"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BluetoothTerminalStatus = exports.BankAccountUpdatedEvent = exports.BankAccountSummary = exports.BankAccountDetailsUpdateRequest = exports.BankAccountDetail = exports.BankAccountDeletedEvent = exports.BankAccountCreatedEvent = exports.BankAccountCreate = exports.BankAccountAssignedEvent = exports.BankAccount = exports.BalanceDetails = exports.AuditLogFieldChangeInformation = exports.AssignedBankAccount = exports.AppUpdatedEvent = exports.AppStoreConfigUpdatedEvent = exports.AppStoreConfigDeletedEvent = exports.AppStoreConfigCreatedEvent = exports.AppStoreAppSupportInfo = exports.AppStoreAppSummary = exports.AppStoreAppSubscriptionSummary = exports.AppStoreAppConfigurationsWithSubscriptions = exports.AppStoreAppConfigurationSummary = exports.AppStoreAppConfigurationHeader = exports.AppStoreAppConfiguration = exports.AppStoreApp = exports.AppSalesforceReferences = exports.AppLookup = exports.AppCreatedEvent = exports.AppConfigUpdateModel = exports.AppConfigSalesChannel = exports.AppCompliance = exports.AppChannelAssignment = exports.App = exports.ApmStatus = exports.ApmStatistics = exports.ApmHourlyDataPoint = exports.ApmDataPoint = exports.ApmCurrencyDataPoint = exports.AnalyticsClientEvent = exports.Allergen = exports.AllMetadataResult = exports.AddressFormResponse = exports.AddressFormDisplayFormat = exports.AddItemDetails = exports.AccountFieldsDefinitions = exports.AccountFieldKeyValuePair = exports.AccountFieldDefinition = exports.AccountDetailBase = exports.AccountDetail = exports.Accept = void 0;
exports.CreateMenuSectionItemFromCatalogItems = exports.CreateLocationArea = exports.CreateLocation = exports.CreateGroupReference = exports.CreateGroup = exports.CreateFullMenuSectionItem = exports.CreateFullMenuSection = exports.CreateFullMenuItemOptionSetItem = exports.CreateFullMenuItemOptionSet = exports.CreateFullMenu = exports.CreateFulfillmentStatesConfiguration = exports.CreateCatalogItem = exports.CreateCatalogGroupReference = exports.CreateBasicAccountModel = exports.CreateAppStoreApp = exports.CreateAccountModel = exports.CountryWithAccountFieldsDefinitions = exports.CountryFormResponse = exports.CoordinatesDm = exports.Coordinates = exports.Contact = exports.ConfiguredStore = exports.ClientDeviceSummary = exports.ClientDeviceEnrollmentResult = exports.ClientDeviceEnroll = exports.ClientDeviceAssignEnrolledDevice = exports.ClientDevice = exports.ChargebackDetails = exports.ChannelStoreMapping = exports.Channel = exports.ChangePasswordModel = exports.CertificateRenewedEvent = exports.CertificateCreatedEvent = exports.CatalogItemUpdatedEvent = exports.CatalogItemCreatedEvent = exports.CatalogItemArchivedEvent = exports.CatalogItem = exports.CatalogImage = exports.CatalogGroupUpdatedEvent = exports.CatalogGroupReference = exports.CatalogGroupCreatedEvent = exports.CatalogGroupArchivedEvent = exports.Cart = exports.CardReaderRegistrationRequest = exports.CardReader = exports.CampaignStatistics = exports.BusinessHoursPeriodBase = exports.BusinessHoursPeriod = exports.BusinessHoursOverrideBase = exports.BusinessHoursOverride = void 0;
exports.Field = exports.FeeSummary = exports.ExternalStoreEvent = exports.ExternalStoreAuditLog = exports.ExecuteConfigurationActionResult = exports.ExecuteConfigurationActionRequest = exports.EventSearchResult = exports.EmvTerminalWithAssignments = exports.EmvTerminal = exports.EmvNotificationEvent = exports.DynamicFormRules = exports.DynamicFormRule = exports.DynamicFormFieldOption = exports.DynamicFormField = exports.DuringOrderPromotionOptionsDm = exports.DriverRequestLoginPinModel = exports.DriverLoginModel = exports.DnsVerifiedEvent = exports.DnsRecordInformation = exports.DeviceSettings = exports.DeliveryZoneUpdatedEvent = exports.DeliveryZoneDeletedEvent = exports.DeliveryZoneCreatedEvent = exports.DeliveryZoneBase = exports.DeliveryZone = exports.DeliveryLocation = exports.DashboardEmbed = exports.CustomerUpdatedEvent = exports.CustomerUpdateModel = exports.CustomerSummary = exports.CustomerDeliveryTrackingOrderLine = exports.CustomerDeliveryTrackingOrder = exports.CustomerCreatedEvent = exports.CustomerConsentUpdatedEvent = exports.Customer = exports.CurrencyData = exports.CspReportRequest = exports.CspReport = exports.CrossSellMenuItems = exports.CreditNoteDetails = exports.CreatedMenuSectionItems = exports.CreateVoucher = exports.CreateTeammate = exports.CreateProductReference = exports.CreateProduct = exports.CreatePayGreenConfigurationRequest = exports.CreateOrderRequest = exports.CreateMetafieldDefinition = exports.CreateMetadata = exports.CreateMenuTaxRate = void 0;
exports.JobDelivery = exports.JobContact = exports.JobCancellation = exports.JobAddress = exports.ItemNutritionInfoAddUpdateModel = exports.InvoicePeriod = exports.InvoiceItem = exports.InvoiceDiscount = exports.Invoice = exports.IntercomUserHash = exports.IndexPageBase = exports.IndexPage = exports.HydraUnAssignedEvent = exports.HydraStoreUnassignedEvent = exports.HydraStoreData = exports.HydraStoreAssignedEvent = exports.HydraStatus = exports.HydraSettingChangedEvent = exports.HydraRequestResetEvent = exports.HydraRegistrationRequest = exports.HydraDeviceDetails = exports.HydraConnectionStatusChangedEvent = exports.HydraConfig = exports.HydraAssignedEvent = exports.HttpRequestAndResponseLog = exports.HomeStatistics = exports.HomeAction = exports.GroupedCoordinates = exports.GroupReference = exports.Group = exports.GoogleViewport = exports.GoogleLocation = exports.GoogleGeometry = exports.GoogleCoordinates = exports.GoogleAddressResult = exports.GoogleAddressComponent = exports.GoogleAddress = exports.GetReceiptByOrderIdQueryResponse = exports.GeoPointRequest = exports.FulfillmentStatusConfigurationItem = exports.FulfillmentStatesConfiguredStore = exports.FulfillmentStatesConfigurationSummary = exports.FulfillmentStatesConfiguration = exports.FulfillmentInfo = exports.FulfillentStatusActionItem = exports.FlipdishFeesDetails = exports.FlipdishEventBase = exports.FirebaseApp = exports.FieldGroup = exports.FieldChangeInformation = void 0;
exports.MenuCreatedEvent = exports.MenuCheckpointCreatedEvent = exports.MenuCheckpoint = exports.MenuCatalogItem = exports.MenuBulkEditEvent = exports.MenuBase = exports.Menu = exports.MaskedPhoneNumber = exports.MappedLocation = exports.LumpDiscountDetails = exports.LoyaltyCampaignUpdatedEvent = exports.LoyaltyCampaignDeletedEvent = exports.LoyaltyCampaignCreatedEvent = exports.LoyaltyCampaignBase = exports.LoyaltyCampaign = exports.LoginWithPinModel = exports.LoginModel = exports.LocationDeletedEvent = exports.LocationCreatedEvent = exports.LocationAreaWithLocations = exports.LocationAreaUpdatedEvent = exports.LocationAreaLocation = exports.LocationAreaCreatedEvent = exports.LocationArea = exports.Location = exports.LocalisedTimeZone = exports.LineItemOption = exports.LineItem = exports.LightspeedSettings = exports.LastPaymentError = exports.Language = exports.KioskTerminalActionStateChangedEvent = exports.KioskSettings = exports.KioskIotConnectionParameters = exports.KioskCashPaymentSettings = exports.KioskBluetoothUnpairingModeEvent = exports.KioskBluetoothTerminalUpdatedEvent = exports.KioskBluetoothTerminalUnpairedEvent = exports.KioskBluetoothTerminalInstallationStatusEvent = exports.KioskBluetoothTerminalInitiateUpdateCheckEvent = exports.KioskBluetoothTerminalFirmwareVersionStatusEvent = exports.KioskBluetoothTerminalCancelUpdateEvent = exports.KioskBluetoothPairingModeEvent = exports.KioskBluetoothInstallUpdateInitiateEvent = exports.JobResponse = exports.JobProof = exports.JobPricing = exports.JobEta = exports.JobDriver = exports.JobDeliveryDetail = void 0;
exports.NutritionInfoLabel = exports.NutritionInfoItemAddUpdateLabelModel = exports.NutritionInfo = exports.NextStatusWithOrderType = exports.ModelBase = exports.MobileAppsSubmissionUpdatedEvent = exports.MobileAppsSubmissionStatusUpdatedEvent = exports.MobileAppsSubmissionStatus = exports.MobileAppsSubmissionDetails = exports.MobileAppsSubmission = exports.MobileAppsStatistics = exports.MobileAppsImage = exports.MetafieldDefinitionRecommendation = exports.MetafieldDefinition = exports.Metafield = exports.Metadata = exports.MenuUploadedEvent = exports.MenuUpdatedEvent = exports.MenuTaxRate = exports.MenuTaxDetails = exports.MenuSummary = exports.MenuStoreNames = exports.MenuSectionUpdatedEvent = exports.MenuSectionItemUpdatedEvent = exports.MenuSectionItemDeletedEvent = exports.MenuSectionItemCreatedEvent = exports.MenuSectionItemBase = exports.MenuSectionItem = exports.MenuSectionDeletedEvent = exports.MenuSectionCreatedEvent = exports.MenuSectionBase = exports.MenuSectionAvailabilityBase = exports.MenuSectionAvailability = exports.MenuSection = exports.MenuObjectDisplayOrders = exports.MenuNutritionInfoHeader = exports.MenuItemOptionSetUpdatedEvent = exports.MenuItemOptionSetItemUpdatedEvent = exports.MenuItemOptionSetItemDeletedEvent = exports.MenuItemOptionSetItemCreatedEvent = exports.MenuItemOptionSetItemBase = exports.MenuItemOptionSetItem = exports.MenuItemOptionSetDeletedEvent = exports.MenuItemOptionSetCreatedEvent = exports.MenuItemOptionSetBase = exports.MenuItemOptionSet = exports.MenuElementListResponse = exports.MenuElementListItemResponse = exports.MenuElementHide = exports.MenuElementEditResponse = void 0;
exports.PaymentTerminalDetails = exports.PaymentIntent = exports.PaymentInfo = exports.PasswordResetModel = exports.OwnerEntityConfigurations = exports.OwnerEntityConfiguration = exports.OtherChargesDetails = exports.OrderVoucherSummary = exports.OrderTipUpdatedEvent = exports.OrderSummary = exports.OrderRejectedEvent = exports.OrderRefundedEvent = exports.OrderReference = exports.OrderRatingUpdatedEvent = exports.OrderPaymentInformation = exports.OrderList = exports.OrderItemOption = exports.OrderItemDm = exports.OrderItem = exports.OrderIngestSubmitOrderResponse = exports.OrderIngestSubmitOrderRequest = exports.OrderFulfillmentStatusWithConfigurationActions = exports.OrderFulfillmentStatusUpdatedEvent = exports.OrderFulfillmentStatusUpdate = exports.OrderFulfillmentStatusBase = exports.OrderFulfillmentStatus = exports.OrderDropOffLocation = exports.OrderDm = exports.OrderDispatchedEvent = exports.OrderDeliveryTrackingStatusUpdatedEvent = exports.OrderDeliveryInformationBase = exports.OrderDeliveryInformation = exports.OrderCustomerTrackingCreatedEvent = exports.OrderCreatedEvent = exports.OrderCapacityConfigUpdatedEvent = exports.OrderBatchingConfiguration = exports.OrderBatchSummary = exports.OrderBatchPublishedEvent = exports.OrderBatch = exports.OrderAcceptedEvent = exports.Order = exports.OnboardingItemUpdate = exports.OnboardingConfigUpdate = exports.OktaPortalFeatureFlag = exports.ObjectDisplayOrder = exports.OauthClientRedirectUri = exports.OAuthTokenModel = exports.OAuthApp = exports.NutritionInfoMenuOptionSetItem = exports.NutritionInfoMenuItem = void 0;
exports.RestApiArrayResultAllMetadataResult = exports.Response = exports.RequestPasswordResetPinResponse = exports.RequestPasswordResetModel = exports.RequestLoginPinResponse = exports.RequestLoginPinModel = exports.Reject = exports.Refund = exports.RedeemInvitationResult = exports.ReaderActionStateInfo = exports.Range = exports.PushNotificationSentEvent = exports.PushNotificationScheduledEvent = exports.PushNotificationResponse = exports.PushNotificationRequest = exports.PushNotificationDeletedEvent = exports.PublishMenuChanges = exports.ProductReference = exports.Product = exports.ProcessingFeeConfig = exports.ProcessPaymentIntentRequest = exports.PrinterUnassignedFromStoreEvent = exports.PrinterTurnedOnEvent = exports.PrinterTurnedOffEvent = exports.PrinterAssignedToStoreEvent = exports.Printer = exports.Price = exports.PreviousOrderItemOption = exports.PreviousOrderItem = exports.PreviousOrder = exports.PredefinedAnswer = exports.PreOrderTime = exports.PreOrderConfig = exports.PosRevenueDetails = exports.PhoneCallStartedEvent = exports.PhoneCallEndedEvent = exports.PhoneCall = exports.PercentDiscountDetails = exports.PendingMenuChangesSummaries = exports.PendingMenuChanges = exports.PayoutSummary = exports.PayoutStore = exports.PayoutRequestIds = exports.PayoutRefund = exports.PayoutOtherCharge = exports.PayoutOrder = exports.PayoutDetail = exports.PayoutChargeback = exports.Payout = exports.PaymentTerminalTransactionDetails = void 0;
exports.RestApiArrayResultStripeCustomConnectedAccount = exports.RestApiArrayResultStoreStatistics = exports.RestApiArrayResultStoreListItem = exports.RestApiArrayResultStoreChannelStoreMapping = exports.RestApiArrayResultStoreChannelAssignment = exports.RestApiArrayResultRetentionCampaign = exports.RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary = exports.RestApiArrayResultRestaurantVoucherPayGreenConfiguration = exports.RestApiArrayResultRestaurantVoucherEligibleStore = exports.RestApiArrayResultRestApiDefaultResponse = exports.RestApiArrayResultProcessingFeeConfig = exports.RestApiArrayResultPreOrderTime = exports.RestApiArrayResultPendingMenuChangesSummaries = exports.RestApiArrayResultPayoutSummary = exports.RestApiArrayResultOrderFulfillmentStatus = exports.RestApiArrayResultOrderBatch = exports.RestApiArrayResultOauthClientRedirectUri = exports.RestApiArrayResultOAuthApp = exports.RestApiArrayResultMobileAppsStatistics = exports.RestApiArrayResultMetadata = exports.RestApiArrayResultMenuTaxDetails = exports.RestApiArrayResultMenuSummary = exports.RestApiArrayResultMenuStoreNames = exports.RestApiArrayResultMenuSectionItem = exports.RestApiArrayResultMenuSection = exports.RestApiArrayResultMenuItemOptionSetItem = exports.RestApiArrayResultMenuItemOptionSet = exports.RestApiArrayResultMenuElementListResponse = exports.RestApiArrayResultMenuElementEditResponse = exports.RestApiArrayResultMenuCheckpoint = exports.RestApiArrayResultLoyaltyCampaign = exports.RestApiArrayResultLocationAreaWithLocations = exports.RestApiArrayResultLocationAreaLocation = exports.RestApiArrayResultLocalisedTimeZone = exports.RestApiArrayResultKioskCashPaymentSettings = exports.RestApiArrayResultHomeAction = exports.RestApiArrayResultFulfillmentStatesConfigurationSummary = exports.RestApiArrayResultEmvTerminalWithAssignments = exports.RestApiArrayResultDeliveryZone = exports.RestApiArrayResultCountryWithAccountFieldsDefinitions = exports.RestApiArrayResultClientDeviceSummary = exports.RestApiArrayResultChannel = exports.RestApiArrayResultBusinessHoursPeriod = exports.RestApiArrayResultBankAccountSummary = exports.RestApiArrayResultAppStoreAppConfigurationSummary = exports.RestApiArrayResultAppStoreAppConfigurationHeader = exports.RestApiArrayResultApmHourlyDataPoint = exports.RestApiArrayResultApmDataPoint = exports.RestApiArrayResultApmCurrencyDataPoint = exports.RestApiArrayResultAllergen = void 0;
exports.RestApiResultAppStoreAppConfiguration = exports.RestApiResultAppStoreApp = exports.RestApiResultAppConfigSalesChannel = exports.RestApiResultAppCompliance = exports.RestApiResultAppChannelAssignment = exports.RestApiResultApp = exports.RestApiResultApmStatus = exports.RestApiResultApmStatistics = exports.RestApiResultAddressFormResponse = exports.RestApiResultAccountFieldsDefinitions = exports.RestApiResultAccountDetail = exports.RestApiPaginationResultWebhookSubscription = exports.RestApiPaginationResultWebhookLog = exports.RestApiPaginationResultVoucherSummary = exports.RestApiPaginationResultStoreValidationConfig = exports.RestApiPaginationResultStoreHeader = exports.RestApiPaginationResultStoreGroupExtended = exports.RestApiPaginationResultStoreGroup = exports.RestApiPaginationResultStore = exports.RestApiPaginationResultPushNotificationResponse = exports.RestApiPaginationResultProduct = exports.RestApiPaginationResultPhoneCall = exports.RestApiPaginationResultPendingMenuChanges = exports.RestApiPaginationResultPayoutRefund = exports.RestApiPaginationResultPayoutOtherCharge = exports.RestApiPaginationResultPayoutOrder = exports.RestApiPaginationResultPayoutChargeback = exports.RestApiPaginationResultPayout = exports.RestApiPaginationResultOrderSummary = exports.RestApiPaginationResultOrder = exports.RestApiPaginationResultOAuthTokenModel = exports.RestApiPaginationResultMetafieldDefinitionRecommendation = exports.RestApiPaginationResultMetafieldDefinition = exports.RestApiPaginationResultHydraDeviceDetails = exports.RestApiPaginationResultHttpRequestAndResponseLog = exports.RestApiPaginationResultGroup = exports.RestApiPaginationResultCatalogItem = exports.RestApiPaginationResultBusinessHoursOverride = exports.RestApiPaginationResultAppStoreAppSummary = exports.RestApiPaginationResultApp = exports.RestApiIntegerResult = exports.RestApiForbiddenResult = exports.RestApiFinanceSearchPaginationResultInvoice = exports.RestApiEventSearchPaginationResult = exports.RestApiErrorResult = exports.RestApiDefaultResponse = exports.RestApiArrayResultVoucherDataPoint = exports.RestApiArrayResultTeammate = exports.RestApiArrayResultSupportedCountry = exports.RestApiArrayResultSubscriptionSummary = void 0;
exports.RestApiResultModelBase = exports.RestApiResultMobileAppsSubmissionStatus = exports.RestApiResultMobileAppsSubmissionDetails = exports.RestApiResultMobileAppsSubmission = exports.RestApiResultMobileAppsImage = exports.RestApiResultMetafieldDefinition = exports.RestApiResultMetadata = exports.RestApiResultMenuSectionItem = exports.RestApiResultMenuSectionAvailability = exports.RestApiResultMenuSection = exports.RestApiResultMenuNutritionInfoHeader = exports.RestApiResultMenuItemOptionSetItem = exports.RestApiResultMenuItemOptionSet = exports.RestApiResultMenu = exports.RestApiResultMappedLocation = exports.RestApiResultLoyaltyCampaign = exports.RestApiResultLocationAreaWithLocations = exports.RestApiResultLocationAreaLocation = exports.RestApiResultLocationArea = exports.RestApiResultLightspeedSettings = exports.RestApiResultKioskSettings = exports.RestApiResultKioskIotConnectionParameters = exports.RestApiResultJobResponse = exports.RestApiResultIntercomUserHash = exports.RestApiResultIndexPageBase = exports.RestApiResultIndexPage = exports.RestApiResultHydraStatus = exports.RestApiResultHydraDeviceDetails = exports.RestApiResultHydraConfig = exports.RestApiResultHomeStatistics = exports.RestApiResultGroup = exports.RestApiResultFulfillmentStatesConfiguration = exports.RestApiResultDnsRecordInformation = exports.RestApiResultDeliveryZone = exports.RestApiResultCustomer = exports.RestApiResultCrossSellMenuItems = exports.RestApiResultCreatedMenuSectionItems = exports.RestApiResultCountryFormResponse = exports.RestApiResultCoordinates = exports.RestApiResultClientDeviceEnrollmentResult = exports.RestApiResultClientDevice = exports.RestApiResultChannel = exports.RestApiResultCatalogItem = exports.RestApiResultCardReader = exports.RestApiResultBusinessHoursPeriod = exports.RestApiResultBusinessHoursOverride = exports.RestApiResultBluetoothTerminalStatus = exports.RestApiResultBankAccountDetail = exports.RestApiResultAssignedBankAccount = exports.RestApiResultAppStoreAppConfigurationsWithSubscriptions = void 0;
exports.RestaurantVoucherEligibleStore = exports.RestaurantVoucherAssignedStore = exports.RestApiUnauthorizedResult = exports.RestApiStringResult = exports.RestApiStringArrayResult = exports.RestApiResultWebsiteTestimonial = exports.RestApiResultWebsiteImage = exports.RestApiResultVoucherWithStats = exports.RestApiResultUpdateMobileAppsSubmissionStatus = exports.RestApiResultTipConfiguration = exports.RestApiResultTelemetrySeriesResult = exports.RestApiResultTeammate = exports.RestApiResultSubscription = exports.RestApiResultSubmitOrderResponseDm = exports.RestApiResultStuartSettings = exports.RestApiResultStripeTerminalLocation = exports.RestApiResultStripeTerminalConnectionToken = exports.RestApiResultStripeConnectedAccount = exports.RestApiResultStoreOrderCapacityConfig = exports.RestApiResultStoreGroupBase = exports.RestApiResultStoreGroup = exports.RestApiResultStoreEndOfDayReport = exports.RestApiResultStoreChannelAssignment = exports.RestApiResultStoreAddress = exports.RestApiResultStore = exports.RestApiResultServiceCharge = exports.RestApiResultRetentionCampaign = exports.RestApiResultRestaurantVoucherPayGreenStoreConfiguration = exports.RestApiResultRestaurantVoucherPayGreenConfiguration = exports.RestApiResultRestApiIntegerResult = exports.RestApiResultRedeemInvitationResult = exports.RestApiResultPushNotificationResponse = exports.RestApiResultProduct = exports.RestApiResultProcessingFeeConfig = exports.RestApiResultPreOrderConfig = exports.RestApiResultPaymentTerminalTransactionDetails = exports.RestApiResultPaymentTerminalDetails = exports.RestApiResultPaymentIntent = exports.RestApiResultOrderPaymentInformation = exports.RestApiResultOrderIngestSubmitOrderResponse = exports.RestApiResultOrderFulfillmentStatusWithConfigurationActions = exports.RestApiResultOrderFulfillmentStatus = exports.RestApiResultOrderDeliveryInformation = exports.RestApiResultOrderBatchingConfiguration = exports.RestApiResultOrderBatch = exports.RestApiResultOrder = exports.RestApiResultOktaPortalFeatureFlag = exports.RestApiResultOauthClientRedirectUri = exports.RestApiResultOAuthApp = exports.RestApiResultNutritionInfo = void 0;
exports.StoreKioskSettingUpdatedEvent = exports.StoreKioskSetting = exports.StoreItemHeader = exports.StoreHeader = exports.StoreGroupUpdatedEvent = exports.StoreGroupExtended = exports.StoreGroupDeletedEvent = exports.StoreGroupCreatedEvent = exports.StoreGroupBase = exports.StoreGroup = exports.StoreFeeConfigUpdatedEvent = exports.StoreFeeConfig = exports.StoreEndOfDayReport = exports.StoreDeletedEvent = exports.StoreDataPoint = exports.StoreCreatedEvent = exports.StoreCreateBase = exports.StoreConfig = exports.StoreCloneSettings = exports.StoreChannelStoreMapping = exports.StoreChannelAssignment = exports.StoreCampaignStartTime = exports.StoreBusinessHoursOverrideDeletedEvent = exports.StoreBusinessHoursOverrideCreatedEvent = exports.StoreBase = exports.StoreArchivedEvent = exports.StoreAddressUpdatedEvent = exports.StoreAddressForm = exports.StoreAddressBase = exports.StoreAddress = exports.Store = exports.StatisticsCurrencyDataPoint = exports.SmsReceivedEvent = exports.SmsInfo = exports.SignupStep = exports.Setting = exports.SetPasswordWithPinModel = exports.SetOrderBatchingConfiguration = exports.ServiceCharge = exports.SearchCriteria = exports.RevenueDetail = exports.RevenueAdjustmentsDetails = exports.RetentionCampaignUpdatedEvent = exports.RetentionCampaignDeletedEvent = exports.RetentionCampaignCreatedEvent = exports.RetentionCampaignBase = exports.RetentionCampaign = exports.RestaurantVoucherPayGreenStoreConfiguration = exports.RestaurantVoucherPayGreenConfigurationSummary = exports.RestaurantVoucherPayGreenConfiguration = void 0;
exports.UpdateAppStoreAppConfigurationValuesBatch = exports.UpdateAppStoreAppConfiguration = exports.UpdateAppStoreApp = exports.UpcomingInvoice = exports.UnRegisterCardReaderRequest = exports.TipConfiguration = exports.TelemetrySeriesResult = exports.TelemetrySeriesQueryParameters = exports.TelemetrySeriesProperty = exports.TeammateUpdatedEvent = exports.TeammateInviteSentEvent = exports.TeammateInviteAcceptedEvent = exports.TeammateDeletedEvent = exports.TeammateBase = exports.Teammate = exports.TaxRate = exports.SupportedCountry = exports.SubscriptionSummary = exports.SubscriptionStore = exports.SubscriptionProduct = exports.Subscription = exports.SubmitOrderResponseDm = exports.SubmitOrderRequest = exports.StuartSettings = exports.StripeTerminalLocation = exports.StripeTerminalConnectionToken = exports.StripeCustomConnectedAccount = exports.StripeConnectedAccountInfo = exports.StripeConnectedAccount = exports.StripeAccountLinkRequest = exports.StoreValidationConfig = exports.StoreUpdatedEvent = exports.StoreUnpublishedEvent = exports.StoreUnarchivedEvent = exports.StoreTipUpdatedEvent = exports.StoreSummary = exports.StoreStatistics = exports.StoreServiceChargeUpdatedEvent = exports.StorePublishedEvent = exports.StorePreOrderConfigUpdatedEvent = exports.StoreOrderCapacityPeriod = exports.StoreOrderCapacityConfigEditModel = exports.StoreOrderCapacityConfig = exports.StoreOpeningHoursUpdatedEvent = exports.StoreNote = exports.StoreMenuAssignedEvent = exports.StoreLogoUpdatedEvent = exports.StoreLogoDeletedEvent = exports.StoreLogoCreatedEvent = exports.StoreListItem = void 0;
exports.VoidAuth = exports.OAuth = exports.ApiKeyAuth = exports.HttpBasicAuth = exports.WebsiteVanityUrlUpdatedEvent = exports.WebsiteUpdatedEvent = exports.WebsiteTestimonialBase = exports.WebsiteTestimonial = exports.WebsiteImage = exports.WebhookSubscriptionUpdatedEvent = exports.WebhookSubscriptionEventInfo = exports.WebhookSubscriptionDeletedEvent = exports.WebhookSubscriptionCreatedEvent = exports.WebhookSubscription = exports.WebhookLog = exports.WebhookEventSample = exports.VoucherWithStats = exports.VoucherUpdatedEvent = exports.VoucherSummary = exports.VoucherDeletedEvent = exports.VoucherDataPoint = exports.VoucherCreatedEvent = exports.VoucherBase = exports.Voucher = exports.ValidationErrorResult = exports.ValidValue = exports.UserUpdatedEvent = exports.UserPasswordCreatedEvent = exports.UserLoginEvent = exports.UserEventInfo = exports.UserDeletedEvent = exports.UserCreatedEvent = exports.UserAnsweredSignupQuestionsEvent = exports.UpdateTipConfiguration = exports.UpdateStorePayGreenConfigurationRequest = exports.UpdateProductReference = exports.UpdateProduct = exports.UpdatePayGreenConfigurationRequest = exports.UpdateMobileAppsSubmissionStatus = exports.UpdateMetafieldDefinition = exports.UpdateLocationArea = exports.UpdateGroupReference = exports.UpdateGroup = exports.UpdateFulfillmentStatesConfiguration = exports.UpdateDriverProfileModel = exports.UpdateDriverNotificationToken = exports.UpdateCatalogItem = exports.UpdateCatalogGroupReference = exports.UpdateAppStoreAppExternalProduct = exports.UpdateAppStoreAppConfigurationWebhookDTO = void 0;
exports.DeviceApi = exports.DeviceApiApiKeys = exports.DeliveryZoneApi = exports.DeliveryZoneApiApiKeys = exports.CustomersApi = exports.CustomersApiApiKeys = exports.CrossSellApi = exports.CrossSellApiApiKeys = exports.ContentSecurityPolicyApi = exports.ContentSecurityPolicyApiApiKeys = exports.ClientsApi = exports.ClientsApiApiKeys = exports.ChannelsStoreMappingApi = exports.ChannelsStoreMappingApiApiKeys = exports.ChannelsApi = exports.ChannelsApiApiKeys = exports.CatalogProductsApi = exports.CatalogProductsApiApiKeys = exports.CatalogItemsApi = exports.CatalogItemsApiApiKeys = exports.CatalogImagesApi = exports.CatalogImagesApiApiKeys = exports.CatalogGroupsApi = exports.CatalogGroupsApiApiKeys = exports.CatalogChangesApi = exports.CatalogChangesApiApiKeys = exports.CardReadersApi = exports.CardReadersApiApiKeys = exports.CampaignsApi = exports.CampaignsApiApiKeys = exports.BankAccountApi = exports.BankAccountApiApiKeys = exports.AuthorizationTokensApi = exports.AuthorizationTokensApiApiKeys = exports.AuditLogsApi = exports.AuditLogsApiApiKeys = exports.AppsApi = exports.AppsApiApiKeys = exports.AppStoreDeveloperApi = exports.AppStoreDeveloperApiApiKeys = exports.AppStoreConfigurationsApi = exports.AppStoreConfigurationsApiApiKeys = exports.AppStoreApi = exports.AppStoreApiApiKeys = exports.ApmApi = exports.ApmApiApiKeys = exports.AddressApi = exports.AddressApiApiKeys = exports.AccountsApi = exports.AccountsApiApiKeys = void 0;
exports.MenusNutritionInfoApi = exports.MenusNutritionInfoApiApiKeys = exports.MenusApi = exports.MenusApiApiKeys = exports.MenuSectionsApi = exports.MenuSectionsApiApiKeys = exports.MenuSectionItemsApi = exports.MenuSectionItemsApiApiKeys = exports.MenuOptionSetsApi = exports.MenuOptionSetsApiApiKeys = exports.MenuOptionSetItemsApi = exports.MenuOptionSetItemsApiApiKeys = exports.LookerSingleSignOnApi = exports.LookerSingleSignOnApiApiKeys = exports.LookerDashboardApi = exports.LookerDashboardApiApiKeys = exports.LocationAreasApi = exports.LocationAreasApiApiKeys = exports.LocationApi = exports.LocationApiApiKeys = exports.LightspeedApi = exports.LightspeedApiApiKeys = exports.KioskIotApi = exports.KioskIotApiApiKeys = exports.InvoicesApi = exports.InvoicesApiApiKeys = exports.IntercomApi = exports.IntercomApiApiKeys = exports.HydraApi = exports.HydraApiApiKeys = exports.HttpRequestResponseLogsApi = exports.HttpRequestResponseLogsApiApiKeys = exports.HomeApi = exports.HomeApiApiKeys = exports.HeartbeatApi = exports.HeartbeatApiApiKeys = exports.GoogleFoodOrderPrototypeApi = exports.GoogleFoodOrderPrototypeApiApiKeys = exports.FulfillmentStateConfigurationApi = exports.FulfillmentStateConfigurationApiApiKeys = exports.FirebaseAppsApi = exports.FirebaseAppsApiApiKeys = exports.FilesApi = exports.FilesApiApiKeys = exports.FeaturesApi = exports.FeaturesApiApiKeys = exports.EventsApi = exports.EventsApiApiKeys = exports.DriversApi = exports.DriversApiApiKeys = void 0;
exports.TerminalIotApi = exports.TerminalIotApiApiKeys = exports.TeammatesApi = exports.TeammatesApiApiKeys = exports.SubscriptionsApi = exports.SubscriptionsApiApiKeys = exports.StuartApi = exports.StuartApiApiKeys = exports.StripeCustomConnectAdminApi = exports.StripeCustomConnectAdminApiApiKeys = exports.StripeCustomConnectApi = exports.StripeCustomConnectApiApiKeys = exports.StoresApi = exports.StoresApiApiKeys = exports.StoreOrderCapacityApi = exports.StoreOrderCapacityApiApiKeys = exports.StoreGroupsApi = exports.StoreGroupsApiApiKeys = exports.RestaurantVouchersPayGreenApi = exports.RestaurantVouchersPayGreenApiApiKeys = exports.ReceiptsApi = exports.ReceiptsApiApiKeys = exports.PushNotificationsApi = exports.PushNotificationsApiApiKeys = exports.ProcessingFeeConfigsApi = exports.ProcessingFeeConfigsApiApiKeys = exports.PayoutsExportApi = exports.PayoutsExportApiApiKeys = exports.PayoutsApi = exports.PayoutsApiApiKeys = exports.PaymentsApi = exports.PaymentsApiApiKeys = exports.PaymentIntentsApi = exports.PaymentIntentsApiApiKeys = exports.OrdersApi = exports.OrdersApiApiKeys = exports.OrderIngestApi = exports.OrderIngestApiApiKeys = exports.OrderBatchingConfigurationApi = exports.OrderBatchingConfigurationApiApiKeys = exports.OrderBatchesApi = exports.OrderBatchesApiApiKeys = exports.OnboardingApi = exports.OnboardingApiApiKeys = exports.OAuthClientsApi = exports.OAuthClientsApiApiKeys = exports.MobileAppsApi = exports.MobileAppsApiApiKeys = exports.MetafieldDefinitionsApi = exports.MetafieldDefinitionsApiApiKeys = void 0;
exports.WebsiteApi = exports.WebsiteApiApiKeys = exports.WebhooksApi = exports.WebhooksApiApiKeys = exports.VouchersApi = exports.VouchersApiApiKeys = exports.UsersApi = exports.UsersApiApiKeys = exports.TipsApi = exports.TipsApiApiKeys = void 0;
var localVarRequest = require("request");
var defaultBasePath = 'https://api-principal-b.portal.flipdishdev.com/';
var primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
var ObjectSerializer = (function () {
    function ObjectSerializer() {
    }
    ObjectSerializer.findCorrectType = function (data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap[expectedType]) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            var discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    };
    ObjectSerializer.serialize = function (data, type) {
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            var subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            var transformedData = [];
            for (var index in data) {
                var date = data[index];
                transformedData.push(ObjectSerializer.serialize(date, subType));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return data.toString();
        }
        else {
            if (enumsMap[type]) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            var attributeTypes = typeMap[type].getAttributeTypeMap();
            var instance = {};
            for (var index in attributeTypes) {
                var attributeType = attributeTypes[index];
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type);
            }
            return instance;
        }
    };
    ObjectSerializer.deserialize = function (data, type) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            var subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            var transformedData = [];
            for (var index in data) {
                var date = data[index];
                transformedData.push(ObjectSerializer.deserialize(date, subType));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap[type]) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            var instance = new typeMap[type]();
            var attributeTypes = typeMap[type].getAttributeTypeMap();
            for (var index in attributeTypes) {
                var attributeType = attributeTypes[index];
                instance[attributeType.name] = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type);
            }
            return instance;
        }
    };
    return ObjectSerializer;
}());
var Accept = (function () {
    function Accept() {
    }
    Accept.getAttributeTypeMap = function () {
        return Accept.attributeTypeMap;
    };
    Accept.discriminator = undefined;
    Accept.attributeTypeMap = [
        {
            "name": "EstimatedMinutesForDelivery",
            "baseName": "EstimatedMinutesForDelivery",
            "type": "number"
        }
    ];
    return Accept;
}());
exports.Accept = Accept;
var AccountDetail = (function () {
    function AccountDetail() {
    }
    AccountDetail.getAttributeTypeMap = function () {
        return AccountDetail.attributeTypeMap;
    };
    AccountDetail.discriminator = undefined;
    AccountDetail.attributeTypeMap = [
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "SignupSteps",
            "baseName": "SignupSteps",
            "type": "Array<SignupStep>"
        },
        {
            "name": "IsVerified",
            "baseName": "IsVerified",
            "type": "boolean"
        },
        {
            "name": "IsSelfServeUser",
            "baseName": "IsSelfServeUser",
            "type": "boolean"
        },
        {
            "name": "AccountId",
            "baseName": "AccountId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Language",
            "baseName": "Language",
            "type": "string"
        },
        {
            "name": "TimeZoneInfoId",
            "baseName": "TimeZoneInfoId",
            "type": "string"
        },
        {
            "name": "DisplayTimesInUserLocalTimeZone",
            "baseName": "DisplayTimesInUserLocalTimeZone",
            "type": "boolean"
        },
        {
            "name": "ShowHiddenFeatures",
            "baseName": "ShowHiddenFeatures",
            "type": "boolean"
        }
    ];
    return AccountDetail;
}());
exports.AccountDetail = AccountDetail;
var AccountDetailBase = (function () {
    function AccountDetailBase() {
    }
    AccountDetailBase.getAttributeTypeMap = function () {
        return AccountDetailBase.attributeTypeMap;
    };
    AccountDetailBase.discriminator = undefined;
    AccountDetailBase.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Language",
            "baseName": "Language",
            "type": "string"
        },
        {
            "name": "TimeZoneInfoId",
            "baseName": "TimeZoneInfoId",
            "type": "string"
        },
        {
            "name": "DisplayTimesInUserLocalTimeZone",
            "baseName": "DisplayTimesInUserLocalTimeZone",
            "type": "boolean"
        },
        {
            "name": "ShowHiddenFeatures",
            "baseName": "ShowHiddenFeatures",
            "type": "boolean"
        }
    ];
    return AccountDetailBase;
}());
exports.AccountDetailBase = AccountDetailBase;
var AccountFieldDefinition = (function () {
    function AccountFieldDefinition() {
    }
    AccountFieldDefinition.getAttributeTypeMap = function () {
        return AccountFieldDefinition.attributeTypeMap;
    };
    AccountFieldDefinition.discriminator = undefined;
    AccountFieldDefinition.attributeTypeMap = [
        {
            "name": "Key",
            "baseName": "Key",
            "type": "AccountFieldDefinition.KeyEnum"
        },
        {
            "name": "DisplayName",
            "baseName": "DisplayName",
            "type": "string"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "AccountFieldDefinition.TypeEnum"
        },
        {
            "name": "MinLength",
            "baseName": "MinLength",
            "type": "number"
        },
        {
            "name": "MaxLength",
            "baseName": "MaxLength",
            "type": "number"
        },
        {
            "name": "DigitsOnly",
            "baseName": "DigitsOnly",
            "type": "boolean"
        },
        {
            "name": "Regex",
            "baseName": "Regex",
            "type": "string"
        }
    ];
    return AccountFieldDefinition;
}());
exports.AccountFieldDefinition = AccountFieldDefinition;
(function (AccountFieldDefinition) {
    var KeyEnum;
    (function (KeyEnum) {
        KeyEnum[KeyEnum["Iban"] = 'Iban'] = "Iban";
        KeyEnum[KeyEnum["AccountNumber"] = 'AccountNumber'] = "AccountNumber";
        KeyEnum[KeyEnum["RoutingNumber"] = 'RoutingNumber'] = "RoutingNumber";
        KeyEnum[KeyEnum["BSB"] = 'BSB'] = "BSB";
        KeyEnum[KeyEnum["BranchCode"] = 'BranchCode'] = "BranchCode";
        KeyEnum[KeyEnum["BankCode"] = 'BankCode'] = "BankCode";
        KeyEnum[KeyEnum["InstitutionNumber"] = 'InstitutionNumber'] = "InstitutionNumber";
        KeyEnum[KeyEnum["TransitNumber"] = 'TransitNumber'] = "TransitNumber";
        KeyEnum[KeyEnum["ClearingCode"] = 'ClearingCode'] = "ClearingCode";
        KeyEnum[KeyEnum["IfscCode"] = 'IfscCode'] = "IfscCode";
        KeyEnum[KeyEnum["Clabe"] = 'Clabe'] = "Clabe";
        KeyEnum[KeyEnum["SortCode"] = 'SortCode'] = "SortCode";
        KeyEnum[KeyEnum["Swift"] = 'Swift'] = "Swift";
    })(KeyEnum = AccountFieldDefinition.KeyEnum || (AccountFieldDefinition.KeyEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["None"] = 'None'] = "None";
        TypeEnum[TypeEnum["Iban"] = 'Iban'] = "Iban";
    })(TypeEnum = AccountFieldDefinition.TypeEnum || (AccountFieldDefinition.TypeEnum = {}));
})(AccountFieldDefinition = exports.AccountFieldDefinition || (exports.AccountFieldDefinition = {}));
exports.AccountFieldDefinition = AccountFieldDefinition;
var AccountFieldKeyValuePair = (function () {
    function AccountFieldKeyValuePair() {
    }
    AccountFieldKeyValuePair.getAttributeTypeMap = function () {
        return AccountFieldKeyValuePair.attributeTypeMap;
    };
    AccountFieldKeyValuePair.discriminator = undefined;
    AccountFieldKeyValuePair.attributeTypeMap = [
        {
            "name": "Key",
            "baseName": "Key",
            "type": "AccountFieldKeyValuePair.KeyEnum"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "string"
        }
    ];
    return AccountFieldKeyValuePair;
}());
exports.AccountFieldKeyValuePair = AccountFieldKeyValuePair;
(function (AccountFieldKeyValuePair) {
    var KeyEnum;
    (function (KeyEnum) {
        KeyEnum[KeyEnum["Iban"] = 'Iban'] = "Iban";
        KeyEnum[KeyEnum["AccountNumber"] = 'AccountNumber'] = "AccountNumber";
        KeyEnum[KeyEnum["RoutingNumber"] = 'RoutingNumber'] = "RoutingNumber";
        KeyEnum[KeyEnum["BSB"] = 'BSB'] = "BSB";
        KeyEnum[KeyEnum["BranchCode"] = 'BranchCode'] = "BranchCode";
        KeyEnum[KeyEnum["BankCode"] = 'BankCode'] = "BankCode";
        KeyEnum[KeyEnum["InstitutionNumber"] = 'InstitutionNumber'] = "InstitutionNumber";
        KeyEnum[KeyEnum["TransitNumber"] = 'TransitNumber'] = "TransitNumber";
        KeyEnum[KeyEnum["ClearingCode"] = 'ClearingCode'] = "ClearingCode";
        KeyEnum[KeyEnum["IfscCode"] = 'IfscCode'] = "IfscCode";
        KeyEnum[KeyEnum["Clabe"] = 'Clabe'] = "Clabe";
        KeyEnum[KeyEnum["SortCode"] = 'SortCode'] = "SortCode";
        KeyEnum[KeyEnum["Swift"] = 'Swift'] = "Swift";
    })(KeyEnum = AccountFieldKeyValuePair.KeyEnum || (AccountFieldKeyValuePair.KeyEnum = {}));
})(AccountFieldKeyValuePair = exports.AccountFieldKeyValuePair || (exports.AccountFieldKeyValuePair = {}));
exports.AccountFieldKeyValuePair = AccountFieldKeyValuePair;
var AccountFieldsDefinitions = (function () {
    function AccountFieldsDefinitions() {
    }
    AccountFieldsDefinitions.getAttributeTypeMap = function () {
        return AccountFieldsDefinitions.attributeTypeMap;
    };
    AccountFieldsDefinitions.discriminator = undefined;
    AccountFieldsDefinitions.attributeTypeMap = [
        {
            "name": "DefinitionsPerCountry",
            "baseName": "DefinitionsPerCountry",
            "type": "{ [key: string]: Array<AccountFieldDefinition>; }"
        }
    ];
    return AccountFieldsDefinitions;
}());
exports.AccountFieldsDefinitions = AccountFieldsDefinitions;
var AddItemDetails = (function () {
    function AddItemDetails() {
    }
    AddItemDetails.getAttributeTypeMap = function () {
        return AddItemDetails.attributeTypeMap;
    };
    AddItemDetails.discriminator = undefined;
    AddItemDetails.attributeTypeMap = [
        {
            "name": "PromotionalItemId",
            "baseName": "PromotionalItemId",
            "type": "number"
        },
        {
            "name": "PromotionalItemName",
            "baseName": "PromotionalItemName",
            "type": "string"
        }
    ];
    return AddItemDetails;
}());
exports.AddItemDetails = AddItemDetails;
var AddressFormDisplayFormat = (function () {
    function AddressFormDisplayFormat() {
    }
    AddressFormDisplayFormat.getAttributeTypeMap = function () {
        return AddressFormDisplayFormat.attributeTypeMap;
    };
    AddressFormDisplayFormat.discriminator = undefined;
    AddressFormDisplayFormat.attributeTypeMap = [
        {
            "name": "OneLine",
            "baseName": "OneLine",
            "type": "string"
        },
        {
            "name": "TwoLines",
            "baseName": "TwoLines",
            "type": "Array<string>"
        }
    ];
    return AddressFormDisplayFormat;
}());
exports.AddressFormDisplayFormat = AddressFormDisplayFormat;
var AddressFormResponse = (function () {
    function AddressFormResponse() {
    }
    AddressFormResponse.getAttributeTypeMap = function () {
        return AddressFormResponse.attributeTypeMap;
    };
    AddressFormResponse.discriminator = undefined;
    AddressFormResponse.attributeTypeMap = [
        {
            "name": "FormData",
            "baseName": "FormData",
            "type": "Array<DynamicFormField>"
        },
        {
            "name": "CountryCode",
            "baseName": "CountryCode",
            "type": "string"
        },
        {
            "name": "Language",
            "baseName": "Language",
            "type": "string"
        },
        {
            "name": "DisplayFormat",
            "baseName": "DisplayFormat",
            "type": "AddressFormDisplayFormat"
        }
    ];
    return AddressFormResponse;
}());
exports.AddressFormResponse = AddressFormResponse;
var AllMetadataResult = (function () {
    function AllMetadataResult() {
    }
    AllMetadataResult.getAttributeTypeMap = function () {
        return AllMetadataResult.attributeTypeMap;
    };
    AllMetadataResult.discriminator = undefined;
    AllMetadataResult.attributeTypeMap = [
        {
            "name": "MenuItemMetadata",
            "baseName": "MenuItemMetadata",
            "type": "Array<Metadata>"
        },
        {
            "name": "MenuItemOptionSetItemMetadata",
            "baseName": "MenuItemOptionSetItemMetadata",
            "type": "Array<Metadata>"
        }
    ];
    return AllMetadataResult;
}());
exports.AllMetadataResult = AllMetadataResult;
var Allergen = (function () {
    function Allergen() {
    }
    Allergen.getAttributeTypeMap = function () {
        return Allergen.attributeTypeMap;
    };
    Allergen.discriminator = undefined;
    Allergen.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "IconUrl",
            "baseName": "IconUrl",
            "type": "string"
        }
    ];
    return Allergen;
}());
exports.Allergen = Allergen;
var AnalyticsClientEvent = (function () {
    function AnalyticsClientEvent() {
    }
    AnalyticsClientEvent.getAttributeTypeMap = function () {
        return AnalyticsClientEvent.attributeTypeMap;
    };
    AnalyticsClientEvent.discriminator = undefined;
    AnalyticsClientEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "EventType",
            "baseName": "EventType",
            "type": "string"
        },
        {
            "name": "AppType",
            "baseName": "AppType",
            "type": "string"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "string"
        },
        {
            "name": "UserId",
            "baseName": "UserId",
            "type": "number"
        },
        {
            "name": "Latitude",
            "baseName": "Latitude",
            "type": "number"
        },
        {
            "name": "Longitude",
            "baseName": "Longitude",
            "type": "number"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return AnalyticsClientEvent;
}());
exports.AnalyticsClientEvent = AnalyticsClientEvent;
var ApmCurrencyDataPoint = (function () {
    function ApmCurrencyDataPoint() {
    }
    ApmCurrencyDataPoint.getAttributeTypeMap = function () {
        return ApmCurrencyDataPoint.attributeTypeMap;
    };
    ApmCurrencyDataPoint.discriminator = undefined;
    ApmCurrencyDataPoint.attributeTypeMap = [
        {
            "name": "PeriodStart",
            "baseName": "PeriodStart",
            "type": "Date"
        },
        {
            "name": "PeriodLengthInDays",
            "baseName": "PeriodLengthInDays",
            "type": "number"
        },
        {
            "name": "CurrencyData",
            "baseName": "CurrencyData",
            "type": "Array<CurrencyData>"
        }
    ];
    return ApmCurrencyDataPoint;
}());
exports.ApmCurrencyDataPoint = ApmCurrencyDataPoint;
var ApmDataPoint = (function () {
    function ApmDataPoint() {
    }
    ApmDataPoint.getAttributeTypeMap = function () {
        return ApmDataPoint.attributeTypeMap;
    };
    ApmDataPoint.discriminator = undefined;
    ApmDataPoint.attributeTypeMap = [
        {
            "name": "PeriodStart",
            "baseName": "PeriodStart",
            "type": "Date"
        },
        {
            "name": "PeriodLengthInDays",
            "baseName": "PeriodLengthInDays",
            "type": "number"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "number"
        }
    ];
    return ApmDataPoint;
}());
exports.ApmDataPoint = ApmDataPoint;
var ApmHourlyDataPoint = (function () {
    function ApmHourlyDataPoint() {
    }
    ApmHourlyDataPoint.getAttributeTypeMap = function () {
        return ApmHourlyDataPoint.attributeTypeMap;
    };
    ApmHourlyDataPoint.discriminator = undefined;
    ApmHourlyDataPoint.attributeTypeMap = [
        {
            "name": "Day",
            "baseName": "Day",
            "type": "ApmHourlyDataPoint.DayEnum"
        },
        {
            "name": "Hour",
            "baseName": "Hour",
            "type": "number"
        },
        {
            "name": "TotalValue",
            "baseName": "TotalValue",
            "type": "number"
        }
    ];
    return ApmHourlyDataPoint;
}());
exports.ApmHourlyDataPoint = ApmHourlyDataPoint;
(function (ApmHourlyDataPoint) {
    var DayEnum;
    (function (DayEnum) {
        DayEnum[DayEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayEnum[DayEnum["Monday"] = 'Monday'] = "Monday";
        DayEnum[DayEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayEnum[DayEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayEnum[DayEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayEnum[DayEnum["Friday"] = 'Friday'] = "Friday";
        DayEnum[DayEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayEnum = ApmHourlyDataPoint.DayEnum || (ApmHourlyDataPoint.DayEnum = {}));
})(ApmHourlyDataPoint = exports.ApmHourlyDataPoint || (exports.ApmHourlyDataPoint = {}));
exports.ApmHourlyDataPoint = ApmHourlyDataPoint;
var ApmStatistics = (function () {
    function ApmStatistics() {
    }
    ApmStatistics.getAttributeTypeMap = function () {
        return ApmStatistics.attributeTypeMap;
    };
    ApmStatistics.discriminator = undefined;
    ApmStatistics.attributeTypeMap = [
        {
            "name": "EstimatedMinutesSaved",
            "baseName": "EstimatedMinutesSaved",
            "type": "number"
        },
        {
            "name": "EstimatedMinutesCouldSaved",
            "baseName": "EstimatedMinutesCouldSaved",
            "type": "number"
        },
        {
            "name": "CurrencyData",
            "baseName": "CurrencyData",
            "type": "Array<StatisticsCurrencyDataPoint>"
        }
    ];
    return ApmStatistics;
}());
exports.ApmStatistics = ApmStatistics;
var ApmStatus = (function () {
    function ApmStatus() {
    }
    ApmStatus.getAttributeTypeMap = function () {
        return ApmStatus.attributeTypeMap;
    };
    ApmStatus.discriminator = undefined;
    ApmStatus.attributeTypeMap = [
        {
            "name": "IsApmEnabled",
            "baseName": "IsApmEnabled",
            "type": "boolean"
        }
    ];
    return ApmStatus;
}());
exports.ApmStatus = ApmStatus;
var App = (function () {
    function App() {
    }
    App.getAttributeTypeMap = function () {
        return App.attributeTypeMap;
    };
    App.discriminator = undefined;
    App.attributeTypeMap = [
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "HasIosApp",
            "baseName": "HasIosApp",
            "type": "boolean"
        },
        {
            "name": "HasAndroidApp",
            "baseName": "HasAndroidApp",
            "type": "boolean"
        },
        {
            "name": "CountryId",
            "baseName": "CountryId",
            "type": "string"
        },
        {
            "name": "LogoImageUrl",
            "baseName": "LogoImageUrl",
            "type": "string"
        },
        {
            "name": "Languages",
            "baseName": "Languages",
            "type": "Array<Language>"
        },
        {
            "name": "AvailableAppLanguages",
            "baseName": "AvailableAppLanguages",
            "type": "Array<Language>"
        },
        {
            "name": "AppAccessLevel",
            "baseName": "AppAccessLevel",
            "type": "App.AppAccessLevelEnum"
        },
        {
            "name": "AppResourceSet",
            "baseName": "AppResourceSet",
            "type": "Array<App.AppResourceSetEnum>"
        },
        {
            "name": "Features",
            "baseName": "Features",
            "type": "Array<string>"
        },
        {
            "name": "MapCenter",
            "baseName": "MapCenter",
            "type": "Coordinates"
        },
        {
            "name": "MapNorthEast",
            "baseName": "MapNorthEast",
            "type": "Coordinates"
        },
        {
            "name": "MapSouthWest",
            "baseName": "MapSouthWest",
            "type": "Coordinates"
        },
        {
            "name": "GoogleMapsApiKeyWeb",
            "baseName": "GoogleMapsApiKeyWeb",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "HostName",
            "baseName": "HostName",
            "type": "string"
        },
        {
            "name": "MainColor",
            "baseName": "MainColor",
            "type": "string"
        },
        {
            "name": "KioskPrimaryColour",
            "baseName": "KioskPrimaryColour",
            "type": "string"
        },
        {
            "name": "ApplicationCategory",
            "baseName": "ApplicationCategory",
            "type": "App.ApplicationCategoryEnum"
        },
        {
            "name": "IsPanaceaEnabled",
            "baseName": "IsPanaceaEnabled",
            "type": "boolean"
        },
        {
            "name": "PanaceaVanityUrl",
            "baseName": "PanaceaVanityUrl",
            "type": "string"
        },
        {
            "name": "CookieConsentPromptEnabled",
            "baseName": "CookieConsentPromptEnabled",
            "type": "boolean"
        }
    ];
    return App;
}());
exports.App = App;
(function (App) {
    var AppAccessLevelEnum;
    (function (AppAccessLevelEnum) {
        AppAccessLevelEnum[AppAccessLevelEnum["None"] = 'None'] = "None";
        AppAccessLevelEnum[AppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        AppAccessLevelEnum[AppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
        AppAccessLevelEnum[AppAccessLevelEnum["Support"] = 'Support'] = "Support";
    })(AppAccessLevelEnum = App.AppAccessLevelEnum || (App.AppAccessLevelEnum = {}));
    var AppResourceSetEnum;
    (function (AppResourceSetEnum) {
        AppResourceSetEnum[AppResourceSetEnum["ViewApp"] = 'ViewApp'] = "ViewApp";
        AppResourceSetEnum[AppResourceSetEnum["CreateApp"] = 'CreateApp'] = "CreateApp";
        AppResourceSetEnum[AppResourceSetEnum["UpdateApp"] = 'UpdateApp'] = "UpdateApp";
        AppResourceSetEnum[AppResourceSetEnum["EditAppAssets"] = 'EditAppAssets'] = "EditAppAssets";
        AppResourceSetEnum[AppResourceSetEnum["EditAppFeatures"] = 'EditAppFeatures'] = "EditAppFeatures";
        AppResourceSetEnum[AppResourceSetEnum["ViewTeammates"] = 'ViewTeammates'] = "ViewTeammates";
        AppResourceSetEnum[AppResourceSetEnum["EditTeammates"] = 'EditTeammates'] = "EditTeammates";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateOwner"] = 'CreateTeammateOwner'] = "CreateTeammateOwner";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateManagedOwner"] = 'CreateTeammateManagedOwner'] = "CreateTeammateManagedOwner";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStoreOwner"] = 'CreateTeammateStoreOwner'] = "CreateTeammateStoreOwner";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStoreManager"] = 'CreateTeammateStoreManager'] = "CreateTeammateStoreManager";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStoreStaff"] = 'CreateTeammateStoreStaff'] = "CreateTeammateStoreStaff";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStoreReadAccess"] = 'CreateTeammateStoreReadAccess'] = "CreateTeammateStoreReadAccess";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateFinanceManager"] = 'CreateTeammateFinanceManager'] = "CreateTeammateFinanceManager";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateIntegrator"] = 'CreateTeammateIntegrator'] = "CreateTeammateIntegrator";
        AppResourceSetEnum[AppResourceSetEnum["ViewApmConfigurations"] = 'ViewApmConfigurations'] = "ViewApmConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["EditApmConfigurations"] = 'EditApmConfigurations'] = "EditApmConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["ViewCampaignsConfigurations"] = 'ViewCampaignsConfigurations'] = "ViewCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["CreateCampaignsConfigurations"] = 'CreateCampaignsConfigurations'] = "CreateCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["UpdateCampaignsConfigurations"] = 'UpdateCampaignsConfigurations'] = "UpdateCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["DeleteCampaignsConfigurations"] = 'DeleteCampaignsConfigurations'] = "DeleteCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["ViewDevelopersSettings"] = 'ViewDevelopersSettings'] = "ViewDevelopersSettings";
        AppResourceSetEnum[AppResourceSetEnum["EditDevelopersSettings"] = 'EditDevelopersSettings'] = "EditDevelopersSettings";
        AppResourceSetEnum[AppResourceSetEnum["ViewOrders"] = 'ViewOrders'] = "ViewOrders";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersAccept"] = 'UpdateOrdersAccept'] = "UpdateOrdersAccept";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersReject"] = 'UpdateOrdersReject'] = "UpdateOrdersReject";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersRefund"] = 'UpdateOrdersRefund'] = "UpdateOrdersRefund";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersDispatch"] = 'UpdateOrdersDispatch'] = "UpdateOrdersDispatch";
        AppResourceSetEnum[AppResourceSetEnum["ViewStores"] = 'ViewStores'] = "ViewStores";
        AppResourceSetEnum[AppResourceSetEnum["CreateStores"] = 'CreateStores'] = "CreateStores";
        AppResourceSetEnum[AppResourceSetEnum["EditStores"] = 'EditStores'] = "EditStores";
        AppResourceSetEnum[AppResourceSetEnum["ViewStoresOpeningHours"] = 'ViewStoresOpeningHours'] = "ViewStoresOpeningHours";
        AppResourceSetEnum[AppResourceSetEnum["UpdateStoresOpenForCollectionOrDelivery"] = 'UpdateStoresOpenForCollectionOrDelivery'] = "UpdateStoresOpenForCollectionOrDelivery";
        AppResourceSetEnum[AppResourceSetEnum["UpdateStoresOpeningHours"] = 'UpdateStoresOpeningHours'] = "UpdateStoresOpeningHours";
        AppResourceSetEnum[AppResourceSetEnum["ViewStoresOpeningHoursOverride"] = 'ViewStoresOpeningHoursOverride'] = "ViewStoresOpeningHoursOverride";
        AppResourceSetEnum[AppResourceSetEnum["EditStoresOpeningHoursOverride"] = 'EditStoresOpeningHoursOverride'] = "EditStoresOpeningHoursOverride";
        AppResourceSetEnum[AppResourceSetEnum["EditStoresOpeningHoursOverrideTemporary"] = 'EditStoresOpeningHoursOverrideTemporary'] = "EditStoresOpeningHoursOverrideTemporary";
        AppResourceSetEnum[AppResourceSetEnum["UpdateStoresName"] = 'UpdateStoresName'] = "UpdateStoresName";
        AppResourceSetEnum[AppResourceSetEnum["EditStoreKioskSettings"] = 'EditStoreKioskSettings'] = "EditStoreKioskSettings";
        AppResourceSetEnum[AppResourceSetEnum["EditStoreOrderCapacity"] = 'EditStoreOrderCapacity'] = "EditStoreOrderCapacity";
        AppResourceSetEnum[AppResourceSetEnum["UpdatePrinterTerminalsAssign"] = 'UpdatePrinterTerminalsAssign'] = "UpdatePrinterTerminalsAssign";
        AppResourceSetEnum[AppResourceSetEnum["UpdatePrinterTerminalsToggle"] = 'UpdatePrinterTerminalsToggle'] = "UpdatePrinterTerminalsToggle";
        AppResourceSetEnum[AppResourceSetEnum["EditStoreNotifications"] = 'EditStoreNotifications'] = "EditStoreNotifications";
        AppResourceSetEnum[AppResourceSetEnum["ViewStoreGroups"] = 'ViewStoreGroups'] = "ViewStoreGroups";
        AppResourceSetEnum[AppResourceSetEnum["CreateStoreGroups"] = 'CreateStoreGroups'] = "CreateStoreGroups";
        AppResourceSetEnum[AppResourceSetEnum["UpdateStoreGroups"] = 'UpdateStoreGroups'] = "UpdateStoreGroups";
        AppResourceSetEnum[AppResourceSetEnum["DeleteStoreGroups"] = 'DeleteStoreGroups'] = "DeleteStoreGroups";
        AppResourceSetEnum[AppResourceSetEnum["ViewDeliveryZones"] = 'ViewDeliveryZones'] = "ViewDeliveryZones";
        AppResourceSetEnum[AppResourceSetEnum["CreateDeliveryZones"] = 'CreateDeliveryZones'] = "CreateDeliveryZones";
        AppResourceSetEnum[AppResourceSetEnum["UpdateDeliveryZones"] = 'UpdateDeliveryZones'] = "UpdateDeliveryZones";
        AppResourceSetEnum[AppResourceSetEnum["DeleteDeliveryZones"] = 'DeleteDeliveryZones'] = "DeleteDeliveryZones";
        AppResourceSetEnum[AppResourceSetEnum["ViewMenu"] = 'ViewMenu'] = "ViewMenu";
        AppResourceSetEnum[AppResourceSetEnum["CreateMenu"] = 'CreateMenu'] = "CreateMenu";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMenu"] = 'UpdateMenu'] = "UpdateMenu";
        AppResourceSetEnum[AppResourceSetEnum["DeleteMenu"] = 'DeleteMenu'] = "DeleteMenu";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMenuLock"] = 'UpdateMenuLock'] = "UpdateMenuLock";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMenuItemsHideTemporarily"] = 'UpdateMenuItemsHideTemporarily'] = "UpdateMenuItemsHideTemporarily";
        AppResourceSetEnum[AppResourceSetEnum["EditMenuImage"] = 'EditMenuImage'] = "EditMenuImage";
        AppResourceSetEnum[AppResourceSetEnum["ViewVouchers"] = 'ViewVouchers'] = "ViewVouchers";
        AppResourceSetEnum[AppResourceSetEnum["EditVouchers"] = 'EditVouchers'] = "EditVouchers";
        AppResourceSetEnum[AppResourceSetEnum["ViewWebsiteContent"] = 'ViewWebsiteContent'] = "ViewWebsiteContent";
        AppResourceSetEnum[AppResourceSetEnum["EditWebsiteContent"] = 'EditWebsiteContent'] = "EditWebsiteContent";
        AppResourceSetEnum[AppResourceSetEnum["ViewWebsiteDnsVerified"] = 'ViewWebsiteDnsVerified'] = "ViewWebsiteDnsVerified";
        AppResourceSetEnum[AppResourceSetEnum["ViewWebsiteCertificateCreated"] = 'ViewWebsiteCertificateCreated'] = "ViewWebsiteCertificateCreated";
        AppResourceSetEnum[AppResourceSetEnum["ViewWebsiteCertificateRenewed"] = 'ViewWebsiteCertificateRenewed'] = "ViewWebsiteCertificateRenewed";
        AppResourceSetEnum[AppResourceSetEnum["ViewBankAccounts"] = 'ViewBankAccounts'] = "ViewBankAccounts";
        AppResourceSetEnum[AppResourceSetEnum["CreateBankAccounts"] = 'CreateBankAccounts'] = "CreateBankAccounts";
        AppResourceSetEnum[AppResourceSetEnum["UpdateBankAccounts"] = 'UpdateBankAccounts'] = "UpdateBankAccounts";
        AppResourceSetEnum[AppResourceSetEnum["UpdateBankAccountsAssign"] = 'UpdateBankAccountsAssign'] = "UpdateBankAccountsAssign";
        AppResourceSetEnum[AppResourceSetEnum["ViewAssignedBankAccount"] = 'ViewAssignedBankAccount'] = "ViewAssignedBankAccount";
        AppResourceSetEnum[AppResourceSetEnum["VerifyBankAccounts"] = 'VerifyBankAccounts'] = "VerifyBankAccounts";
        AppResourceSetEnum[AppResourceSetEnum["ViewServiceChargeConfigurations"] = 'ViewServiceChargeConfigurations'] = "ViewServiceChargeConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["EditServiceChargeConfigurations"] = 'EditServiceChargeConfigurations'] = "EditServiceChargeConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["ViewHydraConfig"] = 'ViewHydraConfig'] = "ViewHydraConfig";
        AppResourceSetEnum[AppResourceSetEnum["UpdateHydraConfigManage"] = 'UpdateHydraConfigManage'] = "UpdateHydraConfigManage";
        AppResourceSetEnum[AppResourceSetEnum["InitiateBluetoothPairingMode"] = 'InitiateBluetoothPairingMode'] = "InitiateBluetoothPairingMode";
        AppResourceSetEnum[AppResourceSetEnum["DeleteTerminal"] = 'DeleteTerminal'] = "DeleteTerminal";
        AppResourceSetEnum[AppResourceSetEnum["ViewKioskTelemetry"] = 'ViewKioskTelemetry'] = "ViewKioskTelemetry";
        AppResourceSetEnum[AppResourceSetEnum["ViewCustomers"] = 'ViewCustomers'] = "ViewCustomers";
        AppResourceSetEnum[AppResourceSetEnum["EditCustomers"] = 'EditCustomers'] = "EditCustomers";
        AppResourceSetEnum[AppResourceSetEnum["CreateCatalogElements"] = 'CreateCatalogElements'] = "CreateCatalogElements";
        AppResourceSetEnum[AppResourceSetEnum["UpdateCatalogElements"] = 'UpdateCatalogElements'] = "UpdateCatalogElements";
        AppResourceSetEnum[AppResourceSetEnum["ViewCatalogElements"] = 'ViewCatalogElements'] = "ViewCatalogElements";
        AppResourceSetEnum[AppResourceSetEnum["DeleteCatalogElements"] = 'DeleteCatalogElements'] = "DeleteCatalogElements";
        AppResourceSetEnum[AppResourceSetEnum["ViewMetafieldDefinitions"] = 'ViewMetafieldDefinitions'] = "ViewMetafieldDefinitions";
        AppResourceSetEnum[AppResourceSetEnum["CreateMetafieldDefinitions"] = 'CreateMetafieldDefinitions'] = "CreateMetafieldDefinitions";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMetafieldDefinitions"] = 'UpdateMetafieldDefinitions'] = "UpdateMetafieldDefinitions";
        AppResourceSetEnum[AppResourceSetEnum["DeleteMetafieldDefinitions"] = 'DeleteMetafieldDefinitions'] = "DeleteMetafieldDefinitions";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMetafields"] = 'UpdateMetafields'] = "UpdateMetafields";
        AppResourceSetEnum[AppResourceSetEnum["ViewCatalogMenuChanges"] = 'ViewCatalogMenuChanges'] = "ViewCatalogMenuChanges";
        AppResourceSetEnum[AppResourceSetEnum["PublishCatalogMenuChanges"] = 'PublishCatalogMenuChanges'] = "PublishCatalogMenuChanges";
        AppResourceSetEnum[AppResourceSetEnum["ViewAppStatistics"] = 'ViewAppStatistics'] = "ViewAppStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewApmStatistics"] = 'ViewApmStatistics'] = "ViewApmStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewCampaignsStatistics"] = 'ViewCampaignsStatistics'] = "ViewCampaignsStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewCustomerStatistics"] = 'ViewCustomerStatistics'] = "ViewCustomerStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewLiveStatistics"] = 'ViewLiveStatistics'] = "ViewLiveStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewOrderStatistics"] = 'ViewOrderStatistics'] = "ViewOrderStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewSalesStatistics"] = 'ViewSalesStatistics'] = "ViewSalesStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewSalesEndOfDayStatistics"] = 'ViewSalesEndOfDayStatistics'] = "ViewSalesEndOfDayStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewVouchersStatistics"] = 'ViewVouchersStatistics'] = "ViewVouchersStatistics";
        AppResourceSetEnum[AppResourceSetEnum["DownloadCustomerCsvExport"] = 'DownloadCustomerCsvExport'] = "DownloadCustomerCsvExport";
        AppResourceSetEnum[AppResourceSetEnum["ViewApmAuditLogs"] = 'ViewApmAuditLogs'] = "ViewApmAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewStoreAuditLogs"] = 'ViewStoreAuditLogs'] = "ViewStoreAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewMenuAuditLogs"] = 'ViewMenuAuditLogs'] = "ViewMenuAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewBankAccountAuditLogs"] = 'ViewBankAccountAuditLogs'] = "ViewBankAccountAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewFeeConfigurationsAuditLogs"] = 'ViewFeeConfigurationsAuditLogs'] = "ViewFeeConfigurationsAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewOrdersAuditLogs"] = 'ViewOrdersAuditLogs'] = "ViewOrdersAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewVouchersAuditLogs"] = 'ViewVouchersAuditLogs'] = "ViewVouchersAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewUserEventsAuditLogs"] = 'ViewUserEventsAuditLogs'] = "ViewUserEventsAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewCampaignsAuditLogs"] = 'ViewCampaignsAuditLogs'] = "ViewCampaignsAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewTeammatesAuditLogs"] = 'ViewTeammatesAuditLogs'] = "ViewTeammatesAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewAppAuditLogs"] = 'ViewAppAuditLogs'] = "ViewAppAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewCustomerAuditLogs"] = 'ViewCustomerAuditLogs'] = "ViewCustomerAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewPrinterAuditLogs"] = 'ViewPrinterAuditLogs'] = "ViewPrinterAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewHydraAuditLogs"] = 'ViewHydraAuditLogs'] = "ViewHydraAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewPushNotificationAuditLogs"] = 'ViewPushNotificationAuditLogs'] = "ViewPushNotificationAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewStripeCustomConnectedAccountAuditLogs"] = 'ViewStripeCustomConnectedAccountAuditLogs'] = "ViewStripeCustomConnectedAccountAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewKioskBluetoothDeviceAuditLogs"] = 'ViewKioskBluetoothDeviceAuditLogs'] = "ViewKioskBluetoothDeviceAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewExternalAuditLogs"] = 'ViewExternalAuditLogs'] = "ViewExternalAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["CreateExternalAuditLogEvents"] = 'CreateExternalAuditLogEvents'] = "CreateExternalAuditLogEvents";
        AppResourceSetEnum[AppResourceSetEnum["ViewCatalogAuditLogs"] = 'ViewCatalogAuditLogs'] = "ViewCatalogAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewOrderFulfillmentAuditLogs"] = 'ViewOrderFulfillmentAuditLogs'] = "ViewOrderFulfillmentAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["SendPushNotificationToCustomer"] = 'SendPushNotificationToCustomer'] = "SendPushNotificationToCustomer";
        AppResourceSetEnum[AppResourceSetEnum["InviteDriverToApp"] = 'InviteDriverToApp'] = "InviteDriverToApp";
        AppResourceSetEnum[AppResourceSetEnum["GetDriverForApp"] = 'GetDriverForApp'] = "GetDriverForApp";
        AppResourceSetEnum[AppResourceSetEnum["RemoveDriverFromApp"] = 'RemoveDriverFromApp'] = "RemoveDriverFromApp";
        AppResourceSetEnum[AppResourceSetEnum["AssignDriverToOrder"] = 'AssignDriverToOrder'] = "AssignDriverToOrder";
        AppResourceSetEnum[AppResourceSetEnum["UnassignDriverFromOrder"] = 'UnassignDriverFromOrder'] = "UnassignDriverFromOrder";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersDeliveryTrackingStatus"] = 'UpdateOrdersDeliveryTrackingStatus'] = "UpdateOrdersDeliveryTrackingStatus";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrderFulfillmentStatus"] = 'UpdateOrderFulfillmentStatus'] = "UpdateOrderFulfillmentStatus";
        AppResourceSetEnum[AppResourceSetEnum["ViewFulfillmentStatesConfiguration"] = 'ViewFulfillmentStatesConfiguration'] = "ViewFulfillmentStatesConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["CreateFulfillmentStatesConfiguration"] = 'CreateFulfillmentStatesConfiguration'] = "CreateFulfillmentStatesConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdateFulfillmentStatesConfiguration"] = 'UpdateFulfillmentStatesConfiguration'] = "UpdateFulfillmentStatesConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["DeleteFulfillmentStatesConfiguration"] = 'DeleteFulfillmentStatesConfiguration'] = "DeleteFulfillmentStatesConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["ViewPayouts"] = 'ViewPayouts'] = "ViewPayouts";
        AppResourceSetEnum[AppResourceSetEnum["ViewChannels"] = 'ViewChannels'] = "ViewChannels";
        AppResourceSetEnum[AppResourceSetEnum["ViewOnboarding"] = 'ViewOnboarding'] = "ViewOnboarding";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOnboarding"] = 'UpdateOnboarding'] = "UpdateOnboarding";
        AppResourceSetEnum[AppResourceSetEnum["ViewClientDevices"] = 'ViewClientDevices'] = "ViewClientDevices";
        AppResourceSetEnum[AppResourceSetEnum["UpdateClientDevices"] = 'UpdateClientDevices'] = "UpdateClientDevices";
        AppResourceSetEnum[AppResourceSetEnum["EnrollClientDevices"] = 'EnrollClientDevices'] = "EnrollClientDevices";
        AppResourceSetEnum[AppResourceSetEnum["AssignClientDevices"] = 'AssignClientDevices'] = "AssignClientDevices";
        AppResourceSetEnum[AppResourceSetEnum["ViewClientAuditLogs"] = 'ViewClientAuditLogs'] = "ViewClientAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["CreateAppStoreAppConfiguration"] = 'CreateAppStoreAppConfiguration'] = "CreateAppStoreAppConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["ViewAppStoreAppConfiguration"] = 'ViewAppStoreAppConfiguration'] = "ViewAppStoreAppConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdateAppStoreAppConfiguration"] = 'UpdateAppStoreAppConfiguration'] = "UpdateAppStoreAppConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["DeleteAppStoreAppConfiguration"] = 'DeleteAppStoreAppConfiguration'] = "DeleteAppStoreAppConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdateAppStoreAppConfigurationSettings"] = 'UpdateAppStoreAppConfigurationSettings'] = "UpdateAppStoreAppConfigurationSettings";
        AppResourceSetEnum[AppResourceSetEnum["ViewSalesChannels"] = 'ViewSalesChannels'] = "ViewSalesChannels";
        AppResourceSetEnum[AppResourceSetEnum["EditSalesChannels"] = 'EditSalesChannels'] = "EditSalesChannels";
        AppResourceSetEnum[AppResourceSetEnum["ViewPayGreenWhiteLabelConfiguration"] = 'ViewPayGreenWhiteLabelConfiguration'] = "ViewPayGreenWhiteLabelConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["CreatePayGreenWhiteLabelConfiguration"] = 'CreatePayGreenWhiteLabelConfiguration'] = "CreatePayGreenWhiteLabelConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdatePayGreenWhiteLabelConfiguration"] = 'UpdatePayGreenWhiteLabelConfiguration'] = "UpdatePayGreenWhiteLabelConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdatePayGreenStoreConfiguration"] = 'UpdatePayGreenStoreConfiguration'] = "UpdatePayGreenStoreConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["ViewSubscriptions"] = 'ViewSubscriptions'] = "ViewSubscriptions";
    })(AppResourceSetEnum = App.AppResourceSetEnum || (App.AppResourceSetEnum = {}));
    var ApplicationCategoryEnum;
    (function (ApplicationCategoryEnum) {
        ApplicationCategoryEnum[ApplicationCategoryEnum["Restaurant"] = 'Restaurant'] = "Restaurant";
        ApplicationCategoryEnum[ApplicationCategoryEnum["Cafe"] = 'Cafe'] = "Cafe";
        ApplicationCategoryEnum[ApplicationCategoryEnum["Convenience"] = 'Convenience'] = "Convenience";
    })(ApplicationCategoryEnum = App.ApplicationCategoryEnum || (App.ApplicationCategoryEnum = {}));
})(App = exports.App || (exports.App = {}));
exports.App = App;
var AppChannelAssignment = (function () {
    function AppChannelAssignment() {
    }
    AppChannelAssignment.getAttributeTypeMap = function () {
        return AppChannelAssignment.attributeTypeMap;
    };
    AppChannelAssignment.discriminator = undefined;
    AppChannelAssignment.attributeTypeMap = [
        {
            "name": "ChannelId",
            "baseName": "ChannelId",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        }
    ];
    return AppChannelAssignment;
}());
exports.AppChannelAssignment = AppChannelAssignment;
var AppCompliance = (function () {
    function AppCompliance() {
    }
    AppCompliance.getAttributeTypeMap = function () {
        return AppCompliance.attributeTypeMap;
    };
    AppCompliance.discriminator = undefined;
    AppCompliance.attributeTypeMap = [
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "ComplianceType",
            "baseName": "ComplianceType",
            "type": "AppCompliance.ComplianceTypeEnum"
        },
        {
            "name": "AllowDisablingOfGdpr",
            "baseName": "AllowDisablingOfGdpr",
            "type": "boolean"
        }
    ];
    return AppCompliance;
}());
exports.AppCompliance = AppCompliance;
(function (AppCompliance) {
    var ComplianceTypeEnum;
    (function (ComplianceTypeEnum) {
        ComplianceTypeEnum[ComplianceTypeEnum["Default"] = 'Default'] = "Default";
        ComplianceTypeEnum[ComplianceTypeEnum["GdprCompliance"] = 'GdprCompliance'] = "GdprCompliance";
    })(ComplianceTypeEnum = AppCompliance.ComplianceTypeEnum || (AppCompliance.ComplianceTypeEnum = {}));
})(AppCompliance = exports.AppCompliance || (exports.AppCompliance = {}));
exports.AppCompliance = AppCompliance;
var AppConfigSalesChannel = (function () {
    function AppConfigSalesChannel() {
    }
    AppConfigSalesChannel.getAttributeTypeMap = function () {
        return AppConfigSalesChannel.attributeTypeMap;
    };
    AppConfigSalesChannel.discriminator = undefined;
    AppConfigSalesChannel.attributeTypeMap = [
        {
            "name": "EmailRequestMode",
            "baseName": "EmailRequestMode",
            "type": "AppConfigSalesChannel.EmailRequestModeEnum"
        },
        {
            "name": "WebToAppRedirect",
            "baseName": "WebToAppRedirect",
            "type": "AppConfigSalesChannel.WebToAppRedirectEnum"
        },
        {
            "name": "AddressEntryType",
            "baseName": "AddressEntryType",
            "type": "AppConfigSalesChannel.AddressEntryTypeEnum"
        },
        {
            "name": "DisplayDeliveryRestaurantListScreen",
            "baseName": "DisplayDeliveryRestaurantListScreen",
            "type": "boolean"
        }
    ];
    return AppConfigSalesChannel;
}());
exports.AppConfigSalesChannel = AppConfigSalesChannel;
(function (AppConfigSalesChannel) {
    var EmailRequestModeEnum;
    (function (EmailRequestModeEnum) {
        EmailRequestModeEnum[EmailRequestModeEnum["DoNotRequest"] = 'DoNotRequest'] = "DoNotRequest";
        EmailRequestModeEnum[EmailRequestModeEnum["Request"] = 'Request'] = "Request";
        EmailRequestModeEnum[EmailRequestModeEnum["Require"] = 'Require'] = "Require";
    })(EmailRequestModeEnum = AppConfigSalesChannel.EmailRequestModeEnum || (AppConfigSalesChannel.EmailRequestModeEnum = {}));
    var WebToAppRedirectEnum;
    (function (WebToAppRedirectEnum) {
        WebToAppRedirectEnum[WebToAppRedirectEnum["NoRedirect"] = 'NoRedirect'] = "NoRedirect";
        WebToAppRedirectEnum[WebToAppRedirectEnum["RedirectOnce"] = 'RedirectOnce'] = "RedirectOnce";
        WebToAppRedirectEnum[WebToAppRedirectEnum["RedirectAlways"] = 'RedirectAlways'] = "RedirectAlways";
        WebToAppRedirectEnum[WebToAppRedirectEnum["SuggestPwa"] = 'SuggestPwa'] = "SuggestPwa";
        WebToAppRedirectEnum[WebToAppRedirectEnum["ForcePwa"] = 'ForcePwa'] = "ForcePwa";
    })(WebToAppRedirectEnum = AppConfigSalesChannel.WebToAppRedirectEnum || (AppConfigSalesChannel.WebToAppRedirectEnum = {}));
    var AddressEntryTypeEnum;
    (function (AddressEntryTypeEnum) {
        AddressEntryTypeEnum[AddressEntryTypeEnum["MapFirst"] = 'MapFirst'] = "MapFirst";
        AddressEntryTypeEnum[AddressEntryTypeEnum["TextEntryManualAllowed"] = 'TextEntryManualAllowed'] = "TextEntryManualAllowed";
        AddressEntryTypeEnum[AddressEntryTypeEnum["TextEntryManualDisallowed"] = 'TextEntryManualDisallowed'] = "TextEntryManualDisallowed";
    })(AddressEntryTypeEnum = AppConfigSalesChannel.AddressEntryTypeEnum || (AppConfigSalesChannel.AddressEntryTypeEnum = {}));
})(AppConfigSalesChannel = exports.AppConfigSalesChannel || (exports.AppConfigSalesChannel = {}));
exports.AppConfigSalesChannel = AppConfigSalesChannel;
var AppConfigUpdateModel = (function () {
    function AppConfigUpdateModel() {
    }
    AppConfigUpdateModel.getAttributeTypeMap = function () {
        return AppConfigUpdateModel.attributeTypeMap;
    };
    AppConfigUpdateModel.discriminator = undefined;
    AppConfigUpdateModel.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "HostName",
            "baseName": "HostName",
            "type": "string"
        },
        {
            "name": "MainColor",
            "baseName": "MainColor",
            "type": "string"
        },
        {
            "name": "KioskPrimaryColour",
            "baseName": "KioskPrimaryColour",
            "type": "string"
        },
        {
            "name": "ApplicationCategory",
            "baseName": "ApplicationCategory",
            "type": "AppConfigUpdateModel.ApplicationCategoryEnum"
        },
        {
            "name": "IsPanaceaEnabled",
            "baseName": "IsPanaceaEnabled",
            "type": "boolean"
        },
        {
            "name": "PanaceaVanityUrl",
            "baseName": "PanaceaVanityUrl",
            "type": "string"
        },
        {
            "name": "CookieConsentPromptEnabled",
            "baseName": "CookieConsentPromptEnabled",
            "type": "boolean"
        }
    ];
    return AppConfigUpdateModel;
}());
exports.AppConfigUpdateModel = AppConfigUpdateModel;
(function (AppConfigUpdateModel) {
    var ApplicationCategoryEnum;
    (function (ApplicationCategoryEnum) {
        ApplicationCategoryEnum[ApplicationCategoryEnum["Restaurant"] = 'Restaurant'] = "Restaurant";
        ApplicationCategoryEnum[ApplicationCategoryEnum["Cafe"] = 'Cafe'] = "Cafe";
        ApplicationCategoryEnum[ApplicationCategoryEnum["Convenience"] = 'Convenience'] = "Convenience";
    })(ApplicationCategoryEnum = AppConfigUpdateModel.ApplicationCategoryEnum || (AppConfigUpdateModel.ApplicationCategoryEnum = {}));
})(AppConfigUpdateModel = exports.AppConfigUpdateModel || (exports.AppConfigUpdateModel = {}));
exports.AppConfigUpdateModel = AppConfigUpdateModel;
var AppCreatedEvent = (function () {
    function AppCreatedEvent() {
    }
    AppCreatedEvent.getAttributeTypeMap = function () {
        return AppCreatedEvent.attributeTypeMap;
    };
    AppCreatedEvent.discriminator = undefined;
    AppCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "AppName",
            "baseName": "AppName",
            "type": "string"
        },
        {
            "name": "CountryId",
            "baseName": "CountryId",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "OpportunityId",
            "baseName": "OpportunityId",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return AppCreatedEvent;
}());
exports.AppCreatedEvent = AppCreatedEvent;
var AppLookup = (function () {
    function AppLookup() {
    }
    AppLookup.getAttributeTypeMap = function () {
        return AppLookup.attributeTypeMap;
    };
    AppLookup.discriminator = undefined;
    AppLookup.attributeTypeMap = [
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "OpportunityId",
            "baseName": "OpportunityId",
            "type": "string"
        }
    ];
    return AppLookup;
}());
exports.AppLookup = AppLookup;
var AppSalesforceReferences = (function () {
    function AppSalesforceReferences() {
    }
    AppSalesforceReferences.getAttributeTypeMap = function () {
        return AppSalesforceReferences.attributeTypeMap;
    };
    AppSalesforceReferences.discriminator = undefined;
    AppSalesforceReferences.attributeTypeMap = [
        {
            "name": "OpportunityId",
            "baseName": "OpportunityId",
            "type": "string"
        }
    ];
    return AppSalesforceReferences;
}());
exports.AppSalesforceReferences = AppSalesforceReferences;
var AppStoreApp = (function () {
    function AppStoreApp() {
    }
    AppStoreApp.getAttributeTypeMap = function () {
        return AppStoreApp.attributeTypeMap;
    };
    AppStoreApp.discriminator = undefined;
    AppStoreApp.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "string"
        },
        {
            "name": "VerificationStatus",
            "baseName": "VerificationStatus",
            "type": "AppStoreApp.VerificationStatusEnum"
        },
        {
            "name": "Logo",
            "baseName": "Logo",
            "type": "string"
        },
        {
            "name": "OAuthAppId",
            "baseName": "OAuthAppId",
            "type": "string"
        },
        {
            "name": "Internal",
            "baseName": "Internal",
            "type": "boolean"
        },
        {
            "name": "Details",
            "baseName": "Details",
            "type": "string"
        },
        {
            "name": "ConfigurationType",
            "baseName": "ConfigurationType",
            "type": "AppStoreApp.ConfigurationTypeEnum"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "AppStoreApp.StoreSelectorTypeEnum"
        },
        {
            "name": "FieldGroups",
            "baseName": "FieldGroups",
            "type": "Array<FieldGroup>"
        },
        {
            "name": "SetupInstructions",
            "baseName": "SetupInstructions",
            "type": "string"
        },
        {
            "name": "ExternalSetupLink",
            "baseName": "ExternalSetupLink",
            "type": "string"
        },
        {
            "name": "TeammateAppAccessLevel",
            "baseName": "TeammateAppAccessLevel",
            "type": "AppStoreApp.TeammateAppAccessLevelEnum"
        },
        {
            "name": "PermissionsType",
            "baseName": "PermissionsType",
            "type": "AppStoreApp.PermissionsTypeEnum"
        },
        {
            "name": "Support",
            "baseName": "Support",
            "type": "AppStoreAppSupportInfo"
        },
        {
            "name": "ExternalFunctionActionUrl",
            "baseName": "ExternalFunctionActionUrl",
            "type": "string"
        },
        {
            "name": "ExternalFunctionSignatureKey",
            "baseName": "ExternalFunctionSignatureKey",
            "type": "string"
        },
        {
            "name": "IsPaid",
            "baseName": "IsPaid",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "Categories",
            "baseName": "Categories",
            "type": "Array<AppStoreApp.CategoriesEnum>"
        },
        {
            "name": "Countries",
            "baseName": "Countries",
            "type": "Array<AppStoreApp.CountriesEnum>"
        },
        {
            "name": "DeveloperName",
            "baseName": "DeveloperName",
            "type": "string"
        }
    ];
    return AppStoreApp;
}());
exports.AppStoreApp = AppStoreApp;
(function (AppStoreApp) {
    var VerificationStatusEnum;
    (function (VerificationStatusEnum) {
        VerificationStatusEnum[VerificationStatusEnum["Draft"] = 'Draft'] = "Draft";
        VerificationStatusEnum[VerificationStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        VerificationStatusEnum[VerificationStatusEnum["Verified"] = 'Verified'] = "Verified";
    })(VerificationStatusEnum = AppStoreApp.VerificationStatusEnum || (AppStoreApp.VerificationStatusEnum = {}));
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = AppStoreApp.ConfigurationTypeEnum || (AppStoreApp.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = AppStoreApp.StoreSelectorTypeEnum || (AppStoreApp.StoreSelectorTypeEnum = {}));
    var TeammateAppAccessLevelEnum;
    (function (TeammateAppAccessLevelEnum) {
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
    })(TeammateAppAccessLevelEnum = AppStoreApp.TeammateAppAccessLevelEnum || (AppStoreApp.TeammateAppAccessLevelEnum = {}));
    var PermissionsTypeEnum;
    (function (PermissionsTypeEnum) {
        PermissionsTypeEnum[PermissionsTypeEnum["Teammate"] = 'Teammate'] = "Teammate";
    })(PermissionsTypeEnum = AppStoreApp.PermissionsTypeEnum || (AppStoreApp.PermissionsTypeEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = AppStoreApp.CategoriesEnum || (AppStoreApp.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = AppStoreApp.CountriesEnum || (AppStoreApp.CountriesEnum = {}));
})(AppStoreApp = exports.AppStoreApp || (exports.AppStoreApp = {}));
exports.AppStoreApp = AppStoreApp;
var AppStoreAppConfiguration = (function () {
    function AppStoreAppConfiguration() {
    }
    AppStoreAppConfiguration.getAttributeTypeMap = function () {
        return AppStoreAppConfiguration.attributeTypeMap;
    };
    AppStoreAppConfiguration.discriminator = undefined;
    AppStoreAppConfiguration.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "string"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "AppStoreAppId",
            "baseName": "AppStoreAppId",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "Settings",
            "baseName": "Settings",
            "type": "Array<Setting>"
        },
        {
            "name": "VerificationStatus",
            "baseName": "VerificationStatus",
            "type": "AppStoreAppConfiguration.VerificationStatusEnum"
        },
        {
            "name": "Logo",
            "baseName": "Logo",
            "type": "string"
        },
        {
            "name": "OAuthAppId",
            "baseName": "OAuthAppId",
            "type": "string"
        },
        {
            "name": "Internal",
            "baseName": "Internal",
            "type": "boolean"
        },
        {
            "name": "Details",
            "baseName": "Details",
            "type": "string"
        },
        {
            "name": "ConfigurationType",
            "baseName": "ConfigurationType",
            "type": "AppStoreAppConfiguration.ConfigurationTypeEnum"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "AppStoreAppConfiguration.StoreSelectorTypeEnum"
        },
        {
            "name": "FieldGroups",
            "baseName": "FieldGroups",
            "type": "Array<FieldGroup>"
        },
        {
            "name": "SetupInstructions",
            "baseName": "SetupInstructions",
            "type": "string"
        },
        {
            "name": "ExternalSetupLink",
            "baseName": "ExternalSetupLink",
            "type": "string"
        },
        {
            "name": "TeammateAppAccessLevel",
            "baseName": "TeammateAppAccessLevel",
            "type": "AppStoreAppConfiguration.TeammateAppAccessLevelEnum"
        },
        {
            "name": "PermissionsType",
            "baseName": "PermissionsType",
            "type": "AppStoreAppConfiguration.PermissionsTypeEnum"
        },
        {
            "name": "Support",
            "baseName": "Support",
            "type": "AppStoreAppSupportInfo"
        },
        {
            "name": "ExternalFunctionActionUrl",
            "baseName": "ExternalFunctionActionUrl",
            "type": "string"
        },
        {
            "name": "ExternalFunctionSignatureKey",
            "baseName": "ExternalFunctionSignatureKey",
            "type": "string"
        },
        {
            "name": "IsPaid",
            "baseName": "IsPaid",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Categories",
            "baseName": "Categories",
            "type": "Array<AppStoreAppConfiguration.CategoriesEnum>"
        },
        {
            "name": "Countries",
            "baseName": "Countries",
            "type": "Array<AppStoreAppConfiguration.CountriesEnum>"
        },
        {
            "name": "DeveloperName",
            "baseName": "DeveloperName",
            "type": "string"
        }
    ];
    return AppStoreAppConfiguration;
}());
exports.AppStoreAppConfiguration = AppStoreAppConfiguration;
(function (AppStoreAppConfiguration) {
    var VerificationStatusEnum;
    (function (VerificationStatusEnum) {
        VerificationStatusEnum[VerificationStatusEnum["Draft"] = 'Draft'] = "Draft";
        VerificationStatusEnum[VerificationStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        VerificationStatusEnum[VerificationStatusEnum["Verified"] = 'Verified'] = "Verified";
    })(VerificationStatusEnum = AppStoreAppConfiguration.VerificationStatusEnum || (AppStoreAppConfiguration.VerificationStatusEnum = {}));
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = AppStoreAppConfiguration.ConfigurationTypeEnum || (AppStoreAppConfiguration.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = AppStoreAppConfiguration.StoreSelectorTypeEnum || (AppStoreAppConfiguration.StoreSelectorTypeEnum = {}));
    var TeammateAppAccessLevelEnum;
    (function (TeammateAppAccessLevelEnum) {
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
    })(TeammateAppAccessLevelEnum = AppStoreAppConfiguration.TeammateAppAccessLevelEnum || (AppStoreAppConfiguration.TeammateAppAccessLevelEnum = {}));
    var PermissionsTypeEnum;
    (function (PermissionsTypeEnum) {
        PermissionsTypeEnum[PermissionsTypeEnum["Teammate"] = 'Teammate'] = "Teammate";
    })(PermissionsTypeEnum = AppStoreAppConfiguration.PermissionsTypeEnum || (AppStoreAppConfiguration.PermissionsTypeEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = AppStoreAppConfiguration.CategoriesEnum || (AppStoreAppConfiguration.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = AppStoreAppConfiguration.CountriesEnum || (AppStoreAppConfiguration.CountriesEnum = {}));
})(AppStoreAppConfiguration = exports.AppStoreAppConfiguration || (exports.AppStoreAppConfiguration = {}));
exports.AppStoreAppConfiguration = AppStoreAppConfiguration;
var AppStoreAppConfigurationHeader = (function () {
    function AppStoreAppConfigurationHeader() {
    }
    AppStoreAppConfigurationHeader.getAttributeTypeMap = function () {
        return AppStoreAppConfigurationHeader.attributeTypeMap;
    };
    AppStoreAppConfigurationHeader.discriminator = undefined;
    AppStoreAppConfigurationHeader.attributeTypeMap = [
        {
            "name": "AppStoreAppId",
            "baseName": "AppStoreAppId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Logo",
            "baseName": "Logo",
            "type": "string"
        },
        {
            "name": "DeveloperName",
            "baseName": "DeveloperName",
            "type": "string"
        }
    ];
    return AppStoreAppConfigurationHeader;
}());
exports.AppStoreAppConfigurationHeader = AppStoreAppConfigurationHeader;
var AppStoreAppConfigurationSummary = (function () {
    function AppStoreAppConfigurationSummary() {
    }
    AppStoreAppConfigurationSummary.getAttributeTypeMap = function () {
        return AppStoreAppConfigurationSummary.attributeTypeMap;
    };
    AppStoreAppConfigurationSummary.discriminator = undefined;
    AppStoreAppConfigurationSummary.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "string"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<ConfiguredStore>"
        },
        {
            "name": "ConfigurationType",
            "baseName": "ConfigurationType",
            "type": "AppStoreAppConfigurationSummary.ConfigurationTypeEnum"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "AppStoreAppConfigurationSummary.StoreSelectorTypeEnum"
        },
        {
            "name": "Internal",
            "baseName": "Internal",
            "type": "boolean"
        },
        {
            "name": "AppStoreAppId",
            "baseName": "AppStoreAppId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Logo",
            "baseName": "Logo",
            "type": "string"
        },
        {
            "name": "DeveloperName",
            "baseName": "DeveloperName",
            "type": "string"
        }
    ];
    return AppStoreAppConfigurationSummary;
}());
exports.AppStoreAppConfigurationSummary = AppStoreAppConfigurationSummary;
(function (AppStoreAppConfigurationSummary) {
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = AppStoreAppConfigurationSummary.ConfigurationTypeEnum || (AppStoreAppConfigurationSummary.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = AppStoreAppConfigurationSummary.StoreSelectorTypeEnum || (AppStoreAppConfigurationSummary.StoreSelectorTypeEnum = {}));
})(AppStoreAppConfigurationSummary = exports.AppStoreAppConfigurationSummary || (exports.AppStoreAppConfigurationSummary = {}));
exports.AppStoreAppConfigurationSummary = AppStoreAppConfigurationSummary;
var AppStoreAppConfigurationsWithSubscriptions = (function () {
    function AppStoreAppConfigurationsWithSubscriptions() {
    }
    AppStoreAppConfigurationsWithSubscriptions.getAttributeTypeMap = function () {
        return AppStoreAppConfigurationsWithSubscriptions.attributeTypeMap;
    };
    AppStoreAppConfigurationsWithSubscriptions.discriminator = undefined;
    AppStoreAppConfigurationsWithSubscriptions.attributeTypeMap = [
        {
            "name": "Subscription",
            "baseName": "Subscription",
            "type": "AppStoreAppSubscriptionSummary"
        },
        {
            "name": "Configurations",
            "baseName": "Configurations",
            "type": "Array<AppStoreAppConfigurationSummary>"
        }
    ];
    return AppStoreAppConfigurationsWithSubscriptions;
}());
exports.AppStoreAppConfigurationsWithSubscriptions = AppStoreAppConfigurationsWithSubscriptions;
var AppStoreAppSubscriptionSummary = (function () {
    function AppStoreAppSubscriptionSummary() {
    }
    AppStoreAppSubscriptionSummary.getAttributeTypeMap = function () {
        return AppStoreAppSubscriptionSummary.attributeTypeMap;
    };
    AppStoreAppSubscriptionSummary.discriminator = undefined;
    AppStoreAppSubscriptionSummary.attributeTypeMap = [
        {
            "name": "TotalSubscriptions",
            "baseName": "TotalSubscriptions",
            "type": "number"
        },
        {
            "name": "UsedSubscriptions",
            "baseName": "UsedSubscriptions",
            "type": "number"
        }
    ];
    return AppStoreAppSubscriptionSummary;
}());
exports.AppStoreAppSubscriptionSummary = AppStoreAppSubscriptionSummary;
var AppStoreAppSummary = (function () {
    function AppStoreAppSummary() {
    }
    AppStoreAppSummary.getAttributeTypeMap = function () {
        return AppStoreAppSummary.attributeTypeMap;
    };
    AppStoreAppSummary.discriminator = undefined;
    AppStoreAppSummary.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "string"
        },
        {
            "name": "VerificationStatus",
            "baseName": "VerificationStatus",
            "type": "AppStoreAppSummary.VerificationStatusEnum"
        },
        {
            "name": "Logo",
            "baseName": "Logo",
            "type": "string"
        },
        {
            "name": "Internal",
            "baseName": "Internal",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "Categories",
            "baseName": "Categories",
            "type": "Array<AppStoreAppSummary.CategoriesEnum>"
        },
        {
            "name": "Countries",
            "baseName": "Countries",
            "type": "Array<AppStoreAppSummary.CountriesEnum>"
        },
        {
            "name": "DeveloperName",
            "baseName": "DeveloperName",
            "type": "string"
        }
    ];
    return AppStoreAppSummary;
}());
exports.AppStoreAppSummary = AppStoreAppSummary;
(function (AppStoreAppSummary) {
    var VerificationStatusEnum;
    (function (VerificationStatusEnum) {
        VerificationStatusEnum[VerificationStatusEnum["Draft"] = 'Draft'] = "Draft";
        VerificationStatusEnum[VerificationStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        VerificationStatusEnum[VerificationStatusEnum["Verified"] = 'Verified'] = "Verified";
    })(VerificationStatusEnum = AppStoreAppSummary.VerificationStatusEnum || (AppStoreAppSummary.VerificationStatusEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = AppStoreAppSummary.CategoriesEnum || (AppStoreAppSummary.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = AppStoreAppSummary.CountriesEnum || (AppStoreAppSummary.CountriesEnum = {}));
})(AppStoreAppSummary = exports.AppStoreAppSummary || (exports.AppStoreAppSummary = {}));
exports.AppStoreAppSummary = AppStoreAppSummary;
var AppStoreAppSupportInfo = (function () {
    function AppStoreAppSupportInfo() {
    }
    AppStoreAppSupportInfo.getAttributeTypeMap = function () {
        return AppStoreAppSupportInfo.attributeTypeMap;
    };
    AppStoreAppSupportInfo.discriminator = undefined;
    AppStoreAppSupportInfo.attributeTypeMap = [
        {
            "name": "PrivacyPolicy",
            "baseName": "PrivacyPolicy",
            "type": "string"
        },
        {
            "name": "TermsOfUse",
            "baseName": "TermsOfUse",
            "type": "string"
        },
        {
            "name": "CompanyWebsite",
            "baseName": "CompanyWebsite",
            "type": "string"
        },
        {
            "name": "LearnMore",
            "baseName": "LearnMore",
            "type": "string"
        },
        {
            "name": "InstallationMessage",
            "baseName": "InstallationMessage",
            "type": "string"
        },
        {
            "name": "SupportEmail",
            "baseName": "SupportEmail",
            "type": "string"
        }
    ];
    return AppStoreAppSupportInfo;
}());
exports.AppStoreAppSupportInfo = AppStoreAppSupportInfo;
var AppStoreConfigCreatedEvent = (function () {
    function AppStoreConfigCreatedEvent() {
    }
    AppStoreConfigCreatedEvent.getAttributeTypeMap = function () {
        return AppStoreConfigCreatedEvent.attributeTypeMap;
    };
    AppStoreConfigCreatedEvent.discriminator = undefined;
    AppStoreConfigCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "AppStoreAppId",
            "baseName": "AppStoreAppId",
            "type": "string"
        },
        {
            "name": "AppStoreAppConfigurationId",
            "baseName": "AppStoreAppConfigurationId",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return AppStoreConfigCreatedEvent;
}());
exports.AppStoreConfigCreatedEvent = AppStoreConfigCreatedEvent;
var AppStoreConfigDeletedEvent = (function () {
    function AppStoreConfigDeletedEvent() {
    }
    AppStoreConfigDeletedEvent.getAttributeTypeMap = function () {
        return AppStoreConfigDeletedEvent.attributeTypeMap;
    };
    AppStoreConfigDeletedEvent.discriminator = undefined;
    AppStoreConfigDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "AppStoreAppId",
            "baseName": "AppStoreAppId",
            "type": "string"
        },
        {
            "name": "AppStoreAppConfigurationId",
            "baseName": "AppStoreAppConfigurationId",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return AppStoreConfigDeletedEvent;
}());
exports.AppStoreConfigDeletedEvent = AppStoreConfigDeletedEvent;
var AppStoreConfigUpdatedEvent = (function () {
    function AppStoreConfigUpdatedEvent() {
    }
    AppStoreConfigUpdatedEvent.getAttributeTypeMap = function () {
        return AppStoreConfigUpdatedEvent.attributeTypeMap;
    };
    AppStoreConfigUpdatedEvent.discriminator = undefined;
    AppStoreConfigUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "AppStoreAppId",
            "baseName": "AppStoreAppId",
            "type": "string"
        },
        {
            "name": "AppStoreAppConfiguration",
            "baseName": "AppStoreAppConfiguration",
            "type": "UpdateAppStoreAppConfigurationWebhookDTO"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return AppStoreConfigUpdatedEvent;
}());
exports.AppStoreConfigUpdatedEvent = AppStoreConfigUpdatedEvent;
var AppUpdatedEvent = (function () {
    function AppUpdatedEvent() {
    }
    AppUpdatedEvent.getAttributeTypeMap = function () {
        return AppUpdatedEvent.attributeTypeMap;
    };
    AppUpdatedEvent.discriminator = undefined;
    AppUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Changes",
            "baseName": "Changes",
            "type": "string"
        },
        {
            "name": "AppName",
            "baseName": "AppName",
            "type": "string"
        },
        {
            "name": "CountryId",
            "baseName": "CountryId",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "App",
            "baseName": "App",
            "type": "App"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return AppUpdatedEvent;
}());
exports.AppUpdatedEvent = AppUpdatedEvent;
var AssignedBankAccount = (function () {
    function AssignedBankAccount() {
    }
    AssignedBankAccount.getAttributeTypeMap = function () {
        return AssignedBankAccount.attributeTypeMap;
    };
    AssignedBankAccount.discriminator = undefined;
    AssignedBankAccount.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "BankAccountName",
            "baseName": "BankAccountName",
            "type": "string"
        }
    ];
    return AssignedBankAccount;
}());
exports.AssignedBankAccount = AssignedBankAccount;
var AuditLogFieldChangeInformation = (function () {
    function AuditLogFieldChangeInformation() {
    }
    AuditLogFieldChangeInformation.getAttributeTypeMap = function () {
        return AuditLogFieldChangeInformation.attributeTypeMap;
    };
    AuditLogFieldChangeInformation.discriminator = undefined;
    AuditLogFieldChangeInformation.attributeTypeMap = [
        {
            "name": "Path",
            "baseName": "Path",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "OldValue",
            "baseName": "OldValue",
            "type": "string"
        },
        {
            "name": "NewValue",
            "baseName": "NewValue",
            "type": "string"
        }
    ];
    return AuditLogFieldChangeInformation;
}());
exports.AuditLogFieldChangeInformation = AuditLogFieldChangeInformation;
var BalanceDetails = (function () {
    function BalanceDetails() {
    }
    BalanceDetails.getAttributeTypeMap = function () {
        return BalanceDetails.attributeTypeMap;
    };
    BalanceDetails.discriminator = undefined;
    BalanceDetails.attributeTypeMap = [
        {
            "name": "OpeningBalance",
            "baseName": "OpeningBalance",
            "type": "number"
        },
        {
            "name": "ClosingBalance",
            "baseName": "ClosingBalance",
            "type": "number"
        }
    ];
    return BalanceDetails;
}());
exports.BalanceDetails = BalanceDetails;
var BankAccount = (function () {
    function BankAccount() {
    }
    BankAccount.getAttributeTypeMap = function () {
        return BankAccount.attributeTypeMap;
    };
    BankAccount.discriminator = undefined;
    BankAccount.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "AccountName",
            "baseName": "AccountName",
            "type": "string"
        },
        {
            "name": "Iban",
            "baseName": "Iban",
            "type": "string"
        },
        {
            "name": "Swift",
            "baseName": "Swift",
            "type": "string"
        },
        {
            "name": "PopulatedAccountFields",
            "baseName": "PopulatedAccountFields",
            "type": "Array<AccountFieldKeyValuePair>"
        },
        {
            "name": "AccountState",
            "baseName": "AccountState",
            "type": "BankAccount.AccountStateEnum"
        },
        {
            "name": "StoreNames",
            "baseName": "StoreNames",
            "type": "Array<string>"
        },
        {
            "name": "BankAddress",
            "baseName": "BankAddress",
            "type": "string"
        },
        {
            "name": "BankCountryCode",
            "baseName": "BankCountryCode",
            "type": "string"
        },
        {
            "name": "AccountHolderAddress",
            "baseName": "AccountHolderAddress",
            "type": "string"
        },
        {
            "name": "AccountHolderCountryCode",
            "baseName": "AccountHolderCountryCode",
            "type": "string"
        },
        {
            "name": "VatNumber",
            "baseName": "VatNumber",
            "type": "string"
        }
    ];
    return BankAccount;
}());
exports.BankAccount = BankAccount;
(function (BankAccount) {
    var AccountStateEnum;
    (function (AccountStateEnum) {
        AccountStateEnum[AccountStateEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStateEnum[AccountStateEnum["AwatingVerification"] = 'AwatingVerification'] = "AwatingVerification";
        AccountStateEnum[AccountStateEnum["Verified"] = 'Verified'] = "Verified";
        AccountStateEnum[AccountStateEnum["Grandfathered"] = 'Grandfathered'] = "Grandfathered";
    })(AccountStateEnum = BankAccount.AccountStateEnum || (BankAccount.AccountStateEnum = {}));
})(BankAccount = exports.BankAccount || (exports.BankAccount = {}));
exports.BankAccount = BankAccount;
var BankAccountAssignedEvent = (function () {
    function BankAccountAssignedEvent() {
    }
    BankAccountAssignedEvent.getAttributeTypeMap = function () {
        return BankAccountAssignedEvent.attributeTypeMap;
    };
    BankAccountAssignedEvent.discriminator = undefined;
    BankAccountAssignedEvent.attributeTypeMap = [
        {
            "name": "BankAccount",
            "baseName": "BankAccount",
            "type": "BankAccount"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return BankAccountAssignedEvent;
}());
exports.BankAccountAssignedEvent = BankAccountAssignedEvent;
var BankAccountCreate = (function () {
    function BankAccountCreate() {
    }
    BankAccountCreate.getAttributeTypeMap = function () {
        return BankAccountCreate.attributeTypeMap;
    };
    BankAccountCreate.discriminator = undefined;
    BankAccountCreate.attributeTypeMap = [
        {
            "name": "BankAddress",
            "baseName": "BankAddress",
            "type": "string"
        },
        {
            "name": "BankCountryCode",
            "baseName": "BankCountryCode",
            "type": "string"
        },
        {
            "name": "AccountHolderAddress",
            "baseName": "AccountHolderAddress",
            "type": "string"
        },
        {
            "name": "AccountHolderCountryCode",
            "baseName": "AccountHolderCountryCode",
            "type": "string"
        },
        {
            "name": "VatNumber",
            "baseName": "VatNumber",
            "type": "string"
        },
        {
            "name": "CurrencyCode",
            "baseName": "CurrencyCode",
            "type": "BankAccountCreate.CurrencyCodeEnum"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "BankName",
            "baseName": "BankName",
            "type": "string"
        },
        {
            "name": "AccountName",
            "baseName": "AccountName",
            "type": "string"
        },
        {
            "name": "Iban",
            "baseName": "Iban",
            "type": "string"
        },
        {
            "name": "Swift",
            "baseName": "Swift",
            "type": "string"
        },
        {
            "name": "NationalClearingCode",
            "baseName": "NationalClearingCode",
            "type": "string"
        },
        {
            "name": "PopulatedAccountFields",
            "baseName": "PopulatedAccountFields",
            "type": "Array<AccountFieldKeyValuePair>"
        },
        {
            "name": "RejectionReason",
            "baseName": "RejectionReason",
            "type": "string"
        },
        {
            "name": "BusinessType",
            "baseName": "BusinessType",
            "type": "BankAccountCreate.BusinessTypeEnum"
        }
    ];
    return BankAccountCreate;
}());
exports.BankAccountCreate = BankAccountCreate;
(function (BankAccountCreate) {
    var CurrencyCodeEnum;
    (function (CurrencyCodeEnum) {
        CurrencyCodeEnum[CurrencyCodeEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyCodeEnum[CurrencyCodeEnum["USD"] = 'USD'] = "USD";
        CurrencyCodeEnum[CurrencyCodeEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyCodeEnum[CurrencyCodeEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyCodeEnum[CurrencyCodeEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyCodeEnum[CurrencyCodeEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyCodeEnum[CurrencyCodeEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyCodeEnum[CurrencyCodeEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyCodeEnum[CurrencyCodeEnum["AED"] = 'AED'] = "AED";
        CurrencyCodeEnum[CurrencyCodeEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyCodeEnum[CurrencyCodeEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyCodeEnum[CurrencyCodeEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyCodeEnum[CurrencyCodeEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyCodeEnum[CurrencyCodeEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyCodeEnum[CurrencyCodeEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyCodeEnum[CurrencyCodeEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyCodeEnum[CurrencyCodeEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyCodeEnum[CurrencyCodeEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyCodeEnum[CurrencyCodeEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyCodeEnum[CurrencyCodeEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyCodeEnum[CurrencyCodeEnum["TND"] = 'TND'] = "TND";
        CurrencyCodeEnum[CurrencyCodeEnum["YER"] = 'YER'] = "YER";
        CurrencyCodeEnum[CurrencyCodeEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyCodeEnum[CurrencyCodeEnum["INR"] = 'INR'] = "INR";
        CurrencyCodeEnum[CurrencyCodeEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyCodeEnum[CurrencyCodeEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyCodeEnum[CurrencyCodeEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyCodeEnum[CurrencyCodeEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyCodeEnum[CurrencyCodeEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyCodeEnum[CurrencyCodeEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyCodeEnum[CurrencyCodeEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyCodeEnum[CurrencyCodeEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyCodeEnum[CurrencyCodeEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyCodeEnum[CurrencyCodeEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyCodeEnum[CurrencyCodeEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyCodeEnum[CurrencyCodeEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyCodeEnum[CurrencyCodeEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyCodeEnum[CurrencyCodeEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyCodeEnum[CurrencyCodeEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyCodeEnum[CurrencyCodeEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyCodeEnum[CurrencyCodeEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyCodeEnum[CurrencyCodeEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyCodeEnum[CurrencyCodeEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyCodeEnum[CurrencyCodeEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyCodeEnum[CurrencyCodeEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyCodeEnum[CurrencyCodeEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyCodeEnum[CurrencyCodeEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyCodeEnum[CurrencyCodeEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyCodeEnum[CurrencyCodeEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyCodeEnum[CurrencyCodeEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyCodeEnum[CurrencyCodeEnum["COP"] = 'COP'] = "COP";
        CurrencyCodeEnum[CurrencyCodeEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyCodeEnum[CurrencyCodeEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyCodeEnum[CurrencyCodeEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyCodeEnum[CurrencyCodeEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyCodeEnum[CurrencyCodeEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyCodeEnum[CurrencyCodeEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyCodeEnum[CurrencyCodeEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyCodeEnum[CurrencyCodeEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyCodeEnum[CurrencyCodeEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyCodeEnum[CurrencyCodeEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyCodeEnum[CurrencyCodeEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyCodeEnum[CurrencyCodeEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyCodeEnum[CurrencyCodeEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyCodeEnum[CurrencyCodeEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyCodeEnum[CurrencyCodeEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyCodeEnum[CurrencyCodeEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyCodeEnum[CurrencyCodeEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyCodeEnum[CurrencyCodeEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyCodeEnum[CurrencyCodeEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyCodeEnum[CurrencyCodeEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyCodeEnum[CurrencyCodeEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyCodeEnum[CurrencyCodeEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyCodeEnum[CurrencyCodeEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyCodeEnum[CurrencyCodeEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyCodeEnum[CurrencyCodeEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyCodeEnum[CurrencyCodeEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyCodeEnum[CurrencyCodeEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyCodeEnum[CurrencyCodeEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyCodeEnum[CurrencyCodeEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyCodeEnum[CurrencyCodeEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyCodeEnum[CurrencyCodeEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyCodeEnum[CurrencyCodeEnum["BND"] = 'BND'] = "BND";
        CurrencyCodeEnum[CurrencyCodeEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyCodeEnum[CurrencyCodeEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyCodeEnum[CurrencyCodeEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyCodeEnum[CurrencyCodeEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyCodeEnum[CurrencyCodeEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyCodeEnum[CurrencyCodeEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyCodeEnum[CurrencyCodeEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyCodeEnum[CurrencyCodeEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyCodeEnum[CurrencyCodeEnum["RON"] = 'RON'] = "RON";
        CurrencyCodeEnum[CurrencyCodeEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyCodeEnum[CurrencyCodeEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyCodeEnum[CurrencyCodeEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyCodeEnum[CurrencyCodeEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyCodeEnum[CurrencyCodeEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyCodeEnum[CurrencyCodeEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyCodeEnum[CurrencyCodeEnum["KES"] = 'KES'] = "KES";
        CurrencyCodeEnum[CurrencyCodeEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyCodeEnum[CurrencyCodeEnum["THB"] = 'THB'] = "THB";
        CurrencyCodeEnum[CurrencyCodeEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyCodeEnum[CurrencyCodeEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyCodeEnum[CurrencyCodeEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyCodeEnum[CurrencyCodeEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyCodeEnum[CurrencyCodeEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyCodeEnum[CurrencyCodeEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyCodeEnum[CurrencyCodeEnum["VND"] = 'VND'] = "VND";
        CurrencyCodeEnum[CurrencyCodeEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyCodeEnum[CurrencyCodeEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyCodeEnum[CurrencyCodeEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyCodeEnum = BankAccountCreate.CurrencyCodeEnum || (BankAccountCreate.CurrencyCodeEnum = {}));
    var BusinessTypeEnum;
    (function (BusinessTypeEnum) {
        BusinessTypeEnum[BusinessTypeEnum["Individual"] = 'Individual'] = "Individual";
        BusinessTypeEnum[BusinessTypeEnum["Company"] = 'Company'] = "Company";
        BusinessTypeEnum[BusinessTypeEnum["NonProfit"] = 'NonProfit'] = "NonProfit";
        BusinessTypeEnum[BusinessTypeEnum["GovernmentEntity"] = 'GovernmentEntity'] = "GovernmentEntity";
    })(BusinessTypeEnum = BankAccountCreate.BusinessTypeEnum || (BankAccountCreate.BusinessTypeEnum = {}));
})(BankAccountCreate = exports.BankAccountCreate || (exports.BankAccountCreate = {}));
exports.BankAccountCreate = BankAccountCreate;
var BankAccountCreatedEvent = (function () {
    function BankAccountCreatedEvent() {
    }
    BankAccountCreatedEvent.getAttributeTypeMap = function () {
        return BankAccountCreatedEvent.attributeTypeMap;
    };
    BankAccountCreatedEvent.discriminator = undefined;
    BankAccountCreatedEvent.attributeTypeMap = [
        {
            "name": "BankAccount",
            "baseName": "BankAccount",
            "type": "BankAccount"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return BankAccountCreatedEvent;
}());
exports.BankAccountCreatedEvent = BankAccountCreatedEvent;
var BankAccountDeletedEvent = (function () {
    function BankAccountDeletedEvent() {
    }
    BankAccountDeletedEvent.getAttributeTypeMap = function () {
        return BankAccountDeletedEvent.attributeTypeMap;
    };
    BankAccountDeletedEvent.discriminator = undefined;
    BankAccountDeletedEvent.attributeTypeMap = [
        {
            "name": "BankAccount",
            "baseName": "BankAccount",
            "type": "BankAccount"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return BankAccountDeletedEvent;
}());
exports.BankAccountDeletedEvent = BankAccountDeletedEvent;
var BankAccountDetail = (function () {
    function BankAccountDetail() {
    }
    BankAccountDetail.getAttributeTypeMap = function () {
        return BankAccountDetail.attributeTypeMap;
    };
    BankAccountDetail.discriminator = undefined;
    BankAccountDetail.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "StoreNames",
            "baseName": "StoreNames",
            "type": "Array<string>"
        },
        {
            "name": "AccountState",
            "baseName": "AccountState",
            "type": "BankAccountDetail.AccountStateEnum"
        },
        {
            "name": "StripeConnectedAccountInfo",
            "baseName": "StripeConnectedAccountInfo",
            "type": "StripeConnectedAccountInfo"
        },
        {
            "name": "BankAddress",
            "baseName": "BankAddress",
            "type": "string"
        },
        {
            "name": "BankCountryCode",
            "baseName": "BankCountryCode",
            "type": "string"
        },
        {
            "name": "AccountHolderAddress",
            "baseName": "AccountHolderAddress",
            "type": "string"
        },
        {
            "name": "AccountHolderCountryCode",
            "baseName": "AccountHolderCountryCode",
            "type": "string"
        },
        {
            "name": "VatNumber",
            "baseName": "VatNumber",
            "type": "string"
        },
        {
            "name": "CurrencyCode",
            "baseName": "CurrencyCode",
            "type": "BankAccountDetail.CurrencyCodeEnum"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "BankName",
            "baseName": "BankName",
            "type": "string"
        },
        {
            "name": "AccountName",
            "baseName": "AccountName",
            "type": "string"
        },
        {
            "name": "Iban",
            "baseName": "Iban",
            "type": "string"
        },
        {
            "name": "Swift",
            "baseName": "Swift",
            "type": "string"
        },
        {
            "name": "NationalClearingCode",
            "baseName": "NationalClearingCode",
            "type": "string"
        },
        {
            "name": "PopulatedAccountFields",
            "baseName": "PopulatedAccountFields",
            "type": "Array<AccountFieldKeyValuePair>"
        },
        {
            "name": "RejectionReason",
            "baseName": "RejectionReason",
            "type": "string"
        },
        {
            "name": "BusinessType",
            "baseName": "BusinessType",
            "type": "BankAccountDetail.BusinessTypeEnum"
        }
    ];
    return BankAccountDetail;
}());
exports.BankAccountDetail = BankAccountDetail;
(function (BankAccountDetail) {
    var AccountStateEnum;
    (function (AccountStateEnum) {
        AccountStateEnum[AccountStateEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStateEnum[AccountStateEnum["AwatingVerification"] = 'AwatingVerification'] = "AwatingVerification";
        AccountStateEnum[AccountStateEnum["Verified"] = 'Verified'] = "Verified";
        AccountStateEnum[AccountStateEnum["Grandfathered"] = 'Grandfathered'] = "Grandfathered";
    })(AccountStateEnum = BankAccountDetail.AccountStateEnum || (BankAccountDetail.AccountStateEnum = {}));
    var CurrencyCodeEnum;
    (function (CurrencyCodeEnum) {
        CurrencyCodeEnum[CurrencyCodeEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyCodeEnum[CurrencyCodeEnum["USD"] = 'USD'] = "USD";
        CurrencyCodeEnum[CurrencyCodeEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyCodeEnum[CurrencyCodeEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyCodeEnum[CurrencyCodeEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyCodeEnum[CurrencyCodeEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyCodeEnum[CurrencyCodeEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyCodeEnum[CurrencyCodeEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyCodeEnum[CurrencyCodeEnum["AED"] = 'AED'] = "AED";
        CurrencyCodeEnum[CurrencyCodeEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyCodeEnum[CurrencyCodeEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyCodeEnum[CurrencyCodeEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyCodeEnum[CurrencyCodeEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyCodeEnum[CurrencyCodeEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyCodeEnum[CurrencyCodeEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyCodeEnum[CurrencyCodeEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyCodeEnum[CurrencyCodeEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyCodeEnum[CurrencyCodeEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyCodeEnum[CurrencyCodeEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyCodeEnum[CurrencyCodeEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyCodeEnum[CurrencyCodeEnum["TND"] = 'TND'] = "TND";
        CurrencyCodeEnum[CurrencyCodeEnum["YER"] = 'YER'] = "YER";
        CurrencyCodeEnum[CurrencyCodeEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyCodeEnum[CurrencyCodeEnum["INR"] = 'INR'] = "INR";
        CurrencyCodeEnum[CurrencyCodeEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyCodeEnum[CurrencyCodeEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyCodeEnum[CurrencyCodeEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyCodeEnum[CurrencyCodeEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyCodeEnum[CurrencyCodeEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyCodeEnum[CurrencyCodeEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyCodeEnum[CurrencyCodeEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyCodeEnum[CurrencyCodeEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyCodeEnum[CurrencyCodeEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyCodeEnum[CurrencyCodeEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyCodeEnum[CurrencyCodeEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyCodeEnum[CurrencyCodeEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyCodeEnum[CurrencyCodeEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyCodeEnum[CurrencyCodeEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyCodeEnum[CurrencyCodeEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyCodeEnum[CurrencyCodeEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyCodeEnum[CurrencyCodeEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyCodeEnum[CurrencyCodeEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyCodeEnum[CurrencyCodeEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyCodeEnum[CurrencyCodeEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyCodeEnum[CurrencyCodeEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyCodeEnum[CurrencyCodeEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyCodeEnum[CurrencyCodeEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyCodeEnum[CurrencyCodeEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyCodeEnum[CurrencyCodeEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyCodeEnum[CurrencyCodeEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyCodeEnum[CurrencyCodeEnum["COP"] = 'COP'] = "COP";
        CurrencyCodeEnum[CurrencyCodeEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyCodeEnum[CurrencyCodeEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyCodeEnum[CurrencyCodeEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyCodeEnum[CurrencyCodeEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyCodeEnum[CurrencyCodeEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyCodeEnum[CurrencyCodeEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyCodeEnum[CurrencyCodeEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyCodeEnum[CurrencyCodeEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyCodeEnum[CurrencyCodeEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyCodeEnum[CurrencyCodeEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyCodeEnum[CurrencyCodeEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyCodeEnum[CurrencyCodeEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyCodeEnum[CurrencyCodeEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyCodeEnum[CurrencyCodeEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyCodeEnum[CurrencyCodeEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyCodeEnum[CurrencyCodeEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyCodeEnum[CurrencyCodeEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyCodeEnum[CurrencyCodeEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyCodeEnum[CurrencyCodeEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyCodeEnum[CurrencyCodeEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyCodeEnum[CurrencyCodeEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyCodeEnum[CurrencyCodeEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyCodeEnum[CurrencyCodeEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyCodeEnum[CurrencyCodeEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyCodeEnum[CurrencyCodeEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyCodeEnum[CurrencyCodeEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyCodeEnum[CurrencyCodeEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyCodeEnum[CurrencyCodeEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyCodeEnum[CurrencyCodeEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyCodeEnum[CurrencyCodeEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyCodeEnum[CurrencyCodeEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyCodeEnum[CurrencyCodeEnum["BND"] = 'BND'] = "BND";
        CurrencyCodeEnum[CurrencyCodeEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyCodeEnum[CurrencyCodeEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyCodeEnum[CurrencyCodeEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyCodeEnum[CurrencyCodeEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyCodeEnum[CurrencyCodeEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyCodeEnum[CurrencyCodeEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyCodeEnum[CurrencyCodeEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyCodeEnum[CurrencyCodeEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyCodeEnum[CurrencyCodeEnum["RON"] = 'RON'] = "RON";
        CurrencyCodeEnum[CurrencyCodeEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyCodeEnum[CurrencyCodeEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyCodeEnum[CurrencyCodeEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyCodeEnum[CurrencyCodeEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyCodeEnum[CurrencyCodeEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyCodeEnum[CurrencyCodeEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyCodeEnum[CurrencyCodeEnum["KES"] = 'KES'] = "KES";
        CurrencyCodeEnum[CurrencyCodeEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyCodeEnum[CurrencyCodeEnum["THB"] = 'THB'] = "THB";
        CurrencyCodeEnum[CurrencyCodeEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyCodeEnum[CurrencyCodeEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyCodeEnum[CurrencyCodeEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyCodeEnum[CurrencyCodeEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyCodeEnum[CurrencyCodeEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyCodeEnum[CurrencyCodeEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyCodeEnum[CurrencyCodeEnum["VND"] = 'VND'] = "VND";
        CurrencyCodeEnum[CurrencyCodeEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyCodeEnum[CurrencyCodeEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyCodeEnum[CurrencyCodeEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyCodeEnum = BankAccountDetail.CurrencyCodeEnum || (BankAccountDetail.CurrencyCodeEnum = {}));
    var BusinessTypeEnum;
    (function (BusinessTypeEnum) {
        BusinessTypeEnum[BusinessTypeEnum["Individual"] = 'Individual'] = "Individual";
        BusinessTypeEnum[BusinessTypeEnum["Company"] = 'Company'] = "Company";
        BusinessTypeEnum[BusinessTypeEnum["NonProfit"] = 'NonProfit'] = "NonProfit";
        BusinessTypeEnum[BusinessTypeEnum["GovernmentEntity"] = 'GovernmentEntity'] = "GovernmentEntity";
    })(BusinessTypeEnum = BankAccountDetail.BusinessTypeEnum || (BankAccountDetail.BusinessTypeEnum = {}));
})(BankAccountDetail = exports.BankAccountDetail || (exports.BankAccountDetail = {}));
exports.BankAccountDetail = BankAccountDetail;
var BankAccountDetailsUpdateRequest = (function () {
    function BankAccountDetailsUpdateRequest() {
    }
    BankAccountDetailsUpdateRequest.getAttributeTypeMap = function () {
        return BankAccountDetailsUpdateRequest.attributeTypeMap;
    };
    BankAccountDetailsUpdateRequest.discriminator = undefined;
    BankAccountDetailsUpdateRequest.attributeTypeMap = [
        {
            "name": "BankAddress",
            "baseName": "BankAddress",
            "type": "string"
        },
        {
            "name": "AccountHolderAddress",
            "baseName": "AccountHolderAddress",
            "type": "string"
        },
        {
            "name": "VatNumber",
            "baseName": "VatNumber",
            "type": "string"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "BankName",
            "baseName": "BankName",
            "type": "string"
        },
        {
            "name": "AccountName",
            "baseName": "AccountName",
            "type": "string"
        },
        {
            "name": "Iban",
            "baseName": "Iban",
            "type": "string"
        },
        {
            "name": "Swift",
            "baseName": "Swift",
            "type": "string"
        },
        {
            "name": "NationalClearingCode",
            "baseName": "NationalClearingCode",
            "type": "string"
        },
        {
            "name": "PopulatedAccountFields",
            "baseName": "PopulatedAccountFields",
            "type": "Array<AccountFieldKeyValuePair>"
        },
        {
            "name": "RejectionReason",
            "baseName": "RejectionReason",
            "type": "string"
        },
        {
            "name": "BusinessType",
            "baseName": "BusinessType",
            "type": "BankAccountDetailsUpdateRequest.BusinessTypeEnum"
        }
    ];
    return BankAccountDetailsUpdateRequest;
}());
exports.BankAccountDetailsUpdateRequest = BankAccountDetailsUpdateRequest;
(function (BankAccountDetailsUpdateRequest) {
    var BusinessTypeEnum;
    (function (BusinessTypeEnum) {
        BusinessTypeEnum[BusinessTypeEnum["Individual"] = 'Individual'] = "Individual";
        BusinessTypeEnum[BusinessTypeEnum["Company"] = 'Company'] = "Company";
        BusinessTypeEnum[BusinessTypeEnum["NonProfit"] = 'NonProfit'] = "NonProfit";
        BusinessTypeEnum[BusinessTypeEnum["GovernmentEntity"] = 'GovernmentEntity'] = "GovernmentEntity";
    })(BusinessTypeEnum = BankAccountDetailsUpdateRequest.BusinessTypeEnum || (BankAccountDetailsUpdateRequest.BusinessTypeEnum = {}));
})(BankAccountDetailsUpdateRequest = exports.BankAccountDetailsUpdateRequest || (exports.BankAccountDetailsUpdateRequest = {}));
exports.BankAccountDetailsUpdateRequest = BankAccountDetailsUpdateRequest;
var BankAccountSummary = (function () {
    function BankAccountSummary() {
    }
    BankAccountSummary.getAttributeTypeMap = function () {
        return BankAccountSummary.attributeTypeMap;
    };
    BankAccountSummary.discriminator = undefined;
    BankAccountSummary.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "StoreNames",
            "baseName": "StoreNames",
            "type": "Array<string>"
        },
        {
            "name": "AccountState",
            "baseName": "AccountState",
            "type": "BankAccountSummary.AccountStateEnum"
        },
        {
            "name": "CurrencyCode",
            "baseName": "CurrencyCode",
            "type": "string"
        },
        {
            "name": "StripeConnectedAccountInfo",
            "baseName": "StripeConnectedAccountInfo",
            "type": "StripeConnectedAccountInfo"
        },
        {
            "name": "AccountName",
            "baseName": "AccountName",
            "type": "string"
        },
        {
            "name": "Iban",
            "baseName": "Iban",
            "type": "string"
        },
        {
            "name": "Swift",
            "baseName": "Swift",
            "type": "string"
        },
        {
            "name": "NationalClearingCode",
            "baseName": "NationalClearingCode",
            "type": "string"
        },
        {
            "name": "PopulatedAccountFields",
            "baseName": "PopulatedAccountFields",
            "type": "Array<AccountFieldKeyValuePair>"
        },
        {
            "name": "RejectionReason",
            "baseName": "RejectionReason",
            "type": "string"
        },
        {
            "name": "BusinessType",
            "baseName": "BusinessType",
            "type": "BankAccountSummary.BusinessTypeEnum"
        }
    ];
    return BankAccountSummary;
}());
exports.BankAccountSummary = BankAccountSummary;
(function (BankAccountSummary) {
    var AccountStateEnum;
    (function (AccountStateEnum) {
        AccountStateEnum[AccountStateEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStateEnum[AccountStateEnum["AwatingVerification"] = 'AwatingVerification'] = "AwatingVerification";
        AccountStateEnum[AccountStateEnum["Verified"] = 'Verified'] = "Verified";
        AccountStateEnum[AccountStateEnum["Grandfathered"] = 'Grandfathered'] = "Grandfathered";
    })(AccountStateEnum = BankAccountSummary.AccountStateEnum || (BankAccountSummary.AccountStateEnum = {}));
    var BusinessTypeEnum;
    (function (BusinessTypeEnum) {
        BusinessTypeEnum[BusinessTypeEnum["Individual"] = 'Individual'] = "Individual";
        BusinessTypeEnum[BusinessTypeEnum["Company"] = 'Company'] = "Company";
        BusinessTypeEnum[BusinessTypeEnum["NonProfit"] = 'NonProfit'] = "NonProfit";
        BusinessTypeEnum[BusinessTypeEnum["GovernmentEntity"] = 'GovernmentEntity'] = "GovernmentEntity";
    })(BusinessTypeEnum = BankAccountSummary.BusinessTypeEnum || (BankAccountSummary.BusinessTypeEnum = {}));
})(BankAccountSummary = exports.BankAccountSummary || (exports.BankAccountSummary = {}));
exports.BankAccountSummary = BankAccountSummary;
var BankAccountUpdatedEvent = (function () {
    function BankAccountUpdatedEvent() {
    }
    BankAccountUpdatedEvent.getAttributeTypeMap = function () {
        return BankAccountUpdatedEvent.attributeTypeMap;
    };
    BankAccountUpdatedEvent.discriminator = undefined;
    BankAccountUpdatedEvent.attributeTypeMap = [
        {
            "name": "BankAccount",
            "baseName": "BankAccount",
            "type": "BankAccount"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return BankAccountUpdatedEvent;
}());
exports.BankAccountUpdatedEvent = BankAccountUpdatedEvent;
var BluetoothTerminalStatus = (function () {
    function BluetoothTerminalStatus() {
    }
    BluetoothTerminalStatus.getAttributeTypeMap = function () {
        return BluetoothTerminalStatus.attributeTypeMap;
    };
    BluetoothTerminalStatus.discriminator = undefined;
    BluetoothTerminalStatus.attributeTypeMap = [
        {
            "name": "SerialNumber",
            "baseName": "SerialNumber",
            "type": "string"
        },
        {
            "name": "SoftwareVersion",
            "baseName": "SoftwareVersion",
            "type": "string"
        },
        {
            "name": "DeviceType",
            "baseName": "DeviceType",
            "type": "BluetoothTerminalStatus.DeviceTypeEnum"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "BluetoothTerminalStatus.StatusEnum"
        },
        {
            "name": "BatteryLevel",
            "baseName": "BatteryLevel",
            "type": "number"
        },
        {
            "name": "UpdateTime",
            "baseName": "UpdateTime",
            "type": "Date"
        },
        {
            "name": "ReaderId",
            "baseName": "ReaderId",
            "type": "string"
        }
    ];
    return BluetoothTerminalStatus;
}());
exports.BluetoothTerminalStatus = BluetoothTerminalStatus;
(function (BluetoothTerminalStatus) {
    var DeviceTypeEnum;
    (function (DeviceTypeEnum) {
        DeviceTypeEnum[DeviceTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        DeviceTypeEnum[DeviceTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        DeviceTypeEnum[DeviceTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        DeviceTypeEnum[DeviceTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        DeviceTypeEnum[DeviceTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(DeviceTypeEnum = BluetoothTerminalStatus.DeviceTypeEnum || (BluetoothTerminalStatus.DeviceTypeEnum = {}));
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["NotConnected"] = 'Not_Connected'] = "NotConnected";
        StatusEnum[StatusEnum["Connecting"] = 'Connecting'] = "Connecting";
        StatusEnum[StatusEnum["Connected"] = 'Connected'] = "Connected";
        StatusEnum[StatusEnum["Online"] = 'Online'] = "Online";
        StatusEnum[StatusEnum["Offline"] = 'Offline'] = "Offline";
    })(StatusEnum = BluetoothTerminalStatus.StatusEnum || (BluetoothTerminalStatus.StatusEnum = {}));
})(BluetoothTerminalStatus = exports.BluetoothTerminalStatus || (exports.BluetoothTerminalStatus = {}));
exports.BluetoothTerminalStatus = BluetoothTerminalStatus;
var BusinessHoursOverride = (function () {
    function BusinessHoursOverride() {
    }
    BusinessHoursOverride.getAttributeTypeMap = function () {
        return BusinessHoursOverride.attributeTypeMap;
    };
    BusinessHoursOverride.discriminator = undefined;
    BusinessHoursOverride.attributeTypeMap = [
        {
            "name": "BusinessHoursOverrideId",
            "baseName": "BusinessHoursOverrideId",
            "type": "number"
        },
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "BusinessHoursOverride.DeliveryTypeEnum"
        },
        {
            "name": "StartTime",
            "baseName": "StartTime",
            "type": "Date"
        },
        {
            "name": "EndTime",
            "baseName": "EndTime",
            "type": "Date"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "BusinessHoursOverride.TypeEnum"
        }
    ];
    return BusinessHoursOverride;
}());
exports.BusinessHoursOverride = BusinessHoursOverride;
(function (BusinessHoursOverride) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = BusinessHoursOverride.DeliveryTypeEnum || (BusinessHoursOverride.DeliveryTypeEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Open"] = 'Open'] = "Open";
        TypeEnum[TypeEnum["Closed"] = 'Closed'] = "Closed";
        TypeEnum[TypeEnum["ClosedAllowPreOrders"] = 'ClosedAllowPreOrders'] = "ClosedAllowPreOrders";
    })(TypeEnum = BusinessHoursOverride.TypeEnum || (BusinessHoursOverride.TypeEnum = {}));
})(BusinessHoursOverride = exports.BusinessHoursOverride || (exports.BusinessHoursOverride = {}));
exports.BusinessHoursOverride = BusinessHoursOverride;
var BusinessHoursOverrideBase = (function () {
    function BusinessHoursOverrideBase() {
    }
    BusinessHoursOverrideBase.getAttributeTypeMap = function () {
        return BusinessHoursOverrideBase.attributeTypeMap;
    };
    BusinessHoursOverrideBase.discriminator = undefined;
    BusinessHoursOverrideBase.attributeTypeMap = [
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "BusinessHoursOverrideBase.DeliveryTypeEnum"
        },
        {
            "name": "StartTime",
            "baseName": "StartTime",
            "type": "Date"
        },
        {
            "name": "EndTime",
            "baseName": "EndTime",
            "type": "Date"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "BusinessHoursOverrideBase.TypeEnum"
        }
    ];
    return BusinessHoursOverrideBase;
}());
exports.BusinessHoursOverrideBase = BusinessHoursOverrideBase;
(function (BusinessHoursOverrideBase) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = BusinessHoursOverrideBase.DeliveryTypeEnum || (BusinessHoursOverrideBase.DeliveryTypeEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Open"] = 'Open'] = "Open";
        TypeEnum[TypeEnum["Closed"] = 'Closed'] = "Closed";
        TypeEnum[TypeEnum["ClosedAllowPreOrders"] = 'ClosedAllowPreOrders'] = "ClosedAllowPreOrders";
    })(TypeEnum = BusinessHoursOverrideBase.TypeEnum || (BusinessHoursOverrideBase.TypeEnum = {}));
})(BusinessHoursOverrideBase = exports.BusinessHoursOverrideBase || (exports.BusinessHoursOverrideBase = {}));
exports.BusinessHoursOverrideBase = BusinessHoursOverrideBase;
var BusinessHoursPeriod = (function () {
    function BusinessHoursPeriod() {
    }
    BusinessHoursPeriod.getAttributeTypeMap = function () {
        return BusinessHoursPeriod.attributeTypeMap;
    };
    BusinessHoursPeriod.discriminator = undefined;
    BusinessHoursPeriod.attributeTypeMap = [
        {
            "name": "Early",
            "baseName": "Early",
            "type": "Range"
        },
        {
            "name": "Late",
            "baseName": "Late",
            "type": "Range"
        },
        {
            "name": "Ranges",
            "baseName": "Ranges",
            "type": "Array<Range>"
        },
        {
            "name": "DayOfWeek",
            "baseName": "DayOfWeek",
            "type": "BusinessHoursPeriod.DayOfWeekEnum"
        },
        {
            "name": "StartTime",
            "baseName": "StartTime",
            "type": "string"
        },
        {
            "name": "Period",
            "baseName": "Period",
            "type": "string"
        },
        {
            "name": "StartTimeEarly",
            "baseName": "StartTimeEarly",
            "type": "string"
        },
        {
            "name": "PeriodEarly",
            "baseName": "PeriodEarly",
            "type": "string"
        }
    ];
    return BusinessHoursPeriod;
}());
exports.BusinessHoursPeriod = BusinessHoursPeriod;
(function (BusinessHoursPeriod) {
    var DayOfWeekEnum;
    (function (DayOfWeekEnum) {
        DayOfWeekEnum[DayOfWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfWeekEnum[DayOfWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfWeekEnum[DayOfWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfWeekEnum[DayOfWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfWeekEnum[DayOfWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfWeekEnum[DayOfWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfWeekEnum[DayOfWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfWeekEnum = BusinessHoursPeriod.DayOfWeekEnum || (BusinessHoursPeriod.DayOfWeekEnum = {}));
})(BusinessHoursPeriod = exports.BusinessHoursPeriod || (exports.BusinessHoursPeriod = {}));
exports.BusinessHoursPeriod = BusinessHoursPeriod;
var BusinessHoursPeriodBase = (function () {
    function BusinessHoursPeriodBase() {
    }
    BusinessHoursPeriodBase.getAttributeTypeMap = function () {
        return BusinessHoursPeriodBase.attributeTypeMap;
    };
    BusinessHoursPeriodBase.discriminator = undefined;
    BusinessHoursPeriodBase.attributeTypeMap = [
        {
            "name": "DayOfWeek",
            "baseName": "DayOfWeek",
            "type": "BusinessHoursPeriodBase.DayOfWeekEnum"
        },
        {
            "name": "StartTime",
            "baseName": "StartTime",
            "type": "string"
        },
        {
            "name": "Period",
            "baseName": "Period",
            "type": "string"
        },
        {
            "name": "StartTimeEarly",
            "baseName": "StartTimeEarly",
            "type": "string"
        },
        {
            "name": "PeriodEarly",
            "baseName": "PeriodEarly",
            "type": "string"
        }
    ];
    return BusinessHoursPeriodBase;
}());
exports.BusinessHoursPeriodBase = BusinessHoursPeriodBase;
(function (BusinessHoursPeriodBase) {
    var DayOfWeekEnum;
    (function (DayOfWeekEnum) {
        DayOfWeekEnum[DayOfWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfWeekEnum[DayOfWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfWeekEnum[DayOfWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfWeekEnum[DayOfWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfWeekEnum[DayOfWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfWeekEnum[DayOfWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfWeekEnum[DayOfWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfWeekEnum = BusinessHoursPeriodBase.DayOfWeekEnum || (BusinessHoursPeriodBase.DayOfWeekEnum = {}));
})(BusinessHoursPeriodBase = exports.BusinessHoursPeriodBase || (exports.BusinessHoursPeriodBase = {}));
exports.BusinessHoursPeriodBase = BusinessHoursPeriodBase;
var CampaignStatistics = (function () {
    function CampaignStatistics() {
    }
    CampaignStatistics.getAttributeTypeMap = function () {
        return CampaignStatistics.attributeTypeMap;
    };
    CampaignStatistics.discriminator = undefined;
    CampaignStatistics.attributeTypeMap = [
        {
            "name": "VouchersIssued",
            "baseName": "VouchersIssued",
            "type": "number"
        },
        {
            "name": "VouchersRedeemed",
            "baseName": "VouchersRedeemed",
            "type": "number"
        },
        {
            "name": "Conversion",
            "baseName": "Conversion",
            "type": "number"
        },
        {
            "name": "SalesGenerated",
            "baseName": "SalesGenerated",
            "type": "number"
        },
        {
            "name": "ReturnOfInvestment",
            "baseName": "ReturnOfInvestment",
            "type": "number"
        }
    ];
    return CampaignStatistics;
}());
exports.CampaignStatistics = CampaignStatistics;
var CardReader = (function () {
    function CardReader() {
    }
    CardReader.getAttributeTypeMap = function () {
        return CardReader.attributeTypeMap;
    };
    CardReader.discriminator = undefined;
    CardReader.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "string"
        },
        {
            "name": "DeviceSoftwareVersion",
            "baseName": "DeviceSoftwareVersion",
            "type": "string"
        },
        {
            "name": "SerialNumber",
            "baseName": "SerialNumber",
            "type": "string"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "string"
        },
        {
            "name": "RegistrationCode",
            "baseName": "RegistrationCode",
            "type": "string"
        },
        {
            "name": "DeviceType",
            "baseName": "DeviceType",
            "type": "string"
        },
        {
            "name": "Deleted",
            "baseName": "Deleted",
            "type": "boolean"
        },
        {
            "name": "Action",
            "baseName": "Action",
            "type": "ReaderActionStateInfo"
        }
    ];
    return CardReader;
}());
exports.CardReader = CardReader;
var CardReaderRegistrationRequest = (function () {
    function CardReaderRegistrationRequest() {
    }
    CardReaderRegistrationRequest.getAttributeTypeMap = function () {
        return CardReaderRegistrationRequest.attributeTypeMap;
    };
    CardReaderRegistrationRequest.discriminator = undefined;
    CardReaderRegistrationRequest.attributeTypeMap = [
        {
            "name": "RegistrationCode",
            "baseName": "RegistrationCode",
            "type": "string"
        },
        {
            "name": "KioskDeviceId",
            "baseName": "KioskDeviceId",
            "type": "string"
        }
    ];
    return CardReaderRegistrationRequest;
}());
exports.CardReaderRegistrationRequest = CardReaderRegistrationRequest;
var Cart = (function () {
    function Cart() {
    }
    Cart.getAttributeTypeMap = function () {
        return Cart.attributeTypeMap;
    };
    Cart.discriminator = undefined;
    Cart.attributeTypeMap = [
        {
            "name": "LineItems",
            "baseName": "LineItems",
            "type": "Array<LineItem>"
        },
        {
            "name": "CartAmount",
            "baseName": "CartAmount",
            "type": "Price"
        },
        {
            "name": "Tip",
            "baseName": "Tip",
            "type": "Price"
        }
    ];
    return Cart;
}());
exports.Cart = Cart;
var CatalogGroupArchivedEvent = (function () {
    function CatalogGroupArchivedEvent() {
    }
    CatalogGroupArchivedEvent.getAttributeTypeMap = function () {
        return CatalogGroupArchivedEvent.attributeTypeMap;
    };
    CatalogGroupArchivedEvent.discriminator = undefined;
    CatalogGroupArchivedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Group",
            "baseName": "Group",
            "type": "Group"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CatalogGroupArchivedEvent;
}());
exports.CatalogGroupArchivedEvent = CatalogGroupArchivedEvent;
var CatalogGroupCreatedEvent = (function () {
    function CatalogGroupCreatedEvent() {
    }
    CatalogGroupCreatedEvent.getAttributeTypeMap = function () {
        return CatalogGroupCreatedEvent.attributeTypeMap;
    };
    CatalogGroupCreatedEvent.discriminator = undefined;
    CatalogGroupCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Group",
            "baseName": "Group",
            "type": "Group"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CatalogGroupCreatedEvent;
}());
exports.CatalogGroupCreatedEvent = CatalogGroupCreatedEvent;
var CatalogGroupReference = (function () {
    function CatalogGroupReference() {
    }
    CatalogGroupReference.getAttributeTypeMap = function () {
        return CatalogGroupReference.attributeTypeMap;
    };
    CatalogGroupReference.discriminator = undefined;
    CatalogGroupReference.attributeTypeMap = [
        {
            "name": "Group",
            "baseName": "Group",
            "type": "Group"
        },
        {
            "name": "CatalogGroupId",
            "baseName": "CatalogGroupId",
            "type": "string"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "GroupType",
            "baseName": "GroupType",
            "type": "CatalogGroupReference.GroupTypeEnum"
        }
    ];
    return CatalogGroupReference;
}());
exports.CatalogGroupReference = CatalogGroupReference;
(function (CatalogGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = CatalogGroupReference.GroupTypeEnum || (CatalogGroupReference.GroupTypeEnum = {}));
})(CatalogGroupReference = exports.CatalogGroupReference || (exports.CatalogGroupReference = {}));
exports.CatalogGroupReference = CatalogGroupReference;
var CatalogGroupUpdatedEvent = (function () {
    function CatalogGroupUpdatedEvent() {
    }
    CatalogGroupUpdatedEvent.getAttributeTypeMap = function () {
        return CatalogGroupUpdatedEvent.attributeTypeMap;
    };
    CatalogGroupUpdatedEvent.discriminator = undefined;
    CatalogGroupUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Group",
            "baseName": "Group",
            "type": "Group"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CatalogGroupUpdatedEvent;
}());
exports.CatalogGroupUpdatedEvent = CatalogGroupUpdatedEvent;
var CatalogImage = (function () {
    function CatalogImage() {
    }
    CatalogImage.getAttributeTypeMap = function () {
        return CatalogImage.attributeTypeMap;
    };
    CatalogImage.discriminator = undefined;
    CatalogImage.attributeTypeMap = [
        {
            "name": "ImageUri",
            "baseName": "ImageUri",
            "type": "string"
        }
    ];
    return CatalogImage;
}());
exports.CatalogImage = CatalogImage;
var CatalogItem = (function () {
    function CatalogItem() {
    }
    CatalogItem.getAttributeTypeMap = function () {
        return CatalogItem.attributeTypeMap;
    };
    CatalogItem.discriminator = undefined;
    CatalogItem.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "IsArchived",
            "baseName": "IsArchived",
            "type": "boolean"
        },
        {
            "name": "Groups",
            "baseName": "Groups",
            "type": "Array<CatalogGroupReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        },
        {
            "name": "ItemType",
            "baseName": "ItemType",
            "type": "CatalogItem.ItemTypeEnum"
        },
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        }
    ];
    return CatalogItem;
}());
exports.CatalogItem = CatalogItem;
(function (CatalogItem) {
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum[ItemTypeEnum["Product"] = 'Product'] = "Product";
        ItemTypeEnum[ItemTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ItemTypeEnum = CatalogItem.ItemTypeEnum || (CatalogItem.ItemTypeEnum = {}));
})(CatalogItem = exports.CatalogItem || (exports.CatalogItem = {}));
exports.CatalogItem = CatalogItem;
var CatalogItemArchivedEvent = (function () {
    function CatalogItemArchivedEvent() {
    }
    CatalogItemArchivedEvent.getAttributeTypeMap = function () {
        return CatalogItemArchivedEvent.attributeTypeMap;
    };
    CatalogItemArchivedEvent.discriminator = undefined;
    CatalogItemArchivedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "CatalogItem",
            "baseName": "CatalogItem",
            "type": "CatalogItem"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CatalogItemArchivedEvent;
}());
exports.CatalogItemArchivedEvent = CatalogItemArchivedEvent;
var CatalogItemCreatedEvent = (function () {
    function CatalogItemCreatedEvent() {
    }
    CatalogItemCreatedEvent.getAttributeTypeMap = function () {
        return CatalogItemCreatedEvent.attributeTypeMap;
    };
    CatalogItemCreatedEvent.discriminator = undefined;
    CatalogItemCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "CatalogItem",
            "baseName": "CatalogItem",
            "type": "CatalogItem"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CatalogItemCreatedEvent;
}());
exports.CatalogItemCreatedEvent = CatalogItemCreatedEvent;
var CatalogItemUpdatedEvent = (function () {
    function CatalogItemUpdatedEvent() {
    }
    CatalogItemUpdatedEvent.getAttributeTypeMap = function () {
        return CatalogItemUpdatedEvent.attributeTypeMap;
    };
    CatalogItemUpdatedEvent.discriminator = undefined;
    CatalogItemUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "CatalogItem",
            "baseName": "CatalogItem",
            "type": "CatalogItem"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CatalogItemUpdatedEvent;
}());
exports.CatalogItemUpdatedEvent = CatalogItemUpdatedEvent;
var CertificateCreatedEvent = (function () {
    function CertificateCreatedEvent() {
    }
    CertificateCreatedEvent.getAttributeTypeMap = function () {
        return CertificateCreatedEvent.attributeTypeMap;
    };
    CertificateCreatedEvent.discriminator = undefined;
    CertificateCreatedEvent.attributeTypeMap = [
        {
            "name": "Hostname",
            "baseName": "Hostname",
            "type": "string"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CertificateCreatedEvent;
}());
exports.CertificateCreatedEvent = CertificateCreatedEvent;
var CertificateRenewedEvent = (function () {
    function CertificateRenewedEvent() {
    }
    CertificateRenewedEvent.getAttributeTypeMap = function () {
        return CertificateRenewedEvent.attributeTypeMap;
    };
    CertificateRenewedEvent.discriminator = undefined;
    CertificateRenewedEvent.attributeTypeMap = [
        {
            "name": "Hostname",
            "baseName": "Hostname",
            "type": "string"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CertificateRenewedEvent;
}());
exports.CertificateRenewedEvent = CertificateRenewedEvent;
var ChangePasswordModel = (function () {
    function ChangePasswordModel() {
    }
    ChangePasswordModel.getAttributeTypeMap = function () {
        return ChangePasswordModel.attributeTypeMap;
    };
    ChangePasswordModel.discriminator = undefined;
    ChangePasswordModel.attributeTypeMap = [
        {
            "name": "OldPassword",
            "baseName": "OldPassword",
            "type": "string"
        },
        {
            "name": "NewPassword",
            "baseName": "NewPassword",
            "type": "string"
        }
    ];
    return ChangePasswordModel;
}());
exports.ChangePasswordModel = ChangePasswordModel;
var Channel = (function () {
    function Channel() {
    }
    Channel.getAttributeTypeMap = function () {
        return Channel.attributeTypeMap;
    };
    Channel.discriminator = undefined;
    Channel.attributeTypeMap = [
        {
            "name": "ChannelId",
            "baseName": "ChannelId",
            "type": "number"
        },
        {
            "name": "TranslationKey",
            "baseName": "TranslationKey",
            "type": "string"
        },
        {
            "name": "Source",
            "baseName": "Source",
            "type": "Channel.SourceEnum"
        },
        {
            "name": "LogoUri",
            "baseName": "LogoUri",
            "type": "string"
        },
        {
            "name": "Available",
            "baseName": "Available",
            "type": "boolean"
        },
        {
            "name": "MaintainedExternally",
            "baseName": "MaintainedExternally",
            "type": "boolean"
        }
    ];
    return Channel;
}());
exports.Channel = Channel;
(function (Channel) {
    var SourceEnum;
    (function (SourceEnum) {
        SourceEnum[SourceEnum["Internal"] = 'Internal'] = "Internal";
        SourceEnum[SourceEnum["External"] = 'External'] = "External";
    })(SourceEnum = Channel.SourceEnum || (Channel.SourceEnum = {}));
})(Channel = exports.Channel || (exports.Channel = {}));
exports.Channel = Channel;
var ChannelStoreMapping = (function () {
    function ChannelStoreMapping() {
    }
    ChannelStoreMapping.getAttributeTypeMap = function () {
        return ChannelStoreMapping.attributeTypeMap;
    };
    ChannelStoreMapping.discriminator = undefined;
    ChannelStoreMapping.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "ChannelStoreId",
            "baseName": "ChannelStoreId",
            "type": "string"
        }
    ];
    return ChannelStoreMapping;
}());
exports.ChannelStoreMapping = ChannelStoreMapping;
var ChargebackDetails = (function () {
    function ChargebackDetails() {
    }
    ChargebackDetails.getAttributeTypeMap = function () {
        return ChargebackDetails.attributeTypeMap;
    };
    ChargebackDetails.discriminator = undefined;
    ChargebackDetails.attributeTypeMap = [
        {
            "name": "ChargebackAmount",
            "baseName": "ChargebackAmount",
            "type": "number"
        },
        {
            "name": "PosSalesChargebackAmount",
            "baseName": "PosSalesChargebackAmount",
            "type": "number"
        },
        {
            "name": "ChargebackRefundedFees",
            "baseName": "ChargebackRefundedFees",
            "type": "number"
        },
        {
            "name": "ChargebacksCount",
            "baseName": "ChargebacksCount",
            "type": "number"
        },
        {
            "name": "TotalChargebackCost",
            "baseName": "TotalChargebackCost",
            "type": "number"
        }
    ];
    return ChargebackDetails;
}());
exports.ChargebackDetails = ChargebackDetails;
var ClientDevice = (function () {
    function ClientDevice() {
    }
    ClientDevice.getAttributeTypeMap = function () {
        return ClientDevice.attributeTypeMap;
    };
    ClientDevice.discriminator = undefined;
    ClientDevice.attributeTypeMap = [
        {
            "name": "DeviceModel",
            "baseName": "DeviceModel",
            "type": "string"
        },
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "DeviceName",
            "baseName": "DeviceName",
            "type": "string"
        }
    ];
    return ClientDevice;
}());
exports.ClientDevice = ClientDevice;
var ClientDeviceAssignEnrolledDevice = (function () {
    function ClientDeviceAssignEnrolledDevice() {
    }
    ClientDeviceAssignEnrolledDevice.getAttributeTypeMap = function () {
        return ClientDeviceAssignEnrolledDevice.attributeTypeMap;
    };
    ClientDeviceAssignEnrolledDevice.discriminator = undefined;
    ClientDeviceAssignEnrolledDevice.attributeTypeMap = [
        {
            "name": "DeviceModel",
            "baseName": "DeviceModel",
            "type": "string"
        },
        {
            "name": "PinCode",
            "baseName": "PinCode",
            "type": "string"
        }
    ];
    return ClientDeviceAssignEnrolledDevice;
}());
exports.ClientDeviceAssignEnrolledDevice = ClientDeviceAssignEnrolledDevice;
var ClientDeviceEnroll = (function () {
    function ClientDeviceEnroll() {
    }
    ClientDeviceEnroll.getAttributeTypeMap = function () {
        return ClientDeviceEnroll.attributeTypeMap;
    };
    ClientDeviceEnroll.discriminator = undefined;
    ClientDeviceEnroll.attributeTypeMap = [
        {
            "name": "DeviceModel",
            "baseName": "DeviceModel",
            "type": "string"
        },
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "DeviceName",
            "baseName": "DeviceName",
            "type": "string"
        }
    ];
    return ClientDeviceEnroll;
}());
exports.ClientDeviceEnroll = ClientDeviceEnroll;
var ClientDeviceEnrollmentResult = (function () {
    function ClientDeviceEnrollmentResult() {
    }
    ClientDeviceEnrollmentResult.getAttributeTypeMap = function () {
        return ClientDeviceEnrollmentResult.attributeTypeMap;
    };
    ClientDeviceEnrollmentResult.discriminator = undefined;
    ClientDeviceEnrollmentResult.attributeTypeMap = [
        {
            "name": "PinCode",
            "baseName": "PinCode",
            "type": "string"
        }
    ];
    return ClientDeviceEnrollmentResult;
}());
exports.ClientDeviceEnrollmentResult = ClientDeviceEnrollmentResult;
var ClientDeviceSummary = (function () {
    function ClientDeviceSummary() {
    }
    ClientDeviceSummary.getAttributeTypeMap = function () {
        return ClientDeviceSummary.attributeTypeMap;
    };
    ClientDeviceSummary.discriminator = undefined;
    ClientDeviceSummary.attributeTypeMap = [
        {
            "name": "DeviceModel",
            "baseName": "DeviceModel",
            "type": "string"
        },
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "DeviceName",
            "baseName": "DeviceName",
            "type": "string"
        }
    ];
    return ClientDeviceSummary;
}());
exports.ClientDeviceSummary = ClientDeviceSummary;
var ConfiguredStore = (function () {
    function ConfiguredStore() {
    }
    ConfiguredStore.getAttributeTypeMap = function () {
        return ConfiguredStore.attributeTypeMap;
    };
    ConfiguredStore.discriminator = undefined;
    ConfiguredStore.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return ConfiguredStore;
}());
exports.ConfiguredStore = ConfiguredStore;
var Contact = (function () {
    function Contact() {
    }
    Contact.getAttributeTypeMap = function () {
        return Contact.attributeTypeMap;
    };
    Contact.discriminator = undefined;
    Contact.attributeTypeMap = [
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        },
        {
            "name": "FirstName",
            "baseName": "FirstName",
            "type": "string"
        },
        {
            "name": "LastName",
            "baseName": "LastName",
            "type": "string"
        }
    ];
    return Contact;
}());
exports.Contact = Contact;
var Coordinates = (function () {
    function Coordinates() {
    }
    Coordinates.getAttributeTypeMap = function () {
        return Coordinates.attributeTypeMap;
    };
    Coordinates.discriminator = undefined;
    Coordinates.attributeTypeMap = [
        {
            "name": "Latitude",
            "baseName": "Latitude",
            "type": "number"
        },
        {
            "name": "Longitude",
            "baseName": "Longitude",
            "type": "number"
        }
    ];
    return Coordinates;
}());
exports.Coordinates = Coordinates;
var CoordinatesDm = (function () {
    function CoordinatesDm() {
    }
    CoordinatesDm.getAttributeTypeMap = function () {
        return CoordinatesDm.attributeTypeMap;
    };
    CoordinatesDm.discriminator = undefined;
    CoordinatesDm.attributeTypeMap = [
        {
            "name": "Latitude",
            "baseName": "Latitude",
            "type": "number"
        },
        {
            "name": "Longitude",
            "baseName": "Longitude",
            "type": "number"
        }
    ];
    return CoordinatesDm;
}());
exports.CoordinatesDm = CoordinatesDm;
var CountryFormResponse = (function () {
    function CountryFormResponse() {
    }
    CountryFormResponse.getAttributeTypeMap = function () {
        return CountryFormResponse.attributeTypeMap;
    };
    CountryFormResponse.discriminator = undefined;
    CountryFormResponse.attributeTypeMap = [
        {
            "name": "Value",
            "baseName": "Value",
            "type": "string"
        },
        {
            "name": "Label",
            "baseName": "Label",
            "type": "string"
        }
    ];
    return CountryFormResponse;
}());
exports.CountryFormResponse = CountryFormResponse;
var CountryWithAccountFieldsDefinitions = (function () {
    function CountryWithAccountFieldsDefinitions() {
    }
    CountryWithAccountFieldsDefinitions.getAttributeTypeMap = function () {
        return CountryWithAccountFieldsDefinitions.attributeTypeMap;
    };
    CountryWithAccountFieldsDefinitions.discriminator = undefined;
    CountryWithAccountFieldsDefinitions.attributeTypeMap = [
        {
            "name": "CountryCode",
            "baseName": "CountryCode",
            "type": "string"
        },
        {
            "name": "DisplayName",
            "baseName": "DisplayName",
            "type": "string"
        },
        {
            "name": "SupportType",
            "baseName": "SupportType",
            "type": "string"
        },
        {
            "name": "FieldDefinitions",
            "baseName": "FieldDefinitions",
            "type": "Array<AccountFieldDefinition>"
        }
    ];
    return CountryWithAccountFieldsDefinitions;
}());
exports.CountryWithAccountFieldsDefinitions = CountryWithAccountFieldsDefinitions;
var CreateAccountModel = (function () {
    function CreateAccountModel() {
    }
    CreateAccountModel.getAttributeTypeMap = function () {
        return CreateAccountModel.attributeTypeMap;
    };
    CreateAccountModel.discriminator = undefined;
    CreateAccountModel.attributeTypeMap = [
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        },
        {
            "name": "LanguageId",
            "baseName": "LanguageId",
            "type": "string"
        },
        {
            "name": "Rid",
            "baseName": "Rid",
            "type": "number"
        },
        {
            "name": "Cid",
            "baseName": "Cid",
            "type": "string"
        },
        {
            "name": "RecaptchaToken",
            "baseName": "RecaptchaToken",
            "type": "string"
        }
    ];
    return CreateAccountModel;
}());
exports.CreateAccountModel = CreateAccountModel;
var CreateAppStoreApp = (function () {
    function CreateAppStoreApp() {
    }
    CreateAppStoreApp.getAttributeTypeMap = function () {
        return CreateAppStoreApp.attributeTypeMap;
    };
    CreateAppStoreApp.discriminator = undefined;
    CreateAppStoreApp.attributeTypeMap = [
        {
            "name": "Details",
            "baseName": "Details",
            "type": "string"
        },
        {
            "name": "ConfigurationType",
            "baseName": "ConfigurationType",
            "type": "CreateAppStoreApp.ConfigurationTypeEnum"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "CreateAppStoreApp.StoreSelectorTypeEnum"
        },
        {
            "name": "FieldGroups",
            "baseName": "FieldGroups",
            "type": "Array<FieldGroup>"
        },
        {
            "name": "SetupInstructions",
            "baseName": "SetupInstructions",
            "type": "string"
        },
        {
            "name": "ExternalSetupLink",
            "baseName": "ExternalSetupLink",
            "type": "string"
        },
        {
            "name": "TeammateAppAccessLevel",
            "baseName": "TeammateAppAccessLevel",
            "type": "CreateAppStoreApp.TeammateAppAccessLevelEnum"
        },
        {
            "name": "PermissionsType",
            "baseName": "PermissionsType",
            "type": "CreateAppStoreApp.PermissionsTypeEnum"
        },
        {
            "name": "Support",
            "baseName": "Support",
            "type": "AppStoreAppSupportInfo"
        },
        {
            "name": "ExternalFunctionActionUrl",
            "baseName": "ExternalFunctionActionUrl",
            "type": "string"
        },
        {
            "name": "ExternalFunctionSignatureKey",
            "baseName": "ExternalFunctionSignatureKey",
            "type": "string"
        },
        {
            "name": "IsPaid",
            "baseName": "IsPaid",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "Categories",
            "baseName": "Categories",
            "type": "Array<CreateAppStoreApp.CategoriesEnum>"
        },
        {
            "name": "Countries",
            "baseName": "Countries",
            "type": "Array<CreateAppStoreApp.CountriesEnum>"
        },
        {
            "name": "DeveloperName",
            "baseName": "DeveloperName",
            "type": "string"
        }
    ];
    return CreateAppStoreApp;
}());
exports.CreateAppStoreApp = CreateAppStoreApp;
(function (CreateAppStoreApp) {
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = CreateAppStoreApp.ConfigurationTypeEnum || (CreateAppStoreApp.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = CreateAppStoreApp.StoreSelectorTypeEnum || (CreateAppStoreApp.StoreSelectorTypeEnum = {}));
    var TeammateAppAccessLevelEnum;
    (function (TeammateAppAccessLevelEnum) {
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
    })(TeammateAppAccessLevelEnum = CreateAppStoreApp.TeammateAppAccessLevelEnum || (CreateAppStoreApp.TeammateAppAccessLevelEnum = {}));
    var PermissionsTypeEnum;
    (function (PermissionsTypeEnum) {
        PermissionsTypeEnum[PermissionsTypeEnum["Teammate"] = 'Teammate'] = "Teammate";
    })(PermissionsTypeEnum = CreateAppStoreApp.PermissionsTypeEnum || (CreateAppStoreApp.PermissionsTypeEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = CreateAppStoreApp.CategoriesEnum || (CreateAppStoreApp.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = CreateAppStoreApp.CountriesEnum || (CreateAppStoreApp.CountriesEnum = {}));
})(CreateAppStoreApp = exports.CreateAppStoreApp || (exports.CreateAppStoreApp = {}));
exports.CreateAppStoreApp = CreateAppStoreApp;
var CreateBasicAccountModel = (function () {
    function CreateBasicAccountModel() {
    }
    CreateBasicAccountModel.getAttributeTypeMap = function () {
        return CreateBasicAccountModel.attributeTypeMap;
    };
    CreateBasicAccountModel.discriminator = undefined;
    CreateBasicAccountModel.attributeTypeMap = [
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        },
        {
            "name": "LanguageId",
            "baseName": "LanguageId",
            "type": "string"
        },
        {
            "name": "OpportunityId",
            "baseName": "OpportunityId",
            "type": "string"
        }
    ];
    return CreateBasicAccountModel;
}());
exports.CreateBasicAccountModel = CreateBasicAccountModel;
var CreateCatalogGroupReference = (function () {
    function CreateCatalogGroupReference() {
    }
    CreateCatalogGroupReference.getAttributeTypeMap = function () {
        return CreateCatalogGroupReference.attributeTypeMap;
    };
    CreateCatalogGroupReference.discriminator = undefined;
    CreateCatalogGroupReference.attributeTypeMap = [
        {
            "name": "CatalogGroupId",
            "baseName": "CatalogGroupId",
            "type": "string"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "GroupType",
            "baseName": "GroupType",
            "type": "CreateCatalogGroupReference.GroupTypeEnum"
        }
    ];
    return CreateCatalogGroupReference;
}());
exports.CreateCatalogGroupReference = CreateCatalogGroupReference;
(function (CreateCatalogGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = CreateCatalogGroupReference.GroupTypeEnum || (CreateCatalogGroupReference.GroupTypeEnum = {}));
})(CreateCatalogGroupReference = exports.CreateCatalogGroupReference || (exports.CreateCatalogGroupReference = {}));
exports.CreateCatalogGroupReference = CreateCatalogGroupReference;
var CreateCatalogItem = (function () {
    function CreateCatalogItem() {
    }
    CreateCatalogItem.getAttributeTypeMap = function () {
        return CreateCatalogItem.attributeTypeMap;
    };
    CreateCatalogItem.discriminator = undefined;
    CreateCatalogItem.attributeTypeMap = [
        {
            "name": "Groups",
            "baseName": "Groups",
            "type": "Array<CreateCatalogGroupReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        },
        {
            "name": "ItemType",
            "baseName": "ItemType",
            "type": "CreateCatalogItem.ItemTypeEnum"
        },
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        }
    ];
    return CreateCatalogItem;
}());
exports.CreateCatalogItem = CreateCatalogItem;
(function (CreateCatalogItem) {
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum[ItemTypeEnum["Product"] = 'Product'] = "Product";
        ItemTypeEnum[ItemTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ItemTypeEnum = CreateCatalogItem.ItemTypeEnum || (CreateCatalogItem.ItemTypeEnum = {}));
})(CreateCatalogItem = exports.CreateCatalogItem || (exports.CreateCatalogItem = {}));
exports.CreateCatalogItem = CreateCatalogItem;
var CreateFulfillmentStatesConfiguration = (function () {
    function CreateFulfillmentStatesConfiguration() {
    }
    CreateFulfillmentStatesConfiguration.getAttributeTypeMap = function () {
        return CreateFulfillmentStatesConfiguration.attributeTypeMap;
    };
    CreateFulfillmentStatesConfiguration.discriminator = undefined;
    CreateFulfillmentStatesConfiguration.attributeTypeMap = [
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "CreateFulfillmentStatesConfiguration.StoreSelectorTypeEnum"
        },
        {
            "name": "States",
            "baseName": "States",
            "type": "Array<FulfillmentStatusConfigurationItem>"
        },
        {
            "name": "AutomaticTransitionsEnabled",
            "baseName": "AutomaticTransitionsEnabled",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return CreateFulfillmentStatesConfiguration;
}());
exports.CreateFulfillmentStatesConfiguration = CreateFulfillmentStatesConfiguration;
(function (CreateFulfillmentStatesConfiguration) {
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = CreateFulfillmentStatesConfiguration.StoreSelectorTypeEnum || (CreateFulfillmentStatesConfiguration.StoreSelectorTypeEnum = {}));
})(CreateFulfillmentStatesConfiguration = exports.CreateFulfillmentStatesConfiguration || (exports.CreateFulfillmentStatesConfiguration = {}));
exports.CreateFulfillmentStatesConfiguration = CreateFulfillmentStatesConfiguration;
var CreateFullMenu = (function () {
    function CreateFullMenu() {
    }
    CreateFullMenu.getAttributeTypeMap = function () {
        return CreateFullMenu.attributeTypeMap;
    };
    CreateFullMenu.discriminator = undefined;
    CreateFullMenu.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        },
        {
            "name": "MenuSections",
            "baseName": "MenuSections",
            "type": "Array<CreateFullMenuSection>"
        },
        {
            "name": "TaxRates",
            "baseName": "TaxRates",
            "type": "Array<CreateMenuTaxRate>"
        },
        {
            "name": "DisplaySectionLinks",
            "baseName": "DisplaySectionLinks",
            "type": "boolean"
        },
        {
            "name": "MenuSectionBehaviour",
            "baseName": "MenuSectionBehaviour",
            "type": "CreateFullMenu.MenuSectionBehaviourEnum"
        },
        {
            "name": "TaxType",
            "baseName": "TaxType",
            "type": "CreateFullMenu.TaxTypeEnum"
        }
    ];
    return CreateFullMenu;
}());
exports.CreateFullMenu = CreateFullMenu;
(function (CreateFullMenu) {
    var MenuSectionBehaviourEnum;
    (function (MenuSectionBehaviourEnum) {
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandSingle"] = 'ExpandSingle'] = "ExpandSingle";
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandMultiple"] = 'ExpandMultiple'] = "ExpandMultiple";
    })(MenuSectionBehaviourEnum = CreateFullMenu.MenuSectionBehaviourEnum || (CreateFullMenu.MenuSectionBehaviourEnum = {}));
    var TaxTypeEnum;
    (function (TaxTypeEnum) {
        TaxTypeEnum[TaxTypeEnum["IncludedInBasePrice"] = 'IncludedInBasePrice'] = "IncludedInBasePrice";
        TaxTypeEnum[TaxTypeEnum["ExcludedFromBasePrice"] = 'ExcludedFromBasePrice'] = "ExcludedFromBasePrice";
    })(TaxTypeEnum = CreateFullMenu.TaxTypeEnum || (CreateFullMenu.TaxTypeEnum = {}));
})(CreateFullMenu = exports.CreateFullMenu || (exports.CreateFullMenu = {}));
exports.CreateFullMenu = CreateFullMenu;
var CreateFullMenuItemOptionSet = (function () {
    function CreateFullMenuItemOptionSet() {
    }
    CreateFullMenuItemOptionSet.getAttributeTypeMap = function () {
        return CreateFullMenuItemOptionSet.attributeTypeMap;
    };
    CreateFullMenuItemOptionSet.discriminator = undefined;
    CreateFullMenuItemOptionSet.attributeTypeMap = [
        {
            "name": "MenuItemOptionSetId",
            "baseName": "MenuItemOptionSetId",
            "type": "number"
        },
        {
            "name": "MenuItemOptionSetItems",
            "baseName": "MenuItemOptionSetItems",
            "type": "Array<CreateFullMenuItemOptionSetItem>"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "IsMasterOptionSet",
            "baseName": "IsMasterOptionSet",
            "type": "boolean"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "MinSelectCount",
            "baseName": "MinSelectCount",
            "type": "number"
        },
        {
            "name": "MaxSelectCount",
            "baseName": "MaxSelectCount",
            "type": "number"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "CreateFullMenuItemOptionSet.CellLayoutTypeEnum"
        }
    ];
    return CreateFullMenuItemOptionSet;
}());
exports.CreateFullMenuItemOptionSet = CreateFullMenuItemOptionSet;
(function (CreateFullMenuItemOptionSet) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = CreateFullMenuItemOptionSet.CellLayoutTypeEnum || (CreateFullMenuItemOptionSet.CellLayoutTypeEnum = {}));
})(CreateFullMenuItemOptionSet = exports.CreateFullMenuItemOptionSet || (exports.CreateFullMenuItemOptionSet = {}));
exports.CreateFullMenuItemOptionSet = CreateFullMenuItemOptionSet;
var CreateFullMenuItemOptionSetItem = (function () {
    function CreateFullMenuItemOptionSetItem() {
    }
    CreateFullMenuItemOptionSetItem.getAttributeTypeMap = function () {
        return CreateFullMenuItemOptionSetItem.attributeTypeMap;
    };
    CreateFullMenuItemOptionSetItem.discriminator = undefined;
    CreateFullMenuItemOptionSetItem.attributeTypeMap = [
        {
            "name": "MenuItemOptionSetItemId",
            "baseName": "MenuItemOptionSetItemId",
            "type": "number"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "Array<CreateMetadata>"
        },
        {
            "name": "TaxRateName",
            "baseName": "TaxRateName",
            "type": "string"
        },
        {
            "name": "NextMenuItemOptionSetId",
            "baseName": "NextMenuItemOptionSetId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "CreateFullMenuItemOptionSetItem.CellLayoutTypeEnum"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        }
    ];
    return CreateFullMenuItemOptionSetItem;
}());
exports.CreateFullMenuItemOptionSetItem = CreateFullMenuItemOptionSetItem;
(function (CreateFullMenuItemOptionSetItem) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = CreateFullMenuItemOptionSetItem.CellLayoutTypeEnum || (CreateFullMenuItemOptionSetItem.CellLayoutTypeEnum = {}));
})(CreateFullMenuItemOptionSetItem = exports.CreateFullMenuItemOptionSetItem || (exports.CreateFullMenuItemOptionSetItem = {}));
exports.CreateFullMenuItemOptionSetItem = CreateFullMenuItemOptionSetItem;
var CreateFullMenuSection = (function () {
    function CreateFullMenuSection() {
    }
    CreateFullMenuSection.getAttributeTypeMap = function () {
        return CreateFullMenuSection.attributeTypeMap;
    };
    CreateFullMenuSection.discriminator = undefined;
    CreateFullMenuSection.attributeTypeMap = [
        {
            "name": "MenuSectionAvailability",
            "baseName": "MenuSectionAvailability",
            "type": "MenuSectionAvailability"
        },
        {
            "name": "MenuItems",
            "baseName": "MenuItems",
            "type": "Array<CreateFullMenuSectionItem>"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "IsHiddenFromCustomers",
            "baseName": "IsHiddenFromCustomers",
            "type": "boolean"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        },
        {
            "name": "MenuSectionId",
            "baseName": "MenuSectionId",
            "type": "number"
        }
    ];
    return CreateFullMenuSection;
}());
exports.CreateFullMenuSection = CreateFullMenuSection;
var CreateFullMenuSectionItem = (function () {
    function CreateFullMenuSectionItem() {
    }
    CreateFullMenuSectionItem.getAttributeTypeMap = function () {
        return CreateFullMenuSectionItem.attributeTypeMap;
    };
    CreateFullMenuSectionItem.discriminator = undefined;
    CreateFullMenuSectionItem.attributeTypeMap = [
        {
            "name": "MenuItemOptionSets",
            "baseName": "MenuItemOptionSets",
            "type": "Array<CreateFullMenuItemOptionSet>"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "Array<CreateMetadata>"
        },
        {
            "name": "TaxRateName",
            "baseName": "TaxRateName",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "SpicinessRating",
            "baseName": "SpicinessRating",
            "type": "CreateFullMenuSectionItem.SpicinessRatingEnum"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "CreateFullMenuSectionItem.CellLayoutTypeEnum"
        },
        {
            "name": "DisableVouchers",
            "baseName": "DisableVouchers",
            "type": "boolean"
        },
        {
            "name": "ImageName",
            "baseName": "ImageName",
            "type": "string"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        },
        {
            "name": "MenuItemId",
            "baseName": "MenuItemId",
            "type": "number"
        }
    ];
    return CreateFullMenuSectionItem;
}());
exports.CreateFullMenuSectionItem = CreateFullMenuSectionItem;
(function (CreateFullMenuSectionItem) {
    var SpicinessRatingEnum;
    (function (SpicinessRatingEnum) {
        SpicinessRatingEnum[SpicinessRatingEnum["NotRated"] = 'NotRated'] = "NotRated";
        SpicinessRatingEnum[SpicinessRatingEnum["Mild"] = 'Mild'] = "Mild";
        SpicinessRatingEnum[SpicinessRatingEnum["Medium"] = 'Medium'] = "Medium";
        SpicinessRatingEnum[SpicinessRatingEnum["Hot"] = 'Hot'] = "Hot";
    })(SpicinessRatingEnum = CreateFullMenuSectionItem.SpicinessRatingEnum || (CreateFullMenuSectionItem.SpicinessRatingEnum = {}));
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = CreateFullMenuSectionItem.CellLayoutTypeEnum || (CreateFullMenuSectionItem.CellLayoutTypeEnum = {}));
})(CreateFullMenuSectionItem = exports.CreateFullMenuSectionItem || (exports.CreateFullMenuSectionItem = {}));
exports.CreateFullMenuSectionItem = CreateFullMenuSectionItem;
var CreateGroup = (function () {
    function CreateGroup() {
    }
    CreateGroup.getAttributeTypeMap = function () {
        return CreateGroup.attributeTypeMap;
    };
    CreateGroup.discriminator = undefined;
    CreateGroup.attributeTypeMap = [
        {
            "name": "MinSelectCount",
            "baseName": "MinSelectCount",
            "type": "number"
        },
        {
            "name": "MaxSelectCount",
            "baseName": "MaxSelectCount",
            "type": "number"
        },
        {
            "name": "Products",
            "baseName": "Products",
            "type": "Array<CreateProductReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        },
        {
            "name": "GroupType",
            "baseName": "GroupType",
            "type": "CreateGroup.GroupTypeEnum"
        },
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "AutogenerateDisplayText",
            "baseName": "AutogenerateDisplayText",
            "type": "boolean"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        }
    ];
    return CreateGroup;
}());
exports.CreateGroup = CreateGroup;
(function (CreateGroup) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = CreateGroup.GroupTypeEnum || (CreateGroup.GroupTypeEnum = {}));
})(CreateGroup = exports.CreateGroup || (exports.CreateGroup = {}));
exports.CreateGroup = CreateGroup;
var CreateGroupReference = (function () {
    function CreateGroupReference() {
    }
    CreateGroupReference.getAttributeTypeMap = function () {
        return CreateGroupReference.attributeTypeMap;
    };
    CreateGroupReference.discriminator = undefined;
    CreateGroupReference.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "GroupType",
            "baseName": "GroupType",
            "type": "CreateGroupReference.GroupTypeEnum"
        }
    ];
    return CreateGroupReference;
}());
exports.CreateGroupReference = CreateGroupReference;
(function (CreateGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = CreateGroupReference.GroupTypeEnum || (CreateGroupReference.GroupTypeEnum = {}));
})(CreateGroupReference = exports.CreateGroupReference || (exports.CreateGroupReference = {}));
exports.CreateGroupReference = CreateGroupReference;
var CreateLocation = (function () {
    function CreateLocation() {
    }
    CreateLocation.getAttributeTypeMap = function () {
        return CreateLocation.attributeTypeMap;
    };
    CreateLocation.discriminator = undefined;
    CreateLocation.attributeTypeMap = [
        {
            "name": "LocationId",
            "baseName": "LocationId",
            "type": "number"
        },
        {
            "name": "LocationName",
            "baseName": "LocationName",
            "type": "string"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "ExternalLocationId",
            "baseName": "ExternalLocationId",
            "type": "string"
        }
    ];
    return CreateLocation;
}());
exports.CreateLocation = CreateLocation;
var CreateLocationArea = (function () {
    function CreateLocationArea() {
    }
    CreateLocationArea.getAttributeTypeMap = function () {
        return CreateLocationArea.attributeTypeMap;
    };
    CreateLocationArea.discriminator = undefined;
    CreateLocationArea.attributeTypeMap = [
        {
            "name": "LocationAreaName",
            "baseName": "LocationAreaName",
            "type": "string"
        }
    ];
    return CreateLocationArea;
}());
exports.CreateLocationArea = CreateLocationArea;
var CreateMenuSectionItemFromCatalogItems = (function () {
    function CreateMenuSectionItemFromCatalogItems() {
    }
    CreateMenuSectionItemFromCatalogItems.getAttributeTypeMap = function () {
        return CreateMenuSectionItemFromCatalogItems.attributeTypeMap;
    };
    CreateMenuSectionItemFromCatalogItems.discriminator = undefined;
    CreateMenuSectionItemFromCatalogItems.attributeTypeMap = [
        {
            "name": "MenuCatalogItems",
            "baseName": "MenuCatalogItems",
            "type": "Array<MenuCatalogItem>"
        }
    ];
    return CreateMenuSectionItemFromCatalogItems;
}());
exports.CreateMenuSectionItemFromCatalogItems = CreateMenuSectionItemFromCatalogItems;
var CreateMenuTaxRate = (function () {
    function CreateMenuTaxRate() {
    }
    CreateMenuTaxRate.getAttributeTypeMap = function () {
        return CreateMenuTaxRate.attributeTypeMap;
    };
    CreateMenuTaxRate.discriminator = undefined;
    CreateMenuTaxRate.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Rate",
            "baseName": "Rate",
            "type": "number"
        }
    ];
    return CreateMenuTaxRate;
}());
exports.CreateMenuTaxRate = CreateMenuTaxRate;
var CreateMetadata = (function () {
    function CreateMetadata() {
    }
    CreateMetadata.getAttributeTypeMap = function () {
        return CreateMetadata.attributeTypeMap;
    };
    CreateMetadata.discriminator = undefined;
    CreateMetadata.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "string"
        }
    ];
    return CreateMetadata;
}());
exports.CreateMetadata = CreateMetadata;
var CreateMetafieldDefinition = (function () {
    function CreateMetafieldDefinition() {
    }
    CreateMetafieldDefinition.getAttributeTypeMap = function () {
        return CreateMetafieldDefinition.attributeTypeMap;
    };
    CreateMetafieldDefinition.discriminator = undefined;
    CreateMetafieldDefinition.attributeTypeMap = [
        {
            "name": "IsReadOnly",
            "baseName": "IsReadOnly",
            "type": "boolean"
        },
        {
            "name": "OwnerEntity",
            "baseName": "OwnerEntity",
            "type": "CreateMetafieldDefinition.OwnerEntityEnum"
        },
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "ValueType",
            "baseName": "ValueType",
            "type": "CreateMetafieldDefinition.ValueTypeEnum"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Behaviors",
            "baseName": "Behaviors",
            "type": "Array<CreateMetafieldDefinition.BehaviorsEnum>"
        },
        {
            "name": "MetafieldDefinitionRecommendationId",
            "baseName": "MetafieldDefinitionRecommendationId",
            "type": "number"
        }
    ];
    return CreateMetafieldDefinition;
}());
exports.CreateMetafieldDefinition = CreateMetafieldDefinition;
(function (CreateMetafieldDefinition) {
    var OwnerEntityEnum;
    (function (OwnerEntityEnum) {
        OwnerEntityEnum[OwnerEntityEnum["CatalogItem"] = 'CatalogItem'] = "CatalogItem";
        OwnerEntityEnum[OwnerEntityEnum["CatalogGroup"] = 'CatalogGroup'] = "CatalogGroup";
        OwnerEntityEnum[OwnerEntityEnum["Menu"] = 'Menu'] = "Menu";
    })(OwnerEntityEnum = CreateMetafieldDefinition.OwnerEntityEnum || (CreateMetafieldDefinition.OwnerEntityEnum = {}));
    var ValueTypeEnum;
    (function (ValueTypeEnum) {
        ValueTypeEnum[ValueTypeEnum["Boolean"] = 'Boolean'] = "Boolean";
        ValueTypeEnum[ValueTypeEnum["Json"] = 'Json'] = "Json";
        ValueTypeEnum[ValueTypeEnum["SingleLineString"] = 'SingleLineString'] = "SingleLineString";
        ValueTypeEnum[ValueTypeEnum["MultiLineString"] = 'MultiLineString'] = "MultiLineString";
    })(ValueTypeEnum = CreateMetafieldDefinition.ValueTypeEnum || (CreateMetafieldDefinition.ValueTypeEnum = {}));
    var BehaviorsEnum;
    (function (BehaviorsEnum) {
        BehaviorsEnum[BehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        BehaviorsEnum[BehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(BehaviorsEnum = CreateMetafieldDefinition.BehaviorsEnum || (CreateMetafieldDefinition.BehaviorsEnum = {}));
})(CreateMetafieldDefinition = exports.CreateMetafieldDefinition || (exports.CreateMetafieldDefinition = {}));
exports.CreateMetafieldDefinition = CreateMetafieldDefinition;
var CreateOrderRequest = (function () {
    function CreateOrderRequest() {
    }
    CreateOrderRequest.getAttributeTypeMap = function () {
        return CreateOrderRequest.attributeTypeMap;
    };
    CreateOrderRequest.discriminator = undefined;
    CreateOrderRequest.attributeTypeMap = [
        {
            "name": "LegacyOrderDm",
            "baseName": "LegacyOrderDm",
            "type": "OrderDm"
        },
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        },
        {
            "name": "DeliveryLocation",
            "baseName": "DeliveryLocation",
            "type": "DeliveryLocation"
        }
    ];
    return CreateOrderRequest;
}());
exports.CreateOrderRequest = CreateOrderRequest;
var CreatePayGreenConfigurationRequest = (function () {
    function CreatePayGreenConfigurationRequest() {
    }
    CreatePayGreenConfigurationRequest.getAttributeTypeMap = function () {
        return CreatePayGreenConfigurationRequest.attributeTypeMap;
    };
    CreatePayGreenConfigurationRequest.discriminator = undefined;
    CreatePayGreenConfigurationRequest.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "PayGreenId",
            "baseName": "PayGreenId",
            "type": "string"
        },
        {
            "name": "PayGreenPrivateKey",
            "baseName": "PayGreenPrivateKey",
            "type": "string"
        },
        {
            "name": "AssignedStores",
            "baseName": "AssignedStores",
            "type": "Array<number>"
        }
    ];
    return CreatePayGreenConfigurationRequest;
}());
exports.CreatePayGreenConfigurationRequest = CreatePayGreenConfigurationRequest;
var CreateProduct = (function () {
    function CreateProduct() {
    }
    CreateProduct.getAttributeTypeMap = function () {
        return CreateProduct.attributeTypeMap;
    };
    CreateProduct.discriminator = undefined;
    CreateProduct.attributeTypeMap = [
        {
            "name": "Groups",
            "baseName": "Groups",
            "type": "Array<CreateGroupReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        },
        {
            "name": "ProductType",
            "baseName": "ProductType",
            "type": "CreateProduct.ProductTypeEnum"
        },
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        }
    ];
    return CreateProduct;
}());
exports.CreateProduct = CreateProduct;
(function (CreateProduct) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = CreateProduct.ProductTypeEnum || (CreateProduct.ProductTypeEnum = {}));
})(CreateProduct = exports.CreateProduct || (exports.CreateProduct = {}));
exports.CreateProduct = CreateProduct;
var CreateProductReference = (function () {
    function CreateProductReference() {
    }
    CreateProductReference.getAttributeTypeMap = function () {
        return CreateProductReference.attributeTypeMap;
    };
    CreateProductReference.discriminator = undefined;
    CreateProductReference.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "ProductType",
            "baseName": "ProductType",
            "type": "CreateProductReference.ProductTypeEnum"
        },
        {
            "name": "PreselectedQuantity",
            "baseName": "PreselectedQuantity",
            "type": "number"
        }
    ];
    return CreateProductReference;
}());
exports.CreateProductReference = CreateProductReference;
(function (CreateProductReference) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = CreateProductReference.ProductTypeEnum || (CreateProductReference.ProductTypeEnum = {}));
})(CreateProductReference = exports.CreateProductReference || (exports.CreateProductReference = {}));
exports.CreateProductReference = CreateProductReference;
var CreateTeammate = (function () {
    function CreateTeammate() {
    }
    CreateTeammate.getAttributeTypeMap = function () {
        return CreateTeammate.attributeTypeMap;
    };
    CreateTeammate.discriminator = undefined;
    CreateTeammate.attributeTypeMap = [
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "AppAccessLevel",
            "baseName": "AppAccessLevel",
            "type": "CreateTeammate.AppAccessLevelEnum"
        },
        {
            "name": "HasAccessToAllStores",
            "baseName": "HasAccessToAllStores",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        }
    ];
    return CreateTeammate;
}());
exports.CreateTeammate = CreateTeammate;
(function (CreateTeammate) {
    var AppAccessLevelEnum;
    (function (AppAccessLevelEnum) {
        AppAccessLevelEnum[AppAccessLevelEnum["None"] = 'None'] = "None";
        AppAccessLevelEnum[AppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        AppAccessLevelEnum[AppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
        AppAccessLevelEnum[AppAccessLevelEnum["Support"] = 'Support'] = "Support";
    })(AppAccessLevelEnum = CreateTeammate.AppAccessLevelEnum || (CreateTeammate.AppAccessLevelEnum = {}));
})(CreateTeammate = exports.CreateTeammate || (exports.CreateTeammate = {}));
exports.CreateTeammate = CreateTeammate;
var CreateVoucher = (function () {
    function CreateVoucher() {
    }
    CreateVoucher.getAttributeTypeMap = function () {
        return CreateVoucher.attributeTypeMap;
    };
    CreateVoucher.discriminator = undefined;
    CreateVoucher.attributeTypeMap = [
        {
            "name": "VoucherType",
            "baseName": "VoucherType",
            "type": "CreateVoucher.VoucherTypeEnum"
        },
        {
            "name": "AddItemDetails",
            "baseName": "AddItemDetails",
            "type": "AddItemDetails"
        },
        {
            "name": "CreditNoteDetails",
            "baseName": "CreditNoteDetails",
            "type": "CreditNoteDetails"
        },
        {
            "name": "LumpDiscountDetails",
            "baseName": "LumpDiscountDetails",
            "type": "LumpDiscountDetails"
        },
        {
            "name": "PercentDiscountDetails",
            "baseName": "PercentDiscountDetails",
            "type": "PercentDiscountDetails"
        },
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<number>"
        },
        {
            "name": "ValidOnOrdersOver",
            "baseName": "ValidOnOrdersOver",
            "type": "number"
        },
        {
            "name": "TakesPriority",
            "baseName": "TakesPriority",
            "type": "boolean"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "IsAutomaticallyApplied",
            "baseName": "IsAutomaticallyApplied",
            "type": "boolean"
        },
        {
            "name": "IncludeDeliveryFee",
            "baseName": "IncludeDeliveryFee",
            "type": "boolean"
        },
        {
            "name": "IsValidForDeliveryOrders",
            "baseName": "IsValidForDeliveryOrders",
            "type": "boolean"
        },
        {
            "name": "IsValidForPickupOrders",
            "baseName": "IsValidForPickupOrders",
            "type": "boolean"
        },
        {
            "name": "IsValidForOrdersPayedOnline",
            "baseName": "IsValidForOrdersPayedOnline",
            "type": "boolean"
        },
        {
            "name": "IsValidForOrdersPayedByCash",
            "baseName": "IsValidForOrdersPayedByCash",
            "type": "boolean"
        },
        {
            "name": "IsValidForFirstOrderOnly",
            "baseName": "IsValidForFirstOrderOnly",
            "type": "boolean"
        },
        {
            "name": "IsValidOncePerCustomer",
            "baseName": "IsValidOncePerCustomer",
            "type": "boolean"
        },
        {
            "name": "IsValidOnlyOnce",
            "baseName": "IsValidOnlyOnce",
            "type": "boolean"
        },
        {
            "name": "StartDate",
            "baseName": "StartDate",
            "type": "Date"
        },
        {
            "name": "ExpiryDate",
            "baseName": "ExpiryDate",
            "type": "Date"
        }
    ];
    return CreateVoucher;
}());
exports.CreateVoucher = CreateVoucher;
(function (CreateVoucher) {
    var VoucherTypeEnum;
    (function (VoucherTypeEnum) {
        VoucherTypeEnum[VoucherTypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        VoucherTypeEnum[VoucherTypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        VoucherTypeEnum[VoucherTypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        VoucherTypeEnum[VoucherTypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
    })(VoucherTypeEnum = CreateVoucher.VoucherTypeEnum || (CreateVoucher.VoucherTypeEnum = {}));
})(CreateVoucher = exports.CreateVoucher || (exports.CreateVoucher = {}));
exports.CreateVoucher = CreateVoucher;
var CreatedMenuSectionItems = (function () {
    function CreatedMenuSectionItems() {
    }
    CreatedMenuSectionItems.getAttributeTypeMap = function () {
        return CreatedMenuSectionItems.attributeTypeMap;
    };
    CreatedMenuSectionItems.discriminator = undefined;
    CreatedMenuSectionItems.attributeTypeMap = [
        {
            "name": "MenuSectionItems",
            "baseName": "MenuSectionItems",
            "type": "Array<MenuSectionItem>"
        }
    ];
    return CreatedMenuSectionItems;
}());
exports.CreatedMenuSectionItems = CreatedMenuSectionItems;
var CreditNoteDetails = (function () {
    function CreditNoteDetails() {
    }
    CreditNoteDetails.getAttributeTypeMap = function () {
        return CreditNoteDetails.attributeTypeMap;
    };
    CreditNoteDetails.discriminator = undefined;
    CreditNoteDetails.attributeTypeMap = [
        {
            "name": "RemainingCredit",
            "baseName": "RemainingCredit",
            "type": "number"
        }
    ];
    return CreditNoteDetails;
}());
exports.CreditNoteDetails = CreditNoteDetails;
var CrossSellMenuItems = (function () {
    function CrossSellMenuItems() {
    }
    CrossSellMenuItems.getAttributeTypeMap = function () {
        return CrossSellMenuItems.attributeTypeMap;
    };
    CrossSellMenuItems.discriminator = undefined;
    CrossSellMenuItems.attributeTypeMap = [
        {
            "name": "MenuItemIds",
            "baseName": "MenuItemIds",
            "type": "Array<number>"
        }
    ];
    return CrossSellMenuItems;
}());
exports.CrossSellMenuItems = CrossSellMenuItems;
var CspReport = (function () {
    function CspReport() {
    }
    CspReport.getAttributeTypeMap = function () {
        return CspReport.attributeTypeMap;
    };
    CspReport.discriminator = undefined;
    CspReport.attributeTypeMap = [
        {
            "name": "Document_uri",
            "baseName": "Document-uri",
            "type": "string"
        },
        {
            "name": "Referrer",
            "baseName": "Referrer",
            "type": "string"
        },
        {
            "name": "Violated_directive",
            "baseName": "Violated-directive",
            "type": "string"
        },
        {
            "name": "Effective_directive",
            "baseName": "Effective-directive",
            "type": "string"
        },
        {
            "name": "Original_policy",
            "baseName": "Original-policy",
            "type": "string"
        },
        {
            "name": "Blocked_uri",
            "baseName": "Blocked-uri",
            "type": "string"
        },
        {
            "name": "Status_code",
            "baseName": "Status-code",
            "type": "number"
        }
    ];
    return CspReport;
}());
exports.CspReport = CspReport;
var CspReportRequest = (function () {
    function CspReportRequest() {
    }
    CspReportRequest.getAttributeTypeMap = function () {
        return CspReportRequest.attributeTypeMap;
    };
    CspReportRequest.discriminator = undefined;
    CspReportRequest.attributeTypeMap = [
        {
            "name": "Csp_report",
            "baseName": "Csp-report",
            "type": "CspReport"
        }
    ];
    return CspReportRequest;
}());
exports.CspReportRequest = CspReportRequest;
var CurrencyData = (function () {
    function CurrencyData() {
    }
    CurrencyData.getAttributeTypeMap = function () {
        return CurrencyData.attributeTypeMap;
    };
    CurrencyData.discriminator = undefined;
    CurrencyData.attributeTypeMap = [
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "CurrencyData.CurrencyEnum"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "number"
        }
    ];
    return CurrencyData;
}());
exports.CurrencyData = CurrencyData;
(function (CurrencyData) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = CurrencyData.CurrencyEnum || (CurrencyData.CurrencyEnum = {}));
})(CurrencyData = exports.CurrencyData || (exports.CurrencyData = {}));
exports.CurrencyData = CurrencyData;
var Customer = (function () {
    function Customer() {
    }
    Customer.getAttributeTypeMap = function () {
        return Customer.attributeTypeMap;
    };
    Customer.discriminator = undefined;
    Customer.attributeTypeMap = [
        {
            "name": "CustomerId",
            "baseName": "CustomerId",
            "type": "number"
        },
        {
            "name": "RegistrationDate",
            "baseName": "RegistrationDate",
            "type": "Date"
        },
        {
            "name": "CashOrdersEnabled",
            "baseName": "CashOrdersEnabled",
            "type": "boolean"
        },
        {
            "name": "CardOrdersEnabled",
            "baseName": "CardOrdersEnabled",
            "type": "boolean"
        },
        {
            "name": "MarketingEnabled",
            "baseName": "MarketingEnabled",
            "type": "boolean"
        }
    ];
    return Customer;
}());
exports.Customer = Customer;
var CustomerConsentUpdatedEvent = (function () {
    function CustomerConsentUpdatedEvent() {
    }
    CustomerConsentUpdatedEvent.getAttributeTypeMap = function () {
        return CustomerConsentUpdatedEvent.attributeTypeMap;
    };
    CustomerConsentUpdatedEvent.discriminator = undefined;
    CustomerConsentUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Enabled",
            "baseName": "Enabled",
            "type": "boolean"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CustomerConsentUpdatedEvent;
}());
exports.CustomerConsentUpdatedEvent = CustomerConsentUpdatedEvent;
var CustomerCreatedEvent = (function () {
    function CustomerCreatedEvent() {
    }
    CustomerCreatedEvent.getAttributeTypeMap = function () {
        return CustomerCreatedEvent.attributeTypeMap;
    };
    CustomerCreatedEvent.discriminator = undefined;
    CustomerCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CustomerCreatedEvent;
}());
exports.CustomerCreatedEvent = CustomerCreatedEvent;
var CustomerDeliveryTrackingOrder = (function () {
    function CustomerDeliveryTrackingOrder() {
    }
    CustomerDeliveryTrackingOrder.getAttributeTypeMap = function () {
        return CustomerDeliveryTrackingOrder.attributeTypeMap;
    };
    CustomerDeliveryTrackingOrder.discriminator = undefined;
    CustomerDeliveryTrackingOrder.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "Address",
            "baseName": "Address",
            "type": "string"
        },
        {
            "name": "DeliveryNotes",
            "baseName": "DeliveryNotes",
            "type": "string"
        },
        {
            "name": "StorePhoneNumber",
            "baseName": "StorePhoneNumber",
            "type": "string"
        },
        {
            "name": "AppIconUrl",
            "baseName": "AppIconUrl",
            "type": "string"
        },
        {
            "name": "OrderTrackingCode",
            "baseName": "OrderTrackingCode",
            "type": "string"
        },
        {
            "name": "PaymentMethodDescription",
            "baseName": "PaymentMethodDescription",
            "type": "string"
        },
        {
            "name": "LastFourDigits",
            "baseName": "LastFourDigits",
            "type": "string"
        },
        {
            "name": "OrderLines",
            "baseName": "OrderLines",
            "type": "Array<CustomerDeliveryTrackingOrderLine>"
        },
        {
            "name": "TotalAmount",
            "baseName": "TotalAmount",
            "type": "number"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "CustomerDeliveryTrackingOrder.CurrencyEnum"
        },
        {
            "name": "Latitude",
            "baseName": "Latitude",
            "type": "number"
        },
        {
            "name": "Longitude",
            "baseName": "Longitude",
            "type": "number"
        },
        {
            "name": "Placed",
            "baseName": "Placed",
            "type": "Date"
        },
        {
            "name": "RequestedFor",
            "baseName": "RequestedFor",
            "type": "Date"
        },
        {
            "name": "DriverId",
            "baseName": "DriverId",
            "type": "number"
        },
        {
            "name": "DriverName",
            "baseName": "DriverName",
            "type": "string"
        },
        {
            "name": "DriverImage",
            "baseName": "DriverImage",
            "type": "string"
        },
        {
            "name": "EstimatedMinutesForDelivery",
            "baseName": "EstimatedMinutesForDelivery",
            "type": "number"
        }
    ];
    return CustomerDeliveryTrackingOrder;
}());
exports.CustomerDeliveryTrackingOrder = CustomerDeliveryTrackingOrder;
(function (CustomerDeliveryTrackingOrder) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = CustomerDeliveryTrackingOrder.CurrencyEnum || (CustomerDeliveryTrackingOrder.CurrencyEnum = {}));
})(CustomerDeliveryTrackingOrder = exports.CustomerDeliveryTrackingOrder || (exports.CustomerDeliveryTrackingOrder = {}));
exports.CustomerDeliveryTrackingOrder = CustomerDeliveryTrackingOrder;
var CustomerDeliveryTrackingOrderLine = (function () {
    function CustomerDeliveryTrackingOrderLine() {
    }
    CustomerDeliveryTrackingOrderLine.getAttributeTypeMap = function () {
        return CustomerDeliveryTrackingOrderLine.attributeTypeMap;
    };
    CustomerDeliveryTrackingOrderLine.discriminator = undefined;
    CustomerDeliveryTrackingOrderLine.attributeTypeMap = [
        {
            "name": "ItemName",
            "baseName": "ItemName",
            "type": "string"
        },
        {
            "name": "SelectedOptions",
            "baseName": "SelectedOptions",
            "type": "Array<string>"
        }
    ];
    return CustomerDeliveryTrackingOrderLine;
}());
exports.CustomerDeliveryTrackingOrderLine = CustomerDeliveryTrackingOrderLine;
var CustomerSummary = (function () {
    function CustomerSummary() {
    }
    CustomerSummary.getAttributeTypeMap = function () {
        return CustomerSummary.attributeTypeMap;
    };
    CustomerSummary.discriminator = undefined;
    CustomerSummary.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "EmailAddress",
            "baseName": "EmailAddress",
            "type": "string"
        },
        {
            "name": "PhoneNumberLocalFormat",
            "baseName": "PhoneNumberLocalFormat",
            "type": "string"
        },
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        }
    ];
    return CustomerSummary;
}());
exports.CustomerSummary = CustomerSummary;
var CustomerUpdateModel = (function () {
    function CustomerUpdateModel() {
    }
    CustomerUpdateModel.getAttributeTypeMap = function () {
        return CustomerUpdateModel.attributeTypeMap;
    };
    CustomerUpdateModel.discriminator = undefined;
    CustomerUpdateModel.attributeTypeMap = [
        {
            "name": "CashOrdersEnabled",
            "baseName": "CashOrdersEnabled",
            "type": "boolean"
        },
        {
            "name": "CardOrdersEnabled",
            "baseName": "CardOrdersEnabled",
            "type": "boolean"
        },
        {
            "name": "MarketingEnabled",
            "baseName": "MarketingEnabled",
            "type": "boolean"
        }
    ];
    return CustomerUpdateModel;
}());
exports.CustomerUpdateModel = CustomerUpdateModel;
var CustomerUpdatedEvent = (function () {
    function CustomerUpdatedEvent() {
    }
    CustomerUpdatedEvent.getAttributeTypeMap = function () {
        return CustomerUpdatedEvent.attributeTypeMap;
    };
    CustomerUpdatedEvent.discriminator = undefined;
    CustomerUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return CustomerUpdatedEvent;
}());
exports.CustomerUpdatedEvent = CustomerUpdatedEvent;
var DashboardEmbed = (function () {
    function DashboardEmbed() {
    }
    DashboardEmbed.getAttributeTypeMap = function () {
        return DashboardEmbed.attributeTypeMap;
    };
    DashboardEmbed.discriminator = undefined;
    DashboardEmbed.attributeTypeMap = [
        {
            "name": "EmbedUrl",
            "baseName": "EmbedUrl",
            "type": "string"
        }
    ];
    return DashboardEmbed;
}());
exports.DashboardEmbed = DashboardEmbed;
var DeliveryLocation = (function () {
    function DeliveryLocation() {
    }
    DeliveryLocation.getAttributeTypeMap = function () {
        return DeliveryLocation.attributeTypeMap;
    };
    DeliveryLocation.discriminator = undefined;
    DeliveryLocation.attributeTypeMap = [
        {
            "name": "Coordinates",
            "baseName": "Coordinates",
            "type": "Coordinates"
        },
        {
            "name": "Building",
            "baseName": "Building",
            "type": "string"
        },
        {
            "name": "Street",
            "baseName": "Street",
            "type": "string"
        },
        {
            "name": "Town",
            "baseName": "Town",
            "type": "string"
        },
        {
            "name": "PostCode",
            "baseName": "PostCode",
            "type": "string"
        },
        {
            "name": "DeliveryInstructions",
            "baseName": "DeliveryInstructions",
            "type": "string"
        },
        {
            "name": "PrettyAddressString",
            "baseName": "PrettyAddressString",
            "type": "string"
        }
    ];
    return DeliveryLocation;
}());
exports.DeliveryLocation = DeliveryLocation;
var DeliveryZone = (function () {
    function DeliveryZone() {
    }
    DeliveryZone.getAttributeTypeMap = function () {
        return DeliveryZone.attributeTypeMap;
    };
    DeliveryZone.discriminator = undefined;
    DeliveryZone.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "DeliveryFee",
            "baseName": "DeliveryFee",
            "type": "number"
        },
        {
            "name": "MinimumDeliveryOrderAmount",
            "baseName": "MinimumDeliveryOrderAmount",
            "type": "number"
        },
        {
            "name": "WellKnownText",
            "baseName": "WellKnownText",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        }
    ];
    return DeliveryZone;
}());
exports.DeliveryZone = DeliveryZone;
var DeliveryZoneBase = (function () {
    function DeliveryZoneBase() {
    }
    DeliveryZoneBase.getAttributeTypeMap = function () {
        return DeliveryZoneBase.attributeTypeMap;
    };
    DeliveryZoneBase.discriminator = undefined;
    DeliveryZoneBase.attributeTypeMap = [
        {
            "name": "DeliveryFee",
            "baseName": "DeliveryFee",
            "type": "number"
        },
        {
            "name": "MinimumDeliveryOrderAmount",
            "baseName": "MinimumDeliveryOrderAmount",
            "type": "number"
        },
        {
            "name": "WellKnownText",
            "baseName": "WellKnownText",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        }
    ];
    return DeliveryZoneBase;
}());
exports.DeliveryZoneBase = DeliveryZoneBase;
var DeliveryZoneCreatedEvent = (function () {
    function DeliveryZoneCreatedEvent() {
    }
    DeliveryZoneCreatedEvent.getAttributeTypeMap = function () {
        return DeliveryZoneCreatedEvent.attributeTypeMap;
    };
    DeliveryZoneCreatedEvent.discriminator = undefined;
    DeliveryZoneCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "DeliveryZone",
            "baseName": "DeliveryZone",
            "type": "DeliveryZone"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return DeliveryZoneCreatedEvent;
}());
exports.DeliveryZoneCreatedEvent = DeliveryZoneCreatedEvent;
var DeliveryZoneDeletedEvent = (function () {
    function DeliveryZoneDeletedEvent() {
    }
    DeliveryZoneDeletedEvent.getAttributeTypeMap = function () {
        return DeliveryZoneDeletedEvent.attributeTypeMap;
    };
    DeliveryZoneDeletedEvent.discriminator = undefined;
    DeliveryZoneDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "DeliveryZone",
            "baseName": "DeliveryZone",
            "type": "DeliveryZone"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return DeliveryZoneDeletedEvent;
}());
exports.DeliveryZoneDeletedEvent = DeliveryZoneDeletedEvent;
var DeliveryZoneUpdatedEvent = (function () {
    function DeliveryZoneUpdatedEvent() {
    }
    DeliveryZoneUpdatedEvent.getAttributeTypeMap = function () {
        return DeliveryZoneUpdatedEvent.attributeTypeMap;
    };
    DeliveryZoneUpdatedEvent.discriminator = undefined;
    DeliveryZoneUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "DeliveryZone",
            "baseName": "DeliveryZone",
            "type": "DeliveryZone"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return DeliveryZoneUpdatedEvent;
}());
exports.DeliveryZoneUpdatedEvent = DeliveryZoneUpdatedEvent;
var DeviceSettings = (function () {
    function DeviceSettings() {
    }
    DeviceSettings.getAttributeTypeMap = function () {
        return DeviceSettings.attributeTypeMap;
    };
    DeviceSettings.discriminator = undefined;
    DeviceSettings.attributeTypeMap = [
        {
            "name": "Volume",
            "baseName": "Volume",
            "type": "number"
        },
        {
            "name": "FontSize",
            "baseName": "FontSize",
            "type": "number"
        },
        {
            "name": "Brightness",
            "baseName": "Brightness",
            "type": "number"
        }
    ];
    return DeviceSettings;
}());
exports.DeviceSettings = DeviceSettings;
var DnsRecordInformation = (function () {
    function DnsRecordInformation() {
    }
    DnsRecordInformation.getAttributeTypeMap = function () {
        return DnsRecordInformation.attributeTypeMap;
    };
    DnsRecordInformation.discriminator = undefined;
    DnsRecordInformation.attributeTypeMap = [
        {
            "name": "IsCNameReady",
            "baseName": "IsCNameReady",
            "type": "boolean"
        },
        {
            "name": "IsAReady",
            "baseName": "IsAReady",
            "type": "boolean"
        },
        {
            "name": "IsApiCNameReady",
            "baseName": "IsApiCNameReady",
            "type": "boolean"
        }
    ];
    return DnsRecordInformation;
}());
exports.DnsRecordInformation = DnsRecordInformation;
var DnsVerifiedEvent = (function () {
    function DnsVerifiedEvent() {
    }
    DnsVerifiedEvent.getAttributeTypeMap = function () {
        return DnsVerifiedEvent.attributeTypeMap;
    };
    DnsVerifiedEvent.discriminator = undefined;
    DnsVerifiedEvent.attributeTypeMap = [
        {
            "name": "Hostname",
            "baseName": "Hostname",
            "type": "string"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return DnsVerifiedEvent;
}());
exports.DnsVerifiedEvent = DnsVerifiedEvent;
var DriverLoginModel = (function () {
    function DriverLoginModel() {
    }
    DriverLoginModel.getAttributeTypeMap = function () {
        return DriverLoginModel.attributeTypeMap;
    };
    DriverLoginModel.discriminator = undefined;
    DriverLoginModel.attributeTypeMap = [
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        },
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        }
    ];
    return DriverLoginModel;
}());
exports.DriverLoginModel = DriverLoginModel;
var DriverRequestLoginPinModel = (function () {
    function DriverRequestLoginPinModel() {
    }
    DriverRequestLoginPinModel.getAttributeTypeMap = function () {
        return DriverRequestLoginPinModel.attributeTypeMap;
    };
    DriverRequestLoginPinModel.discriminator = undefined;
    DriverRequestLoginPinModel.attributeTypeMap = [
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        }
    ];
    return DriverRequestLoginPinModel;
}());
exports.DriverRequestLoginPinModel = DriverRequestLoginPinModel;
var DuringOrderPromotionOptionsDm = (function () {
    function DuringOrderPromotionOptionsDm() {
    }
    DuringOrderPromotionOptionsDm.getAttributeTypeMap = function () {
        return DuringOrderPromotionOptionsDm.attributeTypeMap;
    };
    DuringOrderPromotionOptionsDm.discriminator = undefined;
    DuringOrderPromotionOptionsDm.attributeTypeMap = [
        {
            "name": "DuringOrderPromotionType",
            "baseName": "DuringOrderPromotionType",
            "type": "DuringOrderPromotionOptionsDm.DuringOrderPromotionTypeEnum"
        },
        {
            "name": "MinSmsShareCount",
            "baseName": "MinSmsShareCount",
            "type": "number"
        },
        {
            "name": "FreeCokeCount",
            "baseName": "FreeCokeCount",
            "type": "number"
        },
        {
            "name": "PromotionPeriodSeconds",
            "baseName": "PromotionPeriodSeconds",
            "type": "number"
        }
    ];
    return DuringOrderPromotionOptionsDm;
}());
exports.DuringOrderPromotionOptionsDm = DuringOrderPromotionOptionsDm;
(function (DuringOrderPromotionOptionsDm) {
    var DuringOrderPromotionTypeEnum;
    (function (DuringOrderPromotionTypeEnum) {
        DuringOrderPromotionTypeEnum[DuringOrderPromotionTypeEnum["None"] = 'None'] = "None";
        DuringOrderPromotionTypeEnum[DuringOrderPromotionTypeEnum["BumpFreeChocolate"] = 'BumpFreeChocolate'] = "BumpFreeChocolate";
        DuringOrderPromotionTypeEnum[DuringOrderPromotionTypeEnum["BumpFreeCoke"] = 'BumpFreeCoke'] = "BumpFreeCoke";
        DuringOrderPromotionTypeEnum[DuringOrderPromotionTypeEnum["SmsInviteFreeChocolate"] = 'SmsInviteFreeChocolate'] = "SmsInviteFreeChocolate";
        DuringOrderPromotionTypeEnum[DuringOrderPromotionTypeEnum["SmsInviteFreeCoke"] = 'SmsInviteFreeCoke'] = "SmsInviteFreeCoke";
    })(DuringOrderPromotionTypeEnum = DuringOrderPromotionOptionsDm.DuringOrderPromotionTypeEnum || (DuringOrderPromotionOptionsDm.DuringOrderPromotionTypeEnum = {}));
})(DuringOrderPromotionOptionsDm = exports.DuringOrderPromotionOptionsDm || (exports.DuringOrderPromotionOptionsDm = {}));
exports.DuringOrderPromotionOptionsDm = DuringOrderPromotionOptionsDm;
var DynamicFormField = (function () {
    function DynamicFormField() {
    }
    DynamicFormField.getAttributeTypeMap = function () {
        return DynamicFormField.attributeTypeMap;
    };
    DynamicFormField.discriminator = undefined;
    DynamicFormField.attributeTypeMap = [
        {
            "name": "Identifier",
            "baseName": "Identifier",
            "type": "string"
        },
        {
            "name": "Label",
            "baseName": "Label",
            "type": "string"
        },
        {
            "name": "Placeholder",
            "baseName": "Placeholder",
            "type": "string"
        },
        {
            "name": "Rules",
            "baseName": "Rules",
            "type": "DynamicFormRules"
        },
        {
            "name": "Mapping",
            "baseName": "Mapping",
            "type": "{ [key: string]: string; }"
        },
        {
            "name": "Modifiers",
            "baseName": "Modifiers",
            "type": "Array<string>"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "any"
        }
    ];
    return DynamicFormField;
}());
exports.DynamicFormField = DynamicFormField;
var DynamicFormFieldOption = (function () {
    function DynamicFormFieldOption() {
    }
    DynamicFormFieldOption.getAttributeTypeMap = function () {
        return DynamicFormFieldOption.attributeTypeMap;
    };
    DynamicFormFieldOption.discriminator = undefined;
    DynamicFormFieldOption.attributeTypeMap = [
        {
            "name": "Display",
            "baseName": "Display",
            "type": "string"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "string"
        }
    ];
    return DynamicFormFieldOption;
}());
exports.DynamicFormFieldOption = DynamicFormFieldOption;
var DynamicFormRule = (function () {
    function DynamicFormRule() {
    }
    DynamicFormRule.getAttributeTypeMap = function () {
        return DynamicFormRule.attributeTypeMap;
    };
    DynamicFormRule.discriminator = undefined;
    DynamicFormRule.attributeTypeMap = [
        {
            "name": "Value",
            "baseName": "Value",
            "type": "any"
        },
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        },
        {
            "name": "Scopes",
            "baseName": "Scopes",
            "type": "string"
        }
    ];
    return DynamicFormRule;
}());
exports.DynamicFormRule = DynamicFormRule;
var DynamicFormRules = (function () {
    function DynamicFormRules() {
    }
    DynamicFormRules.getAttributeTypeMap = function () {
        return DynamicFormRules.attributeTypeMap;
    };
    DynamicFormRules.discriminator = undefined;
    DynamicFormRules.attributeTypeMap = [
        {
            "name": "MaxLength",
            "baseName": "MaxLength",
            "type": "DynamicFormRule"
        },
        {
            "name": "MinLength",
            "baseName": "MinLength",
            "type": "DynamicFormRule"
        },
        {
            "name": "Required",
            "baseName": "Required",
            "type": "DynamicFormRule"
        },
        {
            "name": "Pattern",
            "baseName": "Pattern",
            "type": "DynamicFormRule"
        },
        {
            "name": "Predefined",
            "baseName": "Predefined",
            "type": "Array<DynamicFormFieldOption>"
        }
    ];
    return DynamicFormRules;
}());
exports.DynamicFormRules = DynamicFormRules;
var EmvNotificationEvent = (function () {
    function EmvNotificationEvent() {
    }
    EmvNotificationEvent.getAttributeTypeMap = function () {
        return EmvNotificationEvent.attributeTypeMap;
    };
    EmvNotificationEvent.discriminator = undefined;
    EmvNotificationEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Notification",
            "baseName": "Notification",
            "type": "string"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "TerminalId",
            "baseName": "TerminalId",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "ExpDate",
            "baseName": "ExpDate",
            "type": "string"
        },
        {
            "name": "CardType",
            "baseName": "CardType",
            "type": "string"
        },
        {
            "name": "PaymentMethod",
            "baseName": "PaymentMethod",
            "type": "string"
        },
        {
            "name": "AccountNumber",
            "baseName": "AccountNumber",
            "type": "string"
        },
        {
            "name": "AuthCode",
            "baseName": "AuthCode",
            "type": "string"
        },
        {
            "name": "ProviderMessage",
            "baseName": "ProviderMessage",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return EmvNotificationEvent;
}());
exports.EmvNotificationEvent = EmvNotificationEvent;
var EmvTerminal = (function () {
    function EmvTerminal() {
    }
    EmvTerminal.getAttributeTypeMap = function () {
        return EmvTerminal.attributeTypeMap;
    };
    EmvTerminal.discriminator = undefined;
    EmvTerminal.attributeTypeMap = [
        {
            "name": "EmvTerminalId",
            "baseName": "EmvTerminalId",
            "type": "number"
        },
        {
            "name": "TerminalId",
            "baseName": "TerminalId",
            "type": "string"
        },
        {
            "name": "Url",
            "baseName": "Url",
            "type": "string"
        },
        {
            "name": "Token",
            "baseName": "Token",
            "type": "string"
        },
        {
            "name": "SoftwareHouseId",
            "baseName": "SoftwareHouseId",
            "type": "string"
        },
        {
            "name": "InstallerId",
            "baseName": "InstallerId",
            "type": "string"
        }
    ];
    return EmvTerminal;
}());
exports.EmvTerminal = EmvTerminal;
var EmvTerminalWithAssignments = (function () {
    function EmvTerminalWithAssignments() {
    }
    EmvTerminalWithAssignments.getAttributeTypeMap = function () {
        return EmvTerminalWithAssignments.attributeTypeMap;
    };
    EmvTerminalWithAssignments.discriminator = undefined;
    EmvTerminalWithAssignments.attributeTypeMap = [
        {
            "name": "EmvTerminalId",
            "baseName": "EmvTerminalId",
            "type": "string"
        },
        {
            "name": "TerminalId",
            "baseName": "TerminalId",
            "type": "string"
        },
        {
            "name": "IsAssignedToHydraDevice",
            "baseName": "IsAssignedToHydraDevice",
            "type": "boolean"
        },
        {
            "name": "HydraConfigId",
            "baseName": "HydraConfigId",
            "type": "number"
        },
        {
            "name": "HydraDeviceId",
            "baseName": "HydraDeviceId",
            "type": "string"
        },
        {
            "name": "HydraName",
            "baseName": "HydraName",
            "type": "string"
        }
    ];
    return EmvTerminalWithAssignments;
}());
exports.EmvTerminalWithAssignments = EmvTerminalWithAssignments;
var EventSearchResult = (function () {
    function EventSearchResult() {
    }
    EventSearchResult.getAttributeTypeMap = function () {
        return EventSearchResult.attributeTypeMap;
    };
    EventSearchResult.discriminator = undefined;
    EventSearchResult.attributeTypeMap = [
        {
            "name": "AppCreatedEvent",
            "baseName": "AppCreatedEvent",
            "type": "Array<AppCreatedEvent>"
        },
        {
            "name": "AppUpdatedEvent",
            "baseName": "AppUpdatedEvent",
            "type": "Array<AppUpdatedEvent>"
        },
        {
            "name": "AnalyticsClientEvent",
            "baseName": "AnalyticsClientEvent",
            "type": "Array<AnalyticsClientEvent>"
        },
        {
            "name": "OrderAcceptedEvent",
            "baseName": "OrderAcceptedEvent",
            "type": "Array<OrderAcceptedEvent>"
        },
        {
            "name": "OrderDispatchedEvent",
            "baseName": "OrderDispatchedEvent",
            "type": "Array<OrderDispatchedEvent>"
        },
        {
            "name": "OrderCustomerTrackingCreatedEvent",
            "baseName": "OrderCustomerTrackingCreatedEvent",
            "type": "Array<OrderCustomerTrackingCreatedEvent>"
        },
        {
            "name": "OrderDeliveryTrackingStatusUpdatedEvent",
            "baseName": "OrderDeliveryTrackingStatusUpdatedEvent",
            "type": "Array<OrderDeliveryTrackingStatusUpdatedEvent>"
        },
        {
            "name": "OrderBatchPublishedEvent",
            "baseName": "OrderBatchPublishedEvent",
            "type": "Array<OrderBatchPublishedEvent>"
        },
        {
            "name": "OrderCreatedEvent",
            "baseName": "OrderCreatedEvent",
            "type": "Array<OrderCreatedEvent>"
        },
        {
            "name": "OrderRatingUpdatedEvent",
            "baseName": "OrderRatingUpdatedEvent",
            "type": "Array<OrderRatingUpdatedEvent>"
        },
        {
            "name": "OrderRefundedEvent",
            "baseName": "OrderRefundedEvent",
            "type": "Array<OrderRefundedEvent>"
        },
        {
            "name": "OrderRejectedEvent",
            "baseName": "OrderRejectedEvent",
            "type": "Array<OrderRejectedEvent>"
        },
        {
            "name": "OrderTipUpdatedEvent",
            "baseName": "OrderTipUpdatedEvent",
            "type": "Array<OrderTipUpdatedEvent>"
        },
        {
            "name": "OrderTerminalNotifications",
            "baseName": "OrderTerminalNotifications",
            "type": "Array<EmvNotificationEvent>"
        },
        {
            "name": "StoreCreatedEvent",
            "baseName": "StoreCreatedEvent",
            "type": "Array<StoreCreatedEvent>"
        },
        {
            "name": "StoreDeletedEvent",
            "baseName": "StoreDeletedEvent",
            "type": "Array<StoreDeletedEvent>"
        },
        {
            "name": "StoreAddressUpdatedEvent",
            "baseName": "StoreAddressUpdatedEvent",
            "type": "Array<StoreAddressUpdatedEvent>"
        },
        {
            "name": "StoreKioskSettingUpdatedEvent",
            "baseName": "StoreKioskSettingUpdatedEvent",
            "type": "Array<StoreKioskSettingUpdatedEvent>"
        },
        {
            "name": "DeliveryZoneCreatedEvent",
            "baseName": "DeliveryZoneCreatedEvent",
            "type": "Array<DeliveryZoneCreatedEvent>"
        },
        {
            "name": "DeliveryZoneUpdatedEvent",
            "baseName": "DeliveryZoneUpdatedEvent",
            "type": "Array<DeliveryZoneUpdatedEvent>"
        },
        {
            "name": "DeliveryZoneDeletedEvent",
            "baseName": "DeliveryZoneDeletedEvent",
            "type": "Array<DeliveryZoneDeletedEvent>"
        },
        {
            "name": "StoreOpeningHoursUpdatedEvent",
            "baseName": "StoreOpeningHoursUpdatedEvent",
            "type": "Array<StoreOpeningHoursUpdatedEvent>"
        },
        {
            "name": "StoreMenuAssignedEvent",
            "baseName": "StoreMenuAssignedEvent",
            "type": "Array<StoreMenuAssignedEvent>"
        },
        {
            "name": "StoreBusinessHoursOverrideCreatedEvent",
            "baseName": "StoreBusinessHoursOverrideCreatedEvent",
            "type": "Array<StoreBusinessHoursOverrideCreatedEvent>"
        },
        {
            "name": "StoreBusinessHoursOverrideDeletedEvent",
            "baseName": "StoreBusinessHoursOverrideDeletedEvent",
            "type": "Array<StoreBusinessHoursOverrideDeletedEvent>"
        },
        {
            "name": "StoreArchivedEvent",
            "baseName": "StoreArchivedEvent",
            "type": "Array<StoreArchivedEvent>"
        },
        {
            "name": "StoreUnarchivedEvent",
            "baseName": "StoreUnarchivedEvent",
            "type": "Array<StoreUnarchivedEvent>"
        },
        {
            "name": "StorePublishedEvent",
            "baseName": "StorePublishedEvent",
            "type": "Array<StorePublishedEvent>"
        },
        {
            "name": "StoreUnpublishedEvent",
            "baseName": "StoreUnpublishedEvent",
            "type": "Array<StoreUnpublishedEvent>"
        },
        {
            "name": "StoreUpdatedEvent",
            "baseName": "StoreUpdatedEvent",
            "type": "Array<StoreUpdatedEvent>"
        },
        {
            "name": "StorePreOrderConfigUpdatedEvent",
            "baseName": "StorePreOrderConfigUpdatedEvent",
            "type": "Array<StorePreOrderConfigUpdatedEvent>"
        },
        {
            "name": "StoreLogoCreatedEvent",
            "baseName": "StoreLogoCreatedEvent",
            "type": "Array<StoreLogoCreatedEvent>"
        },
        {
            "name": "StoreLogoUpdatedEvent",
            "baseName": "StoreLogoUpdatedEvent",
            "type": "Array<StoreLogoUpdatedEvent>"
        },
        {
            "name": "StoreLogoDeletedEvent",
            "baseName": "StoreLogoDeletedEvent",
            "type": "Array<StoreLogoDeletedEvent>"
        },
        {
            "name": "MenuCreatedEvent",
            "baseName": "MenuCreatedEvent",
            "type": "Array<MenuCreatedEvent>"
        },
        {
            "name": "MenuUpdatedEvent",
            "baseName": "MenuUpdatedEvent",
            "type": "Array<MenuUpdatedEvent>"
        },
        {
            "name": "MenuUploadedEvent",
            "baseName": "MenuUploadedEvent",
            "type": "Array<MenuUploadedEvent>"
        },
        {
            "name": "MenuBulkEditEvent",
            "baseName": "MenuBulkEditEvent",
            "type": "Array<MenuBulkEditEvent>"
        },
        {
            "name": "MenuSectionCreatedEvent",
            "baseName": "MenuSectionCreatedEvent",
            "type": "Array<MenuSectionCreatedEvent>"
        },
        {
            "name": "MenuSectionUpdatedEvent",
            "baseName": "MenuSectionUpdatedEvent",
            "type": "Array<MenuSectionUpdatedEvent>"
        },
        {
            "name": "MenuSectionDeletedEvent",
            "baseName": "MenuSectionDeletedEvent",
            "type": "Array<MenuSectionDeletedEvent>"
        },
        {
            "name": "MenuSectionItemCreatedEvent",
            "baseName": "MenuSectionItemCreatedEvent",
            "type": "Array<MenuSectionItemCreatedEvent>"
        },
        {
            "name": "MenuSectionItemUpdatedEvent",
            "baseName": "MenuSectionItemUpdatedEvent",
            "type": "Array<MenuSectionItemUpdatedEvent>"
        },
        {
            "name": "MenuSectionItemDeletedEvent",
            "baseName": "MenuSectionItemDeletedEvent",
            "type": "Array<MenuSectionItemDeletedEvent>"
        },
        {
            "name": "MenuItemOptionSetCreatedEvent",
            "baseName": "MenuItemOptionSetCreatedEvent",
            "type": "Array<MenuItemOptionSetCreatedEvent>"
        },
        {
            "name": "MenuItemOptionSetUpdatedEvent",
            "baseName": "MenuItemOptionSetUpdatedEvent",
            "type": "Array<MenuItemOptionSetUpdatedEvent>"
        },
        {
            "name": "MenuItemOptionSetDeletedEvent",
            "baseName": "MenuItemOptionSetDeletedEvent",
            "type": "Array<MenuItemOptionSetDeletedEvent>"
        },
        {
            "name": "MenuItemOptionSetItemCreatedEvent",
            "baseName": "MenuItemOptionSetItemCreatedEvent",
            "type": "Array<MenuItemOptionSetItemCreatedEvent>"
        },
        {
            "name": "MenuItemOptionSetItemUpdatedEvent",
            "baseName": "MenuItemOptionSetItemUpdatedEvent",
            "type": "Array<MenuItemOptionSetItemUpdatedEvent>"
        },
        {
            "name": "MenuItemOptionSetItemDeletedEvent",
            "baseName": "MenuItemOptionSetItemDeletedEvent",
            "type": "Array<MenuItemOptionSetItemDeletedEvent>"
        },
        {
            "name": "MenuCheckpointCreatedEvent",
            "baseName": "MenuCheckpointCreatedEvent",
            "type": "Array<MenuCheckpointCreatedEvent>"
        },
        {
            "name": "StoreGroupCreatedEvent",
            "baseName": "StoreGroupCreatedEvent",
            "type": "Array<StoreGroupCreatedEvent>"
        },
        {
            "name": "StoreGroupUpdatedEvent",
            "baseName": "StoreGroupUpdatedEvent",
            "type": "Array<StoreGroupUpdatedEvent>"
        },
        {
            "name": "StoreGroupDeletedEvent",
            "baseName": "StoreGroupDeletedEvent",
            "type": "Array<StoreGroupDeletedEvent>"
        },
        {
            "name": "CustomerCreatedEvent",
            "baseName": "CustomerCreatedEvent",
            "type": "Array<CustomerCreatedEvent>"
        },
        {
            "name": "CustomerUpdatedEvent",
            "baseName": "CustomerUpdatedEvent",
            "type": "Array<CustomerUpdatedEvent>"
        },
        {
            "name": "CustomerConsentUpdatedEvent",
            "baseName": "CustomerConsentUpdatedEvent",
            "type": "Array<CustomerConsentUpdatedEvent>"
        },
        {
            "name": "WebhookSubscriptionCreatedEvent",
            "baseName": "WebhookSubscriptionCreatedEvent",
            "type": "Array<WebhookSubscriptionCreatedEvent>"
        },
        {
            "name": "WebhookSubscriptionUpdatedEvent",
            "baseName": "WebhookSubscriptionUpdatedEvent",
            "type": "Array<WebhookSubscriptionUpdatedEvent>"
        },
        {
            "name": "WebhookSubscriptionDeletedEvent",
            "baseName": "WebhookSubscriptionDeletedEvent",
            "type": "Array<WebhookSubscriptionDeletedEvent>"
        },
        {
            "name": "PrinterTurnedOnEvent",
            "baseName": "PrinterTurnedOnEvent",
            "type": "Array<PrinterTurnedOnEvent>"
        },
        {
            "name": "PrinterTurnedOffEvent",
            "baseName": "PrinterTurnedOffEvent",
            "type": "Array<PrinterTurnedOffEvent>"
        },
        {
            "name": "PrinterAssignedToStoreEvent",
            "baseName": "PrinterAssignedToStoreEvent",
            "type": "Array<PrinterAssignedToStoreEvent>"
        },
        {
            "name": "PrinterUnassignedFromStoreEvent",
            "baseName": "PrinterUnassignedFromStoreEvent",
            "type": "Array<PrinterUnassignedFromStoreEvent>"
        },
        {
            "name": "PhoneCallStartedEvent",
            "baseName": "PhoneCallStartedEvent",
            "type": "Array<PhoneCallStartedEvent>"
        },
        {
            "name": "PhoneCallEndedEvent",
            "baseName": "PhoneCallEndedEvent",
            "type": "Array<PhoneCallEndedEvent>"
        },
        {
            "name": "LoyaltyCampaignCreatedEvent",
            "baseName": "LoyaltyCampaignCreatedEvent",
            "type": "Array<LoyaltyCampaignCreatedEvent>"
        },
        {
            "name": "LoyaltyCampaignDeletedEvent",
            "baseName": "LoyaltyCampaignDeletedEvent",
            "type": "Array<LoyaltyCampaignDeletedEvent>"
        },
        {
            "name": "LoyaltyCampaignUpdatedEvent",
            "baseName": "LoyaltyCampaignUpdatedEvent",
            "type": "Array<LoyaltyCampaignUpdatedEvent>"
        },
        {
            "name": "RetentionCampaignCreatedEvent",
            "baseName": "RetentionCampaignCreatedEvent",
            "type": "Array<RetentionCampaignCreatedEvent>"
        },
        {
            "name": "RetentionCampaignDeletedEvent",
            "baseName": "RetentionCampaignDeletedEvent",
            "type": "Array<RetentionCampaignDeletedEvent>"
        },
        {
            "name": "RetentionCampaignUpdatedEvent",
            "baseName": "RetentionCampaignUpdatedEvent",
            "type": "Array<RetentionCampaignUpdatedEvent>"
        },
        {
            "name": "SmsReceivedEvent",
            "baseName": "SmsReceivedEvent",
            "type": "Array<SmsReceivedEvent>"
        },
        {
            "name": "UserLoginEvent",
            "baseName": "UserLoginEvent",
            "type": "Array<UserLoginEvent>"
        },
        {
            "name": "UserCreatedEvent",
            "baseName": "UserCreatedEvent",
            "type": "Array<UserCreatedEvent>"
        },
        {
            "name": "UserUpdatedEvent",
            "baseName": "UserUpdatedEvent",
            "type": "Array<UserUpdatedEvent>"
        },
        {
            "name": "UserDeletedEvent",
            "baseName": "UserDeletedEvent",
            "type": "Array<UserDeletedEvent>"
        },
        {
            "name": "UserCreatedPasswordEvent",
            "baseName": "UserCreatedPasswordEvent",
            "type": "Array<UserPasswordCreatedEvent>"
        },
        {
            "name": "UserAnsweredSignupQuestionsEvent",
            "baseName": "UserAnsweredSignupQuestionsEvent",
            "type": "Array<UserAnsweredSignupQuestionsEvent>"
        },
        {
            "name": "VoucherCreatedEvent",
            "baseName": "VoucherCreatedEvent",
            "type": "Array<VoucherCreatedEvent>"
        },
        {
            "name": "VoucherUpdatedEvent",
            "baseName": "VoucherUpdatedEvent",
            "type": "Array<VoucherUpdatedEvent>"
        },
        {
            "name": "VoucherDeletedEvent",
            "baseName": "VoucherDeletedEvent",
            "type": "Array<VoucherDeletedEvent>"
        },
        {
            "name": "TeammateInviteSentEvent",
            "baseName": "TeammateInviteSentEvent",
            "type": "Array<TeammateInviteSentEvent>"
        },
        {
            "name": "TeammateInviteAcceptedEvent",
            "baseName": "TeammateInviteAcceptedEvent",
            "type": "Array<TeammateInviteAcceptedEvent>"
        },
        {
            "name": "TeammateUpdatedEvent",
            "baseName": "TeammateUpdatedEvent",
            "type": "Array<TeammateUpdatedEvent>"
        },
        {
            "name": "TeammateDeletedEvent",
            "baseName": "TeammateDeletedEvent",
            "type": "Array<TeammateDeletedEvent>"
        },
        {
            "name": "BankAccountCreatedEvent",
            "baseName": "BankAccountCreatedEvent",
            "type": "Array<BankAccountCreatedEvent>"
        },
        {
            "name": "BankAccountUpdatedEvent",
            "baseName": "BankAccountUpdatedEvent",
            "type": "Array<BankAccountUpdatedEvent>"
        },
        {
            "name": "BankAccountDeletedEvent",
            "baseName": "BankAccountDeletedEvent",
            "type": "Array<BankAccountDeletedEvent>"
        },
        {
            "name": "BankAccountAssignedEvent",
            "baseName": "BankAccountAssignedEvent",
            "type": "Array<BankAccountAssignedEvent>"
        },
        {
            "name": "HydraAssignedEvent",
            "baseName": "HydraAssignedEvent",
            "type": "Array<HydraAssignedEvent>"
        },
        {
            "name": "HydraRequestResetEvent",
            "baseName": "HydraRequestResetEvent",
            "type": "Array<HydraRequestResetEvent>"
        },
        {
            "name": "HydraStoreAssignedEvent",
            "baseName": "HydraStoreAssignedEvent",
            "type": "Array<HydraStoreAssignedEvent>"
        },
        {
            "name": "HydraStoreUnassignedEvent",
            "baseName": "HydraStoreUnassignedEvent",
            "type": "Array<HydraStoreUnassignedEvent>"
        },
        {
            "name": "HydraSettingChangedEvent",
            "baseName": "HydraSettingChangedEvent",
            "type": "Array<HydraSettingChangedEvent>"
        },
        {
            "name": "HydraUnAssignedEvent",
            "baseName": "HydraUnAssignedEvent",
            "type": "Array<HydraUnAssignedEvent>"
        },
        {
            "name": "HydraConnectionStatusChangedEvent",
            "baseName": "HydraConnectionStatusChangedEvent",
            "type": "Array<HydraConnectionStatusChangedEvent>"
        },
        {
            "name": "KioskBluetoothPairingModeEvent",
            "baseName": "KioskBluetoothPairingModeEvent",
            "type": "Array<KioskBluetoothPairingModeEvent>"
        },
        {
            "name": "KioskBluetoothUnpairingModeEvent",
            "baseName": "KioskBluetoothUnpairingModeEvent",
            "type": "Array<KioskBluetoothUnpairingModeEvent>"
        },
        {
            "name": "KioskBluetoothTerminalUnpairedEvent",
            "baseName": "KioskBluetoothTerminalUnpairedEvent",
            "type": "Array<KioskBluetoothTerminalUnpairedEvent>"
        },
        {
            "name": "KioskTerminalActionStateChangedEvent",
            "baseName": "KioskTerminalActionStateChangedEvent",
            "type": "Array<KioskTerminalActionStateChangedEvent>"
        },
        {
            "name": "KioskBluetoothTerminalUpdatedEvent",
            "baseName": "KioskBluetoothTerminalUpdatedEvent",
            "type": "Array<KioskBluetoothTerminalUpdatedEvent>"
        },
        {
            "name": "KioskBluetoothTerminalInitiateUpdateCheckEvent",
            "baseName": "KioskBluetoothTerminalInitiateUpdateCheckEvent",
            "type": "Array<KioskBluetoothTerminalInitiateUpdateCheckEvent>"
        },
        {
            "name": "KioskBluetoothInstallUpdateInitiateEvent",
            "baseName": "KioskBluetoothInstallUpdateInitiateEvent",
            "type": "Array<KioskBluetoothInstallUpdateInitiateEvent>"
        },
        {
            "name": "KioskBluetoothTerminalCancelUpdateEvent",
            "baseName": "KioskBluetoothTerminalCancelUpdateEvent",
            "type": "Array<KioskBluetoothTerminalCancelUpdateEvent>"
        },
        {
            "name": "KioskBluetoothTerminalFirmwareVersionStatusEvent",
            "baseName": "KioskBluetoothTerminalFirmwareVersionStatusEvent",
            "type": "Array<KioskBluetoothTerminalFirmwareVersionStatusEvent>"
        },
        {
            "name": "KioskBluetoothTerminalInstallationStatusEvent",
            "baseName": "KioskBluetoothTerminalInstallationStatusEvent",
            "type": "Array<KioskBluetoothTerminalInstallationStatusEvent>"
        },
        {
            "name": "PushNotificationScheduledEvent",
            "baseName": "PushNotificationScheduledEvent",
            "type": "Array<PushNotificationScheduledEvent>"
        },
        {
            "name": "PushNotificationSentEvent",
            "baseName": "PushNotificationSentEvent",
            "type": "Array<PushNotificationSentEvent>"
        },
        {
            "name": "PushNotificationDeletedEvent",
            "baseName": "PushNotificationDeletedEvent",
            "type": "Array<PushNotificationDeletedEvent>"
        },
        {
            "name": "DnsVerifiedEvent",
            "baseName": "DnsVerifiedEvent",
            "type": "Array<DnsVerifiedEvent>"
        },
        {
            "name": "CertificateCreatedEvent",
            "baseName": "CertificateCreatedEvent",
            "type": "Array<CertificateCreatedEvent>"
        },
        {
            "name": "CertificateRenewedEvent",
            "baseName": "CertificateRenewedEvent",
            "type": "Array<CertificateRenewedEvent>"
        },
        {
            "name": "WebsiteVanityUrlUpdatedEvent",
            "baseName": "WebsiteVanityUrlUpdatedEvent",
            "type": "Array<WebsiteVanityUrlUpdatedEvent>"
        },
        {
            "name": "WebsiteUpdatedEvent",
            "baseName": "WebsiteUpdatedEvent",
            "type": "Array<WebsiteUpdatedEvent>"
        },
        {
            "name": "OrderCapacityUpdatedEvent",
            "baseName": "OrderCapacityUpdatedEvent",
            "type": "Array<OrderCapacityConfigUpdatedEvent>"
        },
        {
            "name": "ExternalStoreEvent",
            "baseName": "ExternalStoreEvent",
            "type": "Array<ExternalStoreEvent>"
        },
        {
            "name": "OrderFulfillmentStatusUpdatedEvent",
            "baseName": "OrderFulfillmentStatusUpdatedEvent",
            "type": "Array<OrderFulfillmentStatusUpdatedEvent>"
        },
        {
            "name": "AppStoreConfigCreatedEvent",
            "baseName": "AppStoreConfigCreatedEvent",
            "type": "Array<AppStoreConfigCreatedEvent>"
        },
        {
            "name": "AppStoreConfigUpdatedEvent",
            "baseName": "AppStoreConfigUpdatedEvent",
            "type": "Array<AppStoreConfigUpdatedEvent>"
        },
        {
            "name": "AppStoreConfigDeletedEvent",
            "baseName": "AppStoreConfigDeletedEvent",
            "type": "Array<AppStoreConfigDeletedEvent>"
        },
        {
            "name": "CatalogItemCreatedEvent",
            "baseName": "CatalogItemCreatedEvent",
            "type": "Array<CatalogItemCreatedEvent>"
        },
        {
            "name": "CatalogItemUpdatedEvent",
            "baseName": "CatalogItemUpdatedEvent",
            "type": "Array<CatalogItemUpdatedEvent>"
        },
        {
            "name": "CatalogItemArchivedEvent",
            "baseName": "CatalogItemArchivedEvent",
            "type": "Array<CatalogItemArchivedEvent>"
        },
        {
            "name": "CatalogGroupCreatedEvent",
            "baseName": "CatalogGroupCreatedEvent",
            "type": "Array<CatalogGroupCreatedEvent>"
        },
        {
            "name": "CatalogGroupUpdatedEvent",
            "baseName": "CatalogGroupUpdatedEvent",
            "type": "Array<CatalogGroupUpdatedEvent>"
        },
        {
            "name": "CatalogGroupArchivedEvent",
            "baseName": "CatalogGroupArchivedEvent",
            "type": "Array<CatalogGroupArchivedEvent>"
        },
        {
            "name": "StoreTipUpdatedEvent",
            "baseName": "StoreTipUpdatedEvent",
            "type": "Array<StoreTipUpdatedEvent>"
        },
        {
            "name": "LocationAreaCreatedEvent",
            "baseName": "LocationAreaCreatedEvent",
            "type": "Array<LocationAreaCreatedEvent>"
        },
        {
            "name": "LocationAreaUpdatedEvent",
            "baseName": "LocationAreaUpdatedEvent",
            "type": "Array<LocationAreaUpdatedEvent>"
        },
        {
            "name": "LocationCreatedEvent",
            "baseName": "LocationCreatedEvent",
            "type": "Array<LocationCreatedEvent>"
        },
        {
            "name": "LocationDeletedEvent",
            "baseName": "LocationDeletedEvent",
            "type": "Array<LocationDeletedEvent>"
        },
        {
            "name": "StoreServiceChargeUpdatedEvent",
            "baseName": "StoreServiceChargeUpdatedEvent",
            "type": "Array<StoreServiceChargeUpdatedEvent>"
        },
        {
            "name": "MobileAppsSubmissionStatusUpdatedEvent",
            "baseName": "MobileAppsSubmissionStatusUpdatedEvent",
            "type": "Array<MobileAppsSubmissionStatusUpdatedEvent>"
        },
        {
            "name": "MobileAppsSubmissionUpdatedEvent",
            "baseName": "MobileAppsSubmissionUpdatedEvent",
            "type": "Array<MobileAppsSubmissionUpdatedEvent>"
        },
        {
            "name": "StoreFeeConfigUpdatedEvent",
            "baseName": "StoreFeeConfigUpdatedEvent",
            "type": "Array<StoreFeeConfigUpdatedEvent>"
        }
    ];
    return EventSearchResult;
}());
exports.EventSearchResult = EventSearchResult;
var ExecuteConfigurationActionRequest = (function () {
    function ExecuteConfigurationActionRequest() {
    }
    ExecuteConfigurationActionRequest.getAttributeTypeMap = function () {
        return ExecuteConfigurationActionRequest.attributeTypeMap;
    };
    ExecuteConfigurationActionRequest.discriminator = undefined;
    ExecuteConfigurationActionRequest.attributeTypeMap = [
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "Action",
            "baseName": "Action",
            "type": "string"
        }
    ];
    return ExecuteConfigurationActionRequest;
}());
exports.ExecuteConfigurationActionRequest = ExecuteConfigurationActionRequest;
var ExecuteConfigurationActionResult = (function () {
    function ExecuteConfigurationActionResult() {
    }
    ExecuteConfigurationActionResult.getAttributeTypeMap = function () {
        return ExecuteConfigurationActionResult.attributeTypeMap;
    };
    ExecuteConfigurationActionResult.discriminator = undefined;
    ExecuteConfigurationActionResult.attributeTypeMap = [
        {
            "name": "ErrorMessage",
            "baseName": "ErrorMessage",
            "type": "string"
        },
        {
            "name": "InfoMessage",
            "baseName": "InfoMessage",
            "type": "string"
        },
        {
            "name": "RedirectUrl",
            "baseName": "RedirectUrl",
            "type": "string"
        },
        {
            "name": "RedirectTarget",
            "baseName": "RedirectTarget",
            "type": "ExecuteConfigurationActionResult.RedirectTargetEnum"
        }
    ];
    return ExecuteConfigurationActionResult;
}());
exports.ExecuteConfigurationActionResult = ExecuteConfigurationActionResult;
(function (ExecuteConfigurationActionResult) {
    var RedirectTargetEnum;
    (function (RedirectTargetEnum) {
        RedirectTargetEnum[RedirectTargetEnum["Default"] = 'Default'] = "Default";
        RedirectTargetEnum[RedirectTargetEnum["NewWindow"] = 'NewWindow'] = "NewWindow";
        RedirectTargetEnum[RedirectTargetEnum["Popup"] = 'Popup'] = "Popup";
    })(RedirectTargetEnum = ExecuteConfigurationActionResult.RedirectTargetEnum || (ExecuteConfigurationActionResult.RedirectTargetEnum = {}));
})(ExecuteConfigurationActionResult = exports.ExecuteConfigurationActionResult || (exports.ExecuteConfigurationActionResult = {}));
exports.ExecuteConfigurationActionResult = ExecuteConfigurationActionResult;
var ExternalStoreAuditLog = (function () {
    function ExternalStoreAuditLog() {
    }
    ExternalStoreAuditLog.getAttributeTypeMap = function () {
        return ExternalStoreAuditLog.attributeTypeMap;
    };
    ExternalStoreAuditLog.discriminator = undefined;
    ExternalStoreAuditLog.attributeTypeMap = [
        {
            "name": "ExternalCreateTime",
            "baseName": "ExternalCreateTime",
            "type": "Date"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Source",
            "baseName": "Source",
            "type": "string"
        },
        {
            "name": "Version",
            "baseName": "Version",
            "type": "string"
        },
        {
            "name": "DescriptionFormat",
            "baseName": "DescriptionFormat",
            "type": "string"
        },
        {
            "name": "DescriptionFields",
            "baseName": "DescriptionFields",
            "type": "string"
        },
        {
            "name": "DescriptionId",
            "baseName": "DescriptionId",
            "type": "string"
        },
        {
            "name": "Ref1",
            "baseName": "Ref1",
            "type": "string"
        },
        {
            "name": "Ref2",
            "baseName": "Ref2",
            "type": "string"
        },
        {
            "name": "Ref3",
            "baseName": "Ref3",
            "type": "string"
        },
        {
            "name": "Ref4",
            "baseName": "Ref4",
            "type": "string"
        },
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "Tags",
            "baseName": "Tags",
            "type": "Array<string>"
        },
        {
            "name": "FieldChanges",
            "baseName": "FieldChanges",
            "type": "Array<AuditLogFieldChangeInformation>"
        }
    ];
    return ExternalStoreAuditLog;
}());
exports.ExternalStoreAuditLog = ExternalStoreAuditLog;
var ExternalStoreEvent = (function () {
    function ExternalStoreEvent() {
    }
    ExternalStoreEvent.getAttributeTypeMap = function () {
        return ExternalStoreEvent.attributeTypeMap;
    };
    ExternalStoreEvent.discriminator = undefined;
    ExternalStoreEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "DescriptionFormat",
            "baseName": "DescriptionFormat",
            "type": "string"
        },
        {
            "name": "DescriptionFields",
            "baseName": "DescriptionFields",
            "type": "string"
        },
        {
            "name": "DescriptionId",
            "baseName": "DescriptionId",
            "type": "string"
        },
        {
            "name": "Ref1",
            "baseName": "Ref1",
            "type": "string"
        },
        {
            "name": "Ref2",
            "baseName": "Ref2",
            "type": "string"
        },
        {
            "name": "Ref3",
            "baseName": "Ref3",
            "type": "string"
        },
        {
            "name": "Ref4",
            "baseName": "Ref4",
            "type": "string"
        },
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "Tags",
            "baseName": "Tags",
            "type": "Array<string>"
        },
        {
            "name": "FieldChanges",
            "baseName": "FieldChanges",
            "type": "Array<FieldChangeInformation>"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return ExternalStoreEvent;
}());
exports.ExternalStoreEvent = ExternalStoreEvent;
var FeeSummary = (function () {
    function FeeSummary() {
    }
    FeeSummary.getAttributeTypeMap = function () {
        return FeeSummary.attributeTypeMap;
    };
    FeeSummary.discriminator = undefined;
    FeeSummary.attributeTypeMap = [
        {
            "name": "FeeAmount",
            "baseName": "FeeAmount",
            "type": "number"
        },
        {
            "name": "PercentageRate",
            "baseName": "PercentageRate",
            "type": "number"
        },
        {
            "name": "PerTransactionFee",
            "baseName": "PerTransactionFee",
            "type": "number"
        }
    ];
    return FeeSummary;
}());
exports.FeeSummary = FeeSummary;
var Field = (function () {
    function Field() {
    }
    Field.getAttributeTypeMap = function () {
        return Field.attributeTypeMap;
    };
    Field.discriminator = undefined;
    Field.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "Tooltip",
            "baseName": "Tooltip",
            "type": "string"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "DefaultValue",
            "baseName": "DefaultValue",
            "type": "string"
        },
        {
            "name": "ValidValues",
            "baseName": "ValidValues",
            "type": "Array<ValidValue>"
        },
        {
            "name": "ValidationRegex",
            "baseName": "ValidationRegex",
            "type": "string"
        },
        {
            "name": "FieldType",
            "baseName": "FieldType",
            "type": "Field.FieldTypeEnum"
        },
        {
            "name": "IsFlipdishRestricted",
            "baseName": "IsFlipdishRestricted",
            "type": "boolean"
        }
    ];
    return Field;
}());
exports.Field = Field;
(function (Field) {
    var FieldTypeEnum;
    (function (FieldTypeEnum) {
        FieldTypeEnum[FieldTypeEnum["Text"] = 'Text'] = "Text";
        FieldTypeEnum[FieldTypeEnum["TextArea"] = 'TextArea'] = "TextArea";
        FieldTypeEnum[FieldTypeEnum["Integer"] = 'Integer'] = "Integer";
        FieldTypeEnum[FieldTypeEnum["Decimal"] = 'Decimal'] = "Decimal";
        FieldTypeEnum[FieldTypeEnum["Date"] = 'Date'] = "Date";
        FieldTypeEnum[FieldTypeEnum["DateTime"] = 'DateTime'] = "DateTime";
        FieldTypeEnum[FieldTypeEnum["Time"] = 'Time'] = "Time";
        FieldTypeEnum[FieldTypeEnum["Select"] = 'Select'] = "Select";
        FieldTypeEnum[FieldTypeEnum["Boolean"] = 'Boolean'] = "Boolean";
        FieldTypeEnum[FieldTypeEnum["ActionButton"] = 'ActionButton'] = "ActionButton";
    })(FieldTypeEnum = Field.FieldTypeEnum || (Field.FieldTypeEnum = {}));
})(Field = exports.Field || (exports.Field = {}));
exports.Field = Field;
var FieldChangeInformation = (function () {
    function FieldChangeInformation() {
    }
    FieldChangeInformation.getAttributeTypeMap = function () {
        return FieldChangeInformation.attributeTypeMap;
    };
    FieldChangeInformation.discriminator = undefined;
    FieldChangeInformation.attributeTypeMap = [
        {
            "name": "Path",
            "baseName": "Path",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "OldValue",
            "baseName": "OldValue",
            "type": "string"
        },
        {
            "name": "NewValue",
            "baseName": "NewValue",
            "type": "string"
        }
    ];
    return FieldChangeInformation;
}());
exports.FieldChangeInformation = FieldChangeInformation;
var FieldGroup = (function () {
    function FieldGroup() {
    }
    FieldGroup.getAttributeTypeMap = function () {
        return FieldGroup.attributeTypeMap;
    };
    FieldGroup.discriminator = undefined;
    FieldGroup.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Tooltip",
            "baseName": "Tooltip",
            "type": "string"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "Fields",
            "baseName": "Fields",
            "type": "Array<Field>"
        }
    ];
    return FieldGroup;
}());
exports.FieldGroup = FieldGroup;
var FirebaseApp = (function () {
    function FirebaseApp() {
    }
    FirebaseApp.getAttributeTypeMap = function () {
        return FirebaseApp.attributeTypeMap;
    };
    FirebaseApp.discriminator = undefined;
    FirebaseApp.attributeTypeMap = [
        {
            "name": "WhitelabelId",
            "baseName": "WhitelabelId",
            "type": "number"
        },
        {
            "name": "PackageId",
            "baseName": "PackageId",
            "type": "string"
        },
        {
            "name": "FirebaseAppId",
            "baseName": "FirebaseAppId",
            "type": "string"
        },
        {
            "name": "FirebaseProjectId",
            "baseName": "FirebaseProjectId",
            "type": "string"
        }
    ];
    return FirebaseApp;
}());
exports.FirebaseApp = FirebaseApp;
var FlipdishEventBase = (function () {
    function FlipdishEventBase() {
    }
    FlipdishEventBase.getAttributeTypeMap = function () {
        return FlipdishEventBase.attributeTypeMap;
    };
    FlipdishEventBase.discriminator = undefined;
    FlipdishEventBase.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return FlipdishEventBase;
}());
exports.FlipdishEventBase = FlipdishEventBase;
var FlipdishFeesDetails = (function () {
    function FlipdishFeesDetails() {
    }
    FlipdishFeesDetails.getAttributeTypeMap = function () {
        return FlipdishFeesDetails.attributeTypeMap;
    };
    FlipdishFeesDetails.discriminator = undefined;
    FlipdishFeesDetails.attributeTypeMap = [
        {
            "name": "OnlineSalesFees",
            "baseName": "OnlineSalesFees",
            "type": "number"
        },
        {
            "name": "CashSalesFees",
            "baseName": "CashSalesFees",
            "type": "number"
        },
        {
            "name": "PosSalesFees",
            "baseName": "PosSalesFees",
            "type": "number"
        },
        {
            "name": "TotalSalesFees",
            "baseName": "TotalSalesFees",
            "type": "number"
        },
        {
            "name": "OnlineSalesRefundedFees",
            "baseName": "OnlineSalesRefundedFees",
            "type": "number"
        },
        {
            "name": "CashSalesRefundedFees",
            "baseName": "CashSalesRefundedFees",
            "type": "number"
        },
        {
            "name": "PosSalesRefundedFees",
            "baseName": "PosSalesRefundedFees",
            "type": "number"
        },
        {
            "name": "SalesFeesVat",
            "baseName": "SalesFeesVat",
            "type": "number"
        },
        {
            "name": "TotalFees",
            "baseName": "TotalFees",
            "type": "number"
        }
    ];
    return FlipdishFeesDetails;
}());
exports.FlipdishFeesDetails = FlipdishFeesDetails;
var FulfillentStatusActionItem = (function () {
    function FulfillentStatusActionItem() {
    }
    FulfillentStatusActionItem.getAttributeTypeMap = function () {
        return FulfillentStatusActionItem.attributeTypeMap;
    };
    FulfillentStatusActionItem.discriminator = undefined;
    FulfillentStatusActionItem.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return FulfillentStatusActionItem;
}());
exports.FulfillentStatusActionItem = FulfillentStatusActionItem;
var FulfillmentInfo = (function () {
    function FulfillmentInfo() {
    }
    FulfillmentInfo.getAttributeTypeMap = function () {
        return FulfillmentInfo.attributeTypeMap;
    };
    FulfillmentInfo.discriminator = undefined;
    FulfillmentInfo.attributeTypeMap = [
        {
            "name": "DispatchType",
            "baseName": "DispatchType",
            "type": "FulfillmentInfo.DispatchTypeEnum"
        },
        {
            "name": "RequestedForUtc",
            "baseName": "RequestedForUtc",
            "type": "Date"
        },
        {
            "name": "Location",
            "baseName": "Location",
            "type": "Location"
        },
        {
            "name": "DispatchAmount",
            "baseName": "DispatchAmount",
            "type": "Price"
        }
    ];
    return FulfillmentInfo;
}());
exports.FulfillmentInfo = FulfillmentInfo;
(function (FulfillmentInfo) {
    var DispatchTypeEnum;
    (function (DispatchTypeEnum) {
        DispatchTypeEnum[DispatchTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DispatchTypeEnum[DispatchTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DispatchTypeEnum = FulfillmentInfo.DispatchTypeEnum || (FulfillmentInfo.DispatchTypeEnum = {}));
})(FulfillmentInfo = exports.FulfillmentInfo || (exports.FulfillmentInfo = {}));
exports.FulfillmentInfo = FulfillmentInfo;
var FulfillmentStatesConfiguration = (function () {
    function FulfillmentStatesConfiguration() {
    }
    FulfillmentStatesConfiguration.getAttributeTypeMap = function () {
        return FulfillmentStatesConfiguration.attributeTypeMap;
    };
    FulfillmentStatesConfiguration.discriminator = undefined;
    FulfillmentStatesConfiguration.attributeTypeMap = [
        {
            "name": "States",
            "baseName": "States",
            "type": "Array<FulfillmentStatusConfigurationItem>"
        },
        {
            "name": "AutomaticTransitionsEnabled",
            "baseName": "AutomaticTransitionsEnabled",
            "type": "boolean"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "ConfigurationUid",
            "baseName": "ConfigurationUid",
            "type": "string"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "FulfillmentStatesConfiguration.StoreSelectorTypeEnum"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return FulfillmentStatesConfiguration;
}());
exports.FulfillmentStatesConfiguration = FulfillmentStatesConfiguration;
(function (FulfillmentStatesConfiguration) {
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = FulfillmentStatesConfiguration.StoreSelectorTypeEnum || (FulfillmentStatesConfiguration.StoreSelectorTypeEnum = {}));
})(FulfillmentStatesConfiguration = exports.FulfillmentStatesConfiguration || (exports.FulfillmentStatesConfiguration = {}));
exports.FulfillmentStatesConfiguration = FulfillmentStatesConfiguration;
var FulfillmentStatesConfigurationSummary = (function () {
    function FulfillmentStatesConfigurationSummary() {
    }
    FulfillmentStatesConfigurationSummary.getAttributeTypeMap = function () {
        return FulfillmentStatesConfigurationSummary.attributeTypeMap;
    };
    FulfillmentStatesConfigurationSummary.discriminator = undefined;
    FulfillmentStatesConfigurationSummary.attributeTypeMap = [
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "ConfigurationUid",
            "baseName": "ConfigurationUid",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "FulfillmentStatesConfigurationSummary.StoreSelectorTypeEnum"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<FulfillmentStatesConfiguredStore>"
        }
    ];
    return FulfillmentStatesConfigurationSummary;
}());
exports.FulfillmentStatesConfigurationSummary = FulfillmentStatesConfigurationSummary;
(function (FulfillmentStatesConfigurationSummary) {
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = FulfillmentStatesConfigurationSummary.StoreSelectorTypeEnum || (FulfillmentStatesConfigurationSummary.StoreSelectorTypeEnum = {}));
})(FulfillmentStatesConfigurationSummary = exports.FulfillmentStatesConfigurationSummary || (exports.FulfillmentStatesConfigurationSummary = {}));
exports.FulfillmentStatesConfigurationSummary = FulfillmentStatesConfigurationSummary;
var FulfillmentStatesConfiguredStore = (function () {
    function FulfillmentStatesConfiguredStore() {
    }
    FulfillmentStatesConfiguredStore.getAttributeTypeMap = function () {
        return FulfillmentStatesConfiguredStore.attributeTypeMap;
    };
    FulfillmentStatesConfiguredStore.discriminator = undefined;
    FulfillmentStatesConfiguredStore.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return FulfillmentStatesConfiguredStore;
}());
exports.FulfillmentStatesConfiguredStore = FulfillmentStatesConfiguredStore;
var FulfillmentStatusConfigurationItem = (function () {
    function FulfillmentStatusConfigurationItem() {
    }
    FulfillmentStatusConfigurationItem.getAttributeTypeMap = function () {
        return FulfillmentStatusConfigurationItem.attributeTypeMap;
    };
    FulfillmentStatusConfigurationItem.discriminator = undefined;
    FulfillmentStatusConfigurationItem.attributeTypeMap = [
        {
            "name": "StatusId",
            "baseName": "StatusId",
            "type": "string"
        },
        {
            "name": "StatusName",
            "baseName": "StatusName",
            "type": "string"
        },
        {
            "name": "Enabled",
            "baseName": "Enabled",
            "type": "boolean"
        },
        {
            "name": "DisplayName",
            "baseName": "DisplayName",
            "type": "string"
        },
        {
            "name": "Icon",
            "baseName": "Icon",
            "type": "string"
        },
        {
            "name": "PublicDescription",
            "baseName": "PublicDescription",
            "type": "string"
        },
        {
            "name": "Internal",
            "baseName": "Internal",
            "type": "boolean"
        },
        {
            "name": "NextStatuses",
            "baseName": "NextStatuses",
            "type": "Array<string>"
        },
        {
            "name": "DefaultNextStatus",
            "baseName": "DefaultNextStatus",
            "type": "Array<NextStatusWithOrderType>"
        },
        {
            "name": "ChangeType",
            "baseName": "ChangeType",
            "type": "FulfillmentStatusConfigurationItem.ChangeTypeEnum"
        },
        {
            "name": "IncludeInReports",
            "baseName": "IncludeInReports",
            "type": "boolean"
        },
        {
            "name": "IsCustom",
            "baseName": "IsCustom",
            "type": "boolean"
        },
        {
            "name": "OrderTypes",
            "baseName": "OrderTypes",
            "type": "Array<FulfillmentStatusConfigurationItem.OrderTypesEnum>"
        },
        {
            "name": "Communication",
            "baseName": "Communication",
            "type": "boolean"
        },
        {
            "name": "Image",
            "baseName": "Image",
            "type": "string"
        }
    ];
    return FulfillmentStatusConfigurationItem;
}());
exports.FulfillmentStatusConfigurationItem = FulfillmentStatusConfigurationItem;
(function (FulfillmentStatusConfigurationItem) {
    var ChangeTypeEnum;
    (function (ChangeTypeEnum) {
        ChangeTypeEnum[ChangeTypeEnum["Manual"] = 'Manual'] = "Manual";
        ChangeTypeEnum[ChangeTypeEnum["Automated"] = 'Automated'] = "Automated";
        ChangeTypeEnum[ChangeTypeEnum["Integrated"] = 'Integrated'] = "Integrated";
    })(ChangeTypeEnum = FulfillmentStatusConfigurationItem.ChangeTypeEnum || (FulfillmentStatusConfigurationItem.ChangeTypeEnum = {}));
    var OrderTypesEnum;
    (function (OrderTypesEnum) {
        OrderTypesEnum[OrderTypesEnum["All"] = 'All'] = "All";
        OrderTypesEnum[OrderTypesEnum["Delivery"] = 'Delivery'] = "Delivery";
        OrderTypesEnum[OrderTypesEnum["Collection"] = 'Collection'] = "Collection";
        OrderTypesEnum[OrderTypesEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(OrderTypesEnum = FulfillmentStatusConfigurationItem.OrderTypesEnum || (FulfillmentStatusConfigurationItem.OrderTypesEnum = {}));
})(FulfillmentStatusConfigurationItem = exports.FulfillmentStatusConfigurationItem || (exports.FulfillmentStatusConfigurationItem = {}));
exports.FulfillmentStatusConfigurationItem = FulfillmentStatusConfigurationItem;
var GeoPointRequest = (function () {
    function GeoPointRequest() {
    }
    GeoPointRequest.getAttributeTypeMap = function () {
        return GeoPointRequest.attributeTypeMap;
    };
    GeoPointRequest.discriminator = undefined;
    GeoPointRequest.attributeTypeMap = [
        {
            "name": "Latitude",
            "baseName": "Latitude",
            "type": "number"
        },
        {
            "name": "Longitude",
            "baseName": "Longitude",
            "type": "number"
        }
    ];
    return GeoPointRequest;
}());
exports.GeoPointRequest = GeoPointRequest;
var GetReceiptByOrderIdQueryResponse = (function () {
    function GetReceiptByOrderIdQueryResponse() {
    }
    GetReceiptByOrderIdQueryResponse.getAttributeTypeMap = function () {
        return GetReceiptByOrderIdQueryResponse.attributeTypeMap;
    };
    GetReceiptByOrderIdQueryResponse.discriminator = undefined;
    GetReceiptByOrderIdQueryResponse.attributeTypeMap = [
        {
            "name": "PreviousOrder",
            "baseName": "PreviousOrder",
            "type": "PreviousOrder"
        },
        {
            "name": "TsRequestedForLocal",
            "baseName": "TsRequestedForLocal",
            "type": "Date"
        },
        {
            "name": "TsOrderPlacedLocal",
            "baseName": "TsOrderPlacedLocal",
            "type": "Date"
        },
        {
            "name": "LogoUrl",
            "baseName": "LogoUrl",
            "type": "string"
        },
        {
            "name": "Address",
            "baseName": "Address",
            "type": "string"
        },
        {
            "name": "VatNumber",
            "baseName": "VatNumber",
            "type": "string"
        },
        {
            "name": "PaymentMethodDescription",
            "baseName": "PaymentMethodDescription",
            "type": "string"
        }
    ];
    return GetReceiptByOrderIdQueryResponse;
}());
exports.GetReceiptByOrderIdQueryResponse = GetReceiptByOrderIdQueryResponse;
var GoogleAddress = (function () {
    function GoogleAddress() {
    }
    GoogleAddress.getAttributeTypeMap = function () {
        return GoogleAddress.attributeTypeMap;
    };
    GoogleAddress.discriminator = undefined;
    GoogleAddress.attributeTypeMap = [
        {
            "name": "Results",
            "baseName": "Results",
            "type": "Array<GoogleAddressResult>"
        },
        {
            "name": "Result",
            "baseName": "Result",
            "type": "GoogleAddressResult"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "string"
        }
    ];
    return GoogleAddress;
}());
exports.GoogleAddress = GoogleAddress;
var GoogleAddressComponent = (function () {
    function GoogleAddressComponent() {
    }
    GoogleAddressComponent.getAttributeTypeMap = function () {
        return GoogleAddressComponent.attributeTypeMap;
    };
    GoogleAddressComponent.discriminator = undefined;
    GoogleAddressComponent.attributeTypeMap = [
        {
            "name": "Long_name",
            "baseName": "Long_name",
            "type": "string"
        },
        {
            "name": "Short_name",
            "baseName": "Short_name",
            "type": "string"
        },
        {
            "name": "Types",
            "baseName": "Types",
            "type": "Array<string>"
        }
    ];
    return GoogleAddressComponent;
}());
exports.GoogleAddressComponent = GoogleAddressComponent;
var GoogleAddressResult = (function () {
    function GoogleAddressResult() {
    }
    GoogleAddressResult.getAttributeTypeMap = function () {
        return GoogleAddressResult.attributeTypeMap;
    };
    GoogleAddressResult.discriminator = undefined;
    GoogleAddressResult.attributeTypeMap = [
        {
            "name": "Address_components",
            "baseName": "Address_components",
            "type": "Array<GoogleAddressComponent>"
        },
        {
            "name": "Formatted_address",
            "baseName": "Formatted_address",
            "type": "string"
        },
        {
            "name": "Geometry",
            "baseName": "Geometry",
            "type": "GoogleGeometry"
        },
        {
            "name": "Place_id",
            "baseName": "Place_id",
            "type": "string"
        },
        {
            "name": "Types",
            "baseName": "Types",
            "type": "Array<string>"
        }
    ];
    return GoogleAddressResult;
}());
exports.GoogleAddressResult = GoogleAddressResult;
var GoogleCoordinates = (function () {
    function GoogleCoordinates() {
    }
    GoogleCoordinates.getAttributeTypeMap = function () {
        return GoogleCoordinates.attributeTypeMap;
    };
    GoogleCoordinates.discriminator = undefined;
    GoogleCoordinates.attributeTypeMap = [
        {
            "name": "Lat",
            "baseName": "Lat",
            "type": "number"
        },
        {
            "name": "Lng",
            "baseName": "Lng",
            "type": "number"
        }
    ];
    return GoogleCoordinates;
}());
exports.GoogleCoordinates = GoogleCoordinates;
var GoogleGeometry = (function () {
    function GoogleGeometry() {
    }
    GoogleGeometry.getAttributeTypeMap = function () {
        return GoogleGeometry.attributeTypeMap;
    };
    GoogleGeometry.discriminator = undefined;
    GoogleGeometry.attributeTypeMap = [
        {
            "name": "Location",
            "baseName": "Location",
            "type": "GoogleLocation"
        },
        {
            "name": "Location_type",
            "baseName": "Location_type",
            "type": "string"
        },
        {
            "name": "Viewport",
            "baseName": "Viewport",
            "type": "GoogleViewport"
        }
    ];
    return GoogleGeometry;
}());
exports.GoogleGeometry = GoogleGeometry;
var GoogleLocation = (function () {
    function GoogleLocation() {
    }
    GoogleLocation.getAttributeTypeMap = function () {
        return GoogleLocation.attributeTypeMap;
    };
    GoogleLocation.discriminator = undefined;
    GoogleLocation.attributeTypeMap = [
        {
            "name": "Lat",
            "baseName": "Lat",
            "type": "number"
        },
        {
            "name": "Lng",
            "baseName": "Lng",
            "type": "number"
        }
    ];
    return GoogleLocation;
}());
exports.GoogleLocation = GoogleLocation;
var GoogleViewport = (function () {
    function GoogleViewport() {
    }
    GoogleViewport.getAttributeTypeMap = function () {
        return GoogleViewport.attributeTypeMap;
    };
    GoogleViewport.discriminator = undefined;
    GoogleViewport.attributeTypeMap = [
        {
            "name": "Northeast",
            "baseName": "Northeast",
            "type": "GoogleCoordinates"
        },
        {
            "name": "Southwest",
            "baseName": "Southwest",
            "type": "GoogleCoordinates"
        }
    ];
    return GoogleViewport;
}());
exports.GoogleViewport = GoogleViewport;
var Group = (function () {
    function Group() {
    }
    Group.getAttributeTypeMap = function () {
        return Group.attributeTypeMap;
    };
    Group.discriminator = undefined;
    Group.attributeTypeMap = [
        {
            "name": "CatalogGroupId",
            "baseName": "CatalogGroupId",
            "type": "string"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "IsArchived",
            "baseName": "IsArchived",
            "type": "boolean"
        },
        {
            "name": "MinSelectCount",
            "baseName": "MinSelectCount",
            "type": "number"
        },
        {
            "name": "MaxSelectCount",
            "baseName": "MaxSelectCount",
            "type": "number"
        },
        {
            "name": "Products",
            "baseName": "Products",
            "type": "Array<ProductReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        },
        {
            "name": "GroupType",
            "baseName": "GroupType",
            "type": "Group.GroupTypeEnum"
        },
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "AutogenerateDisplayText",
            "baseName": "AutogenerateDisplayText",
            "type": "boolean"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        }
    ];
    return Group;
}());
exports.Group = Group;
(function (Group) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = Group.GroupTypeEnum || (Group.GroupTypeEnum = {}));
})(Group = exports.Group || (exports.Group = {}));
exports.Group = Group;
var GroupReference = (function () {
    function GroupReference() {
    }
    GroupReference.getAttributeTypeMap = function () {
        return GroupReference.attributeTypeMap;
    };
    GroupReference.discriminator = undefined;
    GroupReference.attributeTypeMap = [
        {
            "name": "Group",
            "baseName": "Group",
            "type": "Group"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "GroupType",
            "baseName": "GroupType",
            "type": "GroupReference.GroupTypeEnum"
        }
    ];
    return GroupReference;
}());
exports.GroupReference = GroupReference;
(function (GroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = GroupReference.GroupTypeEnum || (GroupReference.GroupTypeEnum = {}));
})(GroupReference = exports.GroupReference || (exports.GroupReference = {}));
exports.GroupReference = GroupReference;
var GroupedCoordinates = (function () {
    function GroupedCoordinates() {
    }
    GroupedCoordinates.getAttributeTypeMap = function () {
        return GroupedCoordinates.attributeTypeMap;
    };
    GroupedCoordinates.discriminator = undefined;
    GroupedCoordinates.attributeTypeMap = [
        {
            "name": "Latitude",
            "baseName": "Latitude",
            "type": "number"
        },
        {
            "name": "Longitude",
            "baseName": "Longitude",
            "type": "number"
        },
        {
            "name": "Count",
            "baseName": "Count",
            "type": "number"
        }
    ];
    return GroupedCoordinates;
}());
exports.GroupedCoordinates = GroupedCoordinates;
var HomeAction = (function () {
    function HomeAction() {
    }
    HomeAction.getAttributeTypeMap = function () {
        return HomeAction.attributeTypeMap;
    };
    HomeAction.discriminator = undefined;
    HomeAction.attributeTypeMap = [
        {
            "name": "HomeActionId",
            "baseName": "HomeActionId",
            "type": "number"
        },
        {
            "name": "HomeActionType",
            "baseName": "HomeActionType",
            "type": "HomeAction.HomeActionTypeEnum"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "number"
        },
        {
            "name": "TitleKey",
            "baseName": "TitleKey",
            "type": "string"
        },
        {
            "name": "ActionKey",
            "baseName": "ActionKey",
            "type": "string"
        },
        {
            "name": "DescriptionKey",
            "baseName": "DescriptionKey",
            "type": "string"
        },
        {
            "name": "Action",
            "baseName": "Action",
            "type": "string"
        },
        {
            "name": "Dismissible",
            "baseName": "Dismissible",
            "type": "boolean"
        }
    ];
    return HomeAction;
}());
exports.HomeAction = HomeAction;
(function (HomeAction) {
    var HomeActionTypeEnum;
    (function (HomeActionTypeEnum) {
        HomeActionTypeEnum[HomeActionTypeEnum["Portal"] = 'Portal'] = "Portal";
        HomeActionTypeEnum[HomeActionTypeEnum["External"] = 'External'] = "External";
    })(HomeActionTypeEnum = HomeAction.HomeActionTypeEnum || (HomeAction.HomeActionTypeEnum = {}));
})(HomeAction = exports.HomeAction || (exports.HomeAction = {}));
exports.HomeAction = HomeAction;
var HomeStatistics = (function () {
    function HomeStatistics() {
    }
    HomeStatistics.getAttributeTypeMap = function () {
        return HomeStatistics.attributeTypeMap;
    };
    HomeStatistics.discriminator = undefined;
    HomeStatistics.attributeTypeMap = [
        {
            "name": "TotalMoneySaved",
            "baseName": "TotalMoneySaved",
            "type": "Array<CurrencyData>"
        }
    ];
    return HomeStatistics;
}());
exports.HomeStatistics = HomeStatistics;
var HttpRequestAndResponseLog = (function () {
    function HttpRequestAndResponseLog() {
    }
    HttpRequestAndResponseLog.getAttributeTypeMap = function () {
        return HttpRequestAndResponseLog.attributeTypeMap;
    };
    HttpRequestAndResponseLog.discriminator = undefined;
    HttpRequestAndResponseLog.attributeTypeMap = [
        {
            "name": "Guid",
            "baseName": "Guid",
            "type": "string"
        },
        {
            "name": "Verb",
            "baseName": "Verb",
            "type": "string"
        },
        {
            "name": "RequestUri",
            "baseName": "RequestUri",
            "type": "string"
        },
        {
            "name": "StatusCode",
            "baseName": "StatusCode",
            "type": "number"
        },
        {
            "name": "ReasonPhrase",
            "baseName": "ReasonPhrase",
            "type": "string"
        },
        {
            "name": "CallDurationInMilliseconds",
            "baseName": "CallDurationInMilliseconds",
            "type": "number"
        },
        {
            "name": "UserId",
            "baseName": "UserId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        },
        {
            "name": "CreatedDateTime",
            "baseName": "CreatedDateTime",
            "type": "string"
        },
        {
            "name": "RequestHeaders",
            "baseName": "RequestHeaders",
            "type": "{ [key: string]: string; }"
        },
        {
            "name": "RequestBody",
            "baseName": "RequestBody",
            "type": "string"
        },
        {
            "name": "RequestLength",
            "baseName": "RequestLength",
            "type": "number"
        },
        {
            "name": "ResponseHeaders",
            "baseName": "ResponseHeaders",
            "type": "{ [key: string]: string; }"
        },
        {
            "name": "ResponseBody",
            "baseName": "ResponseBody",
            "type": "string"
        },
        {
            "name": "ResponseLength",
            "baseName": "ResponseLength",
            "type": "number"
        }
    ];
    return HttpRequestAndResponseLog;
}());
exports.HttpRequestAndResponseLog = HttpRequestAndResponseLog;
var HydraAssignedEvent = (function () {
    function HydraAssignedEvent() {
    }
    HydraAssignedEvent.getAttributeTypeMap = function () {
        return HydraAssignedEvent.attributeTypeMap;
    };
    HydraAssignedEvent.discriminator = undefined;
    HydraAssignedEvent.attributeTypeMap = [
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "HydraStatus",
            "baseName": "HydraStatus",
            "type": "HydraStatus"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return HydraAssignedEvent;
}());
exports.HydraAssignedEvent = HydraAssignedEvent;
var HydraConfig = (function () {
    function HydraConfig() {
    }
    HydraConfig.getAttributeTypeMap = function () {
        return HydraConfig.attributeTypeMap;
    };
    HydraConfig.discriminator = undefined;
    HydraConfig.attributeTypeMap = [
        {
            "name": "MinimumVersion",
            "baseName": "MinimumVersion",
            "type": "string"
        },
        {
            "name": "PaymentOptions",
            "baseName": "PaymentOptions",
            "type": "Array<HydraConfig.PaymentOptionsEnum>"
        },
        {
            "name": "DeviceSettings",
            "baseName": "DeviceSettings",
            "type": "DeviceSettings"
        },
        {
            "name": "Version",
            "baseName": "Version",
            "type": "string"
        },
        {
            "name": "BuildNumber",
            "baseName": "BuildNumber",
            "type": "string"
        },
        {
            "name": "GitSha",
            "baseName": "GitSha",
            "type": "string"
        },
        {
            "name": "GitBranch",
            "baseName": "GitBranch",
            "type": "string"
        }
    ];
    return HydraConfig;
}());
exports.HydraConfig = HydraConfig;
(function (HydraConfig) {
    var PaymentOptionsEnum;
    (function (PaymentOptionsEnum) {
        PaymentOptionsEnum[PaymentOptionsEnum["Online"] = 'Online'] = "Online";
        PaymentOptionsEnum[PaymentOptionsEnum["Emv"] = 'Emv'] = "Emv";
        PaymentOptionsEnum[PaymentOptionsEnum["Counter"] = 'Counter'] = "Counter";
    })(PaymentOptionsEnum = HydraConfig.PaymentOptionsEnum || (HydraConfig.PaymentOptionsEnum = {}));
})(HydraConfig = exports.HydraConfig || (exports.HydraConfig = {}));
exports.HydraConfig = HydraConfig;
var HydraConnectionStatusChangedEvent = (function () {
    function HydraConnectionStatusChangedEvent() {
    }
    HydraConnectionStatusChangedEvent.getAttributeTypeMap = function () {
        return HydraConnectionStatusChangedEvent.attributeTypeMap;
    };
    HydraConnectionStatusChangedEvent.discriminator = undefined;
    HydraConnectionStatusChangedEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "HydraDeviceStatus",
            "baseName": "HydraDeviceStatus",
            "type": "HydraConnectionStatusChangedEvent.HydraDeviceStatusEnum"
        },
        {
            "name": "PollTime",
            "baseName": "PollTime",
            "type": "Date"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return HydraConnectionStatusChangedEvent;
}());
exports.HydraConnectionStatusChangedEvent = HydraConnectionStatusChangedEvent;
(function (HydraConnectionStatusChangedEvent) {
    var HydraDeviceStatusEnum;
    (function (HydraDeviceStatusEnum) {
        HydraDeviceStatusEnum[HydraDeviceStatusEnum["Online"] = 'Online'] = "Online";
        HydraDeviceStatusEnum[HydraDeviceStatusEnum["PossiblyOffline"] = 'PossiblyOffline'] = "PossiblyOffline";
        HydraDeviceStatusEnum[HydraDeviceStatusEnum["Offline"] = 'Offline'] = "Offline";
    })(HydraDeviceStatusEnum = HydraConnectionStatusChangedEvent.HydraDeviceStatusEnum || (HydraConnectionStatusChangedEvent.HydraDeviceStatusEnum = {}));
})(HydraConnectionStatusChangedEvent = exports.HydraConnectionStatusChangedEvent || (exports.HydraConnectionStatusChangedEvent = {}));
exports.HydraConnectionStatusChangedEvent = HydraConnectionStatusChangedEvent;
var HydraDeviceDetails = (function () {
    function HydraDeviceDetails() {
    }
    HydraDeviceDetails.getAttributeTypeMap = function () {
        return HydraDeviceDetails.attributeTypeMap;
    };
    HydraDeviceDetails.discriminator = undefined;
    HydraDeviceDetails.attributeTypeMap = [
        {
            "name": "HydraConfigId",
            "baseName": "HydraConfigId",
            "type": "number"
        },
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "SerialNumber",
            "baseName": "SerialNumber",
            "type": "string"
        },
        {
            "name": "DeviceType",
            "baseName": "DeviceType",
            "type": "HydraDeviceDetails.DeviceTypeEnum"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "HydraDeviceDetails.StatusEnum"
        },
        {
            "name": "DeviceName",
            "baseName": "DeviceName",
            "type": "string"
        },
        {
            "name": "StoreNames",
            "baseName": "StoreNames",
            "type": "Array<HydraStoreData>"
        },
        {
            "name": "LastPollUtc",
            "baseName": "LastPollUtc",
            "type": "Date"
        },
        {
            "name": "Version",
            "baseName": "Version",
            "type": "string"
        },
        {
            "name": "BuildNumber",
            "baseName": "BuildNumber",
            "type": "string"
        },
        {
            "name": "GitSha",
            "baseName": "GitSha",
            "type": "string"
        },
        {
            "name": "GitBranch",
            "baseName": "GitBranch",
            "type": "string"
        }
    ];
    return HydraDeviceDetails;
}());
exports.HydraDeviceDetails = HydraDeviceDetails;
(function (HydraDeviceDetails) {
    var DeviceTypeEnum;
    (function (DeviceTypeEnum) {
        DeviceTypeEnum[DeviceTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        DeviceTypeEnum[DeviceTypeEnum["Terminal"] = 'Terminal'] = "Terminal";
        DeviceTypeEnum[DeviceTypeEnum["LegacyPrinter"] = 'LegacyPrinter'] = "LegacyPrinter";
    })(DeviceTypeEnum = HydraDeviceDetails.DeviceTypeEnum || (HydraDeviceDetails.DeviceTypeEnum = {}));
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Online"] = 'Online'] = "Online";
        StatusEnum[StatusEnum["PossiblyOffline"] = 'PossiblyOffline'] = "PossiblyOffline";
        StatusEnum[StatusEnum["Offline"] = 'Offline'] = "Offline";
    })(StatusEnum = HydraDeviceDetails.StatusEnum || (HydraDeviceDetails.StatusEnum = {}));
})(HydraDeviceDetails = exports.HydraDeviceDetails || (exports.HydraDeviceDetails = {}));
exports.HydraDeviceDetails = HydraDeviceDetails;
var HydraRegistrationRequest = (function () {
    function HydraRegistrationRequest() {
    }
    HydraRegistrationRequest.getAttributeTypeMap = function () {
        return HydraRegistrationRequest.attributeTypeMap;
    };
    HydraRegistrationRequest.discriminator = undefined;
    HydraRegistrationRequest.attributeTypeMap = [
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "DeviceName",
            "baseName": "DeviceName",
            "type": "string"
        },
        {
            "name": "PinCode",
            "baseName": "PinCode",
            "type": "number"
        }
    ];
    return HydraRegistrationRequest;
}());
exports.HydraRegistrationRequest = HydraRegistrationRequest;
var HydraRequestResetEvent = (function () {
    function HydraRequestResetEvent() {
    }
    HydraRequestResetEvent.getAttributeTypeMap = function () {
        return HydraRequestResetEvent.attributeTypeMap;
    };
    HydraRequestResetEvent.discriminator = undefined;
    HydraRequestResetEvent.attributeTypeMap = [
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return HydraRequestResetEvent;
}());
exports.HydraRequestResetEvent = HydraRequestResetEvent;
var HydraSettingChangedEvent = (function () {
    function HydraSettingChangedEvent() {
    }
    HydraSettingChangedEvent.getAttributeTypeMap = function () {
        return HydraSettingChangedEvent.attributeTypeMap;
    };
    HydraSettingChangedEvent.discriminator = undefined;
    HydraSettingChangedEvent.attributeTypeMap = [
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "HydraConfig",
            "baseName": "HydraConfig",
            "type": "HydraConfig"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return HydraSettingChangedEvent;
}());
exports.HydraSettingChangedEvent = HydraSettingChangedEvent;
var HydraStatus = (function () {
    function HydraStatus() {
    }
    HydraStatus.getAttributeTypeMap = function () {
        return HydraStatus.attributeTypeMap;
    };
    HydraStatus.discriminator = undefined;
    HydraStatus.attributeTypeMap = [
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "IsRegistered",
            "baseName": "IsRegistered",
            "type": "boolean"
        },
        {
            "name": "PinCode",
            "baseName": "PinCode",
            "type": "number"
        },
        {
            "name": "Images",
            "baseName": "Images",
            "type": "Array<string>"
        },
        {
            "name": "UserType",
            "baseName": "UserType",
            "type": "HydraStatus.UserTypeEnum"
        }
    ];
    return HydraStatus;
}());
exports.HydraStatus = HydraStatus;
(function (HydraStatus) {
    var UserTypeEnum;
    (function (UserTypeEnum) {
        UserTypeEnum[UserTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        UserTypeEnum[UserTypeEnum["Terminal"] = 'Terminal'] = "Terminal";
        UserTypeEnum[UserTypeEnum["LegacyPrinter"] = 'LegacyPrinter'] = "LegacyPrinter";
    })(UserTypeEnum = HydraStatus.UserTypeEnum || (HydraStatus.UserTypeEnum = {}));
})(HydraStatus = exports.HydraStatus || (exports.HydraStatus = {}));
exports.HydraStatus = HydraStatus;
var HydraStoreAssignedEvent = (function () {
    function HydraStoreAssignedEvent() {
    }
    HydraStoreAssignedEvent.getAttributeTypeMap = function () {
        return HydraStoreAssignedEvent.attributeTypeMap;
    };
    HydraStoreAssignedEvent.discriminator = undefined;
    HydraStoreAssignedEvent.attributeTypeMap = [
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return HydraStoreAssignedEvent;
}());
exports.HydraStoreAssignedEvent = HydraStoreAssignedEvent;
var HydraStoreData = (function () {
    function HydraStoreData() {
    }
    HydraStoreData.getAttributeTypeMap = function () {
        return HydraStoreData.attributeTypeMap;
    };
    HydraStoreData.discriminator = undefined;
    HydraStoreData.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        }
    ];
    return HydraStoreData;
}());
exports.HydraStoreData = HydraStoreData;
var HydraStoreUnassignedEvent = (function () {
    function HydraStoreUnassignedEvent() {
    }
    HydraStoreUnassignedEvent.getAttributeTypeMap = function () {
        return HydraStoreUnassignedEvent.attributeTypeMap;
    };
    HydraStoreUnassignedEvent.discriminator = undefined;
    HydraStoreUnassignedEvent.attributeTypeMap = [
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return HydraStoreUnassignedEvent;
}());
exports.HydraStoreUnassignedEvent = HydraStoreUnassignedEvent;
var HydraUnAssignedEvent = (function () {
    function HydraUnAssignedEvent() {
    }
    HydraUnAssignedEvent.getAttributeTypeMap = function () {
        return HydraUnAssignedEvent.attributeTypeMap;
    };
    HydraUnAssignedEvent.discriminator = undefined;
    HydraUnAssignedEvent.attributeTypeMap = [
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "HydraStatus",
            "baseName": "HydraStatus",
            "type": "HydraStatus"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return HydraUnAssignedEvent;
}());
exports.HydraUnAssignedEvent = HydraUnAssignedEvent;
var IndexPage = (function () {
    function IndexPage() {
    }
    IndexPage.getAttributeTypeMap = function () {
        return IndexPage.attributeTypeMap;
    };
    IndexPage.discriminator = undefined;
    IndexPage.attributeTypeMap = [
        {
            "name": "Testimonials",
            "baseName": "Testimonials",
            "type": "Array<WebsiteTestimonial>"
        },
        {
            "name": "Images",
            "baseName": "Images",
            "type": "Array<WebsiteImage>"
        },
        {
            "name": "AboutSectionEnabled",
            "baseName": "AboutSectionEnabled",
            "type": "boolean"
        },
        {
            "name": "AboutSectionTitle",
            "baseName": "AboutSectionTitle",
            "type": "string"
        },
        {
            "name": "AboutSectionSubtitle",
            "baseName": "AboutSectionSubtitle",
            "type": "string"
        },
        {
            "name": "AboutSectionLeftTitle",
            "baseName": "AboutSectionLeftTitle",
            "type": "string"
        },
        {
            "name": "AboutSectionLeftBody",
            "baseName": "AboutSectionLeftBody",
            "type": "string"
        },
        {
            "name": "AboutSectionRightTitle",
            "baseName": "AboutSectionRightTitle",
            "type": "string"
        },
        {
            "name": "AboutSectionRightBody",
            "baseName": "AboutSectionRightBody",
            "type": "string"
        },
        {
            "name": "OpeningHoursEnabled",
            "baseName": "OpeningHoursEnabled",
            "type": "boolean"
        },
        {
            "name": "MenuPreviewEnabled",
            "baseName": "MenuPreviewEnabled",
            "type": "boolean"
        },
        {
            "name": "GalleryEnabled",
            "baseName": "GalleryEnabled",
            "type": "boolean"
        },
        {
            "name": "TestimonialsEnabled",
            "baseName": "TestimonialsEnabled",
            "type": "boolean"
        },
        {
            "name": "ContactFormEnabled",
            "baseName": "ContactFormEnabled",
            "type": "boolean"
        },
        {
            "name": "ContactFormEmail",
            "baseName": "ContactFormEmail",
            "type": "string"
        },
        {
            "name": "MapEnabled",
            "baseName": "MapEnabled",
            "type": "boolean"
        }
    ];
    return IndexPage;
}());
exports.IndexPage = IndexPage;
var IndexPageBase = (function () {
    function IndexPageBase() {
    }
    IndexPageBase.getAttributeTypeMap = function () {
        return IndexPageBase.attributeTypeMap;
    };
    IndexPageBase.discriminator = undefined;
    IndexPageBase.attributeTypeMap = [
        {
            "name": "AboutSectionEnabled",
            "baseName": "AboutSectionEnabled",
            "type": "boolean"
        },
        {
            "name": "AboutSectionTitle",
            "baseName": "AboutSectionTitle",
            "type": "string"
        },
        {
            "name": "AboutSectionSubtitle",
            "baseName": "AboutSectionSubtitle",
            "type": "string"
        },
        {
            "name": "AboutSectionLeftTitle",
            "baseName": "AboutSectionLeftTitle",
            "type": "string"
        },
        {
            "name": "AboutSectionLeftBody",
            "baseName": "AboutSectionLeftBody",
            "type": "string"
        },
        {
            "name": "AboutSectionRightTitle",
            "baseName": "AboutSectionRightTitle",
            "type": "string"
        },
        {
            "name": "AboutSectionRightBody",
            "baseName": "AboutSectionRightBody",
            "type": "string"
        },
        {
            "name": "OpeningHoursEnabled",
            "baseName": "OpeningHoursEnabled",
            "type": "boolean"
        },
        {
            "name": "MenuPreviewEnabled",
            "baseName": "MenuPreviewEnabled",
            "type": "boolean"
        },
        {
            "name": "GalleryEnabled",
            "baseName": "GalleryEnabled",
            "type": "boolean"
        },
        {
            "name": "TestimonialsEnabled",
            "baseName": "TestimonialsEnabled",
            "type": "boolean"
        },
        {
            "name": "ContactFormEnabled",
            "baseName": "ContactFormEnabled",
            "type": "boolean"
        },
        {
            "name": "ContactFormEmail",
            "baseName": "ContactFormEmail",
            "type": "string"
        },
        {
            "name": "MapEnabled",
            "baseName": "MapEnabled",
            "type": "boolean"
        }
    ];
    return IndexPageBase;
}());
exports.IndexPageBase = IndexPageBase;
var IntercomUserHash = (function () {
    function IntercomUserHash() {
    }
    IntercomUserHash.getAttributeTypeMap = function () {
        return IntercomUserHash.attributeTypeMap;
    };
    IntercomUserHash.discriminator = undefined;
    IntercomUserHash.attributeTypeMap = [
        {
            "name": "UserHash",
            "baseName": "UserHash",
            "type": "string"
        }
    ];
    return IntercomUserHash;
}());
exports.IntercomUserHash = IntercomUserHash;
var Invoice = (function () {
    function Invoice() {
    }
    Invoice.getAttributeTypeMap = function () {
        return Invoice.attributeTypeMap;
    };
    Invoice.discriminator = undefined;
    Invoice.attributeTypeMap = [
        {
            "name": "InvoiceId",
            "baseName": "InvoiceId",
            "type": "string"
        },
        {
            "name": "Number",
            "baseName": "Number",
            "type": "string"
        },
        {
            "name": "Total",
            "baseName": "Total",
            "type": "number"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "Invoice.CurrencyEnum"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "Invoice.StatusEnum"
        },
        {
            "name": "SubscriptionId",
            "baseName": "SubscriptionId",
            "type": "string"
        },
        {
            "name": "PaidAt",
            "baseName": "PaidAt",
            "type": "Date"
        },
        {
            "name": "FinalisedAt",
            "baseName": "FinalisedAt",
            "type": "Date"
        },
        {
            "name": "PdfLink",
            "baseName": "PdfLink",
            "type": "string"
        },
        {
            "name": "HostedUrl",
            "baseName": "HostedUrl",
            "type": "string"
        },
        {
            "name": "Overdue",
            "baseName": "Overdue",
            "type": "boolean"
        }
    ];
    return Invoice;
}());
exports.Invoice = Invoice;
(function (Invoice) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Invoice.CurrencyEnum || (Invoice.CurrencyEnum = {}));
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Draft"] = 'Draft'] = "Draft";
        StatusEnum[StatusEnum["Open"] = 'Open'] = "Open";
        StatusEnum[StatusEnum["Paid"] = 'Paid'] = "Paid";
        StatusEnum[StatusEnum["UnCollectible"] = 'UnCollectible'] = "UnCollectible";
        StatusEnum[StatusEnum["Void"] = 'Void'] = "Void";
    })(StatusEnum = Invoice.StatusEnum || (Invoice.StatusEnum = {}));
})(Invoice = exports.Invoice || (exports.Invoice = {}));
exports.Invoice = Invoice;
var InvoiceDiscount = (function () {
    function InvoiceDiscount() {
    }
    InvoiceDiscount.getAttributeTypeMap = function () {
        return InvoiceDiscount.attributeTypeMap;
    };
    InvoiceDiscount.discriminator = undefined;
    InvoiceDiscount.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        }
    ];
    return InvoiceDiscount;
}());
exports.InvoiceDiscount = InvoiceDiscount;
var InvoiceItem = (function () {
    function InvoiceItem() {
    }
    InvoiceItem.getAttributeTypeMap = function () {
        return InvoiceItem.attributeTypeMap;
    };
    InvoiceItem.discriminator = undefined;
    InvoiceItem.attributeTypeMap = [
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Quantity",
            "baseName": "Quantity",
            "type": "number"
        },
        {
            "name": "UnitAmountExcludingTax",
            "baseName": "UnitAmountExcludingTax",
            "type": "number"
        },
        {
            "name": "Tax",
            "baseName": "Tax",
            "type": "number"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "Period",
            "baseName": "Period",
            "type": "InvoicePeriod"
        }
    ];
    return InvoiceItem;
}());
exports.InvoiceItem = InvoiceItem;
var InvoicePeriod = (function () {
    function InvoicePeriod() {
    }
    InvoicePeriod.getAttributeTypeMap = function () {
        return InvoicePeriod.attributeTypeMap;
    };
    InvoicePeriod.discriminator = undefined;
    InvoicePeriod.attributeTypeMap = [
        {
            "name": "Start",
            "baseName": "Start",
            "type": "Date"
        },
        {
            "name": "End",
            "baseName": "End",
            "type": "Date"
        }
    ];
    return InvoicePeriod;
}());
exports.InvoicePeriod = InvoicePeriod;
var ItemNutritionInfoAddUpdateModel = (function () {
    function ItemNutritionInfoAddUpdateModel() {
    }
    ItemNutritionInfoAddUpdateModel.getAttributeTypeMap = function () {
        return ItemNutritionInfoAddUpdateModel.attributeTypeMap;
    };
    ItemNutritionInfoAddUpdateModel.discriminator = undefined;
    ItemNutritionInfoAddUpdateModel.attributeTypeMap = [
        {
            "name": "Labels",
            "baseName": "Labels",
            "type": "Array<NutritionInfoItemAddUpdateLabelModel>"
        }
    ];
    return ItemNutritionInfoAddUpdateModel;
}());
exports.ItemNutritionInfoAddUpdateModel = ItemNutritionInfoAddUpdateModel;
var JobAddress = (function () {
    function JobAddress() {
    }
    JobAddress.getAttributeTypeMap = function () {
        return JobAddress.attributeTypeMap;
    };
    JobAddress.discriminator = undefined;
    JobAddress.attributeTypeMap = [
        {
            "name": "Street",
            "baseName": "Street",
            "type": "string"
        },
        {
            "name": "Postcode",
            "baseName": "Postcode",
            "type": "string"
        },
        {
            "name": "City",
            "baseName": "City",
            "type": "string"
        },
        {
            "name": "Country",
            "baseName": "Country",
            "type": "string"
        },
        {
            "name": "Zone",
            "baseName": "Zone",
            "type": "string"
        },
        {
            "name": "FormattedAddress",
            "baseName": "FormattedAddress",
            "type": "string"
        }
    ];
    return JobAddress;
}());
exports.JobAddress = JobAddress;
var JobCancellation = (function () {
    function JobCancellation() {
    }
    JobCancellation.getAttributeTypeMap = function () {
        return JobCancellation.attributeTypeMap;
    };
    JobCancellation.discriminator = undefined;
    JobCancellation.attributeTypeMap = [
        {
            "name": "CanceledBy",
            "baseName": "CanceledBy",
            "type": "string"
        },
        {
            "name": "ReasonKey",
            "baseName": "ReasonKey",
            "type": "string"
        },
        {
            "name": "Comment",
            "baseName": "Comment",
            "type": "string"
        }
    ];
    return JobCancellation;
}());
exports.JobCancellation = JobCancellation;
var JobContact = (function () {
    function JobContact() {
    }
    JobContact.getAttributeTypeMap = function () {
        return JobContact.attributeTypeMap;
    };
    JobContact.discriminator = undefined;
    JobContact.attributeTypeMap = [
        {
            "name": "Firstname",
            "baseName": "Firstname",
            "type": "string"
        },
        {
            "name": "Lastname",
            "baseName": "Lastname",
            "type": "string"
        },
        {
            "name": "Phone",
            "baseName": "Phone",
            "type": "string"
        },
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "Company",
            "baseName": "Company",
            "type": "string"
        },
        {
            "name": "CompanyName",
            "baseName": "CompanyName",
            "type": "string"
        }
    ];
    return JobContact;
}());
exports.JobContact = JobContact;
var JobDelivery = (function () {
    function JobDelivery() {
    }
    JobDelivery.getAttributeTypeMap = function () {
        return JobDelivery.attributeTypeMap;
    };
    JobDelivery.discriminator = undefined;
    JobDelivery.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "string"
        },
        {
            "name": "PickedAt",
            "baseName": "PickedAt",
            "type": "string"
        },
        {
            "name": "DeliveredAt",
            "baseName": "DeliveredAt",
            "type": "string"
        },
        {
            "name": "TrackingUrl",
            "baseName": "TrackingUrl",
            "type": "string"
        },
        {
            "name": "ClientReference",
            "baseName": "ClientReference",
            "type": "string"
        },
        {
            "name": "PackageDescription",
            "baseName": "PackageDescription",
            "type": "string"
        },
        {
            "name": "PackageType",
            "baseName": "PackageType",
            "type": "string"
        },
        {
            "name": "Pickup",
            "baseName": "Pickup",
            "type": "JobDeliveryDetail"
        },
        {
            "name": "Dropoff",
            "baseName": "Dropoff",
            "type": "JobDeliveryDetail"
        },
        {
            "name": "Eta",
            "baseName": "Eta",
            "type": "JobEta"
        },
        {
            "name": "Cancellation",
            "baseName": "Cancellation",
            "type": "JobCancellation"
        },
        {
            "name": "Proof",
            "baseName": "Proof",
            "type": "JobProof"
        }
    ];
    return JobDelivery;
}());
exports.JobDelivery = JobDelivery;
var JobDeliveryDetail = (function () {
    function JobDeliveryDetail() {
    }
    JobDeliveryDetail.getAttributeTypeMap = function () {
        return JobDeliveryDetail.attributeTypeMap;
    };
    JobDeliveryDetail.discriminator = undefined;
    JobDeliveryDetail.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "Latitude",
            "baseName": "Latitude",
            "type": "number"
        },
        {
            "name": "Longitude",
            "baseName": "Longitude",
            "type": "number"
        },
        {
            "name": "Comment",
            "baseName": "Comment",
            "type": "string"
        },
        {
            "name": "Address",
            "baseName": "Address",
            "type": "JobAddress"
        },
        {
            "name": "Contact",
            "baseName": "Contact",
            "type": "JobContact"
        }
    ];
    return JobDeliveryDetail;
}());
exports.JobDeliveryDetail = JobDeliveryDetail;
var JobDriver = (function () {
    function JobDriver() {
    }
    JobDriver.getAttributeTypeMap = function () {
        return JobDriver.attributeTypeMap;
    };
    JobDriver.discriminator = undefined;
    JobDriver.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "DisplayName",
            "baseName": "DisplayName",
            "type": "string"
        },
        {
            "name": "Phone",
            "baseName": "Phone",
            "type": "string"
        },
        {
            "name": "PictureUrl",
            "baseName": "PictureUrl",
            "type": "string"
        },
        {
            "name": "TransportType",
            "baseName": "TransportType",
            "type": "string"
        },
        {
            "name": "Latitude",
            "baseName": "Latitude",
            "type": "number"
        },
        {
            "name": "Longitude",
            "baseName": "Longitude",
            "type": "number"
        }
    ];
    return JobDriver;
}());
exports.JobDriver = JobDriver;
var JobEta = (function () {
    function JobEta() {
    }
    JobEta.getAttributeTypeMap = function () {
        return JobEta.attributeTypeMap;
    };
    JobEta.discriminator = undefined;
    JobEta.attributeTypeMap = [
        {
            "name": "Pickup",
            "baseName": "Pickup",
            "type": "string"
        },
        {
            "name": "Dropoff",
            "baseName": "Dropoff",
            "type": "string"
        }
    ];
    return JobEta;
}());
exports.JobEta = JobEta;
var JobPricing = (function () {
    function JobPricing() {
    }
    JobPricing.getAttributeTypeMap = function () {
        return JobPricing.attributeTypeMap;
    };
    JobPricing.discriminator = undefined;
    JobPricing.attributeTypeMap = [
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "string"
        },
        {
            "name": "TaxPercentage",
            "baseName": "TaxPercentage",
            "type": "number"
        },
        {
            "name": "PriceTaxIncluded",
            "baseName": "PriceTaxIncluded",
            "type": "number"
        },
        {
            "name": "PriceTaxExcluded",
            "baseName": "PriceTaxExcluded",
            "type": "number"
        },
        {
            "name": "TaxAmount",
            "baseName": "TaxAmount",
            "type": "number"
        },
        {
            "name": "InvoiceUrl",
            "baseName": "InvoiceUrl",
            "type": "string"
        }
    ];
    return JobPricing;
}());
exports.JobPricing = JobPricing;
var JobProof = (function () {
    function JobProof() {
    }
    JobProof.getAttributeTypeMap = function () {
        return JobProof.attributeTypeMap;
    };
    JobProof.discriminator = undefined;
    JobProof.attributeTypeMap = [
        {
            "name": "SignatureUrl",
            "baseName": "SignatureUrl",
            "type": "string"
        }
    ];
    return JobProof;
}());
exports.JobProof = JobProof;
var JobResponse = (function () {
    function JobResponse() {
    }
    JobResponse.getAttributeTypeMap = function () {
        return JobResponse.attributeTypeMap;
    };
    JobResponse.discriminator = undefined;
    JobResponse.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "CreatedAt",
            "baseName": "CreatedAt",
            "type": "Date"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "string"
        },
        {
            "name": "PackageType",
            "baseName": "PackageType",
            "type": "string"
        },
        {
            "name": "TransportType",
            "baseName": "TransportType",
            "type": "string"
        },
        {
            "name": "AssignmentCode",
            "baseName": "AssignmentCode",
            "type": "string"
        },
        {
            "name": "PickupAt",
            "baseName": "PickupAt",
            "type": "string"
        },
        {
            "name": "DropoffAt",
            "baseName": "DropoffAt",
            "type": "string"
        },
        {
            "name": "Comment",
            "baseName": "Comment",
            "type": "string"
        },
        {
            "name": "Distance",
            "baseName": "Distance",
            "type": "number"
        },
        {
            "name": "Duration",
            "baseName": "Duration",
            "type": "number"
        },
        {
            "name": "Deliveries",
            "baseName": "Deliveries",
            "type": "Array<JobDelivery>"
        },
        {
            "name": "Pricing",
            "baseName": "Pricing",
            "type": "JobPricing"
        },
        {
            "name": "Driver",
            "baseName": "Driver",
            "type": "JobDriver"
        }
    ];
    return JobResponse;
}());
exports.JobResponse = JobResponse;
var KioskBluetoothInstallUpdateInitiateEvent = (function () {
    function KioskBluetoothInstallUpdateInitiateEvent() {
    }
    KioskBluetoothInstallUpdateInitiateEvent.getAttributeTypeMap = function () {
        return KioskBluetoothInstallUpdateInitiateEvent.attributeTypeMap;
    };
    KioskBluetoothInstallUpdateInitiateEvent.discriminator = undefined;
    KioskBluetoothInstallUpdateInitiateEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalType",
            "baseName": "BluetoothTerminalType",
            "type": "KioskBluetoothInstallUpdateInitiateEvent.BluetoothTerminalTypeEnum"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothInstallUpdateInitiateEvent;
}());
exports.KioskBluetoothInstallUpdateInitiateEvent = KioskBluetoothInstallUpdateInitiateEvent;
(function (KioskBluetoothInstallUpdateInitiateEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothInstallUpdateInitiateEvent.BluetoothTerminalTypeEnum || (KioskBluetoothInstallUpdateInitiateEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothInstallUpdateInitiateEvent = exports.KioskBluetoothInstallUpdateInitiateEvent || (exports.KioskBluetoothInstallUpdateInitiateEvent = {}));
exports.KioskBluetoothInstallUpdateInitiateEvent = KioskBluetoothInstallUpdateInitiateEvent;
var KioskBluetoothPairingModeEvent = (function () {
    function KioskBluetoothPairingModeEvent() {
    }
    KioskBluetoothPairingModeEvent.getAttributeTypeMap = function () {
        return KioskBluetoothPairingModeEvent.attributeTypeMap;
    };
    KioskBluetoothPairingModeEvent.discriminator = undefined;
    KioskBluetoothPairingModeEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalType",
            "baseName": "BluetoothTerminalType",
            "type": "KioskBluetoothPairingModeEvent.BluetoothTerminalTypeEnum"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothPairingModeEvent;
}());
exports.KioskBluetoothPairingModeEvent = KioskBluetoothPairingModeEvent;
(function (KioskBluetoothPairingModeEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothPairingModeEvent.BluetoothTerminalTypeEnum || (KioskBluetoothPairingModeEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothPairingModeEvent = exports.KioskBluetoothPairingModeEvent || (exports.KioskBluetoothPairingModeEvent = {}));
exports.KioskBluetoothPairingModeEvent = KioskBluetoothPairingModeEvent;
var KioskBluetoothTerminalCancelUpdateEvent = (function () {
    function KioskBluetoothTerminalCancelUpdateEvent() {
    }
    KioskBluetoothTerminalCancelUpdateEvent.getAttributeTypeMap = function () {
        return KioskBluetoothTerminalCancelUpdateEvent.attributeTypeMap;
    };
    KioskBluetoothTerminalCancelUpdateEvent.discriminator = undefined;
    KioskBluetoothTerminalCancelUpdateEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalType",
            "baseName": "BluetoothTerminalType",
            "type": "KioskBluetoothTerminalCancelUpdateEvent.BluetoothTerminalTypeEnum"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothTerminalCancelUpdateEvent;
}());
exports.KioskBluetoothTerminalCancelUpdateEvent = KioskBluetoothTerminalCancelUpdateEvent;
(function (KioskBluetoothTerminalCancelUpdateEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothTerminalCancelUpdateEvent.BluetoothTerminalTypeEnum || (KioskBluetoothTerminalCancelUpdateEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothTerminalCancelUpdateEvent = exports.KioskBluetoothTerminalCancelUpdateEvent || (exports.KioskBluetoothTerminalCancelUpdateEvent = {}));
exports.KioskBluetoothTerminalCancelUpdateEvent = KioskBluetoothTerminalCancelUpdateEvent;
var KioskBluetoothTerminalFirmwareVersionStatusEvent = (function () {
    function KioskBluetoothTerminalFirmwareVersionStatusEvent() {
    }
    KioskBluetoothTerminalFirmwareVersionStatusEvent.getAttributeTypeMap = function () {
        return KioskBluetoothTerminalFirmwareVersionStatusEvent.attributeTypeMap;
    };
    KioskBluetoothTerminalFirmwareVersionStatusEvent.discriminator = undefined;
    KioskBluetoothTerminalFirmwareVersionStatusEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "SerialNumber",
            "baseName": "SerialNumber",
            "type": "string"
        },
        {
            "name": "HasFirmwareUpdate",
            "baseName": "HasFirmwareUpdate",
            "type": "boolean"
        },
        {
            "name": "HasConfigUpdate",
            "baseName": "HasConfigUpdate",
            "type": "boolean"
        },
        {
            "name": "HasKeyUpdate",
            "baseName": "HasKeyUpdate",
            "type": "boolean"
        },
        {
            "name": "UpdateTimeEstimate",
            "baseName": "UpdateTimeEstimate",
            "type": "KioskBluetoothTerminalFirmwareVersionStatusEvent.UpdateTimeEstimateEnum"
        },
        {
            "name": "UserEventInfo",
            "baseName": "UserEventInfo",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothTerminalFirmwareVersionStatusEvent;
}());
exports.KioskBluetoothTerminalFirmwareVersionStatusEvent = KioskBluetoothTerminalFirmwareVersionStatusEvent;
(function (KioskBluetoothTerminalFirmwareVersionStatusEvent) {
    var UpdateTimeEstimateEnum;
    (function (UpdateTimeEstimateEnum) {
        UpdateTimeEstimateEnum[UpdateTimeEstimateEnum["LessThanOneMinute"] = 'LessThanOneMinute'] = "LessThanOneMinute";
        UpdateTimeEstimateEnum[UpdateTimeEstimateEnum["OneToTwoMinutes"] = 'OneToTwoMinutes'] = "OneToTwoMinutes";
        UpdateTimeEstimateEnum[UpdateTimeEstimateEnum["TwoToFiveMinutes"] = 'TwoToFiveMinutes'] = "TwoToFiveMinutes";
        UpdateTimeEstimateEnum[UpdateTimeEstimateEnum["FiveToFifteenMinutes"] = 'FiveToFifteenMinutes'] = "FiveToFifteenMinutes";
    })(UpdateTimeEstimateEnum = KioskBluetoothTerminalFirmwareVersionStatusEvent.UpdateTimeEstimateEnum || (KioskBluetoothTerminalFirmwareVersionStatusEvent.UpdateTimeEstimateEnum = {}));
})(KioskBluetoothTerminalFirmwareVersionStatusEvent = exports.KioskBluetoothTerminalFirmwareVersionStatusEvent || (exports.KioskBluetoothTerminalFirmwareVersionStatusEvent = {}));
exports.KioskBluetoothTerminalFirmwareVersionStatusEvent = KioskBluetoothTerminalFirmwareVersionStatusEvent;
var KioskBluetoothTerminalInitiateUpdateCheckEvent = (function () {
    function KioskBluetoothTerminalInitiateUpdateCheckEvent() {
    }
    KioskBluetoothTerminalInitiateUpdateCheckEvent.getAttributeTypeMap = function () {
        return KioskBluetoothTerminalInitiateUpdateCheckEvent.attributeTypeMap;
    };
    KioskBluetoothTerminalInitiateUpdateCheckEvent.discriminator = undefined;
    KioskBluetoothTerminalInitiateUpdateCheckEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothTerminalInitiateUpdateCheckEvent;
}());
exports.KioskBluetoothTerminalInitiateUpdateCheckEvent = KioskBluetoothTerminalInitiateUpdateCheckEvent;
var KioskBluetoothTerminalInstallationStatusEvent = (function () {
    function KioskBluetoothTerminalInstallationStatusEvent() {
    }
    KioskBluetoothTerminalInstallationStatusEvent.getAttributeTypeMap = function () {
        return KioskBluetoothTerminalInstallationStatusEvent.attributeTypeMap;
    };
    KioskBluetoothTerminalInstallationStatusEvent.discriminator = undefined;
    KioskBluetoothTerminalInstallationStatusEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalType",
            "baseName": "BluetoothTerminalType",
            "type": "KioskBluetoothTerminalInstallationStatusEvent.BluetoothTerminalTypeEnum"
        },
        {
            "name": "BluetoothTerminalSerialNumber",
            "baseName": "BluetoothTerminalSerialNumber",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Progress",
            "baseName": "Progress",
            "type": "number"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothTerminalInstallationStatusEvent;
}());
exports.KioskBluetoothTerminalInstallationStatusEvent = KioskBluetoothTerminalInstallationStatusEvent;
(function (KioskBluetoothTerminalInstallationStatusEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothTerminalInstallationStatusEvent.BluetoothTerminalTypeEnum || (KioskBluetoothTerminalInstallationStatusEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothTerminalInstallationStatusEvent = exports.KioskBluetoothTerminalInstallationStatusEvent || (exports.KioskBluetoothTerminalInstallationStatusEvent = {}));
exports.KioskBluetoothTerminalInstallationStatusEvent = KioskBluetoothTerminalInstallationStatusEvent;
var KioskBluetoothTerminalUnpairedEvent = (function () {
    function KioskBluetoothTerminalUnpairedEvent() {
    }
    KioskBluetoothTerminalUnpairedEvent.getAttributeTypeMap = function () {
        return KioskBluetoothTerminalUnpairedEvent.attributeTypeMap;
    };
    KioskBluetoothTerminalUnpairedEvent.discriminator = undefined;
    KioskBluetoothTerminalUnpairedEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalType",
            "baseName": "BluetoothTerminalType",
            "type": "KioskBluetoothTerminalUnpairedEvent.BluetoothTerminalTypeEnum"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothTerminalUnpairedEvent;
}());
exports.KioskBluetoothTerminalUnpairedEvent = KioskBluetoothTerminalUnpairedEvent;
(function (KioskBluetoothTerminalUnpairedEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothTerminalUnpairedEvent.BluetoothTerminalTypeEnum || (KioskBluetoothTerminalUnpairedEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothTerminalUnpairedEvent = exports.KioskBluetoothTerminalUnpairedEvent || (exports.KioskBluetoothTerminalUnpairedEvent = {}));
exports.KioskBluetoothTerminalUnpairedEvent = KioskBluetoothTerminalUnpairedEvent;
var KioskBluetoothTerminalUpdatedEvent = (function () {
    function KioskBluetoothTerminalUpdatedEvent() {
    }
    KioskBluetoothTerminalUpdatedEvent.getAttributeTypeMap = function () {
        return KioskBluetoothTerminalUpdatedEvent.attributeTypeMap;
    };
    KioskBluetoothTerminalUpdatedEvent.discriminator = undefined;
    KioskBluetoothTerminalUpdatedEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalType",
            "baseName": "BluetoothTerminalType",
            "type": "KioskBluetoothTerminalUpdatedEvent.BluetoothTerminalTypeEnum"
        },
        {
            "name": "BluetoothTerminalSerialNumber",
            "baseName": "BluetoothTerminalSerialNumber",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalStatus",
            "baseName": "BluetoothTerminalStatus",
            "type": "BluetoothTerminalStatus"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothTerminalUpdatedEvent;
}());
exports.KioskBluetoothTerminalUpdatedEvent = KioskBluetoothTerminalUpdatedEvent;
(function (KioskBluetoothTerminalUpdatedEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothTerminalUpdatedEvent.BluetoothTerminalTypeEnum || (KioskBluetoothTerminalUpdatedEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothTerminalUpdatedEvent = exports.KioskBluetoothTerminalUpdatedEvent || (exports.KioskBluetoothTerminalUpdatedEvent = {}));
exports.KioskBluetoothTerminalUpdatedEvent = KioskBluetoothTerminalUpdatedEvent;
var KioskBluetoothUnpairingModeEvent = (function () {
    function KioskBluetoothUnpairingModeEvent() {
    }
    KioskBluetoothUnpairingModeEvent.getAttributeTypeMap = function () {
        return KioskBluetoothUnpairingModeEvent.attributeTypeMap;
    };
    KioskBluetoothUnpairingModeEvent.discriminator = undefined;
    KioskBluetoothUnpairingModeEvent.attributeTypeMap = [
        {
            "name": "DeviceId",
            "baseName": "DeviceId",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalType",
            "baseName": "BluetoothTerminalType",
            "type": "KioskBluetoothUnpairingModeEvent.BluetoothTerminalTypeEnum"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskBluetoothUnpairingModeEvent;
}());
exports.KioskBluetoothUnpairingModeEvent = KioskBluetoothUnpairingModeEvent;
(function (KioskBluetoothUnpairingModeEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothUnpairingModeEvent.BluetoothTerminalTypeEnum || (KioskBluetoothUnpairingModeEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothUnpairingModeEvent = exports.KioskBluetoothUnpairingModeEvent || (exports.KioskBluetoothUnpairingModeEvent = {}));
exports.KioskBluetoothUnpairingModeEvent = KioskBluetoothUnpairingModeEvent;
var KioskCashPaymentSettings = (function () {
    function KioskCashPaymentSettings() {
    }
    KioskCashPaymentSettings.getAttributeTypeMap = function () {
        return KioskCashPaymentSettings.attributeTypeMap;
    };
    KioskCashPaymentSettings.discriminator = undefined;
    KioskCashPaymentSettings.attributeTypeMap = [
        {
            "name": "IsCashVisibleToCustomer",
            "baseName": "IsCashVisibleToCustomer",
            "type": "boolean"
        },
        {
            "name": "UserId",
            "baseName": "UserId",
            "type": "number"
        }
    ];
    return KioskCashPaymentSettings;
}());
exports.KioskCashPaymentSettings = KioskCashPaymentSettings;
var KioskIotConnectionParameters = (function () {
    function KioskIotConnectionParameters() {
    }
    KioskIotConnectionParameters.getAttributeTypeMap = function () {
        return KioskIotConnectionParameters.attributeTypeMap;
    };
    KioskIotConnectionParameters.discriminator = undefined;
    KioskIotConnectionParameters.attributeTypeMap = [
        {
            "name": "ConnectionString",
            "baseName": "ConnectionString",
            "type": "string"
        }
    ];
    return KioskIotConnectionParameters;
}());
exports.KioskIotConnectionParameters = KioskIotConnectionParameters;
var KioskSettings = (function () {
    function KioskSettings() {
    }
    KioskSettings.getAttributeTypeMap = function () {
        return KioskSettings.attributeTypeMap;
    };
    KioskSettings.discriminator = undefined;
    KioskSettings.attributeTypeMap = [
        {
            "name": "HideLogoFromFrontPage",
            "baseName": "HideLogoFromFrontPage",
            "type": "boolean"
        }
    ];
    return KioskSettings;
}());
exports.KioskSettings = KioskSettings;
var KioskTerminalActionStateChangedEvent = (function () {
    function KioskTerminalActionStateChangedEvent() {
    }
    KioskTerminalActionStateChangedEvent.getAttributeTypeMap = function () {
        return KioskTerminalActionStateChangedEvent.attributeTypeMap;
    };
    KioskTerminalActionStateChangedEvent.discriminator = undefined;
    KioskTerminalActionStateChangedEvent.attributeTypeMap = [
        {
            "name": "ReaderId",
            "baseName": "ReaderId",
            "type": "string"
        },
        {
            "name": "BluetoothTerminalType",
            "baseName": "BluetoothTerminalType",
            "type": "KioskTerminalActionStateChangedEvent.BluetoothTerminalTypeEnum"
        },
        {
            "name": "ActionState",
            "baseName": "ActionState",
            "type": "string"
        },
        {
            "name": "FailureCode",
            "baseName": "FailureCode",
            "type": "string"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return KioskTerminalActionStateChangedEvent;
}());
exports.KioskTerminalActionStateChangedEvent = KioskTerminalActionStateChangedEvent;
(function (KioskTerminalActionStateChangedEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskTerminalActionStateChangedEvent.BluetoothTerminalTypeEnum || (KioskTerminalActionStateChangedEvent.BluetoothTerminalTypeEnum = {}));
})(KioskTerminalActionStateChangedEvent = exports.KioskTerminalActionStateChangedEvent || (exports.KioskTerminalActionStateChangedEvent = {}));
exports.KioskTerminalActionStateChangedEvent = KioskTerminalActionStateChangedEvent;
var Language = (function () {
    function Language() {
    }
    Language.getAttributeTypeMap = function () {
        return Language.attributeTypeMap;
    };
    Language.discriminator = undefined;
    Language.attributeTypeMap = [
        {
            "name": "LanguageId",
            "baseName": "LanguageId",
            "type": "string"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return Language;
}());
exports.Language = Language;
var LastPaymentError = (function () {
    function LastPaymentError() {
    }
    LastPaymentError.getAttributeTypeMap = function () {
        return LastPaymentError.attributeTypeMap;
    };
    LastPaymentError.discriminator = undefined;
    LastPaymentError.attributeTypeMap = [
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        },
        {
            "name": "DeclineCode",
            "baseName": "DeclineCode",
            "type": "string"
        },
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        }
    ];
    return LastPaymentError;
}());
exports.LastPaymentError = LastPaymentError;
var LightspeedSettings = (function () {
    function LightspeedSettings() {
    }
    LightspeedSettings.getAttributeTypeMap = function () {
        return LightspeedSettings.attributeTypeMap;
    };
    LightspeedSettings.discriminator = undefined;
    LightspeedSettings.attributeTypeMap = [
        {
            "name": "CompanyId",
            "baseName": "CompanyId",
            "type": "string"
        },
        {
            "name": "UseOAuth",
            "baseName": "UseOAuth",
            "type": "boolean"
        },
        {
            "name": "Enabled",
            "baseName": "Enabled",
            "type": "boolean"
        },
        {
            "name": "EstimatedMinutesForDelivery",
            "baseName": "EstimatedMinutesForDelivery",
            "type": "number"
        },
        {
            "name": "EstimatedMinutesForCollection",
            "baseName": "EstimatedMinutesForCollection",
            "type": "number"
        },
        {
            "name": "GeographicLocation",
            "baseName": "GeographicLocation",
            "type": "string"
        },
        {
            "name": "Establishment",
            "baseName": "Establishment",
            "type": "boolean"
        },
        {
            "name": "VoucherId",
            "baseName": "VoucherId",
            "type": "string"
        },
        {
            "name": "DeliveryFeeId",
            "baseName": "DeliveryFeeId",
            "type": "string"
        },
        {
            "name": "ProcessingFeeId",
            "baseName": "ProcessingFeeId",
            "type": "string"
        },
        {
            "name": "PriceType",
            "baseName": "PriceType",
            "type": "LightspeedSettings.PriceTypeEnum"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "CollectionTableId",
            "baseName": "CollectionTableId",
            "type": "number"
        },
        {
            "name": "DeliveryTableId",
            "baseName": "DeliveryTableId",
            "type": "number"
        },
        {
            "name": "CollectionTableIds",
            "baseName": "CollectionTableIds",
            "type": "{ [key: string]: string; }"
        },
        {
            "name": "DeliveryTableIds",
            "baseName": "DeliveryTableIds",
            "type": "{ [key: string]: string; }"
        },
        {
            "name": "UseTaxInclusivePrices",
            "baseName": "UseTaxInclusivePrices",
            "type": "boolean"
        },
        {
            "name": "SkipStatusCheckAndAcceptOrderAfterSending",
            "baseName": "SkipStatusCheckAndAcceptOrderAfterSending",
            "type": "boolean"
        },
        {
            "name": "SendTableNumberToTableId",
            "baseName": "SendTableNumberToTableId",
            "type": "boolean"
        },
        {
            "name": "AddChefNoteToProduct",
            "baseName": "AddChefNoteToProduct",
            "type": "boolean"
        },
        {
            "name": "ChefNoteItemId",
            "baseName": "ChefNoteItemId",
            "type": "string"
        },
        {
            "name": "ChefNoteModifierId",
            "baseName": "ChefNoteModifierId",
            "type": "string"
        },
        {
            "name": "ServiceChargeId",
            "baseName": "ServiceChargeId",
            "type": "string"
        }
    ];
    return LightspeedSettings;
}());
exports.LightspeedSettings = LightspeedSettings;
(function (LightspeedSettings) {
    var PriceTypeEnum;
    (function (PriceTypeEnum) {
        PriceTypeEnum[PriceTypeEnum["Default"] = 'Default'] = "Default";
        PriceTypeEnum[PriceTypeEnum["Takeaway"] = 'Takeaway'] = "Takeaway";
        PriceTypeEnum[PriceTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
    })(PriceTypeEnum = LightspeedSettings.PriceTypeEnum || (LightspeedSettings.PriceTypeEnum = {}));
})(LightspeedSettings = exports.LightspeedSettings || (exports.LightspeedSettings = {}));
exports.LightspeedSettings = LightspeedSettings;
var LineItem = (function () {
    function LineItem() {
    }
    LineItem.getAttributeTypeMap = function () {
        return LineItem.attributeTypeMap;
    };
    LineItem.discriminator = undefined;
    LineItem.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "SectionName",
            "baseName": "SectionName",
            "type": "string"
        },
        {
            "name": "ExternalId",
            "baseName": "ExternalId",
            "type": "string"
        },
        {
            "name": "Quantity",
            "baseName": "Quantity",
            "type": "number"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "Price"
        },
        {
            "name": "Notes",
            "baseName": "Notes",
            "type": "string"
        },
        {
            "name": "Options",
            "baseName": "Options",
            "type": "Array<LineItemOption>"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "{ [key: string]: string; }"
        }
    ];
    return LineItem;
}());
exports.LineItem = LineItem;
var LineItemOption = (function () {
    function LineItemOption() {
    }
    LineItemOption.getAttributeTypeMap = function () {
        return LineItemOption.attributeTypeMap;
    };
    LineItemOption.discriminator = undefined;
    LineItemOption.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "ExternalId",
            "baseName": "ExternalId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "Price"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "{ [key: string]: string; }"
        }
    ];
    return LineItemOption;
}());
exports.LineItemOption = LineItemOption;
var LocalisedTimeZone = (function () {
    function LocalisedTimeZone() {
    }
    LocalisedTimeZone.getAttributeTypeMap = function () {
        return LocalisedTimeZone.attributeTypeMap;
    };
    LocalisedTimeZone.discriminator = undefined;
    LocalisedTimeZone.attributeTypeMap = [
        {
            "name": "TimeZoneId",
            "baseName": "TimeZoneId",
            "type": "string"
        },
        {
            "name": "IanaTimeZoneId",
            "baseName": "IanaTimeZoneId",
            "type": "string"
        },
        {
            "name": "DisplayName",
            "baseName": "DisplayName",
            "type": "string"
        }
    ];
    return LocalisedTimeZone;
}());
exports.LocalisedTimeZone = LocalisedTimeZone;
var Location = (function () {
    function Location() {
    }
    Location.getAttributeTypeMap = function () {
        return Location.attributeTypeMap;
    };
    Location.discriminator = undefined;
    Location.attributeTypeMap = [
        {
            "name": "AddressLine1",
            "baseName": "AddressLine1",
            "type": "string"
        },
        {
            "name": "AddressLine2",
            "baseName": "AddressLine2",
            "type": "string"
        },
        {
            "name": "FormattedAddress",
            "baseName": "FormattedAddress",
            "type": "string"
        },
        {
            "name": "PostalCode",
            "baseName": "PostalCode",
            "type": "string"
        },
        {
            "name": "City",
            "baseName": "City",
            "type": "string"
        },
        {
            "name": "Coordinates",
            "baseName": "Coordinates",
            "type": "Coordinates"
        },
        {
            "name": "Notes",
            "baseName": "Notes",
            "type": "string"
        }
    ];
    return Location;
}());
exports.Location = Location;
var LocationArea = (function () {
    function LocationArea() {
    }
    LocationArea.getAttributeTypeMap = function () {
        return LocationArea.attributeTypeMap;
    };
    LocationArea.discriminator = undefined;
    LocationArea.attributeTypeMap = [
        {
            "name": "LocationAreaId",
            "baseName": "LocationAreaId",
            "type": "number"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "LocationAreaName",
            "baseName": "LocationAreaName",
            "type": "string"
        }
    ];
    return LocationArea;
}());
exports.LocationArea = LocationArea;
var LocationAreaCreatedEvent = (function () {
    function LocationAreaCreatedEvent() {
    }
    LocationAreaCreatedEvent.getAttributeTypeMap = function () {
        return LocationAreaCreatedEvent.attributeTypeMap;
    };
    LocationAreaCreatedEvent.discriminator = undefined;
    LocationAreaCreatedEvent.attributeTypeMap = [
        {
            "name": "LocationAreaId",
            "baseName": "LocationAreaId",
            "type": "string"
        },
        {
            "name": "LocationAreaName",
            "baseName": "LocationAreaName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return LocationAreaCreatedEvent;
}());
exports.LocationAreaCreatedEvent = LocationAreaCreatedEvent;
var LocationAreaLocation = (function () {
    function LocationAreaLocation() {
    }
    LocationAreaLocation.getAttributeTypeMap = function () {
        return LocationAreaLocation.attributeTypeMap;
    };
    LocationAreaLocation.discriminator = undefined;
    LocationAreaLocation.attributeTypeMap = [
        {
            "name": "LocationId",
            "baseName": "LocationId",
            "type": "number"
        },
        {
            "name": "LocationName",
            "baseName": "LocationName",
            "type": "string"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "ExternalLocationId",
            "baseName": "ExternalLocationId",
            "type": "string"
        },
        {
            "name": "IsDeleted",
            "baseName": "IsDeleted",
            "type": "boolean"
        }
    ];
    return LocationAreaLocation;
}());
exports.LocationAreaLocation = LocationAreaLocation;
var LocationAreaUpdatedEvent = (function () {
    function LocationAreaUpdatedEvent() {
    }
    LocationAreaUpdatedEvent.getAttributeTypeMap = function () {
        return LocationAreaUpdatedEvent.attributeTypeMap;
    };
    LocationAreaUpdatedEvent.discriminator = undefined;
    LocationAreaUpdatedEvent.attributeTypeMap = [
        {
            "name": "LocationAreaId",
            "baseName": "LocationAreaId",
            "type": "string"
        },
        {
            "name": "LocationAreaName",
            "baseName": "LocationAreaName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return LocationAreaUpdatedEvent;
}());
exports.LocationAreaUpdatedEvent = LocationAreaUpdatedEvent;
var LocationAreaWithLocations = (function () {
    function LocationAreaWithLocations() {
    }
    LocationAreaWithLocations.getAttributeTypeMap = function () {
        return LocationAreaWithLocations.attributeTypeMap;
    };
    LocationAreaWithLocations.discriminator = undefined;
    LocationAreaWithLocations.attributeTypeMap = [
        {
            "name": "LocationAreaId",
            "baseName": "LocationAreaId",
            "type": "number"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "LocationAreaName",
            "baseName": "LocationAreaName",
            "type": "string"
        },
        {
            "name": "Locations",
            "baseName": "Locations",
            "type": "Array<LocationAreaLocation>"
        },
        {
            "name": "IsDeleted",
            "baseName": "IsDeleted",
            "type": "boolean"
        }
    ];
    return LocationAreaWithLocations;
}());
exports.LocationAreaWithLocations = LocationAreaWithLocations;
var LocationCreatedEvent = (function () {
    function LocationCreatedEvent() {
    }
    LocationCreatedEvent.getAttributeTypeMap = function () {
        return LocationCreatedEvent.attributeTypeMap;
    };
    LocationCreatedEvent.discriminator = undefined;
    LocationCreatedEvent.attributeTypeMap = [
        {
            "name": "LocationId",
            "baseName": "LocationId",
            "type": "number"
        },
        {
            "name": "LocationName",
            "baseName": "LocationName",
            "type": "string"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "ExternalLocationId",
            "baseName": "ExternalLocationId",
            "type": "string"
        },
        {
            "name": "LocationAreaId",
            "baseName": "LocationAreaId",
            "type": "number"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return LocationCreatedEvent;
}());
exports.LocationCreatedEvent = LocationCreatedEvent;
var LocationDeletedEvent = (function () {
    function LocationDeletedEvent() {
    }
    LocationDeletedEvent.getAttributeTypeMap = function () {
        return LocationDeletedEvent.attributeTypeMap;
    };
    LocationDeletedEvent.discriminator = undefined;
    LocationDeletedEvent.attributeTypeMap = [
        {
            "name": "LocationId",
            "baseName": "LocationId",
            "type": "number"
        },
        {
            "name": "LocationName",
            "baseName": "LocationName",
            "type": "string"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "ExternalLocationId",
            "baseName": "ExternalLocationId",
            "type": "string"
        },
        {
            "name": "LocationAreaId",
            "baseName": "LocationAreaId",
            "type": "number"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return LocationDeletedEvent;
}());
exports.LocationDeletedEvent = LocationDeletedEvent;
var LoginModel = (function () {
    function LoginModel() {
    }
    LoginModel.getAttributeTypeMap = function () {
        return LoginModel.attributeTypeMap;
    };
    LoginModel.discriminator = undefined;
    LoginModel.attributeTypeMap = [
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "Password",
            "baseName": "Password",
            "type": "string"
        }
    ];
    return LoginModel;
}());
exports.LoginModel = LoginModel;
var LoginWithPinModel = (function () {
    function LoginWithPinModel() {
    }
    LoginWithPinModel.getAttributeTypeMap = function () {
        return LoginWithPinModel.attributeTypeMap;
    };
    LoginWithPinModel.discriminator = undefined;
    LoginWithPinModel.attributeTypeMap = [
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "Pin",
            "baseName": "Pin",
            "type": "number"
        }
    ];
    return LoginWithPinModel;
}());
exports.LoginWithPinModel = LoginWithPinModel;
var LoyaltyCampaign = (function () {
    function LoyaltyCampaign() {
    }
    LoyaltyCampaign.getAttributeTypeMap = function () {
        return LoyaltyCampaign.attributeTypeMap;
    };
    LoyaltyCampaign.discriminator = undefined;
    LoyaltyCampaign.attributeTypeMap = [
        {
            "name": "CampaignId",
            "baseName": "CampaignId",
            "type": "number"
        },
        {
            "name": "Statistics",
            "baseName": "Statistics",
            "type": "CampaignStatistics"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<StoreCampaignStartTime>"
        },
        {
            "name": "OrdersBeforeReceivingVoucher",
            "baseName": "OrdersBeforeReceivingVoucher",
            "type": "number"
        },
        {
            "name": "PercentDiscountAmount",
            "baseName": "PercentDiscountAmount",
            "type": "number"
        },
        {
            "name": "RoundingStrategy",
            "baseName": "RoundingStrategy",
            "type": "number"
        },
        {
            "name": "ShouldIncludeOrdersWithLoyaltyVoucher",
            "baseName": "ShouldIncludeOrdersWithLoyaltyVoucher",
            "type": "boolean"
        },
        {
            "name": "VoucherValidPeriodDays",
            "baseName": "VoucherValidPeriodDays",
            "type": "number"
        },
        {
            "name": "IncludeDeliveryFee",
            "baseName": "IncludeDeliveryFee",
            "type": "boolean"
        },
        {
            "name": "AutoApplyResultingVouchers",
            "baseName": "AutoApplyResultingVouchers",
            "type": "boolean"
        },
        {
            "name": "IncludeExistingOrders",
            "baseName": "IncludeExistingOrders",
            "type": "boolean"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        }
    ];
    return LoyaltyCampaign;
}());
exports.LoyaltyCampaign = LoyaltyCampaign;
var LoyaltyCampaignBase = (function () {
    function LoyaltyCampaignBase() {
    }
    LoyaltyCampaignBase.getAttributeTypeMap = function () {
        return LoyaltyCampaignBase.attributeTypeMap;
    };
    LoyaltyCampaignBase.discriminator = undefined;
    LoyaltyCampaignBase.attributeTypeMap = [
        {
            "name": "OrdersBeforeReceivingVoucher",
            "baseName": "OrdersBeforeReceivingVoucher",
            "type": "number"
        },
        {
            "name": "PercentDiscountAmount",
            "baseName": "PercentDiscountAmount",
            "type": "number"
        },
        {
            "name": "RoundingStrategy",
            "baseName": "RoundingStrategy",
            "type": "number"
        },
        {
            "name": "ShouldIncludeOrdersWithLoyaltyVoucher",
            "baseName": "ShouldIncludeOrdersWithLoyaltyVoucher",
            "type": "boolean"
        },
        {
            "name": "VoucherValidPeriodDays",
            "baseName": "VoucherValidPeriodDays",
            "type": "number"
        },
        {
            "name": "IncludeDeliveryFee",
            "baseName": "IncludeDeliveryFee",
            "type": "boolean"
        },
        {
            "name": "AutoApplyResultingVouchers",
            "baseName": "AutoApplyResultingVouchers",
            "type": "boolean"
        },
        {
            "name": "IncludeExistingOrders",
            "baseName": "IncludeExistingOrders",
            "type": "boolean"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        }
    ];
    return LoyaltyCampaignBase;
}());
exports.LoyaltyCampaignBase = LoyaltyCampaignBase;
var LoyaltyCampaignCreatedEvent = (function () {
    function LoyaltyCampaignCreatedEvent() {
    }
    LoyaltyCampaignCreatedEvent.getAttributeTypeMap = function () {
        return LoyaltyCampaignCreatedEvent.attributeTypeMap;
    };
    LoyaltyCampaignCreatedEvent.discriminator = undefined;
    LoyaltyCampaignCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "LoyaltyCampaign",
            "baseName": "LoyaltyCampaign",
            "type": "LoyaltyCampaign"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return LoyaltyCampaignCreatedEvent;
}());
exports.LoyaltyCampaignCreatedEvent = LoyaltyCampaignCreatedEvent;
var LoyaltyCampaignDeletedEvent = (function () {
    function LoyaltyCampaignDeletedEvent() {
    }
    LoyaltyCampaignDeletedEvent.getAttributeTypeMap = function () {
        return LoyaltyCampaignDeletedEvent.attributeTypeMap;
    };
    LoyaltyCampaignDeletedEvent.discriminator = undefined;
    LoyaltyCampaignDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "LoyaltyCampaign",
            "baseName": "LoyaltyCampaign",
            "type": "LoyaltyCampaign"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return LoyaltyCampaignDeletedEvent;
}());
exports.LoyaltyCampaignDeletedEvent = LoyaltyCampaignDeletedEvent;
var LoyaltyCampaignUpdatedEvent = (function () {
    function LoyaltyCampaignUpdatedEvent() {
    }
    LoyaltyCampaignUpdatedEvent.getAttributeTypeMap = function () {
        return LoyaltyCampaignUpdatedEvent.attributeTypeMap;
    };
    LoyaltyCampaignUpdatedEvent.discriminator = undefined;
    LoyaltyCampaignUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "LoyaltyCampaign",
            "baseName": "LoyaltyCampaign",
            "type": "LoyaltyCampaign"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return LoyaltyCampaignUpdatedEvent;
}());
exports.LoyaltyCampaignUpdatedEvent = LoyaltyCampaignUpdatedEvent;
var LumpDiscountDetails = (function () {
    function LumpDiscountDetails() {
    }
    LumpDiscountDetails.getAttributeTypeMap = function () {
        return LumpDiscountDetails.attributeTypeMap;
    };
    LumpDiscountDetails.discriminator = undefined;
    LumpDiscountDetails.attributeTypeMap = [
        {
            "name": "DiscountAmount",
            "baseName": "DiscountAmount",
            "type": "number"
        }
    ];
    return LumpDiscountDetails;
}());
exports.LumpDiscountDetails = LumpDiscountDetails;
var MappedLocation = (function () {
    function MappedLocation() {
    }
    MappedLocation.getAttributeTypeMap = function () {
        return MappedLocation.attributeTypeMap;
    };
    MappedLocation.discriminator = undefined;
    MappedLocation.attributeTypeMap = [
        {
            "name": "LocationId",
            "baseName": "LocationId",
            "type": "number"
        },
        {
            "name": "ExternalLocationId",
            "baseName": "ExternalLocationId",
            "type": "string"
        }
    ];
    return MappedLocation;
}());
exports.MappedLocation = MappedLocation;
var MaskedPhoneNumber = (function () {
    function MaskedPhoneNumber() {
    }
    MaskedPhoneNumber.getAttributeTypeMap = function () {
        return MaskedPhoneNumber.attributeTypeMap;
    };
    MaskedPhoneNumber.discriminator = undefined;
    MaskedPhoneNumber.attributeTypeMap = [
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        },
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        }
    ];
    return MaskedPhoneNumber;
}());
exports.MaskedPhoneNumber = MaskedPhoneNumber;
var Menu = (function () {
    function Menu() {
    }
    Menu.getAttributeTypeMap = function () {
        return Menu.attributeTypeMap;
    };
    Menu.discriminator = undefined;
    Menu.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "ModifiedTime",
            "baseName": "ModifiedTime",
            "type": "Date"
        },
        {
            "name": "VersionNumber",
            "baseName": "VersionNumber",
            "type": "number"
        },
        {
            "name": "ImageName",
            "baseName": "ImageName",
            "type": "string"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Locked",
            "baseName": "Locked",
            "type": "boolean"
        },
        {
            "name": "MenuSections",
            "baseName": "MenuSections",
            "type": "Array<MenuSection>"
        },
        {
            "name": "TaxRates",
            "baseName": "TaxRates",
            "type": "Array<MenuTaxRate>"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "DisplaySectionLinks",
            "baseName": "DisplaySectionLinks",
            "type": "boolean"
        },
        {
            "name": "MenuSectionBehaviour",
            "baseName": "MenuSectionBehaviour",
            "type": "Menu.MenuSectionBehaviourEnum"
        },
        {
            "name": "TaxType",
            "baseName": "TaxType",
            "type": "Menu.TaxTypeEnum"
        }
    ];
    return Menu;
}());
exports.Menu = Menu;
(function (Menu) {
    var MenuSectionBehaviourEnum;
    (function (MenuSectionBehaviourEnum) {
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandSingle"] = 'ExpandSingle'] = "ExpandSingle";
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandMultiple"] = 'ExpandMultiple'] = "ExpandMultiple";
    })(MenuSectionBehaviourEnum = Menu.MenuSectionBehaviourEnum || (Menu.MenuSectionBehaviourEnum = {}));
    var TaxTypeEnum;
    (function (TaxTypeEnum) {
        TaxTypeEnum[TaxTypeEnum["IncludedInBasePrice"] = 'IncludedInBasePrice'] = "IncludedInBasePrice";
        TaxTypeEnum[TaxTypeEnum["ExcludedFromBasePrice"] = 'ExcludedFromBasePrice'] = "ExcludedFromBasePrice";
    })(TaxTypeEnum = Menu.TaxTypeEnum || (Menu.TaxTypeEnum = {}));
})(Menu = exports.Menu || (exports.Menu = {}));
exports.Menu = Menu;
var MenuBase = (function () {
    function MenuBase() {
    }
    MenuBase.getAttributeTypeMap = function () {
        return MenuBase.attributeTypeMap;
    };
    MenuBase.discriminator = undefined;
    MenuBase.attributeTypeMap = [
        {
            "name": "DisplaySectionLinks",
            "baseName": "DisplaySectionLinks",
            "type": "boolean"
        },
        {
            "name": "MenuSectionBehaviour",
            "baseName": "MenuSectionBehaviour",
            "type": "MenuBase.MenuSectionBehaviourEnum"
        },
        {
            "name": "TaxType",
            "baseName": "TaxType",
            "type": "MenuBase.TaxTypeEnum"
        }
    ];
    return MenuBase;
}());
exports.MenuBase = MenuBase;
(function (MenuBase) {
    var MenuSectionBehaviourEnum;
    (function (MenuSectionBehaviourEnum) {
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandSingle"] = 'ExpandSingle'] = "ExpandSingle";
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandMultiple"] = 'ExpandMultiple'] = "ExpandMultiple";
    })(MenuSectionBehaviourEnum = MenuBase.MenuSectionBehaviourEnum || (MenuBase.MenuSectionBehaviourEnum = {}));
    var TaxTypeEnum;
    (function (TaxTypeEnum) {
        TaxTypeEnum[TaxTypeEnum["IncludedInBasePrice"] = 'IncludedInBasePrice'] = "IncludedInBasePrice";
        TaxTypeEnum[TaxTypeEnum["ExcludedFromBasePrice"] = 'ExcludedFromBasePrice'] = "ExcludedFromBasePrice";
    })(TaxTypeEnum = MenuBase.TaxTypeEnum || (MenuBase.TaxTypeEnum = {}));
})(MenuBase = exports.MenuBase || (exports.MenuBase = {}));
exports.MenuBase = MenuBase;
var MenuBulkEditEvent = (function () {
    function MenuBulkEditEvent() {
    }
    MenuBulkEditEvent.getAttributeTypeMap = function () {
        return MenuBulkEditEvent.attributeTypeMap;
    };
    MenuBulkEditEvent.discriminator = undefined;
    MenuBulkEditEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "MenuName",
            "baseName": "MenuName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Item",
            "baseName": "Item",
            "type": "string"
        },
        {
            "name": "InstanceCount",
            "baseName": "InstanceCount",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuBulkEditEvent;
}());
exports.MenuBulkEditEvent = MenuBulkEditEvent;
var MenuCatalogItem = (function () {
    function MenuCatalogItem() {
    }
    MenuCatalogItem.getAttributeTypeMap = function () {
        return MenuCatalogItem.attributeTypeMap;
    };
    MenuCatalogItem.discriminator = undefined;
    MenuCatalogItem.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "MenuCatalogItem.CellLayoutTypeEnum"
        }
    ];
    return MenuCatalogItem;
}());
exports.MenuCatalogItem = MenuCatalogItem;
(function (MenuCatalogItem) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuCatalogItem.CellLayoutTypeEnum || (MenuCatalogItem.CellLayoutTypeEnum = {}));
})(MenuCatalogItem = exports.MenuCatalogItem || (exports.MenuCatalogItem = {}));
exports.MenuCatalogItem = MenuCatalogItem;
var MenuCheckpoint = (function () {
    function MenuCheckpoint() {
    }
    MenuCheckpoint.getAttributeTypeMap = function () {
        return MenuCheckpoint.attributeTypeMap;
    };
    MenuCheckpoint.discriminator = undefined;
    MenuCheckpoint.attributeTypeMap = [
        {
            "name": "MenuCheckpointId",
            "baseName": "MenuCheckpointId",
            "type": "number"
        },
        {
            "name": "Time",
            "baseName": "Time",
            "type": "Date"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Url",
            "baseName": "Url",
            "type": "string"
        }
    ];
    return MenuCheckpoint;
}());
exports.MenuCheckpoint = MenuCheckpoint;
var MenuCheckpointCreatedEvent = (function () {
    function MenuCheckpointCreatedEvent() {
    }
    MenuCheckpointCreatedEvent.getAttributeTypeMap = function () {
        return MenuCheckpointCreatedEvent.attributeTypeMap;
    };
    MenuCheckpointCreatedEvent.discriminator = undefined;
    MenuCheckpointCreatedEvent.attributeTypeMap = [
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Menu",
            "baseName": "Menu",
            "type": "Menu"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuCheckpointCreatedEvent;
}());
exports.MenuCheckpointCreatedEvent = MenuCheckpointCreatedEvent;
var MenuCreatedEvent = (function () {
    function MenuCreatedEvent() {
    }
    MenuCreatedEvent.getAttributeTypeMap = function () {
        return MenuCreatedEvent.attributeTypeMap;
    };
    MenuCreatedEvent.discriminator = undefined;
    MenuCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Menu",
            "baseName": "Menu",
            "type": "Menu"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuCreatedEvent;
}());
exports.MenuCreatedEvent = MenuCreatedEvent;
var MenuElementEditResponse = (function () {
    function MenuElementEditResponse() {
    }
    MenuElementEditResponse.getAttributeTypeMap = function () {
        return MenuElementEditResponse.attributeTypeMap;
    };
    MenuElementEditResponse.discriminator = undefined;
    MenuElementEditResponse.attributeTypeMap = [
        {
            "name": "SectionName",
            "baseName": "SectionName",
            "type": "string"
        },
        {
            "name": "ItemName",
            "baseName": "ItemName",
            "type": "string"
        },
        {
            "name": "OptionSetName",
            "baseName": "OptionSetName",
            "type": "string"
        },
        {
            "name": "OptionSetItemName",
            "baseName": "OptionSetItemName",
            "type": "string"
        },
        {
            "name": "MenuElementId",
            "baseName": "MenuElementId",
            "type": "number"
        },
        {
            "name": "MenuElementType",
            "baseName": "MenuElementType",
            "type": "MenuElementEditResponse.MenuElementTypeEnum"
        },
        {
            "name": "ValidationCode",
            "baseName": "ValidationCode",
            "type": "MenuElementEditResponse.ValidationCodeEnum"
        }
    ];
    return MenuElementEditResponse;
}());
exports.MenuElementEditResponse = MenuElementEditResponse;
(function (MenuElementEditResponse) {
    var MenuElementTypeEnum;
    (function (MenuElementTypeEnum) {
        MenuElementTypeEnum[MenuElementTypeEnum["Item"] = 'Item'] = "Item";
        MenuElementTypeEnum[MenuElementTypeEnum["OptionSetItem"] = 'OptionSetItem'] = "OptionSetItem";
    })(MenuElementTypeEnum = MenuElementEditResponse.MenuElementTypeEnum || (MenuElementEditResponse.MenuElementTypeEnum = {}));
    var ValidationCodeEnum;
    (function (ValidationCodeEnum) {
        ValidationCodeEnum[ValidationCodeEnum["Success"] = 'Success'] = "Success";
        ValidationCodeEnum[ValidationCodeEnum["MinimumCountViolation"] = 'MinimumCountViolation'] = "MinimumCountViolation";
        ValidationCodeEnum[ValidationCodeEnum["MasterOptionSetViolation"] = 'MasterOptionSetViolation'] = "MasterOptionSetViolation";
        ValidationCodeEnum[ValidationCodeEnum["IncorrectElementTypeInMenu"] = 'IncorrectElementTypeInMenu'] = "IncorrectElementTypeInMenu";
        ValidationCodeEnum[ValidationCodeEnum["DBFailed"] = 'DBFailed'] = "DBFailed";
    })(ValidationCodeEnum = MenuElementEditResponse.ValidationCodeEnum || (MenuElementEditResponse.ValidationCodeEnum = {}));
})(MenuElementEditResponse = exports.MenuElementEditResponse || (exports.MenuElementEditResponse = {}));
exports.MenuElementEditResponse = MenuElementEditResponse;
var MenuElementHide = (function () {
    function MenuElementHide() {
    }
    MenuElementHide.getAttributeTypeMap = function () {
        return MenuElementHide.attributeTypeMap;
    };
    MenuElementHide.discriminator = undefined;
    MenuElementHide.attributeTypeMap = [
        {
            "name": "MenuElementId",
            "baseName": "MenuElementId",
            "type": "number"
        },
        {
            "name": "MenuElementType",
            "baseName": "MenuElementType",
            "type": "MenuElementHide.MenuElementTypeEnum"
        }
    ];
    return MenuElementHide;
}());
exports.MenuElementHide = MenuElementHide;
(function (MenuElementHide) {
    var MenuElementTypeEnum;
    (function (MenuElementTypeEnum) {
        MenuElementTypeEnum[MenuElementTypeEnum["Item"] = 'Item'] = "Item";
        MenuElementTypeEnum[MenuElementTypeEnum["OptionSetItem"] = 'OptionSetItem'] = "OptionSetItem";
    })(MenuElementTypeEnum = MenuElementHide.MenuElementTypeEnum || (MenuElementHide.MenuElementTypeEnum = {}));
})(MenuElementHide = exports.MenuElementHide || (exports.MenuElementHide = {}));
exports.MenuElementHide = MenuElementHide;
var MenuElementListItemResponse = (function () {
    function MenuElementListItemResponse() {
    }
    MenuElementListItemResponse.getAttributeTypeMap = function () {
        return MenuElementListItemResponse.attributeTypeMap;
    };
    MenuElementListItemResponse.discriminator = undefined;
    MenuElementListItemResponse.attributeTypeMap = [
        {
            "name": "MenuElementId",
            "baseName": "MenuElementId",
            "type": "number"
        },
        {
            "name": "MenuElementType",
            "baseName": "MenuElementType",
            "type": "MenuElementListItemResponse.MenuElementTypeEnum"
        }
    ];
    return MenuElementListItemResponse;
}());
exports.MenuElementListItemResponse = MenuElementListItemResponse;
(function (MenuElementListItemResponse) {
    var MenuElementTypeEnum;
    (function (MenuElementTypeEnum) {
        MenuElementTypeEnum[MenuElementTypeEnum["Item"] = 'Item'] = "Item";
        MenuElementTypeEnum[MenuElementTypeEnum["OptionSetItem"] = 'OptionSetItem'] = "OptionSetItem";
    })(MenuElementTypeEnum = MenuElementListItemResponse.MenuElementTypeEnum || (MenuElementListItemResponse.MenuElementTypeEnum = {}));
})(MenuElementListItemResponse = exports.MenuElementListItemResponse || (exports.MenuElementListItemResponse = {}));
exports.MenuElementListItemResponse = MenuElementListItemResponse;
var MenuElementListResponse = (function () {
    function MenuElementListResponse() {
    }
    MenuElementListResponse.getAttributeTypeMap = function () {
        return MenuElementListResponse.attributeTypeMap;
    };
    MenuElementListResponse.discriminator = undefined;
    MenuElementListResponse.attributeTypeMap = [
        {
            "name": "MenuName",
            "baseName": "MenuName",
            "type": "string"
        },
        {
            "name": "MenuElementName",
            "baseName": "MenuElementName",
            "type": "string"
        },
        {
            "name": "InstanceCount",
            "baseName": "InstanceCount",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "Items",
            "baseName": "Items",
            "type": "Array<MenuElementListItemResponse>"
        }
    ];
    return MenuElementListResponse;
}());
exports.MenuElementListResponse = MenuElementListResponse;
var MenuItemOptionSet = (function () {
    function MenuItemOptionSet() {
    }
    MenuItemOptionSet.getAttributeTypeMap = function () {
        return MenuItemOptionSet.attributeTypeMap;
    };
    MenuItemOptionSet.discriminator = undefined;
    MenuItemOptionSet.attributeTypeMap = [
        {
            "name": "MenuItemOptionSetId",
            "baseName": "MenuItemOptionSetId",
            "type": "number"
        },
        {
            "name": "ImageName",
            "baseName": "ImageName",
            "type": "string"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        },
        {
            "name": "MenuItemOptionSetItems",
            "baseName": "MenuItemOptionSetItems",
            "type": "Array<MenuItemOptionSetItem>"
        },
        {
            "name": "PublicId",
            "baseName": "PublicId",
            "type": "string"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "IsMasterOptionSet",
            "baseName": "IsMasterOptionSet",
            "type": "boolean"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "MinSelectCount",
            "baseName": "MinSelectCount",
            "type": "number"
        },
        {
            "name": "MaxSelectCount",
            "baseName": "MaxSelectCount",
            "type": "number"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "MenuItemOptionSet.CellLayoutTypeEnum"
        }
    ];
    return MenuItemOptionSet;
}());
exports.MenuItemOptionSet = MenuItemOptionSet;
(function (MenuItemOptionSet) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuItemOptionSet.CellLayoutTypeEnum || (MenuItemOptionSet.CellLayoutTypeEnum = {}));
})(MenuItemOptionSet = exports.MenuItemOptionSet || (exports.MenuItemOptionSet = {}));
exports.MenuItemOptionSet = MenuItemOptionSet;
var MenuItemOptionSetBase = (function () {
    function MenuItemOptionSetBase() {
    }
    MenuItemOptionSetBase.getAttributeTypeMap = function () {
        return MenuItemOptionSetBase.attributeTypeMap;
    };
    MenuItemOptionSetBase.discriminator = undefined;
    MenuItemOptionSetBase.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "IsMasterOptionSet",
            "baseName": "IsMasterOptionSet",
            "type": "boolean"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "MinSelectCount",
            "baseName": "MinSelectCount",
            "type": "number"
        },
        {
            "name": "MaxSelectCount",
            "baseName": "MaxSelectCount",
            "type": "number"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "MenuItemOptionSetBase.CellLayoutTypeEnum"
        }
    ];
    return MenuItemOptionSetBase;
}());
exports.MenuItemOptionSetBase = MenuItemOptionSetBase;
(function (MenuItemOptionSetBase) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuItemOptionSetBase.CellLayoutTypeEnum || (MenuItemOptionSetBase.CellLayoutTypeEnum = {}));
})(MenuItemOptionSetBase = exports.MenuItemOptionSetBase || (exports.MenuItemOptionSetBase = {}));
exports.MenuItemOptionSetBase = MenuItemOptionSetBase;
var MenuItemOptionSetCreatedEvent = (function () {
    function MenuItemOptionSetCreatedEvent() {
    }
    MenuItemOptionSetCreatedEvent.getAttributeTypeMap = function () {
        return MenuItemOptionSetCreatedEvent.attributeTypeMap;
    };
    MenuItemOptionSetCreatedEvent.discriminator = undefined;
    MenuItemOptionSetCreatedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuItemOptionSet",
            "baseName": "MenuItemOptionSet",
            "type": "MenuItemOptionSet"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuItemOptionSetCreatedEvent;
}());
exports.MenuItemOptionSetCreatedEvent = MenuItemOptionSetCreatedEvent;
var MenuItemOptionSetDeletedEvent = (function () {
    function MenuItemOptionSetDeletedEvent() {
    }
    MenuItemOptionSetDeletedEvent.getAttributeTypeMap = function () {
        return MenuItemOptionSetDeletedEvent.attributeTypeMap;
    };
    MenuItemOptionSetDeletedEvent.discriminator = undefined;
    MenuItemOptionSetDeletedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuItemOptionSet",
            "baseName": "MenuItemOptionSet",
            "type": "MenuItemOptionSet"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuItemOptionSetDeletedEvent;
}());
exports.MenuItemOptionSetDeletedEvent = MenuItemOptionSetDeletedEvent;
var MenuItemOptionSetItem = (function () {
    function MenuItemOptionSetItem() {
    }
    MenuItemOptionSetItem.getAttributeTypeMap = function () {
        return MenuItemOptionSetItem.attributeTypeMap;
    };
    MenuItemOptionSetItem.discriminator = undefined;
    MenuItemOptionSetItem.attributeTypeMap = [
        {
            "name": "MenuItemOptionSetItemId",
            "baseName": "MenuItemOptionSetItemId",
            "type": "number"
        },
        {
            "name": "PublicId",
            "baseName": "PublicId",
            "type": "string"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "Array<CreateMetadata>"
        },
        {
            "name": "NextMenuItemOptionSetId",
            "baseName": "NextMenuItemOptionSetId",
            "type": "number"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "TaxRateName",
            "baseName": "TaxRateName",
            "type": "string"
        },
        {
            "name": "TaxRateId",
            "baseName": "TaxRateId",
            "type": "number"
        },
        {
            "name": "TaxValue",
            "baseName": "TaxValue",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "MenuItemOptionSetItem.CellLayoutTypeEnum"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        }
    ];
    return MenuItemOptionSetItem;
}());
exports.MenuItemOptionSetItem = MenuItemOptionSetItem;
(function (MenuItemOptionSetItem) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuItemOptionSetItem.CellLayoutTypeEnum || (MenuItemOptionSetItem.CellLayoutTypeEnum = {}));
})(MenuItemOptionSetItem = exports.MenuItemOptionSetItem || (exports.MenuItemOptionSetItem = {}));
exports.MenuItemOptionSetItem = MenuItemOptionSetItem;
var MenuItemOptionSetItemBase = (function () {
    function MenuItemOptionSetItemBase() {
    }
    MenuItemOptionSetItemBase.getAttributeTypeMap = function () {
        return MenuItemOptionSetItemBase.attributeTypeMap;
    };
    MenuItemOptionSetItemBase.discriminator = undefined;
    MenuItemOptionSetItemBase.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "MenuItemOptionSetItemBase.CellLayoutTypeEnum"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        }
    ];
    return MenuItemOptionSetItemBase;
}());
exports.MenuItemOptionSetItemBase = MenuItemOptionSetItemBase;
(function (MenuItemOptionSetItemBase) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuItemOptionSetItemBase.CellLayoutTypeEnum || (MenuItemOptionSetItemBase.CellLayoutTypeEnum = {}));
})(MenuItemOptionSetItemBase = exports.MenuItemOptionSetItemBase || (exports.MenuItemOptionSetItemBase = {}));
exports.MenuItemOptionSetItemBase = MenuItemOptionSetItemBase;
var MenuItemOptionSetItemCreatedEvent = (function () {
    function MenuItemOptionSetItemCreatedEvent() {
    }
    MenuItemOptionSetItemCreatedEvent.getAttributeTypeMap = function () {
        return MenuItemOptionSetItemCreatedEvent.attributeTypeMap;
    };
    MenuItemOptionSetItemCreatedEvent.discriminator = undefined;
    MenuItemOptionSetItemCreatedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuItemOptionSetItem",
            "baseName": "MenuItemOptionSetItem",
            "type": "MenuItemOptionSetItem"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuItemOptionSetItemCreatedEvent;
}());
exports.MenuItemOptionSetItemCreatedEvent = MenuItemOptionSetItemCreatedEvent;
var MenuItemOptionSetItemDeletedEvent = (function () {
    function MenuItemOptionSetItemDeletedEvent() {
    }
    MenuItemOptionSetItemDeletedEvent.getAttributeTypeMap = function () {
        return MenuItemOptionSetItemDeletedEvent.attributeTypeMap;
    };
    MenuItemOptionSetItemDeletedEvent.discriminator = undefined;
    MenuItemOptionSetItemDeletedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuItemOptionSetItem",
            "baseName": "MenuItemOptionSetItem",
            "type": "MenuItemOptionSetItem"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuItemOptionSetItemDeletedEvent;
}());
exports.MenuItemOptionSetItemDeletedEvent = MenuItemOptionSetItemDeletedEvent;
var MenuItemOptionSetItemUpdatedEvent = (function () {
    function MenuItemOptionSetItemUpdatedEvent() {
    }
    MenuItemOptionSetItemUpdatedEvent.getAttributeTypeMap = function () {
        return MenuItemOptionSetItemUpdatedEvent.attributeTypeMap;
    };
    MenuItemOptionSetItemUpdatedEvent.discriminator = undefined;
    MenuItemOptionSetItemUpdatedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuItemOptionSetItem",
            "baseName": "MenuItemOptionSetItem",
            "type": "MenuItemOptionSetItem"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuItemOptionSetItemUpdatedEvent;
}());
exports.MenuItemOptionSetItemUpdatedEvent = MenuItemOptionSetItemUpdatedEvent;
var MenuItemOptionSetUpdatedEvent = (function () {
    function MenuItemOptionSetUpdatedEvent() {
    }
    MenuItemOptionSetUpdatedEvent.getAttributeTypeMap = function () {
        return MenuItemOptionSetUpdatedEvent.attributeTypeMap;
    };
    MenuItemOptionSetUpdatedEvent.discriminator = undefined;
    MenuItemOptionSetUpdatedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuItemOptionSet",
            "baseName": "MenuItemOptionSet",
            "type": "MenuItemOptionSet"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuItemOptionSetUpdatedEvent;
}());
exports.MenuItemOptionSetUpdatedEvent = MenuItemOptionSetUpdatedEvent;
var MenuNutritionInfoHeader = (function () {
    function MenuNutritionInfoHeader() {
    }
    MenuNutritionInfoHeader.getAttributeTypeMap = function () {
        return MenuNutritionInfoHeader.attributeTypeMap;
    };
    MenuNutritionInfoHeader.discriminator = undefined;
    MenuNutritionInfoHeader.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "NutritionInfoVersionGuid",
            "baseName": "NutritionInfoVersionGuid",
            "type": "string"
        },
        {
            "name": "AbsoluteUrl",
            "baseName": "AbsoluteUrl",
            "type": "string"
        }
    ];
    return MenuNutritionInfoHeader;
}());
exports.MenuNutritionInfoHeader = MenuNutritionInfoHeader;
var MenuObjectDisplayOrders = (function () {
    function MenuObjectDisplayOrders() {
    }
    MenuObjectDisplayOrders.getAttributeTypeMap = function () {
        return MenuObjectDisplayOrders.attributeTypeMap;
    };
    MenuObjectDisplayOrders.discriminator = undefined;
    MenuObjectDisplayOrders.attributeTypeMap = [
        {
            "name": "DisplayOrders",
            "baseName": "DisplayOrders",
            "type": "Array<ObjectDisplayOrder>"
        }
    ];
    return MenuObjectDisplayOrders;
}());
exports.MenuObjectDisplayOrders = MenuObjectDisplayOrders;
var MenuSection = (function () {
    function MenuSection() {
    }
    MenuSection.getAttributeTypeMap = function () {
        return MenuSection.attributeTypeMap;
    };
    MenuSection.discriminator = undefined;
    MenuSection.attributeTypeMap = [
        {
            "name": "MenuSectionId",
            "baseName": "MenuSectionId",
            "type": "number"
        },
        {
            "name": "MenuItems",
            "baseName": "MenuItems",
            "type": "Array<MenuSectionItem>"
        },
        {
            "name": "MenuSectionAvailability",
            "baseName": "MenuSectionAvailability",
            "type": "MenuSectionAvailability"
        },
        {
            "name": "PublicId",
            "baseName": "PublicId",
            "type": "string"
        },
        {
            "name": "ImageName",
            "baseName": "ImageName",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "IsHiddenFromCustomers",
            "baseName": "IsHiddenFromCustomers",
            "type": "boolean"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        }
    ];
    return MenuSection;
}());
exports.MenuSection = MenuSection;
var MenuSectionAvailability = (function () {
    function MenuSectionAvailability() {
    }
    MenuSectionAvailability.getAttributeTypeMap = function () {
        return MenuSectionAvailability.attributeTypeMap;
    };
    MenuSectionAvailability.discriminator = undefined;
    MenuSectionAvailability.attributeTypeMap = [
        {
            "name": "AvailableTimes",
            "baseName": "AvailableTimes",
            "type": "Array<BusinessHoursPeriod>"
        },
        {
            "name": "AvailabilityMode",
            "baseName": "AvailabilityMode",
            "type": "MenuSectionAvailability.AvailabilityModeEnum"
        }
    ];
    return MenuSectionAvailability;
}());
exports.MenuSectionAvailability = MenuSectionAvailability;
(function (MenuSectionAvailability) {
    var AvailabilityModeEnum;
    (function (AvailabilityModeEnum) {
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlways"] = 'DisplayAlways'] = "DisplayAlways";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayBasedOnTimes"] = 'DisplayBasedOnTimes'] = "DisplayBasedOnTimes";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlwaysStartCollapsed"] = 'DisplayAlwaysStartCollapsed'] = "DisplayAlwaysStartCollapsed";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlwaysStartCollapsedBasedOnTimes"] = 'DisplayAlwaysStartCollapsedBasedOnTimes'] = "DisplayAlwaysStartCollapsedBasedOnTimes";
    })(AvailabilityModeEnum = MenuSectionAvailability.AvailabilityModeEnum || (MenuSectionAvailability.AvailabilityModeEnum = {}));
})(MenuSectionAvailability = exports.MenuSectionAvailability || (exports.MenuSectionAvailability = {}));
exports.MenuSectionAvailability = MenuSectionAvailability;
var MenuSectionAvailabilityBase = (function () {
    function MenuSectionAvailabilityBase() {
    }
    MenuSectionAvailabilityBase.getAttributeTypeMap = function () {
        return MenuSectionAvailabilityBase.attributeTypeMap;
    };
    MenuSectionAvailabilityBase.discriminator = undefined;
    MenuSectionAvailabilityBase.attributeTypeMap = [
        {
            "name": "AvailabilityMode",
            "baseName": "AvailabilityMode",
            "type": "MenuSectionAvailabilityBase.AvailabilityModeEnum"
        }
    ];
    return MenuSectionAvailabilityBase;
}());
exports.MenuSectionAvailabilityBase = MenuSectionAvailabilityBase;
(function (MenuSectionAvailabilityBase) {
    var AvailabilityModeEnum;
    (function (AvailabilityModeEnum) {
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlways"] = 'DisplayAlways'] = "DisplayAlways";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayBasedOnTimes"] = 'DisplayBasedOnTimes'] = "DisplayBasedOnTimes";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlwaysStartCollapsed"] = 'DisplayAlwaysStartCollapsed'] = "DisplayAlwaysStartCollapsed";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlwaysStartCollapsedBasedOnTimes"] = 'DisplayAlwaysStartCollapsedBasedOnTimes'] = "DisplayAlwaysStartCollapsedBasedOnTimes";
    })(AvailabilityModeEnum = MenuSectionAvailabilityBase.AvailabilityModeEnum || (MenuSectionAvailabilityBase.AvailabilityModeEnum = {}));
})(MenuSectionAvailabilityBase = exports.MenuSectionAvailabilityBase || (exports.MenuSectionAvailabilityBase = {}));
exports.MenuSectionAvailabilityBase = MenuSectionAvailabilityBase;
var MenuSectionBase = (function () {
    function MenuSectionBase() {
    }
    MenuSectionBase.getAttributeTypeMap = function () {
        return MenuSectionBase.attributeTypeMap;
    };
    MenuSectionBase.discriminator = undefined;
    MenuSectionBase.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "IsHiddenFromCustomers",
            "baseName": "IsHiddenFromCustomers",
            "type": "boolean"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        },
        {
            "name": "MenuSectionId",
            "baseName": "MenuSectionId",
            "type": "number"
        }
    ];
    return MenuSectionBase;
}());
exports.MenuSectionBase = MenuSectionBase;
var MenuSectionCreatedEvent = (function () {
    function MenuSectionCreatedEvent() {
    }
    MenuSectionCreatedEvent.getAttributeTypeMap = function () {
        return MenuSectionCreatedEvent.attributeTypeMap;
    };
    MenuSectionCreatedEvent.discriminator = undefined;
    MenuSectionCreatedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuSection",
            "baseName": "MenuSection",
            "type": "MenuSection"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuSectionCreatedEvent;
}());
exports.MenuSectionCreatedEvent = MenuSectionCreatedEvent;
var MenuSectionDeletedEvent = (function () {
    function MenuSectionDeletedEvent() {
    }
    MenuSectionDeletedEvent.getAttributeTypeMap = function () {
        return MenuSectionDeletedEvent.attributeTypeMap;
    };
    MenuSectionDeletedEvent.discriminator = undefined;
    MenuSectionDeletedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuSection",
            "baseName": "MenuSection",
            "type": "MenuSection"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuSectionDeletedEvent;
}());
exports.MenuSectionDeletedEvent = MenuSectionDeletedEvent;
var MenuSectionItem = (function () {
    function MenuSectionItem() {
    }
    MenuSectionItem.getAttributeTypeMap = function () {
        return MenuSectionItem.attributeTypeMap;
    };
    MenuSectionItem.discriminator = undefined;
    MenuSectionItem.attributeTypeMap = [
        {
            "name": "ActualPrice",
            "baseName": "ActualPrice",
            "type": "number"
        },
        {
            "name": "MenuItemOptionSets",
            "baseName": "MenuItemOptionSets",
            "type": "Array<MenuItemOptionSet>"
        },
        {
            "name": "DailySpecialHours",
            "baseName": "DailySpecialHours",
            "type": "Array<BusinessHoursPeriod>"
        },
        {
            "name": "PublicId",
            "baseName": "PublicId",
            "type": "string"
        },
        {
            "name": "TaxRateName",
            "baseName": "TaxRateName",
            "type": "string"
        },
        {
            "name": "TaxRateId",
            "baseName": "TaxRateId",
            "type": "number"
        },
        {
            "name": "TaxValue",
            "baseName": "TaxValue",
            "type": "number"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "Array<CreateMetadata>"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "SpicinessRating",
            "baseName": "SpicinessRating",
            "type": "MenuSectionItem.SpicinessRatingEnum"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "MenuSectionItem.CellLayoutTypeEnum"
        },
        {
            "name": "DisableVouchers",
            "baseName": "DisableVouchers",
            "type": "boolean"
        },
        {
            "name": "ImageName",
            "baseName": "ImageName",
            "type": "string"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        },
        {
            "name": "MenuItemId",
            "baseName": "MenuItemId",
            "type": "number"
        }
    ];
    return MenuSectionItem;
}());
exports.MenuSectionItem = MenuSectionItem;
(function (MenuSectionItem) {
    var SpicinessRatingEnum;
    (function (SpicinessRatingEnum) {
        SpicinessRatingEnum[SpicinessRatingEnum["NotRated"] = 'NotRated'] = "NotRated";
        SpicinessRatingEnum[SpicinessRatingEnum["Mild"] = 'Mild'] = "Mild";
        SpicinessRatingEnum[SpicinessRatingEnum["Medium"] = 'Medium'] = "Medium";
        SpicinessRatingEnum[SpicinessRatingEnum["Hot"] = 'Hot'] = "Hot";
    })(SpicinessRatingEnum = MenuSectionItem.SpicinessRatingEnum || (MenuSectionItem.SpicinessRatingEnum = {}));
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuSectionItem.CellLayoutTypeEnum || (MenuSectionItem.CellLayoutTypeEnum = {}));
})(MenuSectionItem = exports.MenuSectionItem || (exports.MenuSectionItem = {}));
exports.MenuSectionItem = MenuSectionItem;
var MenuSectionItemBase = (function () {
    function MenuSectionItemBase() {
    }
    MenuSectionItemBase.getAttributeTypeMap = function () {
        return MenuSectionItemBase.attributeTypeMap;
    };
    MenuSectionItemBase.discriminator = undefined;
    MenuSectionItemBase.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "SpicinessRating",
            "baseName": "SpicinessRating",
            "type": "MenuSectionItemBase.SpicinessRatingEnum"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "CellLayoutType",
            "baseName": "CellLayoutType",
            "type": "MenuSectionItemBase.CellLayoutTypeEnum"
        },
        {
            "name": "DisableVouchers",
            "baseName": "DisableVouchers",
            "type": "boolean"
        },
        {
            "name": "ImageName",
            "baseName": "ImageName",
            "type": "string"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        },
        {
            "name": "MenuItemId",
            "baseName": "MenuItemId",
            "type": "number"
        }
    ];
    return MenuSectionItemBase;
}());
exports.MenuSectionItemBase = MenuSectionItemBase;
(function (MenuSectionItemBase) {
    var SpicinessRatingEnum;
    (function (SpicinessRatingEnum) {
        SpicinessRatingEnum[SpicinessRatingEnum["NotRated"] = 'NotRated'] = "NotRated";
        SpicinessRatingEnum[SpicinessRatingEnum["Mild"] = 'Mild'] = "Mild";
        SpicinessRatingEnum[SpicinessRatingEnum["Medium"] = 'Medium'] = "Medium";
        SpicinessRatingEnum[SpicinessRatingEnum["Hot"] = 'Hot'] = "Hot";
    })(SpicinessRatingEnum = MenuSectionItemBase.SpicinessRatingEnum || (MenuSectionItemBase.SpicinessRatingEnum = {}));
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuSectionItemBase.CellLayoutTypeEnum || (MenuSectionItemBase.CellLayoutTypeEnum = {}));
})(MenuSectionItemBase = exports.MenuSectionItemBase || (exports.MenuSectionItemBase = {}));
exports.MenuSectionItemBase = MenuSectionItemBase;
var MenuSectionItemCreatedEvent = (function () {
    function MenuSectionItemCreatedEvent() {
    }
    MenuSectionItemCreatedEvent.getAttributeTypeMap = function () {
        return MenuSectionItemCreatedEvent.attributeTypeMap;
    };
    MenuSectionItemCreatedEvent.discriminator = undefined;
    MenuSectionItemCreatedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuSectionItem",
            "baseName": "MenuSectionItem",
            "type": "MenuSectionItem"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuSectionItemCreatedEvent;
}());
exports.MenuSectionItemCreatedEvent = MenuSectionItemCreatedEvent;
var MenuSectionItemDeletedEvent = (function () {
    function MenuSectionItemDeletedEvent() {
    }
    MenuSectionItemDeletedEvent.getAttributeTypeMap = function () {
        return MenuSectionItemDeletedEvent.attributeTypeMap;
    };
    MenuSectionItemDeletedEvent.discriminator = undefined;
    MenuSectionItemDeletedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuSectionItem",
            "baseName": "MenuSectionItem",
            "type": "MenuSectionItem"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuSectionItemDeletedEvent;
}());
exports.MenuSectionItemDeletedEvent = MenuSectionItemDeletedEvent;
var MenuSectionItemUpdatedEvent = (function () {
    function MenuSectionItemUpdatedEvent() {
    }
    MenuSectionItemUpdatedEvent.getAttributeTypeMap = function () {
        return MenuSectionItemUpdatedEvent.attributeTypeMap;
    };
    MenuSectionItemUpdatedEvent.discriminator = undefined;
    MenuSectionItemUpdatedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuSectionItem",
            "baseName": "MenuSectionItem",
            "type": "MenuSectionItem"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuSectionItemUpdatedEvent;
}());
exports.MenuSectionItemUpdatedEvent = MenuSectionItemUpdatedEvent;
var MenuSectionUpdatedEvent = (function () {
    function MenuSectionUpdatedEvent() {
    }
    MenuSectionUpdatedEvent.getAttributeTypeMap = function () {
        return MenuSectionUpdatedEvent.attributeTypeMap;
    };
    MenuSectionUpdatedEvent.discriminator = undefined;
    MenuSectionUpdatedEvent.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MenuSection",
            "baseName": "MenuSection",
            "type": "MenuSection"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuSectionUpdatedEvent;
}());
exports.MenuSectionUpdatedEvent = MenuSectionUpdatedEvent;
var MenuStoreNames = (function () {
    function MenuStoreNames() {
    }
    MenuStoreNames.getAttributeTypeMap = function () {
        return MenuStoreNames.attributeTypeMap;
    };
    MenuStoreNames.discriminator = undefined;
    MenuStoreNames.attributeTypeMap = [
        {
            "name": "StoreNames",
            "baseName": "StoreNames",
            "type": "Array<string>"
        }
    ];
    return MenuStoreNames;
}());
exports.MenuStoreNames = MenuStoreNames;
var MenuSummary = (function () {
    function MenuSummary() {
    }
    MenuSummary.getAttributeTypeMap = function () {
        return MenuSummary.attributeTypeMap;
    };
    MenuSummary.discriminator = undefined;
    MenuSummary.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "ModifiedTime",
            "baseName": "ModifiedTime",
            "type": "Date"
        },
        {
            "name": "VersionNumber",
            "baseName": "VersionNumber",
            "type": "number"
        },
        {
            "name": "MenuUrl",
            "baseName": "MenuUrl",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Locked",
            "baseName": "Locked",
            "type": "boolean"
        },
        {
            "name": "StoreNames",
            "baseName": "StoreNames",
            "type": "Array<string>"
        }
    ];
    return MenuSummary;
}());
exports.MenuSummary = MenuSummary;
var MenuTaxDetails = (function () {
    function MenuTaxDetails() {
    }
    MenuTaxDetails.getAttributeTypeMap = function () {
        return MenuTaxDetails.attributeTypeMap;
    };
    MenuTaxDetails.discriminator = undefined;
    MenuTaxDetails.attributeTypeMap = [
        {
            "name": "TaxRates",
            "baseName": "TaxRates",
            "type": "Array<MenuTaxRate>"
        },
        {
            "name": "DisplayTax",
            "baseName": "DisplayTax",
            "type": "boolean"
        },
        {
            "name": "TaxType",
            "baseName": "TaxType",
            "type": "MenuTaxDetails.TaxTypeEnum"
        },
        {
            "name": "ItemTaxes",
            "baseName": "ItemTaxes",
            "type": "{ [key: string]: number; }"
        },
        {
            "name": "SetItemTaxes",
            "baseName": "SetItemTaxes",
            "type": "{ [key: string]: number; }"
        }
    ];
    return MenuTaxDetails;
}());
exports.MenuTaxDetails = MenuTaxDetails;
(function (MenuTaxDetails) {
    var TaxTypeEnum;
    (function (TaxTypeEnum) {
        TaxTypeEnum[TaxTypeEnum["IncludedInBasePrice"] = 'IncludedInBasePrice'] = "IncludedInBasePrice";
        TaxTypeEnum[TaxTypeEnum["ExcludedFromBasePrice"] = 'ExcludedFromBasePrice'] = "ExcludedFromBasePrice";
    })(TaxTypeEnum = MenuTaxDetails.TaxTypeEnum || (MenuTaxDetails.TaxTypeEnum = {}));
})(MenuTaxDetails = exports.MenuTaxDetails || (exports.MenuTaxDetails = {}));
exports.MenuTaxDetails = MenuTaxDetails;
var MenuTaxRate = (function () {
    function MenuTaxRate() {
    }
    MenuTaxRate.getAttributeTypeMap = function () {
        return MenuTaxRate.attributeTypeMap;
    };
    MenuTaxRate.discriminator = undefined;
    MenuTaxRate.attributeTypeMap = [
        {
            "name": "TaxRateId",
            "baseName": "TaxRateId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Rate",
            "baseName": "Rate",
            "type": "number"
        }
    ];
    return MenuTaxRate;
}());
exports.MenuTaxRate = MenuTaxRate;
var MenuUpdatedEvent = (function () {
    function MenuUpdatedEvent() {
    }
    MenuUpdatedEvent.getAttributeTypeMap = function () {
        return MenuUpdatedEvent.attributeTypeMap;
    };
    MenuUpdatedEvent.discriminator = undefined;
    MenuUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Menu",
            "baseName": "Menu",
            "type": "Menu"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuUpdatedEvent;
}());
exports.MenuUpdatedEvent = MenuUpdatedEvent;
var MenuUploadedEvent = (function () {
    function MenuUploadedEvent() {
    }
    MenuUploadedEvent.getAttributeTypeMap = function () {
        return MenuUploadedEvent.attributeTypeMap;
    };
    MenuUploadedEvent.discriminator = undefined;
    MenuUploadedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Menu",
            "baseName": "Menu",
            "type": "Menu"
        },
        {
            "name": "InstanceEventCount",
            "baseName": "InstanceEventCount",
            "type": "string"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MenuUploadedEvent;
}());
exports.MenuUploadedEvent = MenuUploadedEvent;
var Metadata = (function () {
    function Metadata() {
    }
    Metadata.getAttributeTypeMap = function () {
        return Metadata.attributeTypeMap;
    };
    Metadata.discriminator = undefined;
    Metadata.attributeTypeMap = [
        {
            "name": "MenuEntityId",
            "baseName": "MenuEntityId",
            "type": "number"
        },
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "string"
        }
    ];
    return Metadata;
}());
exports.Metadata = Metadata;
var Metafield = (function () {
    function Metafield() {
    }
    Metafield.getAttributeTypeMap = function () {
        return Metafield.attributeTypeMap;
    };
    Metafield.discriminator = undefined;
    Metafield.attributeTypeMap = [
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "string"
        }
    ];
    return Metafield;
}());
exports.Metafield = Metafield;
var MetafieldDefinition = (function () {
    function MetafieldDefinition() {
    }
    MetafieldDefinition.getAttributeTypeMap = function () {
        return MetafieldDefinition.attributeTypeMap;
    };
    MetafieldDefinition.discriminator = undefined;
    MetafieldDefinition.attributeTypeMap = [
        {
            "name": "IsReadOnly",
            "baseName": "IsReadOnly",
            "type": "boolean"
        },
        {
            "name": "OwnerEntity",
            "baseName": "OwnerEntity",
            "type": "MetafieldDefinition.OwnerEntityEnum"
        },
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "ValueType",
            "baseName": "ValueType",
            "type": "MetafieldDefinition.ValueTypeEnum"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Behaviors",
            "baseName": "Behaviors",
            "type": "Array<MetafieldDefinition.BehaviorsEnum>"
        },
        {
            "name": "MetafieldDefinitionRecommendationId",
            "baseName": "MetafieldDefinitionRecommendationId",
            "type": "number"
        }
    ];
    return MetafieldDefinition;
}());
exports.MetafieldDefinition = MetafieldDefinition;
(function (MetafieldDefinition) {
    var OwnerEntityEnum;
    (function (OwnerEntityEnum) {
        OwnerEntityEnum[OwnerEntityEnum["CatalogItem"] = 'CatalogItem'] = "CatalogItem";
        OwnerEntityEnum[OwnerEntityEnum["CatalogGroup"] = 'CatalogGroup'] = "CatalogGroup";
        OwnerEntityEnum[OwnerEntityEnum["Menu"] = 'Menu'] = "Menu";
    })(OwnerEntityEnum = MetafieldDefinition.OwnerEntityEnum || (MetafieldDefinition.OwnerEntityEnum = {}));
    var ValueTypeEnum;
    (function (ValueTypeEnum) {
        ValueTypeEnum[ValueTypeEnum["Boolean"] = 'Boolean'] = "Boolean";
        ValueTypeEnum[ValueTypeEnum["Json"] = 'Json'] = "Json";
        ValueTypeEnum[ValueTypeEnum["SingleLineString"] = 'SingleLineString'] = "SingleLineString";
        ValueTypeEnum[ValueTypeEnum["MultiLineString"] = 'MultiLineString'] = "MultiLineString";
    })(ValueTypeEnum = MetafieldDefinition.ValueTypeEnum || (MetafieldDefinition.ValueTypeEnum = {}));
    var BehaviorsEnum;
    (function (BehaviorsEnum) {
        BehaviorsEnum[BehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        BehaviorsEnum[BehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(BehaviorsEnum = MetafieldDefinition.BehaviorsEnum || (MetafieldDefinition.BehaviorsEnum = {}));
})(MetafieldDefinition = exports.MetafieldDefinition || (exports.MetafieldDefinition = {}));
exports.MetafieldDefinition = MetafieldDefinition;
var MetafieldDefinitionRecommendation = (function () {
    function MetafieldDefinitionRecommendation() {
    }
    MetafieldDefinitionRecommendation.getAttributeTypeMap = function () {
        return MetafieldDefinitionRecommendation.attributeTypeMap;
    };
    MetafieldDefinitionRecommendation.discriminator = undefined;
    MetafieldDefinitionRecommendation.attributeTypeMap = [
        {
            "name": "OwnerEntity",
            "baseName": "OwnerEntity",
            "type": "MetafieldDefinitionRecommendation.OwnerEntityEnum"
        },
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "ValueType",
            "baseName": "ValueType",
            "type": "MetafieldDefinitionRecommendation.ValueTypeEnum"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Behaviors",
            "baseName": "Behaviors",
            "type": "Array<MetafieldDefinitionRecommendation.BehaviorsEnum>"
        },
        {
            "name": "MetafieldDefinitionRecommendationId",
            "baseName": "MetafieldDefinitionRecommendationId",
            "type": "number"
        }
    ];
    return MetafieldDefinitionRecommendation;
}());
exports.MetafieldDefinitionRecommendation = MetafieldDefinitionRecommendation;
(function (MetafieldDefinitionRecommendation) {
    var OwnerEntityEnum;
    (function (OwnerEntityEnum) {
        OwnerEntityEnum[OwnerEntityEnum["CatalogItem"] = 'CatalogItem'] = "CatalogItem";
        OwnerEntityEnum[OwnerEntityEnum["CatalogGroup"] = 'CatalogGroup'] = "CatalogGroup";
        OwnerEntityEnum[OwnerEntityEnum["Menu"] = 'Menu'] = "Menu";
    })(OwnerEntityEnum = MetafieldDefinitionRecommendation.OwnerEntityEnum || (MetafieldDefinitionRecommendation.OwnerEntityEnum = {}));
    var ValueTypeEnum;
    (function (ValueTypeEnum) {
        ValueTypeEnum[ValueTypeEnum["Boolean"] = 'Boolean'] = "Boolean";
        ValueTypeEnum[ValueTypeEnum["Json"] = 'Json'] = "Json";
        ValueTypeEnum[ValueTypeEnum["SingleLineString"] = 'SingleLineString'] = "SingleLineString";
        ValueTypeEnum[ValueTypeEnum["MultiLineString"] = 'MultiLineString'] = "MultiLineString";
    })(ValueTypeEnum = MetafieldDefinitionRecommendation.ValueTypeEnum || (MetafieldDefinitionRecommendation.ValueTypeEnum = {}));
    var BehaviorsEnum;
    (function (BehaviorsEnum) {
        BehaviorsEnum[BehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        BehaviorsEnum[BehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(BehaviorsEnum = MetafieldDefinitionRecommendation.BehaviorsEnum || (MetafieldDefinitionRecommendation.BehaviorsEnum = {}));
})(MetafieldDefinitionRecommendation = exports.MetafieldDefinitionRecommendation || (exports.MetafieldDefinitionRecommendation = {}));
exports.MetafieldDefinitionRecommendation = MetafieldDefinitionRecommendation;
var MobileAppsImage = (function () {
    function MobileAppsImage() {
    }
    MobileAppsImage.getAttributeTypeMap = function () {
        return MobileAppsImage.attributeTypeMap;
    };
    MobileAppsImage.discriminator = undefined;
    MobileAppsImage.attributeTypeMap = [
        {
            "name": "ImageUri",
            "baseName": "ImageUri",
            "type": "string"
        }
    ];
    return MobileAppsImage;
}());
exports.MobileAppsImage = MobileAppsImage;
var MobileAppsStatistics = (function () {
    function MobileAppsStatistics() {
    }
    MobileAppsStatistics.getAttributeTypeMap = function () {
        return MobileAppsStatistics.attributeTypeMap;
    };
    MobileAppsStatistics.discriminator = undefined;
    MobileAppsStatistics.attributeTypeMap = [
        {
            "name": "NumberDownload",
            "baseName": "NumberDownload",
            "type": "number"
        },
        {
            "name": "CurrentRate",
            "baseName": "CurrentRate",
            "type": "number"
        },
        {
            "name": "CurrentVersion",
            "baseName": "CurrentVersion",
            "type": "string"
        },
        {
            "name": "PlayStoreLink",
            "baseName": "PlayStoreLink",
            "type": "string"
        },
        {
            "name": "AppBundleId",
            "baseName": "AppBundleId",
            "type": "string"
        },
        {
            "name": "LastUpdated",
            "baseName": "LastUpdated",
            "type": "Date"
        },
        {
            "name": "Notes",
            "baseName": "Notes",
            "type": "string"
        },
        {
            "name": "Published",
            "baseName": "Published",
            "type": "boolean"
        },
        {
            "name": "PlatformType",
            "baseName": "PlatformType",
            "type": "MobileAppsStatistics.PlatformTypeEnum"
        }
    ];
    return MobileAppsStatistics;
}());
exports.MobileAppsStatistics = MobileAppsStatistics;
(function (MobileAppsStatistics) {
    var PlatformTypeEnum;
    (function (PlatformTypeEnum) {
        PlatformTypeEnum[PlatformTypeEnum["None"] = 'None'] = "None";
        PlatformTypeEnum[PlatformTypeEnum["Android"] = 'Android'] = "Android";
        PlatformTypeEnum[PlatformTypeEnum["IOS"] = 'IOS'] = "IOS";
    })(PlatformTypeEnum = MobileAppsStatistics.PlatformTypeEnum || (MobileAppsStatistics.PlatformTypeEnum = {}));
})(MobileAppsStatistics = exports.MobileAppsStatistics || (exports.MobileAppsStatistics = {}));
exports.MobileAppsStatistics = MobileAppsStatistics;
var MobileAppsSubmission = (function () {
    function MobileAppsSubmission() {
    }
    MobileAppsSubmission.getAttributeTypeMap = function () {
        return MobileAppsSubmission.attributeTypeMap;
    };
    MobileAppsSubmission.discriminator = undefined;
    MobileAppsSubmission.attributeTypeMap = [
        {
            "name": "SubmissionId",
            "baseName": "SubmissionId",
            "type": "number"
        },
        {
            "name": "AppName",
            "baseName": "AppName",
            "type": "string"
        },
        {
            "name": "AppDescription",
            "baseName": "AppDescription",
            "type": "string"
        },
        {
            "name": "AppShortDescription",
            "baseName": "AppShortDescription",
            "type": "string"
        },
        {
            "name": "Keywords",
            "baseName": "Keywords",
            "type": "Array<string>"
        },
        {
            "name": "AutoPublish",
            "baseName": "AutoPublish",
            "type": "boolean"
        }
    ];
    return MobileAppsSubmission;
}());
exports.MobileAppsSubmission = MobileAppsSubmission;
var MobileAppsSubmissionDetails = (function () {
    function MobileAppsSubmissionDetails() {
    }
    MobileAppsSubmissionDetails.getAttributeTypeMap = function () {
        return MobileAppsSubmissionDetails.attributeTypeMap;
    };
    MobileAppsSubmissionDetails.discriminator = undefined;
    MobileAppsSubmissionDetails.attributeTypeMap = [
        {
            "name": "MobileAppsSubmissionId",
            "baseName": "MobileAppsSubmissionId",
            "type": "number"
        },
        {
            "name": "AppName",
            "baseName": "AppName",
            "type": "string"
        },
        {
            "name": "AppDescription",
            "baseName": "AppDescription",
            "type": "string"
        },
        {
            "name": "AppShortDescription",
            "baseName": "AppShortDescription",
            "type": "string"
        },
        {
            "name": "Keywords",
            "baseName": "Keywords",
            "type": "Array<string>"
        },
        {
            "name": "AppLogoUrl",
            "baseName": "AppLogoUrl",
            "type": "string"
        },
        {
            "name": "AutoPublish",
            "baseName": "AutoPublish",
            "type": "boolean"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "Array<MobileAppsSubmissionStatus>"
        }
    ];
    return MobileAppsSubmissionDetails;
}());
exports.MobileAppsSubmissionDetails = MobileAppsSubmissionDetails;
var MobileAppsSubmissionStatus = (function () {
    function MobileAppsSubmissionStatus() {
    }
    MobileAppsSubmissionStatus.getAttributeTypeMap = function () {
        return MobileAppsSubmissionStatus.attributeTypeMap;
    };
    MobileAppsSubmissionStatus.discriminator = undefined;
    MobileAppsSubmissionStatus.attributeTypeMap = [
        {
            "name": "MobileAppsSubmissionStatusId",
            "baseName": "MobileAppsSubmissionStatusId",
            "type": "number"
        },
        {
            "name": "MobileAppsSubmissionId",
            "baseName": "MobileAppsSubmissionId",
            "type": "number"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "MobileAppsSubmissionStatus.TypeEnum"
        },
        {
            "name": "AppStatus",
            "baseName": "AppStatus",
            "type": "MobileAppsSubmissionStatus.AppStatusEnum"
        },
        {
            "name": "UpdateStatus",
            "baseName": "UpdateStatus",
            "type": "MobileAppsSubmissionStatus.UpdateStatusEnum"
        },
        {
            "name": "LastUpdateStatusTime",
            "baseName": "LastUpdateStatusTime",
            "type": "Date"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "UpdateTime",
            "baseName": "UpdateTime",
            "type": "Date"
        },
        {
            "name": "Notes",
            "baseName": "Notes",
            "type": "string"
        }
    ];
    return MobileAppsSubmissionStatus;
}());
exports.MobileAppsSubmissionStatus = MobileAppsSubmissionStatus;
(function (MobileAppsSubmissionStatus) {
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["None"] = 'None'] = "None";
        TypeEnum[TypeEnum["Android"] = 'Android'] = "Android";
        TypeEnum[TypeEnum["IOS"] = 'IOS'] = "IOS";
    })(TypeEnum = MobileAppsSubmissionStatus.TypeEnum || (MobileAppsSubmissionStatus.TypeEnum = {}));
    var AppStatusEnum;
    (function (AppStatusEnum) {
        AppStatusEnum[AppStatusEnum["None"] = 'None'] = "None";
        AppStatusEnum[AppStatusEnum["Published"] = 'Published'] = "Published";
        AppStatusEnum[AppStatusEnum["Unpublished"] = 'Unpublished'] = "Unpublished";
    })(AppStatusEnum = MobileAppsSubmissionStatus.AppStatusEnum || (MobileAppsSubmissionStatus.AppStatusEnum = {}));
    var UpdateStatusEnum;
    (function (UpdateStatusEnum) {
        UpdateStatusEnum[UpdateStatusEnum["None"] = 'None'] = "None";
        UpdateStatusEnum[UpdateStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        UpdateStatusEnum[UpdateStatusEnum["InReview"] = 'InReview'] = "InReview";
        UpdateStatusEnum[UpdateStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        UpdateStatusEnum[UpdateStatusEnum["Approved"] = 'Approved'] = "Approved";
        UpdateStatusEnum[UpdateStatusEnum["Published"] = 'Published'] = "Published";
    })(UpdateStatusEnum = MobileAppsSubmissionStatus.UpdateStatusEnum || (MobileAppsSubmissionStatus.UpdateStatusEnum = {}));
})(MobileAppsSubmissionStatus = exports.MobileAppsSubmissionStatus || (exports.MobileAppsSubmissionStatus = {}));
exports.MobileAppsSubmissionStatus = MobileAppsSubmissionStatus;
var MobileAppsSubmissionStatusUpdatedEvent = (function () {
    function MobileAppsSubmissionStatusUpdatedEvent() {
    }
    MobileAppsSubmissionStatusUpdatedEvent.getAttributeTypeMap = function () {
        return MobileAppsSubmissionStatusUpdatedEvent.attributeTypeMap;
    };
    MobileAppsSubmissionStatusUpdatedEvent.discriminator = undefined;
    MobileAppsSubmissionStatusUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "MobileAppsSubmissionStatus",
            "baseName": "MobileAppsSubmissionStatus",
            "type": "MobileAppsSubmissionStatus"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MobileAppsSubmissionStatusUpdatedEvent;
}());
exports.MobileAppsSubmissionStatusUpdatedEvent = MobileAppsSubmissionStatusUpdatedEvent;
var MobileAppsSubmissionUpdatedEvent = (function () {
    function MobileAppsSubmissionUpdatedEvent() {
    }
    MobileAppsSubmissionUpdatedEvent.getAttributeTypeMap = function () {
        return MobileAppsSubmissionUpdatedEvent.attributeTypeMap;
    };
    MobileAppsSubmissionUpdatedEvent.discriminator = undefined;
    MobileAppsSubmissionUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return MobileAppsSubmissionUpdatedEvent;
}());
exports.MobileAppsSubmissionUpdatedEvent = MobileAppsSubmissionUpdatedEvent;
var ModelBase = (function () {
    function ModelBase() {
    }
    ModelBase.getAttributeTypeMap = function () {
        return ModelBase.attributeTypeMap;
    };
    ModelBase.discriminator = undefined;
    ModelBase.attributeTypeMap = [];
    return ModelBase;
}());
exports.ModelBase = ModelBase;
var NextStatusWithOrderType = (function () {
    function NextStatusWithOrderType() {
    }
    NextStatusWithOrderType.getAttributeTypeMap = function () {
        return NextStatusWithOrderType.attributeTypeMap;
    };
    NextStatusWithOrderType.discriminator = undefined;
    NextStatusWithOrderType.attributeTypeMap = [
        {
            "name": "OrderType",
            "baseName": "OrderType",
            "type": "NextStatusWithOrderType.OrderTypeEnum"
        },
        {
            "name": "NextStatus",
            "baseName": "NextStatus",
            "type": "string"
        }
    ];
    return NextStatusWithOrderType;
}());
exports.NextStatusWithOrderType = NextStatusWithOrderType;
(function (NextStatusWithOrderType) {
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum[OrderTypeEnum["All"] = 'All'] = "All";
        OrderTypeEnum[OrderTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        OrderTypeEnum[OrderTypeEnum["Collection"] = 'Collection'] = "Collection";
        OrderTypeEnum[OrderTypeEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(OrderTypeEnum = NextStatusWithOrderType.OrderTypeEnum || (NextStatusWithOrderType.OrderTypeEnum = {}));
})(NextStatusWithOrderType = exports.NextStatusWithOrderType || (exports.NextStatusWithOrderType = {}));
exports.NextStatusWithOrderType = NextStatusWithOrderType;
var NutritionInfo = (function () {
    function NutritionInfo() {
    }
    NutritionInfo.getAttributeTypeMap = function () {
        return NutritionInfo.attributeTypeMap;
    };
    NutritionInfo.discriminator = undefined;
    NutritionInfo.attributeTypeMap = [
        {
            "name": "Version",
            "baseName": "Version",
            "type": "string"
        },
        {
            "name": "MenuItems",
            "baseName": "MenuItems",
            "type": "Array<NutritionInfoMenuItem>"
        },
        {
            "name": "MenuItemOptionSetItems",
            "baseName": "MenuItemOptionSetItems",
            "type": "Array<NutritionInfoMenuOptionSetItem>"
        }
    ];
    return NutritionInfo;
}());
exports.NutritionInfo = NutritionInfo;
var NutritionInfoItemAddUpdateLabelModel = (function () {
    function NutritionInfoItemAddUpdateLabelModel() {
    }
    NutritionInfoItemAddUpdateLabelModel.getAttributeTypeMap = function () {
        return NutritionInfoItemAddUpdateLabelModel.attributeTypeMap;
    };
    NutritionInfoItemAddUpdateLabelModel.discriminator = undefined;
    NutritionInfoItemAddUpdateLabelModel.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Values",
            "baseName": "Values",
            "type": "Array<string>"
        },
        {
            "name": "IconUrl",
            "baseName": "IconUrl",
            "type": "string"
        }
    ];
    return NutritionInfoItemAddUpdateLabelModel;
}());
exports.NutritionInfoItemAddUpdateLabelModel = NutritionInfoItemAddUpdateLabelModel;
var NutritionInfoLabel = (function () {
    function NutritionInfoLabel() {
    }
    NutritionInfoLabel.getAttributeTypeMap = function () {
        return NutritionInfoLabel.attributeTypeMap;
    };
    NutritionInfoLabel.discriminator = undefined;
    NutritionInfoLabel.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Values",
            "baseName": "Values",
            "type": "Array<string>"
        },
        {
            "name": "IconUrl",
            "baseName": "IconUrl",
            "type": "string"
        }
    ];
    return NutritionInfoLabel;
}());
exports.NutritionInfoLabel = NutritionInfoLabel;
var NutritionInfoMenuItem = (function () {
    function NutritionInfoMenuItem() {
    }
    NutritionInfoMenuItem.getAttributeTypeMap = function () {
        return NutritionInfoMenuItem.attributeTypeMap;
    };
    NutritionInfoMenuItem.discriminator = undefined;
    NutritionInfoMenuItem.attributeTypeMap = [
        {
            "name": "PublicId",
            "baseName": "PublicId",
            "type": "string"
        },
        {
            "name": "Labels",
            "baseName": "Labels",
            "type": "Array<NutritionInfoLabel>"
        }
    ];
    return NutritionInfoMenuItem;
}());
exports.NutritionInfoMenuItem = NutritionInfoMenuItem;
var NutritionInfoMenuOptionSetItem = (function () {
    function NutritionInfoMenuOptionSetItem() {
    }
    NutritionInfoMenuOptionSetItem.getAttributeTypeMap = function () {
        return NutritionInfoMenuOptionSetItem.attributeTypeMap;
    };
    NutritionInfoMenuOptionSetItem.discriminator = undefined;
    NutritionInfoMenuOptionSetItem.attributeTypeMap = [
        {
            "name": "PublicId",
            "baseName": "PublicId",
            "type": "string"
        },
        {
            "name": "Labels",
            "baseName": "Labels",
            "type": "Array<NutritionInfoLabel>"
        }
    ];
    return NutritionInfoMenuOptionSetItem;
}());
exports.NutritionInfoMenuOptionSetItem = NutritionInfoMenuOptionSetItem;
var OAuthApp = (function () {
    function OAuthApp() {
    }
    OAuthApp.getAttributeTypeMap = function () {
        return OAuthApp.attributeTypeMap;
    };
    OAuthApp.discriminator = undefined;
    OAuthApp.attributeTypeMap = [
        {
            "name": "OauthAppId",
            "baseName": "OauthAppId",
            "type": "string"
        },
        {
            "name": "OauthAppName",
            "baseName": "OauthAppName",
            "type": "string"
        },
        {
            "name": "OwnerUserId",
            "baseName": "OwnerUserId",
            "type": "number"
        },
        {
            "name": "LogoUri",
            "baseName": "LogoUri",
            "type": "string"
        },
        {
            "name": "Flow",
            "baseName": "Flow",
            "type": "OAuthApp.FlowEnum"
        },
        {
            "name": "RefreshTokenUsage",
            "baseName": "RefreshTokenUsage",
            "type": "OAuthApp.RefreshTokenUsageEnum"
        },
        {
            "name": "AccessTokenLifetime",
            "baseName": "AccessTokenLifetime",
            "type": "number"
        },
        {
            "name": "AbsoluteRefreshTokenLifetime",
            "baseName": "AbsoluteRefreshTokenLifetime",
            "type": "number"
        }
    ];
    return OAuthApp;
}());
exports.OAuthApp = OAuthApp;
(function (OAuthApp) {
    var FlowEnum;
    (function (FlowEnum) {
        FlowEnum[FlowEnum["AuthorizationCode"] = 'AuthorizationCode'] = "AuthorizationCode";
        FlowEnum[FlowEnum["Implicit"] = 'Implicit'] = "Implicit";
        FlowEnum[FlowEnum["Hybrid"] = 'Hybrid'] = "Hybrid";
        FlowEnum[FlowEnum["ClientCredentials"] = 'ClientCredentials'] = "ClientCredentials";
    })(FlowEnum = OAuthApp.FlowEnum || (OAuthApp.FlowEnum = {}));
    var RefreshTokenUsageEnum;
    (function (RefreshTokenUsageEnum) {
        RefreshTokenUsageEnum[RefreshTokenUsageEnum["ReUse"] = 'ReUse'] = "ReUse";
        RefreshTokenUsageEnum[RefreshTokenUsageEnum["OneTimeOnly"] = 'OneTimeOnly'] = "OneTimeOnly";
    })(RefreshTokenUsageEnum = OAuthApp.RefreshTokenUsageEnum || (OAuthApp.RefreshTokenUsageEnum = {}));
})(OAuthApp = exports.OAuthApp || (exports.OAuthApp = {}));
exports.OAuthApp = OAuthApp;
var OAuthTokenModel = (function () {
    function OAuthTokenModel() {
    }
    OAuthTokenModel.getAttributeTypeMap = function () {
        return OAuthTokenModel.attributeTypeMap;
    };
    OAuthTokenModel.discriminator = undefined;
    OAuthTokenModel.attributeTypeMap = [
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "TokenType",
            "baseName": "TokenType",
            "type": "string"
        },
        {
            "name": "SubjectId",
            "baseName": "SubjectId",
            "type": "string"
        },
        {
            "name": "ClientId",
            "baseName": "ClientId",
            "type": "string"
        },
        {
            "name": "Expiry",
            "baseName": "Expiry",
            "type": "Date"
        }
    ];
    return OAuthTokenModel;
}());
exports.OAuthTokenModel = OAuthTokenModel;
var OauthClientRedirectUri = (function () {
    function OauthClientRedirectUri() {
    }
    OauthClientRedirectUri.getAttributeTypeMap = function () {
        return OauthClientRedirectUri.attributeTypeMap;
    };
    OauthClientRedirectUri.discriminator = undefined;
    OauthClientRedirectUri.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "Uri",
            "baseName": "Uri",
            "type": "string"
        }
    ];
    return OauthClientRedirectUri;
}());
exports.OauthClientRedirectUri = OauthClientRedirectUri;
var ObjectDisplayOrder = (function () {
    function ObjectDisplayOrder() {
    }
    ObjectDisplayOrder.getAttributeTypeMap = function () {
        return ObjectDisplayOrder.attributeTypeMap;
    };
    ObjectDisplayOrder.discriminator = undefined;
    ObjectDisplayOrder.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "DisplayOrder",
            "baseName": "DisplayOrder",
            "type": "number"
        }
    ];
    return ObjectDisplayOrder;
}());
exports.ObjectDisplayOrder = ObjectDisplayOrder;
var OktaPortalFeatureFlag = (function () {
    function OktaPortalFeatureFlag() {
    }
    OktaPortalFeatureFlag.getAttributeTypeMap = function () {
        return OktaPortalFeatureFlag.attributeTypeMap;
    };
    OktaPortalFeatureFlag.discriminator = undefined;
    OktaPortalFeatureFlag.attributeTypeMap = [
        {
            "name": "OktaPortalEnabled",
            "baseName": "OktaPortalEnabled",
            "type": "boolean"
        }
    ];
    return OktaPortalFeatureFlag;
}());
exports.OktaPortalFeatureFlag = OktaPortalFeatureFlag;
var OnboardingConfigUpdate = (function () {
    function OnboardingConfigUpdate() {
    }
    OnboardingConfigUpdate.getAttributeTypeMap = function () {
        return OnboardingConfigUpdate.attributeTypeMap;
    };
    OnboardingConfigUpdate.discriminator = undefined;
    OnboardingConfigUpdate.attributeTypeMap = [
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "IsWelcomeScreenEnabled",
            "baseName": "IsWelcomeScreenEnabled",
            "type": "boolean"
        }
    ];
    return OnboardingConfigUpdate;
}());
exports.OnboardingConfigUpdate = OnboardingConfigUpdate;
var OnboardingItemUpdate = (function () {
    function OnboardingItemUpdate() {
    }
    OnboardingItemUpdate.getAttributeTypeMap = function () {
        return OnboardingItemUpdate.attributeTypeMap;
    };
    OnboardingItemUpdate.discriminator = undefined;
    OnboardingItemUpdate.attributeTypeMap = [
        {
            "name": "Status",
            "baseName": "Status",
            "type": "OnboardingItemUpdate.StatusEnum"
        }
    ];
    return OnboardingItemUpdate;
}());
exports.OnboardingItemUpdate = OnboardingItemUpdate;
(function (OnboardingItemUpdate) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Pending"] = 'Pending'] = "Pending";
        StatusEnum[StatusEnum["InProgress"] = 'InProgress'] = "InProgress";
        StatusEnum[StatusEnum["Completed"] = 'Completed'] = "Completed";
    })(StatusEnum = OnboardingItemUpdate.StatusEnum || (OnboardingItemUpdate.StatusEnum = {}));
})(OnboardingItemUpdate = exports.OnboardingItemUpdate || (exports.OnboardingItemUpdate = {}));
exports.OnboardingItemUpdate = OnboardingItemUpdate;
var Order = (function () {
    function Order() {
    }
    Order.getAttributeTypeMap = function () {
        return Order.attributeTypeMap;
    };
    Order.discriminator = undefined;
    Order.attributeTypeMap = [
        {
            "name": "Store",
            "baseName": "Store",
            "type": "StoreSummary"
        },
        {
            "name": "Customer",
            "baseName": "Customer",
            "type": "CustomerSummary"
        },
        {
            "name": "Voucher",
            "baseName": "Voucher",
            "type": "OrderVoucherSummary"
        },
        {
            "name": "Fees",
            "baseName": "Fees",
            "type": "FeeSummary"
        },
        {
            "name": "OrderItems",
            "baseName": "OrderItems",
            "type": "Array<OrderItem>"
        },
        {
            "name": "DeliveryLocation",
            "baseName": "DeliveryLocation",
            "type": "DeliveryLocation"
        },
        {
            "name": "CustomerLocation",
            "baseName": "CustomerLocation",
            "type": "Coordinates"
        },
        {
            "name": "MaskedPhoneNumber",
            "baseName": "MaskedPhoneNumber",
            "type": "MaskedPhoneNumber"
        },
        {
            "name": "DropOffLocationId",
            "baseName": "DropOffLocationId",
            "type": "number"
        },
        {
            "name": "DropOffLocation",
            "baseName": "DropOffLocation",
            "type": "string"
        },
        {
            "name": "AcceptedFor",
            "baseName": "AcceptedFor",
            "type": "Date"
        },
        {
            "name": "InFraudZone",
            "baseName": "InFraudZone",
            "type": "boolean"
        },
        {
            "name": "UnusualHighValueOrder",
            "baseName": "UnusualHighValueOrder",
            "type": "boolean"
        },
        {
            "name": "RejectedByUserId",
            "baseName": "RejectedByUserId",
            "type": "number"
        },
        {
            "name": "ChannelOrderId",
            "baseName": "ChannelOrderId",
            "type": "string"
        },
        {
            "name": "ChannelOrderDisplayId",
            "baseName": "ChannelOrderDisplayId",
            "type": "string"
        },
        {
            "name": "Channel",
            "baseName": "Channel",
            "type": "Channel"
        },
        {
            "name": "ReceiptCode",
            "baseName": "ReceiptCode",
            "type": "string"
        },
        {
            "name": "OrderDropOffLocation",
            "baseName": "OrderDropOffLocation",
            "type": "OrderDropOffLocation"
        },
        {
            "name": "FulfillmentStatus",
            "baseName": "FulfillmentStatus",
            "type": "OrderFulfillmentStatusBase"
        },
        {
            "name": "OrderBatchInfo",
            "baseName": "OrderBatchInfo",
            "type": "OrderBatchSummary"
        },
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "LocalOrderId",
            "baseName": "LocalOrderId",
            "type": "string"
        },
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "Order.DeliveryTypeEnum"
        },
        {
            "name": "PickupLocationType",
            "baseName": "PickupLocationType",
            "type": "Order.PickupLocationTypeEnum"
        },
        {
            "name": "TableServiceCatagory",
            "baseName": "TableServiceCatagory",
            "type": "Order.TableServiceCatagoryEnum"
        },
        {
            "name": "TipAmount",
            "baseName": "TipAmount",
            "type": "number"
        },
        {
            "name": "DeliveryAmount",
            "baseName": "DeliveryAmount",
            "type": "number"
        },
        {
            "name": "OrderItemsAmount",
            "baseName": "OrderItemsAmount",
            "type": "number"
        },
        {
            "name": "ServiceChargeAmount",
            "baseName": "ServiceChargeAmount",
            "type": "number"
        },
        {
            "name": "ServiceChargePercentage",
            "baseName": "ServiceChargePercentage",
            "type": "number"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "ProcessingFee",
            "baseName": "ProcessingFee",
            "type": "number"
        },
        {
            "name": "PaymentAccountType",
            "baseName": "PaymentAccountType",
            "type": "Order.PaymentAccountTypeEnum"
        },
        {
            "name": "PaymentAccountDescription",
            "baseName": "PaymentAccountDescription",
            "type": "string"
        },
        {
            "name": "OrderState",
            "baseName": "OrderState",
            "type": "Order.OrderStateEnum"
        },
        {
            "name": "IsPreOrder",
            "baseName": "IsPreOrder",
            "type": "boolean"
        },
        {
            "name": "PlacedTime",
            "baseName": "PlacedTime",
            "type": "Date"
        },
        {
            "name": "RequestedForTime",
            "baseName": "RequestedForTime",
            "type": "Date"
        },
        {
            "name": "ChefNote",
            "baseName": "ChefNote",
            "type": "string"
        },
        {
            "name": "AppType",
            "baseName": "AppType",
            "type": "Order.AppTypeEnum"
        },
        {
            "name": "UserRating",
            "baseName": "UserRating",
            "type": "number"
        },
        {
            "name": "PaymentStatus",
            "baseName": "PaymentStatus",
            "type": "Order.PaymentStatusEnum"
        },
        {
            "name": "RejectionReason",
            "baseName": "RejectionReason",
            "type": "Order.RejectionReasonEnum"
        },
        {
            "name": "RefundedAmount",
            "baseName": "RefundedAmount",
            "type": "number"
        },
        {
            "name": "DeliveryTrackingStatus",
            "baseName": "DeliveryTrackingStatus",
            "type": "Order.DeliveryTrackingStatusEnum"
        },
        {
            "name": "DriverId",
            "baseName": "DriverId",
            "type": "number"
        },
        {
            "name": "TotalTax",
            "baseName": "TotalTax",
            "type": "number"
        },
        {
            "name": "OrderTrackingCode",
            "baseName": "OrderTrackingCode",
            "type": "string"
        }
    ];
    return Order;
}());
exports.Order = Order;
(function (Order) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = Order.DeliveryTypeEnum || (Order.DeliveryTypeEnum = {}));
    var PickupLocationTypeEnum;
    (function (PickupLocationTypeEnum) {
        PickupLocationTypeEnum[PickupLocationTypeEnum["TakeOut"] = 'TakeOut'] = "TakeOut";
        PickupLocationTypeEnum[PickupLocationTypeEnum["TableService"] = 'TableService'] = "TableService";
        PickupLocationTypeEnum[PickupLocationTypeEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(PickupLocationTypeEnum = Order.PickupLocationTypeEnum || (Order.PickupLocationTypeEnum = {}));
    var TableServiceCatagoryEnum;
    (function (TableServiceCatagoryEnum) {
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Generic"] = 'Generic'] = "Generic";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Villa"] = 'Villa'] = "Villa";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["House"] = 'House'] = "House";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Room"] = 'Room'] = "Room";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Area"] = 'Area'] = "Area";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Table"] = 'Table'] = "Table";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["ParkingBay"] = 'ParkingBay'] = "ParkingBay";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Gate"] = 'Gate'] = "Gate";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["DriveThrough"] = 'DriveThrough'] = "DriveThrough";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Team"] = 'Team'] = "Team";
    })(TableServiceCatagoryEnum = Order.TableServiceCatagoryEnum || (Order.TableServiceCatagoryEnum = {}));
    var PaymentAccountTypeEnum;
    (function (PaymentAccountTypeEnum) {
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Card"] = 'Card'] = "Card";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Cash"] = 'Cash'] = "Cash";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Ideal"] = 'Ideal'] = "Ideal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Bancontact"] = 'Bancontact'] = "Bancontact";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Giropay"] = 'Giropay'] = "Giropay";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Eps"] = 'Eps'] = "Eps";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Emv"] = 'Emv'] = "Emv";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayPal"] = 'PayPal'] = "PayPal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayGreen"] = 'PayGreen'] = "PayGreen";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["GoogleWalletToken"] = 'GoogleWalletToken'] = "GoogleWalletToken";
    })(PaymentAccountTypeEnum = Order.PaymentAccountTypeEnum || (Order.PaymentAccountTypeEnum = {}));
    var OrderStateEnum;
    (function (OrderStateEnum) {
        OrderStateEnum[OrderStateEnum["Created"] = 'Created'] = "Created";
        OrderStateEnum[OrderStateEnum["PlacedCanBeCancelled"] = 'PlacedCanBeCancelled'] = "PlacedCanBeCancelled";
        OrderStateEnum[OrderStateEnum["ReadyToProcess"] = 'ReadyToProcess'] = "ReadyToProcess";
        OrderStateEnum[OrderStateEnum["AcceptedByRestaurant"] = 'AcceptedByRestaurant'] = "AcceptedByRestaurant";
        OrderStateEnum[OrderStateEnum["Dispatched"] = 'Dispatched'] = "Dispatched";
        OrderStateEnum[OrderStateEnum["Delivered"] = 'Delivered'] = "Delivered";
        OrderStateEnum[OrderStateEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
        OrderStateEnum[OrderStateEnum["ManualReview"] = 'ManualReview'] = "ManualReview";
        OrderStateEnum[OrderStateEnum["RejectedByStore"] = 'RejectedByStore'] = "RejectedByStore";
        OrderStateEnum[OrderStateEnum["RejectedByFlipdish"] = 'RejectedByFlipdish'] = "RejectedByFlipdish";
        OrderStateEnum[OrderStateEnum["RejectedAutomatically"] = 'RejectedAutomatically'] = "RejectedAutomatically";
        OrderStateEnum[OrderStateEnum["RejectedAfterBeingAccepted"] = 'RejectedAfterBeingAccepted'] = "RejectedAfterBeingAccepted";
        OrderStateEnum[OrderStateEnum["AcceptedAndRefunded"] = 'AcceptedAndRefunded'] = "AcceptedAndRefunded";
    })(OrderStateEnum = Order.OrderStateEnum || (Order.OrderStateEnum = {}));
    var AppTypeEnum;
    (function (AppTypeEnum) {
        AppTypeEnum[AppTypeEnum["Unknown"] = 'Unknown'] = "Unknown";
        AppTypeEnum[AppTypeEnum["Ios"] = 'Ios'] = "Ios";
        AppTypeEnum[AppTypeEnum["Android"] = 'Android'] = "Android";
        AppTypeEnum[AppTypeEnum["Web"] = 'Web'] = "Web";
        AppTypeEnum[AppTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        AppTypeEnum[AppTypeEnum["Pos"] = 'Pos'] = "Pos";
        AppTypeEnum[AppTypeEnum["TelephoneCall"] = 'TelephoneCall'] = "TelephoneCall";
        AppTypeEnum[AppTypeEnum["Sms"] = 'Sms'] = "Sms";
        AppTypeEnum[AppTypeEnum["PwaAndroid"] = 'PwaAndroid'] = "PwaAndroid";
        AppTypeEnum[AppTypeEnum["PwaIos"] = 'PwaIos'] = "PwaIos";
        AppTypeEnum[AppTypeEnum["Google"] = 'Google'] = "Google";
    })(AppTypeEnum = Order.AppTypeEnum || (Order.AppTypeEnum = {}));
    var PaymentStatusEnum;
    (function (PaymentStatusEnum) {
        PaymentStatusEnum[PaymentStatusEnum["Paid"] = 'Paid'] = "Paid";
        PaymentStatusEnum[PaymentStatusEnum["Unpaid"] = 'Unpaid'] = "Unpaid";
        PaymentStatusEnum[PaymentStatusEnum["Refunded"] = 'Refunded'] = "Refunded";
        PaymentStatusEnum[PaymentStatusEnum["PartiallyRefunded"] = 'PartiallyRefunded'] = "PartiallyRefunded";
        PaymentStatusEnum[PaymentStatusEnum["Disputed"] = 'Disputed'] = "Disputed";
    })(PaymentStatusEnum = Order.PaymentStatusEnum || (Order.PaymentStatusEnum = {}));
    var RejectionReasonEnum;
    (function (RejectionReasonEnum) {
        RejectionReasonEnum[RejectionReasonEnum["TooBusy"] = 'TooBusy'] = "TooBusy";
        RejectionReasonEnum[RejectionReasonEnum["FoodUnavailable"] = 'FoodUnavailable'] = "FoodUnavailable";
        RejectionReasonEnum[RejectionReasonEnum["UnableToDeliver"] = 'UnableToDeliver'] = "UnableToDeliver";
        RejectionReasonEnum[RejectionReasonEnum["UnknownAddress"] = 'UnknownAddress'] = "UnknownAddress";
        RejectionReasonEnum[RejectionReasonEnum["UnknownReason"] = 'UnknownReason'] = "UnknownReason";
        RejectionReasonEnum[RejectionReasonEnum["TooSoon"] = 'TooSoon'] = "TooSoon";
        RejectionReasonEnum[RejectionReasonEnum["TimeUnavailable"] = 'TimeUnavailable'] = "TimeUnavailable";
        RejectionReasonEnum[RejectionReasonEnum["DontDeliverToArea"] = 'DontDeliverToArea'] = "DontDeliverToArea";
        RejectionReasonEnum[RejectionReasonEnum["StoreUncontactable"] = 'StoreUncontactable'] = "StoreUncontactable";
    })(RejectionReasonEnum = Order.RejectionReasonEnum || (Order.RejectionReasonEnum = {}));
    var DeliveryTrackingStatusEnum;
    (function (DeliveryTrackingStatusEnum) {
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Unassigned"] = 'Unassigned'] = "Unassigned";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Unaccepted"] = 'Unaccepted'] = "Unaccepted";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Carrying"] = 'Carrying'] = "Carrying";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["OnTheWay"] = 'OnTheWay'] = "OnTheWay";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["ArrivedAtLocation"] = 'ArrivedAtLocation'] = "ArrivedAtLocation";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Delivered"] = 'Delivered'] = "Delivered";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["CannotDeliver"] = 'CannotDeliver'] = "CannotDeliver";
    })(DeliveryTrackingStatusEnum = Order.DeliveryTrackingStatusEnum || (Order.DeliveryTrackingStatusEnum = {}));
})(Order = exports.Order || (exports.Order = {}));
exports.Order = Order;
var OrderAcceptedEvent = (function () {
    function OrderAcceptedEvent() {
    }
    OrderAcceptedEvent.getAttributeTypeMap = function () {
        return OrderAcceptedEvent.attributeTypeMap;
    };
    OrderAcceptedEvent.discriminator = undefined;
    OrderAcceptedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "OrderAcceptedTime",
            "baseName": "OrderAcceptedTime",
            "type": "Date"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderAcceptedEvent;
}());
exports.OrderAcceptedEvent = OrderAcceptedEvent;
var OrderBatch = (function () {
    function OrderBatch() {
    }
    OrderBatch.getAttributeTypeMap = function () {
        return OrderBatch.attributeTypeMap;
    };
    OrderBatch.discriminator = undefined;
    OrderBatch.attributeTypeMap = [
        {
            "name": "OrderIds",
            "baseName": "OrderIds",
            "type": "Array<number>"
        },
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "DisplayCode",
            "baseName": "DisplayCode",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "IsPublished",
            "baseName": "IsPublished",
            "type": "boolean"
        }
    ];
    return OrderBatch;
}());
exports.OrderBatch = OrderBatch;
var OrderBatchPublishedEvent = (function () {
    function OrderBatchPublishedEvent() {
    }
    OrderBatchPublishedEvent.getAttributeTypeMap = function () {
        return OrderBatchPublishedEvent.attributeTypeMap;
    };
    OrderBatchPublishedEvent.discriminator = undefined;
    OrderBatchPublishedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "OrderBatchId",
            "baseName": "OrderBatchId",
            "type": "number"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "OrderIds",
            "baseName": "OrderIds",
            "type": "Array<number>"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderBatchPublishedEvent;
}());
exports.OrderBatchPublishedEvent = OrderBatchPublishedEvent;
var OrderBatchSummary = (function () {
    function OrderBatchSummary() {
    }
    OrderBatchSummary.getAttributeTypeMap = function () {
        return OrderBatchSummary.attributeTypeMap;
    };
    OrderBatchSummary.discriminator = undefined;
    OrderBatchSummary.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "DisplayCode",
            "baseName": "DisplayCode",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "IsPublished",
            "baseName": "IsPublished",
            "type": "boolean"
        }
    ];
    return OrderBatchSummary;
}());
exports.OrderBatchSummary = OrderBatchSummary;
var OrderBatchingConfiguration = (function () {
    function OrderBatchingConfiguration() {
    }
    OrderBatchingConfiguration.getAttributeTypeMap = function () {
        return OrderBatchingConfiguration.attributeTypeMap;
    };
    OrderBatchingConfiguration.discriminator = undefined;
    OrderBatchingConfiguration.attributeTypeMap = [
        {
            "name": "BatchIntervalInSeconds",
            "baseName": "BatchIntervalInSeconds",
            "type": "number"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        }
    ];
    return OrderBatchingConfiguration;
}());
exports.OrderBatchingConfiguration = OrderBatchingConfiguration;
var OrderCapacityConfigUpdatedEvent = (function () {
    function OrderCapacityConfigUpdatedEvent() {
    }
    OrderCapacityConfigUpdatedEvent.getAttributeTypeMap = function () {
        return OrderCapacityConfigUpdatedEvent.attributeTypeMap;
    };
    OrderCapacityConfigUpdatedEvent.discriminator = undefined;
    OrderCapacityConfigUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "OrderCapacityConfig",
            "baseName": "OrderCapacityConfig",
            "type": "StoreOrderCapacityConfigEditModel"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderCapacityConfigUpdatedEvent;
}());
exports.OrderCapacityConfigUpdatedEvent = OrderCapacityConfigUpdatedEvent;
var OrderCreatedEvent = (function () {
    function OrderCreatedEvent() {
    }
    OrderCreatedEvent.getAttributeTypeMap = function () {
        return OrderCreatedEvent.attributeTypeMap;
    };
    OrderCreatedEvent.discriminator = undefined;
    OrderCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "OrderCreatedTime",
            "baseName": "OrderCreatedTime",
            "type": "Date"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderCreatedEvent;
}());
exports.OrderCreatedEvent = OrderCreatedEvent;
var OrderCustomerTrackingCreatedEvent = (function () {
    function OrderCustomerTrackingCreatedEvent() {
    }
    OrderCustomerTrackingCreatedEvent.getAttributeTypeMap = function () {
        return OrderCustomerTrackingCreatedEvent.attributeTypeMap;
    };
    OrderCustomerTrackingCreatedEvent.discriminator = undefined;
    OrderCustomerTrackingCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "CustomerDeliveryTrackingOrder"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderCustomerTrackingCreatedEvent;
}());
exports.OrderCustomerTrackingCreatedEvent = OrderCustomerTrackingCreatedEvent;
var OrderDeliveryInformation = (function () {
    function OrderDeliveryInformation() {
    }
    OrderDeliveryInformation.getAttributeTypeMap = function () {
        return OrderDeliveryInformation.attributeTypeMap;
    };
    OrderDeliveryInformation.discriminator = undefined;
    OrderDeliveryInformation.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "ExternalReferenceId",
            "baseName": "ExternalReferenceId",
            "type": "string"
        },
        {
            "name": "TrackUrl",
            "baseName": "TrackUrl",
            "type": "string"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "OrderDeliveryInformation.StatusEnum"
        },
        {
            "name": "DeliveryStatusNotes",
            "baseName": "DeliveryStatusNotes",
            "type": "string"
        },
        {
            "name": "ErrorMessage",
            "baseName": "ErrorMessage",
            "type": "string"
        },
        {
            "name": "IntegrationCode",
            "baseName": "IntegrationCode",
            "type": "string"
        },
        {
            "name": "IntegrationName",
            "baseName": "IntegrationName",
            "type": "string"
        }
    ];
    return OrderDeliveryInformation;
}());
exports.OrderDeliveryInformation = OrderDeliveryInformation;
(function (OrderDeliveryInformation) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["None"] = 'None'] = "None";
        StatusEnum[StatusEnum["Unassigned"] = 'Unassigned'] = "Unassigned";
        StatusEnum[StatusEnum["Unaccepted"] = 'Unaccepted'] = "Unaccepted";
        StatusEnum[StatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        StatusEnum[StatusEnum["Carrying"] = 'Carrying'] = "Carrying";
        StatusEnum[StatusEnum["OnTheWay"] = 'OnTheWay'] = "OnTheWay";
        StatusEnum[StatusEnum["ArrivedAtLocation"] = 'ArrivedAtLocation'] = "ArrivedAtLocation";
        StatusEnum[StatusEnum["Delivered"] = 'Delivered'] = "Delivered";
        StatusEnum[StatusEnum["CannotDeliver"] = 'CannotDeliver'] = "CannotDeliver";
    })(StatusEnum = OrderDeliveryInformation.StatusEnum || (OrderDeliveryInformation.StatusEnum = {}));
})(OrderDeliveryInformation = exports.OrderDeliveryInformation || (exports.OrderDeliveryInformation = {}));
exports.OrderDeliveryInformation = OrderDeliveryInformation;
var OrderDeliveryInformationBase = (function () {
    function OrderDeliveryInformationBase() {
    }
    OrderDeliveryInformationBase.getAttributeTypeMap = function () {
        return OrderDeliveryInformationBase.attributeTypeMap;
    };
    OrderDeliveryInformationBase.discriminator = undefined;
    OrderDeliveryInformationBase.attributeTypeMap = [
        {
            "name": "ExternalReferenceId",
            "baseName": "ExternalReferenceId",
            "type": "string"
        },
        {
            "name": "TrackUrl",
            "baseName": "TrackUrl",
            "type": "string"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "OrderDeliveryInformationBase.StatusEnum"
        },
        {
            "name": "DeliveryStatusNotes",
            "baseName": "DeliveryStatusNotes",
            "type": "string"
        },
        {
            "name": "ErrorMessage",
            "baseName": "ErrorMessage",
            "type": "string"
        },
        {
            "name": "IntegrationCode",
            "baseName": "IntegrationCode",
            "type": "string"
        },
        {
            "name": "IntegrationName",
            "baseName": "IntegrationName",
            "type": "string"
        }
    ];
    return OrderDeliveryInformationBase;
}());
exports.OrderDeliveryInformationBase = OrderDeliveryInformationBase;
(function (OrderDeliveryInformationBase) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["None"] = 'None'] = "None";
        StatusEnum[StatusEnum["Unassigned"] = 'Unassigned'] = "Unassigned";
        StatusEnum[StatusEnum["Unaccepted"] = 'Unaccepted'] = "Unaccepted";
        StatusEnum[StatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        StatusEnum[StatusEnum["Carrying"] = 'Carrying'] = "Carrying";
        StatusEnum[StatusEnum["OnTheWay"] = 'OnTheWay'] = "OnTheWay";
        StatusEnum[StatusEnum["ArrivedAtLocation"] = 'ArrivedAtLocation'] = "ArrivedAtLocation";
        StatusEnum[StatusEnum["Delivered"] = 'Delivered'] = "Delivered";
        StatusEnum[StatusEnum["CannotDeliver"] = 'CannotDeliver'] = "CannotDeliver";
    })(StatusEnum = OrderDeliveryInformationBase.StatusEnum || (OrderDeliveryInformationBase.StatusEnum = {}));
})(OrderDeliveryInformationBase = exports.OrderDeliveryInformationBase || (exports.OrderDeliveryInformationBase = {}));
exports.OrderDeliveryInformationBase = OrderDeliveryInformationBase;
var OrderDeliveryTrackingStatusUpdatedEvent = (function () {
    function OrderDeliveryTrackingStatusUpdatedEvent() {
    }
    OrderDeliveryTrackingStatusUpdatedEvent.getAttributeTypeMap = function () {
        return OrderDeliveryTrackingStatusUpdatedEvent.attributeTypeMap;
    };
    OrderDeliveryTrackingStatusUpdatedEvent.discriminator = undefined;
    OrderDeliveryTrackingStatusUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderDeliveryTrackingStatusUpdatedEvent;
}());
exports.OrderDeliveryTrackingStatusUpdatedEvent = OrderDeliveryTrackingStatusUpdatedEvent;
var OrderDispatchedEvent = (function () {
    function OrderDispatchedEvent() {
    }
    OrderDispatchedEvent.getAttributeTypeMap = function () {
        return OrderDispatchedEvent.attributeTypeMap;
    };
    OrderDispatchedEvent.discriminator = undefined;
    OrderDispatchedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "OrderDispatchedTime",
            "baseName": "OrderDispatchedTime",
            "type": "Date"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderDispatchedEvent;
}());
exports.OrderDispatchedEvent = OrderDispatchedEvent;
var OrderDm = (function () {
    function OrderDm() {
    }
    OrderDm.getAttributeTypeMap = function () {
        return OrderDm.attributeTypeMap;
    };
    OrderDm.discriminator = undefined;
    OrderDm.attributeTypeMap = [
        {
            "name": "UserLocation",
            "baseName": "UserLocation",
            "type": "CoordinatesDm"
        },
        {
            "name": "RequestedDeliveryOrPickupTimeUtc",
            "baseName": "RequestedDeliveryOrPickupTimeUtc",
            "type": "Date"
        },
        {
            "name": "TipAmount",
            "baseName": "TipAmount",
            "type": "number"
        },
        {
            "name": "DeliveryLocationId",
            "baseName": "DeliveryLocationId",
            "type": "number"
        },
        {
            "name": "OrderItemVms",
            "baseName": "OrderItemVms",
            "type": "Array<OrderItemDm>"
        },
        {
            "name": "VirtualRestaurantId",
            "baseName": "VirtualRestaurantId",
            "type": "number"
        },
        {
            "name": "PhysicalRestaurantId",
            "baseName": "PhysicalRestaurantId",
            "type": "number"
        },
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "OrderDm.DeliveryTypeEnum"
        },
        {
            "name": "PickupLocationType",
            "baseName": "PickupLocationType",
            "type": "OrderDm.PickupLocationTypeEnum"
        },
        {
            "name": "PickupLocationId",
            "baseName": "PickupLocationId",
            "type": "number"
        },
        {
            "name": "TableServiceCatagory",
            "baseName": "TableServiceCatagory",
            "type": "OrderDm.TableServiceCatagoryEnum"
        },
        {
            "name": "PaymentAccountId",
            "baseName": "PaymentAccountId",
            "type": "number"
        },
        {
            "name": "IsPreOrder",
            "baseName": "IsPreOrder",
            "type": "boolean"
        },
        {
            "name": "IsAsapOrder",
            "baseName": "IsAsapOrder",
            "type": "boolean"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "MenuVersion",
            "baseName": "MenuVersion",
            "type": "number"
        }
    ];
    return OrderDm;
}());
exports.OrderDm = OrderDm;
(function (OrderDm) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = OrderDm.DeliveryTypeEnum || (OrderDm.DeliveryTypeEnum = {}));
    var PickupLocationTypeEnum;
    (function (PickupLocationTypeEnum) {
        PickupLocationTypeEnum[PickupLocationTypeEnum["TakeOut"] = 'TakeOut'] = "TakeOut";
        PickupLocationTypeEnum[PickupLocationTypeEnum["TableService"] = 'TableService'] = "TableService";
        PickupLocationTypeEnum[PickupLocationTypeEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(PickupLocationTypeEnum = OrderDm.PickupLocationTypeEnum || (OrderDm.PickupLocationTypeEnum = {}));
    var TableServiceCatagoryEnum;
    (function (TableServiceCatagoryEnum) {
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Generic"] = 'Generic'] = "Generic";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Villa"] = 'Villa'] = "Villa";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["House"] = 'House'] = "House";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Room"] = 'Room'] = "Room";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Area"] = 'Area'] = "Area";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Table"] = 'Table'] = "Table";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["ParkingBay"] = 'ParkingBay'] = "ParkingBay";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Gate"] = 'Gate'] = "Gate";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["DriveThrough"] = 'DriveThrough'] = "DriveThrough";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Team"] = 'Team'] = "Team";
    })(TableServiceCatagoryEnum = OrderDm.TableServiceCatagoryEnum || (OrderDm.TableServiceCatagoryEnum = {}));
})(OrderDm = exports.OrderDm || (exports.OrderDm = {}));
exports.OrderDm = OrderDm;
var OrderDropOffLocation = (function () {
    function OrderDropOffLocation() {
    }
    OrderDropOffLocation.getAttributeTypeMap = function () {
        return OrderDropOffLocation.attributeTypeMap;
    };
    OrderDropOffLocation.discriminator = undefined;
    OrderDropOffLocation.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "LocationName",
            "baseName": "LocationName",
            "type": "string"
        },
        {
            "name": "LocationAreaName",
            "baseName": "LocationAreaName",
            "type": "string"
        },
        {
            "name": "LocationId",
            "baseName": "LocationId",
            "type": "number"
        },
        {
            "name": "LocationAreaId",
            "baseName": "LocationAreaId",
            "type": "number"
        },
        {
            "name": "ExternalLocationId",
            "baseName": "ExternalLocationId",
            "type": "string"
        }
    ];
    return OrderDropOffLocation;
}());
exports.OrderDropOffLocation = OrderDropOffLocation;
var OrderFulfillmentStatus = (function () {
    function OrderFulfillmentStatus() {
    }
    OrderFulfillmentStatus.getAttributeTypeMap = function () {
        return OrderFulfillmentStatus.attributeTypeMap;
    };
    OrderFulfillmentStatus.discriminator = undefined;
    OrderFulfillmentStatus.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "StatusId",
            "baseName": "StatusId",
            "type": "string"
        },
        {
            "name": "StatusName",
            "baseName": "StatusName",
            "type": "string"
        },
        {
            "name": "Icon",
            "baseName": "Icon",
            "type": "string"
        }
    ];
    return OrderFulfillmentStatus;
}());
exports.OrderFulfillmentStatus = OrderFulfillmentStatus;
var OrderFulfillmentStatusBase = (function () {
    function OrderFulfillmentStatusBase() {
    }
    OrderFulfillmentStatusBase.getAttributeTypeMap = function () {
        return OrderFulfillmentStatusBase.attributeTypeMap;
    };
    OrderFulfillmentStatusBase.discriminator = undefined;
    OrderFulfillmentStatusBase.attributeTypeMap = [
        {
            "name": "StatusId",
            "baseName": "StatusId",
            "type": "string"
        },
        {
            "name": "StatusName",
            "baseName": "StatusName",
            "type": "string"
        },
        {
            "name": "Icon",
            "baseName": "Icon",
            "type": "string"
        }
    ];
    return OrderFulfillmentStatusBase;
}());
exports.OrderFulfillmentStatusBase = OrderFulfillmentStatusBase;
var OrderFulfillmentStatusUpdate = (function () {
    function OrderFulfillmentStatusUpdate() {
    }
    OrderFulfillmentStatusUpdate.getAttributeTypeMap = function () {
        return OrderFulfillmentStatusUpdate.attributeTypeMap;
    };
    OrderFulfillmentStatusUpdate.discriminator = undefined;
    OrderFulfillmentStatusUpdate.attributeTypeMap = [
        {
            "name": "StatusId",
            "baseName": "StatusId",
            "type": "string"
        }
    ];
    return OrderFulfillmentStatusUpdate;
}());
exports.OrderFulfillmentStatusUpdate = OrderFulfillmentStatusUpdate;
var OrderFulfillmentStatusUpdatedEvent = (function () {
    function OrderFulfillmentStatusUpdatedEvent() {
    }
    OrderFulfillmentStatusUpdatedEvent.getAttributeTypeMap = function () {
        return OrderFulfillmentStatusUpdatedEvent.attributeTypeMap;
    };
    OrderFulfillmentStatusUpdatedEvent.discriminator = undefined;
    OrderFulfillmentStatusUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "StatusName",
            "baseName": "StatusName",
            "type": "string"
        },
        {
            "name": "StatusId",
            "baseName": "StatusId",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderFulfillmentStatusUpdatedEvent;
}());
exports.OrderFulfillmentStatusUpdatedEvent = OrderFulfillmentStatusUpdatedEvent;
var OrderFulfillmentStatusWithConfigurationActions = (function () {
    function OrderFulfillmentStatusWithConfigurationActions() {
    }
    OrderFulfillmentStatusWithConfigurationActions.getAttributeTypeMap = function () {
        return OrderFulfillmentStatusWithConfigurationActions.attributeTypeMap;
    };
    OrderFulfillmentStatusWithConfigurationActions.discriminator = undefined;
    OrderFulfillmentStatusWithConfigurationActions.attributeTypeMap = [
        {
            "name": "DefaultNextStatus",
            "baseName": "DefaultNextStatus",
            "type": "string"
        },
        {
            "name": "NextStatuses",
            "baseName": "NextStatuses",
            "type": "Array<FulfillentStatusActionItem>"
        },
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "StatusId",
            "baseName": "StatusId",
            "type": "string"
        },
        {
            "name": "StatusName",
            "baseName": "StatusName",
            "type": "string"
        },
        {
            "name": "Icon",
            "baseName": "Icon",
            "type": "string"
        }
    ];
    return OrderFulfillmentStatusWithConfigurationActions;
}());
exports.OrderFulfillmentStatusWithConfigurationActions = OrderFulfillmentStatusWithConfigurationActions;
var OrderIngestSubmitOrderRequest = (function () {
    function OrderIngestSubmitOrderRequest() {
    }
    OrderIngestSubmitOrderRequest.getAttributeTypeMap = function () {
        return OrderIngestSubmitOrderRequest.attributeTypeMap;
    };
    OrderIngestSubmitOrderRequest.discriminator = undefined;
    OrderIngestSubmitOrderRequest.attributeTypeMap = [
        {
            "name": "AppType",
            "baseName": "AppType",
            "type": "OrderIngestSubmitOrderRequest.AppTypeEnum"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "CurrencyCode",
            "baseName": "CurrencyCode",
            "type": "OrderIngestSubmitOrderRequest.CurrencyCodeEnum"
        },
        {
            "name": "Cart",
            "baseName": "Cart",
            "type": "Cart"
        },
        {
            "name": "FulfillmentInfo",
            "baseName": "FulfillmentInfo",
            "type": "FulfillmentInfo"
        },
        {
            "name": "ChannelOrderId",
            "baseName": "ChannelOrderId",
            "type": "string"
        },
        {
            "name": "ChannelPublicOrderId",
            "baseName": "ChannelPublicOrderId",
            "type": "string"
        },
        {
            "name": "OrderDateUtc",
            "baseName": "OrderDateUtc",
            "type": "Date"
        },
        {
            "name": "PaymentInfo",
            "baseName": "PaymentInfo",
            "type": "PaymentInfo"
        },
        {
            "name": "Contact",
            "baseName": "Contact",
            "type": "Contact"
        },
        {
            "name": "TipAmount",
            "baseName": "TipAmount",
            "type": "number"
        }
    ];
    return OrderIngestSubmitOrderRequest;
}());
exports.OrderIngestSubmitOrderRequest = OrderIngestSubmitOrderRequest;
(function (OrderIngestSubmitOrderRequest) {
    var AppTypeEnum;
    (function (AppTypeEnum) {
        AppTypeEnum[AppTypeEnum["Unknown"] = 'Unknown'] = "Unknown";
        AppTypeEnum[AppTypeEnum["Ios"] = 'Ios'] = "Ios";
        AppTypeEnum[AppTypeEnum["Android"] = 'Android'] = "Android";
        AppTypeEnum[AppTypeEnum["Web"] = 'Web'] = "Web";
        AppTypeEnum[AppTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        AppTypeEnum[AppTypeEnum["Pos"] = 'Pos'] = "Pos";
        AppTypeEnum[AppTypeEnum["TelephoneCall"] = 'TelephoneCall'] = "TelephoneCall";
        AppTypeEnum[AppTypeEnum["Sms"] = 'Sms'] = "Sms";
        AppTypeEnum[AppTypeEnum["PwaAndroid"] = 'PwaAndroid'] = "PwaAndroid";
        AppTypeEnum[AppTypeEnum["PwaIos"] = 'PwaIos'] = "PwaIos";
        AppTypeEnum[AppTypeEnum["Google"] = 'Google'] = "Google";
    })(AppTypeEnum = OrderIngestSubmitOrderRequest.AppTypeEnum || (OrderIngestSubmitOrderRequest.AppTypeEnum = {}));
    var CurrencyCodeEnum;
    (function (CurrencyCodeEnum) {
        CurrencyCodeEnum[CurrencyCodeEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyCodeEnum[CurrencyCodeEnum["USD"] = 'USD'] = "USD";
        CurrencyCodeEnum[CurrencyCodeEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyCodeEnum[CurrencyCodeEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyCodeEnum[CurrencyCodeEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyCodeEnum[CurrencyCodeEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyCodeEnum[CurrencyCodeEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyCodeEnum[CurrencyCodeEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyCodeEnum[CurrencyCodeEnum["AED"] = 'AED'] = "AED";
        CurrencyCodeEnum[CurrencyCodeEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyCodeEnum[CurrencyCodeEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyCodeEnum[CurrencyCodeEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyCodeEnum[CurrencyCodeEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyCodeEnum[CurrencyCodeEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyCodeEnum[CurrencyCodeEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyCodeEnum[CurrencyCodeEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyCodeEnum[CurrencyCodeEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyCodeEnum[CurrencyCodeEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyCodeEnum[CurrencyCodeEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyCodeEnum[CurrencyCodeEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyCodeEnum[CurrencyCodeEnum["TND"] = 'TND'] = "TND";
        CurrencyCodeEnum[CurrencyCodeEnum["YER"] = 'YER'] = "YER";
        CurrencyCodeEnum[CurrencyCodeEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyCodeEnum[CurrencyCodeEnum["INR"] = 'INR'] = "INR";
        CurrencyCodeEnum[CurrencyCodeEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyCodeEnum[CurrencyCodeEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyCodeEnum[CurrencyCodeEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyCodeEnum[CurrencyCodeEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyCodeEnum[CurrencyCodeEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyCodeEnum[CurrencyCodeEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyCodeEnum[CurrencyCodeEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyCodeEnum[CurrencyCodeEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyCodeEnum[CurrencyCodeEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyCodeEnum[CurrencyCodeEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyCodeEnum[CurrencyCodeEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyCodeEnum[CurrencyCodeEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyCodeEnum[CurrencyCodeEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyCodeEnum[CurrencyCodeEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyCodeEnum[CurrencyCodeEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyCodeEnum[CurrencyCodeEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyCodeEnum[CurrencyCodeEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyCodeEnum[CurrencyCodeEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyCodeEnum[CurrencyCodeEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyCodeEnum[CurrencyCodeEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyCodeEnum[CurrencyCodeEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyCodeEnum[CurrencyCodeEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyCodeEnum[CurrencyCodeEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyCodeEnum[CurrencyCodeEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyCodeEnum[CurrencyCodeEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyCodeEnum[CurrencyCodeEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyCodeEnum[CurrencyCodeEnum["COP"] = 'COP'] = "COP";
        CurrencyCodeEnum[CurrencyCodeEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyCodeEnum[CurrencyCodeEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyCodeEnum[CurrencyCodeEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyCodeEnum[CurrencyCodeEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyCodeEnum[CurrencyCodeEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyCodeEnum[CurrencyCodeEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyCodeEnum[CurrencyCodeEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyCodeEnum[CurrencyCodeEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyCodeEnum[CurrencyCodeEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyCodeEnum[CurrencyCodeEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyCodeEnum[CurrencyCodeEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyCodeEnum[CurrencyCodeEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyCodeEnum[CurrencyCodeEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyCodeEnum[CurrencyCodeEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyCodeEnum[CurrencyCodeEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyCodeEnum[CurrencyCodeEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyCodeEnum[CurrencyCodeEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyCodeEnum[CurrencyCodeEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyCodeEnum[CurrencyCodeEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyCodeEnum[CurrencyCodeEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyCodeEnum[CurrencyCodeEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyCodeEnum[CurrencyCodeEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyCodeEnum[CurrencyCodeEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyCodeEnum[CurrencyCodeEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyCodeEnum[CurrencyCodeEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyCodeEnum[CurrencyCodeEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyCodeEnum[CurrencyCodeEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyCodeEnum[CurrencyCodeEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyCodeEnum[CurrencyCodeEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyCodeEnum[CurrencyCodeEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyCodeEnum[CurrencyCodeEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyCodeEnum[CurrencyCodeEnum["BND"] = 'BND'] = "BND";
        CurrencyCodeEnum[CurrencyCodeEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyCodeEnum[CurrencyCodeEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyCodeEnum[CurrencyCodeEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyCodeEnum[CurrencyCodeEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyCodeEnum[CurrencyCodeEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyCodeEnum[CurrencyCodeEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyCodeEnum[CurrencyCodeEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyCodeEnum[CurrencyCodeEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyCodeEnum[CurrencyCodeEnum["RON"] = 'RON'] = "RON";
        CurrencyCodeEnum[CurrencyCodeEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyCodeEnum[CurrencyCodeEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyCodeEnum[CurrencyCodeEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyCodeEnum[CurrencyCodeEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyCodeEnum[CurrencyCodeEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyCodeEnum[CurrencyCodeEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyCodeEnum[CurrencyCodeEnum["KES"] = 'KES'] = "KES";
        CurrencyCodeEnum[CurrencyCodeEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyCodeEnum[CurrencyCodeEnum["THB"] = 'THB'] = "THB";
        CurrencyCodeEnum[CurrencyCodeEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyCodeEnum[CurrencyCodeEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyCodeEnum[CurrencyCodeEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyCodeEnum[CurrencyCodeEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyCodeEnum[CurrencyCodeEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyCodeEnum[CurrencyCodeEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyCodeEnum[CurrencyCodeEnum["VND"] = 'VND'] = "VND";
        CurrencyCodeEnum[CurrencyCodeEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyCodeEnum[CurrencyCodeEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyCodeEnum[CurrencyCodeEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyCodeEnum = OrderIngestSubmitOrderRequest.CurrencyCodeEnum || (OrderIngestSubmitOrderRequest.CurrencyCodeEnum = {}));
})(OrderIngestSubmitOrderRequest = exports.OrderIngestSubmitOrderRequest || (exports.OrderIngestSubmitOrderRequest = {}));
exports.OrderIngestSubmitOrderRequest = OrderIngestSubmitOrderRequest;
var OrderIngestSubmitOrderResponse = (function () {
    function OrderIngestSubmitOrderResponse() {
    }
    OrderIngestSubmitOrderResponse.getAttributeTypeMap = function () {
        return OrderIngestSubmitOrderResponse.attributeTypeMap;
    };
    OrderIngestSubmitOrderResponse.discriminator = undefined;
    OrderIngestSubmitOrderResponse.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "ReceiptUrl",
            "baseName": "ReceiptUrl",
            "type": "string"
        },
        {
            "name": "CurrencyCode",
            "baseName": "CurrencyCode",
            "type": "OrderIngestSubmitOrderResponse.CurrencyCodeEnum"
        },
        {
            "name": "TotalPrice",
            "baseName": "TotalPrice",
            "type": "Price"
        },
        {
            "name": "DeliveryFee",
            "baseName": "DeliveryFee",
            "type": "Price"
        },
        {
            "name": "EstimatedDeliveryTime",
            "baseName": "EstimatedDeliveryTime",
            "type": "Date"
        },
        {
            "name": "ChannelOrderId",
            "baseName": "ChannelOrderId",
            "type": "string"
        }
    ];
    return OrderIngestSubmitOrderResponse;
}());
exports.OrderIngestSubmitOrderResponse = OrderIngestSubmitOrderResponse;
(function (OrderIngestSubmitOrderResponse) {
    var CurrencyCodeEnum;
    (function (CurrencyCodeEnum) {
        CurrencyCodeEnum[CurrencyCodeEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyCodeEnum[CurrencyCodeEnum["USD"] = 'USD'] = "USD";
        CurrencyCodeEnum[CurrencyCodeEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyCodeEnum[CurrencyCodeEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyCodeEnum[CurrencyCodeEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyCodeEnum[CurrencyCodeEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyCodeEnum[CurrencyCodeEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyCodeEnum[CurrencyCodeEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyCodeEnum[CurrencyCodeEnum["AED"] = 'AED'] = "AED";
        CurrencyCodeEnum[CurrencyCodeEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyCodeEnum[CurrencyCodeEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyCodeEnum[CurrencyCodeEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyCodeEnum[CurrencyCodeEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyCodeEnum[CurrencyCodeEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyCodeEnum[CurrencyCodeEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyCodeEnum[CurrencyCodeEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyCodeEnum[CurrencyCodeEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyCodeEnum[CurrencyCodeEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyCodeEnum[CurrencyCodeEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyCodeEnum[CurrencyCodeEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyCodeEnum[CurrencyCodeEnum["TND"] = 'TND'] = "TND";
        CurrencyCodeEnum[CurrencyCodeEnum["YER"] = 'YER'] = "YER";
        CurrencyCodeEnum[CurrencyCodeEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyCodeEnum[CurrencyCodeEnum["INR"] = 'INR'] = "INR";
        CurrencyCodeEnum[CurrencyCodeEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyCodeEnum[CurrencyCodeEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyCodeEnum[CurrencyCodeEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyCodeEnum[CurrencyCodeEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyCodeEnum[CurrencyCodeEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyCodeEnum[CurrencyCodeEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyCodeEnum[CurrencyCodeEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyCodeEnum[CurrencyCodeEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyCodeEnum[CurrencyCodeEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyCodeEnum[CurrencyCodeEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyCodeEnum[CurrencyCodeEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyCodeEnum[CurrencyCodeEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyCodeEnum[CurrencyCodeEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyCodeEnum[CurrencyCodeEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyCodeEnum[CurrencyCodeEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyCodeEnum[CurrencyCodeEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyCodeEnum[CurrencyCodeEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyCodeEnum[CurrencyCodeEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyCodeEnum[CurrencyCodeEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyCodeEnum[CurrencyCodeEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyCodeEnum[CurrencyCodeEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyCodeEnum[CurrencyCodeEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyCodeEnum[CurrencyCodeEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyCodeEnum[CurrencyCodeEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyCodeEnum[CurrencyCodeEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyCodeEnum[CurrencyCodeEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyCodeEnum[CurrencyCodeEnum["COP"] = 'COP'] = "COP";
        CurrencyCodeEnum[CurrencyCodeEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyCodeEnum[CurrencyCodeEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyCodeEnum[CurrencyCodeEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyCodeEnum[CurrencyCodeEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyCodeEnum[CurrencyCodeEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyCodeEnum[CurrencyCodeEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyCodeEnum[CurrencyCodeEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyCodeEnum[CurrencyCodeEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyCodeEnum[CurrencyCodeEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyCodeEnum[CurrencyCodeEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyCodeEnum[CurrencyCodeEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyCodeEnum[CurrencyCodeEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyCodeEnum[CurrencyCodeEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyCodeEnum[CurrencyCodeEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyCodeEnum[CurrencyCodeEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyCodeEnum[CurrencyCodeEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyCodeEnum[CurrencyCodeEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyCodeEnum[CurrencyCodeEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyCodeEnum[CurrencyCodeEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyCodeEnum[CurrencyCodeEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyCodeEnum[CurrencyCodeEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyCodeEnum[CurrencyCodeEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyCodeEnum[CurrencyCodeEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyCodeEnum[CurrencyCodeEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyCodeEnum[CurrencyCodeEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyCodeEnum[CurrencyCodeEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyCodeEnum[CurrencyCodeEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyCodeEnum[CurrencyCodeEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyCodeEnum[CurrencyCodeEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyCodeEnum[CurrencyCodeEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyCodeEnum[CurrencyCodeEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyCodeEnum[CurrencyCodeEnum["BND"] = 'BND'] = "BND";
        CurrencyCodeEnum[CurrencyCodeEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyCodeEnum[CurrencyCodeEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyCodeEnum[CurrencyCodeEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyCodeEnum[CurrencyCodeEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyCodeEnum[CurrencyCodeEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyCodeEnum[CurrencyCodeEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyCodeEnum[CurrencyCodeEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyCodeEnum[CurrencyCodeEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyCodeEnum[CurrencyCodeEnum["RON"] = 'RON'] = "RON";
        CurrencyCodeEnum[CurrencyCodeEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyCodeEnum[CurrencyCodeEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyCodeEnum[CurrencyCodeEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyCodeEnum[CurrencyCodeEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyCodeEnum[CurrencyCodeEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyCodeEnum[CurrencyCodeEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyCodeEnum[CurrencyCodeEnum["KES"] = 'KES'] = "KES";
        CurrencyCodeEnum[CurrencyCodeEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyCodeEnum[CurrencyCodeEnum["THB"] = 'THB'] = "THB";
        CurrencyCodeEnum[CurrencyCodeEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyCodeEnum[CurrencyCodeEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyCodeEnum[CurrencyCodeEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyCodeEnum[CurrencyCodeEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyCodeEnum[CurrencyCodeEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyCodeEnum[CurrencyCodeEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyCodeEnum[CurrencyCodeEnum["VND"] = 'VND'] = "VND";
        CurrencyCodeEnum[CurrencyCodeEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyCodeEnum[CurrencyCodeEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyCodeEnum[CurrencyCodeEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyCodeEnum = OrderIngestSubmitOrderResponse.CurrencyCodeEnum || (OrderIngestSubmitOrderResponse.CurrencyCodeEnum = {}));
})(OrderIngestSubmitOrderResponse = exports.OrderIngestSubmitOrderResponse || (exports.OrderIngestSubmitOrderResponse = {}));
exports.OrderIngestSubmitOrderResponse = OrderIngestSubmitOrderResponse;
var OrderItem = (function () {
    function OrderItem() {
    }
    OrderItem.getAttributeTypeMap = function () {
        return OrderItem.attributeTypeMap;
    };
    OrderItem.discriminator = undefined;
    OrderItem.attributeTypeMap = [
        {
            "name": "OrderItemOptions",
            "baseName": "OrderItemOptions",
            "type": "Array<OrderItemOption>"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "{ [key: string]: string; }"
        },
        {
            "name": "MenuItemPublicId",
            "baseName": "MenuItemPublicId",
            "type": "string"
        },
        {
            "name": "MenuSectionName",
            "baseName": "MenuSectionName",
            "type": "string"
        },
        {
            "name": "MenuSectionDisplayOrder",
            "baseName": "MenuSectionDisplayOrder",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "PriceIncludingOptionSetItems",
            "baseName": "PriceIncludingOptionSetItems",
            "type": "number"
        },
        {
            "name": "MenuItemId",
            "baseName": "MenuItemId",
            "type": "number"
        },
        {
            "name": "MenuItemDisplayOrder",
            "baseName": "MenuItemDisplayOrder",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        }
    ];
    return OrderItem;
}());
exports.OrderItem = OrderItem;
var OrderItemDm = (function () {
    function OrderItemDm() {
    }
    OrderItemDm.getAttributeTypeMap = function () {
        return OrderItemDm.attributeTypeMap;
    };
    OrderItemDm.discriminator = undefined;
    OrderItemDm.attributeTypeMap = [
        {
            "name": "MenuItemId",
            "baseName": "MenuItemId",
            "type": "number"
        },
        {
            "name": "IsAvailable",
            "baseName": "IsAvailable",
            "type": "boolean"
        },
        {
            "name": "MenuItemOptionSetItemIds",
            "baseName": "MenuItemOptionSetItemIds",
            "type": "Array<number>"
        }
    ];
    return OrderItemDm;
}());
exports.OrderItemDm = OrderItemDm;
var OrderItemOption = (function () {
    function OrderItemOption() {
    }
    OrderItemOption.getAttributeTypeMap = function () {
        return OrderItemOption.attributeTypeMap;
    };
    OrderItemOption.discriminator = undefined;
    OrderItemOption.attributeTypeMap = [
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "{ [key: string]: string; }"
        },
        {
            "name": "MenuItemOptionPublicId",
            "baseName": "MenuItemOptionPublicId",
            "type": "string"
        },
        {
            "name": "MenuItemOptionId",
            "baseName": "MenuItemOptionId",
            "type": "number"
        },
        {
            "name": "IsMasterOptionSetItem",
            "baseName": "IsMasterOptionSetItem",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "MenuItemOptionDisplayOrder",
            "baseName": "MenuItemOptionDisplayOrder",
            "type": "number"
        },
        {
            "name": "MenuItemOptionSetDisplayOrder",
            "baseName": "MenuItemOptionSetDisplayOrder",
            "type": "number"
        }
    ];
    return OrderItemOption;
}());
exports.OrderItemOption = OrderItemOption;
var OrderList = (function () {
    function OrderList() {
    }
    OrderList.getAttributeTypeMap = function () {
        return OrderList.attributeTypeMap;
    };
    OrderList.discriminator = undefined;
    OrderList.attributeTypeMap = [
        {
            "name": "Orders",
            "baseName": "Orders",
            "type": "Array<OrderReference>"
        }
    ];
    return OrderList;
}());
exports.OrderList = OrderList;
var OrderPaymentInformation = (function () {
    function OrderPaymentInformation() {
    }
    OrderPaymentInformation.getAttributeTypeMap = function () {
        return OrderPaymentInformation.attributeTypeMap;
    };
    OrderPaymentInformation.discriminator = undefined;
    OrderPaymentInformation.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "PaymentRefundable",
            "baseName": "PaymentRefundable",
            "type": "boolean"
        }
    ];
    return OrderPaymentInformation;
}());
exports.OrderPaymentInformation = OrderPaymentInformation;
var OrderRatingUpdatedEvent = (function () {
    function OrderRatingUpdatedEvent() {
    }
    OrderRatingUpdatedEvent.getAttributeTypeMap = function () {
        return OrderRatingUpdatedEvent.attributeTypeMap;
    };
    OrderRatingUpdatedEvent.discriminator = undefined;
    OrderRatingUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Rating",
            "baseName": "Rating",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderRatingUpdatedEvent;
}());
exports.OrderRatingUpdatedEvent = OrderRatingUpdatedEvent;
var OrderReference = (function () {
    function OrderReference() {
    }
    OrderReference.getAttributeTypeMap = function () {
        return OrderReference.attributeTypeMap;
    };
    OrderReference.discriminator = undefined;
    OrderReference.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        }
    ];
    return OrderReference;
}());
exports.OrderReference = OrderReference;
var OrderRefundedEvent = (function () {
    function OrderRefundedEvent() {
    }
    OrderRefundedEvent.getAttributeTypeMap = function () {
        return OrderRefundedEvent.attributeTypeMap;
    };
    OrderRefundedEvent.discriminator = undefined;
    OrderRefundedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "RefundedAmount",
            "baseName": "RefundedAmount",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderRefundedEvent;
}());
exports.OrderRefundedEvent = OrderRefundedEvent;
var OrderRejectedEvent = (function () {
    function OrderRejectedEvent() {
    }
    OrderRejectedEvent.getAttributeTypeMap = function () {
        return OrderRejectedEvent.attributeTypeMap;
    };
    OrderRejectedEvent.discriminator = undefined;
    OrderRejectedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "OrderRejectedTime",
            "baseName": "OrderRejectedTime",
            "type": "Date"
        },
        {
            "name": "Reason",
            "baseName": "Reason",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderRejectedEvent;
}());
exports.OrderRejectedEvent = OrderRejectedEvent;
var OrderSummary = (function () {
    function OrderSummary() {
    }
    OrderSummary.getAttributeTypeMap = function () {
        return OrderSummary.attributeTypeMap;
    };
    OrderSummary.discriminator = undefined;
    OrderSummary.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "OrderSummary.DeliveryTypeEnum"
        },
        {
            "name": "PickupLocationType",
            "baseName": "PickupLocationType",
            "type": "OrderSummary.PickupLocationTypeEnum"
        },
        {
            "name": "TableServiceCatagory",
            "baseName": "TableServiceCatagory",
            "type": "OrderSummary.TableServiceCatagoryEnum"
        },
        {
            "name": "OrderState",
            "baseName": "OrderState",
            "type": "OrderSummary.OrderStateEnum"
        },
        {
            "name": "RequestedForTime",
            "baseName": "RequestedForTime",
            "type": "Date"
        },
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        },
        {
            "name": "StoreIanaTimeZone",
            "baseName": "StoreIanaTimeZone",
            "type": "string"
        },
        {
            "name": "CustomerName",
            "baseName": "CustomerName",
            "type": "string"
        },
        {
            "name": "CustomerPhoneNumber",
            "baseName": "CustomerPhoneNumber",
            "type": "string"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "RefundedAmount",
            "baseName": "RefundedAmount",
            "type": "number"
        },
        {
            "name": "PaymentAccountType",
            "baseName": "PaymentAccountType",
            "type": "OrderSummary.PaymentAccountTypeEnum"
        },
        {
            "name": "PaymentStatus",
            "baseName": "PaymentStatus",
            "type": "OrderSummary.PaymentStatusEnum"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "OrderSummary.CurrencyEnum"
        },
        {
            "name": "AppType",
            "baseName": "AppType",
            "type": "OrderSummary.AppTypeEnum"
        },
        {
            "name": "LocalOrderId",
            "baseName": "LocalOrderId",
            "type": "string"
        },
        {
            "name": "DropOffLocationId",
            "baseName": "DropOffLocationId",
            "type": "number"
        },
        {
            "name": "DropOffLocation",
            "baseName": "DropOffLocation",
            "type": "string"
        },
        {
            "name": "AcceptedFor",
            "baseName": "AcceptedFor",
            "type": "Date"
        },
        {
            "name": "Channel",
            "baseName": "Channel",
            "type": "Channel"
        },
        {
            "name": "InFraudZone",
            "baseName": "InFraudZone",
            "type": "boolean"
        },
        {
            "name": "UnusualHighValueOrder",
            "baseName": "UnusualHighValueOrder",
            "type": "boolean"
        },
        {
            "name": "ChannelOrderId",
            "baseName": "ChannelOrderId",
            "type": "string"
        },
        {
            "name": "ChannelOrderDisplayId",
            "baseName": "ChannelOrderDisplayId",
            "type": "string"
        },
        {
            "name": "OrderDropOffLocation",
            "baseName": "OrderDropOffLocation",
            "type": "OrderDropOffLocation"
        },
        {
            "name": "OrderBatchInfo",
            "baseName": "OrderBatchInfo",
            "type": "OrderBatchSummary"
        },
        {
            "name": "DeliveryLocation",
            "baseName": "DeliveryLocation",
            "type": "DeliveryLocation"
        }
    ];
    return OrderSummary;
}());
exports.OrderSummary = OrderSummary;
(function (OrderSummary) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = OrderSummary.DeliveryTypeEnum || (OrderSummary.DeliveryTypeEnum = {}));
    var PickupLocationTypeEnum;
    (function (PickupLocationTypeEnum) {
        PickupLocationTypeEnum[PickupLocationTypeEnum["TakeOut"] = 'TakeOut'] = "TakeOut";
        PickupLocationTypeEnum[PickupLocationTypeEnum["TableService"] = 'TableService'] = "TableService";
        PickupLocationTypeEnum[PickupLocationTypeEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(PickupLocationTypeEnum = OrderSummary.PickupLocationTypeEnum || (OrderSummary.PickupLocationTypeEnum = {}));
    var TableServiceCatagoryEnum;
    (function (TableServiceCatagoryEnum) {
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Generic"] = 'Generic'] = "Generic";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Villa"] = 'Villa'] = "Villa";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["House"] = 'House'] = "House";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Room"] = 'Room'] = "Room";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Area"] = 'Area'] = "Area";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Table"] = 'Table'] = "Table";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["ParkingBay"] = 'ParkingBay'] = "ParkingBay";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Gate"] = 'Gate'] = "Gate";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["DriveThrough"] = 'DriveThrough'] = "DriveThrough";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Team"] = 'Team'] = "Team";
    })(TableServiceCatagoryEnum = OrderSummary.TableServiceCatagoryEnum || (OrderSummary.TableServiceCatagoryEnum = {}));
    var OrderStateEnum;
    (function (OrderStateEnum) {
        OrderStateEnum[OrderStateEnum["Created"] = 'Created'] = "Created";
        OrderStateEnum[OrderStateEnum["PlacedCanBeCancelled"] = 'PlacedCanBeCancelled'] = "PlacedCanBeCancelled";
        OrderStateEnum[OrderStateEnum["ReadyToProcess"] = 'ReadyToProcess'] = "ReadyToProcess";
        OrderStateEnum[OrderStateEnum["AcceptedByRestaurant"] = 'AcceptedByRestaurant'] = "AcceptedByRestaurant";
        OrderStateEnum[OrderStateEnum["Dispatched"] = 'Dispatched'] = "Dispatched";
        OrderStateEnum[OrderStateEnum["Delivered"] = 'Delivered'] = "Delivered";
        OrderStateEnum[OrderStateEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
        OrderStateEnum[OrderStateEnum["ManualReview"] = 'ManualReview'] = "ManualReview";
        OrderStateEnum[OrderStateEnum["RejectedByStore"] = 'RejectedByStore'] = "RejectedByStore";
        OrderStateEnum[OrderStateEnum["RejectedByFlipdish"] = 'RejectedByFlipdish'] = "RejectedByFlipdish";
        OrderStateEnum[OrderStateEnum["RejectedAutomatically"] = 'RejectedAutomatically'] = "RejectedAutomatically";
        OrderStateEnum[OrderStateEnum["RejectedAfterBeingAccepted"] = 'RejectedAfterBeingAccepted'] = "RejectedAfterBeingAccepted";
        OrderStateEnum[OrderStateEnum["AcceptedAndRefunded"] = 'AcceptedAndRefunded'] = "AcceptedAndRefunded";
    })(OrderStateEnum = OrderSummary.OrderStateEnum || (OrderSummary.OrderStateEnum = {}));
    var PaymentAccountTypeEnum;
    (function (PaymentAccountTypeEnum) {
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Card"] = 'Card'] = "Card";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Cash"] = 'Cash'] = "Cash";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Ideal"] = 'Ideal'] = "Ideal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Bancontact"] = 'Bancontact'] = "Bancontact";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Giropay"] = 'Giropay'] = "Giropay";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Eps"] = 'Eps'] = "Eps";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Emv"] = 'Emv'] = "Emv";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayPal"] = 'PayPal'] = "PayPal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayGreen"] = 'PayGreen'] = "PayGreen";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["GoogleWalletToken"] = 'GoogleWalletToken'] = "GoogleWalletToken";
    })(PaymentAccountTypeEnum = OrderSummary.PaymentAccountTypeEnum || (OrderSummary.PaymentAccountTypeEnum = {}));
    var PaymentStatusEnum;
    (function (PaymentStatusEnum) {
        PaymentStatusEnum[PaymentStatusEnum["Paid"] = 'Paid'] = "Paid";
        PaymentStatusEnum[PaymentStatusEnum["Unpaid"] = 'Unpaid'] = "Unpaid";
        PaymentStatusEnum[PaymentStatusEnum["Refunded"] = 'Refunded'] = "Refunded";
        PaymentStatusEnum[PaymentStatusEnum["PartiallyRefunded"] = 'PartiallyRefunded'] = "PartiallyRefunded";
        PaymentStatusEnum[PaymentStatusEnum["Disputed"] = 'Disputed'] = "Disputed";
    })(PaymentStatusEnum = OrderSummary.PaymentStatusEnum || (OrderSummary.PaymentStatusEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = OrderSummary.CurrencyEnum || (OrderSummary.CurrencyEnum = {}));
    var AppTypeEnum;
    (function (AppTypeEnum) {
        AppTypeEnum[AppTypeEnum["Unknown"] = 'Unknown'] = "Unknown";
        AppTypeEnum[AppTypeEnum["Ios"] = 'Ios'] = "Ios";
        AppTypeEnum[AppTypeEnum["Android"] = 'Android'] = "Android";
        AppTypeEnum[AppTypeEnum["Web"] = 'Web'] = "Web";
        AppTypeEnum[AppTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        AppTypeEnum[AppTypeEnum["Pos"] = 'Pos'] = "Pos";
        AppTypeEnum[AppTypeEnum["TelephoneCall"] = 'TelephoneCall'] = "TelephoneCall";
        AppTypeEnum[AppTypeEnum["Sms"] = 'Sms'] = "Sms";
        AppTypeEnum[AppTypeEnum["PwaAndroid"] = 'PwaAndroid'] = "PwaAndroid";
        AppTypeEnum[AppTypeEnum["PwaIos"] = 'PwaIos'] = "PwaIos";
        AppTypeEnum[AppTypeEnum["Google"] = 'Google'] = "Google";
    })(AppTypeEnum = OrderSummary.AppTypeEnum || (OrderSummary.AppTypeEnum = {}));
})(OrderSummary = exports.OrderSummary || (exports.OrderSummary = {}));
exports.OrderSummary = OrderSummary;
var OrderTipUpdatedEvent = (function () {
    function OrderTipUpdatedEvent() {
    }
    OrderTipUpdatedEvent.getAttributeTypeMap = function () {
        return OrderTipUpdatedEvent.attributeTypeMap;
    };
    OrderTipUpdatedEvent.discriminator = undefined;
    OrderTipUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "TipAmount",
            "baseName": "TipAmount",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Order",
            "baseName": "Order",
            "type": "Order"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return OrderTipUpdatedEvent;
}());
exports.OrderTipUpdatedEvent = OrderTipUpdatedEvent;
var OrderVoucherSummary = (function () {
    function OrderVoucherSummary() {
    }
    OrderVoucherSummary.getAttributeTypeMap = function () {
        return OrderVoucherSummary.attributeTypeMap;
    };
    OrderVoucherSummary.discriminator = undefined;
    OrderVoucherSummary.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "OrderVoucherSummary.TypeEnum"
        },
        {
            "name": "SubType",
            "baseName": "SubType",
            "type": "OrderVoucherSummary.SubTypeEnum"
        }
    ];
    return OrderVoucherSummary;
}());
exports.OrderVoucherSummary = OrderVoucherSummary;
(function (OrderVoucherSummary) {
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        TypeEnum[TypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        TypeEnum[TypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        TypeEnum[TypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
    })(TypeEnum = OrderVoucherSummary.TypeEnum || (OrderVoucherSummary.TypeEnum = {}));
    var SubTypeEnum;
    (function (SubTypeEnum) {
        SubTypeEnum[SubTypeEnum["None"] = 'None'] = "None";
        SubTypeEnum[SubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        SubTypeEnum[SubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        SubTypeEnum[SubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        SubTypeEnum[SubTypeEnum["Retention"] = 'Retention'] = "Retention";
        SubTypeEnum[SubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        SubTypeEnum[SubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(SubTypeEnum = OrderVoucherSummary.SubTypeEnum || (OrderVoucherSummary.SubTypeEnum = {}));
})(OrderVoucherSummary = exports.OrderVoucherSummary || (exports.OrderVoucherSummary = {}));
exports.OrderVoucherSummary = OrderVoucherSummary;
var OtherChargesDetails = (function () {
    function OtherChargesDetails() {
    }
    OtherChargesDetails.getAttributeTypeMap = function () {
        return OtherChargesDetails.attributeTypeMap;
    };
    OtherChargesDetails.discriminator = undefined;
    OtherChargesDetails.attributeTypeMap = [
        {
            "name": "TotalOtherCharges",
            "baseName": "TotalOtherCharges",
            "type": "number"
        },
        {
            "name": "ChargesCount",
            "baseName": "ChargesCount",
            "type": "number"
        }
    ];
    return OtherChargesDetails;
}());
exports.OtherChargesDetails = OtherChargesDetails;
var OwnerEntityConfiguration = (function () {
    function OwnerEntityConfiguration() {
    }
    OwnerEntityConfiguration.getAttributeTypeMap = function () {
        return OwnerEntityConfiguration.attributeTypeMap;
    };
    OwnerEntityConfiguration.discriminator = undefined;
    OwnerEntityConfiguration.attributeTypeMap = [
        {
            "name": "OwnerEntity",
            "baseName": "OwnerEntity",
            "type": "OwnerEntityConfiguration.OwnerEntityEnum"
        },
        {
            "name": "AllowedBehaviors",
            "baseName": "AllowedBehaviors",
            "type": "Array<OwnerEntityConfiguration.AllowedBehaviorsEnum>"
        }
    ];
    return OwnerEntityConfiguration;
}());
exports.OwnerEntityConfiguration = OwnerEntityConfiguration;
(function (OwnerEntityConfiguration) {
    var OwnerEntityEnum;
    (function (OwnerEntityEnum) {
        OwnerEntityEnum[OwnerEntityEnum["CatalogItem"] = 'CatalogItem'] = "CatalogItem";
        OwnerEntityEnum[OwnerEntityEnum["CatalogGroup"] = 'CatalogGroup'] = "CatalogGroup";
        OwnerEntityEnum[OwnerEntityEnum["Menu"] = 'Menu'] = "Menu";
    })(OwnerEntityEnum = OwnerEntityConfiguration.OwnerEntityEnum || (OwnerEntityConfiguration.OwnerEntityEnum = {}));
    var AllowedBehaviorsEnum;
    (function (AllowedBehaviorsEnum) {
        AllowedBehaviorsEnum[AllowedBehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        AllowedBehaviorsEnum[AllowedBehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(AllowedBehaviorsEnum = OwnerEntityConfiguration.AllowedBehaviorsEnum || (OwnerEntityConfiguration.AllowedBehaviorsEnum = {}));
})(OwnerEntityConfiguration = exports.OwnerEntityConfiguration || (exports.OwnerEntityConfiguration = {}));
exports.OwnerEntityConfiguration = OwnerEntityConfiguration;
var OwnerEntityConfigurations = (function () {
    function OwnerEntityConfigurations() {
    }
    OwnerEntityConfigurations.getAttributeTypeMap = function () {
        return OwnerEntityConfigurations.attributeTypeMap;
    };
    OwnerEntityConfigurations.discriminator = undefined;
    OwnerEntityConfigurations.attributeTypeMap = [
        {
            "name": "Configurations",
            "baseName": "Configurations",
            "type": "Array<OwnerEntityConfiguration>"
        }
    ];
    return OwnerEntityConfigurations;
}());
exports.OwnerEntityConfigurations = OwnerEntityConfigurations;
var PasswordResetModel = (function () {
    function PasswordResetModel() {
    }
    PasswordResetModel.getAttributeTypeMap = function () {
        return PasswordResetModel.attributeTypeMap;
    };
    PasswordResetModel.discriminator = undefined;
    PasswordResetModel.attributeTypeMap = [
        {
            "name": "TokenId",
            "baseName": "TokenId",
            "type": "string"
        },
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "Password",
            "baseName": "Password",
            "type": "string"
        },
        {
            "name": "PasswordConfirmation",
            "baseName": "PasswordConfirmation",
            "type": "string"
        },
        {
            "name": "Token",
            "baseName": "Token",
            "type": "string"
        }
    ];
    return PasswordResetModel;
}());
exports.PasswordResetModel = PasswordResetModel;
var PaymentInfo = (function () {
    function PaymentInfo() {
    }
    PaymentInfo.getAttributeTypeMap = function () {
        return PaymentInfo.attributeTypeMap;
    };
    PaymentInfo.discriminator = undefined;
    PaymentInfo.attributeTypeMap = [
        {
            "name": "Paid",
            "baseName": "Paid",
            "type": "boolean"
        },
        {
            "name": "PaymentType",
            "baseName": "PaymentType",
            "type": "string"
        }
    ];
    return PaymentInfo;
}());
exports.PaymentInfo = PaymentInfo;
var PaymentIntent = (function () {
    function PaymentIntent() {
    }
    PaymentIntent.getAttributeTypeMap = function () {
        return PaymentIntent.attributeTypeMap;
    };
    PaymentIntent.discriminator = undefined;
    PaymentIntent.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "string"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "string"
        },
        {
            "name": "Created",
            "baseName": "Created",
            "type": "Date"
        },
        {
            "name": "LastPaymentError",
            "baseName": "LastPaymentError",
            "type": "LastPaymentError"
        }
    ];
    return PaymentIntent;
}());
exports.PaymentIntent = PaymentIntent;
var PaymentTerminalDetails = (function () {
    function PaymentTerminalDetails() {
    }
    PaymentTerminalDetails.getAttributeTypeMap = function () {
        return PaymentTerminalDetails.attributeTypeMap;
    };
    PaymentTerminalDetails.discriminator = undefined;
    PaymentTerminalDetails.attributeTypeMap = [
        {
            "name": "TerminalId",
            "baseName": "TerminalId",
            "type": "string"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "string"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "string"
        },
        {
            "name": "Uri",
            "baseName": "Uri",
            "type": "string"
        }
    ];
    return PaymentTerminalDetails;
}());
exports.PaymentTerminalDetails = PaymentTerminalDetails;
var PaymentTerminalTransactionDetails = (function () {
    function PaymentTerminalTransactionDetails() {
    }
    PaymentTerminalTransactionDetails.getAttributeTypeMap = function () {
        return PaymentTerminalTransactionDetails.attributeTypeMap;
    };
    PaymentTerminalTransactionDetails.discriminator = undefined;
    PaymentTerminalTransactionDetails.attributeTypeMap = [
        {
            "name": "CardSchemeName",
            "baseName": "CardSchemeName",
            "type": "string"
        },
        {
            "name": "DateOfExpiry",
            "baseName": "DateOfExpiry",
            "type": "string"
        },
        {
            "name": "AuthCode",
            "baseName": "AuthCode",
            "type": "string"
        },
        {
            "name": "TransactionResult",
            "baseName": "TransactionResult",
            "type": "string"
        },
        {
            "name": "PrimaryAccountNumber",
            "baseName": "PrimaryAccountNumber",
            "type": "string"
        },
        {
            "name": "CardholderVerificationMethod",
            "baseName": "CardholderVerificationMethod",
            "type": "string"
        }
    ];
    return PaymentTerminalTransactionDetails;
}());
exports.PaymentTerminalTransactionDetails = PaymentTerminalTransactionDetails;
var Payout = (function () {
    function Payout() {
    }
    Payout.getAttributeTypeMap = function () {
        return Payout.attributeTypeMap;
    };
    Payout.discriminator = undefined;
    Payout.attributeTypeMap = [
        {
            "name": "PayoutId",
            "baseName": "PayoutId",
            "type": "number"
        },
        {
            "name": "PayeeBankAccountId",
            "baseName": "PayeeBankAccountId",
            "type": "number"
        },
        {
            "name": "AccountName",
            "baseName": "AccountName",
            "type": "string"
        },
        {
            "name": "PayoutStatus",
            "baseName": "PayoutStatus",
            "type": "Payout.PayoutStatusEnum"
        },
        {
            "name": "CreatedDate",
            "baseName": "CreatedDate",
            "type": "Date"
        },
        {
            "name": "PeriodStartTime",
            "baseName": "PeriodStartTime",
            "type": "Date"
        },
        {
            "name": "PeriodEndTime",
            "baseName": "PeriodEndTime",
            "type": "Date"
        },
        {
            "name": "DestinationBank",
            "baseName": "DestinationBank",
            "type": "string"
        },
        {
            "name": "DestinationAccount",
            "baseName": "DestinationAccount",
            "type": "string"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "PayoutType",
            "baseName": "PayoutType",
            "type": "Payout.PayoutTypeEnum"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "Payout.CurrencyEnum"
        },
        {
            "name": "CutoffDate",
            "baseName": "CutoffDate",
            "type": "Date"
        },
        {
            "name": "OnlineSalesAmount",
            "baseName": "OnlineSalesAmount",
            "type": "number"
        },
        {
            "name": "OnlineSalesDeliveryCharges",
            "baseName": "OnlineSalesDeliveryCharges",
            "type": "number"
        },
        {
            "name": "OnlineSalesTips",
            "baseName": "OnlineSalesTips",
            "type": "number"
        },
        {
            "name": "OnlineSalesServiceCharges",
            "baseName": "OnlineSalesServiceCharges",
            "type": "number"
        },
        {
            "name": "OnlineSalesRefundedFees",
            "baseName": "OnlineSalesRefundedFees",
            "type": "number"
        },
        {
            "name": "OnlineSalesFees",
            "baseName": "OnlineSalesFees",
            "type": "number"
        },
        {
            "name": "PosSalesFees",
            "baseName": "PosSalesFees",
            "type": "number"
        },
        {
            "name": "OnlineSalesRefundedAmount",
            "baseName": "OnlineSalesRefundedAmount",
            "type": "number"
        },
        {
            "name": "PosSalesRefundedAmount",
            "baseName": "PosSalesRefundedAmount",
            "type": "number"
        },
        {
            "name": "OnlineSalesTax",
            "baseName": "OnlineSalesTax",
            "type": "number"
        },
        {
            "name": "TotalOnlineRevenue",
            "baseName": "TotalOnlineRevenue",
            "type": "number"
        },
        {
            "name": "CashSalesFees",
            "baseName": "CashSalesFees",
            "type": "number"
        },
        {
            "name": "CashSalesRefundedFees",
            "baseName": "CashSalesRefundedFees",
            "type": "number"
        },
        {
            "name": "CustomerCashFees",
            "baseName": "CustomerCashFees",
            "type": "number"
        },
        {
            "name": "SalesFeesVat",
            "baseName": "SalesFeesVat",
            "type": "number"
        },
        {
            "name": "TotalFees",
            "baseName": "TotalFees",
            "type": "number"
        },
        {
            "name": "TotalOnlineRevenueAdjustments",
            "baseName": "TotalOnlineRevenueAdjustments",
            "type": "number"
        },
        {
            "name": "ChargebackAmount",
            "baseName": "ChargebackAmount",
            "type": "number"
        },
        {
            "name": "PosSalesChargebackAmount",
            "baseName": "PosSalesChargebackAmount",
            "type": "number"
        },
        {
            "name": "ChargebackRefundedFees",
            "baseName": "ChargebackRefundedFees",
            "type": "number"
        },
        {
            "name": "TotalChargebackCost",
            "baseName": "TotalChargebackCost",
            "type": "number"
        },
        {
            "name": "TotalOtherCharges",
            "baseName": "TotalOtherCharges",
            "type": "number"
        },
        {
            "name": "OpeningBalance",
            "baseName": "OpeningBalance",
            "type": "number"
        },
        {
            "name": "ClosingBalance",
            "baseName": "ClosingBalance",
            "type": "number"
        },
        {
            "name": "PayGreenSalesAmount",
            "baseName": "PayGreenSalesAmount",
            "type": "number"
        }
    ];
    return Payout;
}());
exports.Payout = Payout;
(function (Payout) {
    var PayoutStatusEnum;
    (function (PayoutStatusEnum) {
        PayoutStatusEnum[PayoutStatusEnum["Pending"] = 'Pending'] = "Pending";
        PayoutStatusEnum[PayoutStatusEnum["InTransit"] = 'InTransit'] = "InTransit";
        PayoutStatusEnum[PayoutStatusEnum["Paid"] = 'Paid'] = "Paid";
        PayoutStatusEnum[PayoutStatusEnum["Failed"] = 'Failed'] = "Failed";
        PayoutStatusEnum[PayoutStatusEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
    })(PayoutStatusEnum = Payout.PayoutStatusEnum || (Payout.PayoutStatusEnum = {}));
    var PayoutTypeEnum;
    (function (PayoutTypeEnum) {
        PayoutTypeEnum[PayoutTypeEnum["Internal"] = 'Internal'] = "Internal";
        PayoutTypeEnum[PayoutTypeEnum["Stripe"] = 'Stripe'] = "Stripe";
    })(PayoutTypeEnum = Payout.PayoutTypeEnum || (Payout.PayoutTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Payout.CurrencyEnum || (Payout.CurrencyEnum = {}));
})(Payout = exports.Payout || (exports.Payout = {}));
exports.Payout = Payout;
var PayoutChargeback = (function () {
    function PayoutChargeback() {
    }
    PayoutChargeback.getAttributeTypeMap = function () {
        return PayoutChargeback.attributeTypeMap;
    };
    PayoutChargeback.discriminator = undefined;
    PayoutChargeback.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "OrderCurrency",
            "baseName": "OrderCurrency",
            "type": "PayoutChargeback.OrderCurrencyEnum"
        },
        {
            "name": "PayoutId",
            "baseName": "PayoutId",
            "type": "number"
        },
        {
            "name": "OrderDate",
            "baseName": "OrderDate",
            "type": "Date"
        },
        {
            "name": "OrderType",
            "baseName": "OrderType",
            "type": "PayoutChargeback.OrderTypeEnum"
        },
        {
            "name": "ChargebackDate",
            "baseName": "ChargebackDate",
            "type": "Date"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "ChargebackAmount",
            "baseName": "ChargebackAmount",
            "type": "number"
        },
        {
            "name": "RefundedFees",
            "baseName": "RefundedFees",
            "type": "number"
        }
    ];
    return PayoutChargeback;
}());
exports.PayoutChargeback = PayoutChargeback;
(function (PayoutChargeback) {
    var OrderCurrencyEnum;
    (function (OrderCurrencyEnum) {
        OrderCurrencyEnum[OrderCurrencyEnum["EUR"] = 'EUR'] = "EUR";
        OrderCurrencyEnum[OrderCurrencyEnum["USD"] = 'USD'] = "USD";
        OrderCurrencyEnum[OrderCurrencyEnum["GBP"] = 'GBP'] = "GBP";
        OrderCurrencyEnum[OrderCurrencyEnum["CAD"] = 'CAD'] = "CAD";
        OrderCurrencyEnum[OrderCurrencyEnum["AUD"] = 'AUD'] = "AUD";
        OrderCurrencyEnum[OrderCurrencyEnum["DJF"] = 'DJF'] = "DJF";
        OrderCurrencyEnum[OrderCurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        OrderCurrencyEnum[OrderCurrencyEnum["ETB"] = 'ETB'] = "ETB";
        OrderCurrencyEnum[OrderCurrencyEnum["AED"] = 'AED'] = "AED";
        OrderCurrencyEnum[OrderCurrencyEnum["BHD"] = 'BHD'] = "BHD";
        OrderCurrencyEnum[OrderCurrencyEnum["DZD"] = 'DZD'] = "DZD";
        OrderCurrencyEnum[OrderCurrencyEnum["EGP"] = 'EGP'] = "EGP";
        OrderCurrencyEnum[OrderCurrencyEnum["IQD"] = 'IQD'] = "IQD";
        OrderCurrencyEnum[OrderCurrencyEnum["JOD"] = 'JOD'] = "JOD";
        OrderCurrencyEnum[OrderCurrencyEnum["KWD"] = 'KWD'] = "KWD";
        OrderCurrencyEnum[OrderCurrencyEnum["LBP"] = 'LBP'] = "LBP";
        OrderCurrencyEnum[OrderCurrencyEnum["LYD"] = 'LYD'] = "LYD";
        OrderCurrencyEnum[OrderCurrencyEnum["MAD"] = 'MAD'] = "MAD";
        OrderCurrencyEnum[OrderCurrencyEnum["OMR"] = 'OMR'] = "OMR";
        OrderCurrencyEnum[OrderCurrencyEnum["QAR"] = 'QAR'] = "QAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SAR"] = 'SAR'] = "SAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SYP"] = 'SYP'] = "SYP";
        OrderCurrencyEnum[OrderCurrencyEnum["TND"] = 'TND'] = "TND";
        OrderCurrencyEnum[OrderCurrencyEnum["YER"] = 'YER'] = "YER";
        OrderCurrencyEnum[OrderCurrencyEnum["CLP"] = 'CLP'] = "CLP";
        OrderCurrencyEnum[OrderCurrencyEnum["INR"] = 'INR'] = "INR";
        OrderCurrencyEnum[OrderCurrencyEnum["AZN"] = 'AZN'] = "AZN";
        OrderCurrencyEnum[OrderCurrencyEnum["RUB"] = 'RUB'] = "RUB";
        OrderCurrencyEnum[OrderCurrencyEnum["BYN"] = 'BYN'] = "BYN";
        OrderCurrencyEnum[OrderCurrencyEnum["BGN"] = 'BGN'] = "BGN";
        OrderCurrencyEnum[OrderCurrencyEnum["NGN"] = 'NGN'] = "NGN";
        OrderCurrencyEnum[OrderCurrencyEnum["BDT"] = 'BDT'] = "BDT";
        OrderCurrencyEnum[OrderCurrencyEnum["CNY"] = 'CNY'] = "CNY";
        OrderCurrencyEnum[OrderCurrencyEnum["BAM"] = 'BAM'] = "BAM";
        OrderCurrencyEnum[OrderCurrencyEnum["CZK"] = 'CZK'] = "CZK";
        OrderCurrencyEnum[OrderCurrencyEnum["DKK"] = 'DKK'] = "DKK";
        OrderCurrencyEnum[OrderCurrencyEnum["CHF"] = 'CHF'] = "CHF";
        OrderCurrencyEnum[OrderCurrencyEnum["MVR"] = 'MVR'] = "MVR";
        OrderCurrencyEnum[OrderCurrencyEnum["BTN"] = 'BTN'] = "BTN";
        OrderCurrencyEnum[OrderCurrencyEnum["XCD"] = 'XCD'] = "XCD";
        OrderCurrencyEnum[OrderCurrencyEnum["BZD"] = 'BZD'] = "BZD";
        OrderCurrencyEnum[OrderCurrencyEnum["HKD"] = 'HKD'] = "HKD";
        OrderCurrencyEnum[OrderCurrencyEnum["IDR"] = 'IDR'] = "IDR";
        OrderCurrencyEnum[OrderCurrencyEnum["JMD"] = 'JMD'] = "JMD";
        OrderCurrencyEnum[OrderCurrencyEnum["MYR"] = 'MYR'] = "MYR";
        OrderCurrencyEnum[OrderCurrencyEnum["NZD"] = 'NZD'] = "NZD";
        OrderCurrencyEnum[OrderCurrencyEnum["PHP"] = 'PHP'] = "PHP";
        OrderCurrencyEnum[OrderCurrencyEnum["SGD"] = 'SGD'] = "SGD";
        OrderCurrencyEnum[OrderCurrencyEnum["TTD"] = 'TTD'] = "TTD";
        OrderCurrencyEnum[OrderCurrencyEnum["XDR"] = 'XDR'] = "XDR";
        OrderCurrencyEnum[OrderCurrencyEnum["ARS"] = 'ARS'] = "ARS";
        OrderCurrencyEnum[OrderCurrencyEnum["BOB"] = 'BOB'] = "BOB";
        OrderCurrencyEnum[OrderCurrencyEnum["COP"] = 'COP'] = "COP";
        OrderCurrencyEnum[OrderCurrencyEnum["CRC"] = 'CRC'] = "CRC";
        OrderCurrencyEnum[OrderCurrencyEnum["CUP"] = 'CUP'] = "CUP";
        OrderCurrencyEnum[OrderCurrencyEnum["DOP"] = 'DOP'] = "DOP";
        OrderCurrencyEnum[OrderCurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        OrderCurrencyEnum[OrderCurrencyEnum["HNL"] = 'HNL'] = "HNL";
        OrderCurrencyEnum[OrderCurrencyEnum["MXN"] = 'MXN'] = "MXN";
        OrderCurrencyEnum[OrderCurrencyEnum["NIO"] = 'NIO'] = "NIO";
        OrderCurrencyEnum[OrderCurrencyEnum["PAB"] = 'PAB'] = "PAB";
        OrderCurrencyEnum[OrderCurrencyEnum["PEN"] = 'PEN'] = "PEN";
        OrderCurrencyEnum[OrderCurrencyEnum["PYG"] = 'PYG'] = "PYG";
        OrderCurrencyEnum[OrderCurrencyEnum["UYU"] = 'UYU'] = "UYU";
        OrderCurrencyEnum[OrderCurrencyEnum["VEF"] = 'VEF'] = "VEF";
        OrderCurrencyEnum[OrderCurrencyEnum["IRR"] = 'IRR'] = "IRR";
        OrderCurrencyEnum[OrderCurrencyEnum["XOF"] = 'XOF'] = "XOF";
        OrderCurrencyEnum[OrderCurrencyEnum["CDF"] = 'CDF'] = "CDF";
        OrderCurrencyEnum[OrderCurrencyEnum["XAF"] = 'XAF'] = "XAF";
        OrderCurrencyEnum[OrderCurrencyEnum["HTG"] = 'HTG'] = "HTG";
        OrderCurrencyEnum[OrderCurrencyEnum["ILS"] = 'ILS'] = "ILS";
        OrderCurrencyEnum[OrderCurrencyEnum["HRK"] = 'HRK'] = "HRK";
        OrderCurrencyEnum[OrderCurrencyEnum["HUF"] = 'HUF'] = "HUF";
        OrderCurrencyEnum[OrderCurrencyEnum["AMD"] = 'AMD'] = "AMD";
        OrderCurrencyEnum[OrderCurrencyEnum["ISK"] = 'ISK'] = "ISK";
        OrderCurrencyEnum[OrderCurrencyEnum["JPY"] = 'JPY'] = "JPY";
        OrderCurrencyEnum[OrderCurrencyEnum["GEL"] = 'GEL'] = "GEL";
        OrderCurrencyEnum[OrderCurrencyEnum["KZT"] = 'KZT'] = "KZT";
        OrderCurrencyEnum[OrderCurrencyEnum["KHR"] = 'KHR'] = "KHR";
        OrderCurrencyEnum[OrderCurrencyEnum["KRW"] = 'KRW'] = "KRW";
        OrderCurrencyEnum[OrderCurrencyEnum["KGS"] = 'KGS'] = "KGS";
        OrderCurrencyEnum[OrderCurrencyEnum["LAK"] = 'LAK'] = "LAK";
        OrderCurrencyEnum[OrderCurrencyEnum["MKD"] = 'MKD'] = "MKD";
        OrderCurrencyEnum[OrderCurrencyEnum["MNT"] = 'MNT'] = "MNT";
        OrderCurrencyEnum[OrderCurrencyEnum["BND"] = 'BND'] = "BND";
        OrderCurrencyEnum[OrderCurrencyEnum["MMK"] = 'MMK'] = "MMK";
        OrderCurrencyEnum[OrderCurrencyEnum["NOK"] = 'NOK'] = "NOK";
        OrderCurrencyEnum[OrderCurrencyEnum["NPR"] = 'NPR'] = "NPR";
        OrderCurrencyEnum[OrderCurrencyEnum["PKR"] = 'PKR'] = "PKR";
        OrderCurrencyEnum[OrderCurrencyEnum["PLN"] = 'PLN'] = "PLN";
        OrderCurrencyEnum[OrderCurrencyEnum["AFN"] = 'AFN'] = "AFN";
        OrderCurrencyEnum[OrderCurrencyEnum["BRL"] = 'BRL'] = "BRL";
        OrderCurrencyEnum[OrderCurrencyEnum["MDL"] = 'MDL'] = "MDL";
        OrderCurrencyEnum[OrderCurrencyEnum["RON"] = 'RON'] = "RON";
        OrderCurrencyEnum[OrderCurrencyEnum["RWF"] = 'RWF'] = "RWF";
        OrderCurrencyEnum[OrderCurrencyEnum["SEK"] = 'SEK'] = "SEK";
        OrderCurrencyEnum[OrderCurrencyEnum["LKR"] = 'LKR'] = "LKR";
        OrderCurrencyEnum[OrderCurrencyEnum["SOS"] = 'SOS'] = "SOS";
        OrderCurrencyEnum[OrderCurrencyEnum["ALL"] = 'ALL'] = "ALL";
        OrderCurrencyEnum[OrderCurrencyEnum["RSD"] = 'RSD'] = "RSD";
        OrderCurrencyEnum[OrderCurrencyEnum["KES"] = 'KES'] = "KES";
        OrderCurrencyEnum[OrderCurrencyEnum["TJS"] = 'TJS'] = "TJS";
        OrderCurrencyEnum[OrderCurrencyEnum["THB"] = 'THB'] = "THB";
        OrderCurrencyEnum[OrderCurrencyEnum["ERN"] = 'ERN'] = "ERN";
        OrderCurrencyEnum[OrderCurrencyEnum["TMT"] = 'TMT'] = "TMT";
        OrderCurrencyEnum[OrderCurrencyEnum["BWP"] = 'BWP'] = "BWP";
        OrderCurrencyEnum[OrderCurrencyEnum["TRY"] = 'TRY'] = "TRY";
        OrderCurrencyEnum[OrderCurrencyEnum["UAH"] = 'UAH'] = "UAH";
        OrderCurrencyEnum[OrderCurrencyEnum["UZS"] = 'UZS'] = "UZS";
        OrderCurrencyEnum[OrderCurrencyEnum["VND"] = 'VND'] = "VND";
        OrderCurrencyEnum[OrderCurrencyEnum["MOP"] = 'MOP'] = "MOP";
        OrderCurrencyEnum[OrderCurrencyEnum["TWD"] = 'TWD'] = "TWD";
        OrderCurrencyEnum[OrderCurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(OrderCurrencyEnum = PayoutChargeback.OrderCurrencyEnum || (PayoutChargeback.OrderCurrencyEnum = {}));
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum[OrderTypeEnum["Cash"] = 'Cash'] = "Cash";
        OrderTypeEnum[OrderTypeEnum["Online"] = 'Online'] = "Online";
    })(OrderTypeEnum = PayoutChargeback.OrderTypeEnum || (PayoutChargeback.OrderTypeEnum = {}));
})(PayoutChargeback = exports.PayoutChargeback || (exports.PayoutChargeback = {}));
exports.PayoutChargeback = PayoutChargeback;
var PayoutDetail = (function () {
    function PayoutDetail() {
    }
    PayoutDetail.getAttributeTypeMap = function () {
        return PayoutDetail.attributeTypeMap;
    };
    PayoutDetail.discriminator = undefined;
    PayoutDetail.attributeTypeMap = [
        {
            "name": "PayoutId",
            "baseName": "PayoutId",
            "type": "number"
        },
        {
            "name": "BankAccountId",
            "baseName": "BankAccountId",
            "type": "number"
        },
        {
            "name": "AccountName",
            "baseName": "AccountName",
            "type": "string"
        },
        {
            "name": "PayoutStatus",
            "baseName": "PayoutStatus",
            "type": "PayoutDetail.PayoutStatusEnum"
        },
        {
            "name": "CreatedDate",
            "baseName": "CreatedDate",
            "type": "Date"
        },
        {
            "name": "PeriodStartTime",
            "baseName": "PeriodStartTime",
            "type": "Date"
        },
        {
            "name": "PeriodEndTime",
            "baseName": "PeriodEndTime",
            "type": "Date"
        },
        {
            "name": "DestinationBank",
            "baseName": "DestinationBank",
            "type": "string"
        },
        {
            "name": "DestinationAccount",
            "baseName": "DestinationAccount",
            "type": "string"
        },
        {
            "name": "PayoutType",
            "baseName": "PayoutType",
            "type": "PayoutDetail.PayoutTypeEnum"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "PayoutDetail.CurrencyEnum"
        },
        {
            "name": "PayoutStores",
            "baseName": "PayoutStores",
            "type": "Array<PayoutStore>"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "CutoffDate",
            "baseName": "CutoffDate",
            "type": "Date"
        }
    ];
    return PayoutDetail;
}());
exports.PayoutDetail = PayoutDetail;
(function (PayoutDetail) {
    var PayoutStatusEnum;
    (function (PayoutStatusEnum) {
        PayoutStatusEnum[PayoutStatusEnum["Pending"] = 'Pending'] = "Pending";
        PayoutStatusEnum[PayoutStatusEnum["InTransit"] = 'InTransit'] = "InTransit";
        PayoutStatusEnum[PayoutStatusEnum["Paid"] = 'Paid'] = "Paid";
        PayoutStatusEnum[PayoutStatusEnum["Failed"] = 'Failed'] = "Failed";
        PayoutStatusEnum[PayoutStatusEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
    })(PayoutStatusEnum = PayoutDetail.PayoutStatusEnum || (PayoutDetail.PayoutStatusEnum = {}));
    var PayoutTypeEnum;
    (function (PayoutTypeEnum) {
        PayoutTypeEnum[PayoutTypeEnum["Internal"] = 'Internal'] = "Internal";
        PayoutTypeEnum[PayoutTypeEnum["Stripe"] = 'Stripe'] = "Stripe";
    })(PayoutTypeEnum = PayoutDetail.PayoutTypeEnum || (PayoutDetail.PayoutTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = PayoutDetail.CurrencyEnum || (PayoutDetail.CurrencyEnum = {}));
})(PayoutDetail = exports.PayoutDetail || (exports.PayoutDetail = {}));
exports.PayoutDetail = PayoutDetail;
var PayoutOrder = (function () {
    function PayoutOrder() {
    }
    PayoutOrder.getAttributeTypeMap = function () {
        return PayoutOrder.attributeTypeMap;
    };
    PayoutOrder.discriminator = undefined;
    PayoutOrder.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "PayoutId",
            "baseName": "PayoutId",
            "type": "number"
        },
        {
            "name": "OrderDate",
            "baseName": "OrderDate",
            "type": "Date"
        },
        {
            "name": "OrderType",
            "baseName": "OrderType",
            "type": "PayoutOrder.OrderTypeEnum"
        },
        {
            "name": "OrderCurrency",
            "baseName": "OrderCurrency",
            "type": "PayoutOrder.OrderCurrencyEnum"
        },
        {
            "name": "Sales",
            "baseName": "Sales",
            "type": "number"
        },
        {
            "name": "SalesTax",
            "baseName": "SalesTax",
            "type": "number"
        },
        {
            "name": "DeliveryCharges",
            "baseName": "DeliveryCharges",
            "type": "number"
        },
        {
            "name": "Tips",
            "baseName": "Tips",
            "type": "number"
        },
        {
            "name": "Voucher",
            "baseName": "Voucher",
            "type": "number"
        },
        {
            "name": "FlatFeeExcludingVat",
            "baseName": "FlatFeeExcludingVat",
            "type": "number"
        },
        {
            "name": "FlatFeeExcludingVAT",
            "baseName": "FlatFeeExcludingVAT",
            "type": "number"
        },
        {
            "name": "PercentageFeeExcludingVat",
            "baseName": "PercentageFeeExcludingVat",
            "type": "number"
        },
        {
            "name": "PercentageFeeExcludingVAT",
            "baseName": "PercentageFeeExcludingVAT",
            "type": "number"
        },
        {
            "name": "Vat",
            "baseName": "Vat",
            "type": "number"
        },
        {
            "name": "TotalFees",
            "baseName": "TotalFees",
            "type": "number"
        },
        {
            "name": "CashFeeChargedToCustomer",
            "baseName": "CashFeeChargedToCustomer",
            "type": "number"
        },
        {
            "name": "NetSales",
            "baseName": "NetSales",
            "type": "number"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "ServiceChargeAmount",
            "baseName": "ServiceChargeAmount",
            "type": "number"
        },
        {
            "name": "ServiceChargePercentage",
            "baseName": "ServiceChargePercentage",
            "type": "number"
        }
    ];
    return PayoutOrder;
}());
exports.PayoutOrder = PayoutOrder;
(function (PayoutOrder) {
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum[OrderTypeEnum["Cash"] = 'Cash'] = "Cash";
        OrderTypeEnum[OrderTypeEnum["Online"] = 'Online'] = "Online";
    })(OrderTypeEnum = PayoutOrder.OrderTypeEnum || (PayoutOrder.OrderTypeEnum = {}));
    var OrderCurrencyEnum;
    (function (OrderCurrencyEnum) {
        OrderCurrencyEnum[OrderCurrencyEnum["EUR"] = 'EUR'] = "EUR";
        OrderCurrencyEnum[OrderCurrencyEnum["USD"] = 'USD'] = "USD";
        OrderCurrencyEnum[OrderCurrencyEnum["GBP"] = 'GBP'] = "GBP";
        OrderCurrencyEnum[OrderCurrencyEnum["CAD"] = 'CAD'] = "CAD";
        OrderCurrencyEnum[OrderCurrencyEnum["AUD"] = 'AUD'] = "AUD";
        OrderCurrencyEnum[OrderCurrencyEnum["DJF"] = 'DJF'] = "DJF";
        OrderCurrencyEnum[OrderCurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        OrderCurrencyEnum[OrderCurrencyEnum["ETB"] = 'ETB'] = "ETB";
        OrderCurrencyEnum[OrderCurrencyEnum["AED"] = 'AED'] = "AED";
        OrderCurrencyEnum[OrderCurrencyEnum["BHD"] = 'BHD'] = "BHD";
        OrderCurrencyEnum[OrderCurrencyEnum["DZD"] = 'DZD'] = "DZD";
        OrderCurrencyEnum[OrderCurrencyEnum["EGP"] = 'EGP'] = "EGP";
        OrderCurrencyEnum[OrderCurrencyEnum["IQD"] = 'IQD'] = "IQD";
        OrderCurrencyEnum[OrderCurrencyEnum["JOD"] = 'JOD'] = "JOD";
        OrderCurrencyEnum[OrderCurrencyEnum["KWD"] = 'KWD'] = "KWD";
        OrderCurrencyEnum[OrderCurrencyEnum["LBP"] = 'LBP'] = "LBP";
        OrderCurrencyEnum[OrderCurrencyEnum["LYD"] = 'LYD'] = "LYD";
        OrderCurrencyEnum[OrderCurrencyEnum["MAD"] = 'MAD'] = "MAD";
        OrderCurrencyEnum[OrderCurrencyEnum["OMR"] = 'OMR'] = "OMR";
        OrderCurrencyEnum[OrderCurrencyEnum["QAR"] = 'QAR'] = "QAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SAR"] = 'SAR'] = "SAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SYP"] = 'SYP'] = "SYP";
        OrderCurrencyEnum[OrderCurrencyEnum["TND"] = 'TND'] = "TND";
        OrderCurrencyEnum[OrderCurrencyEnum["YER"] = 'YER'] = "YER";
        OrderCurrencyEnum[OrderCurrencyEnum["CLP"] = 'CLP'] = "CLP";
        OrderCurrencyEnum[OrderCurrencyEnum["INR"] = 'INR'] = "INR";
        OrderCurrencyEnum[OrderCurrencyEnum["AZN"] = 'AZN'] = "AZN";
        OrderCurrencyEnum[OrderCurrencyEnum["RUB"] = 'RUB'] = "RUB";
        OrderCurrencyEnum[OrderCurrencyEnum["BYN"] = 'BYN'] = "BYN";
        OrderCurrencyEnum[OrderCurrencyEnum["BGN"] = 'BGN'] = "BGN";
        OrderCurrencyEnum[OrderCurrencyEnum["NGN"] = 'NGN'] = "NGN";
        OrderCurrencyEnum[OrderCurrencyEnum["BDT"] = 'BDT'] = "BDT";
        OrderCurrencyEnum[OrderCurrencyEnum["CNY"] = 'CNY'] = "CNY";
        OrderCurrencyEnum[OrderCurrencyEnum["BAM"] = 'BAM'] = "BAM";
        OrderCurrencyEnum[OrderCurrencyEnum["CZK"] = 'CZK'] = "CZK";
        OrderCurrencyEnum[OrderCurrencyEnum["DKK"] = 'DKK'] = "DKK";
        OrderCurrencyEnum[OrderCurrencyEnum["CHF"] = 'CHF'] = "CHF";
        OrderCurrencyEnum[OrderCurrencyEnum["MVR"] = 'MVR'] = "MVR";
        OrderCurrencyEnum[OrderCurrencyEnum["BTN"] = 'BTN'] = "BTN";
        OrderCurrencyEnum[OrderCurrencyEnum["XCD"] = 'XCD'] = "XCD";
        OrderCurrencyEnum[OrderCurrencyEnum["BZD"] = 'BZD'] = "BZD";
        OrderCurrencyEnum[OrderCurrencyEnum["HKD"] = 'HKD'] = "HKD";
        OrderCurrencyEnum[OrderCurrencyEnum["IDR"] = 'IDR'] = "IDR";
        OrderCurrencyEnum[OrderCurrencyEnum["JMD"] = 'JMD'] = "JMD";
        OrderCurrencyEnum[OrderCurrencyEnum["MYR"] = 'MYR'] = "MYR";
        OrderCurrencyEnum[OrderCurrencyEnum["NZD"] = 'NZD'] = "NZD";
        OrderCurrencyEnum[OrderCurrencyEnum["PHP"] = 'PHP'] = "PHP";
        OrderCurrencyEnum[OrderCurrencyEnum["SGD"] = 'SGD'] = "SGD";
        OrderCurrencyEnum[OrderCurrencyEnum["TTD"] = 'TTD'] = "TTD";
        OrderCurrencyEnum[OrderCurrencyEnum["XDR"] = 'XDR'] = "XDR";
        OrderCurrencyEnum[OrderCurrencyEnum["ARS"] = 'ARS'] = "ARS";
        OrderCurrencyEnum[OrderCurrencyEnum["BOB"] = 'BOB'] = "BOB";
        OrderCurrencyEnum[OrderCurrencyEnum["COP"] = 'COP'] = "COP";
        OrderCurrencyEnum[OrderCurrencyEnum["CRC"] = 'CRC'] = "CRC";
        OrderCurrencyEnum[OrderCurrencyEnum["CUP"] = 'CUP'] = "CUP";
        OrderCurrencyEnum[OrderCurrencyEnum["DOP"] = 'DOP'] = "DOP";
        OrderCurrencyEnum[OrderCurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        OrderCurrencyEnum[OrderCurrencyEnum["HNL"] = 'HNL'] = "HNL";
        OrderCurrencyEnum[OrderCurrencyEnum["MXN"] = 'MXN'] = "MXN";
        OrderCurrencyEnum[OrderCurrencyEnum["NIO"] = 'NIO'] = "NIO";
        OrderCurrencyEnum[OrderCurrencyEnum["PAB"] = 'PAB'] = "PAB";
        OrderCurrencyEnum[OrderCurrencyEnum["PEN"] = 'PEN'] = "PEN";
        OrderCurrencyEnum[OrderCurrencyEnum["PYG"] = 'PYG'] = "PYG";
        OrderCurrencyEnum[OrderCurrencyEnum["UYU"] = 'UYU'] = "UYU";
        OrderCurrencyEnum[OrderCurrencyEnum["VEF"] = 'VEF'] = "VEF";
        OrderCurrencyEnum[OrderCurrencyEnum["IRR"] = 'IRR'] = "IRR";
        OrderCurrencyEnum[OrderCurrencyEnum["XOF"] = 'XOF'] = "XOF";
        OrderCurrencyEnum[OrderCurrencyEnum["CDF"] = 'CDF'] = "CDF";
        OrderCurrencyEnum[OrderCurrencyEnum["XAF"] = 'XAF'] = "XAF";
        OrderCurrencyEnum[OrderCurrencyEnum["HTG"] = 'HTG'] = "HTG";
        OrderCurrencyEnum[OrderCurrencyEnum["ILS"] = 'ILS'] = "ILS";
        OrderCurrencyEnum[OrderCurrencyEnum["HRK"] = 'HRK'] = "HRK";
        OrderCurrencyEnum[OrderCurrencyEnum["HUF"] = 'HUF'] = "HUF";
        OrderCurrencyEnum[OrderCurrencyEnum["AMD"] = 'AMD'] = "AMD";
        OrderCurrencyEnum[OrderCurrencyEnum["ISK"] = 'ISK'] = "ISK";
        OrderCurrencyEnum[OrderCurrencyEnum["JPY"] = 'JPY'] = "JPY";
        OrderCurrencyEnum[OrderCurrencyEnum["GEL"] = 'GEL'] = "GEL";
        OrderCurrencyEnum[OrderCurrencyEnum["KZT"] = 'KZT'] = "KZT";
        OrderCurrencyEnum[OrderCurrencyEnum["KHR"] = 'KHR'] = "KHR";
        OrderCurrencyEnum[OrderCurrencyEnum["KRW"] = 'KRW'] = "KRW";
        OrderCurrencyEnum[OrderCurrencyEnum["KGS"] = 'KGS'] = "KGS";
        OrderCurrencyEnum[OrderCurrencyEnum["LAK"] = 'LAK'] = "LAK";
        OrderCurrencyEnum[OrderCurrencyEnum["MKD"] = 'MKD'] = "MKD";
        OrderCurrencyEnum[OrderCurrencyEnum["MNT"] = 'MNT'] = "MNT";
        OrderCurrencyEnum[OrderCurrencyEnum["BND"] = 'BND'] = "BND";
        OrderCurrencyEnum[OrderCurrencyEnum["MMK"] = 'MMK'] = "MMK";
        OrderCurrencyEnum[OrderCurrencyEnum["NOK"] = 'NOK'] = "NOK";
        OrderCurrencyEnum[OrderCurrencyEnum["NPR"] = 'NPR'] = "NPR";
        OrderCurrencyEnum[OrderCurrencyEnum["PKR"] = 'PKR'] = "PKR";
        OrderCurrencyEnum[OrderCurrencyEnum["PLN"] = 'PLN'] = "PLN";
        OrderCurrencyEnum[OrderCurrencyEnum["AFN"] = 'AFN'] = "AFN";
        OrderCurrencyEnum[OrderCurrencyEnum["BRL"] = 'BRL'] = "BRL";
        OrderCurrencyEnum[OrderCurrencyEnum["MDL"] = 'MDL'] = "MDL";
        OrderCurrencyEnum[OrderCurrencyEnum["RON"] = 'RON'] = "RON";
        OrderCurrencyEnum[OrderCurrencyEnum["RWF"] = 'RWF'] = "RWF";
        OrderCurrencyEnum[OrderCurrencyEnum["SEK"] = 'SEK'] = "SEK";
        OrderCurrencyEnum[OrderCurrencyEnum["LKR"] = 'LKR'] = "LKR";
        OrderCurrencyEnum[OrderCurrencyEnum["SOS"] = 'SOS'] = "SOS";
        OrderCurrencyEnum[OrderCurrencyEnum["ALL"] = 'ALL'] = "ALL";
        OrderCurrencyEnum[OrderCurrencyEnum["RSD"] = 'RSD'] = "RSD";
        OrderCurrencyEnum[OrderCurrencyEnum["KES"] = 'KES'] = "KES";
        OrderCurrencyEnum[OrderCurrencyEnum["TJS"] = 'TJS'] = "TJS";
        OrderCurrencyEnum[OrderCurrencyEnum["THB"] = 'THB'] = "THB";
        OrderCurrencyEnum[OrderCurrencyEnum["ERN"] = 'ERN'] = "ERN";
        OrderCurrencyEnum[OrderCurrencyEnum["TMT"] = 'TMT'] = "TMT";
        OrderCurrencyEnum[OrderCurrencyEnum["BWP"] = 'BWP'] = "BWP";
        OrderCurrencyEnum[OrderCurrencyEnum["TRY"] = 'TRY'] = "TRY";
        OrderCurrencyEnum[OrderCurrencyEnum["UAH"] = 'UAH'] = "UAH";
        OrderCurrencyEnum[OrderCurrencyEnum["UZS"] = 'UZS'] = "UZS";
        OrderCurrencyEnum[OrderCurrencyEnum["VND"] = 'VND'] = "VND";
        OrderCurrencyEnum[OrderCurrencyEnum["MOP"] = 'MOP'] = "MOP";
        OrderCurrencyEnum[OrderCurrencyEnum["TWD"] = 'TWD'] = "TWD";
        OrderCurrencyEnum[OrderCurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(OrderCurrencyEnum = PayoutOrder.OrderCurrencyEnum || (PayoutOrder.OrderCurrencyEnum = {}));
})(PayoutOrder = exports.PayoutOrder || (exports.PayoutOrder = {}));
exports.PayoutOrder = PayoutOrder;
var PayoutOtherCharge = (function () {
    function PayoutOtherCharge() {
    }
    PayoutOtherCharge.getAttributeTypeMap = function () {
        return PayoutOtherCharge.attributeTypeMap;
    };
    PayoutOtherCharge.discriminator = undefined;
    PayoutOtherCharge.attributeTypeMap = [
        {
            "name": "ChargeId",
            "baseName": "ChargeId",
            "type": "number"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "PayoutOtherCharge.CurrencyEnum"
        },
        {
            "name": "PayoutId",
            "baseName": "PayoutId",
            "type": "number"
        },
        {
            "name": "ChargeDate",
            "baseName": "ChargeDate",
            "type": "Date"
        },
        {
            "name": "ChargeType",
            "baseName": "ChargeType",
            "type": "PayoutOtherCharge.ChargeTypeEnum"
        },
        {
            "name": "ChargeDescription",
            "baseName": "ChargeDescription",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        }
    ];
    return PayoutOtherCharge;
}());
exports.PayoutOtherCharge = PayoutOtherCharge;
(function (PayoutOtherCharge) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = PayoutOtherCharge.CurrencyEnum || (PayoutOtherCharge.CurrencyEnum = {}));
    var ChargeTypeEnum;
    (function (ChargeTypeEnum) {
        ChargeTypeEnum[ChargeTypeEnum["Other"] = 'Other'] = "Other";
        ChargeTypeEnum[ChargeTypeEnum["Fees"] = 'Fees'] = "Fees";
        ChargeTypeEnum[ChargeTypeEnum["Chargeback"] = 'Chargeback'] = "Chargeback";
        ChargeTypeEnum[ChargeTypeEnum["TipFailure"] = 'TipFailure'] = "TipFailure";
        ChargeTypeEnum[ChargeTypeEnum["ExternalDisbursement"] = 'ExternalDisbursement'] = "ExternalDisbursement";
        ChargeTypeEnum[ChargeTypeEnum["Goods"] = 'Goods'] = "Goods";
        ChargeTypeEnum[ChargeTypeEnum["RestaurantSales"] = 'RestaurantSales'] = "RestaurantSales";
        ChargeTypeEnum[ChargeTypeEnum["Tips"] = 'Tips'] = "Tips";
    })(ChargeTypeEnum = PayoutOtherCharge.ChargeTypeEnum || (PayoutOtherCharge.ChargeTypeEnum = {}));
})(PayoutOtherCharge = exports.PayoutOtherCharge || (exports.PayoutOtherCharge = {}));
exports.PayoutOtherCharge = PayoutOtherCharge;
var PayoutRefund = (function () {
    function PayoutRefund() {
    }
    PayoutRefund.getAttributeTypeMap = function () {
        return PayoutRefund.attributeTypeMap;
    };
    PayoutRefund.discriminator = undefined;
    PayoutRefund.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "OrderCurrency",
            "baseName": "OrderCurrency",
            "type": "PayoutRefund.OrderCurrencyEnum"
        },
        {
            "name": "PayoutId",
            "baseName": "PayoutId",
            "type": "number"
        },
        {
            "name": "OrderDate",
            "baseName": "OrderDate",
            "type": "Date"
        },
        {
            "name": "OrderType",
            "baseName": "OrderType",
            "type": "PayoutRefund.OrderTypeEnum"
        },
        {
            "name": "RefundDate",
            "baseName": "RefundDate",
            "type": "Date"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "TotalRefund",
            "baseName": "TotalRefund",
            "type": "number"
        },
        {
            "name": "RefundedFees",
            "baseName": "RefundedFees",
            "type": "number"
        },
        {
            "name": "RefundedAmount",
            "baseName": "RefundedAmount",
            "type": "number"
        },
        {
            "name": "CashFeeRefundedToCustomer",
            "baseName": "CashFeeRefundedToCustomer",
            "type": "number"
        }
    ];
    return PayoutRefund;
}());
exports.PayoutRefund = PayoutRefund;
(function (PayoutRefund) {
    var OrderCurrencyEnum;
    (function (OrderCurrencyEnum) {
        OrderCurrencyEnum[OrderCurrencyEnum["EUR"] = 'EUR'] = "EUR";
        OrderCurrencyEnum[OrderCurrencyEnum["USD"] = 'USD'] = "USD";
        OrderCurrencyEnum[OrderCurrencyEnum["GBP"] = 'GBP'] = "GBP";
        OrderCurrencyEnum[OrderCurrencyEnum["CAD"] = 'CAD'] = "CAD";
        OrderCurrencyEnum[OrderCurrencyEnum["AUD"] = 'AUD'] = "AUD";
        OrderCurrencyEnum[OrderCurrencyEnum["DJF"] = 'DJF'] = "DJF";
        OrderCurrencyEnum[OrderCurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        OrderCurrencyEnum[OrderCurrencyEnum["ETB"] = 'ETB'] = "ETB";
        OrderCurrencyEnum[OrderCurrencyEnum["AED"] = 'AED'] = "AED";
        OrderCurrencyEnum[OrderCurrencyEnum["BHD"] = 'BHD'] = "BHD";
        OrderCurrencyEnum[OrderCurrencyEnum["DZD"] = 'DZD'] = "DZD";
        OrderCurrencyEnum[OrderCurrencyEnum["EGP"] = 'EGP'] = "EGP";
        OrderCurrencyEnum[OrderCurrencyEnum["IQD"] = 'IQD'] = "IQD";
        OrderCurrencyEnum[OrderCurrencyEnum["JOD"] = 'JOD'] = "JOD";
        OrderCurrencyEnum[OrderCurrencyEnum["KWD"] = 'KWD'] = "KWD";
        OrderCurrencyEnum[OrderCurrencyEnum["LBP"] = 'LBP'] = "LBP";
        OrderCurrencyEnum[OrderCurrencyEnum["LYD"] = 'LYD'] = "LYD";
        OrderCurrencyEnum[OrderCurrencyEnum["MAD"] = 'MAD'] = "MAD";
        OrderCurrencyEnum[OrderCurrencyEnum["OMR"] = 'OMR'] = "OMR";
        OrderCurrencyEnum[OrderCurrencyEnum["QAR"] = 'QAR'] = "QAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SAR"] = 'SAR'] = "SAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SYP"] = 'SYP'] = "SYP";
        OrderCurrencyEnum[OrderCurrencyEnum["TND"] = 'TND'] = "TND";
        OrderCurrencyEnum[OrderCurrencyEnum["YER"] = 'YER'] = "YER";
        OrderCurrencyEnum[OrderCurrencyEnum["CLP"] = 'CLP'] = "CLP";
        OrderCurrencyEnum[OrderCurrencyEnum["INR"] = 'INR'] = "INR";
        OrderCurrencyEnum[OrderCurrencyEnum["AZN"] = 'AZN'] = "AZN";
        OrderCurrencyEnum[OrderCurrencyEnum["RUB"] = 'RUB'] = "RUB";
        OrderCurrencyEnum[OrderCurrencyEnum["BYN"] = 'BYN'] = "BYN";
        OrderCurrencyEnum[OrderCurrencyEnum["BGN"] = 'BGN'] = "BGN";
        OrderCurrencyEnum[OrderCurrencyEnum["NGN"] = 'NGN'] = "NGN";
        OrderCurrencyEnum[OrderCurrencyEnum["BDT"] = 'BDT'] = "BDT";
        OrderCurrencyEnum[OrderCurrencyEnum["CNY"] = 'CNY'] = "CNY";
        OrderCurrencyEnum[OrderCurrencyEnum["BAM"] = 'BAM'] = "BAM";
        OrderCurrencyEnum[OrderCurrencyEnum["CZK"] = 'CZK'] = "CZK";
        OrderCurrencyEnum[OrderCurrencyEnum["DKK"] = 'DKK'] = "DKK";
        OrderCurrencyEnum[OrderCurrencyEnum["CHF"] = 'CHF'] = "CHF";
        OrderCurrencyEnum[OrderCurrencyEnum["MVR"] = 'MVR'] = "MVR";
        OrderCurrencyEnum[OrderCurrencyEnum["BTN"] = 'BTN'] = "BTN";
        OrderCurrencyEnum[OrderCurrencyEnum["XCD"] = 'XCD'] = "XCD";
        OrderCurrencyEnum[OrderCurrencyEnum["BZD"] = 'BZD'] = "BZD";
        OrderCurrencyEnum[OrderCurrencyEnum["HKD"] = 'HKD'] = "HKD";
        OrderCurrencyEnum[OrderCurrencyEnum["IDR"] = 'IDR'] = "IDR";
        OrderCurrencyEnum[OrderCurrencyEnum["JMD"] = 'JMD'] = "JMD";
        OrderCurrencyEnum[OrderCurrencyEnum["MYR"] = 'MYR'] = "MYR";
        OrderCurrencyEnum[OrderCurrencyEnum["NZD"] = 'NZD'] = "NZD";
        OrderCurrencyEnum[OrderCurrencyEnum["PHP"] = 'PHP'] = "PHP";
        OrderCurrencyEnum[OrderCurrencyEnum["SGD"] = 'SGD'] = "SGD";
        OrderCurrencyEnum[OrderCurrencyEnum["TTD"] = 'TTD'] = "TTD";
        OrderCurrencyEnum[OrderCurrencyEnum["XDR"] = 'XDR'] = "XDR";
        OrderCurrencyEnum[OrderCurrencyEnum["ARS"] = 'ARS'] = "ARS";
        OrderCurrencyEnum[OrderCurrencyEnum["BOB"] = 'BOB'] = "BOB";
        OrderCurrencyEnum[OrderCurrencyEnum["COP"] = 'COP'] = "COP";
        OrderCurrencyEnum[OrderCurrencyEnum["CRC"] = 'CRC'] = "CRC";
        OrderCurrencyEnum[OrderCurrencyEnum["CUP"] = 'CUP'] = "CUP";
        OrderCurrencyEnum[OrderCurrencyEnum["DOP"] = 'DOP'] = "DOP";
        OrderCurrencyEnum[OrderCurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        OrderCurrencyEnum[OrderCurrencyEnum["HNL"] = 'HNL'] = "HNL";
        OrderCurrencyEnum[OrderCurrencyEnum["MXN"] = 'MXN'] = "MXN";
        OrderCurrencyEnum[OrderCurrencyEnum["NIO"] = 'NIO'] = "NIO";
        OrderCurrencyEnum[OrderCurrencyEnum["PAB"] = 'PAB'] = "PAB";
        OrderCurrencyEnum[OrderCurrencyEnum["PEN"] = 'PEN'] = "PEN";
        OrderCurrencyEnum[OrderCurrencyEnum["PYG"] = 'PYG'] = "PYG";
        OrderCurrencyEnum[OrderCurrencyEnum["UYU"] = 'UYU'] = "UYU";
        OrderCurrencyEnum[OrderCurrencyEnum["VEF"] = 'VEF'] = "VEF";
        OrderCurrencyEnum[OrderCurrencyEnum["IRR"] = 'IRR'] = "IRR";
        OrderCurrencyEnum[OrderCurrencyEnum["XOF"] = 'XOF'] = "XOF";
        OrderCurrencyEnum[OrderCurrencyEnum["CDF"] = 'CDF'] = "CDF";
        OrderCurrencyEnum[OrderCurrencyEnum["XAF"] = 'XAF'] = "XAF";
        OrderCurrencyEnum[OrderCurrencyEnum["HTG"] = 'HTG'] = "HTG";
        OrderCurrencyEnum[OrderCurrencyEnum["ILS"] = 'ILS'] = "ILS";
        OrderCurrencyEnum[OrderCurrencyEnum["HRK"] = 'HRK'] = "HRK";
        OrderCurrencyEnum[OrderCurrencyEnum["HUF"] = 'HUF'] = "HUF";
        OrderCurrencyEnum[OrderCurrencyEnum["AMD"] = 'AMD'] = "AMD";
        OrderCurrencyEnum[OrderCurrencyEnum["ISK"] = 'ISK'] = "ISK";
        OrderCurrencyEnum[OrderCurrencyEnum["JPY"] = 'JPY'] = "JPY";
        OrderCurrencyEnum[OrderCurrencyEnum["GEL"] = 'GEL'] = "GEL";
        OrderCurrencyEnum[OrderCurrencyEnum["KZT"] = 'KZT'] = "KZT";
        OrderCurrencyEnum[OrderCurrencyEnum["KHR"] = 'KHR'] = "KHR";
        OrderCurrencyEnum[OrderCurrencyEnum["KRW"] = 'KRW'] = "KRW";
        OrderCurrencyEnum[OrderCurrencyEnum["KGS"] = 'KGS'] = "KGS";
        OrderCurrencyEnum[OrderCurrencyEnum["LAK"] = 'LAK'] = "LAK";
        OrderCurrencyEnum[OrderCurrencyEnum["MKD"] = 'MKD'] = "MKD";
        OrderCurrencyEnum[OrderCurrencyEnum["MNT"] = 'MNT'] = "MNT";
        OrderCurrencyEnum[OrderCurrencyEnum["BND"] = 'BND'] = "BND";
        OrderCurrencyEnum[OrderCurrencyEnum["MMK"] = 'MMK'] = "MMK";
        OrderCurrencyEnum[OrderCurrencyEnum["NOK"] = 'NOK'] = "NOK";
        OrderCurrencyEnum[OrderCurrencyEnum["NPR"] = 'NPR'] = "NPR";
        OrderCurrencyEnum[OrderCurrencyEnum["PKR"] = 'PKR'] = "PKR";
        OrderCurrencyEnum[OrderCurrencyEnum["PLN"] = 'PLN'] = "PLN";
        OrderCurrencyEnum[OrderCurrencyEnum["AFN"] = 'AFN'] = "AFN";
        OrderCurrencyEnum[OrderCurrencyEnum["BRL"] = 'BRL'] = "BRL";
        OrderCurrencyEnum[OrderCurrencyEnum["MDL"] = 'MDL'] = "MDL";
        OrderCurrencyEnum[OrderCurrencyEnum["RON"] = 'RON'] = "RON";
        OrderCurrencyEnum[OrderCurrencyEnum["RWF"] = 'RWF'] = "RWF";
        OrderCurrencyEnum[OrderCurrencyEnum["SEK"] = 'SEK'] = "SEK";
        OrderCurrencyEnum[OrderCurrencyEnum["LKR"] = 'LKR'] = "LKR";
        OrderCurrencyEnum[OrderCurrencyEnum["SOS"] = 'SOS'] = "SOS";
        OrderCurrencyEnum[OrderCurrencyEnum["ALL"] = 'ALL'] = "ALL";
        OrderCurrencyEnum[OrderCurrencyEnum["RSD"] = 'RSD'] = "RSD";
        OrderCurrencyEnum[OrderCurrencyEnum["KES"] = 'KES'] = "KES";
        OrderCurrencyEnum[OrderCurrencyEnum["TJS"] = 'TJS'] = "TJS";
        OrderCurrencyEnum[OrderCurrencyEnum["THB"] = 'THB'] = "THB";
        OrderCurrencyEnum[OrderCurrencyEnum["ERN"] = 'ERN'] = "ERN";
        OrderCurrencyEnum[OrderCurrencyEnum["TMT"] = 'TMT'] = "TMT";
        OrderCurrencyEnum[OrderCurrencyEnum["BWP"] = 'BWP'] = "BWP";
        OrderCurrencyEnum[OrderCurrencyEnum["TRY"] = 'TRY'] = "TRY";
        OrderCurrencyEnum[OrderCurrencyEnum["UAH"] = 'UAH'] = "UAH";
        OrderCurrencyEnum[OrderCurrencyEnum["UZS"] = 'UZS'] = "UZS";
        OrderCurrencyEnum[OrderCurrencyEnum["VND"] = 'VND'] = "VND";
        OrderCurrencyEnum[OrderCurrencyEnum["MOP"] = 'MOP'] = "MOP";
        OrderCurrencyEnum[OrderCurrencyEnum["TWD"] = 'TWD'] = "TWD";
        OrderCurrencyEnum[OrderCurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(OrderCurrencyEnum = PayoutRefund.OrderCurrencyEnum || (PayoutRefund.OrderCurrencyEnum = {}));
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum[OrderTypeEnum["Cash"] = 'Cash'] = "Cash";
        OrderTypeEnum[OrderTypeEnum["Online"] = 'Online'] = "Online";
    })(OrderTypeEnum = PayoutRefund.OrderTypeEnum || (PayoutRefund.OrderTypeEnum = {}));
})(PayoutRefund = exports.PayoutRefund || (exports.PayoutRefund = {}));
exports.PayoutRefund = PayoutRefund;
var PayoutRequestIds = (function () {
    function PayoutRequestIds() {
    }
    PayoutRequestIds.getAttributeTypeMap = function () {
        return PayoutRequestIds.attributeTypeMap;
    };
    PayoutRequestIds.discriminator = undefined;
    PayoutRequestIds.attributeTypeMap = [
        {
            "name": "BankAccountIds",
            "baseName": "BankAccountIds",
            "type": "Array<number>"
        },
        {
            "name": "States",
            "baseName": "States",
            "type": "Array<PayoutRequestIds.StatesEnum>"
        }
    ];
    return PayoutRequestIds;
}());
exports.PayoutRequestIds = PayoutRequestIds;
(function (PayoutRequestIds) {
    var StatesEnum;
    (function (StatesEnum) {
        StatesEnum[StatesEnum["Pending"] = 'Pending'] = "Pending";
        StatesEnum[StatesEnum["InTransit"] = 'InTransit'] = "InTransit";
        StatesEnum[StatesEnum["Paid"] = 'Paid'] = "Paid";
        StatesEnum[StatesEnum["Failed"] = 'Failed'] = "Failed";
        StatesEnum[StatesEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
    })(StatesEnum = PayoutRequestIds.StatesEnum || (PayoutRequestIds.StatesEnum = {}));
})(PayoutRequestIds = exports.PayoutRequestIds || (exports.PayoutRequestIds = {}));
exports.PayoutRequestIds = PayoutRequestIds;
var PayoutStore = (function () {
    function PayoutStore() {
    }
    PayoutStore.getAttributeTypeMap = function () {
        return PayoutStore.attributeTypeMap;
    };
    PayoutStore.discriminator = undefined;
    PayoutStore.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        },
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "OnlineRevenue",
            "baseName": "OnlineRevenue",
            "type": "RevenueDetail"
        },
        {
            "name": "Revenue",
            "baseName": "Revenue",
            "type": "RevenueDetail"
        },
        {
            "name": "RevenueAdjustments",
            "baseName": "RevenueAdjustments",
            "type": "RevenueAdjustmentsDetails"
        },
        {
            "name": "FlipdishFees",
            "baseName": "FlipdishFees",
            "type": "FlipdishFeesDetails"
        },
        {
            "name": "Chargebacks",
            "baseName": "Chargebacks",
            "type": "ChargebackDetails"
        },
        {
            "name": "OtherCharges",
            "baseName": "OtherCharges",
            "type": "OtherChargesDetails"
        },
        {
            "name": "Balance",
            "baseName": "Balance",
            "type": "BalanceDetails"
        },
        {
            "name": "PosRevenue",
            "baseName": "PosRevenue",
            "type": "PosRevenueDetails"
        }
    ];
    return PayoutStore;
}());
exports.PayoutStore = PayoutStore;
var PayoutSummary = (function () {
    function PayoutSummary() {
    }
    PayoutSummary.getAttributeTypeMap = function () {
        return PayoutSummary.attributeTypeMap;
    };
    PayoutSummary.discriminator = undefined;
    PayoutSummary.attributeTypeMap = [
        {
            "name": "PayoutStatus",
            "baseName": "PayoutStatus",
            "type": "PayoutSummary.PayoutStatusEnum"
        },
        {
            "name": "TotalAmount",
            "baseName": "TotalAmount",
            "type": "number"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "PayoutSummary.CurrencyEnum"
        },
        {
            "name": "TotalCount",
            "baseName": "TotalCount",
            "type": "number"
        }
    ];
    return PayoutSummary;
}());
exports.PayoutSummary = PayoutSummary;
(function (PayoutSummary) {
    var PayoutStatusEnum;
    (function (PayoutStatusEnum) {
        PayoutStatusEnum[PayoutStatusEnum["Pending"] = 'Pending'] = "Pending";
        PayoutStatusEnum[PayoutStatusEnum["InTransit"] = 'InTransit'] = "InTransit";
        PayoutStatusEnum[PayoutStatusEnum["Paid"] = 'Paid'] = "Paid";
        PayoutStatusEnum[PayoutStatusEnum["Failed"] = 'Failed'] = "Failed";
        PayoutStatusEnum[PayoutStatusEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
    })(PayoutStatusEnum = PayoutSummary.PayoutStatusEnum || (PayoutSummary.PayoutStatusEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = PayoutSummary.CurrencyEnum || (PayoutSummary.CurrencyEnum = {}));
})(PayoutSummary = exports.PayoutSummary || (exports.PayoutSummary = {}));
exports.PayoutSummary = PayoutSummary;
var PendingMenuChanges = (function () {
    function PendingMenuChanges() {
    }
    PendingMenuChanges.getAttributeTypeMap = function () {
        return PendingMenuChanges.attributeTypeMap;
    };
    PendingMenuChanges.discriminator = undefined;
    PendingMenuChanges.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        }
    ];
    return PendingMenuChanges;
}());
exports.PendingMenuChanges = PendingMenuChanges;
var PendingMenuChangesSummaries = (function () {
    function PendingMenuChangesSummaries() {
    }
    PendingMenuChangesSummaries.getAttributeTypeMap = function () {
        return PendingMenuChangesSummaries.attributeTypeMap;
    };
    PendingMenuChangesSummaries.discriminator = undefined;
    PendingMenuChangesSummaries.attributeTypeMap = [
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "TotalPendingChanges",
            "baseName": "TotalPendingChanges",
            "type": "number"
        }
    ];
    return PendingMenuChangesSummaries;
}());
exports.PendingMenuChangesSummaries = PendingMenuChangesSummaries;
var PercentDiscountDetails = (function () {
    function PercentDiscountDetails() {
    }
    PercentDiscountDetails.getAttributeTypeMap = function () {
        return PercentDiscountDetails.attributeTypeMap;
    };
    PercentDiscountDetails.discriminator = undefined;
    PercentDiscountDetails.attributeTypeMap = [
        {
            "name": "PercentageDiscount",
            "baseName": "PercentageDiscount",
            "type": "number"
        }
    ];
    return PercentDiscountDetails;
}());
exports.PercentDiscountDetails = PercentDiscountDetails;
var PhoneCall = (function () {
    function PhoneCall() {
    }
    PhoneCall.getAttributeTypeMap = function () {
        return PhoneCall.attributeTypeMap;
    };
    PhoneCall.discriminator = undefined;
    PhoneCall.attributeTypeMap = [
        {
            "name": "PhoneCallId",
            "baseName": "PhoneCallId",
            "type": "number"
        },
        {
            "name": "TimeOfCall",
            "baseName": "TimeOfCall",
            "type": "Date"
        },
        {
            "name": "TimeOfCallLocal",
            "baseName": "TimeOfCallLocal",
            "type": "Date"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        },
        {
            "name": "CallerName",
            "baseName": "CallerName",
            "type": "string"
        },
        {
            "name": "CallerUserId",
            "baseName": "CallerUserId",
            "type": "number"
        },
        {
            "name": "CallerNumber",
            "baseName": "CallerNumber",
            "type": "string"
        },
        {
            "name": "CallLengthInSeconds",
            "baseName": "CallLengthInSeconds",
            "type": "number"
        },
        {
            "name": "CallStatus",
            "baseName": "CallStatus",
            "type": "PhoneCall.CallStatusEnum"
        }
    ];
    return PhoneCall;
}());
exports.PhoneCall = PhoneCall;
(function (PhoneCall) {
    var CallStatusEnum;
    (function (CallStatusEnum) {
        CallStatusEnum[CallStatusEnum["Queued"] = 'Queued'] = "Queued";
        CallStatusEnum[CallStatusEnum["Ringing"] = 'Ringing'] = "Ringing";
        CallStatusEnum[CallStatusEnum["InProgress"] = 'InProgress'] = "InProgress";
        CallStatusEnum[CallStatusEnum["Completed"] = 'Completed'] = "Completed";
        CallStatusEnum[CallStatusEnum["Failed"] = 'Failed'] = "Failed";
        CallStatusEnum[CallStatusEnum["Busy"] = 'Busy'] = "Busy";
        CallStatusEnum[CallStatusEnum["NoAnswer"] = 'NoAnswer'] = "NoAnswer";
        CallStatusEnum[CallStatusEnum["Unknown"] = 'Unknown'] = "Unknown";
        CallStatusEnum[CallStatusEnum["Canceled"] = 'Canceled'] = "Canceled";
    })(CallStatusEnum = PhoneCall.CallStatusEnum || (PhoneCall.CallStatusEnum = {}));
})(PhoneCall = exports.PhoneCall || (exports.PhoneCall = {}));
exports.PhoneCall = PhoneCall;
var PhoneCallEndedEvent = (function () {
    function PhoneCallEndedEvent() {
    }
    PhoneCallEndedEvent.getAttributeTypeMap = function () {
        return PhoneCallEndedEvent.attributeTypeMap;
    };
    PhoneCallEndedEvent.discriminator = undefined;
    PhoneCallEndedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "PhoneCall",
            "baseName": "PhoneCall",
            "type": "PhoneCall"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PhoneCallEndedEvent;
}());
exports.PhoneCallEndedEvent = PhoneCallEndedEvent;
var PhoneCallStartedEvent = (function () {
    function PhoneCallStartedEvent() {
    }
    PhoneCallStartedEvent.getAttributeTypeMap = function () {
        return PhoneCallStartedEvent.attributeTypeMap;
    };
    PhoneCallStartedEvent.discriminator = undefined;
    PhoneCallStartedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "PhoneCall",
            "baseName": "PhoneCall",
            "type": "PhoneCall"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PhoneCallStartedEvent;
}());
exports.PhoneCallStartedEvent = PhoneCallStartedEvent;
var PosRevenueDetails = (function () {
    function PosRevenueDetails() {
    }
    PosRevenueDetails.getAttributeTypeMap = function () {
        return PosRevenueDetails.attributeTypeMap;
    };
    PosRevenueDetails.discriminator = undefined;
    PosRevenueDetails.attributeTypeMap = [
        {
            "name": "PosSalesAmount",
            "baseName": "PosSalesAmount",
            "type": "number"
        },
        {
            "name": "PosSalesTax",
            "baseName": "PosSalesTax",
            "type": "number"
        },
        {
            "name": "PosSalesTips",
            "baseName": "PosSalesTips",
            "type": "number"
        },
        {
            "name": "TotalPosRevenue",
            "baseName": "TotalPosRevenue",
            "type": "number"
        }
    ];
    return PosRevenueDetails;
}());
exports.PosRevenueDetails = PosRevenueDetails;
var PreOrderConfig = (function () {
    function PreOrderConfig() {
    }
    PreOrderConfig.getAttributeTypeMap = function () {
        return PreOrderConfig.attributeTypeMap;
    };
    PreOrderConfig.discriminator = undefined;
    PreOrderConfig.attributeTypeMap = [
        {
            "name": "LeadTimeMinutes",
            "baseName": "LeadTimeMinutes",
            "type": "number"
        },
        {
            "name": "IntervalMinutes",
            "baseName": "IntervalMinutes",
            "type": "number"
        },
        {
            "name": "MaxOrderAheadDays",
            "baseName": "MaxOrderAheadDays",
            "type": "number"
        },
        {
            "name": "IncludeAsap",
            "baseName": "IncludeAsap",
            "type": "boolean"
        },
        {
            "name": "IncludeMoreGranularInitialTime",
            "baseName": "IncludeMoreGranularInitialTime",
            "type": "boolean"
        },
        {
            "name": "CutOffTimePreviousDayBasic",
            "baseName": "CutOffTimePreviousDayBasic",
            "type": "string"
        },
        {
            "name": "CutOffTimeCurrentDayBasic",
            "baseName": "CutOffTimeCurrentDayBasic",
            "type": "string"
        },
        {
            "name": "PreOrderTimeDisplayType",
            "baseName": "PreOrderTimeDisplayType",
            "type": "PreOrderConfig.PreOrderTimeDisplayTypeEnum"
        },
        {
            "name": "AlwaysAppearOpen",
            "baseName": "AlwaysAppearOpen",
            "type": "boolean"
        },
        {
            "name": "RequireExplicitSelectAlways",
            "baseName": "RequireExplicitSelectAlways",
            "type": "boolean"
        }
    ];
    return PreOrderConfig;
}());
exports.PreOrderConfig = PreOrderConfig;
(function (PreOrderConfig) {
    var PreOrderTimeDisplayTypeEnum;
    (function (PreOrderTimeDisplayTypeEnum) {
        PreOrderTimeDisplayTypeEnum[PreOrderTimeDisplayTypeEnum["SingleTime"] = 'SingleTime'] = "SingleTime";
        PreOrderTimeDisplayTypeEnum[PreOrderTimeDisplayTypeEnum["StartAndEndTime"] = 'StartAndEndTime'] = "StartAndEndTime";
        PreOrderTimeDisplayTypeEnum[PreOrderTimeDisplayTypeEnum["DayOnly"] = 'DayOnly'] = "DayOnly";
    })(PreOrderTimeDisplayTypeEnum = PreOrderConfig.PreOrderTimeDisplayTypeEnum || (PreOrderConfig.PreOrderTimeDisplayTypeEnum = {}));
})(PreOrderConfig = exports.PreOrderConfig || (exports.PreOrderConfig = {}));
exports.PreOrderConfig = PreOrderConfig;
var PreOrderTime = (function () {
    function PreOrderTime() {
    }
    PreOrderTime.getAttributeTypeMap = function () {
        return PreOrderTime.attributeTypeMap;
    };
    PreOrderTime.discriminator = undefined;
    PreOrderTime.attributeTypeMap = [
        {
            "name": "StartTime",
            "baseName": "StartTime",
            "type": "Date"
        },
        {
            "name": "EndTime",
            "baseName": "EndTime",
            "type": "Date"
        }
    ];
    return PreOrderTime;
}());
exports.PreOrderTime = PreOrderTime;
var PredefinedAnswer = (function () {
    function PredefinedAnswer() {
    }
    PredefinedAnswer.getAttributeTypeMap = function () {
        return PredefinedAnswer.attributeTypeMap;
    };
    PredefinedAnswer.discriminator = undefined;
    PredefinedAnswer.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "Text",
            "baseName": "Text",
            "type": "string"
        }
    ];
    return PredefinedAnswer;
}());
exports.PredefinedAnswer = PredefinedAnswer;
var PreviousOrder = (function () {
    function PreviousOrder() {
    }
    PreviousOrder.getAttributeTypeMap = function () {
        return PreviousOrder.attributeTypeMap;
    };
    PreviousOrder.discriminator = undefined;
    PreviousOrder.attributeTypeMap = [
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "string"
        },
        {
            "name": "DeliveryLocationAddressString",
            "baseName": "DeliveryLocationAddressString",
            "type": "string"
        },
        {
            "name": "PaymentAccountType",
            "baseName": "PaymentAccountType",
            "type": "string"
        },
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "RestaurantName",
            "baseName": "RestaurantName",
            "type": "string"
        },
        {
            "name": "LocalOrderId",
            "baseName": "LocalOrderId",
            "type": "string"
        },
        {
            "name": "TableServiceCategory",
            "baseName": "TableServiceCategory",
            "type": "string"
        },
        {
            "name": "PickupLocationOptionValue",
            "baseName": "PickupLocationOptionValue",
            "type": "string"
        },
        {
            "name": "CustomerName",
            "baseName": "CustomerName",
            "type": "string"
        },
        {
            "name": "PhoneNumberInternationalFormatString",
            "baseName": "PhoneNumberInternationalFormatString",
            "type": "string"
        },
        {
            "name": "DeliveryInstructions",
            "baseName": "DeliveryInstructions",
            "type": "string"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "PreviousOrder.CurrencyEnum"
        },
        {
            "name": "ProcessingFee",
            "baseName": "ProcessingFee",
            "type": "number"
        },
        {
            "name": "ServiceChargePercentage",
            "baseName": "ServiceChargePercentage",
            "type": "number"
        },
        {
            "name": "ServiceChargeAmount",
            "baseName": "ServiceChargeAmount",
            "type": "number"
        },
        {
            "name": "TipAmount",
            "baseName": "TipAmount",
            "type": "number"
        },
        {
            "name": "DeliveryAmount",
            "baseName": "DeliveryAmount",
            "type": "number"
        },
        {
            "name": "TotalTax",
            "baseName": "TotalTax",
            "type": "number"
        },
        {
            "name": "TotalAmount",
            "baseName": "TotalAmount",
            "type": "number"
        },
        {
            "name": "Items",
            "baseName": "Items",
            "type": "Array<PreviousOrderItem>"
        },
        {
            "name": "TaxRates",
            "baseName": "TaxRates",
            "type": "Array<TaxRate>"
        },
        {
            "name": "WhiteLabelId",
            "baseName": "WhiteLabelId",
            "type": "number"
        }
    ];
    return PreviousOrder;
}());
exports.PreviousOrder = PreviousOrder;
(function (PreviousOrder) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = PreviousOrder.CurrencyEnum || (PreviousOrder.CurrencyEnum = {}));
})(PreviousOrder = exports.PreviousOrder || (exports.PreviousOrder = {}));
exports.PreviousOrder = PreviousOrder;
var PreviousOrderItem = (function () {
    function PreviousOrderItem() {
    }
    PreviousOrderItem.getAttributeTypeMap = function () {
        return PreviousOrderItem.attributeTypeMap;
    };
    PreviousOrderItem.discriminator = undefined;
    PreviousOrderItem.attributeTypeMap = [
        {
            "name": "MenuSectionDisplayOrder",
            "baseName": "MenuSectionDisplayOrder",
            "type": "number"
        },
        {
            "name": "MenuSectionName",
            "baseName": "MenuSectionName",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "PriceIncludingOptionSetItems",
            "baseName": "PriceIncludingOptionSetItems",
            "type": "number"
        },
        {
            "name": "TaxAmount",
            "baseName": "TaxAmount",
            "type": "number"
        },
        {
            "name": "PreviousOrderItemOptions",
            "baseName": "PreviousOrderItemOptions",
            "type": "Array<PreviousOrderItemOption>"
        }
    ];
    return PreviousOrderItem;
}());
exports.PreviousOrderItem = PreviousOrderItem;
var PreviousOrderItemOption = (function () {
    function PreviousOrderItemOption() {
    }
    PreviousOrderItemOption.getAttributeTypeMap = function () {
        return PreviousOrderItemOption.attributeTypeMap;
    };
    PreviousOrderItemOption.discriminator = undefined;
    PreviousOrderItemOption.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return PreviousOrderItemOption;
}());
exports.PreviousOrderItemOption = PreviousOrderItemOption;
var Price = (function () {
    function Price() {
    }
    Price.getAttributeTypeMap = function () {
        return Price.attributeTypeMap;
    };
    Price.discriminator = undefined;
    Price.attributeTypeMap = [
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "Tax",
            "baseName": "Tax",
            "type": "number"
        }
    ];
    return Price;
}());
exports.Price = Price;
var Printer = (function () {
    function Printer() {
    }
    Printer.getAttributeTypeMap = function () {
        return Printer.attributeTypeMap;
    };
    Printer.discriminator = undefined;
    Printer.attributeTypeMap = [
        {
            "name": "SerialNumber",
            "baseName": "SerialNumber",
            "type": "string"
        },
        {
            "name": "LastPollTime",
            "baseName": "LastPollTime",
            "type": "Date"
        }
    ];
    return Printer;
}());
exports.Printer = Printer;
var PrinterAssignedToStoreEvent = (function () {
    function PrinterAssignedToStoreEvent() {
    }
    PrinterAssignedToStoreEvent.getAttributeTypeMap = function () {
        return PrinterAssignedToStoreEvent.attributeTypeMap;
    };
    PrinterAssignedToStoreEvent.discriminator = undefined;
    PrinterAssignedToStoreEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Printer",
            "baseName": "Printer",
            "type": "Printer"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PrinterAssignedToStoreEvent;
}());
exports.PrinterAssignedToStoreEvent = PrinterAssignedToStoreEvent;
var PrinterTurnedOffEvent = (function () {
    function PrinterTurnedOffEvent() {
    }
    PrinterTurnedOffEvent.getAttributeTypeMap = function () {
        return PrinterTurnedOffEvent.attributeTypeMap;
    };
    PrinterTurnedOffEvent.discriminator = undefined;
    PrinterTurnedOffEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Printer",
            "baseName": "Printer",
            "type": "Printer"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PrinterTurnedOffEvent;
}());
exports.PrinterTurnedOffEvent = PrinterTurnedOffEvent;
var PrinterTurnedOnEvent = (function () {
    function PrinterTurnedOnEvent() {
    }
    PrinterTurnedOnEvent.getAttributeTypeMap = function () {
        return PrinterTurnedOnEvent.attributeTypeMap;
    };
    PrinterTurnedOnEvent.discriminator = undefined;
    PrinterTurnedOnEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Printer",
            "baseName": "Printer",
            "type": "Printer"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PrinterTurnedOnEvent;
}());
exports.PrinterTurnedOnEvent = PrinterTurnedOnEvent;
var PrinterUnassignedFromStoreEvent = (function () {
    function PrinterUnassignedFromStoreEvent() {
    }
    PrinterUnassignedFromStoreEvent.getAttributeTypeMap = function () {
        return PrinterUnassignedFromStoreEvent.attributeTypeMap;
    };
    PrinterUnassignedFromStoreEvent.discriminator = undefined;
    PrinterUnassignedFromStoreEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Printer",
            "baseName": "Printer",
            "type": "Printer"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PrinterUnassignedFromStoreEvent;
}());
exports.PrinterUnassignedFromStoreEvent = PrinterUnassignedFromStoreEvent;
var ProcessPaymentIntentRequest = (function () {
    function ProcessPaymentIntentRequest() {
    }
    ProcessPaymentIntentRequest.getAttributeTypeMap = function () {
        return ProcessPaymentIntentRequest.attributeTypeMap;
    };
    ProcessPaymentIntentRequest.discriminator = undefined;
    ProcessPaymentIntentRequest.attributeTypeMap = [
        {
            "name": "PaymentIntentId",
            "baseName": "PaymentIntentId",
            "type": "string"
        }
    ];
    return ProcessPaymentIntentRequest;
}());
exports.ProcessPaymentIntentRequest = ProcessPaymentIntentRequest;
var ProcessingFeeConfig = (function () {
    function ProcessingFeeConfig() {
    }
    ProcessingFeeConfig.getAttributeTypeMap = function () {
        return ProcessingFeeConfig.attributeTypeMap;
    };
    ProcessingFeeConfig.discriminator = undefined;
    ProcessingFeeConfig.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "PaymentAccountType",
            "baseName": "PaymentAccountType",
            "type": "ProcessingFeeConfig.PaymentAccountTypeEnum"
        },
        {
            "name": "PercentFee",
            "baseName": "PercentFee",
            "type": "number"
        },
        {
            "name": "FixedFee",
            "baseName": "FixedFee",
            "type": "number"
        }
    ];
    return ProcessingFeeConfig;
}());
exports.ProcessingFeeConfig = ProcessingFeeConfig;
(function (ProcessingFeeConfig) {
    var PaymentAccountTypeEnum;
    (function (PaymentAccountTypeEnum) {
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Card"] = 'Card'] = "Card";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Cash"] = 'Cash'] = "Cash";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Ideal"] = 'Ideal'] = "Ideal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Bancontact"] = 'Bancontact'] = "Bancontact";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Giropay"] = 'Giropay'] = "Giropay";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Eps"] = 'Eps'] = "Eps";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Emv"] = 'Emv'] = "Emv";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayPal"] = 'PayPal'] = "PayPal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayGreen"] = 'PayGreen'] = "PayGreen";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["GoogleWalletToken"] = 'GoogleWalletToken'] = "GoogleWalletToken";
    })(PaymentAccountTypeEnum = ProcessingFeeConfig.PaymentAccountTypeEnum || (ProcessingFeeConfig.PaymentAccountTypeEnum = {}));
})(ProcessingFeeConfig = exports.ProcessingFeeConfig || (exports.ProcessingFeeConfig = {}));
exports.ProcessingFeeConfig = ProcessingFeeConfig;
var Product = (function () {
    function Product() {
    }
    Product.getAttributeTypeMap = function () {
        return Product.attributeTypeMap;
    };
    Product.discriminator = undefined;
    Product.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "IsArchived",
            "baseName": "IsArchived",
            "type": "boolean"
        },
        {
            "name": "Groups",
            "baseName": "Groups",
            "type": "Array<GroupReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        },
        {
            "name": "ProductType",
            "baseName": "ProductType",
            "type": "Product.ProductTypeEnum"
        },
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        }
    ];
    return Product;
}());
exports.Product = Product;
(function (Product) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = Product.ProductTypeEnum || (Product.ProductTypeEnum = {}));
})(Product = exports.Product || (exports.Product = {}));
exports.Product = Product;
var ProductReference = (function () {
    function ProductReference() {
    }
    ProductReference.getAttributeTypeMap = function () {
        return ProductReference.attributeTypeMap;
    };
    ProductReference.discriminator = undefined;
    ProductReference.attributeTypeMap = [
        {
            "name": "Item",
            "baseName": "Item",
            "type": "Product"
        },
        {
            "name": "Product",
            "baseName": "Product",
            "type": "Product"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "ProductType",
            "baseName": "ProductType",
            "type": "ProductReference.ProductTypeEnum"
        },
        {
            "name": "PreselectedQuantity",
            "baseName": "PreselectedQuantity",
            "type": "number"
        }
    ];
    return ProductReference;
}());
exports.ProductReference = ProductReference;
(function (ProductReference) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = ProductReference.ProductTypeEnum || (ProductReference.ProductTypeEnum = {}));
})(ProductReference = exports.ProductReference || (exports.ProductReference = {}));
exports.ProductReference = ProductReference;
var PublishMenuChanges = (function () {
    function PublishMenuChanges() {
    }
    PublishMenuChanges.getAttributeTypeMap = function () {
        return PublishMenuChanges.attributeTypeMap;
    };
    PublishMenuChanges.discriminator = undefined;
    PublishMenuChanges.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "MenuIds",
            "baseName": "MenuIds",
            "type": "Array<number>"
        }
    ];
    return PublishMenuChanges;
}());
exports.PublishMenuChanges = PublishMenuChanges;
var PushNotificationDeletedEvent = (function () {
    function PushNotificationDeletedEvent() {
    }
    PushNotificationDeletedEvent.getAttributeTypeMap = function () {
        return PushNotificationDeletedEvent.attributeTypeMap;
    };
    PushNotificationDeletedEvent.discriminator = undefined;
    PushNotificationDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "PushNotification",
            "baseName": "PushNotification",
            "type": "PushNotificationRequest"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PushNotificationDeletedEvent;
}());
exports.PushNotificationDeletedEvent = PushNotificationDeletedEvent;
var PushNotificationRequest = (function () {
    function PushNotificationRequest() {
    }
    PushNotificationRequest.getAttributeTypeMap = function () {
        return PushNotificationRequest.attributeTypeMap;
    };
    PushNotificationRequest.discriminator = undefined;
    PushNotificationRequest.attributeTypeMap = [
        {
            "name": "ScheduledTime",
            "baseName": "ScheduledTime",
            "type": "Date"
        },
        {
            "name": "Title",
            "baseName": "Title",
            "type": "string"
        },
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        }
    ];
    return PushNotificationRequest;
}());
exports.PushNotificationRequest = PushNotificationRequest;
var PushNotificationResponse = (function () {
    function PushNotificationResponse() {
    }
    PushNotificationResponse.getAttributeTypeMap = function () {
        return PushNotificationResponse.attributeTypeMap;
    };
    PushNotificationResponse.discriminator = undefined;
    PushNotificationResponse.attributeTypeMap = [
        {
            "name": "Sent",
            "baseName": "Sent",
            "type": "boolean"
        },
        {
            "name": "ScheduledPushNotificationId",
            "baseName": "ScheduledPushNotificationId",
            "type": "number"
        },
        {
            "name": "ScheduledTime",
            "baseName": "ScheduledTime",
            "type": "Date"
        },
        {
            "name": "Title",
            "baseName": "Title",
            "type": "string"
        },
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        }
    ];
    return PushNotificationResponse;
}());
exports.PushNotificationResponse = PushNotificationResponse;
var PushNotificationScheduledEvent = (function () {
    function PushNotificationScheduledEvent() {
    }
    PushNotificationScheduledEvent.getAttributeTypeMap = function () {
        return PushNotificationScheduledEvent.attributeTypeMap;
    };
    PushNotificationScheduledEvent.discriminator = undefined;
    PushNotificationScheduledEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "PushNotification",
            "baseName": "PushNotification",
            "type": "PushNotificationRequest"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PushNotificationScheduledEvent;
}());
exports.PushNotificationScheduledEvent = PushNotificationScheduledEvent;
var PushNotificationSentEvent = (function () {
    function PushNotificationSentEvent() {
    }
    PushNotificationSentEvent.getAttributeTypeMap = function () {
        return PushNotificationSentEvent.attributeTypeMap;
    };
    PushNotificationSentEvent.discriminator = undefined;
    PushNotificationSentEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "PushNotification",
            "baseName": "PushNotification",
            "type": "PushNotificationRequest"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return PushNotificationSentEvent;
}());
exports.PushNotificationSentEvent = PushNotificationSentEvent;
var Range = (function () {
    function Range() {
    }
    Range.getAttributeTypeMap = function () {
        return Range.attributeTypeMap;
    };
    Range.discriminator = undefined;
    Range.attributeTypeMap = [
        {
            "name": "StartTime",
            "baseName": "StartTime",
            "type": "string"
        },
        {
            "name": "Period",
            "baseName": "Period",
            "type": "string"
        },
        {
            "name": "DayOfWeek",
            "baseName": "DayOfWeek",
            "type": "Range.DayOfWeekEnum"
        }
    ];
    return Range;
}());
exports.Range = Range;
(function (Range) {
    var DayOfWeekEnum;
    (function (DayOfWeekEnum) {
        DayOfWeekEnum[DayOfWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfWeekEnum[DayOfWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfWeekEnum[DayOfWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfWeekEnum[DayOfWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfWeekEnum[DayOfWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfWeekEnum[DayOfWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfWeekEnum[DayOfWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfWeekEnum = Range.DayOfWeekEnum || (Range.DayOfWeekEnum = {}));
})(Range = exports.Range || (exports.Range = {}));
exports.Range = Range;
var ReaderActionStateInfo = (function () {
    function ReaderActionStateInfo() {
    }
    ReaderActionStateInfo.getAttributeTypeMap = function () {
        return ReaderActionStateInfo.attributeTypeMap;
    };
    ReaderActionStateInfo.discriminator = undefined;
    ReaderActionStateInfo.attributeTypeMap = [
        {
            "name": "ActionState",
            "baseName": "ActionState",
            "type": "string"
        },
        {
            "name": "FailureCode",
            "baseName": "FailureCode",
            "type": "string"
        },
        {
            "name": "FailureMessage",
            "baseName": "FailureMessage",
            "type": "string"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "string"
        }
    ];
    return ReaderActionStateInfo;
}());
exports.ReaderActionStateInfo = ReaderActionStateInfo;
var RedeemInvitationResult = (function () {
    function RedeemInvitationResult() {
    }
    RedeemInvitationResult.getAttributeTypeMap = function () {
        return RedeemInvitationResult.attributeTypeMap;
    };
    RedeemInvitationResult.discriminator = undefined;
    RedeemInvitationResult.attributeTypeMap = [
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "InvitationStatus",
            "baseName": "InvitationStatus",
            "type": "RedeemInvitationResult.InvitationStatusEnum"
        }
    ];
    return RedeemInvitationResult;
}());
exports.RedeemInvitationResult = RedeemInvitationResult;
(function (RedeemInvitationResult) {
    var InvitationStatusEnum;
    (function (InvitationStatusEnum) {
        InvitationStatusEnum[InvitationStatusEnum["Pending"] = 'Pending'] = "Pending";
        InvitationStatusEnum[InvitationStatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        InvitationStatusEnum[InvitationStatusEnum["Expired"] = 'Expired'] = "Expired";
    })(InvitationStatusEnum = RedeemInvitationResult.InvitationStatusEnum || (RedeemInvitationResult.InvitationStatusEnum = {}));
})(RedeemInvitationResult = exports.RedeemInvitationResult || (exports.RedeemInvitationResult = {}));
exports.RedeemInvitationResult = RedeemInvitationResult;
var Refund = (function () {
    function Refund() {
    }
    Refund.getAttributeTypeMap = function () {
        return Refund.attributeTypeMap;
    };
    Refund.discriminator = undefined;
    Refund.attributeTypeMap = [
        {
            "name": "RefundReason",
            "baseName": "RefundReason",
            "type": "string"
        },
        {
            "name": "RefundAmount",
            "baseName": "RefundAmount",
            "type": "number"
        },
        {
            "name": "NotifyCustomer",
            "baseName": "NotifyCustomer",
            "type": "boolean"
        }
    ];
    return Refund;
}());
exports.Refund = Refund;
var Reject = (function () {
    function Reject() {
    }
    Reject.getAttributeTypeMap = function () {
        return Reject.attributeTypeMap;
    };
    Reject.discriminator = undefined;
    Reject.attributeTypeMap = [
        {
            "name": "RejectReason",
            "baseName": "RejectReason",
            "type": "Reject.RejectReasonEnum"
        },
        {
            "name": "DoNotNotifyCustomer",
            "baseName": "DoNotNotifyCustomer",
            "type": "boolean"
        }
    ];
    return Reject;
}());
exports.Reject = Reject;
(function (Reject) {
    var RejectReasonEnum;
    (function (RejectReasonEnum) {
        RejectReasonEnum[RejectReasonEnum["TooBusy"] = 'TooBusy'] = "TooBusy";
        RejectReasonEnum[RejectReasonEnum["FoodUnavailable"] = 'FoodUnavailable'] = "FoodUnavailable";
        RejectReasonEnum[RejectReasonEnum["UnableToDeliver"] = 'UnableToDeliver'] = "UnableToDeliver";
        RejectReasonEnum[RejectReasonEnum["UnknownAddress"] = 'UnknownAddress'] = "UnknownAddress";
        RejectReasonEnum[RejectReasonEnum["UnknownReason"] = 'UnknownReason'] = "UnknownReason";
        RejectReasonEnum[RejectReasonEnum["TooSoon"] = 'TooSoon'] = "TooSoon";
        RejectReasonEnum[RejectReasonEnum["TimeUnavailable"] = 'TimeUnavailable'] = "TimeUnavailable";
        RejectReasonEnum[RejectReasonEnum["DontDeliverToArea"] = 'DontDeliverToArea'] = "DontDeliverToArea";
        RejectReasonEnum[RejectReasonEnum["StoreUncontactable"] = 'StoreUncontactable'] = "StoreUncontactable";
    })(RejectReasonEnum = Reject.RejectReasonEnum || (Reject.RejectReasonEnum = {}));
})(Reject = exports.Reject || (exports.Reject = {}));
exports.Reject = Reject;
var RequestLoginPinModel = (function () {
    function RequestLoginPinModel() {
    }
    RequestLoginPinModel.getAttributeTypeMap = function () {
        return RequestLoginPinModel.attributeTypeMap;
    };
    RequestLoginPinModel.discriminator = undefined;
    RequestLoginPinModel.attributeTypeMap = [
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        }
    ];
    return RequestLoginPinModel;
}());
exports.RequestLoginPinModel = RequestLoginPinModel;
var RequestLoginPinResponse = (function () {
    function RequestLoginPinResponse() {
    }
    RequestLoginPinResponse.getAttributeTypeMap = function () {
        return RequestLoginPinResponse.attributeTypeMap;
    };
    RequestLoginPinResponse.discriminator = undefined;
    RequestLoginPinResponse.attributeTypeMap = [
        {
            "name": "LoginPinSentViaEmail",
            "baseName": "LoginPinSentViaEmail",
            "type": "boolean"
        },
        {
            "name": "ForceOktaLogin",
            "baseName": "ForceOktaLogin",
            "type": "boolean"
        }
    ];
    return RequestLoginPinResponse;
}());
exports.RequestLoginPinResponse = RequestLoginPinResponse;
var RequestPasswordResetModel = (function () {
    function RequestPasswordResetModel() {
    }
    RequestPasswordResetModel.getAttributeTypeMap = function () {
        return RequestPasswordResetModel.attributeTypeMap;
    };
    RequestPasswordResetModel.discriminator = undefined;
    RequestPasswordResetModel.attributeTypeMap = [
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "RecaptchaToken",
            "baseName": "RecaptchaToken",
            "type": "string"
        }
    ];
    return RequestPasswordResetModel;
}());
exports.RequestPasswordResetModel = RequestPasswordResetModel;
var RequestPasswordResetPinResponse = (function () {
    function RequestPasswordResetPinResponse() {
    }
    RequestPasswordResetPinResponse.getAttributeTypeMap = function () {
        return RequestPasswordResetPinResponse.attributeTypeMap;
    };
    RequestPasswordResetPinResponse.discriminator = undefined;
    RequestPasswordResetPinResponse.attributeTypeMap = [
        {
            "name": "PasswordResetPinSentViaEmail",
            "baseName": "PasswordResetPinSentViaEmail",
            "type": "boolean"
        }
    ];
    return RequestPasswordResetPinResponse;
}());
exports.RequestPasswordResetPinResponse = RequestPasswordResetPinResponse;
var Response = (function () {
    function Response() {
    }
    Response.getAttributeTypeMap = function () {
        return Response.attributeTypeMap;
    };
    Response.discriminator = undefined;
    Response.attributeTypeMap = [
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<StoreItemHeader>"
        }
    ];
    return Response;
}());
exports.Response = Response;
var RestApiArrayResultAllMetadataResult = (function () {
    function RestApiArrayResultAllMetadataResult() {
    }
    RestApiArrayResultAllMetadataResult.getAttributeTypeMap = function () {
        return RestApiArrayResultAllMetadataResult.attributeTypeMap;
    };
    RestApiArrayResultAllMetadataResult.discriminator = undefined;
    RestApiArrayResultAllMetadataResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<AllMetadataResult>"
        }
    ];
    return RestApiArrayResultAllMetadataResult;
}());
exports.RestApiArrayResultAllMetadataResult = RestApiArrayResultAllMetadataResult;
var RestApiArrayResultAllergen = (function () {
    function RestApiArrayResultAllergen() {
    }
    RestApiArrayResultAllergen.getAttributeTypeMap = function () {
        return RestApiArrayResultAllergen.attributeTypeMap;
    };
    RestApiArrayResultAllergen.discriminator = undefined;
    RestApiArrayResultAllergen.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Allergen>"
        }
    ];
    return RestApiArrayResultAllergen;
}());
exports.RestApiArrayResultAllergen = RestApiArrayResultAllergen;
var RestApiArrayResultApmCurrencyDataPoint = (function () {
    function RestApiArrayResultApmCurrencyDataPoint() {
    }
    RestApiArrayResultApmCurrencyDataPoint.getAttributeTypeMap = function () {
        return RestApiArrayResultApmCurrencyDataPoint.attributeTypeMap;
    };
    RestApiArrayResultApmCurrencyDataPoint.discriminator = undefined;
    RestApiArrayResultApmCurrencyDataPoint.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<ApmCurrencyDataPoint>"
        }
    ];
    return RestApiArrayResultApmCurrencyDataPoint;
}());
exports.RestApiArrayResultApmCurrencyDataPoint = RestApiArrayResultApmCurrencyDataPoint;
var RestApiArrayResultApmDataPoint = (function () {
    function RestApiArrayResultApmDataPoint() {
    }
    RestApiArrayResultApmDataPoint.getAttributeTypeMap = function () {
        return RestApiArrayResultApmDataPoint.attributeTypeMap;
    };
    RestApiArrayResultApmDataPoint.discriminator = undefined;
    RestApiArrayResultApmDataPoint.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<ApmDataPoint>"
        }
    ];
    return RestApiArrayResultApmDataPoint;
}());
exports.RestApiArrayResultApmDataPoint = RestApiArrayResultApmDataPoint;
var RestApiArrayResultApmHourlyDataPoint = (function () {
    function RestApiArrayResultApmHourlyDataPoint() {
    }
    RestApiArrayResultApmHourlyDataPoint.getAttributeTypeMap = function () {
        return RestApiArrayResultApmHourlyDataPoint.attributeTypeMap;
    };
    RestApiArrayResultApmHourlyDataPoint.discriminator = undefined;
    RestApiArrayResultApmHourlyDataPoint.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<ApmHourlyDataPoint>"
        }
    ];
    return RestApiArrayResultApmHourlyDataPoint;
}());
exports.RestApiArrayResultApmHourlyDataPoint = RestApiArrayResultApmHourlyDataPoint;
var RestApiArrayResultAppStoreAppConfigurationHeader = (function () {
    function RestApiArrayResultAppStoreAppConfigurationHeader() {
    }
    RestApiArrayResultAppStoreAppConfigurationHeader.getAttributeTypeMap = function () {
        return RestApiArrayResultAppStoreAppConfigurationHeader.attributeTypeMap;
    };
    RestApiArrayResultAppStoreAppConfigurationHeader.discriminator = undefined;
    RestApiArrayResultAppStoreAppConfigurationHeader.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<AppStoreAppConfigurationHeader>"
        }
    ];
    return RestApiArrayResultAppStoreAppConfigurationHeader;
}());
exports.RestApiArrayResultAppStoreAppConfigurationHeader = RestApiArrayResultAppStoreAppConfigurationHeader;
var RestApiArrayResultAppStoreAppConfigurationSummary = (function () {
    function RestApiArrayResultAppStoreAppConfigurationSummary() {
    }
    RestApiArrayResultAppStoreAppConfigurationSummary.getAttributeTypeMap = function () {
        return RestApiArrayResultAppStoreAppConfigurationSummary.attributeTypeMap;
    };
    RestApiArrayResultAppStoreAppConfigurationSummary.discriminator = undefined;
    RestApiArrayResultAppStoreAppConfigurationSummary.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<AppStoreAppConfigurationSummary>"
        }
    ];
    return RestApiArrayResultAppStoreAppConfigurationSummary;
}());
exports.RestApiArrayResultAppStoreAppConfigurationSummary = RestApiArrayResultAppStoreAppConfigurationSummary;
var RestApiArrayResultBankAccountSummary = (function () {
    function RestApiArrayResultBankAccountSummary() {
    }
    RestApiArrayResultBankAccountSummary.getAttributeTypeMap = function () {
        return RestApiArrayResultBankAccountSummary.attributeTypeMap;
    };
    RestApiArrayResultBankAccountSummary.discriminator = undefined;
    RestApiArrayResultBankAccountSummary.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<BankAccountSummary>"
        }
    ];
    return RestApiArrayResultBankAccountSummary;
}());
exports.RestApiArrayResultBankAccountSummary = RestApiArrayResultBankAccountSummary;
var RestApiArrayResultBusinessHoursPeriod = (function () {
    function RestApiArrayResultBusinessHoursPeriod() {
    }
    RestApiArrayResultBusinessHoursPeriod.getAttributeTypeMap = function () {
        return RestApiArrayResultBusinessHoursPeriod.attributeTypeMap;
    };
    RestApiArrayResultBusinessHoursPeriod.discriminator = undefined;
    RestApiArrayResultBusinessHoursPeriod.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<BusinessHoursPeriod>"
        }
    ];
    return RestApiArrayResultBusinessHoursPeriod;
}());
exports.RestApiArrayResultBusinessHoursPeriod = RestApiArrayResultBusinessHoursPeriod;
var RestApiArrayResultChannel = (function () {
    function RestApiArrayResultChannel() {
    }
    RestApiArrayResultChannel.getAttributeTypeMap = function () {
        return RestApiArrayResultChannel.attributeTypeMap;
    };
    RestApiArrayResultChannel.discriminator = undefined;
    RestApiArrayResultChannel.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Channel>"
        }
    ];
    return RestApiArrayResultChannel;
}());
exports.RestApiArrayResultChannel = RestApiArrayResultChannel;
var RestApiArrayResultClientDeviceSummary = (function () {
    function RestApiArrayResultClientDeviceSummary() {
    }
    RestApiArrayResultClientDeviceSummary.getAttributeTypeMap = function () {
        return RestApiArrayResultClientDeviceSummary.attributeTypeMap;
    };
    RestApiArrayResultClientDeviceSummary.discriminator = undefined;
    RestApiArrayResultClientDeviceSummary.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<ClientDeviceSummary>"
        }
    ];
    return RestApiArrayResultClientDeviceSummary;
}());
exports.RestApiArrayResultClientDeviceSummary = RestApiArrayResultClientDeviceSummary;
var RestApiArrayResultCountryWithAccountFieldsDefinitions = (function () {
    function RestApiArrayResultCountryWithAccountFieldsDefinitions() {
    }
    RestApiArrayResultCountryWithAccountFieldsDefinitions.getAttributeTypeMap = function () {
        return RestApiArrayResultCountryWithAccountFieldsDefinitions.attributeTypeMap;
    };
    RestApiArrayResultCountryWithAccountFieldsDefinitions.discriminator = undefined;
    RestApiArrayResultCountryWithAccountFieldsDefinitions.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<CountryWithAccountFieldsDefinitions>"
        }
    ];
    return RestApiArrayResultCountryWithAccountFieldsDefinitions;
}());
exports.RestApiArrayResultCountryWithAccountFieldsDefinitions = RestApiArrayResultCountryWithAccountFieldsDefinitions;
var RestApiArrayResultDeliveryZone = (function () {
    function RestApiArrayResultDeliveryZone() {
    }
    RestApiArrayResultDeliveryZone.getAttributeTypeMap = function () {
        return RestApiArrayResultDeliveryZone.attributeTypeMap;
    };
    RestApiArrayResultDeliveryZone.discriminator = undefined;
    RestApiArrayResultDeliveryZone.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<DeliveryZone>"
        }
    ];
    return RestApiArrayResultDeliveryZone;
}());
exports.RestApiArrayResultDeliveryZone = RestApiArrayResultDeliveryZone;
var RestApiArrayResultEmvTerminalWithAssignments = (function () {
    function RestApiArrayResultEmvTerminalWithAssignments() {
    }
    RestApiArrayResultEmvTerminalWithAssignments.getAttributeTypeMap = function () {
        return RestApiArrayResultEmvTerminalWithAssignments.attributeTypeMap;
    };
    RestApiArrayResultEmvTerminalWithAssignments.discriminator = undefined;
    RestApiArrayResultEmvTerminalWithAssignments.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<EmvTerminalWithAssignments>"
        }
    ];
    return RestApiArrayResultEmvTerminalWithAssignments;
}());
exports.RestApiArrayResultEmvTerminalWithAssignments = RestApiArrayResultEmvTerminalWithAssignments;
var RestApiArrayResultFulfillmentStatesConfigurationSummary = (function () {
    function RestApiArrayResultFulfillmentStatesConfigurationSummary() {
    }
    RestApiArrayResultFulfillmentStatesConfigurationSummary.getAttributeTypeMap = function () {
        return RestApiArrayResultFulfillmentStatesConfigurationSummary.attributeTypeMap;
    };
    RestApiArrayResultFulfillmentStatesConfigurationSummary.discriminator = undefined;
    RestApiArrayResultFulfillmentStatesConfigurationSummary.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<FulfillmentStatesConfigurationSummary>"
        }
    ];
    return RestApiArrayResultFulfillmentStatesConfigurationSummary;
}());
exports.RestApiArrayResultFulfillmentStatesConfigurationSummary = RestApiArrayResultFulfillmentStatesConfigurationSummary;
var RestApiArrayResultHomeAction = (function () {
    function RestApiArrayResultHomeAction() {
    }
    RestApiArrayResultHomeAction.getAttributeTypeMap = function () {
        return RestApiArrayResultHomeAction.attributeTypeMap;
    };
    RestApiArrayResultHomeAction.discriminator = undefined;
    RestApiArrayResultHomeAction.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<HomeAction>"
        }
    ];
    return RestApiArrayResultHomeAction;
}());
exports.RestApiArrayResultHomeAction = RestApiArrayResultHomeAction;
var RestApiArrayResultKioskCashPaymentSettings = (function () {
    function RestApiArrayResultKioskCashPaymentSettings() {
    }
    RestApiArrayResultKioskCashPaymentSettings.getAttributeTypeMap = function () {
        return RestApiArrayResultKioskCashPaymentSettings.attributeTypeMap;
    };
    RestApiArrayResultKioskCashPaymentSettings.discriminator = undefined;
    RestApiArrayResultKioskCashPaymentSettings.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<KioskCashPaymentSettings>"
        }
    ];
    return RestApiArrayResultKioskCashPaymentSettings;
}());
exports.RestApiArrayResultKioskCashPaymentSettings = RestApiArrayResultKioskCashPaymentSettings;
var RestApiArrayResultLocalisedTimeZone = (function () {
    function RestApiArrayResultLocalisedTimeZone() {
    }
    RestApiArrayResultLocalisedTimeZone.getAttributeTypeMap = function () {
        return RestApiArrayResultLocalisedTimeZone.attributeTypeMap;
    };
    RestApiArrayResultLocalisedTimeZone.discriminator = undefined;
    RestApiArrayResultLocalisedTimeZone.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<LocalisedTimeZone>"
        }
    ];
    return RestApiArrayResultLocalisedTimeZone;
}());
exports.RestApiArrayResultLocalisedTimeZone = RestApiArrayResultLocalisedTimeZone;
var RestApiArrayResultLocationAreaLocation = (function () {
    function RestApiArrayResultLocationAreaLocation() {
    }
    RestApiArrayResultLocationAreaLocation.getAttributeTypeMap = function () {
        return RestApiArrayResultLocationAreaLocation.attributeTypeMap;
    };
    RestApiArrayResultLocationAreaLocation.discriminator = undefined;
    RestApiArrayResultLocationAreaLocation.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<LocationAreaLocation>"
        }
    ];
    return RestApiArrayResultLocationAreaLocation;
}());
exports.RestApiArrayResultLocationAreaLocation = RestApiArrayResultLocationAreaLocation;
var RestApiArrayResultLocationAreaWithLocations = (function () {
    function RestApiArrayResultLocationAreaWithLocations() {
    }
    RestApiArrayResultLocationAreaWithLocations.getAttributeTypeMap = function () {
        return RestApiArrayResultLocationAreaWithLocations.attributeTypeMap;
    };
    RestApiArrayResultLocationAreaWithLocations.discriminator = undefined;
    RestApiArrayResultLocationAreaWithLocations.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<LocationAreaWithLocations>"
        }
    ];
    return RestApiArrayResultLocationAreaWithLocations;
}());
exports.RestApiArrayResultLocationAreaWithLocations = RestApiArrayResultLocationAreaWithLocations;
var RestApiArrayResultLoyaltyCampaign = (function () {
    function RestApiArrayResultLoyaltyCampaign() {
    }
    RestApiArrayResultLoyaltyCampaign.getAttributeTypeMap = function () {
        return RestApiArrayResultLoyaltyCampaign.attributeTypeMap;
    };
    RestApiArrayResultLoyaltyCampaign.discriminator = undefined;
    RestApiArrayResultLoyaltyCampaign.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<LoyaltyCampaign>"
        }
    ];
    return RestApiArrayResultLoyaltyCampaign;
}());
exports.RestApiArrayResultLoyaltyCampaign = RestApiArrayResultLoyaltyCampaign;
var RestApiArrayResultMenuCheckpoint = (function () {
    function RestApiArrayResultMenuCheckpoint() {
    }
    RestApiArrayResultMenuCheckpoint.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuCheckpoint.attributeTypeMap;
    };
    RestApiArrayResultMenuCheckpoint.discriminator = undefined;
    RestApiArrayResultMenuCheckpoint.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuCheckpoint>"
        }
    ];
    return RestApiArrayResultMenuCheckpoint;
}());
exports.RestApiArrayResultMenuCheckpoint = RestApiArrayResultMenuCheckpoint;
var RestApiArrayResultMenuElementEditResponse = (function () {
    function RestApiArrayResultMenuElementEditResponse() {
    }
    RestApiArrayResultMenuElementEditResponse.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuElementEditResponse.attributeTypeMap;
    };
    RestApiArrayResultMenuElementEditResponse.discriminator = undefined;
    RestApiArrayResultMenuElementEditResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuElementEditResponse>"
        }
    ];
    return RestApiArrayResultMenuElementEditResponse;
}());
exports.RestApiArrayResultMenuElementEditResponse = RestApiArrayResultMenuElementEditResponse;
var RestApiArrayResultMenuElementListResponse = (function () {
    function RestApiArrayResultMenuElementListResponse() {
    }
    RestApiArrayResultMenuElementListResponse.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuElementListResponse.attributeTypeMap;
    };
    RestApiArrayResultMenuElementListResponse.discriminator = undefined;
    RestApiArrayResultMenuElementListResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuElementListResponse>"
        }
    ];
    return RestApiArrayResultMenuElementListResponse;
}());
exports.RestApiArrayResultMenuElementListResponse = RestApiArrayResultMenuElementListResponse;
var RestApiArrayResultMenuItemOptionSet = (function () {
    function RestApiArrayResultMenuItemOptionSet() {
    }
    RestApiArrayResultMenuItemOptionSet.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuItemOptionSet.attributeTypeMap;
    };
    RestApiArrayResultMenuItemOptionSet.discriminator = undefined;
    RestApiArrayResultMenuItemOptionSet.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuItemOptionSet>"
        }
    ];
    return RestApiArrayResultMenuItemOptionSet;
}());
exports.RestApiArrayResultMenuItemOptionSet = RestApiArrayResultMenuItemOptionSet;
var RestApiArrayResultMenuItemOptionSetItem = (function () {
    function RestApiArrayResultMenuItemOptionSetItem() {
    }
    RestApiArrayResultMenuItemOptionSetItem.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuItemOptionSetItem.attributeTypeMap;
    };
    RestApiArrayResultMenuItemOptionSetItem.discriminator = undefined;
    RestApiArrayResultMenuItemOptionSetItem.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuItemOptionSetItem>"
        }
    ];
    return RestApiArrayResultMenuItemOptionSetItem;
}());
exports.RestApiArrayResultMenuItemOptionSetItem = RestApiArrayResultMenuItemOptionSetItem;
var RestApiArrayResultMenuSection = (function () {
    function RestApiArrayResultMenuSection() {
    }
    RestApiArrayResultMenuSection.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuSection.attributeTypeMap;
    };
    RestApiArrayResultMenuSection.discriminator = undefined;
    RestApiArrayResultMenuSection.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuSection>"
        }
    ];
    return RestApiArrayResultMenuSection;
}());
exports.RestApiArrayResultMenuSection = RestApiArrayResultMenuSection;
var RestApiArrayResultMenuSectionItem = (function () {
    function RestApiArrayResultMenuSectionItem() {
    }
    RestApiArrayResultMenuSectionItem.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuSectionItem.attributeTypeMap;
    };
    RestApiArrayResultMenuSectionItem.discriminator = undefined;
    RestApiArrayResultMenuSectionItem.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuSectionItem>"
        }
    ];
    return RestApiArrayResultMenuSectionItem;
}());
exports.RestApiArrayResultMenuSectionItem = RestApiArrayResultMenuSectionItem;
var RestApiArrayResultMenuStoreNames = (function () {
    function RestApiArrayResultMenuStoreNames() {
    }
    RestApiArrayResultMenuStoreNames.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuStoreNames.attributeTypeMap;
    };
    RestApiArrayResultMenuStoreNames.discriminator = undefined;
    RestApiArrayResultMenuStoreNames.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuStoreNames>"
        }
    ];
    return RestApiArrayResultMenuStoreNames;
}());
exports.RestApiArrayResultMenuStoreNames = RestApiArrayResultMenuStoreNames;
var RestApiArrayResultMenuSummary = (function () {
    function RestApiArrayResultMenuSummary() {
    }
    RestApiArrayResultMenuSummary.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuSummary.attributeTypeMap;
    };
    RestApiArrayResultMenuSummary.discriminator = undefined;
    RestApiArrayResultMenuSummary.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuSummary>"
        }
    ];
    return RestApiArrayResultMenuSummary;
}());
exports.RestApiArrayResultMenuSummary = RestApiArrayResultMenuSummary;
var RestApiArrayResultMenuTaxDetails = (function () {
    function RestApiArrayResultMenuTaxDetails() {
    }
    RestApiArrayResultMenuTaxDetails.getAttributeTypeMap = function () {
        return RestApiArrayResultMenuTaxDetails.attributeTypeMap;
    };
    RestApiArrayResultMenuTaxDetails.discriminator = undefined;
    RestApiArrayResultMenuTaxDetails.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MenuTaxDetails>"
        }
    ];
    return RestApiArrayResultMenuTaxDetails;
}());
exports.RestApiArrayResultMenuTaxDetails = RestApiArrayResultMenuTaxDetails;
var RestApiArrayResultMetadata = (function () {
    function RestApiArrayResultMetadata() {
    }
    RestApiArrayResultMetadata.getAttributeTypeMap = function () {
        return RestApiArrayResultMetadata.attributeTypeMap;
    };
    RestApiArrayResultMetadata.discriminator = undefined;
    RestApiArrayResultMetadata.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Metadata>"
        }
    ];
    return RestApiArrayResultMetadata;
}());
exports.RestApiArrayResultMetadata = RestApiArrayResultMetadata;
var RestApiArrayResultMobileAppsStatistics = (function () {
    function RestApiArrayResultMobileAppsStatistics() {
    }
    RestApiArrayResultMobileAppsStatistics.getAttributeTypeMap = function () {
        return RestApiArrayResultMobileAppsStatistics.attributeTypeMap;
    };
    RestApiArrayResultMobileAppsStatistics.discriminator = undefined;
    RestApiArrayResultMobileAppsStatistics.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MobileAppsStatistics>"
        }
    ];
    return RestApiArrayResultMobileAppsStatistics;
}());
exports.RestApiArrayResultMobileAppsStatistics = RestApiArrayResultMobileAppsStatistics;
var RestApiArrayResultOAuthApp = (function () {
    function RestApiArrayResultOAuthApp() {
    }
    RestApiArrayResultOAuthApp.getAttributeTypeMap = function () {
        return RestApiArrayResultOAuthApp.attributeTypeMap;
    };
    RestApiArrayResultOAuthApp.discriminator = undefined;
    RestApiArrayResultOAuthApp.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<OAuthApp>"
        }
    ];
    return RestApiArrayResultOAuthApp;
}());
exports.RestApiArrayResultOAuthApp = RestApiArrayResultOAuthApp;
var RestApiArrayResultOauthClientRedirectUri = (function () {
    function RestApiArrayResultOauthClientRedirectUri() {
    }
    RestApiArrayResultOauthClientRedirectUri.getAttributeTypeMap = function () {
        return RestApiArrayResultOauthClientRedirectUri.attributeTypeMap;
    };
    RestApiArrayResultOauthClientRedirectUri.discriminator = undefined;
    RestApiArrayResultOauthClientRedirectUri.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<OauthClientRedirectUri>"
        }
    ];
    return RestApiArrayResultOauthClientRedirectUri;
}());
exports.RestApiArrayResultOauthClientRedirectUri = RestApiArrayResultOauthClientRedirectUri;
var RestApiArrayResultOrderBatch = (function () {
    function RestApiArrayResultOrderBatch() {
    }
    RestApiArrayResultOrderBatch.getAttributeTypeMap = function () {
        return RestApiArrayResultOrderBatch.attributeTypeMap;
    };
    RestApiArrayResultOrderBatch.discriminator = undefined;
    RestApiArrayResultOrderBatch.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<OrderBatch>"
        }
    ];
    return RestApiArrayResultOrderBatch;
}());
exports.RestApiArrayResultOrderBatch = RestApiArrayResultOrderBatch;
var RestApiArrayResultOrderFulfillmentStatus = (function () {
    function RestApiArrayResultOrderFulfillmentStatus() {
    }
    RestApiArrayResultOrderFulfillmentStatus.getAttributeTypeMap = function () {
        return RestApiArrayResultOrderFulfillmentStatus.attributeTypeMap;
    };
    RestApiArrayResultOrderFulfillmentStatus.discriminator = undefined;
    RestApiArrayResultOrderFulfillmentStatus.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<OrderFulfillmentStatus>"
        }
    ];
    return RestApiArrayResultOrderFulfillmentStatus;
}());
exports.RestApiArrayResultOrderFulfillmentStatus = RestApiArrayResultOrderFulfillmentStatus;
var RestApiArrayResultPayoutSummary = (function () {
    function RestApiArrayResultPayoutSummary() {
    }
    RestApiArrayResultPayoutSummary.getAttributeTypeMap = function () {
        return RestApiArrayResultPayoutSummary.attributeTypeMap;
    };
    RestApiArrayResultPayoutSummary.discriminator = undefined;
    RestApiArrayResultPayoutSummary.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PayoutSummary>"
        }
    ];
    return RestApiArrayResultPayoutSummary;
}());
exports.RestApiArrayResultPayoutSummary = RestApiArrayResultPayoutSummary;
var RestApiArrayResultPendingMenuChangesSummaries = (function () {
    function RestApiArrayResultPendingMenuChangesSummaries() {
    }
    RestApiArrayResultPendingMenuChangesSummaries.getAttributeTypeMap = function () {
        return RestApiArrayResultPendingMenuChangesSummaries.attributeTypeMap;
    };
    RestApiArrayResultPendingMenuChangesSummaries.discriminator = undefined;
    RestApiArrayResultPendingMenuChangesSummaries.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PendingMenuChangesSummaries>"
        }
    ];
    return RestApiArrayResultPendingMenuChangesSummaries;
}());
exports.RestApiArrayResultPendingMenuChangesSummaries = RestApiArrayResultPendingMenuChangesSummaries;
var RestApiArrayResultPreOrderTime = (function () {
    function RestApiArrayResultPreOrderTime() {
    }
    RestApiArrayResultPreOrderTime.getAttributeTypeMap = function () {
        return RestApiArrayResultPreOrderTime.attributeTypeMap;
    };
    RestApiArrayResultPreOrderTime.discriminator = undefined;
    RestApiArrayResultPreOrderTime.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PreOrderTime>"
        }
    ];
    return RestApiArrayResultPreOrderTime;
}());
exports.RestApiArrayResultPreOrderTime = RestApiArrayResultPreOrderTime;
var RestApiArrayResultProcessingFeeConfig = (function () {
    function RestApiArrayResultProcessingFeeConfig() {
    }
    RestApiArrayResultProcessingFeeConfig.getAttributeTypeMap = function () {
        return RestApiArrayResultProcessingFeeConfig.attributeTypeMap;
    };
    RestApiArrayResultProcessingFeeConfig.discriminator = undefined;
    RestApiArrayResultProcessingFeeConfig.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<ProcessingFeeConfig>"
        }
    ];
    return RestApiArrayResultProcessingFeeConfig;
}());
exports.RestApiArrayResultProcessingFeeConfig = RestApiArrayResultProcessingFeeConfig;
var RestApiArrayResultRestApiDefaultResponse = (function () {
    function RestApiArrayResultRestApiDefaultResponse() {
    }
    RestApiArrayResultRestApiDefaultResponse.getAttributeTypeMap = function () {
        return RestApiArrayResultRestApiDefaultResponse.attributeTypeMap;
    };
    RestApiArrayResultRestApiDefaultResponse.discriminator = undefined;
    RestApiArrayResultRestApiDefaultResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<RestApiDefaultResponse>"
        }
    ];
    return RestApiArrayResultRestApiDefaultResponse;
}());
exports.RestApiArrayResultRestApiDefaultResponse = RestApiArrayResultRestApiDefaultResponse;
var RestApiArrayResultRestaurantVoucherEligibleStore = (function () {
    function RestApiArrayResultRestaurantVoucherEligibleStore() {
    }
    RestApiArrayResultRestaurantVoucherEligibleStore.getAttributeTypeMap = function () {
        return RestApiArrayResultRestaurantVoucherEligibleStore.attributeTypeMap;
    };
    RestApiArrayResultRestaurantVoucherEligibleStore.discriminator = undefined;
    RestApiArrayResultRestaurantVoucherEligibleStore.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<RestaurantVoucherEligibleStore>"
        }
    ];
    return RestApiArrayResultRestaurantVoucherEligibleStore;
}());
exports.RestApiArrayResultRestaurantVoucherEligibleStore = RestApiArrayResultRestaurantVoucherEligibleStore;
var RestApiArrayResultRestaurantVoucherPayGreenConfiguration = (function () {
    function RestApiArrayResultRestaurantVoucherPayGreenConfiguration() {
    }
    RestApiArrayResultRestaurantVoucherPayGreenConfiguration.getAttributeTypeMap = function () {
        return RestApiArrayResultRestaurantVoucherPayGreenConfiguration.attributeTypeMap;
    };
    RestApiArrayResultRestaurantVoucherPayGreenConfiguration.discriminator = undefined;
    RestApiArrayResultRestaurantVoucherPayGreenConfiguration.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<RestaurantVoucherPayGreenConfiguration>"
        }
    ];
    return RestApiArrayResultRestaurantVoucherPayGreenConfiguration;
}());
exports.RestApiArrayResultRestaurantVoucherPayGreenConfiguration = RestApiArrayResultRestaurantVoucherPayGreenConfiguration;
var RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary = (function () {
    function RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary() {
    }
    RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary.getAttributeTypeMap = function () {
        return RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary.attributeTypeMap;
    };
    RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary.discriminator = undefined;
    RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<RestaurantVoucherPayGreenConfigurationSummary>"
        }
    ];
    return RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary;
}());
exports.RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary = RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary;
var RestApiArrayResultRetentionCampaign = (function () {
    function RestApiArrayResultRetentionCampaign() {
    }
    RestApiArrayResultRetentionCampaign.getAttributeTypeMap = function () {
        return RestApiArrayResultRetentionCampaign.attributeTypeMap;
    };
    RestApiArrayResultRetentionCampaign.discriminator = undefined;
    RestApiArrayResultRetentionCampaign.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<RetentionCampaign>"
        }
    ];
    return RestApiArrayResultRetentionCampaign;
}());
exports.RestApiArrayResultRetentionCampaign = RestApiArrayResultRetentionCampaign;
var RestApiArrayResultStoreChannelAssignment = (function () {
    function RestApiArrayResultStoreChannelAssignment() {
    }
    RestApiArrayResultStoreChannelAssignment.getAttributeTypeMap = function () {
        return RestApiArrayResultStoreChannelAssignment.attributeTypeMap;
    };
    RestApiArrayResultStoreChannelAssignment.discriminator = undefined;
    RestApiArrayResultStoreChannelAssignment.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreChannelAssignment>"
        }
    ];
    return RestApiArrayResultStoreChannelAssignment;
}());
exports.RestApiArrayResultStoreChannelAssignment = RestApiArrayResultStoreChannelAssignment;
var RestApiArrayResultStoreChannelStoreMapping = (function () {
    function RestApiArrayResultStoreChannelStoreMapping() {
    }
    RestApiArrayResultStoreChannelStoreMapping.getAttributeTypeMap = function () {
        return RestApiArrayResultStoreChannelStoreMapping.attributeTypeMap;
    };
    RestApiArrayResultStoreChannelStoreMapping.discriminator = undefined;
    RestApiArrayResultStoreChannelStoreMapping.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreChannelStoreMapping>"
        }
    ];
    return RestApiArrayResultStoreChannelStoreMapping;
}());
exports.RestApiArrayResultStoreChannelStoreMapping = RestApiArrayResultStoreChannelStoreMapping;
var RestApiArrayResultStoreListItem = (function () {
    function RestApiArrayResultStoreListItem() {
    }
    RestApiArrayResultStoreListItem.getAttributeTypeMap = function () {
        return RestApiArrayResultStoreListItem.attributeTypeMap;
    };
    RestApiArrayResultStoreListItem.discriminator = undefined;
    RestApiArrayResultStoreListItem.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreListItem>"
        }
    ];
    return RestApiArrayResultStoreListItem;
}());
exports.RestApiArrayResultStoreListItem = RestApiArrayResultStoreListItem;
var RestApiArrayResultStoreStatistics = (function () {
    function RestApiArrayResultStoreStatistics() {
    }
    RestApiArrayResultStoreStatistics.getAttributeTypeMap = function () {
        return RestApiArrayResultStoreStatistics.attributeTypeMap;
    };
    RestApiArrayResultStoreStatistics.discriminator = undefined;
    RestApiArrayResultStoreStatistics.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreStatistics>"
        }
    ];
    return RestApiArrayResultStoreStatistics;
}());
exports.RestApiArrayResultStoreStatistics = RestApiArrayResultStoreStatistics;
var RestApiArrayResultStripeCustomConnectedAccount = (function () {
    function RestApiArrayResultStripeCustomConnectedAccount() {
    }
    RestApiArrayResultStripeCustomConnectedAccount.getAttributeTypeMap = function () {
        return RestApiArrayResultStripeCustomConnectedAccount.attributeTypeMap;
    };
    RestApiArrayResultStripeCustomConnectedAccount.discriminator = undefined;
    RestApiArrayResultStripeCustomConnectedAccount.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StripeCustomConnectedAccount>"
        }
    ];
    return RestApiArrayResultStripeCustomConnectedAccount;
}());
exports.RestApiArrayResultStripeCustomConnectedAccount = RestApiArrayResultStripeCustomConnectedAccount;
var RestApiArrayResultSubscriptionSummary = (function () {
    function RestApiArrayResultSubscriptionSummary() {
    }
    RestApiArrayResultSubscriptionSummary.getAttributeTypeMap = function () {
        return RestApiArrayResultSubscriptionSummary.attributeTypeMap;
    };
    RestApiArrayResultSubscriptionSummary.discriminator = undefined;
    RestApiArrayResultSubscriptionSummary.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<SubscriptionSummary>"
        }
    ];
    return RestApiArrayResultSubscriptionSummary;
}());
exports.RestApiArrayResultSubscriptionSummary = RestApiArrayResultSubscriptionSummary;
var RestApiArrayResultSupportedCountry = (function () {
    function RestApiArrayResultSupportedCountry() {
    }
    RestApiArrayResultSupportedCountry.getAttributeTypeMap = function () {
        return RestApiArrayResultSupportedCountry.attributeTypeMap;
    };
    RestApiArrayResultSupportedCountry.discriminator = undefined;
    RestApiArrayResultSupportedCountry.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<SupportedCountry>"
        }
    ];
    return RestApiArrayResultSupportedCountry;
}());
exports.RestApiArrayResultSupportedCountry = RestApiArrayResultSupportedCountry;
var RestApiArrayResultTeammate = (function () {
    function RestApiArrayResultTeammate() {
    }
    RestApiArrayResultTeammate.getAttributeTypeMap = function () {
        return RestApiArrayResultTeammate.attributeTypeMap;
    };
    RestApiArrayResultTeammate.discriminator = undefined;
    RestApiArrayResultTeammate.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Teammate>"
        }
    ];
    return RestApiArrayResultTeammate;
}());
exports.RestApiArrayResultTeammate = RestApiArrayResultTeammate;
var RestApiArrayResultVoucherDataPoint = (function () {
    function RestApiArrayResultVoucherDataPoint() {
    }
    RestApiArrayResultVoucherDataPoint.getAttributeTypeMap = function () {
        return RestApiArrayResultVoucherDataPoint.attributeTypeMap;
    };
    RestApiArrayResultVoucherDataPoint.discriminator = undefined;
    RestApiArrayResultVoucherDataPoint.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<VoucherDataPoint>"
        }
    ];
    return RestApiArrayResultVoucherDataPoint;
}());
exports.RestApiArrayResultVoucherDataPoint = RestApiArrayResultVoucherDataPoint;
var RestApiDefaultResponse = (function () {
    function RestApiDefaultResponse() {
    }
    RestApiDefaultResponse.getAttributeTypeMap = function () {
        return RestApiDefaultResponse.attributeTypeMap;
    };
    RestApiDefaultResponse.discriminator = undefined;
    RestApiDefaultResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "string"
        }
    ];
    return RestApiDefaultResponse;
}());
exports.RestApiDefaultResponse = RestApiDefaultResponse;
var RestApiErrorResult = (function () {
    function RestApiErrorResult() {
    }
    RestApiErrorResult.getAttributeTypeMap = function () {
        return RestApiErrorResult.attributeTypeMap;
    };
    RestApiErrorResult.discriminator = undefined;
    RestApiErrorResult.attributeTypeMap = [
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        },
        {
            "name": "ErrorCode",
            "baseName": "ErrorCode",
            "type": "number"
        },
        {
            "name": "StackTrace",
            "baseName": "StackTrace",
            "type": "string"
        },
        {
            "name": "Errors",
            "baseName": "Errors",
            "type": "Array<ValidationErrorResult>"
        }
    ];
    return RestApiErrorResult;
}());
exports.RestApiErrorResult = RestApiErrorResult;
var RestApiEventSearchPaginationResult = (function () {
    function RestApiEventSearchPaginationResult() {
    }
    RestApiEventSearchPaginationResult.getAttributeTypeMap = function () {
        return RestApiEventSearchPaginationResult.attributeTypeMap;
    };
    RestApiEventSearchPaginationResult.discriminator = undefined;
    RestApiEventSearchPaginationResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "EventSearchResult"
        },
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        }
    ];
    return RestApiEventSearchPaginationResult;
}());
exports.RestApiEventSearchPaginationResult = RestApiEventSearchPaginationResult;
var RestApiFinanceSearchPaginationResultInvoice = (function () {
    function RestApiFinanceSearchPaginationResultInvoice() {
    }
    RestApiFinanceSearchPaginationResultInvoice.getAttributeTypeMap = function () {
        return RestApiFinanceSearchPaginationResultInvoice.attributeTypeMap;
    };
    RestApiFinanceSearchPaginationResultInvoice.discriminator = undefined;
    RestApiFinanceSearchPaginationResultInvoice.attributeTypeMap = [
        {
            "name": "NextPage",
            "baseName": "NextPage",
            "type": "string"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Invoice>"
        }
    ];
    return RestApiFinanceSearchPaginationResultInvoice;
}());
exports.RestApiFinanceSearchPaginationResultInvoice = RestApiFinanceSearchPaginationResultInvoice;
var RestApiForbiddenResult = (function () {
    function RestApiForbiddenResult() {
    }
    RestApiForbiddenResult.getAttributeTypeMap = function () {
        return RestApiForbiddenResult.attributeTypeMap;
    };
    RestApiForbiddenResult.discriminator = undefined;
    RestApiForbiddenResult.attributeTypeMap = [
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        }
    ];
    return RestApiForbiddenResult;
}());
exports.RestApiForbiddenResult = RestApiForbiddenResult;
var RestApiIntegerResult = (function () {
    function RestApiIntegerResult() {
    }
    RestApiIntegerResult.getAttributeTypeMap = function () {
        return RestApiIntegerResult.attributeTypeMap;
    };
    RestApiIntegerResult.discriminator = undefined;
    RestApiIntegerResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "number"
        }
    ];
    return RestApiIntegerResult;
}());
exports.RestApiIntegerResult = RestApiIntegerResult;
var RestApiPaginationResultApp = (function () {
    function RestApiPaginationResultApp() {
    }
    RestApiPaginationResultApp.getAttributeTypeMap = function () {
        return RestApiPaginationResultApp.attributeTypeMap;
    };
    RestApiPaginationResultApp.discriminator = undefined;
    RestApiPaginationResultApp.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<App>"
        }
    ];
    return RestApiPaginationResultApp;
}());
exports.RestApiPaginationResultApp = RestApiPaginationResultApp;
var RestApiPaginationResultAppStoreAppSummary = (function () {
    function RestApiPaginationResultAppStoreAppSummary() {
    }
    RestApiPaginationResultAppStoreAppSummary.getAttributeTypeMap = function () {
        return RestApiPaginationResultAppStoreAppSummary.attributeTypeMap;
    };
    RestApiPaginationResultAppStoreAppSummary.discriminator = undefined;
    RestApiPaginationResultAppStoreAppSummary.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<AppStoreAppSummary>"
        }
    ];
    return RestApiPaginationResultAppStoreAppSummary;
}());
exports.RestApiPaginationResultAppStoreAppSummary = RestApiPaginationResultAppStoreAppSummary;
var RestApiPaginationResultBusinessHoursOverride = (function () {
    function RestApiPaginationResultBusinessHoursOverride() {
    }
    RestApiPaginationResultBusinessHoursOverride.getAttributeTypeMap = function () {
        return RestApiPaginationResultBusinessHoursOverride.attributeTypeMap;
    };
    RestApiPaginationResultBusinessHoursOverride.discriminator = undefined;
    RestApiPaginationResultBusinessHoursOverride.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<BusinessHoursOverride>"
        }
    ];
    return RestApiPaginationResultBusinessHoursOverride;
}());
exports.RestApiPaginationResultBusinessHoursOverride = RestApiPaginationResultBusinessHoursOverride;
var RestApiPaginationResultCatalogItem = (function () {
    function RestApiPaginationResultCatalogItem() {
    }
    RestApiPaginationResultCatalogItem.getAttributeTypeMap = function () {
        return RestApiPaginationResultCatalogItem.attributeTypeMap;
    };
    RestApiPaginationResultCatalogItem.discriminator = undefined;
    RestApiPaginationResultCatalogItem.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<CatalogItem>"
        }
    ];
    return RestApiPaginationResultCatalogItem;
}());
exports.RestApiPaginationResultCatalogItem = RestApiPaginationResultCatalogItem;
var RestApiPaginationResultGroup = (function () {
    function RestApiPaginationResultGroup() {
    }
    RestApiPaginationResultGroup.getAttributeTypeMap = function () {
        return RestApiPaginationResultGroup.attributeTypeMap;
    };
    RestApiPaginationResultGroup.discriminator = undefined;
    RestApiPaginationResultGroup.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Group>"
        }
    ];
    return RestApiPaginationResultGroup;
}());
exports.RestApiPaginationResultGroup = RestApiPaginationResultGroup;
var RestApiPaginationResultHttpRequestAndResponseLog = (function () {
    function RestApiPaginationResultHttpRequestAndResponseLog() {
    }
    RestApiPaginationResultHttpRequestAndResponseLog.getAttributeTypeMap = function () {
        return RestApiPaginationResultHttpRequestAndResponseLog.attributeTypeMap;
    };
    RestApiPaginationResultHttpRequestAndResponseLog.discriminator = undefined;
    RestApiPaginationResultHttpRequestAndResponseLog.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<HttpRequestAndResponseLog>"
        }
    ];
    return RestApiPaginationResultHttpRequestAndResponseLog;
}());
exports.RestApiPaginationResultHttpRequestAndResponseLog = RestApiPaginationResultHttpRequestAndResponseLog;
var RestApiPaginationResultHydraDeviceDetails = (function () {
    function RestApiPaginationResultHydraDeviceDetails() {
    }
    RestApiPaginationResultHydraDeviceDetails.getAttributeTypeMap = function () {
        return RestApiPaginationResultHydraDeviceDetails.attributeTypeMap;
    };
    RestApiPaginationResultHydraDeviceDetails.discriminator = undefined;
    RestApiPaginationResultHydraDeviceDetails.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<HydraDeviceDetails>"
        }
    ];
    return RestApiPaginationResultHydraDeviceDetails;
}());
exports.RestApiPaginationResultHydraDeviceDetails = RestApiPaginationResultHydraDeviceDetails;
var RestApiPaginationResultMetafieldDefinition = (function () {
    function RestApiPaginationResultMetafieldDefinition() {
    }
    RestApiPaginationResultMetafieldDefinition.getAttributeTypeMap = function () {
        return RestApiPaginationResultMetafieldDefinition.attributeTypeMap;
    };
    RestApiPaginationResultMetafieldDefinition.discriminator = undefined;
    RestApiPaginationResultMetafieldDefinition.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MetafieldDefinition>"
        }
    ];
    return RestApiPaginationResultMetafieldDefinition;
}());
exports.RestApiPaginationResultMetafieldDefinition = RestApiPaginationResultMetafieldDefinition;
var RestApiPaginationResultMetafieldDefinitionRecommendation = (function () {
    function RestApiPaginationResultMetafieldDefinitionRecommendation() {
    }
    RestApiPaginationResultMetafieldDefinitionRecommendation.getAttributeTypeMap = function () {
        return RestApiPaginationResultMetafieldDefinitionRecommendation.attributeTypeMap;
    };
    RestApiPaginationResultMetafieldDefinitionRecommendation.discriminator = undefined;
    RestApiPaginationResultMetafieldDefinitionRecommendation.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<MetafieldDefinitionRecommendation>"
        }
    ];
    return RestApiPaginationResultMetafieldDefinitionRecommendation;
}());
exports.RestApiPaginationResultMetafieldDefinitionRecommendation = RestApiPaginationResultMetafieldDefinitionRecommendation;
var RestApiPaginationResultOAuthTokenModel = (function () {
    function RestApiPaginationResultOAuthTokenModel() {
    }
    RestApiPaginationResultOAuthTokenModel.getAttributeTypeMap = function () {
        return RestApiPaginationResultOAuthTokenModel.attributeTypeMap;
    };
    RestApiPaginationResultOAuthTokenModel.discriminator = undefined;
    RestApiPaginationResultOAuthTokenModel.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<OAuthTokenModel>"
        }
    ];
    return RestApiPaginationResultOAuthTokenModel;
}());
exports.RestApiPaginationResultOAuthTokenModel = RestApiPaginationResultOAuthTokenModel;
var RestApiPaginationResultOrder = (function () {
    function RestApiPaginationResultOrder() {
    }
    RestApiPaginationResultOrder.getAttributeTypeMap = function () {
        return RestApiPaginationResultOrder.attributeTypeMap;
    };
    RestApiPaginationResultOrder.discriminator = undefined;
    RestApiPaginationResultOrder.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Order>"
        }
    ];
    return RestApiPaginationResultOrder;
}());
exports.RestApiPaginationResultOrder = RestApiPaginationResultOrder;
var RestApiPaginationResultOrderSummary = (function () {
    function RestApiPaginationResultOrderSummary() {
    }
    RestApiPaginationResultOrderSummary.getAttributeTypeMap = function () {
        return RestApiPaginationResultOrderSummary.attributeTypeMap;
    };
    RestApiPaginationResultOrderSummary.discriminator = undefined;
    RestApiPaginationResultOrderSummary.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<OrderSummary>"
        }
    ];
    return RestApiPaginationResultOrderSummary;
}());
exports.RestApiPaginationResultOrderSummary = RestApiPaginationResultOrderSummary;
var RestApiPaginationResultPayout = (function () {
    function RestApiPaginationResultPayout() {
    }
    RestApiPaginationResultPayout.getAttributeTypeMap = function () {
        return RestApiPaginationResultPayout.attributeTypeMap;
    };
    RestApiPaginationResultPayout.discriminator = undefined;
    RestApiPaginationResultPayout.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Payout>"
        }
    ];
    return RestApiPaginationResultPayout;
}());
exports.RestApiPaginationResultPayout = RestApiPaginationResultPayout;
var RestApiPaginationResultPayoutChargeback = (function () {
    function RestApiPaginationResultPayoutChargeback() {
    }
    RestApiPaginationResultPayoutChargeback.getAttributeTypeMap = function () {
        return RestApiPaginationResultPayoutChargeback.attributeTypeMap;
    };
    RestApiPaginationResultPayoutChargeback.discriminator = undefined;
    RestApiPaginationResultPayoutChargeback.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PayoutChargeback>"
        }
    ];
    return RestApiPaginationResultPayoutChargeback;
}());
exports.RestApiPaginationResultPayoutChargeback = RestApiPaginationResultPayoutChargeback;
var RestApiPaginationResultPayoutOrder = (function () {
    function RestApiPaginationResultPayoutOrder() {
    }
    RestApiPaginationResultPayoutOrder.getAttributeTypeMap = function () {
        return RestApiPaginationResultPayoutOrder.attributeTypeMap;
    };
    RestApiPaginationResultPayoutOrder.discriminator = undefined;
    RestApiPaginationResultPayoutOrder.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PayoutOrder>"
        }
    ];
    return RestApiPaginationResultPayoutOrder;
}());
exports.RestApiPaginationResultPayoutOrder = RestApiPaginationResultPayoutOrder;
var RestApiPaginationResultPayoutOtherCharge = (function () {
    function RestApiPaginationResultPayoutOtherCharge() {
    }
    RestApiPaginationResultPayoutOtherCharge.getAttributeTypeMap = function () {
        return RestApiPaginationResultPayoutOtherCharge.attributeTypeMap;
    };
    RestApiPaginationResultPayoutOtherCharge.discriminator = undefined;
    RestApiPaginationResultPayoutOtherCharge.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PayoutOtherCharge>"
        }
    ];
    return RestApiPaginationResultPayoutOtherCharge;
}());
exports.RestApiPaginationResultPayoutOtherCharge = RestApiPaginationResultPayoutOtherCharge;
var RestApiPaginationResultPayoutRefund = (function () {
    function RestApiPaginationResultPayoutRefund() {
    }
    RestApiPaginationResultPayoutRefund.getAttributeTypeMap = function () {
        return RestApiPaginationResultPayoutRefund.attributeTypeMap;
    };
    RestApiPaginationResultPayoutRefund.discriminator = undefined;
    RestApiPaginationResultPayoutRefund.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PayoutRefund>"
        }
    ];
    return RestApiPaginationResultPayoutRefund;
}());
exports.RestApiPaginationResultPayoutRefund = RestApiPaginationResultPayoutRefund;
var RestApiPaginationResultPendingMenuChanges = (function () {
    function RestApiPaginationResultPendingMenuChanges() {
    }
    RestApiPaginationResultPendingMenuChanges.getAttributeTypeMap = function () {
        return RestApiPaginationResultPendingMenuChanges.attributeTypeMap;
    };
    RestApiPaginationResultPendingMenuChanges.discriminator = undefined;
    RestApiPaginationResultPendingMenuChanges.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PendingMenuChanges>"
        }
    ];
    return RestApiPaginationResultPendingMenuChanges;
}());
exports.RestApiPaginationResultPendingMenuChanges = RestApiPaginationResultPendingMenuChanges;
var RestApiPaginationResultPhoneCall = (function () {
    function RestApiPaginationResultPhoneCall() {
    }
    RestApiPaginationResultPhoneCall.getAttributeTypeMap = function () {
        return RestApiPaginationResultPhoneCall.attributeTypeMap;
    };
    RestApiPaginationResultPhoneCall.discriminator = undefined;
    RestApiPaginationResultPhoneCall.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PhoneCall>"
        }
    ];
    return RestApiPaginationResultPhoneCall;
}());
exports.RestApiPaginationResultPhoneCall = RestApiPaginationResultPhoneCall;
var RestApiPaginationResultProduct = (function () {
    function RestApiPaginationResultProduct() {
    }
    RestApiPaginationResultProduct.getAttributeTypeMap = function () {
        return RestApiPaginationResultProduct.attributeTypeMap;
    };
    RestApiPaginationResultProduct.discriminator = undefined;
    RestApiPaginationResultProduct.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Product>"
        }
    ];
    return RestApiPaginationResultProduct;
}());
exports.RestApiPaginationResultProduct = RestApiPaginationResultProduct;
var RestApiPaginationResultPushNotificationResponse = (function () {
    function RestApiPaginationResultPushNotificationResponse() {
    }
    RestApiPaginationResultPushNotificationResponse.getAttributeTypeMap = function () {
        return RestApiPaginationResultPushNotificationResponse.attributeTypeMap;
    };
    RestApiPaginationResultPushNotificationResponse.discriminator = undefined;
    RestApiPaginationResultPushNotificationResponse.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<PushNotificationResponse>"
        }
    ];
    return RestApiPaginationResultPushNotificationResponse;
}());
exports.RestApiPaginationResultPushNotificationResponse = RestApiPaginationResultPushNotificationResponse;
var RestApiPaginationResultStore = (function () {
    function RestApiPaginationResultStore() {
    }
    RestApiPaginationResultStore.getAttributeTypeMap = function () {
        return RestApiPaginationResultStore.attributeTypeMap;
    };
    RestApiPaginationResultStore.discriminator = undefined;
    RestApiPaginationResultStore.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<Store>"
        }
    ];
    return RestApiPaginationResultStore;
}());
exports.RestApiPaginationResultStore = RestApiPaginationResultStore;
var RestApiPaginationResultStoreGroup = (function () {
    function RestApiPaginationResultStoreGroup() {
    }
    RestApiPaginationResultStoreGroup.getAttributeTypeMap = function () {
        return RestApiPaginationResultStoreGroup.attributeTypeMap;
    };
    RestApiPaginationResultStoreGroup.discriminator = undefined;
    RestApiPaginationResultStoreGroup.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreGroup>"
        }
    ];
    return RestApiPaginationResultStoreGroup;
}());
exports.RestApiPaginationResultStoreGroup = RestApiPaginationResultStoreGroup;
var RestApiPaginationResultStoreGroupExtended = (function () {
    function RestApiPaginationResultStoreGroupExtended() {
    }
    RestApiPaginationResultStoreGroupExtended.getAttributeTypeMap = function () {
        return RestApiPaginationResultStoreGroupExtended.attributeTypeMap;
    };
    RestApiPaginationResultStoreGroupExtended.discriminator = undefined;
    RestApiPaginationResultStoreGroupExtended.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreGroupExtended>"
        }
    ];
    return RestApiPaginationResultStoreGroupExtended;
}());
exports.RestApiPaginationResultStoreGroupExtended = RestApiPaginationResultStoreGroupExtended;
var RestApiPaginationResultStoreHeader = (function () {
    function RestApiPaginationResultStoreHeader() {
    }
    RestApiPaginationResultStoreHeader.getAttributeTypeMap = function () {
        return RestApiPaginationResultStoreHeader.attributeTypeMap;
    };
    RestApiPaginationResultStoreHeader.discriminator = undefined;
    RestApiPaginationResultStoreHeader.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreHeader>"
        }
    ];
    return RestApiPaginationResultStoreHeader;
}());
exports.RestApiPaginationResultStoreHeader = RestApiPaginationResultStoreHeader;
var RestApiPaginationResultStoreValidationConfig = (function () {
    function RestApiPaginationResultStoreValidationConfig() {
    }
    RestApiPaginationResultStoreValidationConfig.getAttributeTypeMap = function () {
        return RestApiPaginationResultStoreValidationConfig.attributeTypeMap;
    };
    RestApiPaginationResultStoreValidationConfig.discriminator = undefined;
    RestApiPaginationResultStoreValidationConfig.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreValidationConfig>"
        }
    ];
    return RestApiPaginationResultStoreValidationConfig;
}());
exports.RestApiPaginationResultStoreValidationConfig = RestApiPaginationResultStoreValidationConfig;
var RestApiPaginationResultVoucherSummary = (function () {
    function RestApiPaginationResultVoucherSummary() {
    }
    RestApiPaginationResultVoucherSummary.getAttributeTypeMap = function () {
        return RestApiPaginationResultVoucherSummary.attributeTypeMap;
    };
    RestApiPaginationResultVoucherSummary.discriminator = undefined;
    RestApiPaginationResultVoucherSummary.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<VoucherSummary>"
        }
    ];
    return RestApiPaginationResultVoucherSummary;
}());
exports.RestApiPaginationResultVoucherSummary = RestApiPaginationResultVoucherSummary;
var RestApiPaginationResultWebhookLog = (function () {
    function RestApiPaginationResultWebhookLog() {
    }
    RestApiPaginationResultWebhookLog.getAttributeTypeMap = function () {
        return RestApiPaginationResultWebhookLog.attributeTypeMap;
    };
    RestApiPaginationResultWebhookLog.discriminator = undefined;
    RestApiPaginationResultWebhookLog.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<WebhookLog>"
        }
    ];
    return RestApiPaginationResultWebhookLog;
}());
exports.RestApiPaginationResultWebhookLog = RestApiPaginationResultWebhookLog;
var RestApiPaginationResultWebhookSubscription = (function () {
    function RestApiPaginationResultWebhookSubscription() {
    }
    RestApiPaginationResultWebhookSubscription.getAttributeTypeMap = function () {
        return RestApiPaginationResultWebhookSubscription.attributeTypeMap;
    };
    RestApiPaginationResultWebhookSubscription.discriminator = undefined;
    RestApiPaginationResultWebhookSubscription.attributeTypeMap = [
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "TotalRecordCount",
            "baseName": "TotalRecordCount",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<WebhookSubscription>"
        }
    ];
    return RestApiPaginationResultWebhookSubscription;
}());
exports.RestApiPaginationResultWebhookSubscription = RestApiPaginationResultWebhookSubscription;
var RestApiResultAccountDetail = (function () {
    function RestApiResultAccountDetail() {
    }
    RestApiResultAccountDetail.getAttributeTypeMap = function () {
        return RestApiResultAccountDetail.attributeTypeMap;
    };
    RestApiResultAccountDetail.discriminator = undefined;
    RestApiResultAccountDetail.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AccountDetail"
        }
    ];
    return RestApiResultAccountDetail;
}());
exports.RestApiResultAccountDetail = RestApiResultAccountDetail;
var RestApiResultAccountFieldsDefinitions = (function () {
    function RestApiResultAccountFieldsDefinitions() {
    }
    RestApiResultAccountFieldsDefinitions.getAttributeTypeMap = function () {
        return RestApiResultAccountFieldsDefinitions.attributeTypeMap;
    };
    RestApiResultAccountFieldsDefinitions.discriminator = undefined;
    RestApiResultAccountFieldsDefinitions.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AccountFieldsDefinitions"
        }
    ];
    return RestApiResultAccountFieldsDefinitions;
}());
exports.RestApiResultAccountFieldsDefinitions = RestApiResultAccountFieldsDefinitions;
var RestApiResultAddressFormResponse = (function () {
    function RestApiResultAddressFormResponse() {
    }
    RestApiResultAddressFormResponse.getAttributeTypeMap = function () {
        return RestApiResultAddressFormResponse.attributeTypeMap;
    };
    RestApiResultAddressFormResponse.discriminator = undefined;
    RestApiResultAddressFormResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AddressFormResponse"
        }
    ];
    return RestApiResultAddressFormResponse;
}());
exports.RestApiResultAddressFormResponse = RestApiResultAddressFormResponse;
var RestApiResultApmStatistics = (function () {
    function RestApiResultApmStatistics() {
    }
    RestApiResultApmStatistics.getAttributeTypeMap = function () {
        return RestApiResultApmStatistics.attributeTypeMap;
    };
    RestApiResultApmStatistics.discriminator = undefined;
    RestApiResultApmStatistics.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "ApmStatistics"
        }
    ];
    return RestApiResultApmStatistics;
}());
exports.RestApiResultApmStatistics = RestApiResultApmStatistics;
var RestApiResultApmStatus = (function () {
    function RestApiResultApmStatus() {
    }
    RestApiResultApmStatus.getAttributeTypeMap = function () {
        return RestApiResultApmStatus.attributeTypeMap;
    };
    RestApiResultApmStatus.discriminator = undefined;
    RestApiResultApmStatus.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "ApmStatus"
        }
    ];
    return RestApiResultApmStatus;
}());
exports.RestApiResultApmStatus = RestApiResultApmStatus;
var RestApiResultApp = (function () {
    function RestApiResultApp() {
    }
    RestApiResultApp.getAttributeTypeMap = function () {
        return RestApiResultApp.attributeTypeMap;
    };
    RestApiResultApp.discriminator = undefined;
    RestApiResultApp.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "App"
        }
    ];
    return RestApiResultApp;
}());
exports.RestApiResultApp = RestApiResultApp;
var RestApiResultAppChannelAssignment = (function () {
    function RestApiResultAppChannelAssignment() {
    }
    RestApiResultAppChannelAssignment.getAttributeTypeMap = function () {
        return RestApiResultAppChannelAssignment.attributeTypeMap;
    };
    RestApiResultAppChannelAssignment.discriminator = undefined;
    RestApiResultAppChannelAssignment.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AppChannelAssignment"
        }
    ];
    return RestApiResultAppChannelAssignment;
}());
exports.RestApiResultAppChannelAssignment = RestApiResultAppChannelAssignment;
var RestApiResultAppCompliance = (function () {
    function RestApiResultAppCompliance() {
    }
    RestApiResultAppCompliance.getAttributeTypeMap = function () {
        return RestApiResultAppCompliance.attributeTypeMap;
    };
    RestApiResultAppCompliance.discriminator = undefined;
    RestApiResultAppCompliance.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AppCompliance"
        }
    ];
    return RestApiResultAppCompliance;
}());
exports.RestApiResultAppCompliance = RestApiResultAppCompliance;
var RestApiResultAppConfigSalesChannel = (function () {
    function RestApiResultAppConfigSalesChannel() {
    }
    RestApiResultAppConfigSalesChannel.getAttributeTypeMap = function () {
        return RestApiResultAppConfigSalesChannel.attributeTypeMap;
    };
    RestApiResultAppConfigSalesChannel.discriminator = undefined;
    RestApiResultAppConfigSalesChannel.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AppConfigSalesChannel"
        }
    ];
    return RestApiResultAppConfigSalesChannel;
}());
exports.RestApiResultAppConfigSalesChannel = RestApiResultAppConfigSalesChannel;
var RestApiResultAppStoreApp = (function () {
    function RestApiResultAppStoreApp() {
    }
    RestApiResultAppStoreApp.getAttributeTypeMap = function () {
        return RestApiResultAppStoreApp.attributeTypeMap;
    };
    RestApiResultAppStoreApp.discriminator = undefined;
    RestApiResultAppStoreApp.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AppStoreApp"
        }
    ];
    return RestApiResultAppStoreApp;
}());
exports.RestApiResultAppStoreApp = RestApiResultAppStoreApp;
var RestApiResultAppStoreAppConfiguration = (function () {
    function RestApiResultAppStoreAppConfiguration() {
    }
    RestApiResultAppStoreAppConfiguration.getAttributeTypeMap = function () {
        return RestApiResultAppStoreAppConfiguration.attributeTypeMap;
    };
    RestApiResultAppStoreAppConfiguration.discriminator = undefined;
    RestApiResultAppStoreAppConfiguration.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AppStoreAppConfiguration"
        }
    ];
    return RestApiResultAppStoreAppConfiguration;
}());
exports.RestApiResultAppStoreAppConfiguration = RestApiResultAppStoreAppConfiguration;
var RestApiResultAppStoreAppConfigurationsWithSubscriptions = (function () {
    function RestApiResultAppStoreAppConfigurationsWithSubscriptions() {
    }
    RestApiResultAppStoreAppConfigurationsWithSubscriptions.getAttributeTypeMap = function () {
        return RestApiResultAppStoreAppConfigurationsWithSubscriptions.attributeTypeMap;
    };
    RestApiResultAppStoreAppConfigurationsWithSubscriptions.discriminator = undefined;
    RestApiResultAppStoreAppConfigurationsWithSubscriptions.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AppStoreAppConfigurationsWithSubscriptions"
        }
    ];
    return RestApiResultAppStoreAppConfigurationsWithSubscriptions;
}());
exports.RestApiResultAppStoreAppConfigurationsWithSubscriptions = RestApiResultAppStoreAppConfigurationsWithSubscriptions;
var RestApiResultAssignedBankAccount = (function () {
    function RestApiResultAssignedBankAccount() {
    }
    RestApiResultAssignedBankAccount.getAttributeTypeMap = function () {
        return RestApiResultAssignedBankAccount.attributeTypeMap;
    };
    RestApiResultAssignedBankAccount.discriminator = undefined;
    RestApiResultAssignedBankAccount.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "AssignedBankAccount"
        }
    ];
    return RestApiResultAssignedBankAccount;
}());
exports.RestApiResultAssignedBankAccount = RestApiResultAssignedBankAccount;
var RestApiResultBankAccountDetail = (function () {
    function RestApiResultBankAccountDetail() {
    }
    RestApiResultBankAccountDetail.getAttributeTypeMap = function () {
        return RestApiResultBankAccountDetail.attributeTypeMap;
    };
    RestApiResultBankAccountDetail.discriminator = undefined;
    RestApiResultBankAccountDetail.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "BankAccountDetail"
        }
    ];
    return RestApiResultBankAccountDetail;
}());
exports.RestApiResultBankAccountDetail = RestApiResultBankAccountDetail;
var RestApiResultBluetoothTerminalStatus = (function () {
    function RestApiResultBluetoothTerminalStatus() {
    }
    RestApiResultBluetoothTerminalStatus.getAttributeTypeMap = function () {
        return RestApiResultBluetoothTerminalStatus.attributeTypeMap;
    };
    RestApiResultBluetoothTerminalStatus.discriminator = undefined;
    RestApiResultBluetoothTerminalStatus.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "BluetoothTerminalStatus"
        }
    ];
    return RestApiResultBluetoothTerminalStatus;
}());
exports.RestApiResultBluetoothTerminalStatus = RestApiResultBluetoothTerminalStatus;
var RestApiResultBusinessHoursOverride = (function () {
    function RestApiResultBusinessHoursOverride() {
    }
    RestApiResultBusinessHoursOverride.getAttributeTypeMap = function () {
        return RestApiResultBusinessHoursOverride.attributeTypeMap;
    };
    RestApiResultBusinessHoursOverride.discriminator = undefined;
    RestApiResultBusinessHoursOverride.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "BusinessHoursOverride"
        }
    ];
    return RestApiResultBusinessHoursOverride;
}());
exports.RestApiResultBusinessHoursOverride = RestApiResultBusinessHoursOverride;
var RestApiResultBusinessHoursPeriod = (function () {
    function RestApiResultBusinessHoursPeriod() {
    }
    RestApiResultBusinessHoursPeriod.getAttributeTypeMap = function () {
        return RestApiResultBusinessHoursPeriod.attributeTypeMap;
    };
    RestApiResultBusinessHoursPeriod.discriminator = undefined;
    RestApiResultBusinessHoursPeriod.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "BusinessHoursPeriod"
        }
    ];
    return RestApiResultBusinessHoursPeriod;
}());
exports.RestApiResultBusinessHoursPeriod = RestApiResultBusinessHoursPeriod;
var RestApiResultCardReader = (function () {
    function RestApiResultCardReader() {
    }
    RestApiResultCardReader.getAttributeTypeMap = function () {
        return RestApiResultCardReader.attributeTypeMap;
    };
    RestApiResultCardReader.discriminator = undefined;
    RestApiResultCardReader.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "CardReader"
        }
    ];
    return RestApiResultCardReader;
}());
exports.RestApiResultCardReader = RestApiResultCardReader;
var RestApiResultCatalogItem = (function () {
    function RestApiResultCatalogItem() {
    }
    RestApiResultCatalogItem.getAttributeTypeMap = function () {
        return RestApiResultCatalogItem.attributeTypeMap;
    };
    RestApiResultCatalogItem.discriminator = undefined;
    RestApiResultCatalogItem.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "CatalogItem"
        }
    ];
    return RestApiResultCatalogItem;
}());
exports.RestApiResultCatalogItem = RestApiResultCatalogItem;
var RestApiResultChannel = (function () {
    function RestApiResultChannel() {
    }
    RestApiResultChannel.getAttributeTypeMap = function () {
        return RestApiResultChannel.attributeTypeMap;
    };
    RestApiResultChannel.discriminator = undefined;
    RestApiResultChannel.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Channel"
        }
    ];
    return RestApiResultChannel;
}());
exports.RestApiResultChannel = RestApiResultChannel;
var RestApiResultClientDevice = (function () {
    function RestApiResultClientDevice() {
    }
    RestApiResultClientDevice.getAttributeTypeMap = function () {
        return RestApiResultClientDevice.attributeTypeMap;
    };
    RestApiResultClientDevice.discriminator = undefined;
    RestApiResultClientDevice.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "ClientDevice"
        }
    ];
    return RestApiResultClientDevice;
}());
exports.RestApiResultClientDevice = RestApiResultClientDevice;
var RestApiResultClientDeviceEnrollmentResult = (function () {
    function RestApiResultClientDeviceEnrollmentResult() {
    }
    RestApiResultClientDeviceEnrollmentResult.getAttributeTypeMap = function () {
        return RestApiResultClientDeviceEnrollmentResult.attributeTypeMap;
    };
    RestApiResultClientDeviceEnrollmentResult.discriminator = undefined;
    RestApiResultClientDeviceEnrollmentResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "ClientDeviceEnrollmentResult"
        }
    ];
    return RestApiResultClientDeviceEnrollmentResult;
}());
exports.RestApiResultClientDeviceEnrollmentResult = RestApiResultClientDeviceEnrollmentResult;
var RestApiResultCoordinates = (function () {
    function RestApiResultCoordinates() {
    }
    RestApiResultCoordinates.getAttributeTypeMap = function () {
        return RestApiResultCoordinates.attributeTypeMap;
    };
    RestApiResultCoordinates.discriminator = undefined;
    RestApiResultCoordinates.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Coordinates"
        }
    ];
    return RestApiResultCoordinates;
}());
exports.RestApiResultCoordinates = RestApiResultCoordinates;
var RestApiResultCountryFormResponse = (function () {
    function RestApiResultCountryFormResponse() {
    }
    RestApiResultCountryFormResponse.getAttributeTypeMap = function () {
        return RestApiResultCountryFormResponse.attributeTypeMap;
    };
    RestApiResultCountryFormResponse.discriminator = undefined;
    RestApiResultCountryFormResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "CountryFormResponse"
        }
    ];
    return RestApiResultCountryFormResponse;
}());
exports.RestApiResultCountryFormResponse = RestApiResultCountryFormResponse;
var RestApiResultCreatedMenuSectionItems = (function () {
    function RestApiResultCreatedMenuSectionItems() {
    }
    RestApiResultCreatedMenuSectionItems.getAttributeTypeMap = function () {
        return RestApiResultCreatedMenuSectionItems.attributeTypeMap;
    };
    RestApiResultCreatedMenuSectionItems.discriminator = undefined;
    RestApiResultCreatedMenuSectionItems.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "CreatedMenuSectionItems"
        }
    ];
    return RestApiResultCreatedMenuSectionItems;
}());
exports.RestApiResultCreatedMenuSectionItems = RestApiResultCreatedMenuSectionItems;
var RestApiResultCrossSellMenuItems = (function () {
    function RestApiResultCrossSellMenuItems() {
    }
    RestApiResultCrossSellMenuItems.getAttributeTypeMap = function () {
        return RestApiResultCrossSellMenuItems.attributeTypeMap;
    };
    RestApiResultCrossSellMenuItems.discriminator = undefined;
    RestApiResultCrossSellMenuItems.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "CrossSellMenuItems"
        }
    ];
    return RestApiResultCrossSellMenuItems;
}());
exports.RestApiResultCrossSellMenuItems = RestApiResultCrossSellMenuItems;
var RestApiResultCustomer = (function () {
    function RestApiResultCustomer() {
    }
    RestApiResultCustomer.getAttributeTypeMap = function () {
        return RestApiResultCustomer.attributeTypeMap;
    };
    RestApiResultCustomer.discriminator = undefined;
    RestApiResultCustomer.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Customer"
        }
    ];
    return RestApiResultCustomer;
}());
exports.RestApiResultCustomer = RestApiResultCustomer;
var RestApiResultDeliveryZone = (function () {
    function RestApiResultDeliveryZone() {
    }
    RestApiResultDeliveryZone.getAttributeTypeMap = function () {
        return RestApiResultDeliveryZone.attributeTypeMap;
    };
    RestApiResultDeliveryZone.discriminator = undefined;
    RestApiResultDeliveryZone.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "DeliveryZone"
        }
    ];
    return RestApiResultDeliveryZone;
}());
exports.RestApiResultDeliveryZone = RestApiResultDeliveryZone;
var RestApiResultDnsRecordInformation = (function () {
    function RestApiResultDnsRecordInformation() {
    }
    RestApiResultDnsRecordInformation.getAttributeTypeMap = function () {
        return RestApiResultDnsRecordInformation.attributeTypeMap;
    };
    RestApiResultDnsRecordInformation.discriminator = undefined;
    RestApiResultDnsRecordInformation.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "DnsRecordInformation"
        }
    ];
    return RestApiResultDnsRecordInformation;
}());
exports.RestApiResultDnsRecordInformation = RestApiResultDnsRecordInformation;
var RestApiResultFulfillmentStatesConfiguration = (function () {
    function RestApiResultFulfillmentStatesConfiguration() {
    }
    RestApiResultFulfillmentStatesConfiguration.getAttributeTypeMap = function () {
        return RestApiResultFulfillmentStatesConfiguration.attributeTypeMap;
    };
    RestApiResultFulfillmentStatesConfiguration.discriminator = undefined;
    RestApiResultFulfillmentStatesConfiguration.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "FulfillmentStatesConfiguration"
        }
    ];
    return RestApiResultFulfillmentStatesConfiguration;
}());
exports.RestApiResultFulfillmentStatesConfiguration = RestApiResultFulfillmentStatesConfiguration;
var RestApiResultGroup = (function () {
    function RestApiResultGroup() {
    }
    RestApiResultGroup.getAttributeTypeMap = function () {
        return RestApiResultGroup.attributeTypeMap;
    };
    RestApiResultGroup.discriminator = undefined;
    RestApiResultGroup.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Group"
        }
    ];
    return RestApiResultGroup;
}());
exports.RestApiResultGroup = RestApiResultGroup;
var RestApiResultHomeStatistics = (function () {
    function RestApiResultHomeStatistics() {
    }
    RestApiResultHomeStatistics.getAttributeTypeMap = function () {
        return RestApiResultHomeStatistics.attributeTypeMap;
    };
    RestApiResultHomeStatistics.discriminator = undefined;
    RestApiResultHomeStatistics.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "HomeStatistics"
        }
    ];
    return RestApiResultHomeStatistics;
}());
exports.RestApiResultHomeStatistics = RestApiResultHomeStatistics;
var RestApiResultHydraConfig = (function () {
    function RestApiResultHydraConfig() {
    }
    RestApiResultHydraConfig.getAttributeTypeMap = function () {
        return RestApiResultHydraConfig.attributeTypeMap;
    };
    RestApiResultHydraConfig.discriminator = undefined;
    RestApiResultHydraConfig.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "HydraConfig"
        }
    ];
    return RestApiResultHydraConfig;
}());
exports.RestApiResultHydraConfig = RestApiResultHydraConfig;
var RestApiResultHydraDeviceDetails = (function () {
    function RestApiResultHydraDeviceDetails() {
    }
    RestApiResultHydraDeviceDetails.getAttributeTypeMap = function () {
        return RestApiResultHydraDeviceDetails.attributeTypeMap;
    };
    RestApiResultHydraDeviceDetails.discriminator = undefined;
    RestApiResultHydraDeviceDetails.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "HydraDeviceDetails"
        }
    ];
    return RestApiResultHydraDeviceDetails;
}());
exports.RestApiResultHydraDeviceDetails = RestApiResultHydraDeviceDetails;
var RestApiResultHydraStatus = (function () {
    function RestApiResultHydraStatus() {
    }
    RestApiResultHydraStatus.getAttributeTypeMap = function () {
        return RestApiResultHydraStatus.attributeTypeMap;
    };
    RestApiResultHydraStatus.discriminator = undefined;
    RestApiResultHydraStatus.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "HydraStatus"
        }
    ];
    return RestApiResultHydraStatus;
}());
exports.RestApiResultHydraStatus = RestApiResultHydraStatus;
var RestApiResultIndexPage = (function () {
    function RestApiResultIndexPage() {
    }
    RestApiResultIndexPage.getAttributeTypeMap = function () {
        return RestApiResultIndexPage.attributeTypeMap;
    };
    RestApiResultIndexPage.discriminator = undefined;
    RestApiResultIndexPage.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "IndexPage"
        }
    ];
    return RestApiResultIndexPage;
}());
exports.RestApiResultIndexPage = RestApiResultIndexPage;
var RestApiResultIndexPageBase = (function () {
    function RestApiResultIndexPageBase() {
    }
    RestApiResultIndexPageBase.getAttributeTypeMap = function () {
        return RestApiResultIndexPageBase.attributeTypeMap;
    };
    RestApiResultIndexPageBase.discriminator = undefined;
    RestApiResultIndexPageBase.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "IndexPageBase"
        }
    ];
    return RestApiResultIndexPageBase;
}());
exports.RestApiResultIndexPageBase = RestApiResultIndexPageBase;
var RestApiResultIntercomUserHash = (function () {
    function RestApiResultIntercomUserHash() {
    }
    RestApiResultIntercomUserHash.getAttributeTypeMap = function () {
        return RestApiResultIntercomUserHash.attributeTypeMap;
    };
    RestApiResultIntercomUserHash.discriminator = undefined;
    RestApiResultIntercomUserHash.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "IntercomUserHash"
        }
    ];
    return RestApiResultIntercomUserHash;
}());
exports.RestApiResultIntercomUserHash = RestApiResultIntercomUserHash;
var RestApiResultJobResponse = (function () {
    function RestApiResultJobResponse() {
    }
    RestApiResultJobResponse.getAttributeTypeMap = function () {
        return RestApiResultJobResponse.attributeTypeMap;
    };
    RestApiResultJobResponse.discriminator = undefined;
    RestApiResultJobResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "JobResponse"
        }
    ];
    return RestApiResultJobResponse;
}());
exports.RestApiResultJobResponse = RestApiResultJobResponse;
var RestApiResultKioskIotConnectionParameters = (function () {
    function RestApiResultKioskIotConnectionParameters() {
    }
    RestApiResultKioskIotConnectionParameters.getAttributeTypeMap = function () {
        return RestApiResultKioskIotConnectionParameters.attributeTypeMap;
    };
    RestApiResultKioskIotConnectionParameters.discriminator = undefined;
    RestApiResultKioskIotConnectionParameters.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "KioskIotConnectionParameters"
        }
    ];
    return RestApiResultKioskIotConnectionParameters;
}());
exports.RestApiResultKioskIotConnectionParameters = RestApiResultKioskIotConnectionParameters;
var RestApiResultKioskSettings = (function () {
    function RestApiResultKioskSettings() {
    }
    RestApiResultKioskSettings.getAttributeTypeMap = function () {
        return RestApiResultKioskSettings.attributeTypeMap;
    };
    RestApiResultKioskSettings.discriminator = undefined;
    RestApiResultKioskSettings.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "KioskSettings"
        }
    ];
    return RestApiResultKioskSettings;
}());
exports.RestApiResultKioskSettings = RestApiResultKioskSettings;
var RestApiResultLightspeedSettings = (function () {
    function RestApiResultLightspeedSettings() {
    }
    RestApiResultLightspeedSettings.getAttributeTypeMap = function () {
        return RestApiResultLightspeedSettings.attributeTypeMap;
    };
    RestApiResultLightspeedSettings.discriminator = undefined;
    RestApiResultLightspeedSettings.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "LightspeedSettings"
        }
    ];
    return RestApiResultLightspeedSettings;
}());
exports.RestApiResultLightspeedSettings = RestApiResultLightspeedSettings;
var RestApiResultLocationArea = (function () {
    function RestApiResultLocationArea() {
    }
    RestApiResultLocationArea.getAttributeTypeMap = function () {
        return RestApiResultLocationArea.attributeTypeMap;
    };
    RestApiResultLocationArea.discriminator = undefined;
    RestApiResultLocationArea.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "LocationArea"
        }
    ];
    return RestApiResultLocationArea;
}());
exports.RestApiResultLocationArea = RestApiResultLocationArea;
var RestApiResultLocationAreaLocation = (function () {
    function RestApiResultLocationAreaLocation() {
    }
    RestApiResultLocationAreaLocation.getAttributeTypeMap = function () {
        return RestApiResultLocationAreaLocation.attributeTypeMap;
    };
    RestApiResultLocationAreaLocation.discriminator = undefined;
    RestApiResultLocationAreaLocation.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "LocationAreaLocation"
        }
    ];
    return RestApiResultLocationAreaLocation;
}());
exports.RestApiResultLocationAreaLocation = RestApiResultLocationAreaLocation;
var RestApiResultLocationAreaWithLocations = (function () {
    function RestApiResultLocationAreaWithLocations() {
    }
    RestApiResultLocationAreaWithLocations.getAttributeTypeMap = function () {
        return RestApiResultLocationAreaWithLocations.attributeTypeMap;
    };
    RestApiResultLocationAreaWithLocations.discriminator = undefined;
    RestApiResultLocationAreaWithLocations.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "LocationAreaWithLocations"
        }
    ];
    return RestApiResultLocationAreaWithLocations;
}());
exports.RestApiResultLocationAreaWithLocations = RestApiResultLocationAreaWithLocations;
var RestApiResultLoyaltyCampaign = (function () {
    function RestApiResultLoyaltyCampaign() {
    }
    RestApiResultLoyaltyCampaign.getAttributeTypeMap = function () {
        return RestApiResultLoyaltyCampaign.attributeTypeMap;
    };
    RestApiResultLoyaltyCampaign.discriminator = undefined;
    RestApiResultLoyaltyCampaign.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "LoyaltyCampaign"
        }
    ];
    return RestApiResultLoyaltyCampaign;
}());
exports.RestApiResultLoyaltyCampaign = RestApiResultLoyaltyCampaign;
var RestApiResultMappedLocation = (function () {
    function RestApiResultMappedLocation() {
    }
    RestApiResultMappedLocation.getAttributeTypeMap = function () {
        return RestApiResultMappedLocation.attributeTypeMap;
    };
    RestApiResultMappedLocation.discriminator = undefined;
    RestApiResultMappedLocation.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MappedLocation"
        }
    ];
    return RestApiResultMappedLocation;
}());
exports.RestApiResultMappedLocation = RestApiResultMappedLocation;
var RestApiResultMenu = (function () {
    function RestApiResultMenu() {
    }
    RestApiResultMenu.getAttributeTypeMap = function () {
        return RestApiResultMenu.attributeTypeMap;
    };
    RestApiResultMenu.discriminator = undefined;
    RestApiResultMenu.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Menu"
        }
    ];
    return RestApiResultMenu;
}());
exports.RestApiResultMenu = RestApiResultMenu;
var RestApiResultMenuItemOptionSet = (function () {
    function RestApiResultMenuItemOptionSet() {
    }
    RestApiResultMenuItemOptionSet.getAttributeTypeMap = function () {
        return RestApiResultMenuItemOptionSet.attributeTypeMap;
    };
    RestApiResultMenuItemOptionSet.discriminator = undefined;
    RestApiResultMenuItemOptionSet.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MenuItemOptionSet"
        }
    ];
    return RestApiResultMenuItemOptionSet;
}());
exports.RestApiResultMenuItemOptionSet = RestApiResultMenuItemOptionSet;
var RestApiResultMenuItemOptionSetItem = (function () {
    function RestApiResultMenuItemOptionSetItem() {
    }
    RestApiResultMenuItemOptionSetItem.getAttributeTypeMap = function () {
        return RestApiResultMenuItemOptionSetItem.attributeTypeMap;
    };
    RestApiResultMenuItemOptionSetItem.discriminator = undefined;
    RestApiResultMenuItemOptionSetItem.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MenuItemOptionSetItem"
        }
    ];
    return RestApiResultMenuItemOptionSetItem;
}());
exports.RestApiResultMenuItemOptionSetItem = RestApiResultMenuItemOptionSetItem;
var RestApiResultMenuNutritionInfoHeader = (function () {
    function RestApiResultMenuNutritionInfoHeader() {
    }
    RestApiResultMenuNutritionInfoHeader.getAttributeTypeMap = function () {
        return RestApiResultMenuNutritionInfoHeader.attributeTypeMap;
    };
    RestApiResultMenuNutritionInfoHeader.discriminator = undefined;
    RestApiResultMenuNutritionInfoHeader.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MenuNutritionInfoHeader"
        }
    ];
    return RestApiResultMenuNutritionInfoHeader;
}());
exports.RestApiResultMenuNutritionInfoHeader = RestApiResultMenuNutritionInfoHeader;
var RestApiResultMenuSection = (function () {
    function RestApiResultMenuSection() {
    }
    RestApiResultMenuSection.getAttributeTypeMap = function () {
        return RestApiResultMenuSection.attributeTypeMap;
    };
    RestApiResultMenuSection.discriminator = undefined;
    RestApiResultMenuSection.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MenuSection"
        }
    ];
    return RestApiResultMenuSection;
}());
exports.RestApiResultMenuSection = RestApiResultMenuSection;
var RestApiResultMenuSectionAvailability = (function () {
    function RestApiResultMenuSectionAvailability() {
    }
    RestApiResultMenuSectionAvailability.getAttributeTypeMap = function () {
        return RestApiResultMenuSectionAvailability.attributeTypeMap;
    };
    RestApiResultMenuSectionAvailability.discriminator = undefined;
    RestApiResultMenuSectionAvailability.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MenuSectionAvailability"
        }
    ];
    return RestApiResultMenuSectionAvailability;
}());
exports.RestApiResultMenuSectionAvailability = RestApiResultMenuSectionAvailability;
var RestApiResultMenuSectionItem = (function () {
    function RestApiResultMenuSectionItem() {
    }
    RestApiResultMenuSectionItem.getAttributeTypeMap = function () {
        return RestApiResultMenuSectionItem.attributeTypeMap;
    };
    RestApiResultMenuSectionItem.discriminator = undefined;
    RestApiResultMenuSectionItem.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MenuSectionItem"
        }
    ];
    return RestApiResultMenuSectionItem;
}());
exports.RestApiResultMenuSectionItem = RestApiResultMenuSectionItem;
var RestApiResultMetadata = (function () {
    function RestApiResultMetadata() {
    }
    RestApiResultMetadata.getAttributeTypeMap = function () {
        return RestApiResultMetadata.attributeTypeMap;
    };
    RestApiResultMetadata.discriminator = undefined;
    RestApiResultMetadata.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Metadata"
        }
    ];
    return RestApiResultMetadata;
}());
exports.RestApiResultMetadata = RestApiResultMetadata;
var RestApiResultMetafieldDefinition = (function () {
    function RestApiResultMetafieldDefinition() {
    }
    RestApiResultMetafieldDefinition.getAttributeTypeMap = function () {
        return RestApiResultMetafieldDefinition.attributeTypeMap;
    };
    RestApiResultMetafieldDefinition.discriminator = undefined;
    RestApiResultMetafieldDefinition.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MetafieldDefinition"
        }
    ];
    return RestApiResultMetafieldDefinition;
}());
exports.RestApiResultMetafieldDefinition = RestApiResultMetafieldDefinition;
var RestApiResultMobileAppsImage = (function () {
    function RestApiResultMobileAppsImage() {
    }
    RestApiResultMobileAppsImage.getAttributeTypeMap = function () {
        return RestApiResultMobileAppsImage.attributeTypeMap;
    };
    RestApiResultMobileAppsImage.discriminator = undefined;
    RestApiResultMobileAppsImage.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MobileAppsImage"
        }
    ];
    return RestApiResultMobileAppsImage;
}());
exports.RestApiResultMobileAppsImage = RestApiResultMobileAppsImage;
var RestApiResultMobileAppsSubmission = (function () {
    function RestApiResultMobileAppsSubmission() {
    }
    RestApiResultMobileAppsSubmission.getAttributeTypeMap = function () {
        return RestApiResultMobileAppsSubmission.attributeTypeMap;
    };
    RestApiResultMobileAppsSubmission.discriminator = undefined;
    RestApiResultMobileAppsSubmission.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MobileAppsSubmission"
        }
    ];
    return RestApiResultMobileAppsSubmission;
}());
exports.RestApiResultMobileAppsSubmission = RestApiResultMobileAppsSubmission;
var RestApiResultMobileAppsSubmissionDetails = (function () {
    function RestApiResultMobileAppsSubmissionDetails() {
    }
    RestApiResultMobileAppsSubmissionDetails.getAttributeTypeMap = function () {
        return RestApiResultMobileAppsSubmissionDetails.attributeTypeMap;
    };
    RestApiResultMobileAppsSubmissionDetails.discriminator = undefined;
    RestApiResultMobileAppsSubmissionDetails.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MobileAppsSubmissionDetails"
        }
    ];
    return RestApiResultMobileAppsSubmissionDetails;
}());
exports.RestApiResultMobileAppsSubmissionDetails = RestApiResultMobileAppsSubmissionDetails;
var RestApiResultMobileAppsSubmissionStatus = (function () {
    function RestApiResultMobileAppsSubmissionStatus() {
    }
    RestApiResultMobileAppsSubmissionStatus.getAttributeTypeMap = function () {
        return RestApiResultMobileAppsSubmissionStatus.attributeTypeMap;
    };
    RestApiResultMobileAppsSubmissionStatus.discriminator = undefined;
    RestApiResultMobileAppsSubmissionStatus.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "MobileAppsSubmissionStatus"
        }
    ];
    return RestApiResultMobileAppsSubmissionStatus;
}());
exports.RestApiResultMobileAppsSubmissionStatus = RestApiResultMobileAppsSubmissionStatus;
var RestApiResultModelBase = (function () {
    function RestApiResultModelBase() {
    }
    RestApiResultModelBase.getAttributeTypeMap = function () {
        return RestApiResultModelBase.attributeTypeMap;
    };
    RestApiResultModelBase.discriminator = undefined;
    RestApiResultModelBase.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "ModelBase"
        }
    ];
    return RestApiResultModelBase;
}());
exports.RestApiResultModelBase = RestApiResultModelBase;
var RestApiResultNutritionInfo = (function () {
    function RestApiResultNutritionInfo() {
    }
    RestApiResultNutritionInfo.getAttributeTypeMap = function () {
        return RestApiResultNutritionInfo.attributeTypeMap;
    };
    RestApiResultNutritionInfo.discriminator = undefined;
    RestApiResultNutritionInfo.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "NutritionInfo"
        }
    ];
    return RestApiResultNutritionInfo;
}());
exports.RestApiResultNutritionInfo = RestApiResultNutritionInfo;
var RestApiResultOAuthApp = (function () {
    function RestApiResultOAuthApp() {
    }
    RestApiResultOAuthApp.getAttributeTypeMap = function () {
        return RestApiResultOAuthApp.attributeTypeMap;
    };
    RestApiResultOAuthApp.discriminator = undefined;
    RestApiResultOAuthApp.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OAuthApp"
        }
    ];
    return RestApiResultOAuthApp;
}());
exports.RestApiResultOAuthApp = RestApiResultOAuthApp;
var RestApiResultOauthClientRedirectUri = (function () {
    function RestApiResultOauthClientRedirectUri() {
    }
    RestApiResultOauthClientRedirectUri.getAttributeTypeMap = function () {
        return RestApiResultOauthClientRedirectUri.attributeTypeMap;
    };
    RestApiResultOauthClientRedirectUri.discriminator = undefined;
    RestApiResultOauthClientRedirectUri.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OauthClientRedirectUri"
        }
    ];
    return RestApiResultOauthClientRedirectUri;
}());
exports.RestApiResultOauthClientRedirectUri = RestApiResultOauthClientRedirectUri;
var RestApiResultOktaPortalFeatureFlag = (function () {
    function RestApiResultOktaPortalFeatureFlag() {
    }
    RestApiResultOktaPortalFeatureFlag.getAttributeTypeMap = function () {
        return RestApiResultOktaPortalFeatureFlag.attributeTypeMap;
    };
    RestApiResultOktaPortalFeatureFlag.discriminator = undefined;
    RestApiResultOktaPortalFeatureFlag.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OktaPortalFeatureFlag"
        }
    ];
    return RestApiResultOktaPortalFeatureFlag;
}());
exports.RestApiResultOktaPortalFeatureFlag = RestApiResultOktaPortalFeatureFlag;
var RestApiResultOrder = (function () {
    function RestApiResultOrder() {
    }
    RestApiResultOrder.getAttributeTypeMap = function () {
        return RestApiResultOrder.attributeTypeMap;
    };
    RestApiResultOrder.discriminator = undefined;
    RestApiResultOrder.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Order"
        }
    ];
    return RestApiResultOrder;
}());
exports.RestApiResultOrder = RestApiResultOrder;
var RestApiResultOrderBatch = (function () {
    function RestApiResultOrderBatch() {
    }
    RestApiResultOrderBatch.getAttributeTypeMap = function () {
        return RestApiResultOrderBatch.attributeTypeMap;
    };
    RestApiResultOrderBatch.discriminator = undefined;
    RestApiResultOrderBatch.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OrderBatch"
        }
    ];
    return RestApiResultOrderBatch;
}());
exports.RestApiResultOrderBatch = RestApiResultOrderBatch;
var RestApiResultOrderBatchingConfiguration = (function () {
    function RestApiResultOrderBatchingConfiguration() {
    }
    RestApiResultOrderBatchingConfiguration.getAttributeTypeMap = function () {
        return RestApiResultOrderBatchingConfiguration.attributeTypeMap;
    };
    RestApiResultOrderBatchingConfiguration.discriminator = undefined;
    RestApiResultOrderBatchingConfiguration.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OrderBatchingConfiguration"
        }
    ];
    return RestApiResultOrderBatchingConfiguration;
}());
exports.RestApiResultOrderBatchingConfiguration = RestApiResultOrderBatchingConfiguration;
var RestApiResultOrderDeliveryInformation = (function () {
    function RestApiResultOrderDeliveryInformation() {
    }
    RestApiResultOrderDeliveryInformation.getAttributeTypeMap = function () {
        return RestApiResultOrderDeliveryInformation.attributeTypeMap;
    };
    RestApiResultOrderDeliveryInformation.discriminator = undefined;
    RestApiResultOrderDeliveryInformation.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OrderDeliveryInformation"
        }
    ];
    return RestApiResultOrderDeliveryInformation;
}());
exports.RestApiResultOrderDeliveryInformation = RestApiResultOrderDeliveryInformation;
var RestApiResultOrderFulfillmentStatus = (function () {
    function RestApiResultOrderFulfillmentStatus() {
    }
    RestApiResultOrderFulfillmentStatus.getAttributeTypeMap = function () {
        return RestApiResultOrderFulfillmentStatus.attributeTypeMap;
    };
    RestApiResultOrderFulfillmentStatus.discriminator = undefined;
    RestApiResultOrderFulfillmentStatus.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OrderFulfillmentStatus"
        }
    ];
    return RestApiResultOrderFulfillmentStatus;
}());
exports.RestApiResultOrderFulfillmentStatus = RestApiResultOrderFulfillmentStatus;
var RestApiResultOrderFulfillmentStatusWithConfigurationActions = (function () {
    function RestApiResultOrderFulfillmentStatusWithConfigurationActions() {
    }
    RestApiResultOrderFulfillmentStatusWithConfigurationActions.getAttributeTypeMap = function () {
        return RestApiResultOrderFulfillmentStatusWithConfigurationActions.attributeTypeMap;
    };
    RestApiResultOrderFulfillmentStatusWithConfigurationActions.discriminator = undefined;
    RestApiResultOrderFulfillmentStatusWithConfigurationActions.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OrderFulfillmentStatusWithConfigurationActions"
        }
    ];
    return RestApiResultOrderFulfillmentStatusWithConfigurationActions;
}());
exports.RestApiResultOrderFulfillmentStatusWithConfigurationActions = RestApiResultOrderFulfillmentStatusWithConfigurationActions;
var RestApiResultOrderIngestSubmitOrderResponse = (function () {
    function RestApiResultOrderIngestSubmitOrderResponse() {
    }
    RestApiResultOrderIngestSubmitOrderResponse.getAttributeTypeMap = function () {
        return RestApiResultOrderIngestSubmitOrderResponse.attributeTypeMap;
    };
    RestApiResultOrderIngestSubmitOrderResponse.discriminator = undefined;
    RestApiResultOrderIngestSubmitOrderResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OrderIngestSubmitOrderResponse"
        }
    ];
    return RestApiResultOrderIngestSubmitOrderResponse;
}());
exports.RestApiResultOrderIngestSubmitOrderResponse = RestApiResultOrderIngestSubmitOrderResponse;
var RestApiResultOrderPaymentInformation = (function () {
    function RestApiResultOrderPaymentInformation() {
    }
    RestApiResultOrderPaymentInformation.getAttributeTypeMap = function () {
        return RestApiResultOrderPaymentInformation.attributeTypeMap;
    };
    RestApiResultOrderPaymentInformation.discriminator = undefined;
    RestApiResultOrderPaymentInformation.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "OrderPaymentInformation"
        }
    ];
    return RestApiResultOrderPaymentInformation;
}());
exports.RestApiResultOrderPaymentInformation = RestApiResultOrderPaymentInformation;
var RestApiResultPaymentIntent = (function () {
    function RestApiResultPaymentIntent() {
    }
    RestApiResultPaymentIntent.getAttributeTypeMap = function () {
        return RestApiResultPaymentIntent.attributeTypeMap;
    };
    RestApiResultPaymentIntent.discriminator = undefined;
    RestApiResultPaymentIntent.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "PaymentIntent"
        }
    ];
    return RestApiResultPaymentIntent;
}());
exports.RestApiResultPaymentIntent = RestApiResultPaymentIntent;
var RestApiResultPaymentTerminalDetails = (function () {
    function RestApiResultPaymentTerminalDetails() {
    }
    RestApiResultPaymentTerminalDetails.getAttributeTypeMap = function () {
        return RestApiResultPaymentTerminalDetails.attributeTypeMap;
    };
    RestApiResultPaymentTerminalDetails.discriminator = undefined;
    RestApiResultPaymentTerminalDetails.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "PaymentTerminalDetails"
        }
    ];
    return RestApiResultPaymentTerminalDetails;
}());
exports.RestApiResultPaymentTerminalDetails = RestApiResultPaymentTerminalDetails;
var RestApiResultPaymentTerminalTransactionDetails = (function () {
    function RestApiResultPaymentTerminalTransactionDetails() {
    }
    RestApiResultPaymentTerminalTransactionDetails.getAttributeTypeMap = function () {
        return RestApiResultPaymentTerminalTransactionDetails.attributeTypeMap;
    };
    RestApiResultPaymentTerminalTransactionDetails.discriminator = undefined;
    RestApiResultPaymentTerminalTransactionDetails.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "PaymentTerminalTransactionDetails"
        }
    ];
    return RestApiResultPaymentTerminalTransactionDetails;
}());
exports.RestApiResultPaymentTerminalTransactionDetails = RestApiResultPaymentTerminalTransactionDetails;
var RestApiResultPreOrderConfig = (function () {
    function RestApiResultPreOrderConfig() {
    }
    RestApiResultPreOrderConfig.getAttributeTypeMap = function () {
        return RestApiResultPreOrderConfig.attributeTypeMap;
    };
    RestApiResultPreOrderConfig.discriminator = undefined;
    RestApiResultPreOrderConfig.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "PreOrderConfig"
        }
    ];
    return RestApiResultPreOrderConfig;
}());
exports.RestApiResultPreOrderConfig = RestApiResultPreOrderConfig;
var RestApiResultProcessingFeeConfig = (function () {
    function RestApiResultProcessingFeeConfig() {
    }
    RestApiResultProcessingFeeConfig.getAttributeTypeMap = function () {
        return RestApiResultProcessingFeeConfig.attributeTypeMap;
    };
    RestApiResultProcessingFeeConfig.discriminator = undefined;
    RestApiResultProcessingFeeConfig.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "ProcessingFeeConfig"
        }
    ];
    return RestApiResultProcessingFeeConfig;
}());
exports.RestApiResultProcessingFeeConfig = RestApiResultProcessingFeeConfig;
var RestApiResultProduct = (function () {
    function RestApiResultProduct() {
    }
    RestApiResultProduct.getAttributeTypeMap = function () {
        return RestApiResultProduct.attributeTypeMap;
    };
    RestApiResultProduct.discriminator = undefined;
    RestApiResultProduct.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Product"
        }
    ];
    return RestApiResultProduct;
}());
exports.RestApiResultProduct = RestApiResultProduct;
var RestApiResultPushNotificationResponse = (function () {
    function RestApiResultPushNotificationResponse() {
    }
    RestApiResultPushNotificationResponse.getAttributeTypeMap = function () {
        return RestApiResultPushNotificationResponse.attributeTypeMap;
    };
    RestApiResultPushNotificationResponse.discriminator = undefined;
    RestApiResultPushNotificationResponse.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "PushNotificationResponse"
        }
    ];
    return RestApiResultPushNotificationResponse;
}());
exports.RestApiResultPushNotificationResponse = RestApiResultPushNotificationResponse;
var RestApiResultRedeemInvitationResult = (function () {
    function RestApiResultRedeemInvitationResult() {
    }
    RestApiResultRedeemInvitationResult.getAttributeTypeMap = function () {
        return RestApiResultRedeemInvitationResult.attributeTypeMap;
    };
    RestApiResultRedeemInvitationResult.discriminator = undefined;
    RestApiResultRedeemInvitationResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "RedeemInvitationResult"
        }
    ];
    return RestApiResultRedeemInvitationResult;
}());
exports.RestApiResultRedeemInvitationResult = RestApiResultRedeemInvitationResult;
var RestApiResultRestApiIntegerResult = (function () {
    function RestApiResultRestApiIntegerResult() {
    }
    RestApiResultRestApiIntegerResult.getAttributeTypeMap = function () {
        return RestApiResultRestApiIntegerResult.attributeTypeMap;
    };
    RestApiResultRestApiIntegerResult.discriminator = undefined;
    RestApiResultRestApiIntegerResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "RestApiIntegerResult"
        }
    ];
    return RestApiResultRestApiIntegerResult;
}());
exports.RestApiResultRestApiIntegerResult = RestApiResultRestApiIntegerResult;
var RestApiResultRestaurantVoucherPayGreenConfiguration = (function () {
    function RestApiResultRestaurantVoucherPayGreenConfiguration() {
    }
    RestApiResultRestaurantVoucherPayGreenConfiguration.getAttributeTypeMap = function () {
        return RestApiResultRestaurantVoucherPayGreenConfiguration.attributeTypeMap;
    };
    RestApiResultRestaurantVoucherPayGreenConfiguration.discriminator = undefined;
    RestApiResultRestaurantVoucherPayGreenConfiguration.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "RestaurantVoucherPayGreenConfiguration"
        }
    ];
    return RestApiResultRestaurantVoucherPayGreenConfiguration;
}());
exports.RestApiResultRestaurantVoucherPayGreenConfiguration = RestApiResultRestaurantVoucherPayGreenConfiguration;
var RestApiResultRestaurantVoucherPayGreenStoreConfiguration = (function () {
    function RestApiResultRestaurantVoucherPayGreenStoreConfiguration() {
    }
    RestApiResultRestaurantVoucherPayGreenStoreConfiguration.getAttributeTypeMap = function () {
        return RestApiResultRestaurantVoucherPayGreenStoreConfiguration.attributeTypeMap;
    };
    RestApiResultRestaurantVoucherPayGreenStoreConfiguration.discriminator = undefined;
    RestApiResultRestaurantVoucherPayGreenStoreConfiguration.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "RestaurantVoucherPayGreenStoreConfiguration"
        }
    ];
    return RestApiResultRestaurantVoucherPayGreenStoreConfiguration;
}());
exports.RestApiResultRestaurantVoucherPayGreenStoreConfiguration = RestApiResultRestaurantVoucherPayGreenStoreConfiguration;
var RestApiResultRetentionCampaign = (function () {
    function RestApiResultRetentionCampaign() {
    }
    RestApiResultRetentionCampaign.getAttributeTypeMap = function () {
        return RestApiResultRetentionCampaign.attributeTypeMap;
    };
    RestApiResultRetentionCampaign.discriminator = undefined;
    RestApiResultRetentionCampaign.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "RetentionCampaign"
        }
    ];
    return RestApiResultRetentionCampaign;
}());
exports.RestApiResultRetentionCampaign = RestApiResultRetentionCampaign;
var RestApiResultServiceCharge = (function () {
    function RestApiResultServiceCharge() {
    }
    RestApiResultServiceCharge.getAttributeTypeMap = function () {
        return RestApiResultServiceCharge.attributeTypeMap;
    };
    RestApiResultServiceCharge.discriminator = undefined;
    RestApiResultServiceCharge.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "ServiceCharge"
        }
    ];
    return RestApiResultServiceCharge;
}());
exports.RestApiResultServiceCharge = RestApiResultServiceCharge;
var RestApiResultStore = (function () {
    function RestApiResultStore() {
    }
    RestApiResultStore.getAttributeTypeMap = function () {
        return RestApiResultStore.attributeTypeMap;
    };
    RestApiResultStore.discriminator = undefined;
    RestApiResultStore.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Store"
        }
    ];
    return RestApiResultStore;
}());
exports.RestApiResultStore = RestApiResultStore;
var RestApiResultStoreAddress = (function () {
    function RestApiResultStoreAddress() {
    }
    RestApiResultStoreAddress.getAttributeTypeMap = function () {
        return RestApiResultStoreAddress.attributeTypeMap;
    };
    RestApiResultStoreAddress.discriminator = undefined;
    RestApiResultStoreAddress.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StoreAddress"
        }
    ];
    return RestApiResultStoreAddress;
}());
exports.RestApiResultStoreAddress = RestApiResultStoreAddress;
var RestApiResultStoreChannelAssignment = (function () {
    function RestApiResultStoreChannelAssignment() {
    }
    RestApiResultStoreChannelAssignment.getAttributeTypeMap = function () {
        return RestApiResultStoreChannelAssignment.attributeTypeMap;
    };
    RestApiResultStoreChannelAssignment.discriminator = undefined;
    RestApiResultStoreChannelAssignment.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StoreChannelAssignment"
        }
    ];
    return RestApiResultStoreChannelAssignment;
}());
exports.RestApiResultStoreChannelAssignment = RestApiResultStoreChannelAssignment;
var RestApiResultStoreEndOfDayReport = (function () {
    function RestApiResultStoreEndOfDayReport() {
    }
    RestApiResultStoreEndOfDayReport.getAttributeTypeMap = function () {
        return RestApiResultStoreEndOfDayReport.attributeTypeMap;
    };
    RestApiResultStoreEndOfDayReport.discriminator = undefined;
    RestApiResultStoreEndOfDayReport.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StoreEndOfDayReport"
        }
    ];
    return RestApiResultStoreEndOfDayReport;
}());
exports.RestApiResultStoreEndOfDayReport = RestApiResultStoreEndOfDayReport;
var RestApiResultStoreGroup = (function () {
    function RestApiResultStoreGroup() {
    }
    RestApiResultStoreGroup.getAttributeTypeMap = function () {
        return RestApiResultStoreGroup.attributeTypeMap;
    };
    RestApiResultStoreGroup.discriminator = undefined;
    RestApiResultStoreGroup.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StoreGroup"
        }
    ];
    return RestApiResultStoreGroup;
}());
exports.RestApiResultStoreGroup = RestApiResultStoreGroup;
var RestApiResultStoreGroupBase = (function () {
    function RestApiResultStoreGroupBase() {
    }
    RestApiResultStoreGroupBase.getAttributeTypeMap = function () {
        return RestApiResultStoreGroupBase.attributeTypeMap;
    };
    RestApiResultStoreGroupBase.discriminator = undefined;
    RestApiResultStoreGroupBase.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StoreGroupBase"
        }
    ];
    return RestApiResultStoreGroupBase;
}());
exports.RestApiResultStoreGroupBase = RestApiResultStoreGroupBase;
var RestApiResultStoreOrderCapacityConfig = (function () {
    function RestApiResultStoreOrderCapacityConfig() {
    }
    RestApiResultStoreOrderCapacityConfig.getAttributeTypeMap = function () {
        return RestApiResultStoreOrderCapacityConfig.attributeTypeMap;
    };
    RestApiResultStoreOrderCapacityConfig.discriminator = undefined;
    RestApiResultStoreOrderCapacityConfig.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StoreOrderCapacityConfig"
        }
    ];
    return RestApiResultStoreOrderCapacityConfig;
}());
exports.RestApiResultStoreOrderCapacityConfig = RestApiResultStoreOrderCapacityConfig;
var RestApiResultStripeConnectedAccount = (function () {
    function RestApiResultStripeConnectedAccount() {
    }
    RestApiResultStripeConnectedAccount.getAttributeTypeMap = function () {
        return RestApiResultStripeConnectedAccount.attributeTypeMap;
    };
    RestApiResultStripeConnectedAccount.discriminator = undefined;
    RestApiResultStripeConnectedAccount.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StripeConnectedAccount"
        }
    ];
    return RestApiResultStripeConnectedAccount;
}());
exports.RestApiResultStripeConnectedAccount = RestApiResultStripeConnectedAccount;
var RestApiResultStripeTerminalConnectionToken = (function () {
    function RestApiResultStripeTerminalConnectionToken() {
    }
    RestApiResultStripeTerminalConnectionToken.getAttributeTypeMap = function () {
        return RestApiResultStripeTerminalConnectionToken.attributeTypeMap;
    };
    RestApiResultStripeTerminalConnectionToken.discriminator = undefined;
    RestApiResultStripeTerminalConnectionToken.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StripeTerminalConnectionToken"
        }
    ];
    return RestApiResultStripeTerminalConnectionToken;
}());
exports.RestApiResultStripeTerminalConnectionToken = RestApiResultStripeTerminalConnectionToken;
var RestApiResultStripeTerminalLocation = (function () {
    function RestApiResultStripeTerminalLocation() {
    }
    RestApiResultStripeTerminalLocation.getAttributeTypeMap = function () {
        return RestApiResultStripeTerminalLocation.attributeTypeMap;
    };
    RestApiResultStripeTerminalLocation.discriminator = undefined;
    RestApiResultStripeTerminalLocation.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StripeTerminalLocation"
        }
    ];
    return RestApiResultStripeTerminalLocation;
}());
exports.RestApiResultStripeTerminalLocation = RestApiResultStripeTerminalLocation;
var RestApiResultStuartSettings = (function () {
    function RestApiResultStuartSettings() {
    }
    RestApiResultStuartSettings.getAttributeTypeMap = function () {
        return RestApiResultStuartSettings.attributeTypeMap;
    };
    RestApiResultStuartSettings.discriminator = undefined;
    RestApiResultStuartSettings.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "StuartSettings"
        }
    ];
    return RestApiResultStuartSettings;
}());
exports.RestApiResultStuartSettings = RestApiResultStuartSettings;
var RestApiResultSubmitOrderResponseDm = (function () {
    function RestApiResultSubmitOrderResponseDm() {
    }
    RestApiResultSubmitOrderResponseDm.getAttributeTypeMap = function () {
        return RestApiResultSubmitOrderResponseDm.attributeTypeMap;
    };
    RestApiResultSubmitOrderResponseDm.discriminator = undefined;
    RestApiResultSubmitOrderResponseDm.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "SubmitOrderResponseDm"
        }
    ];
    return RestApiResultSubmitOrderResponseDm;
}());
exports.RestApiResultSubmitOrderResponseDm = RestApiResultSubmitOrderResponseDm;
var RestApiResultSubscription = (function () {
    function RestApiResultSubscription() {
    }
    RestApiResultSubscription.getAttributeTypeMap = function () {
        return RestApiResultSubscription.attributeTypeMap;
    };
    RestApiResultSubscription.discriminator = undefined;
    RestApiResultSubscription.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Subscription"
        }
    ];
    return RestApiResultSubscription;
}());
exports.RestApiResultSubscription = RestApiResultSubscription;
var RestApiResultTeammate = (function () {
    function RestApiResultTeammate() {
    }
    RestApiResultTeammate.getAttributeTypeMap = function () {
        return RestApiResultTeammate.attributeTypeMap;
    };
    RestApiResultTeammate.discriminator = undefined;
    RestApiResultTeammate.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Teammate"
        }
    ];
    return RestApiResultTeammate;
}());
exports.RestApiResultTeammate = RestApiResultTeammate;
var RestApiResultTelemetrySeriesResult = (function () {
    function RestApiResultTelemetrySeriesResult() {
    }
    RestApiResultTelemetrySeriesResult.getAttributeTypeMap = function () {
        return RestApiResultTelemetrySeriesResult.attributeTypeMap;
    };
    RestApiResultTelemetrySeriesResult.discriminator = undefined;
    RestApiResultTelemetrySeriesResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "TelemetrySeriesResult"
        }
    ];
    return RestApiResultTelemetrySeriesResult;
}());
exports.RestApiResultTelemetrySeriesResult = RestApiResultTelemetrySeriesResult;
var RestApiResultTipConfiguration = (function () {
    function RestApiResultTipConfiguration() {
    }
    RestApiResultTipConfiguration.getAttributeTypeMap = function () {
        return RestApiResultTipConfiguration.attributeTypeMap;
    };
    RestApiResultTipConfiguration.discriminator = undefined;
    RestApiResultTipConfiguration.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "TipConfiguration"
        }
    ];
    return RestApiResultTipConfiguration;
}());
exports.RestApiResultTipConfiguration = RestApiResultTipConfiguration;
var RestApiResultUpdateMobileAppsSubmissionStatus = (function () {
    function RestApiResultUpdateMobileAppsSubmissionStatus() {
    }
    RestApiResultUpdateMobileAppsSubmissionStatus.getAttributeTypeMap = function () {
        return RestApiResultUpdateMobileAppsSubmissionStatus.attributeTypeMap;
    };
    RestApiResultUpdateMobileAppsSubmissionStatus.discriminator = undefined;
    RestApiResultUpdateMobileAppsSubmissionStatus.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "UpdateMobileAppsSubmissionStatus"
        }
    ];
    return RestApiResultUpdateMobileAppsSubmissionStatus;
}());
exports.RestApiResultUpdateMobileAppsSubmissionStatus = RestApiResultUpdateMobileAppsSubmissionStatus;
var RestApiResultVoucherWithStats = (function () {
    function RestApiResultVoucherWithStats() {
    }
    RestApiResultVoucherWithStats.getAttributeTypeMap = function () {
        return RestApiResultVoucherWithStats.attributeTypeMap;
    };
    RestApiResultVoucherWithStats.discriminator = undefined;
    RestApiResultVoucherWithStats.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "VoucherWithStats"
        }
    ];
    return RestApiResultVoucherWithStats;
}());
exports.RestApiResultVoucherWithStats = RestApiResultVoucherWithStats;
var RestApiResultWebsiteImage = (function () {
    function RestApiResultWebsiteImage() {
    }
    RestApiResultWebsiteImage.getAttributeTypeMap = function () {
        return RestApiResultWebsiteImage.attributeTypeMap;
    };
    RestApiResultWebsiteImage.discriminator = undefined;
    RestApiResultWebsiteImage.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "WebsiteImage"
        }
    ];
    return RestApiResultWebsiteImage;
}());
exports.RestApiResultWebsiteImage = RestApiResultWebsiteImage;
var RestApiResultWebsiteTestimonial = (function () {
    function RestApiResultWebsiteTestimonial() {
    }
    RestApiResultWebsiteTestimonial.getAttributeTypeMap = function () {
        return RestApiResultWebsiteTestimonial.attributeTypeMap;
    };
    RestApiResultWebsiteTestimonial.discriminator = undefined;
    RestApiResultWebsiteTestimonial.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "WebsiteTestimonial"
        }
    ];
    return RestApiResultWebsiteTestimonial;
}());
exports.RestApiResultWebsiteTestimonial = RestApiResultWebsiteTestimonial;
var RestApiStringArrayResult = (function () {
    function RestApiStringArrayResult() {
    }
    RestApiStringArrayResult.getAttributeTypeMap = function () {
        return RestApiStringArrayResult.attributeTypeMap;
    };
    RestApiStringArrayResult.discriminator = undefined;
    RestApiStringArrayResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<string>"
        }
    ];
    return RestApiStringArrayResult;
}());
exports.RestApiStringArrayResult = RestApiStringArrayResult;
var RestApiStringResult = (function () {
    function RestApiStringResult() {
    }
    RestApiStringResult.getAttributeTypeMap = function () {
        return RestApiStringResult.attributeTypeMap;
    };
    RestApiStringResult.discriminator = undefined;
    RestApiStringResult.attributeTypeMap = [
        {
            "name": "Data",
            "baseName": "Data",
            "type": "string"
        }
    ];
    return RestApiStringResult;
}());
exports.RestApiStringResult = RestApiStringResult;
var RestApiUnauthorizedResult = (function () {
    function RestApiUnauthorizedResult() {
    }
    RestApiUnauthorizedResult.getAttributeTypeMap = function () {
        return RestApiUnauthorizedResult.attributeTypeMap;
    };
    RestApiUnauthorizedResult.discriminator = undefined;
    RestApiUnauthorizedResult.attributeTypeMap = [
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        }
    ];
    return RestApiUnauthorizedResult;
}());
exports.RestApiUnauthorizedResult = RestApiUnauthorizedResult;
var RestaurantVoucherAssignedStore = (function () {
    function RestaurantVoucherAssignedStore() {
    }
    RestaurantVoucherAssignedStore.getAttributeTypeMap = function () {
        return RestaurantVoucherAssignedStore.attributeTypeMap;
    };
    RestaurantVoucherAssignedStore.discriminator = undefined;
    RestaurantVoucherAssignedStore.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Active",
            "baseName": "Active",
            "type": "boolean"
        }
    ];
    return RestaurantVoucherAssignedStore;
}());
exports.RestaurantVoucherAssignedStore = RestaurantVoucherAssignedStore;
var RestaurantVoucherEligibleStore = (function () {
    function RestaurantVoucherEligibleStore() {
    }
    RestaurantVoucherEligibleStore.getAttributeTypeMap = function () {
        return RestaurantVoucherEligibleStore.attributeTypeMap;
    };
    RestaurantVoucherEligibleStore.discriminator = undefined;
    RestaurantVoucherEligibleStore.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return RestaurantVoucherEligibleStore;
}());
exports.RestaurantVoucherEligibleStore = RestaurantVoucherEligibleStore;
var RestaurantVoucherPayGreenConfiguration = (function () {
    function RestaurantVoucherPayGreenConfiguration() {
    }
    RestaurantVoucherPayGreenConfiguration.getAttributeTypeMap = function () {
        return RestaurantVoucherPayGreenConfiguration.attributeTypeMap;
    };
    RestaurantVoucherPayGreenConfiguration.discriminator = undefined;
    RestaurantVoucherPayGreenConfiguration.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "PayGreenId",
            "baseName": "PayGreenId",
            "type": "string"
        },
        {
            "name": "PayGreenConfigurationId",
            "baseName": "PayGreenConfigurationId",
            "type": "number"
        },
        {
            "name": "AssignedStores",
            "baseName": "AssignedStores",
            "type": "Array<RestaurantVoucherAssignedStore>"
        }
    ];
    return RestaurantVoucherPayGreenConfiguration;
}());
exports.RestaurantVoucherPayGreenConfiguration = RestaurantVoucherPayGreenConfiguration;
var RestaurantVoucherPayGreenConfigurationSummary = (function () {
    function RestaurantVoucherPayGreenConfigurationSummary() {
    }
    RestaurantVoucherPayGreenConfigurationSummary.getAttributeTypeMap = function () {
        return RestaurantVoucherPayGreenConfigurationSummary.attributeTypeMap;
    };
    RestaurantVoucherPayGreenConfigurationSummary.discriminator = undefined;
    RestaurantVoucherPayGreenConfigurationSummary.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "PayGreenConfigurationId",
            "baseName": "PayGreenConfigurationId",
            "type": "number"
        }
    ];
    return RestaurantVoucherPayGreenConfigurationSummary;
}());
exports.RestaurantVoucherPayGreenConfigurationSummary = RestaurantVoucherPayGreenConfigurationSummary;
var RestaurantVoucherPayGreenStoreConfiguration = (function () {
    function RestaurantVoucherPayGreenStoreConfiguration() {
    }
    RestaurantVoucherPayGreenStoreConfiguration.getAttributeTypeMap = function () {
        return RestaurantVoucherPayGreenStoreConfiguration.attributeTypeMap;
    };
    RestaurantVoucherPayGreenStoreConfiguration.discriminator = undefined;
    RestaurantVoucherPayGreenStoreConfiguration.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Active",
            "baseName": "Active",
            "type": "boolean"
        },
        {
            "name": "PayGreenId",
            "baseName": "PayGreenId",
            "type": "string"
        },
        {
            "name": "PayGreenConfigurationId",
            "baseName": "PayGreenConfigurationId",
            "type": "number"
        }
    ];
    return RestaurantVoucherPayGreenStoreConfiguration;
}());
exports.RestaurantVoucherPayGreenStoreConfiguration = RestaurantVoucherPayGreenStoreConfiguration;
var RetentionCampaign = (function () {
    function RetentionCampaign() {
    }
    RetentionCampaign.getAttributeTypeMap = function () {
        return RetentionCampaign.attributeTypeMap;
    };
    RetentionCampaign.discriminator = undefined;
    RetentionCampaign.attributeTypeMap = [
        {
            "name": "CampaignId",
            "baseName": "CampaignId",
            "type": "number"
        },
        {
            "name": "Statistics",
            "baseName": "Statistics",
            "type": "CampaignStatistics"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<StoreCampaignStartTime>"
        },
        {
            "name": "NotifyCustomerAfterMinutes",
            "baseName": "NotifyCustomerAfterMinutes",
            "type": "number"
        },
        {
            "name": "PercentDiscountAmount",
            "baseName": "PercentDiscountAmount",
            "type": "number"
        },
        {
            "name": "LumpDiscountAmount",
            "baseName": "LumpDiscountAmount",
            "type": "number"
        },
        {
            "name": "VoucherValidPeriodDays",
            "baseName": "VoucherValidPeriodDays",
            "type": "number"
        },
        {
            "name": "IncludeDeliveryFee",
            "baseName": "IncludeDeliveryFee",
            "type": "boolean"
        },
        {
            "name": "AutoApplyResultingVouchers",
            "baseName": "AutoApplyResultingVouchers",
            "type": "boolean"
        },
        {
            "name": "IncludeExistingOrders",
            "baseName": "IncludeExistingOrders",
            "type": "boolean"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        }
    ];
    return RetentionCampaign;
}());
exports.RetentionCampaign = RetentionCampaign;
var RetentionCampaignBase = (function () {
    function RetentionCampaignBase() {
    }
    RetentionCampaignBase.getAttributeTypeMap = function () {
        return RetentionCampaignBase.attributeTypeMap;
    };
    RetentionCampaignBase.discriminator = undefined;
    RetentionCampaignBase.attributeTypeMap = [
        {
            "name": "NotifyCustomerAfterMinutes",
            "baseName": "NotifyCustomerAfterMinutes",
            "type": "number"
        },
        {
            "name": "PercentDiscountAmount",
            "baseName": "PercentDiscountAmount",
            "type": "number"
        },
        {
            "name": "LumpDiscountAmount",
            "baseName": "LumpDiscountAmount",
            "type": "number"
        },
        {
            "name": "VoucherValidPeriodDays",
            "baseName": "VoucherValidPeriodDays",
            "type": "number"
        },
        {
            "name": "IncludeDeliveryFee",
            "baseName": "IncludeDeliveryFee",
            "type": "boolean"
        },
        {
            "name": "AutoApplyResultingVouchers",
            "baseName": "AutoApplyResultingVouchers",
            "type": "boolean"
        },
        {
            "name": "IncludeExistingOrders",
            "baseName": "IncludeExistingOrders",
            "type": "boolean"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        }
    ];
    return RetentionCampaignBase;
}());
exports.RetentionCampaignBase = RetentionCampaignBase;
var RetentionCampaignCreatedEvent = (function () {
    function RetentionCampaignCreatedEvent() {
    }
    RetentionCampaignCreatedEvent.getAttributeTypeMap = function () {
        return RetentionCampaignCreatedEvent.attributeTypeMap;
    };
    RetentionCampaignCreatedEvent.discriminator = undefined;
    RetentionCampaignCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "RetentionCampaign",
            "baseName": "RetentionCampaign",
            "type": "RetentionCampaign"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return RetentionCampaignCreatedEvent;
}());
exports.RetentionCampaignCreatedEvent = RetentionCampaignCreatedEvent;
var RetentionCampaignDeletedEvent = (function () {
    function RetentionCampaignDeletedEvent() {
    }
    RetentionCampaignDeletedEvent.getAttributeTypeMap = function () {
        return RetentionCampaignDeletedEvent.attributeTypeMap;
    };
    RetentionCampaignDeletedEvent.discriminator = undefined;
    RetentionCampaignDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "RetentionCampaign",
            "baseName": "RetentionCampaign",
            "type": "RetentionCampaign"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return RetentionCampaignDeletedEvent;
}());
exports.RetentionCampaignDeletedEvent = RetentionCampaignDeletedEvent;
var RetentionCampaignUpdatedEvent = (function () {
    function RetentionCampaignUpdatedEvent() {
    }
    RetentionCampaignUpdatedEvent.getAttributeTypeMap = function () {
        return RetentionCampaignUpdatedEvent.attributeTypeMap;
    };
    RetentionCampaignUpdatedEvent.discriminator = undefined;
    RetentionCampaignUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "RetentionCampaign",
            "baseName": "RetentionCampaign",
            "type": "RetentionCampaign"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return RetentionCampaignUpdatedEvent;
}());
exports.RetentionCampaignUpdatedEvent = RetentionCampaignUpdatedEvent;
var RevenueAdjustmentsDetails = (function () {
    function RevenueAdjustmentsDetails() {
    }
    RevenueAdjustmentsDetails.getAttributeTypeMap = function () {
        return RevenueAdjustmentsDetails.attributeTypeMap;
    };
    RevenueAdjustmentsDetails.discriminator = undefined;
    RevenueAdjustmentsDetails.attributeTypeMap = [
        {
            "name": "OnlineSalesRefundedAmount",
            "baseName": "OnlineSalesRefundedAmount",
            "type": "number"
        },
        {
            "name": "PosSalesRefundedAmount",
            "baseName": "PosSalesRefundedAmount",
            "type": "number"
        },
        {
            "name": "CashSalesRefundedAmount",
            "baseName": "CashSalesRefundedAmount",
            "type": "number"
        },
        {
            "name": "CustomerCashFees",
            "baseName": "CustomerCashFees",
            "type": "number"
        },
        {
            "name": "RefundsCount",
            "baseName": "RefundsCount",
            "type": "number"
        },
        {
            "name": "PayGreenSalesAmount",
            "baseName": "PayGreenSalesAmount",
            "type": "number"
        },
        {
            "name": "PayGreenProcessingFees",
            "baseName": "PayGreenProcessingFees",
            "type": "number"
        },
        {
            "name": "TotalOnlineRevenueAdjustments",
            "baseName": "TotalOnlineRevenueAdjustments",
            "type": "number"
        }
    ];
    return RevenueAdjustmentsDetails;
}());
exports.RevenueAdjustmentsDetails = RevenueAdjustmentsDetails;
var RevenueDetail = (function () {
    function RevenueDetail() {
    }
    RevenueDetail.getAttributeTypeMap = function () {
        return RevenueDetail.attributeTypeMap;
    };
    RevenueDetail.discriminator = undefined;
    RevenueDetail.attributeTypeMap = [
        {
            "name": "OnlineSalesAmount",
            "baseName": "OnlineSalesAmount",
            "type": "number"
        },
        {
            "name": "OnlineSalesTax",
            "baseName": "OnlineSalesTax",
            "type": "number"
        },
        {
            "name": "OnlineSalesIncludingTax",
            "baseName": "OnlineSalesIncludingTax",
            "type": "number"
        },
        {
            "name": "OnlineSalesFeesBaseAmount",
            "baseName": "OnlineSalesFeesBaseAmount",
            "type": "number"
        },
        {
            "name": "CashSalesAmount",
            "baseName": "CashSalesAmount",
            "type": "number"
        },
        {
            "name": "CashSalesTax",
            "baseName": "CashSalesTax",
            "type": "number"
        },
        {
            "name": "CashSalesIncludingTax",
            "baseName": "CashSalesIncludingTax",
            "type": "number"
        },
        {
            "name": "CashSalesFeesBaseAmount",
            "baseName": "CashSalesFeesBaseAmount",
            "type": "number"
        },
        {
            "name": "TotalSalesIncludingTax",
            "baseName": "TotalSalesIncludingTax",
            "type": "number"
        },
        {
            "name": "OnlineSalesDeliveryCharges",
            "baseName": "OnlineSalesDeliveryCharges",
            "type": "number"
        },
        {
            "name": "OnlineSalesTips",
            "baseName": "OnlineSalesTips",
            "type": "number"
        },
        {
            "name": "TotalOnlineRevenue",
            "baseName": "TotalOnlineRevenue",
            "type": "number"
        },
        {
            "name": "OnlineSalesServiceCharges",
            "baseName": "OnlineSalesServiceCharges",
            "type": "number"
        }
    ];
    return RevenueDetail;
}());
exports.RevenueDetail = RevenueDetail;
var SearchCriteria = (function () {
    function SearchCriteria() {
    }
    SearchCriteria.getAttributeTypeMap = function () {
        return SearchCriteria.attributeTypeMap;
    };
    SearchCriteria.discriminator = undefined;
    SearchCriteria.attributeTypeMap = [
        {
            "name": "Limit",
            "baseName": "Limit",
            "type": "number"
        },
        {
            "name": "Page",
            "baseName": "Page",
            "type": "number"
        },
        {
            "name": "Start",
            "baseName": "Start",
            "type": "Date"
        },
        {
            "name": "End",
            "baseName": "End",
            "type": "Date"
        },
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreIdList",
            "baseName": "StoreIdList",
            "type": "Array<number>"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "UserId",
            "baseName": "UserId",
            "type": "number"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "CampaignId",
            "baseName": "CampaignId",
            "type": "number"
        },
        {
            "name": "UserEmail",
            "baseName": "UserEmail",
            "type": "string"
        },
        {
            "name": "UserName",
            "baseName": "UserName",
            "type": "string"
        },
        {
            "name": "VoucherCode",
            "baseName": "VoucherCode",
            "type": "string"
        },
        {
            "name": "EventType",
            "baseName": "EventType",
            "type": "Array<string>"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        }
    ];
    return SearchCriteria;
}());
exports.SearchCriteria = SearchCriteria;
var ServiceCharge = (function () {
    function ServiceCharge() {
    }
    ServiceCharge.getAttributeTypeMap = function () {
        return ServiceCharge.attributeTypeMap;
    };
    ServiceCharge.discriminator = undefined;
    ServiceCharge.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "PercentageValue",
            "baseName": "PercentageValue",
            "type": "number"
        },
        {
            "name": "Enabled",
            "baseName": "Enabled",
            "type": "boolean"
        },
        {
            "name": "IsOptional",
            "baseName": "IsOptional",
            "type": "boolean"
        },
        {
            "name": "DisplayWithProcessingFee",
            "baseName": "DisplayWithProcessingFee",
            "type": "boolean"
        },
        {
            "name": "IncludesVouchers",
            "baseName": "IncludesVouchers",
            "type": "boolean"
        }
    ];
    return ServiceCharge;
}());
exports.ServiceCharge = ServiceCharge;
var SetOrderBatchingConfiguration = (function () {
    function SetOrderBatchingConfiguration() {
    }
    SetOrderBatchingConfiguration.getAttributeTypeMap = function () {
        return SetOrderBatchingConfiguration.attributeTypeMap;
    };
    SetOrderBatchingConfiguration.discriminator = undefined;
    SetOrderBatchingConfiguration.attributeTypeMap = [
        {
            "name": "BatchIntervalInSeconds",
            "baseName": "BatchIntervalInSeconds",
            "type": "number"
        },
        {
            "name": "Enabled",
            "baseName": "Enabled",
            "type": "boolean"
        }
    ];
    return SetOrderBatchingConfiguration;
}());
exports.SetOrderBatchingConfiguration = SetOrderBatchingConfiguration;
var SetPasswordWithPinModel = (function () {
    function SetPasswordWithPinModel() {
    }
    SetPasswordWithPinModel.getAttributeTypeMap = function () {
        return SetPasswordWithPinModel.attributeTypeMap;
    };
    SetPasswordWithPinModel.discriminator = undefined;
    SetPasswordWithPinModel.attributeTypeMap = [
        {
            "name": "Pin",
            "baseName": "Pin",
            "type": "number"
        },
        {
            "name": "NewPassword",
            "baseName": "NewPassword",
            "type": "string"
        },
        {
            "name": "RecaptchaToken",
            "baseName": "RecaptchaToken",
            "type": "string"
        }
    ];
    return SetPasswordWithPinModel;
}());
exports.SetPasswordWithPinModel = SetPasswordWithPinModel;
var Setting = (function () {
    function Setting() {
    }
    Setting.getAttributeTypeMap = function () {
        return Setting.attributeTypeMap;
    };
    Setting.discriminator = undefined;
    Setting.attributeTypeMap = [
        {
            "name": "Key",
            "baseName": "Key",
            "type": "string"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "string"
        }
    ];
    return Setting;
}());
exports.Setting = Setting;
var SignupStep = (function () {
    function SignupStep() {
    }
    SignupStep.getAttributeTypeMap = function () {
        return SignupStep.attributeTypeMap;
    };
    SignupStep.discriminator = undefined;
    SignupStep.attributeTypeMap = [
        {
            "name": "Action",
            "baseName": "Action",
            "type": "SignupStep.ActionEnum"
        },
        {
            "name": "Question",
            "baseName": "Question",
            "type": "string"
        },
        {
            "name": "PredefinedAnswers",
            "baseName": "PredefinedAnswers",
            "type": "Array<PredefinedAnswer>"
        }
    ];
    return SignupStep;
}());
exports.SignupStep = SignupStep;
(function (SignupStep) {
    var ActionEnum;
    (function (ActionEnum) {
        ActionEnum[ActionEnum["Question"] = 'Question'] = "Question";
        ActionEnum[ActionEnum["StoreLocation"] = 'StoreLocation'] = "StoreLocation";
        ActionEnum[ActionEnum["PaymentSubscription"] = 'PaymentSubscription'] = "PaymentSubscription";
    })(ActionEnum = SignupStep.ActionEnum || (SignupStep.ActionEnum = {}));
})(SignupStep = exports.SignupStep || (exports.SignupStep = {}));
exports.SignupStep = SignupStep;
var SmsInfo = (function () {
    function SmsInfo() {
    }
    SmsInfo.getAttributeTypeMap = function () {
        return SmsInfo.attributeTypeMap;
    };
    SmsInfo.discriminator = undefined;
    SmsInfo.attributeTypeMap = [
        {
            "name": "From",
            "baseName": "From",
            "type": "string"
        },
        {
            "name": "To",
            "baseName": "To",
            "type": "string"
        },
        {
            "name": "Text",
            "baseName": "Text",
            "type": "string"
        }
    ];
    return SmsInfo;
}());
exports.SmsInfo = SmsInfo;
var SmsReceivedEvent = (function () {
    function SmsReceivedEvent() {
    }
    SmsReceivedEvent.getAttributeTypeMap = function () {
        return SmsReceivedEvent.attributeTypeMap;
    };
    SmsReceivedEvent.discriminator = undefined;
    SmsReceivedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "SmsInfo",
            "baseName": "SmsInfo",
            "type": "SmsInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return SmsReceivedEvent;
}());
exports.SmsReceivedEvent = SmsReceivedEvent;
var StatisticsCurrencyDataPoint = (function () {
    function StatisticsCurrencyDataPoint() {
    }
    StatisticsCurrencyDataPoint.getAttributeTypeMap = function () {
        return StatisticsCurrencyDataPoint.attributeTypeMap;
    };
    StatisticsCurrencyDataPoint.discriminator = undefined;
    StatisticsCurrencyDataPoint.attributeTypeMap = [
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "StatisticsCurrencyDataPoint.CurrencyEnum"
        },
        {
            "name": "UserCount",
            "baseName": "UserCount",
            "type": "number"
        },
        {
            "name": "OrderCount",
            "baseName": "OrderCount",
            "type": "number"
        },
        {
            "name": "OrderValue",
            "baseName": "OrderValue",
            "type": "number"
        }
    ];
    return StatisticsCurrencyDataPoint;
}());
exports.StatisticsCurrencyDataPoint = StatisticsCurrencyDataPoint;
(function (StatisticsCurrencyDataPoint) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StatisticsCurrencyDataPoint.CurrencyEnum || (StatisticsCurrencyDataPoint.CurrencyEnum = {}));
})(StatisticsCurrencyDataPoint = exports.StatisticsCurrencyDataPoint || (exports.StatisticsCurrencyDataPoint = {}));
exports.StatisticsCurrencyDataPoint = StatisticsCurrencyDataPoint;
var Store = (function () {
    function Store() {
    }
    Store.getAttributeTypeMap = function () {
        return Store.attributeTypeMap;
    };
    Store.discriminator = undefined;
    Store.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "Address",
            "baseName": "Address",
            "type": "StoreAddress"
        },
        {
            "name": "DeliveryZones",
            "baseName": "DeliveryZones",
            "type": "Array<DeliveryZone>"
        },
        {
            "name": "ApmPhoneNumber",
            "baseName": "ApmPhoneNumber",
            "type": "string"
        },
        {
            "name": "PickupHours",
            "baseName": "PickupHours",
            "type": "Array<BusinessHoursPeriod>"
        },
        {
            "name": "DeliveryHours",
            "baseName": "DeliveryHours",
            "type": "Array<BusinessHoursPeriod>"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "OrderConfirmationMessageOverrideDelivery",
            "baseName": "OrderConfirmationMessageOverrideDelivery",
            "type": "string"
        },
        {
            "name": "OrderConfirmationMessageOverridePickup",
            "baseName": "OrderConfirmationMessageOverridePickup",
            "type": "string"
        },
        {
            "name": "PrintoutLayoutType",
            "baseName": "PrintoutLayoutType",
            "type": "Store.PrintoutLayoutTypeEnum"
        },
        {
            "name": "StoreNotes",
            "baseName": "StoreNotes",
            "type": "Array<StoreNote>"
        },
        {
            "name": "MicrosoftTimeZone",
            "baseName": "MicrosoftTimeZone",
            "type": "string"
        },
        {
            "name": "IanaTimeZone",
            "baseName": "IanaTimeZone",
            "type": "string"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "Store.CurrencyEnum"
        },
        {
            "name": "PreOrderDeliveryEnabled",
            "baseName": "PreOrderDeliveryEnabled",
            "type": "boolean"
        },
        {
            "name": "PreOrderPickupEnabled",
            "baseName": "PreOrderPickupEnabled",
            "type": "boolean"
        },
        {
            "name": "LogoUrl",
            "baseName": "LogoUrl",
            "type": "string"
        },
        {
            "name": "FraudPreventionStrategy",
            "baseName": "FraudPreventionStrategy",
            "type": "string"
        },
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        },
        {
            "name": "AlwaysAppearOpen",
            "baseName": "AlwaysAppearOpen",
            "type": "boolean"
        },
        {
            "name": "PreOrderEnabled",
            "baseName": "PreOrderEnabled",
            "type": "boolean"
        },
        {
            "name": "TakeOutEnabled",
            "baseName": "TakeOutEnabled",
            "type": "boolean"
        },
        {
            "name": "TableServiceEnabled",
            "baseName": "TableServiceEnabled",
            "type": "boolean"
        },
        {
            "name": "DineInEnabled",
            "baseName": "DineInEnabled",
            "type": "boolean"
        },
        {
            "name": "AllowPreOrdersAndTableService",
            "baseName": "AllowPreOrdersAndTableService",
            "type": "boolean"
        },
        {
            "name": "PickupEnabled",
            "baseName": "PickupEnabled",
            "type": "boolean"
        },
        {
            "name": "DeliveryEnabled",
            "baseName": "DeliveryEnabled",
            "type": "boolean"
        },
        {
            "name": "CardOrderDeliveryEnabled",
            "baseName": "CardOrderDeliveryEnabled",
            "type": "boolean"
        },
        {
            "name": "CashOrdersDeliveryEnabled",
            "baseName": "CashOrdersDeliveryEnabled",
            "type": "boolean"
        },
        {
            "name": "CardOrdersPickupEnabled",
            "baseName": "CardOrdersPickupEnabled",
            "type": "boolean"
        },
        {
            "name": "CashOrdersPickupEnabled",
            "baseName": "CashOrdersPickupEnabled",
            "type": "boolean"
        },
        {
            "name": "TipsEnabled",
            "baseName": "TipsEnabled",
            "type": "boolean"
        },
        {
            "name": "AutomaticallyAcceptOrders",
            "baseName": "AutomaticallyAcceptOrders",
            "type": "boolean"
        },
        {
            "name": "OpenForDelivery",
            "baseName": "OpenForDelivery",
            "type": "boolean"
        },
        {
            "name": "OpenForPickup",
            "baseName": "OpenForPickup",
            "type": "boolean"
        },
        {
            "name": "MinimumPickupOrderAmount",
            "baseName": "MinimumPickupOrderAmount",
            "type": "number"
        },
        {
            "name": "RequireCustomerNameForPickup",
            "baseName": "RequireCustomerNameForPickup",
            "type": "boolean"
        },
        {
            "name": "GdprCustomerPhoneNumbers",
            "baseName": "GdprCustomerPhoneNumbers",
            "type": "boolean"
        },
        {
            "name": "RequireCustomerNameForDelivery",
            "baseName": "RequireCustomerNameForDelivery",
            "type": "boolean"
        },
        {
            "name": "AllowChefNotes",
            "baseName": "AllowChefNotes",
            "type": "boolean"
        },
        {
            "name": "EtaInPickupConfirmationSmsEnabled",
            "baseName": "EtaInPickupConfirmationSmsEnabled",
            "type": "boolean"
        },
        {
            "name": "EtaInDeliveryConfirmationSmsEnabled",
            "baseName": "EtaInDeliveryConfirmationSmsEnabled",
            "type": "boolean"
        },
        {
            "name": "IsArchived",
            "baseName": "IsArchived",
            "type": "boolean"
        },
        {
            "name": "IsPublished",
            "baseName": "IsPublished",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "EmailAddress",
            "baseName": "EmailAddress",
            "type": "string"
        },
        {
            "name": "StaffLanguage",
            "baseName": "StaffLanguage",
            "type": "string"
        }
    ];
    return Store;
}());
exports.Store = Store;
(function (Store) {
    var PrintoutLayoutTypeEnum;
    (function (PrintoutLayoutTypeEnum) {
        PrintoutLayoutTypeEnum[PrintoutLayoutTypeEnum["Default"] = 'Default'] = "Default";
        PrintoutLayoutTypeEnum[PrintoutLayoutTypeEnum["Centra"] = 'Centra'] = "Centra";
        PrintoutLayoutTypeEnum[PrintoutLayoutTypeEnum["SmallChefNotes"] = 'SmallChefNotes'] = "SmallChefNotes";
        PrintoutLayoutTypeEnum[PrintoutLayoutTypeEnum["SmallChefNotesAndCentra"] = 'SmallChefNotesAndCentra'] = "SmallChefNotesAndCentra";
    })(PrintoutLayoutTypeEnum = Store.PrintoutLayoutTypeEnum || (Store.PrintoutLayoutTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Store.CurrencyEnum || (Store.CurrencyEnum = {}));
})(Store = exports.Store || (exports.Store = {}));
exports.Store = Store;
var StoreAddress = (function () {
    function StoreAddress() {
    }
    StoreAddress.getAttributeTypeMap = function () {
        return StoreAddress.attributeTypeMap;
    };
    StoreAddress.discriminator = undefined;
    StoreAddress.attributeTypeMap = [
        {
            "name": "AddressId",
            "baseName": "AddressId",
            "type": "number"
        },
        {
            "name": "Coordinates",
            "baseName": "Coordinates",
            "type": "Coordinates"
        },
        {
            "name": "Line1",
            "baseName": "Line1",
            "type": "string"
        },
        {
            "name": "Postcode",
            "baseName": "Postcode",
            "type": "string"
        },
        {
            "name": "City",
            "baseName": "City",
            "type": "string"
        },
        {
            "name": "CountryCode",
            "baseName": "CountryCode",
            "type": "string"
        },
        {
            "name": "DisplayForCustomer",
            "baseName": "DisplayForCustomer",
            "type": "string"
        },
        {
            "name": "AddressFields",
            "baseName": "AddressFields",
            "type": "{ [key: string]: any; }"
        },
        {
            "name": "SingleLineDisplay",
            "baseName": "SingleLineDisplay",
            "type": "string"
        },
        {
            "name": "TwoLinesDisplay",
            "baseName": "TwoLinesDisplay",
            "type": "Array<string>"
        }
    ];
    return StoreAddress;
}());
exports.StoreAddress = StoreAddress;
var StoreAddressBase = (function () {
    function StoreAddressBase() {
    }
    StoreAddressBase.getAttributeTypeMap = function () {
        return StoreAddressBase.attributeTypeMap;
    };
    StoreAddressBase.discriminator = undefined;
    StoreAddressBase.attributeTypeMap = [
        {
            "name": "Line1",
            "baseName": "Line1",
            "type": "string"
        },
        {
            "name": "Postcode",
            "baseName": "Postcode",
            "type": "string"
        },
        {
            "name": "City",
            "baseName": "City",
            "type": "string"
        },
        {
            "name": "CountryCode",
            "baseName": "CountryCode",
            "type": "string"
        },
        {
            "name": "DisplayForCustomer",
            "baseName": "DisplayForCustomer",
            "type": "string"
        },
        {
            "name": "AddressFields",
            "baseName": "AddressFields",
            "type": "{ [key: string]: any; }"
        },
        {
            "name": "SingleLineDisplay",
            "baseName": "SingleLineDisplay",
            "type": "string"
        },
        {
            "name": "TwoLinesDisplay",
            "baseName": "TwoLinesDisplay",
            "type": "Array<string>"
        }
    ];
    return StoreAddressBase;
}());
exports.StoreAddressBase = StoreAddressBase;
var StoreAddressForm = (function () {
    function StoreAddressForm() {
    }
    StoreAddressForm.getAttributeTypeMap = function () {
        return StoreAddressForm.attributeTypeMap;
    };
    StoreAddressForm.discriminator = undefined;
    StoreAddressForm.attributeTypeMap = [
        {
            "name": "AddressFields",
            "baseName": "AddressFields",
            "type": "{ [key: string]: any; }"
        },
        {
            "name": "CountryCode",
            "baseName": "CountryCode",
            "type": "string"
        }
    ];
    return StoreAddressForm;
}());
exports.StoreAddressForm = StoreAddressForm;
var StoreAddressUpdatedEvent = (function () {
    function StoreAddressUpdatedEvent() {
    }
    StoreAddressUpdatedEvent.getAttributeTypeMap = function () {
        return StoreAddressUpdatedEvent.attributeTypeMap;
    };
    StoreAddressUpdatedEvent.discriminator = undefined;
    StoreAddressUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreAddress",
            "baseName": "StoreAddress",
            "type": "StoreAddress"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreAddressUpdatedEvent;
}());
exports.StoreAddressUpdatedEvent = StoreAddressUpdatedEvent;
var StoreArchivedEvent = (function () {
    function StoreArchivedEvent() {
    }
    StoreArchivedEvent.getAttributeTypeMap = function () {
        return StoreArchivedEvent.attributeTypeMap;
    };
    StoreArchivedEvent.discriminator = undefined;
    StoreArchivedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Store",
            "baseName": "Store",
            "type": "Store"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreArchivedEvent;
}());
exports.StoreArchivedEvent = StoreArchivedEvent;
var StoreBase = (function () {
    function StoreBase() {
    }
    StoreBase.getAttributeTypeMap = function () {
        return StoreBase.attributeTypeMap;
    };
    StoreBase.discriminator = undefined;
    StoreBase.attributeTypeMap = [
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        },
        {
            "name": "AlwaysAppearOpen",
            "baseName": "AlwaysAppearOpen",
            "type": "boolean"
        },
        {
            "name": "PreOrderEnabled",
            "baseName": "PreOrderEnabled",
            "type": "boolean"
        },
        {
            "name": "TakeOutEnabled",
            "baseName": "TakeOutEnabled",
            "type": "boolean"
        },
        {
            "name": "TableServiceEnabled",
            "baseName": "TableServiceEnabled",
            "type": "boolean"
        },
        {
            "name": "DineInEnabled",
            "baseName": "DineInEnabled",
            "type": "boolean"
        },
        {
            "name": "AllowPreOrdersAndTableService",
            "baseName": "AllowPreOrdersAndTableService",
            "type": "boolean"
        },
        {
            "name": "PickupEnabled",
            "baseName": "PickupEnabled",
            "type": "boolean"
        },
        {
            "name": "DeliveryEnabled",
            "baseName": "DeliveryEnabled",
            "type": "boolean"
        },
        {
            "name": "CardOrderDeliveryEnabled",
            "baseName": "CardOrderDeliveryEnabled",
            "type": "boolean"
        },
        {
            "name": "CashOrdersDeliveryEnabled",
            "baseName": "CashOrdersDeliveryEnabled",
            "type": "boolean"
        },
        {
            "name": "CardOrdersPickupEnabled",
            "baseName": "CardOrdersPickupEnabled",
            "type": "boolean"
        },
        {
            "name": "CashOrdersPickupEnabled",
            "baseName": "CashOrdersPickupEnabled",
            "type": "boolean"
        },
        {
            "name": "TipsEnabled",
            "baseName": "TipsEnabled",
            "type": "boolean"
        },
        {
            "name": "AutomaticallyAcceptOrders",
            "baseName": "AutomaticallyAcceptOrders",
            "type": "boolean"
        },
        {
            "name": "OpenForDelivery",
            "baseName": "OpenForDelivery",
            "type": "boolean"
        },
        {
            "name": "OpenForPickup",
            "baseName": "OpenForPickup",
            "type": "boolean"
        },
        {
            "name": "MinimumPickupOrderAmount",
            "baseName": "MinimumPickupOrderAmount",
            "type": "number"
        },
        {
            "name": "RequireCustomerNameForPickup",
            "baseName": "RequireCustomerNameForPickup",
            "type": "boolean"
        },
        {
            "name": "GdprCustomerPhoneNumbers",
            "baseName": "GdprCustomerPhoneNumbers",
            "type": "boolean"
        },
        {
            "name": "RequireCustomerNameForDelivery",
            "baseName": "RequireCustomerNameForDelivery",
            "type": "boolean"
        },
        {
            "name": "AllowChefNotes",
            "baseName": "AllowChefNotes",
            "type": "boolean"
        },
        {
            "name": "EtaInPickupConfirmationSmsEnabled",
            "baseName": "EtaInPickupConfirmationSmsEnabled",
            "type": "boolean"
        },
        {
            "name": "EtaInDeliveryConfirmationSmsEnabled",
            "baseName": "EtaInDeliveryConfirmationSmsEnabled",
            "type": "boolean"
        },
        {
            "name": "IsArchived",
            "baseName": "IsArchived",
            "type": "boolean"
        },
        {
            "name": "IsPublished",
            "baseName": "IsPublished",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "EmailAddress",
            "baseName": "EmailAddress",
            "type": "string"
        },
        {
            "name": "StaffLanguage",
            "baseName": "StaffLanguage",
            "type": "string"
        }
    ];
    return StoreBase;
}());
exports.StoreBase = StoreBase;
var StoreBusinessHoursOverrideCreatedEvent = (function () {
    function StoreBusinessHoursOverrideCreatedEvent() {
    }
    StoreBusinessHoursOverrideCreatedEvent.getAttributeTypeMap = function () {
        return StoreBusinessHoursOverrideCreatedEvent.attributeTypeMap;
    };
    StoreBusinessHoursOverrideCreatedEvent.discriminator = undefined;
    StoreBusinessHoursOverrideCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "BusinessHoursOverride",
            "baseName": "BusinessHoursOverride",
            "type": "BusinessHoursOverride"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreBusinessHoursOverrideCreatedEvent;
}());
exports.StoreBusinessHoursOverrideCreatedEvent = StoreBusinessHoursOverrideCreatedEvent;
var StoreBusinessHoursOverrideDeletedEvent = (function () {
    function StoreBusinessHoursOverrideDeletedEvent() {
    }
    StoreBusinessHoursOverrideDeletedEvent.getAttributeTypeMap = function () {
        return StoreBusinessHoursOverrideDeletedEvent.attributeTypeMap;
    };
    StoreBusinessHoursOverrideDeletedEvent.discriminator = undefined;
    StoreBusinessHoursOverrideDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "BusinessHoursOverride",
            "baseName": "BusinessHoursOverride",
            "type": "BusinessHoursOverride"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreBusinessHoursOverrideDeletedEvent;
}());
exports.StoreBusinessHoursOverrideDeletedEvent = StoreBusinessHoursOverrideDeletedEvent;
var StoreCampaignStartTime = (function () {
    function StoreCampaignStartTime() {
    }
    StoreCampaignStartTime.getAttributeTypeMap = function () {
        return StoreCampaignStartTime.attributeTypeMap;
    };
    StoreCampaignStartTime.discriminator = undefined;
    StoreCampaignStartTime.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "TsStart",
            "baseName": "TsStart",
            "type": "Date"
        }
    ];
    return StoreCampaignStartTime;
}());
exports.StoreCampaignStartTime = StoreCampaignStartTime;
var StoreChannelAssignment = (function () {
    function StoreChannelAssignment() {
    }
    StoreChannelAssignment.getAttributeTypeMap = function () {
        return StoreChannelAssignment.attributeTypeMap;
    };
    StoreChannelAssignment.discriminator = undefined;
    StoreChannelAssignment.attributeTypeMap = [
        {
            "name": "ChannelId",
            "baseName": "ChannelId",
            "type": "number"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        }
    ];
    return StoreChannelAssignment;
}());
exports.StoreChannelAssignment = StoreChannelAssignment;
var StoreChannelStoreMapping = (function () {
    function StoreChannelStoreMapping() {
    }
    StoreChannelStoreMapping.getAttributeTypeMap = function () {
        return StoreChannelStoreMapping.attributeTypeMap;
    };
    StoreChannelStoreMapping.discriminator = undefined;
    StoreChannelStoreMapping.attributeTypeMap = [
        {
            "name": "ChannelId",
            "baseName": "ChannelId",
            "type": "number"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "ChannelStoreId",
            "baseName": "ChannelStoreId",
            "type": "string"
        }
    ];
    return StoreChannelStoreMapping;
}());
exports.StoreChannelStoreMapping = StoreChannelStoreMapping;
var StoreCloneSettings = (function () {
    function StoreCloneSettings() {
    }
    StoreCloneSettings.getAttributeTypeMap = function () {
        return StoreCloneSettings.attributeTypeMap;
    };
    StoreCloneSettings.discriminator = undefined;
    StoreCloneSettings.attributeTypeMap = [
        {
            "name": "TargetStoreGroupId",
            "baseName": "TargetStoreGroupId",
            "type": "number"
        }
    ];
    return StoreCloneSettings;
}());
exports.StoreCloneSettings = StoreCloneSettings;
var StoreConfig = (function () {
    function StoreConfig() {
    }
    StoreConfig.getAttributeTypeMap = function () {
        return StoreConfig.attributeTypeMap;
    };
    StoreConfig.discriminator = undefined;
    StoreConfig.attributeTypeMap = [
        {
            "name": "PickupEnabled",
            "baseName": "PickupEnabled",
            "type": "boolean"
        },
        {
            "name": "BankAccountAttached",
            "baseName": "BankAccountAttached",
            "type": "boolean"
        },
        {
            "name": "MenuAssigned",
            "baseName": "MenuAssigned",
            "type": "boolean"
        },
        {
            "name": "HasFullAddress",
            "baseName": "HasFullAddress",
            "type": "boolean"
        },
        {
            "name": "PickupHours",
            "baseName": "PickupHours",
            "type": "boolean"
        },
        {
            "name": "IsPublished",
            "baseName": "IsPublished",
            "type": "boolean"
        }
    ];
    return StoreConfig;
}());
exports.StoreConfig = StoreConfig;
var StoreCreateBase = (function () {
    function StoreCreateBase() {
    }
    StoreCreateBase.getAttributeTypeMap = function () {
        return StoreCreateBase.attributeTypeMap;
    };
    StoreCreateBase.discriminator = undefined;
    StoreCreateBase.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "EmailAddress",
            "baseName": "EmailAddress",
            "type": "string"
        },
        {
            "name": "StaffLanguage",
            "baseName": "StaffLanguage",
            "type": "string"
        }
    ];
    return StoreCreateBase;
}());
exports.StoreCreateBase = StoreCreateBase;
var StoreCreatedEvent = (function () {
    function StoreCreatedEvent() {
    }
    StoreCreatedEvent.getAttributeTypeMap = function () {
        return StoreCreatedEvent.attributeTypeMap;
    };
    StoreCreatedEvent.discriminator = undefined;
    StoreCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Store",
            "baseName": "Store",
            "type": "Store"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreCreatedEvent;
}());
exports.StoreCreatedEvent = StoreCreatedEvent;
var StoreDataPoint = (function () {
    function StoreDataPoint() {
    }
    StoreDataPoint.getAttributeTypeMap = function () {
        return StoreDataPoint.attributeTypeMap;
    };
    StoreDataPoint.discriminator = undefined;
    StoreDataPoint.attributeTypeMap = [
        {
            "name": "Day",
            "baseName": "Day",
            "type": "Date"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "number"
        }
    ];
    return StoreDataPoint;
}());
exports.StoreDataPoint = StoreDataPoint;
var StoreDeletedEvent = (function () {
    function StoreDeletedEvent() {
    }
    StoreDeletedEvent.getAttributeTypeMap = function () {
        return StoreDeletedEvent.attributeTypeMap;
    };
    StoreDeletedEvent.discriminator = undefined;
    StoreDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Store",
            "baseName": "Store",
            "type": "Store"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreDeletedEvent;
}());
exports.StoreDeletedEvent = StoreDeletedEvent;
var StoreEndOfDayReport = (function () {
    function StoreEndOfDayReport() {
    }
    StoreEndOfDayReport.getAttributeTypeMap = function () {
        return StoreEndOfDayReport.attributeTypeMap;
    };
    StoreEndOfDayReport.discriminator = undefined;
    StoreEndOfDayReport.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "StoreEndOfDayReport.CurrencyEnum"
        },
        {
            "name": "OrderCount",
            "baseName": "OrderCount",
            "type": "number"
        },
        {
            "name": "OrderValue",
            "baseName": "OrderValue",
            "type": "number"
        },
        {
            "name": "OrderValueExcludingDeliveryFees",
            "baseName": "OrderValueExcludingDeliveryFees",
            "type": "number"
        },
        {
            "name": "CollectionOrderCount",
            "baseName": "CollectionOrderCount",
            "type": "number"
        },
        {
            "name": "CollectionCashOrderCount",
            "baseName": "CollectionCashOrderCount",
            "type": "number"
        },
        {
            "name": "CollectionPaidOnlineOrderCount",
            "baseName": "CollectionPaidOnlineOrderCount",
            "type": "number"
        },
        {
            "name": "CollectionOrderValue",
            "baseName": "CollectionOrderValue",
            "type": "number"
        },
        {
            "name": "CollectionCashOrderValue",
            "baseName": "CollectionCashOrderValue",
            "type": "number"
        },
        {
            "name": "CollectionPaidOnlineOrderValue",
            "baseName": "CollectionPaidOnlineOrderValue",
            "type": "number"
        },
        {
            "name": "DeliveryOrderCount",
            "baseName": "DeliveryOrderCount",
            "type": "number"
        },
        {
            "name": "DeliveryCashOrderCount",
            "baseName": "DeliveryCashOrderCount",
            "type": "number"
        },
        {
            "name": "DeliveryPaidOnlineOrderCount",
            "baseName": "DeliveryPaidOnlineOrderCount",
            "type": "number"
        },
        {
            "name": "DeliveryOrderValue",
            "baseName": "DeliveryOrderValue",
            "type": "number"
        },
        {
            "name": "DeliveryCashOrderValue",
            "baseName": "DeliveryCashOrderValue",
            "type": "number"
        },
        {
            "name": "DeliveryPaidOnlineOrderValue",
            "baseName": "DeliveryPaidOnlineOrderValue",
            "type": "number"
        },
        {
            "name": "PaidOnlineOrderCount",
            "baseName": "PaidOnlineOrderCount",
            "type": "number"
        },
        {
            "name": "CashOrderCount",
            "baseName": "CashOrderCount",
            "type": "number"
        },
        {
            "name": "PaidOnlineOrderValue",
            "baseName": "PaidOnlineOrderValue",
            "type": "number"
        },
        {
            "name": "CashOrderValue",
            "baseName": "CashOrderValue",
            "type": "number"
        },
        {
            "name": "PaidOnlineOrderValueExcludingDeliveryFees",
            "baseName": "PaidOnlineOrderValueExcludingDeliveryFees",
            "type": "number"
        },
        {
            "name": "CashOrderValueExcludingDeliveryFees",
            "baseName": "CashOrderValueExcludingDeliveryFees",
            "type": "number"
        },
        {
            "name": "StartTime",
            "baseName": "StartTime",
            "type": "Date"
        },
        {
            "name": "EndTime",
            "baseName": "EndTime",
            "type": "Date"
        }
    ];
    return StoreEndOfDayReport;
}());
exports.StoreEndOfDayReport = StoreEndOfDayReport;
(function (StoreEndOfDayReport) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreEndOfDayReport.CurrencyEnum || (StoreEndOfDayReport.CurrencyEnum = {}));
})(StoreEndOfDayReport = exports.StoreEndOfDayReport || (exports.StoreEndOfDayReport = {}));
exports.StoreEndOfDayReport = StoreEndOfDayReport;
var StoreFeeConfig = (function () {
    function StoreFeeConfig() {
    }
    StoreFeeConfig.getAttributeTypeMap = function () {
        return StoreFeeConfig.attributeTypeMap;
    };
    StoreFeeConfig.discriminator = undefined;
    StoreFeeConfig.attributeTypeMap = [
        {
            "name": "FeeConfigId",
            "baseName": "FeeConfigId",
            "type": "number"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StartTime",
            "baseName": "StartTime",
            "type": "Date"
        },
        {
            "name": "PercentFeeCardOrders",
            "baseName": "PercentFeeCardOrders",
            "type": "number"
        },
        {
            "name": "PercentFeeCashOrders",
            "baseName": "PercentFeeCashOrders",
            "type": "number"
        },
        {
            "name": "PercentFeeCardOrdersWeb",
            "baseName": "PercentFeeCardOrdersWeb",
            "type": "number"
        },
        {
            "name": "PercentFeeCashOrdersWeb",
            "baseName": "PercentFeeCashOrdersWeb",
            "type": "number"
        },
        {
            "name": "PercentFeeCardOrdersKiosk",
            "baseName": "PercentFeeCardOrdersKiosk",
            "type": "number"
        },
        {
            "name": "PercentFeeCashOrdersKiosk",
            "baseName": "PercentFeeCashOrdersKiosk",
            "type": "number"
        },
        {
            "name": "FixedFeeCardOrdersKiosk",
            "baseName": "FixedFeeCardOrdersKiosk",
            "type": "number"
        },
        {
            "name": "FixedFeeCashOrdersKiosk",
            "baseName": "FixedFeeCashOrdersKiosk",
            "type": "number"
        },
        {
            "name": "PercentFeeCardOrdersKioskChargedToCustomerIncludingVat",
            "baseName": "PercentFeeCardOrdersKioskChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "FixedFeeCardOrdersKioskChargedToCustomerIncludingVat",
            "baseName": "FixedFeeCardOrdersKioskChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "PercentFeeCashOrdersKioskChargedToCustomerIncludingVat",
            "baseName": "PercentFeeCashOrdersKioskChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "FixedFeeCashOrdersKioskChargedToCustomerIncludingVat",
            "baseName": "FixedFeeCashOrdersKioskChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "FixedFeeCardOrders",
            "baseName": "FixedFeeCardOrders",
            "type": "number"
        },
        {
            "name": "FixedFeeCashOrders",
            "baseName": "FixedFeeCashOrders",
            "type": "number"
        },
        {
            "name": "PercentFeeCardOrdersChargedToCustomerIncludingVat",
            "baseName": "PercentFeeCardOrdersChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "FixedFeeCardOrdersChargedToCustomerIncludingVat",
            "baseName": "FixedFeeCardOrdersChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "PercentFeeCashOrdersChargedToCustomerIncludingVat",
            "baseName": "PercentFeeCashOrdersChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "FixedFeeCashOrdersChargedToCustomerIncludingVat",
            "baseName": "FixedFeeCashOrdersChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "PercentFeeTips",
            "baseName": "PercentFeeTips",
            "type": "number"
        },
        {
            "name": "PercentFeeTipsCollection",
            "baseName": "PercentFeeTipsCollection",
            "type": "number"
        },
        {
            "name": "PercentFeeTipsDelivery",
            "baseName": "PercentFeeTipsDelivery",
            "type": "number"
        },
        {
            "name": "TaxRatePercent",
            "baseName": "TaxRatePercent",
            "type": "number"
        },
        {
            "name": "PercentFeeCardOrdersLocationService",
            "baseName": "PercentFeeCardOrdersLocationService",
            "type": "number"
        },
        {
            "name": "PercentFeeCashOrdersLocationService",
            "baseName": "PercentFeeCashOrdersLocationService",
            "type": "number"
        },
        {
            "name": "FixedFeeCardOrdersLocationService",
            "baseName": "FixedFeeCardOrdersLocationService",
            "type": "number"
        },
        {
            "name": "FixedFeeCashOrdersLocationService",
            "baseName": "FixedFeeCashOrdersLocationService",
            "type": "number"
        },
        {
            "name": "PercentFeeCardOrdersLocationServiceChargedToCustomerIncludingVat",
            "baseName": "PercentFeeCardOrdersLocationServiceChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "PercentFeeCashOrdersLocationServiceChargedToCustomerIncludingVat",
            "baseName": "PercentFeeCashOrdersLocationServiceChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "FixedFeeCardOrdersLocationServiceChargedToCustomerIncludingVat",
            "baseName": "FixedFeeCardOrdersLocationServiceChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "FixedFeeCashOrdersLocationServiceChargedToCustomerIncludingVat",
            "baseName": "FixedFeeCashOrdersLocationServiceChargedToCustomerIncludingVat",
            "type": "number"
        },
        {
            "name": "PercentFeeCardOrdersIngest",
            "baseName": "PercentFeeCardOrdersIngest",
            "type": "number"
        },
        {
            "name": "PercentFeeCashOrdersIngest",
            "baseName": "PercentFeeCashOrdersIngest",
            "type": "number"
        },
        {
            "name": "FixedFeeCardOrdersIngest",
            "baseName": "FixedFeeCardOrdersIngest",
            "type": "number"
        },
        {
            "name": "FixedFeeCashOrdersIngest",
            "baseName": "FixedFeeCashOrdersIngest",
            "type": "number"
        },
        {
            "name": "PercentFeeDelivery",
            "baseName": "PercentFeeDelivery",
            "type": "number"
        },
        {
            "name": "FixedFeeDelivery",
            "baseName": "FixedFeeDelivery",
            "type": "number"
        },
        {
            "name": "PercentFeeCardPosTransaction",
            "baseName": "PercentFeeCardPosTransaction",
            "type": "number"
        },
        {
            "name": "FixedFeeCardPosTransaction",
            "baseName": "FixedFeeCardPosTransaction",
            "type": "number"
        },
        {
            "name": "PercentFeeOrderWithGoogle",
            "baseName": "PercentFeeOrderWithGoogle",
            "type": "number"
        },
        {
            "name": "FixedFeeOrderWithGoogle",
            "baseName": "FixedFeeOrderWithGoogle",
            "type": "number"
        }
    ];
    return StoreFeeConfig;
}());
exports.StoreFeeConfig = StoreFeeConfig;
var StoreFeeConfigUpdatedEvent = (function () {
    function StoreFeeConfigUpdatedEvent() {
    }
    StoreFeeConfigUpdatedEvent.getAttributeTypeMap = function () {
        return StoreFeeConfigUpdatedEvent.attributeTypeMap;
    };
    StoreFeeConfigUpdatedEvent.discriminator = undefined;
    StoreFeeConfigUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Changes",
            "baseName": "Changes",
            "type": "string"
        },
        {
            "name": "StoreFeeConfig",
            "baseName": "StoreFeeConfig",
            "type": "StoreFeeConfig"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreFeeConfigUpdatedEvent;
}());
exports.StoreFeeConfigUpdatedEvent = StoreFeeConfigUpdatedEvent;
var StoreGroup = (function () {
    function StoreGroup() {
    }
    StoreGroup.getAttributeTypeMap = function () {
        return StoreGroup.attributeTypeMap;
    };
    StoreGroup.discriminator = undefined;
    StoreGroup.attributeTypeMap = [
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "GeneralRating",
            "baseName": "GeneralRating",
            "type": "number"
        },
        {
            "name": "GeneralRatingCount",
            "baseName": "GeneralRatingCount",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "StoreGroup.CurrencyEnum"
        }
    ];
    return StoreGroup;
}());
exports.StoreGroup = StoreGroup;
(function (StoreGroup) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreGroup.CurrencyEnum || (StoreGroup.CurrencyEnum = {}));
})(StoreGroup = exports.StoreGroup || (exports.StoreGroup = {}));
exports.StoreGroup = StoreGroup;
var StoreGroupBase = (function () {
    function StoreGroupBase() {
    }
    StoreGroupBase.getAttributeTypeMap = function () {
        return StoreGroupBase.attributeTypeMap;
    };
    StoreGroupBase.discriminator = undefined;
    StoreGroupBase.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "StoreGroupBase.CurrencyEnum"
        }
    ];
    return StoreGroupBase;
}());
exports.StoreGroupBase = StoreGroupBase;
(function (StoreGroupBase) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreGroupBase.CurrencyEnum || (StoreGroupBase.CurrencyEnum = {}));
})(StoreGroupBase = exports.StoreGroupBase || (exports.StoreGroupBase = {}));
exports.StoreGroupBase = StoreGroupBase;
var StoreGroupCreatedEvent = (function () {
    function StoreGroupCreatedEvent() {
    }
    StoreGroupCreatedEvent.getAttributeTypeMap = function () {
        return StoreGroupCreatedEvent.attributeTypeMap;
    };
    StoreGroupCreatedEvent.discriminator = undefined;
    StoreGroupCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreGroup",
            "baseName": "StoreGroup",
            "type": "StoreGroup"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreGroupCreatedEvent;
}());
exports.StoreGroupCreatedEvent = StoreGroupCreatedEvent;
var StoreGroupDeletedEvent = (function () {
    function StoreGroupDeletedEvent() {
    }
    StoreGroupDeletedEvent.getAttributeTypeMap = function () {
        return StoreGroupDeletedEvent.attributeTypeMap;
    };
    StoreGroupDeletedEvent.discriminator = undefined;
    StoreGroupDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreGroup",
            "baseName": "StoreGroup",
            "type": "StoreGroup"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreGroupDeletedEvent;
}());
exports.StoreGroupDeletedEvent = StoreGroupDeletedEvent;
var StoreGroupExtended = (function () {
    function StoreGroupExtended() {
    }
    StoreGroupExtended.getAttributeTypeMap = function () {
        return StoreGroupExtended.attributeTypeMap;
    };
    StoreGroupExtended.discriminator = undefined;
    StoreGroupExtended.attributeTypeMap = [
        {
            "name": "DeliveryMenuMessage",
            "baseName": "DeliveryMenuMessage",
            "type": "string"
        },
        {
            "name": "PickupMenuMessage",
            "baseName": "PickupMenuMessage",
            "type": "string"
        },
        {
            "name": "TotalStores",
            "baseName": "TotalStores",
            "type": "number"
        },
        {
            "name": "GroupedCoordinates",
            "baseName": "GroupedCoordinates",
            "type": "Array<GroupedCoordinates>"
        },
        {
            "name": "StoreHeaders",
            "baseName": "StoreHeaders",
            "type": "Array<StoreHeader>"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "GeneralRating",
            "baseName": "GeneralRating",
            "type": "number"
        },
        {
            "name": "GeneralRatingCount",
            "baseName": "GeneralRatingCount",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "StoreGroupExtended.CurrencyEnum"
        }
    ];
    return StoreGroupExtended;
}());
exports.StoreGroupExtended = StoreGroupExtended;
(function (StoreGroupExtended) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreGroupExtended.CurrencyEnum || (StoreGroupExtended.CurrencyEnum = {}));
})(StoreGroupExtended = exports.StoreGroupExtended || (exports.StoreGroupExtended = {}));
exports.StoreGroupExtended = StoreGroupExtended;
var StoreGroupUpdatedEvent = (function () {
    function StoreGroupUpdatedEvent() {
    }
    StoreGroupUpdatedEvent.getAttributeTypeMap = function () {
        return StoreGroupUpdatedEvent.attributeTypeMap;
    };
    StoreGroupUpdatedEvent.discriminator = undefined;
    StoreGroupUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreGroup",
            "baseName": "StoreGroup",
            "type": "StoreGroup"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreGroupUpdatedEvent;
}());
exports.StoreGroupUpdatedEvent = StoreGroupUpdatedEvent;
var StoreHeader = (function () {
    function StoreHeader() {
    }
    StoreHeader.getAttributeTypeMap = function () {
        return StoreHeader.attributeTypeMap;
    };
    StoreHeader.discriminator = undefined;
    StoreHeader.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Category",
            "baseName": "Category",
            "type": "string"
        }
    ];
    return StoreHeader;
}());
exports.StoreHeader = StoreHeader;
var StoreItemHeader = (function () {
    function StoreItemHeader() {
    }
    StoreItemHeader.getAttributeTypeMap = function () {
        return StoreItemHeader.attributeTypeMap;
    };
    StoreItemHeader.discriminator = undefined;
    StoreItemHeader.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return StoreItemHeader;
}());
exports.StoreItemHeader = StoreItemHeader;
var StoreKioskSetting = (function () {
    function StoreKioskSetting() {
    }
    StoreKioskSetting.getAttributeTypeMap = function () {
        return StoreKioskSetting.attributeTypeMap;
    };
    StoreKioskSetting.discriminator = undefined;
    StoreKioskSetting.attributeTypeMap = [
        {
            "name": "KioskSettingId",
            "baseName": "KioskSettingId",
            "type": "number"
        },
        {
            "name": "KioskName",
            "baseName": "KioskName",
            "type": "string"
        },
        {
            "name": "RequireCustomerName",
            "baseName": "RequireCustomerName",
            "type": "boolean"
        },
        {
            "name": "RequireCustomerPhoneNumber",
            "baseName": "RequireCustomerPhoneNumber",
            "type": "boolean"
        },
        {
            "name": "RequestCustomerPhoneNumber",
            "baseName": "RequestCustomerPhoneNumber",
            "type": "boolean"
        },
        {
            "name": "RequestTableNumber",
            "baseName": "RequestTableNumber",
            "type": "boolean"
        },
        {
            "name": "OfferDineInOrTakeawayOption",
            "baseName": "OfferDineInOrTakeawayOption",
            "type": "boolean"
        },
        {
            "name": "PhysicalRestaurantId",
            "baseName": "PhysicalRestaurantId",
            "type": "number"
        },
        {
            "name": "HydraConfigId",
            "baseName": "HydraConfigId",
            "type": "number"
        }
    ];
    return StoreKioskSetting;
}());
exports.StoreKioskSetting = StoreKioskSetting;
var StoreKioskSettingUpdatedEvent = (function () {
    function StoreKioskSettingUpdatedEvent() {
    }
    StoreKioskSettingUpdatedEvent.getAttributeTypeMap = function () {
        return StoreKioskSettingUpdatedEvent.attributeTypeMap;
    };
    StoreKioskSettingUpdatedEvent.discriminator = undefined;
    StoreKioskSettingUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "StoreKioskSetting",
            "baseName": "StoreKioskSetting",
            "type": "StoreKioskSetting"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreKioskSettingUpdatedEvent;
}());
exports.StoreKioskSettingUpdatedEvent = StoreKioskSettingUpdatedEvent;
var StoreListItem = (function () {
    function StoreListItem() {
    }
    StoreListItem.getAttributeTypeMap = function () {
        return StoreListItem.attributeTypeMap;
    };
    StoreListItem.discriminator = undefined;
    StoreListItem.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreName",
            "baseName": "StoreName",
            "type": "string"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "StoreGroupName",
            "baseName": "StoreGroupName",
            "type": "string"
        },
        {
            "name": "HasLoyaltyCampaign",
            "baseName": "HasLoyaltyCampaign",
            "type": "boolean"
        },
        {
            "name": "HasRetentionCampaign",
            "baseName": "HasRetentionCampaign",
            "type": "boolean"
        },
        {
            "name": "IsPublished",
            "baseName": "IsPublished",
            "type": "boolean"
        }
    ];
    return StoreListItem;
}());
exports.StoreListItem = StoreListItem;
var StoreLogoCreatedEvent = (function () {
    function StoreLogoCreatedEvent() {
    }
    StoreLogoCreatedEvent.getAttributeTypeMap = function () {
        return StoreLogoCreatedEvent.attributeTypeMap;
    };
    StoreLogoCreatedEvent.discriminator = undefined;
    StoreLogoCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreLogoCreatedEvent;
}());
exports.StoreLogoCreatedEvent = StoreLogoCreatedEvent;
var StoreLogoDeletedEvent = (function () {
    function StoreLogoDeletedEvent() {
    }
    StoreLogoDeletedEvent.getAttributeTypeMap = function () {
        return StoreLogoDeletedEvent.attributeTypeMap;
    };
    StoreLogoDeletedEvent.discriminator = undefined;
    StoreLogoDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreLogoDeletedEvent;
}());
exports.StoreLogoDeletedEvent = StoreLogoDeletedEvent;
var StoreLogoUpdatedEvent = (function () {
    function StoreLogoUpdatedEvent() {
    }
    StoreLogoUpdatedEvent.getAttributeTypeMap = function () {
        return StoreLogoUpdatedEvent.attributeTypeMap;
    };
    StoreLogoUpdatedEvent.discriminator = undefined;
    StoreLogoUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreLogoUpdatedEvent;
}());
exports.StoreLogoUpdatedEvent = StoreLogoUpdatedEvent;
var StoreMenuAssignedEvent = (function () {
    function StoreMenuAssignedEvent() {
    }
    StoreMenuAssignedEvent.getAttributeTypeMap = function () {
        return StoreMenuAssignedEvent.attributeTypeMap;
    };
    StoreMenuAssignedEvent.discriminator = undefined;
    StoreMenuAssignedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreMenuAssignedEvent;
}());
exports.StoreMenuAssignedEvent = StoreMenuAssignedEvent;
var StoreNote = (function () {
    function StoreNote() {
    }
    StoreNote.getAttributeTypeMap = function () {
        return StoreNote.attributeTypeMap;
    };
    StoreNote.discriminator = undefined;
    StoreNote.attributeTypeMap = [
        {
            "name": "UserId",
            "baseName": "UserId",
            "type": "number"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Note",
            "baseName": "Note",
            "type": "string"
        }
    ];
    return StoreNote;
}());
exports.StoreNote = StoreNote;
var StoreOpeningHoursUpdatedEvent = (function () {
    function StoreOpeningHoursUpdatedEvent() {
    }
    StoreOpeningHoursUpdatedEvent.getAttributeTypeMap = function () {
        return StoreOpeningHoursUpdatedEvent.attributeTypeMap;
    };
    StoreOpeningHoursUpdatedEvent.discriminator = undefined;
    StoreOpeningHoursUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "StoreOpeningHoursUpdatedEvent.DeliveryTypeEnum"
        },
        {
            "name": "BusinessHoursPeriodOld",
            "baseName": "BusinessHoursPeriodOld",
            "type": "BusinessHoursPeriod"
        },
        {
            "name": "BusinessHoursPeriod",
            "baseName": "BusinessHoursPeriod",
            "type": "BusinessHoursPeriod"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreOpeningHoursUpdatedEvent;
}());
exports.StoreOpeningHoursUpdatedEvent = StoreOpeningHoursUpdatedEvent;
(function (StoreOpeningHoursUpdatedEvent) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = StoreOpeningHoursUpdatedEvent.DeliveryTypeEnum || (StoreOpeningHoursUpdatedEvent.DeliveryTypeEnum = {}));
})(StoreOpeningHoursUpdatedEvent = exports.StoreOpeningHoursUpdatedEvent || (exports.StoreOpeningHoursUpdatedEvent = {}));
exports.StoreOpeningHoursUpdatedEvent = StoreOpeningHoursUpdatedEvent;
var StoreOrderCapacityConfig = (function () {
    function StoreOrderCapacityConfig() {
    }
    StoreOrderCapacityConfig.getAttributeTypeMap = function () {
        return StoreOrderCapacityConfig.attributeTypeMap;
    };
    StoreOrderCapacityConfig.discriminator = undefined;
    StoreOrderCapacityConfig.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "StoreOrderCapacityConfig.DeliveryTypeEnum"
        },
        {
            "name": "StoreIntervalInMinutes",
            "baseName": "StoreIntervalInMinutes",
            "type": "number"
        },
        {
            "name": "OrderCapacityPeriods",
            "baseName": "OrderCapacityPeriods",
            "type": "Array<StoreOrderCapacityPeriod>"
        }
    ];
    return StoreOrderCapacityConfig;
}());
exports.StoreOrderCapacityConfig = StoreOrderCapacityConfig;
(function (StoreOrderCapacityConfig) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = StoreOrderCapacityConfig.DeliveryTypeEnum || (StoreOrderCapacityConfig.DeliveryTypeEnum = {}));
})(StoreOrderCapacityConfig = exports.StoreOrderCapacityConfig || (exports.StoreOrderCapacityConfig = {}));
exports.StoreOrderCapacityConfig = StoreOrderCapacityConfig;
var StoreOrderCapacityConfigEditModel = (function () {
    function StoreOrderCapacityConfigEditModel() {
    }
    StoreOrderCapacityConfigEditModel.getAttributeTypeMap = function () {
        return StoreOrderCapacityConfigEditModel.attributeTypeMap;
    };
    StoreOrderCapacityConfigEditModel.discriminator = undefined;
    StoreOrderCapacityConfigEditModel.attributeTypeMap = [
        {
            "name": "OrderCapacityPeriods",
            "baseName": "OrderCapacityPeriods",
            "type": "Array<StoreOrderCapacityPeriod>"
        }
    ];
    return StoreOrderCapacityConfigEditModel;
}());
exports.StoreOrderCapacityConfigEditModel = StoreOrderCapacityConfigEditModel;
var StoreOrderCapacityPeriod = (function () {
    function StoreOrderCapacityPeriod() {
    }
    StoreOrderCapacityPeriod.getAttributeTypeMap = function () {
        return StoreOrderCapacityPeriod.attributeTypeMap;
    };
    StoreOrderCapacityPeriod.discriminator = undefined;
    StoreOrderCapacityPeriod.attributeTypeMap = [
        {
            "name": "MaxOrderNumberPerStoreInterval",
            "baseName": "MaxOrderNumberPerStoreInterval",
            "type": "number"
        },
        {
            "name": "DayOfTheWeek",
            "baseName": "DayOfTheWeek",
            "type": "StoreOrderCapacityPeriod.DayOfTheWeekEnum"
        },
        {
            "name": "PeriodStartHour",
            "baseName": "PeriodStartHour",
            "type": "number"
        },
        {
            "name": "PeriodStartMinutes",
            "baseName": "PeriodStartMinutes",
            "type": "number"
        },
        {
            "name": "PeriodEndHour",
            "baseName": "PeriodEndHour",
            "type": "number"
        },
        {
            "name": "PeriodEndMinutes",
            "baseName": "PeriodEndMinutes",
            "type": "number"
        }
    ];
    return StoreOrderCapacityPeriod;
}());
exports.StoreOrderCapacityPeriod = StoreOrderCapacityPeriod;
(function (StoreOrderCapacityPeriod) {
    var DayOfTheWeekEnum;
    (function (DayOfTheWeekEnum) {
        DayOfTheWeekEnum[DayOfTheWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfTheWeekEnum = StoreOrderCapacityPeriod.DayOfTheWeekEnum || (StoreOrderCapacityPeriod.DayOfTheWeekEnum = {}));
})(StoreOrderCapacityPeriod = exports.StoreOrderCapacityPeriod || (exports.StoreOrderCapacityPeriod = {}));
exports.StoreOrderCapacityPeriod = StoreOrderCapacityPeriod;
var StorePreOrderConfigUpdatedEvent = (function () {
    function StorePreOrderConfigUpdatedEvent() {
    }
    StorePreOrderConfigUpdatedEvent.getAttributeTypeMap = function () {
        return StorePreOrderConfigUpdatedEvent.attributeTypeMap;
    };
    StorePreOrderConfigUpdatedEvent.discriminator = undefined;
    StorePreOrderConfigUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "PreOrderConfig",
            "baseName": "PreOrderConfig",
            "type": "PreOrderConfig"
        },
        {
            "name": "OldPreOrderConfig",
            "baseName": "OldPreOrderConfig",
            "type": "PreOrderConfig"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StorePreOrderConfigUpdatedEvent;
}());
exports.StorePreOrderConfigUpdatedEvent = StorePreOrderConfigUpdatedEvent;
var StorePublishedEvent = (function () {
    function StorePublishedEvent() {
    }
    StorePublishedEvent.getAttributeTypeMap = function () {
        return StorePublishedEvent.attributeTypeMap;
    };
    StorePublishedEvent.discriminator = undefined;
    StorePublishedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Store",
            "baseName": "Store",
            "type": "Store"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StorePublishedEvent;
}());
exports.StorePublishedEvent = StorePublishedEvent;
var StoreServiceChargeUpdatedEvent = (function () {
    function StoreServiceChargeUpdatedEvent() {
    }
    StoreServiceChargeUpdatedEvent.getAttributeTypeMap = function () {
        return StoreServiceChargeUpdatedEvent.attributeTypeMap;
    };
    StoreServiceChargeUpdatedEvent.discriminator = undefined;
    StoreServiceChargeUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "ServiceCharge",
            "baseName": "ServiceCharge",
            "type": "ServiceCharge"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreServiceChargeUpdatedEvent;
}());
exports.StoreServiceChargeUpdatedEvent = StoreServiceChargeUpdatedEvent;
var StoreStatistics = (function () {
    function StoreStatistics() {
    }
    StoreStatistics.getAttributeTypeMap = function () {
        return StoreStatistics.attributeTypeMap;
    };
    StoreStatistics.discriminator = undefined;
    StoreStatistics.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Data",
            "baseName": "Data",
            "type": "Array<StoreDataPoint>"
        }
    ];
    return StoreStatistics;
}());
exports.StoreStatistics = StoreStatistics;
var StoreSummary = (function () {
    function StoreSummary() {
    }
    StoreSummary.getAttributeTypeMap = function () {
        return StoreSummary.attributeTypeMap;
    };
    StoreSummary.discriminator = undefined;
    StoreSummary.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "MenuId",
            "baseName": "MenuId",
            "type": "number"
        },
        {
            "name": "Metadata",
            "baseName": "Metadata",
            "type": "{ [key: string]: string; }"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "StoreSummary.CurrencyEnum"
        },
        {
            "name": "Coordinates",
            "baseName": "Coordinates",
            "type": "Coordinates"
        },
        {
            "name": "StoreTimezone",
            "baseName": "StoreTimezone",
            "type": "string"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        }
    ];
    return StoreSummary;
}());
exports.StoreSummary = StoreSummary;
(function (StoreSummary) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreSummary.CurrencyEnum || (StoreSummary.CurrencyEnum = {}));
})(StoreSummary = exports.StoreSummary || (exports.StoreSummary = {}));
exports.StoreSummary = StoreSummary;
var StoreTipUpdatedEvent = (function () {
    function StoreTipUpdatedEvent() {
    }
    StoreTipUpdatedEvent.getAttributeTypeMap = function () {
        return StoreTipUpdatedEvent.attributeTypeMap;
    };
    StoreTipUpdatedEvent.discriminator = undefined;
    StoreTipUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Config",
            "baseName": "Config",
            "type": "UpdateTipConfiguration"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreTipUpdatedEvent;
}());
exports.StoreTipUpdatedEvent = StoreTipUpdatedEvent;
var StoreUnarchivedEvent = (function () {
    function StoreUnarchivedEvent() {
    }
    StoreUnarchivedEvent.getAttributeTypeMap = function () {
        return StoreUnarchivedEvent.attributeTypeMap;
    };
    StoreUnarchivedEvent.discriminator = undefined;
    StoreUnarchivedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Store",
            "baseName": "Store",
            "type": "Store"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreUnarchivedEvent;
}());
exports.StoreUnarchivedEvent = StoreUnarchivedEvent;
var StoreUnpublishedEvent = (function () {
    function StoreUnpublishedEvent() {
    }
    StoreUnpublishedEvent.getAttributeTypeMap = function () {
        return StoreUnpublishedEvent.attributeTypeMap;
    };
    StoreUnpublishedEvent.discriminator = undefined;
    StoreUnpublishedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Store",
            "baseName": "Store",
            "type": "Store"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreUnpublishedEvent;
}());
exports.StoreUnpublishedEvent = StoreUnpublishedEvent;
var StoreUpdatedEvent = (function () {
    function StoreUpdatedEvent() {
    }
    StoreUpdatedEvent.getAttributeTypeMap = function () {
        return StoreUpdatedEvent.attributeTypeMap;
    };
    StoreUpdatedEvent.discriminator = undefined;
    StoreUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Store",
            "baseName": "Store",
            "type": "Store"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return StoreUpdatedEvent;
}());
exports.StoreUpdatedEvent = StoreUpdatedEvent;
var StoreValidationConfig = (function () {
    function StoreValidationConfig() {
    }
    StoreValidationConfig.getAttributeTypeMap = function () {
        return StoreValidationConfig.attributeTypeMap;
    };
    StoreValidationConfig.discriminator = undefined;
    StoreValidationConfig.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "IsValid",
            "baseName": "IsValid",
            "type": "boolean"
        },
        {
            "name": "StoreGroupId",
            "baseName": "StoreGroupId",
            "type": "number"
        },
        {
            "name": "ConfigValidation",
            "baseName": "ConfigValidation",
            "type": "StoreConfig"
        }
    ];
    return StoreValidationConfig;
}());
exports.StoreValidationConfig = StoreValidationConfig;
var StripeAccountLinkRequest = (function () {
    function StripeAccountLinkRequest() {
    }
    StripeAccountLinkRequest.getAttributeTypeMap = function () {
        return StripeAccountLinkRequest.attributeTypeMap;
    };
    StripeAccountLinkRequest.discriminator = undefined;
    StripeAccountLinkRequest.attributeTypeMap = [
        {
            "name": "StripeId",
            "baseName": "StripeId",
            "type": "string"
        },
        {
            "name": "ReturnUrl",
            "baseName": "ReturnUrl",
            "type": "string"
        },
        {
            "name": "Collect",
            "baseName": "Collect",
            "type": "StripeAccountLinkRequest.CollectEnum"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "StripeAccountLinkRequest.TypeEnum"
        }
    ];
    return StripeAccountLinkRequest;
}());
exports.StripeAccountLinkRequest = StripeAccountLinkRequest;
(function (StripeAccountLinkRequest) {
    var CollectEnum;
    (function (CollectEnum) {
        CollectEnum[CollectEnum["CurrentlyDue"] = 'CurrentlyDue'] = "CurrentlyDue";
        CollectEnum[CollectEnum["EventuallyDue"] = 'EventuallyDue'] = "EventuallyDue";
    })(CollectEnum = StripeAccountLinkRequest.CollectEnum || (StripeAccountLinkRequest.CollectEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Onboarding"] = 'Onboarding'] = "Onboarding";
        TypeEnum[TypeEnum["Update"] = 'Update'] = "Update";
    })(TypeEnum = StripeAccountLinkRequest.TypeEnum || (StripeAccountLinkRequest.TypeEnum = {}));
})(StripeAccountLinkRequest = exports.StripeAccountLinkRequest || (exports.StripeAccountLinkRequest = {}));
exports.StripeAccountLinkRequest = StripeAccountLinkRequest;
var StripeConnectedAccount = (function () {
    function StripeConnectedAccount() {
    }
    StripeConnectedAccount.getAttributeTypeMap = function () {
        return StripeConnectedAccount.attributeTypeMap;
    };
    StripeConnectedAccount.discriminator = undefined;
    StripeConnectedAccount.attributeTypeMap = [
        {
            "name": "FlipdishConnectedAccountId",
            "baseName": "FlipdishConnectedAccountId",
            "type": "number"
        },
        {
            "name": "StripeId",
            "baseName": "StripeId",
            "type": "string"
        },
        {
            "name": "WhitelabelConfigId",
            "baseName": "WhitelabelConfigId",
            "type": "number"
        },
        {
            "name": "CardPaymentsStatus",
            "baseName": "CardPaymentsStatus",
            "type": "StripeConnectedAccount.CardPaymentsStatusEnum"
        },
        {
            "name": "TransfersStatus",
            "baseName": "TransfersStatus",
            "type": "StripeConnectedAccount.TransfersStatusEnum"
        },
        {
            "name": "AccountStatus",
            "baseName": "AccountStatus",
            "type": "StripeConnectedAccount.AccountStatusEnum"
        }
    ];
    return StripeConnectedAccount;
}());
exports.StripeConnectedAccount = StripeConnectedAccount;
(function (StripeConnectedAccount) {
    var CardPaymentsStatusEnum;
    (function (CardPaymentsStatusEnum) {
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Pending"] = 'Pending'] = "Pending";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Active"] = 'Active'] = "Active";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(CardPaymentsStatusEnum = StripeConnectedAccount.CardPaymentsStatusEnum || (StripeConnectedAccount.CardPaymentsStatusEnum = {}));
    var TransfersStatusEnum;
    (function (TransfersStatusEnum) {
        TransfersStatusEnum[TransfersStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        TransfersStatusEnum[TransfersStatusEnum["Pending"] = 'Pending'] = "Pending";
        TransfersStatusEnum[TransfersStatusEnum["Active"] = 'Active'] = "Active";
        TransfersStatusEnum[TransfersStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(TransfersStatusEnum = StripeConnectedAccount.TransfersStatusEnum || (StripeConnectedAccount.TransfersStatusEnum = {}));
    var AccountStatusEnum;
    (function (AccountStatusEnum) {
        AccountStatusEnum[AccountStatusEnum["Disabled"] = 'Disabled'] = "Disabled";
        AccountStatusEnum[AccountStatusEnum["Enabled"] = 'Enabled'] = "Enabled";
        AccountStatusEnum[AccountStatusEnum["AdditionalInformationRequired"] = 'AdditionalInformationRequired'] = "AdditionalInformationRequired";
        AccountStatusEnum[AccountStatusEnum["PendingVerification"] = 'PendingVerification'] = "PendingVerification";
        AccountStatusEnum[AccountStatusEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStatusEnum[AccountStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        AccountStatusEnum[AccountStatusEnum["UpdateExternalAccount"] = 'UpdateExternalAccount'] = "UpdateExternalAccount";
    })(AccountStatusEnum = StripeConnectedAccount.AccountStatusEnum || (StripeConnectedAccount.AccountStatusEnum = {}));
})(StripeConnectedAccount = exports.StripeConnectedAccount || (exports.StripeConnectedAccount = {}));
exports.StripeConnectedAccount = StripeConnectedAccount;
var StripeConnectedAccountInfo = (function () {
    function StripeConnectedAccountInfo() {
    }
    StripeConnectedAccountInfo.getAttributeTypeMap = function () {
        return StripeConnectedAccountInfo.attributeTypeMap;
    };
    StripeConnectedAccountInfo.discriminator = undefined;
    StripeConnectedAccountInfo.attributeTypeMap = [
        {
            "name": "AccountStatus",
            "baseName": "AccountStatus",
            "type": "StripeConnectedAccountInfo.AccountStatusEnum"
        },
        {
            "name": "StripeId",
            "baseName": "StripeId",
            "type": "string"
        },
        {
            "name": "CardPaymentStatus",
            "baseName": "CardPaymentStatus",
            "type": "StripeConnectedAccountInfo.CardPaymentStatusEnum"
        },
        {
            "name": "PayoutScheduleInterval",
            "baseName": "PayoutScheduleInterval",
            "type": "StripeConnectedAccountInfo.PayoutScheduleIntervalEnum"
        },
        {
            "name": "PayoutsPaused",
            "baseName": "PayoutsPaused",
            "type": "boolean"
        }
    ];
    return StripeConnectedAccountInfo;
}());
exports.StripeConnectedAccountInfo = StripeConnectedAccountInfo;
(function (StripeConnectedAccountInfo) {
    var AccountStatusEnum;
    (function (AccountStatusEnum) {
        AccountStatusEnum[AccountStatusEnum["Disabled"] = 'Disabled'] = "Disabled";
        AccountStatusEnum[AccountStatusEnum["Enabled"] = 'Enabled'] = "Enabled";
        AccountStatusEnum[AccountStatusEnum["AdditionalInformationRequired"] = 'AdditionalInformationRequired'] = "AdditionalInformationRequired";
        AccountStatusEnum[AccountStatusEnum["PendingVerification"] = 'PendingVerification'] = "PendingVerification";
        AccountStatusEnum[AccountStatusEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStatusEnum[AccountStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        AccountStatusEnum[AccountStatusEnum["UpdateExternalAccount"] = 'UpdateExternalAccount'] = "UpdateExternalAccount";
    })(AccountStatusEnum = StripeConnectedAccountInfo.AccountStatusEnum || (StripeConnectedAccountInfo.AccountStatusEnum = {}));
    var CardPaymentStatusEnum;
    (function (CardPaymentStatusEnum) {
        CardPaymentStatusEnum[CardPaymentStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        CardPaymentStatusEnum[CardPaymentStatusEnum["Pending"] = 'Pending'] = "Pending";
        CardPaymentStatusEnum[CardPaymentStatusEnum["Active"] = 'Active'] = "Active";
        CardPaymentStatusEnum[CardPaymentStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(CardPaymentStatusEnum = StripeConnectedAccountInfo.CardPaymentStatusEnum || (StripeConnectedAccountInfo.CardPaymentStatusEnum = {}));
    var PayoutScheduleIntervalEnum;
    (function (PayoutScheduleIntervalEnum) {
        PayoutScheduleIntervalEnum[PayoutScheduleIntervalEnum["Manual"] = 'Manual'] = "Manual";
        PayoutScheduleIntervalEnum[PayoutScheduleIntervalEnum["Daily"] = 'Daily'] = "Daily";
        PayoutScheduleIntervalEnum[PayoutScheduleIntervalEnum["Weekly"] = 'Weekly'] = "Weekly";
        PayoutScheduleIntervalEnum[PayoutScheduleIntervalEnum["Monthly"] = 'Monthly'] = "Monthly";
    })(PayoutScheduleIntervalEnum = StripeConnectedAccountInfo.PayoutScheduleIntervalEnum || (StripeConnectedAccountInfo.PayoutScheduleIntervalEnum = {}));
})(StripeConnectedAccountInfo = exports.StripeConnectedAccountInfo || (exports.StripeConnectedAccountInfo = {}));
exports.StripeConnectedAccountInfo = StripeConnectedAccountInfo;
var StripeCustomConnectedAccount = (function () {
    function StripeCustomConnectedAccount() {
    }
    StripeCustomConnectedAccount.getAttributeTypeMap = function () {
        return StripeCustomConnectedAccount.attributeTypeMap;
    };
    StripeCustomConnectedAccount.discriminator = undefined;
    StripeCustomConnectedAccount.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "StripeId",
            "baseName": "StripeId",
            "type": "string"
        },
        {
            "name": "CardPaymentsStatus",
            "baseName": "CardPaymentsStatus",
            "type": "StripeCustomConnectedAccount.CardPaymentsStatusEnum"
        },
        {
            "name": "TransfersStatus",
            "baseName": "TransfersStatus",
            "type": "StripeCustomConnectedAccount.TransfersStatusEnum"
        },
        {
            "name": "AccountStatus",
            "baseName": "AccountStatus",
            "type": "StripeCustomConnectedAccount.AccountStatusEnum"
        }
    ];
    return StripeCustomConnectedAccount;
}());
exports.StripeCustomConnectedAccount = StripeCustomConnectedAccount;
(function (StripeCustomConnectedAccount) {
    var CardPaymentsStatusEnum;
    (function (CardPaymentsStatusEnum) {
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Pending"] = 'Pending'] = "Pending";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Active"] = 'Active'] = "Active";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(CardPaymentsStatusEnum = StripeCustomConnectedAccount.CardPaymentsStatusEnum || (StripeCustomConnectedAccount.CardPaymentsStatusEnum = {}));
    var TransfersStatusEnum;
    (function (TransfersStatusEnum) {
        TransfersStatusEnum[TransfersStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        TransfersStatusEnum[TransfersStatusEnum["Pending"] = 'Pending'] = "Pending";
        TransfersStatusEnum[TransfersStatusEnum["Active"] = 'Active'] = "Active";
        TransfersStatusEnum[TransfersStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(TransfersStatusEnum = StripeCustomConnectedAccount.TransfersStatusEnum || (StripeCustomConnectedAccount.TransfersStatusEnum = {}));
    var AccountStatusEnum;
    (function (AccountStatusEnum) {
        AccountStatusEnum[AccountStatusEnum["Disabled"] = 'Disabled'] = "Disabled";
        AccountStatusEnum[AccountStatusEnum["Enabled"] = 'Enabled'] = "Enabled";
        AccountStatusEnum[AccountStatusEnum["AdditionalInformationRequired"] = 'AdditionalInformationRequired'] = "AdditionalInformationRequired";
        AccountStatusEnum[AccountStatusEnum["PendingVerification"] = 'PendingVerification'] = "PendingVerification";
        AccountStatusEnum[AccountStatusEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStatusEnum[AccountStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        AccountStatusEnum[AccountStatusEnum["UpdateExternalAccount"] = 'UpdateExternalAccount'] = "UpdateExternalAccount";
    })(AccountStatusEnum = StripeCustomConnectedAccount.AccountStatusEnum || (StripeCustomConnectedAccount.AccountStatusEnum = {}));
})(StripeCustomConnectedAccount = exports.StripeCustomConnectedAccount || (exports.StripeCustomConnectedAccount = {}));
exports.StripeCustomConnectedAccount = StripeCustomConnectedAccount;
var StripeTerminalConnectionToken = (function () {
    function StripeTerminalConnectionToken() {
    }
    StripeTerminalConnectionToken.getAttributeTypeMap = function () {
        return StripeTerminalConnectionToken.attributeTypeMap;
    };
    StripeTerminalConnectionToken.discriminator = undefined;
    StripeTerminalConnectionToken.attributeTypeMap = [
        {
            "name": "Token",
            "baseName": "Token",
            "type": "string"
        }
    ];
    return StripeTerminalConnectionToken;
}());
exports.StripeTerminalConnectionToken = StripeTerminalConnectionToken;
var StripeTerminalLocation = (function () {
    function StripeTerminalLocation() {
    }
    StripeTerminalLocation.getAttributeTypeMap = function () {
        return StripeTerminalLocation.attributeTypeMap;
    };
    StripeTerminalLocation.discriminator = undefined;
    StripeTerminalLocation.attributeTypeMap = [
        {
            "name": "Location",
            "baseName": "Location",
            "type": "string"
        }
    ];
    return StripeTerminalLocation;
}());
exports.StripeTerminalLocation = StripeTerminalLocation;
var StuartSettings = (function () {
    function StuartSettings() {
    }
    StuartSettings.getAttributeTypeMap = function () {
        return StuartSettings.attributeTypeMap;
    };
    StuartSettings.discriminator = undefined;
    StuartSettings.attributeTypeMap = [
        {
            "name": "ClientId",
            "baseName": "ClientId",
            "type": "string"
        },
        {
            "name": "ClientSecret",
            "baseName": "ClientSecret",
            "type": "string"
        },
        {
            "name": "Enabled",
            "baseName": "Enabled",
            "type": "boolean"
        },
        {
            "name": "WebhookUrlBasicAuthentication",
            "baseName": "WebhookUrlBasicAuthentication",
            "type": "string"
        },
        {
            "name": "OverrideWebhookUrl",
            "baseName": "OverrideWebhookUrl",
            "type": "boolean"
        },
        {
            "name": "MinutesToPickupBeforeThanDeliveryTime",
            "baseName": "MinutesToPickupBeforeThanDeliveryTime",
            "type": "number"
        },
        {
            "name": "PackageType",
            "baseName": "PackageType",
            "type": "StuartSettings.PackageTypeEnum"
        },
        {
            "name": "TransportType",
            "baseName": "TransportType",
            "type": "StuartSettings.TransportTypeEnum"
        },
        {
            "name": "CancelOrderIfStuartCancelDelivery",
            "baseName": "CancelOrderIfStuartCancelDelivery",
            "type": "boolean"
        },
        {
            "name": "TransportPrices",
            "baseName": "TransportPrices",
            "type": "any"
        }
    ];
    return StuartSettings;
}());
exports.StuartSettings = StuartSettings;
(function (StuartSettings) {
    var PackageTypeEnum;
    (function (PackageTypeEnum) {
        PackageTypeEnum[PackageTypeEnum["Xsmall"] = 'Xsmall'] = "Xsmall";
        PackageTypeEnum[PackageTypeEnum["Small"] = 'Small'] = "Small";
        PackageTypeEnum[PackageTypeEnum["Medium"] = 'Medium'] = "Medium";
        PackageTypeEnum[PackageTypeEnum["Large"] = 'Large'] = "Large";
        PackageTypeEnum[PackageTypeEnum["Xlarge"] = 'Xlarge'] = "Xlarge";
    })(PackageTypeEnum = StuartSettings.PackageTypeEnum || (StuartSettings.PackageTypeEnum = {}));
    var TransportTypeEnum;
    (function (TransportTypeEnum) {
        TransportTypeEnum[TransportTypeEnum["Bike"] = 'Bike'] = "Bike";
        TransportTypeEnum[TransportTypeEnum["Cargobike"] = 'Cargobike'] = "Cargobike";
        TransportTypeEnum[TransportTypeEnum["Cargobikexl"] = 'Cargobikexl'] = "Cargobikexl";
        TransportTypeEnum[TransportTypeEnum["Motorbike"] = 'Motorbike'] = "Motorbike";
        TransportTypeEnum[TransportTypeEnum["Motorbikexl"] = 'Motorbikexl'] = "Motorbikexl";
        TransportTypeEnum[TransportTypeEnum["Car"] = 'Car'] = "Car";
        TransportTypeEnum[TransportTypeEnum["Van"] = 'Van'] = "Van";
    })(TransportTypeEnum = StuartSettings.TransportTypeEnum || (StuartSettings.TransportTypeEnum = {}));
})(StuartSettings = exports.StuartSettings || (exports.StuartSettings = {}));
exports.StuartSettings = StuartSettings;
var SubmitOrderRequest = (function () {
    function SubmitOrderRequest() {
    }
    SubmitOrderRequest.getAttributeTypeMap = function () {
        return SubmitOrderRequest.attributeTypeMap;
    };
    SubmitOrderRequest.discriminator = undefined;
    SubmitOrderRequest.attributeTypeMap = [
        {
            "name": "PaymentToken",
            "baseName": "PaymentToken",
            "type": "string"
        },
        {
            "name": "PhoneNumber",
            "baseName": "PhoneNumber",
            "type": "string"
        }
    ];
    return SubmitOrderRequest;
}());
exports.SubmitOrderRequest = SubmitOrderRequest;
var SubmitOrderResponseDm = (function () {
    function SubmitOrderResponseDm() {
    }
    SubmitOrderResponseDm.getAttributeTypeMap = function () {
        return SubmitOrderResponseDm.attributeTypeMap;
    };
    SubmitOrderResponseDm.discriminator = undefined;
    SubmitOrderResponseDm.attributeTypeMap = [
        {
            "name": "OrderId",
            "baseName": "OrderId",
            "type": "number"
        },
        {
            "name": "LocalOrderId",
            "baseName": "LocalOrderId",
            "type": "string"
        },
        {
            "name": "DeliveryTimeEstimateMinutes",
            "baseName": "DeliveryTimeEstimateMinutes",
            "type": "number"
        },
        {
            "name": "OrderPlacedMessage",
            "baseName": "OrderPlacedMessage",
            "type": "string"
        },
        {
            "name": "DisplayTipControl",
            "baseName": "DisplayTipControl",
            "type": "boolean"
        },
        {
            "name": "DisplayRateAppControl",
            "baseName": "DisplayRateAppControl",
            "type": "boolean"
        },
        {
            "name": "CancelOrderPeriodSeconds",
            "baseName": "CancelOrderPeriodSeconds",
            "type": "number"
        },
        {
            "name": "RestaurantName",
            "baseName": "RestaurantName",
            "type": "string"
        },
        {
            "name": "LinkText",
            "baseName": "LinkText",
            "type": "string"
        },
        {
            "name": "LinkUrl",
            "baseName": "LinkUrl",
            "type": "string"
        },
        {
            "name": "DeliveryType",
            "baseName": "DeliveryType",
            "type": "SubmitOrderResponseDm.DeliveryTypeEnum"
        },
        {
            "name": "DuringOrderPromotionOptions",
            "baseName": "DuringOrderPromotionOptions",
            "type": "DuringOrderPromotionOptionsDm"
        },
        {
            "name": "RedirectUri",
            "baseName": "RedirectUri",
            "type": "string"
        },
        {
            "name": "PickupCode",
            "baseName": "PickupCode",
            "type": "string"
        },
        {
            "name": "RestaurantAddress",
            "baseName": "RestaurantAddress",
            "type": "string"
        },
        {
            "name": "PaymentIntentClientSecret",
            "baseName": "PaymentIntentClientSecret",
            "type": "string"
        }
    ];
    return SubmitOrderResponseDm;
}());
exports.SubmitOrderResponseDm = SubmitOrderResponseDm;
(function (SubmitOrderResponseDm) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = SubmitOrderResponseDm.DeliveryTypeEnum || (SubmitOrderResponseDm.DeliveryTypeEnum = {}));
})(SubmitOrderResponseDm = exports.SubmitOrderResponseDm || (exports.SubmitOrderResponseDm = {}));
exports.SubmitOrderResponseDm = SubmitOrderResponseDm;
var Subscription = (function () {
    function Subscription() {
    }
    Subscription.getAttributeTypeMap = function () {
        return Subscription.attributeTypeMap;
    };
    Subscription.discriminator = undefined;
    Subscription.attributeTypeMap = [
        {
            "name": "Products",
            "baseName": "Products",
            "type": "Array<SubscriptionProduct>"
        },
        {
            "name": "NextInvoiceAmount",
            "baseName": "NextInvoiceAmount",
            "type": "number"
        },
        {
            "name": "NextInvoiceBillingDate",
            "baseName": "NextInvoiceBillingDate",
            "type": "Date"
        },
        {
            "name": "UpcomingInvoiceItems",
            "baseName": "UpcomingInvoiceItems",
            "type": "Array<InvoiceItem>"
        },
        {
            "name": "UpcomingInvoiceDiscounts",
            "baseName": "UpcomingInvoiceDiscounts",
            "type": "Array<InvoiceDiscount>"
        },
        {
            "name": "UpcomingInvoice",
            "baseName": "UpcomingInvoice",
            "type": "UpcomingInvoice"
        },
        {
            "name": "SubscriptionId",
            "baseName": "SubscriptionId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "Subscription.StatusEnum"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "Subscription.CurrencyEnum"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "string"
        },
        {
            "name": "DefaultPaymentDescription",
            "baseName": "DefaultPaymentDescription",
            "type": "string"
        },
        {
            "name": "CancellationDate",
            "baseName": "CancellationDate",
            "type": "Date"
        }
    ];
    return Subscription;
}());
exports.Subscription = Subscription;
(function (Subscription) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Incomplete"] = 'Incomplete'] = "Incomplete";
        StatusEnum[StatusEnum["IncompleteExpired"] = 'IncompleteExpired'] = "IncompleteExpired";
        StatusEnum[StatusEnum["Trialing"] = 'Trialing'] = "Trialing";
        StatusEnum[StatusEnum["Active"] = 'Active'] = "Active";
        StatusEnum[StatusEnum["PastDue"] = 'PastDue'] = "PastDue";
        StatusEnum[StatusEnum["Canceled"] = 'Canceled'] = "Canceled";
        StatusEnum[StatusEnum["Unpaid"] = 'Unpaid'] = "Unpaid";
    })(StatusEnum = Subscription.StatusEnum || (Subscription.StatusEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Subscription.CurrencyEnum || (Subscription.CurrencyEnum = {}));
})(Subscription = exports.Subscription || (exports.Subscription = {}));
exports.Subscription = Subscription;
var SubscriptionProduct = (function () {
    function SubscriptionProduct() {
    }
    SubscriptionProduct.getAttributeTypeMap = function () {
        return SubscriptionProduct.attributeTypeMap;
    };
    SubscriptionProduct.discriminator = undefined;
    SubscriptionProduct.attributeTypeMap = [
        {
            "name": "ProductId",
            "baseName": "ProductId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Quantity",
            "baseName": "Quantity",
            "type": "number"
        },
        {
            "name": "PricePerUnit",
            "baseName": "PricePerUnit",
            "type": "number"
        },
        {
            "name": "PriceTotal",
            "baseName": "PriceTotal",
            "type": "number"
        },
        {
            "name": "PaymentFrequency",
            "baseName": "PaymentFrequency",
            "type": "SubscriptionProduct.PaymentFrequencyEnum"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<SubscriptionStore>"
        }
    ];
    return SubscriptionProduct;
}());
exports.SubscriptionProduct = SubscriptionProduct;
(function (SubscriptionProduct) {
    var PaymentFrequencyEnum;
    (function (PaymentFrequencyEnum) {
        PaymentFrequencyEnum[PaymentFrequencyEnum["Day"] = 'day'] = "Day";
        PaymentFrequencyEnum[PaymentFrequencyEnum["Week"] = 'week'] = "Week";
        PaymentFrequencyEnum[PaymentFrequencyEnum["Month"] = 'month'] = "Month";
        PaymentFrequencyEnum[PaymentFrequencyEnum["Year"] = 'year'] = "Year";
    })(PaymentFrequencyEnum = SubscriptionProduct.PaymentFrequencyEnum || (SubscriptionProduct.PaymentFrequencyEnum = {}));
})(SubscriptionProduct = exports.SubscriptionProduct || (exports.SubscriptionProduct = {}));
exports.SubscriptionProduct = SubscriptionProduct;
var SubscriptionStore = (function () {
    function SubscriptionStore() {
    }
    SubscriptionStore.getAttributeTypeMap = function () {
        return SubscriptionStore.attributeTypeMap;
    };
    SubscriptionStore.discriminator = undefined;
    SubscriptionStore.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return SubscriptionStore;
}());
exports.SubscriptionStore = SubscriptionStore;
var SubscriptionSummary = (function () {
    function SubscriptionSummary() {
    }
    SubscriptionSummary.getAttributeTypeMap = function () {
        return SubscriptionSummary.attributeTypeMap;
    };
    SubscriptionSummary.discriminator = undefined;
    SubscriptionSummary.attributeTypeMap = [
        {
            "name": "NextInvoiceAmount",
            "baseName": "NextInvoiceAmount",
            "type": "number"
        },
        {
            "name": "NextInvoiceBillingDate",
            "baseName": "NextInvoiceBillingDate",
            "type": "Date"
        },
        {
            "name": "SubscriptionId",
            "baseName": "SubscriptionId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "SubscriptionSummary.StatusEnum"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "SubscriptionSummary.CurrencyEnum"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "string"
        },
        {
            "name": "DefaultPaymentDescription",
            "baseName": "DefaultPaymentDescription",
            "type": "string"
        },
        {
            "name": "CancellationDate",
            "baseName": "CancellationDate",
            "type": "Date"
        }
    ];
    return SubscriptionSummary;
}());
exports.SubscriptionSummary = SubscriptionSummary;
(function (SubscriptionSummary) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Incomplete"] = 'Incomplete'] = "Incomplete";
        StatusEnum[StatusEnum["IncompleteExpired"] = 'IncompleteExpired'] = "IncompleteExpired";
        StatusEnum[StatusEnum["Trialing"] = 'Trialing'] = "Trialing";
        StatusEnum[StatusEnum["Active"] = 'Active'] = "Active";
        StatusEnum[StatusEnum["PastDue"] = 'PastDue'] = "PastDue";
        StatusEnum[StatusEnum["Canceled"] = 'Canceled'] = "Canceled";
        StatusEnum[StatusEnum["Unpaid"] = 'Unpaid'] = "Unpaid";
    })(StatusEnum = SubscriptionSummary.StatusEnum || (SubscriptionSummary.StatusEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = SubscriptionSummary.CurrencyEnum || (SubscriptionSummary.CurrencyEnum = {}));
})(SubscriptionSummary = exports.SubscriptionSummary || (exports.SubscriptionSummary = {}));
exports.SubscriptionSummary = SubscriptionSummary;
var SupportedCountry = (function () {
    function SupportedCountry() {
    }
    SupportedCountry.getAttributeTypeMap = function () {
        return SupportedCountry.attributeTypeMap;
    };
    SupportedCountry.discriminator = undefined;
    SupportedCountry.attributeTypeMap = [
        {
            "name": "CountryCode",
            "baseName": "CountryCode",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "PhoneCode",
            "baseName": "PhoneCode",
            "type": "number"
        },
        {
            "name": "LanguageCode",
            "baseName": "LanguageCode",
            "type": "string"
        },
        {
            "name": "LanguageName",
            "baseName": "LanguageName",
            "type": "string"
        },
        {
            "name": "OtpNumber",
            "baseName": "OtpNumber",
            "type": "string"
        },
        {
            "name": "SupportNumber",
            "baseName": "SupportNumber",
            "type": "string"
        },
        {
            "name": "AddressLayout",
            "baseName": "AddressLayout",
            "type": "SupportedCountry.AddressLayoutEnum"
        },
        {
            "name": "PostCodeType",
            "baseName": "PostCodeType",
            "type": "SupportedCountry.PostCodeTypeEnum"
        },
        {
            "name": "SupportRegion",
            "baseName": "SupportRegion",
            "type": "SupportedCountry.SupportRegionEnum"
        }
    ];
    return SupportedCountry;
}());
exports.SupportedCountry = SupportedCountry;
(function (SupportedCountry) {
    var AddressLayoutEnum;
    (function (AddressLayoutEnum) {
        AddressLayoutEnum[AddressLayoutEnum["BuildingFirst"] = 'BuildingFirst'] = "BuildingFirst";
        AddressLayoutEnum[AddressLayoutEnum["AddressFirst"] = 'AddressFirst'] = "AddressFirst";
        AddressLayoutEnum[AddressLayoutEnum["FullStreetAddressFirst"] = 'FullStreetAddressFirst'] = "FullStreetAddressFirst";
    })(AddressLayoutEnum = SupportedCountry.AddressLayoutEnum || (SupportedCountry.AddressLayoutEnum = {}));
    var PostCodeTypeEnum;
    (function (PostCodeTypeEnum) {
        PostCodeTypeEnum[PostCodeTypeEnum["None"] = 'None'] = "None";
        PostCodeTypeEnum[PostCodeTypeEnum["PostCode"] = 'PostCode'] = "PostCode";
        PostCodeTypeEnum[PostCodeTypeEnum["Zip"] = 'Zip'] = "Zip";
    })(PostCodeTypeEnum = SupportedCountry.PostCodeTypeEnum || (SupportedCountry.PostCodeTypeEnum = {}));
    var SupportRegionEnum;
    (function (SupportRegionEnum) {
        SupportRegionEnum[SupportRegionEnum["Default"] = 'Default'] = "Default";
        SupportRegionEnum[SupportRegionEnum["Spain"] = 'Spain'] = "Spain";
        SupportRegionEnum[SupportRegionEnum["Benelux"] = 'Benelux'] = "Benelux";
    })(SupportRegionEnum = SupportedCountry.SupportRegionEnum || (SupportedCountry.SupportRegionEnum = {}));
})(SupportedCountry = exports.SupportedCountry || (exports.SupportedCountry = {}));
exports.SupportedCountry = SupportedCountry;
var TaxRate = (function () {
    function TaxRate() {
    }
    TaxRate.getAttributeTypeMap = function () {
        return TaxRate.attributeTypeMap;
    };
    TaxRate.discriminator = undefined;
    TaxRate.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Percentage",
            "baseName": "Percentage",
            "type": "number"
        },
        {
            "name": "Total",
            "baseName": "Total",
            "type": "number"
        }
    ];
    return TaxRate;
}());
exports.TaxRate = TaxRate;
var Teammate = (function () {
    function Teammate() {
    }
    Teammate.getAttributeTypeMap = function () {
        return Teammate.attributeTypeMap;
    };
    Teammate.discriminator = undefined;
    Teammate.attributeTypeMap = [
        {
            "name": "TeammateId",
            "baseName": "TeammateId",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "LastActivity",
            "baseName": "LastActivity",
            "type": "Date"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "InvitationStatus",
            "baseName": "InvitationStatus",
            "type": "Teammate.InvitationStatusEnum"
        },
        {
            "name": "Email",
            "baseName": "Email",
            "type": "string"
        },
        {
            "name": "AppAccessLevel",
            "baseName": "AppAccessLevel",
            "type": "Teammate.AppAccessLevelEnum"
        },
        {
            "name": "HasAccessToAllStores",
            "baseName": "HasAccessToAllStores",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        }
    ];
    return Teammate;
}());
exports.Teammate = Teammate;
(function (Teammate) {
    var InvitationStatusEnum;
    (function (InvitationStatusEnum) {
        InvitationStatusEnum[InvitationStatusEnum["Pending"] = 'Pending'] = "Pending";
        InvitationStatusEnum[InvitationStatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        InvitationStatusEnum[InvitationStatusEnum["Expired"] = 'Expired'] = "Expired";
    })(InvitationStatusEnum = Teammate.InvitationStatusEnum || (Teammate.InvitationStatusEnum = {}));
    var AppAccessLevelEnum;
    (function (AppAccessLevelEnum) {
        AppAccessLevelEnum[AppAccessLevelEnum["None"] = 'None'] = "None";
        AppAccessLevelEnum[AppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        AppAccessLevelEnum[AppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
        AppAccessLevelEnum[AppAccessLevelEnum["Support"] = 'Support'] = "Support";
    })(AppAccessLevelEnum = Teammate.AppAccessLevelEnum || (Teammate.AppAccessLevelEnum = {}));
})(Teammate = exports.Teammate || (exports.Teammate = {}));
exports.Teammate = Teammate;
var TeammateBase = (function () {
    function TeammateBase() {
    }
    TeammateBase.getAttributeTypeMap = function () {
        return TeammateBase.attributeTypeMap;
    };
    TeammateBase.discriminator = undefined;
    TeammateBase.attributeTypeMap = [
        {
            "name": "AppAccessLevel",
            "baseName": "AppAccessLevel",
            "type": "TeammateBase.AppAccessLevelEnum"
        },
        {
            "name": "HasAccessToAllStores",
            "baseName": "HasAccessToAllStores",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        }
    ];
    return TeammateBase;
}());
exports.TeammateBase = TeammateBase;
(function (TeammateBase) {
    var AppAccessLevelEnum;
    (function (AppAccessLevelEnum) {
        AppAccessLevelEnum[AppAccessLevelEnum["None"] = 'None'] = "None";
        AppAccessLevelEnum[AppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        AppAccessLevelEnum[AppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
        AppAccessLevelEnum[AppAccessLevelEnum["Support"] = 'Support'] = "Support";
    })(AppAccessLevelEnum = TeammateBase.AppAccessLevelEnum || (TeammateBase.AppAccessLevelEnum = {}));
})(TeammateBase = exports.TeammateBase || (exports.TeammateBase = {}));
exports.TeammateBase = TeammateBase;
var TeammateDeletedEvent = (function () {
    function TeammateDeletedEvent() {
    }
    TeammateDeletedEvent.getAttributeTypeMap = function () {
        return TeammateDeletedEvent.attributeTypeMap;
    };
    TeammateDeletedEvent.discriminator = undefined;
    TeammateDeletedEvent.attributeTypeMap = [
        {
            "name": "Teammate",
            "baseName": "Teammate",
            "type": "Teammate"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return TeammateDeletedEvent;
}());
exports.TeammateDeletedEvent = TeammateDeletedEvent;
var TeammateInviteAcceptedEvent = (function () {
    function TeammateInviteAcceptedEvent() {
    }
    TeammateInviteAcceptedEvent.getAttributeTypeMap = function () {
        return TeammateInviteAcceptedEvent.attributeTypeMap;
    };
    TeammateInviteAcceptedEvent.discriminator = undefined;
    TeammateInviteAcceptedEvent.attributeTypeMap = [
        {
            "name": "Teammate",
            "baseName": "Teammate",
            "type": "Teammate"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return TeammateInviteAcceptedEvent;
}());
exports.TeammateInviteAcceptedEvent = TeammateInviteAcceptedEvent;
var TeammateInviteSentEvent = (function () {
    function TeammateInviteSentEvent() {
    }
    TeammateInviteSentEvent.getAttributeTypeMap = function () {
        return TeammateInviteSentEvent.attributeTypeMap;
    };
    TeammateInviteSentEvent.discriminator = undefined;
    TeammateInviteSentEvent.attributeTypeMap = [
        {
            "name": "Teammate",
            "baseName": "Teammate",
            "type": "Teammate"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return TeammateInviteSentEvent;
}());
exports.TeammateInviteSentEvent = TeammateInviteSentEvent;
var TeammateUpdatedEvent = (function () {
    function TeammateUpdatedEvent() {
    }
    TeammateUpdatedEvent.getAttributeTypeMap = function () {
        return TeammateUpdatedEvent.attributeTypeMap;
    };
    TeammateUpdatedEvent.discriminator = undefined;
    TeammateUpdatedEvent.attributeTypeMap = [
        {
            "name": "Teammate",
            "baseName": "Teammate",
            "type": "Teammate"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return TeammateUpdatedEvent;
}());
exports.TeammateUpdatedEvent = TeammateUpdatedEvent;
var TelemetrySeriesProperty = (function () {
    function TelemetrySeriesProperty() {
    }
    TelemetrySeriesProperty.getAttributeTypeMap = function () {
        return TelemetrySeriesProperty.attributeTypeMap;
    };
    TelemetrySeriesProperty.discriminator = undefined;
    TelemetrySeriesProperty.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "string"
        },
        {
            "name": "IntValues",
            "baseName": "IntValues",
            "type": "Array<number>"
        },
        {
            "name": "StringValues",
            "baseName": "StringValues",
            "type": "Array<string>"
        },
        {
            "name": "DoubleValues",
            "baseName": "DoubleValues",
            "type": "Array<number>"
        }
    ];
    return TelemetrySeriesProperty;
}());
exports.TelemetrySeriesProperty = TelemetrySeriesProperty;
var TelemetrySeriesQueryParameters = (function () {
    function TelemetrySeriesQueryParameters() {
    }
    TelemetrySeriesQueryParameters.getAttributeTypeMap = function () {
        return TelemetrySeriesQueryParameters.attributeTypeMap;
    };
    TelemetrySeriesQueryParameters.discriminator = undefined;
    TelemetrySeriesQueryParameters.attributeTypeMap = [
        {
            "name": "KioskId",
            "baseName": "KioskId",
            "type": "string"
        },
        {
            "name": "Variables",
            "baseName": "Variables",
            "type": "Array<string>"
        },
        {
            "name": "StartDate",
            "baseName": "StartDate",
            "type": "Date"
        },
        {
            "name": "EndDate",
            "baseName": "EndDate",
            "type": "Date"
        }
    ];
    return TelemetrySeriesQueryParameters;
}());
exports.TelemetrySeriesQueryParameters = TelemetrySeriesQueryParameters;
var TelemetrySeriesResult = (function () {
    function TelemetrySeriesResult() {
    }
    TelemetrySeriesResult.getAttributeTypeMap = function () {
        return TelemetrySeriesResult.attributeTypeMap;
    };
    TelemetrySeriesResult.discriminator = undefined;
    TelemetrySeriesResult.attributeTypeMap = [
        {
            "name": "Timestamps",
            "baseName": "Timestamps",
            "type": "Array<Date>"
        },
        {
            "name": "Properties",
            "baseName": "Properties",
            "type": "Array<TelemetrySeriesProperty>"
        }
    ];
    return TelemetrySeriesResult;
}());
exports.TelemetrySeriesResult = TelemetrySeriesResult;
var TipConfiguration = (function () {
    function TipConfiguration() {
    }
    TipConfiguration.getAttributeTypeMap = function () {
        return TipConfiguration.attributeTypeMap;
    };
    TipConfiguration.discriminator = undefined;
    TipConfiguration.attributeTypeMap = [
        {
            "name": "StoreId",
            "baseName": "StoreId",
            "type": "number"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "AllowCustomTips",
            "baseName": "AllowCustomTips",
            "type": "boolean"
        },
        {
            "name": "AllowRoundUp",
            "baseName": "AllowRoundUp",
            "type": "boolean"
        },
        {
            "name": "AllowEmojis",
            "baseName": "AllowEmojis",
            "type": "boolean"
        },
        {
            "name": "Percentages",
            "baseName": "Percentages",
            "type": "Array<number>"
        },
        {
            "name": "DefaultPercentage",
            "baseName": "DefaultPercentage",
            "type": "number"
        }
    ];
    return TipConfiguration;
}());
exports.TipConfiguration = TipConfiguration;
var UnRegisterCardReaderRequest = (function () {
    function UnRegisterCardReaderRequest() {
    }
    UnRegisterCardReaderRequest.getAttributeTypeMap = function () {
        return UnRegisterCardReaderRequest.attributeTypeMap;
    };
    UnRegisterCardReaderRequest.discriminator = undefined;
    UnRegisterCardReaderRequest.attributeTypeMap = [
        {
            "name": "ReaderId",
            "baseName": "ReaderId",
            "type": "string"
        },
        {
            "name": "KioskDeviceId",
            "baseName": "KioskDeviceId",
            "type": "string"
        }
    ];
    return UnRegisterCardReaderRequest;
}());
exports.UnRegisterCardReaderRequest = UnRegisterCardReaderRequest;
var UpcomingInvoice = (function () {
    function UpcomingInvoice() {
    }
    UpcomingInvoice.getAttributeTypeMap = function () {
        return UpcomingInvoice.attributeTypeMap;
    };
    UpcomingInvoice.discriminator = undefined;
    UpcomingInvoice.attributeTypeMap = [
        {
            "name": "Amount",
            "baseName": "Amount",
            "type": "number"
        },
        {
            "name": "NextBillingDate",
            "baseName": "NextBillingDate",
            "type": "Date"
        },
        {
            "name": "Subtotal",
            "baseName": "Subtotal",
            "type": "number"
        },
        {
            "name": "TotalExcludingTax",
            "baseName": "TotalExcludingTax",
            "type": "number"
        },
        {
            "name": "AmountDue",
            "baseName": "AmountDue",
            "type": "number"
        },
        {
            "name": "Tax",
            "baseName": "Tax",
            "type": "number"
        },
        {
            "name": "Items",
            "baseName": "Items",
            "type": "Array<InvoiceItem>"
        },
        {
            "name": "Discounts",
            "baseName": "Discounts",
            "type": "Array<InvoiceDiscount>"
        }
    ];
    return UpcomingInvoice;
}());
exports.UpcomingInvoice = UpcomingInvoice;
var UpdateAppStoreApp = (function () {
    function UpdateAppStoreApp() {
    }
    UpdateAppStoreApp.getAttributeTypeMap = function () {
        return UpdateAppStoreApp.attributeTypeMap;
    };
    UpdateAppStoreApp.discriminator = undefined;
    UpdateAppStoreApp.attributeTypeMap = [
        {
            "name": "Details",
            "baseName": "Details",
            "type": "string"
        },
        {
            "name": "ConfigurationType",
            "baseName": "ConfigurationType",
            "type": "UpdateAppStoreApp.ConfigurationTypeEnum"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "UpdateAppStoreApp.StoreSelectorTypeEnum"
        },
        {
            "name": "FieldGroups",
            "baseName": "FieldGroups",
            "type": "Array<FieldGroup>"
        },
        {
            "name": "SetupInstructions",
            "baseName": "SetupInstructions",
            "type": "string"
        },
        {
            "name": "ExternalSetupLink",
            "baseName": "ExternalSetupLink",
            "type": "string"
        },
        {
            "name": "TeammateAppAccessLevel",
            "baseName": "TeammateAppAccessLevel",
            "type": "UpdateAppStoreApp.TeammateAppAccessLevelEnum"
        },
        {
            "name": "PermissionsType",
            "baseName": "PermissionsType",
            "type": "UpdateAppStoreApp.PermissionsTypeEnum"
        },
        {
            "name": "Support",
            "baseName": "Support",
            "type": "AppStoreAppSupportInfo"
        },
        {
            "name": "ExternalFunctionActionUrl",
            "baseName": "ExternalFunctionActionUrl",
            "type": "string"
        },
        {
            "name": "ExternalFunctionSignatureKey",
            "baseName": "ExternalFunctionSignatureKey",
            "type": "string"
        },
        {
            "name": "IsPaid",
            "baseName": "IsPaid",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "Categories",
            "baseName": "Categories",
            "type": "Array<UpdateAppStoreApp.CategoriesEnum>"
        },
        {
            "name": "Countries",
            "baseName": "Countries",
            "type": "Array<UpdateAppStoreApp.CountriesEnum>"
        },
        {
            "name": "DeveloperName",
            "baseName": "DeveloperName",
            "type": "string"
        }
    ];
    return UpdateAppStoreApp;
}());
exports.UpdateAppStoreApp = UpdateAppStoreApp;
(function (UpdateAppStoreApp) {
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = UpdateAppStoreApp.ConfigurationTypeEnum || (UpdateAppStoreApp.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = UpdateAppStoreApp.StoreSelectorTypeEnum || (UpdateAppStoreApp.StoreSelectorTypeEnum = {}));
    var TeammateAppAccessLevelEnum;
    (function (TeammateAppAccessLevelEnum) {
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
    })(TeammateAppAccessLevelEnum = UpdateAppStoreApp.TeammateAppAccessLevelEnum || (UpdateAppStoreApp.TeammateAppAccessLevelEnum = {}));
    var PermissionsTypeEnum;
    (function (PermissionsTypeEnum) {
        PermissionsTypeEnum[PermissionsTypeEnum["Teammate"] = 'Teammate'] = "Teammate";
    })(PermissionsTypeEnum = UpdateAppStoreApp.PermissionsTypeEnum || (UpdateAppStoreApp.PermissionsTypeEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = UpdateAppStoreApp.CategoriesEnum || (UpdateAppStoreApp.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = UpdateAppStoreApp.CountriesEnum || (UpdateAppStoreApp.CountriesEnum = {}));
})(UpdateAppStoreApp = exports.UpdateAppStoreApp || (exports.UpdateAppStoreApp = {}));
exports.UpdateAppStoreApp = UpdateAppStoreApp;
var UpdateAppStoreAppConfiguration = (function () {
    function UpdateAppStoreAppConfiguration() {
    }
    UpdateAppStoreAppConfiguration.getAttributeTypeMap = function () {
        return UpdateAppStoreAppConfiguration.attributeTypeMap;
    };
    UpdateAppStoreAppConfiguration.discriminator = undefined;
    UpdateAppStoreAppConfiguration.attributeTypeMap = [
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "Settings",
            "baseName": "Settings",
            "type": "Array<Setting>"
        }
    ];
    return UpdateAppStoreAppConfiguration;
}());
exports.UpdateAppStoreAppConfiguration = UpdateAppStoreAppConfiguration;
var UpdateAppStoreAppConfigurationValuesBatch = (function () {
    function UpdateAppStoreAppConfigurationValuesBatch() {
    }
    UpdateAppStoreAppConfigurationValuesBatch.getAttributeTypeMap = function () {
        return UpdateAppStoreAppConfigurationValuesBatch.attributeTypeMap;
    };
    UpdateAppStoreAppConfigurationValuesBatch.discriminator = undefined;
    UpdateAppStoreAppConfigurationValuesBatch.attributeTypeMap = [
        {
            "name": "Settings",
            "baseName": "Settings",
            "type": "Array<Setting>"
        }
    ];
    return UpdateAppStoreAppConfigurationValuesBatch;
}());
exports.UpdateAppStoreAppConfigurationValuesBatch = UpdateAppStoreAppConfigurationValuesBatch;
var UpdateAppStoreAppConfigurationWebhookDTO = (function () {
    function UpdateAppStoreAppConfigurationWebhookDTO() {
    }
    UpdateAppStoreAppConfigurationWebhookDTO.getAttributeTypeMap = function () {
        return UpdateAppStoreAppConfigurationWebhookDTO.attributeTypeMap;
    };
    UpdateAppStoreAppConfigurationWebhookDTO.discriminator = undefined;
    UpdateAppStoreAppConfigurationWebhookDTO.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "Settings",
            "baseName": "Settings",
            "type": "Array<Setting>"
        }
    ];
    return UpdateAppStoreAppConfigurationWebhookDTO;
}());
exports.UpdateAppStoreAppConfigurationWebhookDTO = UpdateAppStoreAppConfigurationWebhookDTO;
var UpdateAppStoreAppExternalProduct = (function () {
    function UpdateAppStoreAppExternalProduct() {
    }
    UpdateAppStoreAppExternalProduct.getAttributeTypeMap = function () {
        return UpdateAppStoreAppExternalProduct.attributeTypeMap;
    };
    UpdateAppStoreAppExternalProduct.discriminator = undefined;
    UpdateAppStoreAppExternalProduct.attributeTypeMap = [
        {
            "name": "ExternalProductId",
            "baseName": "ExternalProductId",
            "type": "string"
        }
    ];
    return UpdateAppStoreAppExternalProduct;
}());
exports.UpdateAppStoreAppExternalProduct = UpdateAppStoreAppExternalProduct;
var UpdateCatalogGroupReference = (function () {
    function UpdateCatalogGroupReference() {
    }
    UpdateCatalogGroupReference.getAttributeTypeMap = function () {
        return UpdateCatalogGroupReference.attributeTypeMap;
    };
    UpdateCatalogGroupReference.discriminator = undefined;
    UpdateCatalogGroupReference.attributeTypeMap = [
        {
            "name": "CatalogGroupId",
            "baseName": "CatalogGroupId",
            "type": "string"
        },
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "GroupType",
            "baseName": "GroupType",
            "type": "UpdateCatalogGroupReference.GroupTypeEnum"
        }
    ];
    return UpdateCatalogGroupReference;
}());
exports.UpdateCatalogGroupReference = UpdateCatalogGroupReference;
(function (UpdateCatalogGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = UpdateCatalogGroupReference.GroupTypeEnum || (UpdateCatalogGroupReference.GroupTypeEnum = {}));
})(UpdateCatalogGroupReference = exports.UpdateCatalogGroupReference || (exports.UpdateCatalogGroupReference = {}));
exports.UpdateCatalogGroupReference = UpdateCatalogGroupReference;
var UpdateCatalogItem = (function () {
    function UpdateCatalogItem() {
    }
    UpdateCatalogItem.getAttributeTypeMap = function () {
        return UpdateCatalogItem.attributeTypeMap;
    };
    UpdateCatalogItem.discriminator = undefined;
    UpdateCatalogItem.attributeTypeMap = [
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        },
        {
            "name": "Groups",
            "baseName": "Groups",
            "type": "Array<UpdateCatalogGroupReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        }
    ];
    return UpdateCatalogItem;
}());
exports.UpdateCatalogItem = UpdateCatalogItem;
var UpdateDriverNotificationToken = (function () {
    function UpdateDriverNotificationToken() {
    }
    UpdateDriverNotificationToken.getAttributeTypeMap = function () {
        return UpdateDriverNotificationToken.attributeTypeMap;
    };
    UpdateDriverNotificationToken.discriminator = undefined;
    UpdateDriverNotificationToken.attributeTypeMap = [
        {
            "name": "PushNotificationsToken",
            "baseName": "PushNotificationsToken",
            "type": "string"
        }
    ];
    return UpdateDriverNotificationToken;
}());
exports.UpdateDriverNotificationToken = UpdateDriverNotificationToken;
var UpdateDriverProfileModel = (function () {
    function UpdateDriverProfileModel() {
    }
    UpdateDriverProfileModel.getAttributeTypeMap = function () {
        return UpdateDriverProfileModel.attributeTypeMap;
    };
    UpdateDriverProfileModel.discriminator = undefined;
    UpdateDriverProfileModel.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return UpdateDriverProfileModel;
}());
exports.UpdateDriverProfileModel = UpdateDriverProfileModel;
var UpdateFulfillmentStatesConfiguration = (function () {
    function UpdateFulfillmentStatesConfiguration() {
    }
    UpdateFulfillmentStatesConfiguration.getAttributeTypeMap = function () {
        return UpdateFulfillmentStatesConfiguration.attributeTypeMap;
    };
    UpdateFulfillmentStatesConfiguration.discriminator = undefined;
    UpdateFulfillmentStatesConfiguration.attributeTypeMap = [
        {
            "name": "OverwriteSystemTemplate",
            "baseName": "OverwriteSystemTemplate",
            "type": "boolean"
        },
        {
            "name": "StoreIds",
            "baseName": "StoreIds",
            "type": "Array<number>"
        },
        {
            "name": "StoreSelectorType",
            "baseName": "StoreSelectorType",
            "type": "UpdateFulfillmentStatesConfiguration.StoreSelectorTypeEnum"
        },
        {
            "name": "States",
            "baseName": "States",
            "type": "Array<FulfillmentStatusConfigurationItem>"
        },
        {
            "name": "AutomaticTransitionsEnabled",
            "baseName": "AutomaticTransitionsEnabled",
            "type": "boolean"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return UpdateFulfillmentStatesConfiguration;
}());
exports.UpdateFulfillmentStatesConfiguration = UpdateFulfillmentStatesConfiguration;
(function (UpdateFulfillmentStatesConfiguration) {
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = UpdateFulfillmentStatesConfiguration.StoreSelectorTypeEnum || (UpdateFulfillmentStatesConfiguration.StoreSelectorTypeEnum = {}));
})(UpdateFulfillmentStatesConfiguration = exports.UpdateFulfillmentStatesConfiguration || (exports.UpdateFulfillmentStatesConfiguration = {}));
exports.UpdateFulfillmentStatesConfiguration = UpdateFulfillmentStatesConfiguration;
var UpdateGroup = (function () {
    function UpdateGroup() {
    }
    UpdateGroup.getAttributeTypeMap = function () {
        return UpdateGroup.attributeTypeMap;
    };
    UpdateGroup.discriminator = undefined;
    UpdateGroup.attributeTypeMap = [
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "AutogenerateDisplayText",
            "baseName": "AutogenerateDisplayText",
            "type": "boolean"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        },
        {
            "name": "MinSelectCount",
            "baseName": "MinSelectCount",
            "type": "number"
        },
        {
            "name": "MaxSelectCount",
            "baseName": "MaxSelectCount",
            "type": "number"
        },
        {
            "name": "Products",
            "baseName": "Products",
            "type": "Array<UpdateProductReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        }
    ];
    return UpdateGroup;
}());
exports.UpdateGroup = UpdateGroup;
var UpdateGroupReference = (function () {
    function UpdateGroupReference() {
    }
    UpdateGroupReference.getAttributeTypeMap = function () {
        return UpdateGroupReference.attributeTypeMap;
    };
    UpdateGroupReference.discriminator = undefined;
    UpdateGroupReference.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "GroupType",
            "baseName": "GroupType",
            "type": "UpdateGroupReference.GroupTypeEnum"
        }
    ];
    return UpdateGroupReference;
}());
exports.UpdateGroupReference = UpdateGroupReference;
(function (UpdateGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = UpdateGroupReference.GroupTypeEnum || (UpdateGroupReference.GroupTypeEnum = {}));
})(UpdateGroupReference = exports.UpdateGroupReference || (exports.UpdateGroupReference = {}));
exports.UpdateGroupReference = UpdateGroupReference;
var UpdateLocationArea = (function () {
    function UpdateLocationArea() {
    }
    UpdateLocationArea.getAttributeTypeMap = function () {
        return UpdateLocationArea.attributeTypeMap;
    };
    UpdateLocationArea.discriminator = undefined;
    UpdateLocationArea.attributeTypeMap = [
        {
            "name": "LocationAreaId",
            "baseName": "LocationAreaId",
            "type": "number"
        },
        {
            "name": "LocationAreaName",
            "baseName": "LocationAreaName",
            "type": "string"
        },
        {
            "name": "IsDeleted",
            "baseName": "IsDeleted",
            "type": "boolean"
        }
    ];
    return UpdateLocationArea;
}());
exports.UpdateLocationArea = UpdateLocationArea;
var UpdateMetafieldDefinition = (function () {
    function UpdateMetafieldDefinition() {
    }
    UpdateMetafieldDefinition.getAttributeTypeMap = function () {
        return UpdateMetafieldDefinition.attributeTypeMap;
    };
    UpdateMetafieldDefinition.discriminator = undefined;
    UpdateMetafieldDefinition.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Behaviors",
            "baseName": "Behaviors",
            "type": "Array<UpdateMetafieldDefinition.BehaviorsEnum>"
        }
    ];
    return UpdateMetafieldDefinition;
}());
exports.UpdateMetafieldDefinition = UpdateMetafieldDefinition;
(function (UpdateMetafieldDefinition) {
    var BehaviorsEnum;
    (function (BehaviorsEnum) {
        BehaviorsEnum[BehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        BehaviorsEnum[BehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(BehaviorsEnum = UpdateMetafieldDefinition.BehaviorsEnum || (UpdateMetafieldDefinition.BehaviorsEnum = {}));
})(UpdateMetafieldDefinition = exports.UpdateMetafieldDefinition || (exports.UpdateMetafieldDefinition = {}));
exports.UpdateMetafieldDefinition = UpdateMetafieldDefinition;
var UpdateMobileAppsSubmissionStatus = (function () {
    function UpdateMobileAppsSubmissionStatus() {
    }
    UpdateMobileAppsSubmissionStatus.getAttributeTypeMap = function () {
        return UpdateMobileAppsSubmissionStatus.attributeTypeMap;
    };
    UpdateMobileAppsSubmissionStatus.discriminator = undefined;
    UpdateMobileAppsSubmissionStatus.attributeTypeMap = [
        {
            "name": "MobileAppsSubmissionStatusId",
            "baseName": "MobileAppsSubmissionStatusId",
            "type": "number"
        },
        {
            "name": "Type",
            "baseName": "Type",
            "type": "UpdateMobileAppsSubmissionStatus.TypeEnum"
        },
        {
            "name": "AppStatus",
            "baseName": "AppStatus",
            "type": "UpdateMobileAppsSubmissionStatus.AppStatusEnum"
        },
        {
            "name": "UpdateStatus",
            "baseName": "UpdateStatus",
            "type": "UpdateMobileAppsSubmissionStatus.UpdateStatusEnum"
        },
        {
            "name": "LastUpdateStatusTime",
            "baseName": "LastUpdateStatusTime",
            "type": "Date"
        },
        {
            "name": "Notes",
            "baseName": "Notes",
            "type": "string"
        }
    ];
    return UpdateMobileAppsSubmissionStatus;
}());
exports.UpdateMobileAppsSubmissionStatus = UpdateMobileAppsSubmissionStatus;
(function (UpdateMobileAppsSubmissionStatus) {
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["None"] = 'None'] = "None";
        TypeEnum[TypeEnum["Android"] = 'Android'] = "Android";
        TypeEnum[TypeEnum["IOS"] = 'IOS'] = "IOS";
    })(TypeEnum = UpdateMobileAppsSubmissionStatus.TypeEnum || (UpdateMobileAppsSubmissionStatus.TypeEnum = {}));
    var AppStatusEnum;
    (function (AppStatusEnum) {
        AppStatusEnum[AppStatusEnum["None"] = 'None'] = "None";
        AppStatusEnum[AppStatusEnum["Published"] = 'Published'] = "Published";
        AppStatusEnum[AppStatusEnum["Unpublished"] = 'Unpublished'] = "Unpublished";
    })(AppStatusEnum = UpdateMobileAppsSubmissionStatus.AppStatusEnum || (UpdateMobileAppsSubmissionStatus.AppStatusEnum = {}));
    var UpdateStatusEnum;
    (function (UpdateStatusEnum) {
        UpdateStatusEnum[UpdateStatusEnum["None"] = 'None'] = "None";
        UpdateStatusEnum[UpdateStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        UpdateStatusEnum[UpdateStatusEnum["InReview"] = 'InReview'] = "InReview";
        UpdateStatusEnum[UpdateStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        UpdateStatusEnum[UpdateStatusEnum["Approved"] = 'Approved'] = "Approved";
        UpdateStatusEnum[UpdateStatusEnum["Published"] = 'Published'] = "Published";
    })(UpdateStatusEnum = UpdateMobileAppsSubmissionStatus.UpdateStatusEnum || (UpdateMobileAppsSubmissionStatus.UpdateStatusEnum = {}));
})(UpdateMobileAppsSubmissionStatus = exports.UpdateMobileAppsSubmissionStatus || (exports.UpdateMobileAppsSubmissionStatus = {}));
exports.UpdateMobileAppsSubmissionStatus = UpdateMobileAppsSubmissionStatus;
var UpdatePayGreenConfigurationRequest = (function () {
    function UpdatePayGreenConfigurationRequest() {
    }
    UpdatePayGreenConfigurationRequest.getAttributeTypeMap = function () {
        return UpdatePayGreenConfigurationRequest.attributeTypeMap;
    };
    UpdatePayGreenConfigurationRequest.discriminator = undefined;
    UpdatePayGreenConfigurationRequest.attributeTypeMap = [
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "AssignedStores",
            "baseName": "AssignedStores",
            "type": "Array<number>"
        }
    ];
    return UpdatePayGreenConfigurationRequest;
}());
exports.UpdatePayGreenConfigurationRequest = UpdatePayGreenConfigurationRequest;
var UpdateProduct = (function () {
    function UpdateProduct() {
    }
    UpdateProduct.getAttributeTypeMap = function () {
        return UpdateProduct.attributeTypeMap;
    };
    UpdateProduct.discriminator = undefined;
    UpdateProduct.attributeTypeMap = [
        {
            "name": "Sku",
            "baseName": "Sku",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Price",
            "baseName": "Price",
            "type": "number"
        },
        {
            "name": "ImageFileName",
            "baseName": "ImageFileName",
            "type": "string"
        },
        {
            "name": "Alcohol",
            "baseName": "Alcohol",
            "type": "boolean"
        },
        {
            "name": "Groups",
            "baseName": "Groups",
            "type": "Array<UpdateGroupReference>"
        },
        {
            "name": "Metafields",
            "baseName": "Metafields",
            "type": "Array<Metafield>"
        }
    ];
    return UpdateProduct;
}());
exports.UpdateProduct = UpdateProduct;
var UpdateProductReference = (function () {
    function UpdateProductReference() {
    }
    UpdateProductReference.getAttributeTypeMap = function () {
        return UpdateProductReference.attributeTypeMap;
    };
    UpdateProductReference.discriminator = undefined;
    UpdateProductReference.attributeTypeMap = [
        {
            "name": "CatalogItemId",
            "baseName": "CatalogItemId",
            "type": "string"
        },
        {
            "name": "ProductType",
            "baseName": "ProductType",
            "type": "UpdateProductReference.ProductTypeEnum"
        },
        {
            "name": "PreselectedQuantity",
            "baseName": "PreselectedQuantity",
            "type": "number"
        }
    ];
    return UpdateProductReference;
}());
exports.UpdateProductReference = UpdateProductReference;
(function (UpdateProductReference) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = UpdateProductReference.ProductTypeEnum || (UpdateProductReference.ProductTypeEnum = {}));
})(UpdateProductReference = exports.UpdateProductReference || (exports.UpdateProductReference = {}));
exports.UpdateProductReference = UpdateProductReference;
var UpdateStorePayGreenConfigurationRequest = (function () {
    function UpdateStorePayGreenConfigurationRequest() {
    }
    UpdateStorePayGreenConfigurationRequest.getAttributeTypeMap = function () {
        return UpdateStorePayGreenConfigurationRequest.attributeTypeMap;
    };
    UpdateStorePayGreenConfigurationRequest.discriminator = undefined;
    UpdateStorePayGreenConfigurationRequest.attributeTypeMap = [
        {
            "name": "Active",
            "baseName": "Active",
            "type": "boolean"
        },
        {
            "name": "PayGreenConfigurationId",
            "baseName": "PayGreenConfigurationId",
            "type": "number"
        }
    ];
    return UpdateStorePayGreenConfigurationRequest;
}());
exports.UpdateStorePayGreenConfigurationRequest = UpdateStorePayGreenConfigurationRequest;
var UpdateTipConfiguration = (function () {
    function UpdateTipConfiguration() {
    }
    UpdateTipConfiguration.getAttributeTypeMap = function () {
        return UpdateTipConfiguration.attributeTypeMap;
    };
    UpdateTipConfiguration.discriminator = undefined;
    UpdateTipConfiguration.attributeTypeMap = [
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "AllowCustomTips",
            "baseName": "AllowCustomTips",
            "type": "boolean"
        },
        {
            "name": "AllowRoundUp",
            "baseName": "AllowRoundUp",
            "type": "boolean"
        },
        {
            "name": "AllowEmojis",
            "baseName": "AllowEmojis",
            "type": "boolean"
        },
        {
            "name": "Percentages",
            "baseName": "Percentages",
            "type": "Array<number>"
        },
        {
            "name": "DefaultPercentage",
            "baseName": "DefaultPercentage",
            "type": "number"
        }
    ];
    return UpdateTipConfiguration;
}());
exports.UpdateTipConfiguration = UpdateTipConfiguration;
var UserAnsweredSignupQuestionsEvent = (function () {
    function UserAnsweredSignupQuestionsEvent() {
    }
    UserAnsweredSignupQuestionsEvent.getAttributeTypeMap = function () {
        return UserAnsweredSignupQuestionsEvent.attributeTypeMap;
    };
    UserAnsweredSignupQuestionsEvent.discriminator = undefined;
    UserAnsweredSignupQuestionsEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "SignupAnswers",
            "baseName": "SignupAnswers",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return UserAnsweredSignupQuestionsEvent;
}());
exports.UserAnsweredSignupQuestionsEvent = UserAnsweredSignupQuestionsEvent;
var UserCreatedEvent = (function () {
    function UserCreatedEvent() {
    }
    UserCreatedEvent.getAttributeTypeMap = function () {
        return UserCreatedEvent.attributeTypeMap;
    };
    UserCreatedEvent.discriminator = undefined;
    UserCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return UserCreatedEvent;
}());
exports.UserCreatedEvent = UserCreatedEvent;
var UserDeletedEvent = (function () {
    function UserDeletedEvent() {
    }
    UserDeletedEvent.getAttributeTypeMap = function () {
        return UserDeletedEvent.attributeTypeMap;
    };
    UserDeletedEvent.discriminator = undefined;
    UserDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return UserDeletedEvent;
}());
exports.UserDeletedEvent = UserDeletedEvent;
var UserEventInfo = (function () {
    function UserEventInfo() {
    }
    UserEventInfo.getAttributeTypeMap = function () {
        return UserEventInfo.attributeTypeMap;
    };
    UserEventInfo.discriminator = undefined;
    UserEventInfo.attributeTypeMap = [
        {
            "name": "UserId",
            "baseName": "UserId",
            "type": "number"
        },
        {
            "name": "UserName",
            "baseName": "UserName",
            "type": "string"
        },
        {
            "name": "UserPhoneNumber",
            "baseName": "UserPhoneNumber",
            "type": "string"
        },
        {
            "name": "UserEmail",
            "baseName": "UserEmail",
            "type": "string"
        }
    ];
    return UserEventInfo;
}());
exports.UserEventInfo = UserEventInfo;
var UserLoginEvent = (function () {
    function UserLoginEvent() {
    }
    UserLoginEvent.getAttributeTypeMap = function () {
        return UserLoginEvent.attributeTypeMap;
    };
    UserLoginEvent.discriminator = undefined;
    UserLoginEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return UserLoginEvent;
}());
exports.UserLoginEvent = UserLoginEvent;
var UserPasswordCreatedEvent = (function () {
    function UserPasswordCreatedEvent() {
    }
    UserPasswordCreatedEvent.getAttributeTypeMap = function () {
        return UserPasswordCreatedEvent.attributeTypeMap;
    };
    UserPasswordCreatedEvent.discriminator = undefined;
    UserPasswordCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return UserPasswordCreatedEvent;
}());
exports.UserPasswordCreatedEvent = UserPasswordCreatedEvent;
var UserUpdatedEvent = (function () {
    function UserUpdatedEvent() {
    }
    UserUpdatedEvent.getAttributeTypeMap = function () {
        return UserUpdatedEvent.attributeTypeMap;
    };
    UserUpdatedEvent.discriminator = undefined;
    UserUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return UserUpdatedEvent;
}());
exports.UserUpdatedEvent = UserUpdatedEvent;
var ValidValue = (function () {
    function ValidValue() {
    }
    ValidValue.getAttributeTypeMap = function () {
        return ValidValue.attributeTypeMap;
    };
    ValidValue.discriminator = undefined;
    ValidValue.attributeTypeMap = [
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        },
        {
            "name": "Name",
            "baseName": "Name",
            "type": "string"
        }
    ];
    return ValidValue;
}());
exports.ValidValue = ValidValue;
var ValidationErrorResult = (function () {
    function ValidationErrorResult() {
    }
    ValidationErrorResult.getAttributeTypeMap = function () {
        return ValidationErrorResult.attributeTypeMap;
    };
    ValidationErrorResult.discriminator = undefined;
    ValidationErrorResult.attributeTypeMap = [
        {
            "name": "FieldName",
            "baseName": "FieldName",
            "type": "string"
        },
        {
            "name": "Errors",
            "baseName": "Errors",
            "type": "Array<string>"
        }
    ];
    return ValidationErrorResult;
}());
exports.ValidationErrorResult = ValidationErrorResult;
var Voucher = (function () {
    function Voucher() {
    }
    Voucher.getAttributeTypeMap = function () {
        return Voucher.attributeTypeMap;
    };
    Voucher.discriminator = undefined;
    Voucher.attributeTypeMap = [
        {
            "name": "VoucherId",
            "baseName": "VoucherId",
            "type": "number"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "Voucher.StatusEnum"
        },
        {
            "name": "VoucherType",
            "baseName": "VoucherType",
            "type": "Voucher.VoucherTypeEnum"
        },
        {
            "name": "VoucherSubType",
            "baseName": "VoucherSubType",
            "type": "Voucher.VoucherSubTypeEnum"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "Voucher.CurrencyEnum"
        },
        {
            "name": "StoreNames",
            "baseName": "StoreNames",
            "type": "Array<string>"
        },
        {
            "name": "AddItemDetails",
            "baseName": "AddItemDetails",
            "type": "AddItemDetails"
        },
        {
            "name": "CreditNoteDetails",
            "baseName": "CreditNoteDetails",
            "type": "CreditNoteDetails"
        },
        {
            "name": "LumpDiscountDetails",
            "baseName": "LumpDiscountDetails",
            "type": "LumpDiscountDetails"
        },
        {
            "name": "PercentDiscountDetails",
            "baseName": "PercentDiscountDetails",
            "type": "PercentDiscountDetails"
        },
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<number>"
        },
        {
            "name": "ValidOnOrdersOver",
            "baseName": "ValidOnOrdersOver",
            "type": "number"
        },
        {
            "name": "TakesPriority",
            "baseName": "TakesPriority",
            "type": "boolean"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "IsAutomaticallyApplied",
            "baseName": "IsAutomaticallyApplied",
            "type": "boolean"
        },
        {
            "name": "IncludeDeliveryFee",
            "baseName": "IncludeDeliveryFee",
            "type": "boolean"
        },
        {
            "name": "IsValidForDeliveryOrders",
            "baseName": "IsValidForDeliveryOrders",
            "type": "boolean"
        },
        {
            "name": "IsValidForPickupOrders",
            "baseName": "IsValidForPickupOrders",
            "type": "boolean"
        },
        {
            "name": "IsValidForOrdersPayedOnline",
            "baseName": "IsValidForOrdersPayedOnline",
            "type": "boolean"
        },
        {
            "name": "IsValidForOrdersPayedByCash",
            "baseName": "IsValidForOrdersPayedByCash",
            "type": "boolean"
        },
        {
            "name": "IsValidForFirstOrderOnly",
            "baseName": "IsValidForFirstOrderOnly",
            "type": "boolean"
        },
        {
            "name": "IsValidOncePerCustomer",
            "baseName": "IsValidOncePerCustomer",
            "type": "boolean"
        },
        {
            "name": "IsValidOnlyOnce",
            "baseName": "IsValidOnlyOnce",
            "type": "boolean"
        },
        {
            "name": "StartDate",
            "baseName": "StartDate",
            "type": "Date"
        },
        {
            "name": "ExpiryDate",
            "baseName": "ExpiryDate",
            "type": "Date"
        }
    ];
    return Voucher;
}());
exports.Voucher = Voucher;
(function (Voucher) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Valid"] = 'Valid'] = "Valid";
        StatusEnum[StatusEnum["NotYetValid"] = 'NotYetValid'] = "NotYetValid";
        StatusEnum[StatusEnum["Expired"] = 'Expired'] = "Expired";
        StatusEnum[StatusEnum["Used"] = 'Used'] = "Used";
        StatusEnum[StatusEnum["Disabled"] = 'Disabled'] = "Disabled";
    })(StatusEnum = Voucher.StatusEnum || (Voucher.StatusEnum = {}));
    var VoucherTypeEnum;
    (function (VoucherTypeEnum) {
        VoucherTypeEnum[VoucherTypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        VoucherTypeEnum[VoucherTypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        VoucherTypeEnum[VoucherTypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        VoucherTypeEnum[VoucherTypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
    })(VoucherTypeEnum = Voucher.VoucherTypeEnum || (Voucher.VoucherTypeEnum = {}));
    var VoucherSubTypeEnum;
    (function (VoucherSubTypeEnum) {
        VoucherSubTypeEnum[VoucherSubTypeEnum["None"] = 'None'] = "None";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Retention"] = 'Retention'] = "Retention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(VoucherSubTypeEnum = Voucher.VoucherSubTypeEnum || (Voucher.VoucherSubTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Voucher.CurrencyEnum || (Voucher.CurrencyEnum = {}));
})(Voucher = exports.Voucher || (exports.Voucher = {}));
exports.Voucher = Voucher;
var VoucherBase = (function () {
    function VoucherBase() {
    }
    VoucherBase.getAttributeTypeMap = function () {
        return VoucherBase.attributeTypeMap;
    };
    VoucherBase.discriminator = undefined;
    VoucherBase.attributeTypeMap = [
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<number>"
        },
        {
            "name": "ValidOnOrdersOver",
            "baseName": "ValidOnOrdersOver",
            "type": "number"
        },
        {
            "name": "TakesPriority",
            "baseName": "TakesPriority",
            "type": "boolean"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "IsAutomaticallyApplied",
            "baseName": "IsAutomaticallyApplied",
            "type": "boolean"
        },
        {
            "name": "IncludeDeliveryFee",
            "baseName": "IncludeDeliveryFee",
            "type": "boolean"
        },
        {
            "name": "IsValidForDeliveryOrders",
            "baseName": "IsValidForDeliveryOrders",
            "type": "boolean"
        },
        {
            "name": "IsValidForPickupOrders",
            "baseName": "IsValidForPickupOrders",
            "type": "boolean"
        },
        {
            "name": "IsValidForOrdersPayedOnline",
            "baseName": "IsValidForOrdersPayedOnline",
            "type": "boolean"
        },
        {
            "name": "IsValidForOrdersPayedByCash",
            "baseName": "IsValidForOrdersPayedByCash",
            "type": "boolean"
        },
        {
            "name": "IsValidForFirstOrderOnly",
            "baseName": "IsValidForFirstOrderOnly",
            "type": "boolean"
        },
        {
            "name": "IsValidOncePerCustomer",
            "baseName": "IsValidOncePerCustomer",
            "type": "boolean"
        },
        {
            "name": "IsValidOnlyOnce",
            "baseName": "IsValidOnlyOnce",
            "type": "boolean"
        },
        {
            "name": "StartDate",
            "baseName": "StartDate",
            "type": "Date"
        },
        {
            "name": "ExpiryDate",
            "baseName": "ExpiryDate",
            "type": "Date"
        }
    ];
    return VoucherBase;
}());
exports.VoucherBase = VoucherBase;
var VoucherCreatedEvent = (function () {
    function VoucherCreatedEvent() {
    }
    VoucherCreatedEvent.getAttributeTypeMap = function () {
        return VoucherCreatedEvent.attributeTypeMap;
    };
    VoucherCreatedEvent.discriminator = undefined;
    VoucherCreatedEvent.attributeTypeMap = [
        {
            "name": "VoucherId",
            "baseName": "VoucherId",
            "type": "number"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Voucher",
            "baseName": "Voucher",
            "type": "Voucher"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return VoucherCreatedEvent;
}());
exports.VoucherCreatedEvent = VoucherCreatedEvent;
var VoucherDataPoint = (function () {
    function VoucherDataPoint() {
    }
    VoucherDataPoint.getAttributeTypeMap = function () {
        return VoucherDataPoint.attributeTypeMap;
    };
    VoucherDataPoint.discriminator = undefined;
    VoucherDataPoint.attributeTypeMap = [
        {
            "name": "PeriodStart",
            "baseName": "PeriodStart",
            "type": "Date"
        },
        {
            "name": "PeriodLengthInDays",
            "baseName": "PeriodLengthInDays",
            "type": "number"
        },
        {
            "name": "Value",
            "baseName": "Value",
            "type": "number"
        }
    ];
    return VoucherDataPoint;
}());
exports.VoucherDataPoint = VoucherDataPoint;
var VoucherDeletedEvent = (function () {
    function VoucherDeletedEvent() {
    }
    VoucherDeletedEvent.getAttributeTypeMap = function () {
        return VoucherDeletedEvent.attributeTypeMap;
    };
    VoucherDeletedEvent.discriminator = undefined;
    VoucherDeletedEvent.attributeTypeMap = [
        {
            "name": "VoucherId",
            "baseName": "VoucherId",
            "type": "number"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Voucher",
            "baseName": "Voucher",
            "type": "Voucher"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return VoucherDeletedEvent;
}());
exports.VoucherDeletedEvent = VoucherDeletedEvent;
var VoucherSummary = (function () {
    function VoucherSummary() {
    }
    VoucherSummary.getAttributeTypeMap = function () {
        return VoucherSummary.attributeTypeMap;
    };
    VoucherSummary.discriminator = undefined;
    VoucherSummary.attributeTypeMap = [
        {
            "name": "VoucherId",
            "baseName": "VoucherId",
            "type": "number"
        },
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "VoucherSummary.StatusEnum"
        },
        {
            "name": "VoucherType",
            "baseName": "VoucherType",
            "type": "VoucherSummary.VoucherTypeEnum"
        },
        {
            "name": "VoucherSubType",
            "baseName": "VoucherSubType",
            "type": "VoucherSummary.VoucherSubTypeEnum"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        }
    ];
    return VoucherSummary;
}());
exports.VoucherSummary = VoucherSummary;
(function (VoucherSummary) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Valid"] = 'Valid'] = "Valid";
        StatusEnum[StatusEnum["NotYetValid"] = 'NotYetValid'] = "NotYetValid";
        StatusEnum[StatusEnum["Expired"] = 'Expired'] = "Expired";
        StatusEnum[StatusEnum["Used"] = 'Used'] = "Used";
        StatusEnum[StatusEnum["Disabled"] = 'Disabled'] = "Disabled";
    })(StatusEnum = VoucherSummary.StatusEnum || (VoucherSummary.StatusEnum = {}));
    var VoucherTypeEnum;
    (function (VoucherTypeEnum) {
        VoucherTypeEnum[VoucherTypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        VoucherTypeEnum[VoucherTypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        VoucherTypeEnum[VoucherTypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        VoucherTypeEnum[VoucherTypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
    })(VoucherTypeEnum = VoucherSummary.VoucherTypeEnum || (VoucherSummary.VoucherTypeEnum = {}));
    var VoucherSubTypeEnum;
    (function (VoucherSubTypeEnum) {
        VoucherSubTypeEnum[VoucherSubTypeEnum["None"] = 'None'] = "None";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Retention"] = 'Retention'] = "Retention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(VoucherSubTypeEnum = VoucherSummary.VoucherSubTypeEnum || (VoucherSummary.VoucherSubTypeEnum = {}));
})(VoucherSummary = exports.VoucherSummary || (exports.VoucherSummary = {}));
exports.VoucherSummary = VoucherSummary;
var VoucherUpdatedEvent = (function () {
    function VoucherUpdatedEvent() {
    }
    VoucherUpdatedEvent.getAttributeTypeMap = function () {
        return VoucherUpdatedEvent.attributeTypeMap;
    };
    VoucherUpdatedEvent.discriminator = undefined;
    VoucherUpdatedEvent.attributeTypeMap = [
        {
            "name": "VoucherId",
            "baseName": "VoucherId",
            "type": "number"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Voucher",
            "baseName": "Voucher",
            "type": "Voucher"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return VoucherUpdatedEvent;
}());
exports.VoucherUpdatedEvent = VoucherUpdatedEvent;
var VoucherWithStats = (function () {
    function VoucherWithStats() {
    }
    VoucherWithStats.getAttributeTypeMap = function () {
        return VoucherWithStats.attributeTypeMap;
    };
    VoucherWithStats.discriminator = undefined;
    VoucherWithStats.attributeTypeMap = [
        {
            "name": "TotalUsed",
            "baseName": "TotalUsed",
            "type": "number"
        },
        {
            "name": "TotalCustomers",
            "baseName": "TotalCustomers",
            "type": "number"
        },
        {
            "name": "TotalAmountFromOrders",
            "baseName": "TotalAmountFromOrders",
            "type": "number"
        },
        {
            "name": "TotalDiscounted",
            "baseName": "TotalDiscounted",
            "type": "number"
        },
        {
            "name": "AverageOrderSize",
            "baseName": "AverageOrderSize",
            "type": "number"
        },
        {
            "name": "VoucherId",
            "baseName": "VoucherId",
            "type": "number"
        },
        {
            "name": "Status",
            "baseName": "Status",
            "type": "VoucherWithStats.StatusEnum"
        },
        {
            "name": "VoucherType",
            "baseName": "VoucherType",
            "type": "VoucherWithStats.VoucherTypeEnum"
        },
        {
            "name": "VoucherSubType",
            "baseName": "VoucherSubType",
            "type": "VoucherWithStats.VoucherSubTypeEnum"
        },
        {
            "name": "Currency",
            "baseName": "Currency",
            "type": "VoucherWithStats.CurrencyEnum"
        },
        {
            "name": "StoreNames",
            "baseName": "StoreNames",
            "type": "Array<string>"
        },
        {
            "name": "AddItemDetails",
            "baseName": "AddItemDetails",
            "type": "AddItemDetails"
        },
        {
            "name": "CreditNoteDetails",
            "baseName": "CreditNoteDetails",
            "type": "CreditNoteDetails"
        },
        {
            "name": "LumpDiscountDetails",
            "baseName": "LumpDiscountDetails",
            "type": "LumpDiscountDetails"
        },
        {
            "name": "PercentDiscountDetails",
            "baseName": "PercentDiscountDetails",
            "type": "PercentDiscountDetails"
        },
        {
            "name": "Code",
            "baseName": "Code",
            "type": "string"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "Stores",
            "baseName": "Stores",
            "type": "Array<number>"
        },
        {
            "name": "ValidOnOrdersOver",
            "baseName": "ValidOnOrdersOver",
            "type": "number"
        },
        {
            "name": "TakesPriority",
            "baseName": "TakesPriority",
            "type": "boolean"
        },
        {
            "name": "IsEnabled",
            "baseName": "IsEnabled",
            "type": "boolean"
        },
        {
            "name": "IsAutomaticallyApplied",
            "baseName": "IsAutomaticallyApplied",
            "type": "boolean"
        },
        {
            "name": "IncludeDeliveryFee",
            "baseName": "IncludeDeliveryFee",
            "type": "boolean"
        },
        {
            "name": "IsValidForDeliveryOrders",
            "baseName": "IsValidForDeliveryOrders",
            "type": "boolean"
        },
        {
            "name": "IsValidForPickupOrders",
            "baseName": "IsValidForPickupOrders",
            "type": "boolean"
        },
        {
            "name": "IsValidForOrdersPayedOnline",
            "baseName": "IsValidForOrdersPayedOnline",
            "type": "boolean"
        },
        {
            "name": "IsValidForOrdersPayedByCash",
            "baseName": "IsValidForOrdersPayedByCash",
            "type": "boolean"
        },
        {
            "name": "IsValidForFirstOrderOnly",
            "baseName": "IsValidForFirstOrderOnly",
            "type": "boolean"
        },
        {
            "name": "IsValidOncePerCustomer",
            "baseName": "IsValidOncePerCustomer",
            "type": "boolean"
        },
        {
            "name": "IsValidOnlyOnce",
            "baseName": "IsValidOnlyOnce",
            "type": "boolean"
        },
        {
            "name": "StartDate",
            "baseName": "StartDate",
            "type": "Date"
        },
        {
            "name": "ExpiryDate",
            "baseName": "ExpiryDate",
            "type": "Date"
        }
    ];
    return VoucherWithStats;
}());
exports.VoucherWithStats = VoucherWithStats;
(function (VoucherWithStats) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Valid"] = 'Valid'] = "Valid";
        StatusEnum[StatusEnum["NotYetValid"] = 'NotYetValid'] = "NotYetValid";
        StatusEnum[StatusEnum["Expired"] = 'Expired'] = "Expired";
        StatusEnum[StatusEnum["Used"] = 'Used'] = "Used";
        StatusEnum[StatusEnum["Disabled"] = 'Disabled'] = "Disabled";
    })(StatusEnum = VoucherWithStats.StatusEnum || (VoucherWithStats.StatusEnum = {}));
    var VoucherTypeEnum;
    (function (VoucherTypeEnum) {
        VoucherTypeEnum[VoucherTypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        VoucherTypeEnum[VoucherTypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        VoucherTypeEnum[VoucherTypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        VoucherTypeEnum[VoucherTypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
    })(VoucherTypeEnum = VoucherWithStats.VoucherTypeEnum || (VoucherWithStats.VoucherTypeEnum = {}));
    var VoucherSubTypeEnum;
    (function (VoucherSubTypeEnum) {
        VoucherSubTypeEnum[VoucherSubTypeEnum["None"] = 'None'] = "None";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Retention"] = 'Retention'] = "Retention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(VoucherSubTypeEnum = VoucherWithStats.VoucherSubTypeEnum || (VoucherWithStats.VoucherSubTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = VoucherWithStats.CurrencyEnum || (VoucherWithStats.CurrencyEnum = {}));
})(VoucherWithStats = exports.VoucherWithStats || (exports.VoucherWithStats = {}));
exports.VoucherWithStats = VoucherWithStats;
var WebhookEventSample = (function () {
    function WebhookEventSample() {
    }
    WebhookEventSample.getAttributeTypeMap = function () {
        return WebhookEventSample.attributeTypeMap;
    };
    WebhookEventSample.discriminator = undefined;
    WebhookEventSample.attributeTypeMap = [
        {
            "name": "Type",
            "baseName": "Type",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Body",
            "baseName": "Body",
            "type": "FlipdishEventBase"
        }
    ];
    return WebhookEventSample;
}());
exports.WebhookEventSample = WebhookEventSample;
var WebhookLog = (function () {
    function WebhookLog() {
    }
    WebhookLog.getAttributeTypeMap = function () {
        return WebhookLog.attributeTypeMap;
    };
    WebhookLog.discriminator = undefined;
    WebhookLog.attributeTypeMap = [
        {
            "name": "WebhookSubscriptionOwnerUserId",
            "baseName": "WebhookSubscriptionOwnerUserId",
            "type": "number"
        },
        {
            "name": "EventCreated",
            "baseName": "EventCreated",
            "type": "string"
        },
        {
            "name": "WebhookTriggered",
            "baseName": "WebhookTriggered",
            "type": "string"
        },
        {
            "name": "WebhookEventName",
            "baseName": "WebhookEventName",
            "type": "string"
        },
        {
            "name": "WebhookSubscriptionCallbackUrl",
            "baseName": "WebhookSubscriptionCallbackUrl",
            "type": "string"
        },
        {
            "name": "HttpResponseStatusCode",
            "baseName": "HttpResponseStatusCode",
            "type": "string"
        },
        {
            "name": "HttpResponseStatus",
            "baseName": "HttpResponseStatus",
            "type": "string"
        },
        {
            "name": "RequestHeaders",
            "baseName": "RequestHeaders",
            "type": "string"
        },
        {
            "name": "RequestBody",
            "baseName": "RequestBody",
            "type": "string"
        },
        {
            "name": "ResponseHeaders",
            "baseName": "ResponseHeaders",
            "type": "string"
        },
        {
            "name": "ResponseBody",
            "baseName": "ResponseBody",
            "type": "string"
        },
        {
            "name": "Duration",
            "baseName": "Duration",
            "type": "string"
        },
        {
            "name": "RetryCount",
            "baseName": "RetryCount",
            "type": "number"
        },
        {
            "name": "FlipdishWebhookId",
            "baseName": "FlipdishWebhookId",
            "type": "string"
        },
        {
            "name": "Version",
            "baseName": "Version",
            "type": "string"
        }
    ];
    return WebhookLog;
}());
exports.WebhookLog = WebhookLog;
var WebhookSubscription = (function () {
    function WebhookSubscription() {
    }
    WebhookSubscription.getAttributeTypeMap = function () {
        return WebhookSubscription.attributeTypeMap;
    };
    WebhookSubscription.discriminator = undefined;
    WebhookSubscription.attributeTypeMap = [
        {
            "name": "Id",
            "baseName": "Id",
            "type": "number"
        },
        {
            "name": "OwnerUserId",
            "baseName": "OwnerUserId",
            "type": "number"
        },
        {
            "name": "Version",
            "baseName": "Version",
            "type": "string"
        },
        {
            "name": "EventNames",
            "baseName": "EventNames",
            "type": "Array<string>"
        },
        {
            "name": "CallbackUrl",
            "baseName": "CallbackUrl",
            "type": "string"
        },
        {
            "name": "Enabled",
            "baseName": "Enabled",
            "type": "boolean"
        },
        {
            "name": "VerifyToken",
            "baseName": "VerifyToken",
            "type": "string"
        }
    ];
    return WebhookSubscription;
}());
exports.WebhookSubscription = WebhookSubscription;
var WebhookSubscriptionCreatedEvent = (function () {
    function WebhookSubscriptionCreatedEvent() {
    }
    WebhookSubscriptionCreatedEvent.getAttributeTypeMap = function () {
        return WebhookSubscriptionCreatedEvent.attributeTypeMap;
    };
    WebhookSubscriptionCreatedEvent.discriminator = undefined;
    WebhookSubscriptionCreatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "WebhookSubscriptionEventInfo",
            "baseName": "WebhookSubscriptionEventInfo",
            "type": "WebhookSubscriptionEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return WebhookSubscriptionCreatedEvent;
}());
exports.WebhookSubscriptionCreatedEvent = WebhookSubscriptionCreatedEvent;
var WebhookSubscriptionDeletedEvent = (function () {
    function WebhookSubscriptionDeletedEvent() {
    }
    WebhookSubscriptionDeletedEvent.getAttributeTypeMap = function () {
        return WebhookSubscriptionDeletedEvent.attributeTypeMap;
    };
    WebhookSubscriptionDeletedEvent.discriminator = undefined;
    WebhookSubscriptionDeletedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "WebhookSubscriptionEventInfo",
            "baseName": "WebhookSubscriptionEventInfo",
            "type": "WebhookSubscriptionEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return WebhookSubscriptionDeletedEvent;
}());
exports.WebhookSubscriptionDeletedEvent = WebhookSubscriptionDeletedEvent;
var WebhookSubscriptionEventInfo = (function () {
    function WebhookSubscriptionEventInfo() {
    }
    WebhookSubscriptionEventInfo.getAttributeTypeMap = function () {
        return WebhookSubscriptionEventInfo.attributeTypeMap;
    };
    WebhookSubscriptionEventInfo.discriminator = undefined;
    WebhookSubscriptionEventInfo.attributeTypeMap = [
        {
            "name": "OwnerUserId",
            "baseName": "OwnerUserId",
            "type": "number"
        },
        {
            "name": "WebhookSubscriptionId",
            "baseName": "WebhookSubscriptionId",
            "type": "number"
        },
        {
            "name": "ClientId",
            "baseName": "ClientId",
            "type": "string"
        },
        {
            "name": "CallbackUrl",
            "baseName": "CallbackUrl",
            "type": "string"
        }
    ];
    return WebhookSubscriptionEventInfo;
}());
exports.WebhookSubscriptionEventInfo = WebhookSubscriptionEventInfo;
var WebhookSubscriptionUpdatedEvent = (function () {
    function WebhookSubscriptionUpdatedEvent() {
    }
    WebhookSubscriptionUpdatedEvent.getAttributeTypeMap = function () {
        return WebhookSubscriptionUpdatedEvent.attributeTypeMap;
    };
    WebhookSubscriptionUpdatedEvent.discriminator = undefined;
    WebhookSubscriptionUpdatedEvent.attributeTypeMap = [
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "WebhookSubscriptionEventInfo",
            "baseName": "WebhookSubscriptionEventInfo",
            "type": "WebhookSubscriptionEventInfo"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return WebhookSubscriptionUpdatedEvent;
}());
exports.WebhookSubscriptionUpdatedEvent = WebhookSubscriptionUpdatedEvent;
var WebsiteImage = (function () {
    function WebsiteImage() {
    }
    WebsiteImage.getAttributeTypeMap = function () {
        return WebsiteImage.attributeTypeMap;
    };
    WebsiteImage.discriminator = undefined;
    WebsiteImage.attributeTypeMap = [
        {
            "name": "ImageId",
            "baseName": "ImageId",
            "type": "number"
        },
        {
            "name": "ImageLocation",
            "baseName": "ImageLocation",
            "type": "WebsiteImage.ImageLocationEnum"
        },
        {
            "name": "ImageUrl",
            "baseName": "ImageUrl",
            "type": "string"
        }
    ];
    return WebsiteImage;
}());
exports.WebsiteImage = WebsiteImage;
(function (WebsiteImage) {
    var ImageLocationEnum;
    (function (ImageLocationEnum) {
        ImageLocationEnum[ImageLocationEnum["IndexHeader"] = 'IndexHeader'] = "IndexHeader";
        ImageLocationEnum[ImageLocationEnum["IndexAboutSectionLeft"] = 'IndexAboutSectionLeft'] = "IndexAboutSectionLeft";
        ImageLocationEnum[ImageLocationEnum["IndexAboutSectionRight"] = 'IndexAboutSectionRight'] = "IndexAboutSectionRight";
        ImageLocationEnum[ImageLocationEnum["IndexGallery"] = 'IndexGallery'] = "IndexGallery";
        ImageLocationEnum[ImageLocationEnum["IndexOpeningHoursHeader"] = 'IndexOpeningHoursHeader'] = "IndexOpeningHoursHeader";
        ImageLocationEnum[ImageLocationEnum["IndexTestimonialsHeader"] = 'IndexTestimonialsHeader'] = "IndexTestimonialsHeader";
    })(ImageLocationEnum = WebsiteImage.ImageLocationEnum || (WebsiteImage.ImageLocationEnum = {}));
})(WebsiteImage = exports.WebsiteImage || (exports.WebsiteImage = {}));
exports.WebsiteImage = WebsiteImage;
var WebsiteTestimonial = (function () {
    function WebsiteTestimonial() {
    }
    WebsiteTestimonial.getAttributeTypeMap = function () {
        return WebsiteTestimonial.attributeTypeMap;
    };
    WebsiteTestimonial.discriminator = undefined;
    WebsiteTestimonial.attributeTypeMap = [
        {
            "name": "TestimonialId",
            "baseName": "TestimonialId",
            "type": "number"
        },
        {
            "name": "Author",
            "baseName": "Author",
            "type": "string"
        },
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        }
    ];
    return WebsiteTestimonial;
}());
exports.WebsiteTestimonial = WebsiteTestimonial;
var WebsiteTestimonialBase = (function () {
    function WebsiteTestimonialBase() {
    }
    WebsiteTestimonialBase.getAttributeTypeMap = function () {
        return WebsiteTestimonialBase.attributeTypeMap;
    };
    WebsiteTestimonialBase.discriminator = undefined;
    WebsiteTestimonialBase.attributeTypeMap = [
        {
            "name": "Author",
            "baseName": "Author",
            "type": "string"
        },
        {
            "name": "Message",
            "baseName": "Message",
            "type": "string"
        }
    ];
    return WebsiteTestimonialBase;
}());
exports.WebsiteTestimonialBase = WebsiteTestimonialBase;
var WebsiteUpdatedEvent = (function () {
    function WebsiteUpdatedEvent() {
    }
    WebsiteUpdatedEvent.getAttributeTypeMap = function () {
        return WebsiteUpdatedEvent.attributeTypeMap;
    };
    WebsiteUpdatedEvent.discriminator = undefined;
    WebsiteUpdatedEvent.attributeTypeMap = [
        {
            "name": "AppNameId",
            "baseName": "AppNameId",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return WebsiteUpdatedEvent;
}());
exports.WebsiteUpdatedEvent = WebsiteUpdatedEvent;
var WebsiteVanityUrlUpdatedEvent = (function () {
    function WebsiteVanityUrlUpdatedEvent() {
    }
    WebsiteVanityUrlUpdatedEvent.getAttributeTypeMap = function () {
        return WebsiteVanityUrlUpdatedEvent.attributeTypeMap;
    };
    WebsiteVanityUrlUpdatedEvent.discriminator = undefined;
    WebsiteVanityUrlUpdatedEvent.attributeTypeMap = [
        {
            "name": "Description",
            "baseName": "Description",
            "type": "string"
        },
        {
            "name": "User",
            "baseName": "User",
            "type": "UserEventInfo"
        },
        {
            "name": "VanityUrl",
            "baseName": "VanityUrl",
            "type": "string"
        },
        {
            "name": "EventName",
            "baseName": "EventName",
            "type": "string"
        },
        {
            "name": "FlipdishEventId",
            "baseName": "FlipdishEventId",
            "type": "string"
        },
        {
            "name": "CreateTime",
            "baseName": "CreateTime",
            "type": "Date"
        },
        {
            "name": "Position",
            "baseName": "Position",
            "type": "number"
        },
        {
            "name": "AppId",
            "baseName": "AppId",
            "type": "string"
        },
        {
            "name": "IpAddress",
            "baseName": "IpAddress",
            "type": "string"
        }
    ];
    return WebsiteVanityUrlUpdatedEvent;
}());
exports.WebsiteVanityUrlUpdatedEvent = WebsiteVanityUrlUpdatedEvent;
var enumsMap = {
    "AccountFieldDefinition.KeyEnum": AccountFieldDefinition.KeyEnum,
    "AccountFieldDefinition.TypeEnum": AccountFieldDefinition.TypeEnum,
    "AccountFieldKeyValuePair.KeyEnum": AccountFieldKeyValuePair.KeyEnum,
    "ApmHourlyDataPoint.DayEnum": ApmHourlyDataPoint.DayEnum,
    "App.AppAccessLevelEnum": App.AppAccessLevelEnum,
    "App.AppResourceSetEnum": App.AppResourceSetEnum,
    "App.ApplicationCategoryEnum": App.ApplicationCategoryEnum,
    "AppCompliance.ComplianceTypeEnum": AppCompliance.ComplianceTypeEnum,
    "AppConfigSalesChannel.EmailRequestModeEnum": AppConfigSalesChannel.EmailRequestModeEnum,
    "AppConfigSalesChannel.WebToAppRedirectEnum": AppConfigSalesChannel.WebToAppRedirectEnum,
    "AppConfigSalesChannel.AddressEntryTypeEnum": AppConfigSalesChannel.AddressEntryTypeEnum,
    "AppConfigUpdateModel.ApplicationCategoryEnum": AppConfigUpdateModel.ApplicationCategoryEnum,
    "AppStoreApp.VerificationStatusEnum": AppStoreApp.VerificationStatusEnum,
    "AppStoreApp.ConfigurationTypeEnum": AppStoreApp.ConfigurationTypeEnum,
    "AppStoreApp.StoreSelectorTypeEnum": AppStoreApp.StoreSelectorTypeEnum,
    "AppStoreApp.TeammateAppAccessLevelEnum": AppStoreApp.TeammateAppAccessLevelEnum,
    "AppStoreApp.PermissionsTypeEnum": AppStoreApp.PermissionsTypeEnum,
    "AppStoreApp.CategoriesEnum": AppStoreApp.CategoriesEnum,
    "AppStoreApp.CountriesEnum": AppStoreApp.CountriesEnum,
    "AppStoreAppConfiguration.VerificationStatusEnum": AppStoreAppConfiguration.VerificationStatusEnum,
    "AppStoreAppConfiguration.ConfigurationTypeEnum": AppStoreAppConfiguration.ConfigurationTypeEnum,
    "AppStoreAppConfiguration.StoreSelectorTypeEnum": AppStoreAppConfiguration.StoreSelectorTypeEnum,
    "AppStoreAppConfiguration.TeammateAppAccessLevelEnum": AppStoreAppConfiguration.TeammateAppAccessLevelEnum,
    "AppStoreAppConfiguration.PermissionsTypeEnum": AppStoreAppConfiguration.PermissionsTypeEnum,
    "AppStoreAppConfiguration.CategoriesEnum": AppStoreAppConfiguration.CategoriesEnum,
    "AppStoreAppConfiguration.CountriesEnum": AppStoreAppConfiguration.CountriesEnum,
    "AppStoreAppConfigurationSummary.ConfigurationTypeEnum": AppStoreAppConfigurationSummary.ConfigurationTypeEnum,
    "AppStoreAppConfigurationSummary.StoreSelectorTypeEnum": AppStoreAppConfigurationSummary.StoreSelectorTypeEnum,
    "AppStoreAppSummary.VerificationStatusEnum": AppStoreAppSummary.VerificationStatusEnum,
    "AppStoreAppSummary.CategoriesEnum": AppStoreAppSummary.CategoriesEnum,
    "AppStoreAppSummary.CountriesEnum": AppStoreAppSummary.CountriesEnum,
    "BankAccount.AccountStateEnum": BankAccount.AccountStateEnum,
    "BankAccountCreate.CurrencyCodeEnum": BankAccountCreate.CurrencyCodeEnum,
    "BankAccountCreate.BusinessTypeEnum": BankAccountCreate.BusinessTypeEnum,
    "BankAccountDetail.AccountStateEnum": BankAccountDetail.AccountStateEnum,
    "BankAccountDetail.CurrencyCodeEnum": BankAccountDetail.CurrencyCodeEnum,
    "BankAccountDetail.BusinessTypeEnum": BankAccountDetail.BusinessTypeEnum,
    "BankAccountDetailsUpdateRequest.BusinessTypeEnum": BankAccountDetailsUpdateRequest.BusinessTypeEnum,
    "BankAccountSummary.AccountStateEnum": BankAccountSummary.AccountStateEnum,
    "BankAccountSummary.BusinessTypeEnum": BankAccountSummary.BusinessTypeEnum,
    "BluetoothTerminalStatus.DeviceTypeEnum": BluetoothTerminalStatus.DeviceTypeEnum,
    "BluetoothTerminalStatus.StatusEnum": BluetoothTerminalStatus.StatusEnum,
    "BusinessHoursOverride.DeliveryTypeEnum": BusinessHoursOverride.DeliveryTypeEnum,
    "BusinessHoursOverride.TypeEnum": BusinessHoursOverride.TypeEnum,
    "BusinessHoursOverrideBase.DeliveryTypeEnum": BusinessHoursOverrideBase.DeliveryTypeEnum,
    "BusinessHoursOverrideBase.TypeEnum": BusinessHoursOverrideBase.TypeEnum,
    "BusinessHoursPeriod.DayOfWeekEnum": BusinessHoursPeriod.DayOfWeekEnum,
    "BusinessHoursPeriodBase.DayOfWeekEnum": BusinessHoursPeriodBase.DayOfWeekEnum,
    "CatalogGroupReference.GroupTypeEnum": CatalogGroupReference.GroupTypeEnum,
    "CatalogItem.ItemTypeEnum": CatalogItem.ItemTypeEnum,
    "Channel.SourceEnum": Channel.SourceEnum,
    "CreateAppStoreApp.ConfigurationTypeEnum": CreateAppStoreApp.ConfigurationTypeEnum,
    "CreateAppStoreApp.StoreSelectorTypeEnum": CreateAppStoreApp.StoreSelectorTypeEnum,
    "CreateAppStoreApp.TeammateAppAccessLevelEnum": CreateAppStoreApp.TeammateAppAccessLevelEnum,
    "CreateAppStoreApp.PermissionsTypeEnum": CreateAppStoreApp.PermissionsTypeEnum,
    "CreateAppStoreApp.CategoriesEnum": CreateAppStoreApp.CategoriesEnum,
    "CreateAppStoreApp.CountriesEnum": CreateAppStoreApp.CountriesEnum,
    "CreateCatalogGroupReference.GroupTypeEnum": CreateCatalogGroupReference.GroupTypeEnum,
    "CreateCatalogItem.ItemTypeEnum": CreateCatalogItem.ItemTypeEnum,
    "CreateFulfillmentStatesConfiguration.StoreSelectorTypeEnum": CreateFulfillmentStatesConfiguration.StoreSelectorTypeEnum,
    "CreateFullMenu.MenuSectionBehaviourEnum": CreateFullMenu.MenuSectionBehaviourEnum,
    "CreateFullMenu.TaxTypeEnum": CreateFullMenu.TaxTypeEnum,
    "CreateFullMenuItemOptionSet.CellLayoutTypeEnum": CreateFullMenuItemOptionSet.CellLayoutTypeEnum,
    "CreateFullMenuItemOptionSetItem.CellLayoutTypeEnum": CreateFullMenuItemOptionSetItem.CellLayoutTypeEnum,
    "CreateFullMenuSectionItem.SpicinessRatingEnum": CreateFullMenuSectionItem.SpicinessRatingEnum,
    "CreateFullMenuSectionItem.CellLayoutTypeEnum": CreateFullMenuSectionItem.CellLayoutTypeEnum,
    "CreateGroup.GroupTypeEnum": CreateGroup.GroupTypeEnum,
    "CreateGroupReference.GroupTypeEnum": CreateGroupReference.GroupTypeEnum,
    "CreateMetafieldDefinition.OwnerEntityEnum": CreateMetafieldDefinition.OwnerEntityEnum,
    "CreateMetafieldDefinition.ValueTypeEnum": CreateMetafieldDefinition.ValueTypeEnum,
    "CreateMetafieldDefinition.BehaviorsEnum": CreateMetafieldDefinition.BehaviorsEnum,
    "CreateProduct.ProductTypeEnum": CreateProduct.ProductTypeEnum,
    "CreateProductReference.ProductTypeEnum": CreateProductReference.ProductTypeEnum,
    "CreateTeammate.AppAccessLevelEnum": CreateTeammate.AppAccessLevelEnum,
    "CreateVoucher.VoucherTypeEnum": CreateVoucher.VoucherTypeEnum,
    "CurrencyData.CurrencyEnum": CurrencyData.CurrencyEnum,
    "CustomerDeliveryTrackingOrder.CurrencyEnum": CustomerDeliveryTrackingOrder.CurrencyEnum,
    "DuringOrderPromotionOptionsDm.DuringOrderPromotionTypeEnum": DuringOrderPromotionOptionsDm.DuringOrderPromotionTypeEnum,
    "ExecuteConfigurationActionResult.RedirectTargetEnum": ExecuteConfigurationActionResult.RedirectTargetEnum,
    "Field.FieldTypeEnum": Field.FieldTypeEnum,
    "FulfillmentInfo.DispatchTypeEnum": FulfillmentInfo.DispatchTypeEnum,
    "FulfillmentStatesConfiguration.StoreSelectorTypeEnum": FulfillmentStatesConfiguration.StoreSelectorTypeEnum,
    "FulfillmentStatesConfigurationSummary.StoreSelectorTypeEnum": FulfillmentStatesConfigurationSummary.StoreSelectorTypeEnum,
    "FulfillmentStatusConfigurationItem.ChangeTypeEnum": FulfillmentStatusConfigurationItem.ChangeTypeEnum,
    "FulfillmentStatusConfigurationItem.OrderTypesEnum": FulfillmentStatusConfigurationItem.OrderTypesEnum,
    "Group.GroupTypeEnum": Group.GroupTypeEnum,
    "GroupReference.GroupTypeEnum": GroupReference.GroupTypeEnum,
    "HomeAction.HomeActionTypeEnum": HomeAction.HomeActionTypeEnum,
    "HydraConfig.PaymentOptionsEnum": HydraConfig.PaymentOptionsEnum,
    "HydraConnectionStatusChangedEvent.HydraDeviceStatusEnum": HydraConnectionStatusChangedEvent.HydraDeviceStatusEnum,
    "HydraDeviceDetails.DeviceTypeEnum": HydraDeviceDetails.DeviceTypeEnum,
    "HydraDeviceDetails.StatusEnum": HydraDeviceDetails.StatusEnum,
    "HydraStatus.UserTypeEnum": HydraStatus.UserTypeEnum,
    "Invoice.CurrencyEnum": Invoice.CurrencyEnum,
    "Invoice.StatusEnum": Invoice.StatusEnum,
    "KioskBluetoothInstallUpdateInitiateEvent.BluetoothTerminalTypeEnum": KioskBluetoothInstallUpdateInitiateEvent.BluetoothTerminalTypeEnum,
    "KioskBluetoothPairingModeEvent.BluetoothTerminalTypeEnum": KioskBluetoothPairingModeEvent.BluetoothTerminalTypeEnum,
    "KioskBluetoothTerminalCancelUpdateEvent.BluetoothTerminalTypeEnum": KioskBluetoothTerminalCancelUpdateEvent.BluetoothTerminalTypeEnum,
    "KioskBluetoothTerminalFirmwareVersionStatusEvent.UpdateTimeEstimateEnum": KioskBluetoothTerminalFirmwareVersionStatusEvent.UpdateTimeEstimateEnum,
    "KioskBluetoothTerminalInstallationStatusEvent.BluetoothTerminalTypeEnum": KioskBluetoothTerminalInstallationStatusEvent.BluetoothTerminalTypeEnum,
    "KioskBluetoothTerminalUnpairedEvent.BluetoothTerminalTypeEnum": KioskBluetoothTerminalUnpairedEvent.BluetoothTerminalTypeEnum,
    "KioskBluetoothTerminalUpdatedEvent.BluetoothTerminalTypeEnum": KioskBluetoothTerminalUpdatedEvent.BluetoothTerminalTypeEnum,
    "KioskBluetoothUnpairingModeEvent.BluetoothTerminalTypeEnum": KioskBluetoothUnpairingModeEvent.BluetoothTerminalTypeEnum,
    "KioskTerminalActionStateChangedEvent.BluetoothTerminalTypeEnum": KioskTerminalActionStateChangedEvent.BluetoothTerminalTypeEnum,
    "LightspeedSettings.PriceTypeEnum": LightspeedSettings.PriceTypeEnum,
    "Menu.MenuSectionBehaviourEnum": Menu.MenuSectionBehaviourEnum,
    "Menu.TaxTypeEnum": Menu.TaxTypeEnum,
    "MenuBase.MenuSectionBehaviourEnum": MenuBase.MenuSectionBehaviourEnum,
    "MenuBase.TaxTypeEnum": MenuBase.TaxTypeEnum,
    "MenuCatalogItem.CellLayoutTypeEnum": MenuCatalogItem.CellLayoutTypeEnum,
    "MenuElementEditResponse.MenuElementTypeEnum": MenuElementEditResponse.MenuElementTypeEnum,
    "MenuElementEditResponse.ValidationCodeEnum": MenuElementEditResponse.ValidationCodeEnum,
    "MenuElementHide.MenuElementTypeEnum": MenuElementHide.MenuElementTypeEnum,
    "MenuElementListItemResponse.MenuElementTypeEnum": MenuElementListItemResponse.MenuElementTypeEnum,
    "MenuItemOptionSet.CellLayoutTypeEnum": MenuItemOptionSet.CellLayoutTypeEnum,
    "MenuItemOptionSetBase.CellLayoutTypeEnum": MenuItemOptionSetBase.CellLayoutTypeEnum,
    "MenuItemOptionSetItem.CellLayoutTypeEnum": MenuItemOptionSetItem.CellLayoutTypeEnum,
    "MenuItemOptionSetItemBase.CellLayoutTypeEnum": MenuItemOptionSetItemBase.CellLayoutTypeEnum,
    "MenuSectionAvailability.AvailabilityModeEnum": MenuSectionAvailability.AvailabilityModeEnum,
    "MenuSectionAvailabilityBase.AvailabilityModeEnum": MenuSectionAvailabilityBase.AvailabilityModeEnum,
    "MenuSectionItem.SpicinessRatingEnum": MenuSectionItem.SpicinessRatingEnum,
    "MenuSectionItem.CellLayoutTypeEnum": MenuSectionItem.CellLayoutTypeEnum,
    "MenuSectionItemBase.SpicinessRatingEnum": MenuSectionItemBase.SpicinessRatingEnum,
    "MenuSectionItemBase.CellLayoutTypeEnum": MenuSectionItemBase.CellLayoutTypeEnum,
    "MenuTaxDetails.TaxTypeEnum": MenuTaxDetails.TaxTypeEnum,
    "MetafieldDefinition.OwnerEntityEnum": MetafieldDefinition.OwnerEntityEnum,
    "MetafieldDefinition.ValueTypeEnum": MetafieldDefinition.ValueTypeEnum,
    "MetafieldDefinition.BehaviorsEnum": MetafieldDefinition.BehaviorsEnum,
    "MetafieldDefinitionRecommendation.OwnerEntityEnum": MetafieldDefinitionRecommendation.OwnerEntityEnum,
    "MetafieldDefinitionRecommendation.ValueTypeEnum": MetafieldDefinitionRecommendation.ValueTypeEnum,
    "MetafieldDefinitionRecommendation.BehaviorsEnum": MetafieldDefinitionRecommendation.BehaviorsEnum,
    "MobileAppsStatistics.PlatformTypeEnum": MobileAppsStatistics.PlatformTypeEnum,
    "MobileAppsSubmissionStatus.TypeEnum": MobileAppsSubmissionStatus.TypeEnum,
    "MobileAppsSubmissionStatus.AppStatusEnum": MobileAppsSubmissionStatus.AppStatusEnum,
    "MobileAppsSubmissionStatus.UpdateStatusEnum": MobileAppsSubmissionStatus.UpdateStatusEnum,
    "NextStatusWithOrderType.OrderTypeEnum": NextStatusWithOrderType.OrderTypeEnum,
    "OAuthApp.FlowEnum": OAuthApp.FlowEnum,
    "OAuthApp.RefreshTokenUsageEnum": OAuthApp.RefreshTokenUsageEnum,
    "OnboardingItemUpdate.StatusEnum": OnboardingItemUpdate.StatusEnum,
    "Order.DeliveryTypeEnum": Order.DeliveryTypeEnum,
    "Order.PickupLocationTypeEnum": Order.PickupLocationTypeEnum,
    "Order.TableServiceCatagoryEnum": Order.TableServiceCatagoryEnum,
    "Order.PaymentAccountTypeEnum": Order.PaymentAccountTypeEnum,
    "Order.OrderStateEnum": Order.OrderStateEnum,
    "Order.AppTypeEnum": Order.AppTypeEnum,
    "Order.PaymentStatusEnum": Order.PaymentStatusEnum,
    "Order.RejectionReasonEnum": Order.RejectionReasonEnum,
    "Order.DeliveryTrackingStatusEnum": Order.DeliveryTrackingStatusEnum,
    "OrderDeliveryInformation.StatusEnum": OrderDeliveryInformation.StatusEnum,
    "OrderDeliveryInformationBase.StatusEnum": OrderDeliveryInformationBase.StatusEnum,
    "OrderDm.DeliveryTypeEnum": OrderDm.DeliveryTypeEnum,
    "OrderDm.PickupLocationTypeEnum": OrderDm.PickupLocationTypeEnum,
    "OrderDm.TableServiceCatagoryEnum": OrderDm.TableServiceCatagoryEnum,
    "OrderIngestSubmitOrderRequest.AppTypeEnum": OrderIngestSubmitOrderRequest.AppTypeEnum,
    "OrderIngestSubmitOrderRequest.CurrencyCodeEnum": OrderIngestSubmitOrderRequest.CurrencyCodeEnum,
    "OrderIngestSubmitOrderResponse.CurrencyCodeEnum": OrderIngestSubmitOrderResponse.CurrencyCodeEnum,
    "OrderSummary.DeliveryTypeEnum": OrderSummary.DeliveryTypeEnum,
    "OrderSummary.PickupLocationTypeEnum": OrderSummary.PickupLocationTypeEnum,
    "OrderSummary.TableServiceCatagoryEnum": OrderSummary.TableServiceCatagoryEnum,
    "OrderSummary.OrderStateEnum": OrderSummary.OrderStateEnum,
    "OrderSummary.PaymentAccountTypeEnum": OrderSummary.PaymentAccountTypeEnum,
    "OrderSummary.PaymentStatusEnum": OrderSummary.PaymentStatusEnum,
    "OrderSummary.CurrencyEnum": OrderSummary.CurrencyEnum,
    "OrderSummary.AppTypeEnum": OrderSummary.AppTypeEnum,
    "OrderVoucherSummary.TypeEnum": OrderVoucherSummary.TypeEnum,
    "OrderVoucherSummary.SubTypeEnum": OrderVoucherSummary.SubTypeEnum,
    "OwnerEntityConfiguration.OwnerEntityEnum": OwnerEntityConfiguration.OwnerEntityEnum,
    "OwnerEntityConfiguration.AllowedBehaviorsEnum": OwnerEntityConfiguration.AllowedBehaviorsEnum,
    "Payout.PayoutStatusEnum": Payout.PayoutStatusEnum,
    "Payout.PayoutTypeEnum": Payout.PayoutTypeEnum,
    "Payout.CurrencyEnum": Payout.CurrencyEnum,
    "PayoutChargeback.OrderCurrencyEnum": PayoutChargeback.OrderCurrencyEnum,
    "PayoutChargeback.OrderTypeEnum": PayoutChargeback.OrderTypeEnum,
    "PayoutDetail.PayoutStatusEnum": PayoutDetail.PayoutStatusEnum,
    "PayoutDetail.PayoutTypeEnum": PayoutDetail.PayoutTypeEnum,
    "PayoutDetail.CurrencyEnum": PayoutDetail.CurrencyEnum,
    "PayoutOrder.OrderTypeEnum": PayoutOrder.OrderTypeEnum,
    "PayoutOrder.OrderCurrencyEnum": PayoutOrder.OrderCurrencyEnum,
    "PayoutOtherCharge.CurrencyEnum": PayoutOtherCharge.CurrencyEnum,
    "PayoutOtherCharge.ChargeTypeEnum": PayoutOtherCharge.ChargeTypeEnum,
    "PayoutRefund.OrderCurrencyEnum": PayoutRefund.OrderCurrencyEnum,
    "PayoutRefund.OrderTypeEnum": PayoutRefund.OrderTypeEnum,
    "PayoutRequestIds.StatesEnum": PayoutRequestIds.StatesEnum,
    "PayoutSummary.PayoutStatusEnum": PayoutSummary.PayoutStatusEnum,
    "PayoutSummary.CurrencyEnum": PayoutSummary.CurrencyEnum,
    "PhoneCall.CallStatusEnum": PhoneCall.CallStatusEnum,
    "PreOrderConfig.PreOrderTimeDisplayTypeEnum": PreOrderConfig.PreOrderTimeDisplayTypeEnum,
    "PreviousOrder.CurrencyEnum": PreviousOrder.CurrencyEnum,
    "ProcessingFeeConfig.PaymentAccountTypeEnum": ProcessingFeeConfig.PaymentAccountTypeEnum,
    "Product.ProductTypeEnum": Product.ProductTypeEnum,
    "ProductReference.ProductTypeEnum": ProductReference.ProductTypeEnum,
    "Range.DayOfWeekEnum": Range.DayOfWeekEnum,
    "RedeemInvitationResult.InvitationStatusEnum": RedeemInvitationResult.InvitationStatusEnum,
    "Reject.RejectReasonEnum": Reject.RejectReasonEnum,
    "SignupStep.ActionEnum": SignupStep.ActionEnum,
    "StatisticsCurrencyDataPoint.CurrencyEnum": StatisticsCurrencyDataPoint.CurrencyEnum,
    "Store.PrintoutLayoutTypeEnum": Store.PrintoutLayoutTypeEnum,
    "Store.CurrencyEnum": Store.CurrencyEnum,
    "StoreEndOfDayReport.CurrencyEnum": StoreEndOfDayReport.CurrencyEnum,
    "StoreGroup.CurrencyEnum": StoreGroup.CurrencyEnum,
    "StoreGroupBase.CurrencyEnum": StoreGroupBase.CurrencyEnum,
    "StoreGroupExtended.CurrencyEnum": StoreGroupExtended.CurrencyEnum,
    "StoreOpeningHoursUpdatedEvent.DeliveryTypeEnum": StoreOpeningHoursUpdatedEvent.DeliveryTypeEnum,
    "StoreOrderCapacityConfig.DeliveryTypeEnum": StoreOrderCapacityConfig.DeliveryTypeEnum,
    "StoreOrderCapacityPeriod.DayOfTheWeekEnum": StoreOrderCapacityPeriod.DayOfTheWeekEnum,
    "StoreSummary.CurrencyEnum": StoreSummary.CurrencyEnum,
    "StripeAccountLinkRequest.CollectEnum": StripeAccountLinkRequest.CollectEnum,
    "StripeAccountLinkRequest.TypeEnum": StripeAccountLinkRequest.TypeEnum,
    "StripeConnectedAccount.CardPaymentsStatusEnum": StripeConnectedAccount.CardPaymentsStatusEnum,
    "StripeConnectedAccount.TransfersStatusEnum": StripeConnectedAccount.TransfersStatusEnum,
    "StripeConnectedAccount.AccountStatusEnum": StripeConnectedAccount.AccountStatusEnum,
    "StripeConnectedAccountInfo.AccountStatusEnum": StripeConnectedAccountInfo.AccountStatusEnum,
    "StripeConnectedAccountInfo.CardPaymentStatusEnum": StripeConnectedAccountInfo.CardPaymentStatusEnum,
    "StripeConnectedAccountInfo.PayoutScheduleIntervalEnum": StripeConnectedAccountInfo.PayoutScheduleIntervalEnum,
    "StripeCustomConnectedAccount.CardPaymentsStatusEnum": StripeCustomConnectedAccount.CardPaymentsStatusEnum,
    "StripeCustomConnectedAccount.TransfersStatusEnum": StripeCustomConnectedAccount.TransfersStatusEnum,
    "StripeCustomConnectedAccount.AccountStatusEnum": StripeCustomConnectedAccount.AccountStatusEnum,
    "StuartSettings.PackageTypeEnum": StuartSettings.PackageTypeEnum,
    "StuartSettings.TransportTypeEnum": StuartSettings.TransportTypeEnum,
    "SubmitOrderResponseDm.DeliveryTypeEnum": SubmitOrderResponseDm.DeliveryTypeEnum,
    "Subscription.StatusEnum": Subscription.StatusEnum,
    "Subscription.CurrencyEnum": Subscription.CurrencyEnum,
    "SubscriptionProduct.PaymentFrequencyEnum": SubscriptionProduct.PaymentFrequencyEnum,
    "SubscriptionSummary.StatusEnum": SubscriptionSummary.StatusEnum,
    "SubscriptionSummary.CurrencyEnum": SubscriptionSummary.CurrencyEnum,
    "SupportedCountry.AddressLayoutEnum": SupportedCountry.AddressLayoutEnum,
    "SupportedCountry.PostCodeTypeEnum": SupportedCountry.PostCodeTypeEnum,
    "SupportedCountry.SupportRegionEnum": SupportedCountry.SupportRegionEnum,
    "Teammate.InvitationStatusEnum": Teammate.InvitationStatusEnum,
    "Teammate.AppAccessLevelEnum": Teammate.AppAccessLevelEnum,
    "TeammateBase.AppAccessLevelEnum": TeammateBase.AppAccessLevelEnum,
    "UpdateAppStoreApp.ConfigurationTypeEnum": UpdateAppStoreApp.ConfigurationTypeEnum,
    "UpdateAppStoreApp.StoreSelectorTypeEnum": UpdateAppStoreApp.StoreSelectorTypeEnum,
    "UpdateAppStoreApp.TeammateAppAccessLevelEnum": UpdateAppStoreApp.TeammateAppAccessLevelEnum,
    "UpdateAppStoreApp.PermissionsTypeEnum": UpdateAppStoreApp.PermissionsTypeEnum,
    "UpdateAppStoreApp.CategoriesEnum": UpdateAppStoreApp.CategoriesEnum,
    "UpdateAppStoreApp.CountriesEnum": UpdateAppStoreApp.CountriesEnum,
    "UpdateCatalogGroupReference.GroupTypeEnum": UpdateCatalogGroupReference.GroupTypeEnum,
    "UpdateFulfillmentStatesConfiguration.StoreSelectorTypeEnum": UpdateFulfillmentStatesConfiguration.StoreSelectorTypeEnum,
    "UpdateGroupReference.GroupTypeEnum": UpdateGroupReference.GroupTypeEnum,
    "UpdateMetafieldDefinition.BehaviorsEnum": UpdateMetafieldDefinition.BehaviorsEnum,
    "UpdateMobileAppsSubmissionStatus.TypeEnum": UpdateMobileAppsSubmissionStatus.TypeEnum,
    "UpdateMobileAppsSubmissionStatus.AppStatusEnum": UpdateMobileAppsSubmissionStatus.AppStatusEnum,
    "UpdateMobileAppsSubmissionStatus.UpdateStatusEnum": UpdateMobileAppsSubmissionStatus.UpdateStatusEnum,
    "UpdateProductReference.ProductTypeEnum": UpdateProductReference.ProductTypeEnum,
    "Voucher.StatusEnum": Voucher.StatusEnum,
    "Voucher.VoucherTypeEnum": Voucher.VoucherTypeEnum,
    "Voucher.VoucherSubTypeEnum": Voucher.VoucherSubTypeEnum,
    "Voucher.CurrencyEnum": Voucher.CurrencyEnum,
    "VoucherSummary.StatusEnum": VoucherSummary.StatusEnum,
    "VoucherSummary.VoucherTypeEnum": VoucherSummary.VoucherTypeEnum,
    "VoucherSummary.VoucherSubTypeEnum": VoucherSummary.VoucherSubTypeEnum,
    "VoucherWithStats.StatusEnum": VoucherWithStats.StatusEnum,
    "VoucherWithStats.VoucherTypeEnum": VoucherWithStats.VoucherTypeEnum,
    "VoucherWithStats.VoucherSubTypeEnum": VoucherWithStats.VoucherSubTypeEnum,
    "VoucherWithStats.CurrencyEnum": VoucherWithStats.CurrencyEnum,
    "WebsiteImage.ImageLocationEnum": WebsiteImage.ImageLocationEnum,
};
var typeMap = {
    "Accept": Accept,
    "AccountDetail": AccountDetail,
    "AccountDetailBase": AccountDetailBase,
    "AccountFieldDefinition": AccountFieldDefinition,
    "AccountFieldKeyValuePair": AccountFieldKeyValuePair,
    "AccountFieldsDefinitions": AccountFieldsDefinitions,
    "AddItemDetails": AddItemDetails,
    "AddressFormDisplayFormat": AddressFormDisplayFormat,
    "AddressFormResponse": AddressFormResponse,
    "AllMetadataResult": AllMetadataResult,
    "Allergen": Allergen,
    "AnalyticsClientEvent": AnalyticsClientEvent,
    "ApmCurrencyDataPoint": ApmCurrencyDataPoint,
    "ApmDataPoint": ApmDataPoint,
    "ApmHourlyDataPoint": ApmHourlyDataPoint,
    "ApmStatistics": ApmStatistics,
    "ApmStatus": ApmStatus,
    "App": App,
    "AppChannelAssignment": AppChannelAssignment,
    "AppCompliance": AppCompliance,
    "AppConfigSalesChannel": AppConfigSalesChannel,
    "AppConfigUpdateModel": AppConfigUpdateModel,
    "AppCreatedEvent": AppCreatedEvent,
    "AppLookup": AppLookup,
    "AppSalesforceReferences": AppSalesforceReferences,
    "AppStoreApp": AppStoreApp,
    "AppStoreAppConfiguration": AppStoreAppConfiguration,
    "AppStoreAppConfigurationHeader": AppStoreAppConfigurationHeader,
    "AppStoreAppConfigurationSummary": AppStoreAppConfigurationSummary,
    "AppStoreAppConfigurationsWithSubscriptions": AppStoreAppConfigurationsWithSubscriptions,
    "AppStoreAppSubscriptionSummary": AppStoreAppSubscriptionSummary,
    "AppStoreAppSummary": AppStoreAppSummary,
    "AppStoreAppSupportInfo": AppStoreAppSupportInfo,
    "AppStoreConfigCreatedEvent": AppStoreConfigCreatedEvent,
    "AppStoreConfigDeletedEvent": AppStoreConfigDeletedEvent,
    "AppStoreConfigUpdatedEvent": AppStoreConfigUpdatedEvent,
    "AppUpdatedEvent": AppUpdatedEvent,
    "AssignedBankAccount": AssignedBankAccount,
    "AuditLogFieldChangeInformation": AuditLogFieldChangeInformation,
    "BalanceDetails": BalanceDetails,
    "BankAccount": BankAccount,
    "BankAccountAssignedEvent": BankAccountAssignedEvent,
    "BankAccountCreate": BankAccountCreate,
    "BankAccountCreatedEvent": BankAccountCreatedEvent,
    "BankAccountDeletedEvent": BankAccountDeletedEvent,
    "BankAccountDetail": BankAccountDetail,
    "BankAccountDetailsUpdateRequest": BankAccountDetailsUpdateRequest,
    "BankAccountSummary": BankAccountSummary,
    "BankAccountUpdatedEvent": BankAccountUpdatedEvent,
    "BluetoothTerminalStatus": BluetoothTerminalStatus,
    "BusinessHoursOverride": BusinessHoursOverride,
    "BusinessHoursOverrideBase": BusinessHoursOverrideBase,
    "BusinessHoursPeriod": BusinessHoursPeriod,
    "BusinessHoursPeriodBase": BusinessHoursPeriodBase,
    "CampaignStatistics": CampaignStatistics,
    "CardReader": CardReader,
    "CardReaderRegistrationRequest": CardReaderRegistrationRequest,
    "Cart": Cart,
    "CatalogGroupArchivedEvent": CatalogGroupArchivedEvent,
    "CatalogGroupCreatedEvent": CatalogGroupCreatedEvent,
    "CatalogGroupReference": CatalogGroupReference,
    "CatalogGroupUpdatedEvent": CatalogGroupUpdatedEvent,
    "CatalogImage": CatalogImage,
    "CatalogItem": CatalogItem,
    "CatalogItemArchivedEvent": CatalogItemArchivedEvent,
    "CatalogItemCreatedEvent": CatalogItemCreatedEvent,
    "CatalogItemUpdatedEvent": CatalogItemUpdatedEvent,
    "CertificateCreatedEvent": CertificateCreatedEvent,
    "CertificateRenewedEvent": CertificateRenewedEvent,
    "ChangePasswordModel": ChangePasswordModel,
    "Channel": Channel,
    "ChannelStoreMapping": ChannelStoreMapping,
    "ChargebackDetails": ChargebackDetails,
    "ClientDevice": ClientDevice,
    "ClientDeviceAssignEnrolledDevice": ClientDeviceAssignEnrolledDevice,
    "ClientDeviceEnroll": ClientDeviceEnroll,
    "ClientDeviceEnrollmentResult": ClientDeviceEnrollmentResult,
    "ClientDeviceSummary": ClientDeviceSummary,
    "ConfiguredStore": ConfiguredStore,
    "Contact": Contact,
    "Coordinates": Coordinates,
    "CoordinatesDm": CoordinatesDm,
    "CountryFormResponse": CountryFormResponse,
    "CountryWithAccountFieldsDefinitions": CountryWithAccountFieldsDefinitions,
    "CreateAccountModel": CreateAccountModel,
    "CreateAppStoreApp": CreateAppStoreApp,
    "CreateBasicAccountModel": CreateBasicAccountModel,
    "CreateCatalogGroupReference": CreateCatalogGroupReference,
    "CreateCatalogItem": CreateCatalogItem,
    "CreateFulfillmentStatesConfiguration": CreateFulfillmentStatesConfiguration,
    "CreateFullMenu": CreateFullMenu,
    "CreateFullMenuItemOptionSet": CreateFullMenuItemOptionSet,
    "CreateFullMenuItemOptionSetItem": CreateFullMenuItemOptionSetItem,
    "CreateFullMenuSection": CreateFullMenuSection,
    "CreateFullMenuSectionItem": CreateFullMenuSectionItem,
    "CreateGroup": CreateGroup,
    "CreateGroupReference": CreateGroupReference,
    "CreateLocation": CreateLocation,
    "CreateLocationArea": CreateLocationArea,
    "CreateMenuSectionItemFromCatalogItems": CreateMenuSectionItemFromCatalogItems,
    "CreateMenuTaxRate": CreateMenuTaxRate,
    "CreateMetadata": CreateMetadata,
    "CreateMetafieldDefinition": CreateMetafieldDefinition,
    "CreateOrderRequest": CreateOrderRequest,
    "CreatePayGreenConfigurationRequest": CreatePayGreenConfigurationRequest,
    "CreateProduct": CreateProduct,
    "CreateProductReference": CreateProductReference,
    "CreateTeammate": CreateTeammate,
    "CreateVoucher": CreateVoucher,
    "CreatedMenuSectionItems": CreatedMenuSectionItems,
    "CreditNoteDetails": CreditNoteDetails,
    "CrossSellMenuItems": CrossSellMenuItems,
    "CspReport": CspReport,
    "CspReportRequest": CspReportRequest,
    "CurrencyData": CurrencyData,
    "Customer": Customer,
    "CustomerConsentUpdatedEvent": CustomerConsentUpdatedEvent,
    "CustomerCreatedEvent": CustomerCreatedEvent,
    "CustomerDeliveryTrackingOrder": CustomerDeliveryTrackingOrder,
    "CustomerDeliveryTrackingOrderLine": CustomerDeliveryTrackingOrderLine,
    "CustomerSummary": CustomerSummary,
    "CustomerUpdateModel": CustomerUpdateModel,
    "CustomerUpdatedEvent": CustomerUpdatedEvent,
    "DashboardEmbed": DashboardEmbed,
    "DeliveryLocation": DeliveryLocation,
    "DeliveryZone": DeliveryZone,
    "DeliveryZoneBase": DeliveryZoneBase,
    "DeliveryZoneCreatedEvent": DeliveryZoneCreatedEvent,
    "DeliveryZoneDeletedEvent": DeliveryZoneDeletedEvent,
    "DeliveryZoneUpdatedEvent": DeliveryZoneUpdatedEvent,
    "DeviceSettings": DeviceSettings,
    "DnsRecordInformation": DnsRecordInformation,
    "DnsVerifiedEvent": DnsVerifiedEvent,
    "DriverLoginModel": DriverLoginModel,
    "DriverRequestLoginPinModel": DriverRequestLoginPinModel,
    "DuringOrderPromotionOptionsDm": DuringOrderPromotionOptionsDm,
    "DynamicFormField": DynamicFormField,
    "DynamicFormFieldOption": DynamicFormFieldOption,
    "DynamicFormRule": DynamicFormRule,
    "DynamicFormRules": DynamicFormRules,
    "EmvNotificationEvent": EmvNotificationEvent,
    "EmvTerminal": EmvTerminal,
    "EmvTerminalWithAssignments": EmvTerminalWithAssignments,
    "EventSearchResult": EventSearchResult,
    "ExecuteConfigurationActionRequest": ExecuteConfigurationActionRequest,
    "ExecuteConfigurationActionResult": ExecuteConfigurationActionResult,
    "ExternalStoreAuditLog": ExternalStoreAuditLog,
    "ExternalStoreEvent": ExternalStoreEvent,
    "FeeSummary": FeeSummary,
    "Field": Field,
    "FieldChangeInformation": FieldChangeInformation,
    "FieldGroup": FieldGroup,
    "FirebaseApp": FirebaseApp,
    "FlipdishEventBase": FlipdishEventBase,
    "FlipdishFeesDetails": FlipdishFeesDetails,
    "FulfillentStatusActionItem": FulfillentStatusActionItem,
    "FulfillmentInfo": FulfillmentInfo,
    "FulfillmentStatesConfiguration": FulfillmentStatesConfiguration,
    "FulfillmentStatesConfigurationSummary": FulfillmentStatesConfigurationSummary,
    "FulfillmentStatesConfiguredStore": FulfillmentStatesConfiguredStore,
    "FulfillmentStatusConfigurationItem": FulfillmentStatusConfigurationItem,
    "GeoPointRequest": GeoPointRequest,
    "GetReceiptByOrderIdQueryResponse": GetReceiptByOrderIdQueryResponse,
    "GoogleAddress": GoogleAddress,
    "GoogleAddressComponent": GoogleAddressComponent,
    "GoogleAddressResult": GoogleAddressResult,
    "GoogleCoordinates": GoogleCoordinates,
    "GoogleGeometry": GoogleGeometry,
    "GoogleLocation": GoogleLocation,
    "GoogleViewport": GoogleViewport,
    "Group": Group,
    "GroupReference": GroupReference,
    "GroupedCoordinates": GroupedCoordinates,
    "HomeAction": HomeAction,
    "HomeStatistics": HomeStatistics,
    "HttpRequestAndResponseLog": HttpRequestAndResponseLog,
    "HydraAssignedEvent": HydraAssignedEvent,
    "HydraConfig": HydraConfig,
    "HydraConnectionStatusChangedEvent": HydraConnectionStatusChangedEvent,
    "HydraDeviceDetails": HydraDeviceDetails,
    "HydraRegistrationRequest": HydraRegistrationRequest,
    "HydraRequestResetEvent": HydraRequestResetEvent,
    "HydraSettingChangedEvent": HydraSettingChangedEvent,
    "HydraStatus": HydraStatus,
    "HydraStoreAssignedEvent": HydraStoreAssignedEvent,
    "HydraStoreData": HydraStoreData,
    "HydraStoreUnassignedEvent": HydraStoreUnassignedEvent,
    "HydraUnAssignedEvent": HydraUnAssignedEvent,
    "IndexPage": IndexPage,
    "IndexPageBase": IndexPageBase,
    "IntercomUserHash": IntercomUserHash,
    "Invoice": Invoice,
    "InvoiceDiscount": InvoiceDiscount,
    "InvoiceItem": InvoiceItem,
    "InvoicePeriod": InvoicePeriod,
    "ItemNutritionInfoAddUpdateModel": ItemNutritionInfoAddUpdateModel,
    "JobAddress": JobAddress,
    "JobCancellation": JobCancellation,
    "JobContact": JobContact,
    "JobDelivery": JobDelivery,
    "JobDeliveryDetail": JobDeliveryDetail,
    "JobDriver": JobDriver,
    "JobEta": JobEta,
    "JobPricing": JobPricing,
    "JobProof": JobProof,
    "JobResponse": JobResponse,
    "KioskBluetoothInstallUpdateInitiateEvent": KioskBluetoothInstallUpdateInitiateEvent,
    "KioskBluetoothPairingModeEvent": KioskBluetoothPairingModeEvent,
    "KioskBluetoothTerminalCancelUpdateEvent": KioskBluetoothTerminalCancelUpdateEvent,
    "KioskBluetoothTerminalFirmwareVersionStatusEvent": KioskBluetoothTerminalFirmwareVersionStatusEvent,
    "KioskBluetoothTerminalInitiateUpdateCheckEvent": KioskBluetoothTerminalInitiateUpdateCheckEvent,
    "KioskBluetoothTerminalInstallationStatusEvent": KioskBluetoothTerminalInstallationStatusEvent,
    "KioskBluetoothTerminalUnpairedEvent": KioskBluetoothTerminalUnpairedEvent,
    "KioskBluetoothTerminalUpdatedEvent": KioskBluetoothTerminalUpdatedEvent,
    "KioskBluetoothUnpairingModeEvent": KioskBluetoothUnpairingModeEvent,
    "KioskCashPaymentSettings": KioskCashPaymentSettings,
    "KioskIotConnectionParameters": KioskIotConnectionParameters,
    "KioskSettings": KioskSettings,
    "KioskTerminalActionStateChangedEvent": KioskTerminalActionStateChangedEvent,
    "Language": Language,
    "LastPaymentError": LastPaymentError,
    "LightspeedSettings": LightspeedSettings,
    "LineItem": LineItem,
    "LineItemOption": LineItemOption,
    "LocalisedTimeZone": LocalisedTimeZone,
    "Location": Location,
    "LocationArea": LocationArea,
    "LocationAreaCreatedEvent": LocationAreaCreatedEvent,
    "LocationAreaLocation": LocationAreaLocation,
    "LocationAreaUpdatedEvent": LocationAreaUpdatedEvent,
    "LocationAreaWithLocations": LocationAreaWithLocations,
    "LocationCreatedEvent": LocationCreatedEvent,
    "LocationDeletedEvent": LocationDeletedEvent,
    "LoginModel": LoginModel,
    "LoginWithPinModel": LoginWithPinModel,
    "LoyaltyCampaign": LoyaltyCampaign,
    "LoyaltyCampaignBase": LoyaltyCampaignBase,
    "LoyaltyCampaignCreatedEvent": LoyaltyCampaignCreatedEvent,
    "LoyaltyCampaignDeletedEvent": LoyaltyCampaignDeletedEvent,
    "LoyaltyCampaignUpdatedEvent": LoyaltyCampaignUpdatedEvent,
    "LumpDiscountDetails": LumpDiscountDetails,
    "MappedLocation": MappedLocation,
    "MaskedPhoneNumber": MaskedPhoneNumber,
    "Menu": Menu,
    "MenuBase": MenuBase,
    "MenuBulkEditEvent": MenuBulkEditEvent,
    "MenuCatalogItem": MenuCatalogItem,
    "MenuCheckpoint": MenuCheckpoint,
    "MenuCheckpointCreatedEvent": MenuCheckpointCreatedEvent,
    "MenuCreatedEvent": MenuCreatedEvent,
    "MenuElementEditResponse": MenuElementEditResponse,
    "MenuElementHide": MenuElementHide,
    "MenuElementListItemResponse": MenuElementListItemResponse,
    "MenuElementListResponse": MenuElementListResponse,
    "MenuItemOptionSet": MenuItemOptionSet,
    "MenuItemOptionSetBase": MenuItemOptionSetBase,
    "MenuItemOptionSetCreatedEvent": MenuItemOptionSetCreatedEvent,
    "MenuItemOptionSetDeletedEvent": MenuItemOptionSetDeletedEvent,
    "MenuItemOptionSetItem": MenuItemOptionSetItem,
    "MenuItemOptionSetItemBase": MenuItemOptionSetItemBase,
    "MenuItemOptionSetItemCreatedEvent": MenuItemOptionSetItemCreatedEvent,
    "MenuItemOptionSetItemDeletedEvent": MenuItemOptionSetItemDeletedEvent,
    "MenuItemOptionSetItemUpdatedEvent": MenuItemOptionSetItemUpdatedEvent,
    "MenuItemOptionSetUpdatedEvent": MenuItemOptionSetUpdatedEvent,
    "MenuNutritionInfoHeader": MenuNutritionInfoHeader,
    "MenuObjectDisplayOrders": MenuObjectDisplayOrders,
    "MenuSection": MenuSection,
    "MenuSectionAvailability": MenuSectionAvailability,
    "MenuSectionAvailabilityBase": MenuSectionAvailabilityBase,
    "MenuSectionBase": MenuSectionBase,
    "MenuSectionCreatedEvent": MenuSectionCreatedEvent,
    "MenuSectionDeletedEvent": MenuSectionDeletedEvent,
    "MenuSectionItem": MenuSectionItem,
    "MenuSectionItemBase": MenuSectionItemBase,
    "MenuSectionItemCreatedEvent": MenuSectionItemCreatedEvent,
    "MenuSectionItemDeletedEvent": MenuSectionItemDeletedEvent,
    "MenuSectionItemUpdatedEvent": MenuSectionItemUpdatedEvent,
    "MenuSectionUpdatedEvent": MenuSectionUpdatedEvent,
    "MenuStoreNames": MenuStoreNames,
    "MenuSummary": MenuSummary,
    "MenuTaxDetails": MenuTaxDetails,
    "MenuTaxRate": MenuTaxRate,
    "MenuUpdatedEvent": MenuUpdatedEvent,
    "MenuUploadedEvent": MenuUploadedEvent,
    "Metadata": Metadata,
    "Metafield": Metafield,
    "MetafieldDefinition": MetafieldDefinition,
    "MetafieldDefinitionRecommendation": MetafieldDefinitionRecommendation,
    "MobileAppsImage": MobileAppsImage,
    "MobileAppsStatistics": MobileAppsStatistics,
    "MobileAppsSubmission": MobileAppsSubmission,
    "MobileAppsSubmissionDetails": MobileAppsSubmissionDetails,
    "MobileAppsSubmissionStatus": MobileAppsSubmissionStatus,
    "MobileAppsSubmissionStatusUpdatedEvent": MobileAppsSubmissionStatusUpdatedEvent,
    "MobileAppsSubmissionUpdatedEvent": MobileAppsSubmissionUpdatedEvent,
    "ModelBase": ModelBase,
    "NextStatusWithOrderType": NextStatusWithOrderType,
    "NutritionInfo": NutritionInfo,
    "NutritionInfoItemAddUpdateLabelModel": NutritionInfoItemAddUpdateLabelModel,
    "NutritionInfoLabel": NutritionInfoLabel,
    "NutritionInfoMenuItem": NutritionInfoMenuItem,
    "NutritionInfoMenuOptionSetItem": NutritionInfoMenuOptionSetItem,
    "OAuthApp": OAuthApp,
    "OAuthTokenModel": OAuthTokenModel,
    "OauthClientRedirectUri": OauthClientRedirectUri,
    "ObjectDisplayOrder": ObjectDisplayOrder,
    "OktaPortalFeatureFlag": OktaPortalFeatureFlag,
    "OnboardingConfigUpdate": OnboardingConfigUpdate,
    "OnboardingItemUpdate": OnboardingItemUpdate,
    "Order": Order,
    "OrderAcceptedEvent": OrderAcceptedEvent,
    "OrderBatch": OrderBatch,
    "OrderBatchPublishedEvent": OrderBatchPublishedEvent,
    "OrderBatchSummary": OrderBatchSummary,
    "OrderBatchingConfiguration": OrderBatchingConfiguration,
    "OrderCapacityConfigUpdatedEvent": OrderCapacityConfigUpdatedEvent,
    "OrderCreatedEvent": OrderCreatedEvent,
    "OrderCustomerTrackingCreatedEvent": OrderCustomerTrackingCreatedEvent,
    "OrderDeliveryInformation": OrderDeliveryInformation,
    "OrderDeliveryInformationBase": OrderDeliveryInformationBase,
    "OrderDeliveryTrackingStatusUpdatedEvent": OrderDeliveryTrackingStatusUpdatedEvent,
    "OrderDispatchedEvent": OrderDispatchedEvent,
    "OrderDm": OrderDm,
    "OrderDropOffLocation": OrderDropOffLocation,
    "OrderFulfillmentStatus": OrderFulfillmentStatus,
    "OrderFulfillmentStatusBase": OrderFulfillmentStatusBase,
    "OrderFulfillmentStatusUpdate": OrderFulfillmentStatusUpdate,
    "OrderFulfillmentStatusUpdatedEvent": OrderFulfillmentStatusUpdatedEvent,
    "OrderFulfillmentStatusWithConfigurationActions": OrderFulfillmentStatusWithConfigurationActions,
    "OrderIngestSubmitOrderRequest": OrderIngestSubmitOrderRequest,
    "OrderIngestSubmitOrderResponse": OrderIngestSubmitOrderResponse,
    "OrderItem": OrderItem,
    "OrderItemDm": OrderItemDm,
    "OrderItemOption": OrderItemOption,
    "OrderList": OrderList,
    "OrderPaymentInformation": OrderPaymentInformation,
    "OrderRatingUpdatedEvent": OrderRatingUpdatedEvent,
    "OrderReference": OrderReference,
    "OrderRefundedEvent": OrderRefundedEvent,
    "OrderRejectedEvent": OrderRejectedEvent,
    "OrderSummary": OrderSummary,
    "OrderTipUpdatedEvent": OrderTipUpdatedEvent,
    "OrderVoucherSummary": OrderVoucherSummary,
    "OtherChargesDetails": OtherChargesDetails,
    "OwnerEntityConfiguration": OwnerEntityConfiguration,
    "OwnerEntityConfigurations": OwnerEntityConfigurations,
    "PasswordResetModel": PasswordResetModel,
    "PaymentInfo": PaymentInfo,
    "PaymentIntent": PaymentIntent,
    "PaymentTerminalDetails": PaymentTerminalDetails,
    "PaymentTerminalTransactionDetails": PaymentTerminalTransactionDetails,
    "Payout": Payout,
    "PayoutChargeback": PayoutChargeback,
    "PayoutDetail": PayoutDetail,
    "PayoutOrder": PayoutOrder,
    "PayoutOtherCharge": PayoutOtherCharge,
    "PayoutRefund": PayoutRefund,
    "PayoutRequestIds": PayoutRequestIds,
    "PayoutStore": PayoutStore,
    "PayoutSummary": PayoutSummary,
    "PendingMenuChanges": PendingMenuChanges,
    "PendingMenuChangesSummaries": PendingMenuChangesSummaries,
    "PercentDiscountDetails": PercentDiscountDetails,
    "PhoneCall": PhoneCall,
    "PhoneCallEndedEvent": PhoneCallEndedEvent,
    "PhoneCallStartedEvent": PhoneCallStartedEvent,
    "PosRevenueDetails": PosRevenueDetails,
    "PreOrderConfig": PreOrderConfig,
    "PreOrderTime": PreOrderTime,
    "PredefinedAnswer": PredefinedAnswer,
    "PreviousOrder": PreviousOrder,
    "PreviousOrderItem": PreviousOrderItem,
    "PreviousOrderItemOption": PreviousOrderItemOption,
    "Price": Price,
    "Printer": Printer,
    "PrinterAssignedToStoreEvent": PrinterAssignedToStoreEvent,
    "PrinterTurnedOffEvent": PrinterTurnedOffEvent,
    "PrinterTurnedOnEvent": PrinterTurnedOnEvent,
    "PrinterUnassignedFromStoreEvent": PrinterUnassignedFromStoreEvent,
    "ProcessPaymentIntentRequest": ProcessPaymentIntentRequest,
    "ProcessingFeeConfig": ProcessingFeeConfig,
    "Product": Product,
    "ProductReference": ProductReference,
    "PublishMenuChanges": PublishMenuChanges,
    "PushNotificationDeletedEvent": PushNotificationDeletedEvent,
    "PushNotificationRequest": PushNotificationRequest,
    "PushNotificationResponse": PushNotificationResponse,
    "PushNotificationScheduledEvent": PushNotificationScheduledEvent,
    "PushNotificationSentEvent": PushNotificationSentEvent,
    "Range": Range,
    "ReaderActionStateInfo": ReaderActionStateInfo,
    "RedeemInvitationResult": RedeemInvitationResult,
    "Refund": Refund,
    "Reject": Reject,
    "RequestLoginPinModel": RequestLoginPinModel,
    "RequestLoginPinResponse": RequestLoginPinResponse,
    "RequestPasswordResetModel": RequestPasswordResetModel,
    "RequestPasswordResetPinResponse": RequestPasswordResetPinResponse,
    "Response": Response,
    "RestApiArrayResultAllMetadataResult": RestApiArrayResultAllMetadataResult,
    "RestApiArrayResultAllergen": RestApiArrayResultAllergen,
    "RestApiArrayResultApmCurrencyDataPoint": RestApiArrayResultApmCurrencyDataPoint,
    "RestApiArrayResultApmDataPoint": RestApiArrayResultApmDataPoint,
    "RestApiArrayResultApmHourlyDataPoint": RestApiArrayResultApmHourlyDataPoint,
    "RestApiArrayResultAppStoreAppConfigurationHeader": RestApiArrayResultAppStoreAppConfigurationHeader,
    "RestApiArrayResultAppStoreAppConfigurationSummary": RestApiArrayResultAppStoreAppConfigurationSummary,
    "RestApiArrayResultBankAccountSummary": RestApiArrayResultBankAccountSummary,
    "RestApiArrayResultBusinessHoursPeriod": RestApiArrayResultBusinessHoursPeriod,
    "RestApiArrayResultChannel": RestApiArrayResultChannel,
    "RestApiArrayResultClientDeviceSummary": RestApiArrayResultClientDeviceSummary,
    "RestApiArrayResultCountryWithAccountFieldsDefinitions": RestApiArrayResultCountryWithAccountFieldsDefinitions,
    "RestApiArrayResultDeliveryZone": RestApiArrayResultDeliveryZone,
    "RestApiArrayResultEmvTerminalWithAssignments": RestApiArrayResultEmvTerminalWithAssignments,
    "RestApiArrayResultFulfillmentStatesConfigurationSummary": RestApiArrayResultFulfillmentStatesConfigurationSummary,
    "RestApiArrayResultHomeAction": RestApiArrayResultHomeAction,
    "RestApiArrayResultKioskCashPaymentSettings": RestApiArrayResultKioskCashPaymentSettings,
    "RestApiArrayResultLocalisedTimeZone": RestApiArrayResultLocalisedTimeZone,
    "RestApiArrayResultLocationAreaLocation": RestApiArrayResultLocationAreaLocation,
    "RestApiArrayResultLocationAreaWithLocations": RestApiArrayResultLocationAreaWithLocations,
    "RestApiArrayResultLoyaltyCampaign": RestApiArrayResultLoyaltyCampaign,
    "RestApiArrayResultMenuCheckpoint": RestApiArrayResultMenuCheckpoint,
    "RestApiArrayResultMenuElementEditResponse": RestApiArrayResultMenuElementEditResponse,
    "RestApiArrayResultMenuElementListResponse": RestApiArrayResultMenuElementListResponse,
    "RestApiArrayResultMenuItemOptionSet": RestApiArrayResultMenuItemOptionSet,
    "RestApiArrayResultMenuItemOptionSetItem": RestApiArrayResultMenuItemOptionSetItem,
    "RestApiArrayResultMenuSection": RestApiArrayResultMenuSection,
    "RestApiArrayResultMenuSectionItem": RestApiArrayResultMenuSectionItem,
    "RestApiArrayResultMenuStoreNames": RestApiArrayResultMenuStoreNames,
    "RestApiArrayResultMenuSummary": RestApiArrayResultMenuSummary,
    "RestApiArrayResultMenuTaxDetails": RestApiArrayResultMenuTaxDetails,
    "RestApiArrayResultMetadata": RestApiArrayResultMetadata,
    "RestApiArrayResultMobileAppsStatistics": RestApiArrayResultMobileAppsStatistics,
    "RestApiArrayResultOAuthApp": RestApiArrayResultOAuthApp,
    "RestApiArrayResultOauthClientRedirectUri": RestApiArrayResultOauthClientRedirectUri,
    "RestApiArrayResultOrderBatch": RestApiArrayResultOrderBatch,
    "RestApiArrayResultOrderFulfillmentStatus": RestApiArrayResultOrderFulfillmentStatus,
    "RestApiArrayResultPayoutSummary": RestApiArrayResultPayoutSummary,
    "RestApiArrayResultPendingMenuChangesSummaries": RestApiArrayResultPendingMenuChangesSummaries,
    "RestApiArrayResultPreOrderTime": RestApiArrayResultPreOrderTime,
    "RestApiArrayResultProcessingFeeConfig": RestApiArrayResultProcessingFeeConfig,
    "RestApiArrayResultRestApiDefaultResponse": RestApiArrayResultRestApiDefaultResponse,
    "RestApiArrayResultRestaurantVoucherEligibleStore": RestApiArrayResultRestaurantVoucherEligibleStore,
    "RestApiArrayResultRestaurantVoucherPayGreenConfiguration": RestApiArrayResultRestaurantVoucherPayGreenConfiguration,
    "RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary": RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary,
    "RestApiArrayResultRetentionCampaign": RestApiArrayResultRetentionCampaign,
    "RestApiArrayResultStoreChannelAssignment": RestApiArrayResultStoreChannelAssignment,
    "RestApiArrayResultStoreChannelStoreMapping": RestApiArrayResultStoreChannelStoreMapping,
    "RestApiArrayResultStoreListItem": RestApiArrayResultStoreListItem,
    "RestApiArrayResultStoreStatistics": RestApiArrayResultStoreStatistics,
    "RestApiArrayResultStripeCustomConnectedAccount": RestApiArrayResultStripeCustomConnectedAccount,
    "RestApiArrayResultSubscriptionSummary": RestApiArrayResultSubscriptionSummary,
    "RestApiArrayResultSupportedCountry": RestApiArrayResultSupportedCountry,
    "RestApiArrayResultTeammate": RestApiArrayResultTeammate,
    "RestApiArrayResultVoucherDataPoint": RestApiArrayResultVoucherDataPoint,
    "RestApiDefaultResponse": RestApiDefaultResponse,
    "RestApiErrorResult": RestApiErrorResult,
    "RestApiEventSearchPaginationResult": RestApiEventSearchPaginationResult,
    "RestApiFinanceSearchPaginationResultInvoice": RestApiFinanceSearchPaginationResultInvoice,
    "RestApiForbiddenResult": RestApiForbiddenResult,
    "RestApiIntegerResult": RestApiIntegerResult,
    "RestApiPaginationResultApp": RestApiPaginationResultApp,
    "RestApiPaginationResultAppStoreAppSummary": RestApiPaginationResultAppStoreAppSummary,
    "RestApiPaginationResultBusinessHoursOverride": RestApiPaginationResultBusinessHoursOverride,
    "RestApiPaginationResultCatalogItem": RestApiPaginationResultCatalogItem,
    "RestApiPaginationResultGroup": RestApiPaginationResultGroup,
    "RestApiPaginationResultHttpRequestAndResponseLog": RestApiPaginationResultHttpRequestAndResponseLog,
    "RestApiPaginationResultHydraDeviceDetails": RestApiPaginationResultHydraDeviceDetails,
    "RestApiPaginationResultMetafieldDefinition": RestApiPaginationResultMetafieldDefinition,
    "RestApiPaginationResultMetafieldDefinitionRecommendation": RestApiPaginationResultMetafieldDefinitionRecommendation,
    "RestApiPaginationResultOAuthTokenModel": RestApiPaginationResultOAuthTokenModel,
    "RestApiPaginationResultOrder": RestApiPaginationResultOrder,
    "RestApiPaginationResultOrderSummary": RestApiPaginationResultOrderSummary,
    "RestApiPaginationResultPayout": RestApiPaginationResultPayout,
    "RestApiPaginationResultPayoutChargeback": RestApiPaginationResultPayoutChargeback,
    "RestApiPaginationResultPayoutOrder": RestApiPaginationResultPayoutOrder,
    "RestApiPaginationResultPayoutOtherCharge": RestApiPaginationResultPayoutOtherCharge,
    "RestApiPaginationResultPayoutRefund": RestApiPaginationResultPayoutRefund,
    "RestApiPaginationResultPendingMenuChanges": RestApiPaginationResultPendingMenuChanges,
    "RestApiPaginationResultPhoneCall": RestApiPaginationResultPhoneCall,
    "RestApiPaginationResultProduct": RestApiPaginationResultProduct,
    "RestApiPaginationResultPushNotificationResponse": RestApiPaginationResultPushNotificationResponse,
    "RestApiPaginationResultStore": RestApiPaginationResultStore,
    "RestApiPaginationResultStoreGroup": RestApiPaginationResultStoreGroup,
    "RestApiPaginationResultStoreGroupExtended": RestApiPaginationResultStoreGroupExtended,
    "RestApiPaginationResultStoreHeader": RestApiPaginationResultStoreHeader,
    "RestApiPaginationResultStoreValidationConfig": RestApiPaginationResultStoreValidationConfig,
    "RestApiPaginationResultVoucherSummary": RestApiPaginationResultVoucherSummary,
    "RestApiPaginationResultWebhookLog": RestApiPaginationResultWebhookLog,
    "RestApiPaginationResultWebhookSubscription": RestApiPaginationResultWebhookSubscription,
    "RestApiResultAccountDetail": RestApiResultAccountDetail,
    "RestApiResultAccountFieldsDefinitions": RestApiResultAccountFieldsDefinitions,
    "RestApiResultAddressFormResponse": RestApiResultAddressFormResponse,
    "RestApiResultApmStatistics": RestApiResultApmStatistics,
    "RestApiResultApmStatus": RestApiResultApmStatus,
    "RestApiResultApp": RestApiResultApp,
    "RestApiResultAppChannelAssignment": RestApiResultAppChannelAssignment,
    "RestApiResultAppCompliance": RestApiResultAppCompliance,
    "RestApiResultAppConfigSalesChannel": RestApiResultAppConfigSalesChannel,
    "RestApiResultAppStoreApp": RestApiResultAppStoreApp,
    "RestApiResultAppStoreAppConfiguration": RestApiResultAppStoreAppConfiguration,
    "RestApiResultAppStoreAppConfigurationsWithSubscriptions": RestApiResultAppStoreAppConfigurationsWithSubscriptions,
    "RestApiResultAssignedBankAccount": RestApiResultAssignedBankAccount,
    "RestApiResultBankAccountDetail": RestApiResultBankAccountDetail,
    "RestApiResultBluetoothTerminalStatus": RestApiResultBluetoothTerminalStatus,
    "RestApiResultBusinessHoursOverride": RestApiResultBusinessHoursOverride,
    "RestApiResultBusinessHoursPeriod": RestApiResultBusinessHoursPeriod,
    "RestApiResultCardReader": RestApiResultCardReader,
    "RestApiResultCatalogItem": RestApiResultCatalogItem,
    "RestApiResultChannel": RestApiResultChannel,
    "RestApiResultClientDevice": RestApiResultClientDevice,
    "RestApiResultClientDeviceEnrollmentResult": RestApiResultClientDeviceEnrollmentResult,
    "RestApiResultCoordinates": RestApiResultCoordinates,
    "RestApiResultCountryFormResponse": RestApiResultCountryFormResponse,
    "RestApiResultCreatedMenuSectionItems": RestApiResultCreatedMenuSectionItems,
    "RestApiResultCrossSellMenuItems": RestApiResultCrossSellMenuItems,
    "RestApiResultCustomer": RestApiResultCustomer,
    "RestApiResultDeliveryZone": RestApiResultDeliveryZone,
    "RestApiResultDnsRecordInformation": RestApiResultDnsRecordInformation,
    "RestApiResultFulfillmentStatesConfiguration": RestApiResultFulfillmentStatesConfiguration,
    "RestApiResultGroup": RestApiResultGroup,
    "RestApiResultHomeStatistics": RestApiResultHomeStatistics,
    "RestApiResultHydraConfig": RestApiResultHydraConfig,
    "RestApiResultHydraDeviceDetails": RestApiResultHydraDeviceDetails,
    "RestApiResultHydraStatus": RestApiResultHydraStatus,
    "RestApiResultIndexPage": RestApiResultIndexPage,
    "RestApiResultIndexPageBase": RestApiResultIndexPageBase,
    "RestApiResultIntercomUserHash": RestApiResultIntercomUserHash,
    "RestApiResultJobResponse": RestApiResultJobResponse,
    "RestApiResultKioskIotConnectionParameters": RestApiResultKioskIotConnectionParameters,
    "RestApiResultKioskSettings": RestApiResultKioskSettings,
    "RestApiResultLightspeedSettings": RestApiResultLightspeedSettings,
    "RestApiResultLocationArea": RestApiResultLocationArea,
    "RestApiResultLocationAreaLocation": RestApiResultLocationAreaLocation,
    "RestApiResultLocationAreaWithLocations": RestApiResultLocationAreaWithLocations,
    "RestApiResultLoyaltyCampaign": RestApiResultLoyaltyCampaign,
    "RestApiResultMappedLocation": RestApiResultMappedLocation,
    "RestApiResultMenu": RestApiResultMenu,
    "RestApiResultMenuItemOptionSet": RestApiResultMenuItemOptionSet,
    "RestApiResultMenuItemOptionSetItem": RestApiResultMenuItemOptionSetItem,
    "RestApiResultMenuNutritionInfoHeader": RestApiResultMenuNutritionInfoHeader,
    "RestApiResultMenuSection": RestApiResultMenuSection,
    "RestApiResultMenuSectionAvailability": RestApiResultMenuSectionAvailability,
    "RestApiResultMenuSectionItem": RestApiResultMenuSectionItem,
    "RestApiResultMetadata": RestApiResultMetadata,
    "RestApiResultMetafieldDefinition": RestApiResultMetafieldDefinition,
    "RestApiResultMobileAppsImage": RestApiResultMobileAppsImage,
    "RestApiResultMobileAppsSubmission": RestApiResultMobileAppsSubmission,
    "RestApiResultMobileAppsSubmissionDetails": RestApiResultMobileAppsSubmissionDetails,
    "RestApiResultMobileAppsSubmissionStatus": RestApiResultMobileAppsSubmissionStatus,
    "RestApiResultModelBase": RestApiResultModelBase,
    "RestApiResultNutritionInfo": RestApiResultNutritionInfo,
    "RestApiResultOAuthApp": RestApiResultOAuthApp,
    "RestApiResultOauthClientRedirectUri": RestApiResultOauthClientRedirectUri,
    "RestApiResultOktaPortalFeatureFlag": RestApiResultOktaPortalFeatureFlag,
    "RestApiResultOrder": RestApiResultOrder,
    "RestApiResultOrderBatch": RestApiResultOrderBatch,
    "RestApiResultOrderBatchingConfiguration": RestApiResultOrderBatchingConfiguration,
    "RestApiResultOrderDeliveryInformation": RestApiResultOrderDeliveryInformation,
    "RestApiResultOrderFulfillmentStatus": RestApiResultOrderFulfillmentStatus,
    "RestApiResultOrderFulfillmentStatusWithConfigurationActions": RestApiResultOrderFulfillmentStatusWithConfigurationActions,
    "RestApiResultOrderIngestSubmitOrderResponse": RestApiResultOrderIngestSubmitOrderResponse,
    "RestApiResultOrderPaymentInformation": RestApiResultOrderPaymentInformation,
    "RestApiResultPaymentIntent": RestApiResultPaymentIntent,
    "RestApiResultPaymentTerminalDetails": RestApiResultPaymentTerminalDetails,
    "RestApiResultPaymentTerminalTransactionDetails": RestApiResultPaymentTerminalTransactionDetails,
    "RestApiResultPreOrderConfig": RestApiResultPreOrderConfig,
    "RestApiResultProcessingFeeConfig": RestApiResultProcessingFeeConfig,
    "RestApiResultProduct": RestApiResultProduct,
    "RestApiResultPushNotificationResponse": RestApiResultPushNotificationResponse,
    "RestApiResultRedeemInvitationResult": RestApiResultRedeemInvitationResult,
    "RestApiResultRestApiIntegerResult": RestApiResultRestApiIntegerResult,
    "RestApiResultRestaurantVoucherPayGreenConfiguration": RestApiResultRestaurantVoucherPayGreenConfiguration,
    "RestApiResultRestaurantVoucherPayGreenStoreConfiguration": RestApiResultRestaurantVoucherPayGreenStoreConfiguration,
    "RestApiResultRetentionCampaign": RestApiResultRetentionCampaign,
    "RestApiResultServiceCharge": RestApiResultServiceCharge,
    "RestApiResultStore": RestApiResultStore,
    "RestApiResultStoreAddress": RestApiResultStoreAddress,
    "RestApiResultStoreChannelAssignment": RestApiResultStoreChannelAssignment,
    "RestApiResultStoreEndOfDayReport": RestApiResultStoreEndOfDayReport,
    "RestApiResultStoreGroup": RestApiResultStoreGroup,
    "RestApiResultStoreGroupBase": RestApiResultStoreGroupBase,
    "RestApiResultStoreOrderCapacityConfig": RestApiResultStoreOrderCapacityConfig,
    "RestApiResultStripeConnectedAccount": RestApiResultStripeConnectedAccount,
    "RestApiResultStripeTerminalConnectionToken": RestApiResultStripeTerminalConnectionToken,
    "RestApiResultStripeTerminalLocation": RestApiResultStripeTerminalLocation,
    "RestApiResultStuartSettings": RestApiResultStuartSettings,
    "RestApiResultSubmitOrderResponseDm": RestApiResultSubmitOrderResponseDm,
    "RestApiResultSubscription": RestApiResultSubscription,
    "RestApiResultTeammate": RestApiResultTeammate,
    "RestApiResultTelemetrySeriesResult": RestApiResultTelemetrySeriesResult,
    "RestApiResultTipConfiguration": RestApiResultTipConfiguration,
    "RestApiResultUpdateMobileAppsSubmissionStatus": RestApiResultUpdateMobileAppsSubmissionStatus,
    "RestApiResultVoucherWithStats": RestApiResultVoucherWithStats,
    "RestApiResultWebsiteImage": RestApiResultWebsiteImage,
    "RestApiResultWebsiteTestimonial": RestApiResultWebsiteTestimonial,
    "RestApiStringArrayResult": RestApiStringArrayResult,
    "RestApiStringResult": RestApiStringResult,
    "RestApiUnauthorizedResult": RestApiUnauthorizedResult,
    "RestaurantVoucherAssignedStore": RestaurantVoucherAssignedStore,
    "RestaurantVoucherEligibleStore": RestaurantVoucherEligibleStore,
    "RestaurantVoucherPayGreenConfiguration": RestaurantVoucherPayGreenConfiguration,
    "RestaurantVoucherPayGreenConfigurationSummary": RestaurantVoucherPayGreenConfigurationSummary,
    "RestaurantVoucherPayGreenStoreConfiguration": RestaurantVoucherPayGreenStoreConfiguration,
    "RetentionCampaign": RetentionCampaign,
    "RetentionCampaignBase": RetentionCampaignBase,
    "RetentionCampaignCreatedEvent": RetentionCampaignCreatedEvent,
    "RetentionCampaignDeletedEvent": RetentionCampaignDeletedEvent,
    "RetentionCampaignUpdatedEvent": RetentionCampaignUpdatedEvent,
    "RevenueAdjustmentsDetails": RevenueAdjustmentsDetails,
    "RevenueDetail": RevenueDetail,
    "SearchCriteria": SearchCriteria,
    "ServiceCharge": ServiceCharge,
    "SetOrderBatchingConfiguration": SetOrderBatchingConfiguration,
    "SetPasswordWithPinModel": SetPasswordWithPinModel,
    "Setting": Setting,
    "SignupStep": SignupStep,
    "SmsInfo": SmsInfo,
    "SmsReceivedEvent": SmsReceivedEvent,
    "StatisticsCurrencyDataPoint": StatisticsCurrencyDataPoint,
    "Store": Store,
    "StoreAddress": StoreAddress,
    "StoreAddressBase": StoreAddressBase,
    "StoreAddressForm": StoreAddressForm,
    "StoreAddressUpdatedEvent": StoreAddressUpdatedEvent,
    "StoreArchivedEvent": StoreArchivedEvent,
    "StoreBase": StoreBase,
    "StoreBusinessHoursOverrideCreatedEvent": StoreBusinessHoursOverrideCreatedEvent,
    "StoreBusinessHoursOverrideDeletedEvent": StoreBusinessHoursOverrideDeletedEvent,
    "StoreCampaignStartTime": StoreCampaignStartTime,
    "StoreChannelAssignment": StoreChannelAssignment,
    "StoreChannelStoreMapping": StoreChannelStoreMapping,
    "StoreCloneSettings": StoreCloneSettings,
    "StoreConfig": StoreConfig,
    "StoreCreateBase": StoreCreateBase,
    "StoreCreatedEvent": StoreCreatedEvent,
    "StoreDataPoint": StoreDataPoint,
    "StoreDeletedEvent": StoreDeletedEvent,
    "StoreEndOfDayReport": StoreEndOfDayReport,
    "StoreFeeConfig": StoreFeeConfig,
    "StoreFeeConfigUpdatedEvent": StoreFeeConfigUpdatedEvent,
    "StoreGroup": StoreGroup,
    "StoreGroupBase": StoreGroupBase,
    "StoreGroupCreatedEvent": StoreGroupCreatedEvent,
    "StoreGroupDeletedEvent": StoreGroupDeletedEvent,
    "StoreGroupExtended": StoreGroupExtended,
    "StoreGroupUpdatedEvent": StoreGroupUpdatedEvent,
    "StoreHeader": StoreHeader,
    "StoreItemHeader": StoreItemHeader,
    "StoreKioskSetting": StoreKioskSetting,
    "StoreKioskSettingUpdatedEvent": StoreKioskSettingUpdatedEvent,
    "StoreListItem": StoreListItem,
    "StoreLogoCreatedEvent": StoreLogoCreatedEvent,
    "StoreLogoDeletedEvent": StoreLogoDeletedEvent,
    "StoreLogoUpdatedEvent": StoreLogoUpdatedEvent,
    "StoreMenuAssignedEvent": StoreMenuAssignedEvent,
    "StoreNote": StoreNote,
    "StoreOpeningHoursUpdatedEvent": StoreOpeningHoursUpdatedEvent,
    "StoreOrderCapacityConfig": StoreOrderCapacityConfig,
    "StoreOrderCapacityConfigEditModel": StoreOrderCapacityConfigEditModel,
    "StoreOrderCapacityPeriod": StoreOrderCapacityPeriod,
    "StorePreOrderConfigUpdatedEvent": StorePreOrderConfigUpdatedEvent,
    "StorePublishedEvent": StorePublishedEvent,
    "StoreServiceChargeUpdatedEvent": StoreServiceChargeUpdatedEvent,
    "StoreStatistics": StoreStatistics,
    "StoreSummary": StoreSummary,
    "StoreTipUpdatedEvent": StoreTipUpdatedEvent,
    "StoreUnarchivedEvent": StoreUnarchivedEvent,
    "StoreUnpublishedEvent": StoreUnpublishedEvent,
    "StoreUpdatedEvent": StoreUpdatedEvent,
    "StoreValidationConfig": StoreValidationConfig,
    "StripeAccountLinkRequest": StripeAccountLinkRequest,
    "StripeConnectedAccount": StripeConnectedAccount,
    "StripeConnectedAccountInfo": StripeConnectedAccountInfo,
    "StripeCustomConnectedAccount": StripeCustomConnectedAccount,
    "StripeTerminalConnectionToken": StripeTerminalConnectionToken,
    "StripeTerminalLocation": StripeTerminalLocation,
    "StuartSettings": StuartSettings,
    "SubmitOrderRequest": SubmitOrderRequest,
    "SubmitOrderResponseDm": SubmitOrderResponseDm,
    "Subscription": Subscription,
    "SubscriptionProduct": SubscriptionProduct,
    "SubscriptionStore": SubscriptionStore,
    "SubscriptionSummary": SubscriptionSummary,
    "SupportedCountry": SupportedCountry,
    "TaxRate": TaxRate,
    "Teammate": Teammate,
    "TeammateBase": TeammateBase,
    "TeammateDeletedEvent": TeammateDeletedEvent,
    "TeammateInviteAcceptedEvent": TeammateInviteAcceptedEvent,
    "TeammateInviteSentEvent": TeammateInviteSentEvent,
    "TeammateUpdatedEvent": TeammateUpdatedEvent,
    "TelemetrySeriesProperty": TelemetrySeriesProperty,
    "TelemetrySeriesQueryParameters": TelemetrySeriesQueryParameters,
    "TelemetrySeriesResult": TelemetrySeriesResult,
    "TipConfiguration": TipConfiguration,
    "UnRegisterCardReaderRequest": UnRegisterCardReaderRequest,
    "UpcomingInvoice": UpcomingInvoice,
    "UpdateAppStoreApp": UpdateAppStoreApp,
    "UpdateAppStoreAppConfiguration": UpdateAppStoreAppConfiguration,
    "UpdateAppStoreAppConfigurationValuesBatch": UpdateAppStoreAppConfigurationValuesBatch,
    "UpdateAppStoreAppConfigurationWebhookDTO": UpdateAppStoreAppConfigurationWebhookDTO,
    "UpdateAppStoreAppExternalProduct": UpdateAppStoreAppExternalProduct,
    "UpdateCatalogGroupReference": UpdateCatalogGroupReference,
    "UpdateCatalogItem": UpdateCatalogItem,
    "UpdateDriverNotificationToken": UpdateDriverNotificationToken,
    "UpdateDriverProfileModel": UpdateDriverProfileModel,
    "UpdateFulfillmentStatesConfiguration": UpdateFulfillmentStatesConfiguration,
    "UpdateGroup": UpdateGroup,
    "UpdateGroupReference": UpdateGroupReference,
    "UpdateLocationArea": UpdateLocationArea,
    "UpdateMetafieldDefinition": UpdateMetafieldDefinition,
    "UpdateMobileAppsSubmissionStatus": UpdateMobileAppsSubmissionStatus,
    "UpdatePayGreenConfigurationRequest": UpdatePayGreenConfigurationRequest,
    "UpdateProduct": UpdateProduct,
    "UpdateProductReference": UpdateProductReference,
    "UpdateStorePayGreenConfigurationRequest": UpdateStorePayGreenConfigurationRequest,
    "UpdateTipConfiguration": UpdateTipConfiguration,
    "UserAnsweredSignupQuestionsEvent": UserAnsweredSignupQuestionsEvent,
    "UserCreatedEvent": UserCreatedEvent,
    "UserDeletedEvent": UserDeletedEvent,
    "UserEventInfo": UserEventInfo,
    "UserLoginEvent": UserLoginEvent,
    "UserPasswordCreatedEvent": UserPasswordCreatedEvent,
    "UserUpdatedEvent": UserUpdatedEvent,
    "ValidValue": ValidValue,
    "ValidationErrorResult": ValidationErrorResult,
    "Voucher": Voucher,
    "VoucherBase": VoucherBase,
    "VoucherCreatedEvent": VoucherCreatedEvent,
    "VoucherDataPoint": VoucherDataPoint,
    "VoucherDeletedEvent": VoucherDeletedEvent,
    "VoucherSummary": VoucherSummary,
    "VoucherUpdatedEvent": VoucherUpdatedEvent,
    "VoucherWithStats": VoucherWithStats,
    "WebhookEventSample": WebhookEventSample,
    "WebhookLog": WebhookLog,
    "WebhookSubscription": WebhookSubscription,
    "WebhookSubscriptionCreatedEvent": WebhookSubscriptionCreatedEvent,
    "WebhookSubscriptionDeletedEvent": WebhookSubscriptionDeletedEvent,
    "WebhookSubscriptionEventInfo": WebhookSubscriptionEventInfo,
    "WebhookSubscriptionUpdatedEvent": WebhookSubscriptionUpdatedEvent,
    "WebsiteImage": WebsiteImage,
    "WebsiteTestimonial": WebsiteTestimonial,
    "WebsiteTestimonialBase": WebsiteTestimonialBase,
    "WebsiteUpdatedEvent": WebsiteUpdatedEvent,
    "WebsiteVanityUrlUpdatedEvent": WebsiteVanityUrlUpdatedEvent,
};
var HttpBasicAuth = (function () {
    function HttpBasicAuth() {
        this.username = '';
        this.password = '';
    }
    HttpBasicAuth.prototype.applyToRequest = function (requestOptions) {
        requestOptions.auth = {
            username: this.username, password: this.password
        };
    };
    return HttpBasicAuth;
}());
exports.HttpBasicAuth = HttpBasicAuth;
var ApiKeyAuth = (function () {
    function ApiKeyAuth(location, paramName) {
        this.location = location;
        this.paramName = paramName;
        this.apiKey = '';
    }
    ApiKeyAuth.prototype.applyToRequest = function (requestOptions) {
        if (this.location == "query") {
            requestOptions.qs[this.paramName] = this.apiKey;
        }
        else if (this.location == "header" && requestOptions && requestOptions.headers) {
            requestOptions.headers[this.paramName] = this.apiKey;
        }
    };
    return ApiKeyAuth;
}());
exports.ApiKeyAuth = ApiKeyAuth;
var OAuth = (function () {
    function OAuth() {
        this.accessToken = '';
    }
    OAuth.prototype.applyToRequest = function (requestOptions) {
        if (requestOptions && requestOptions.headers) {
            requestOptions.headers["Authorization"] = "Bearer " + this.accessToken;
        }
    };
    return OAuth;
}());
exports.OAuth = OAuth;
var VoidAuth = (function () {
    function VoidAuth() {
        this.username = '';
        this.password = '';
    }
    VoidAuth.prototype.applyToRequest = function (_) {
    };
    return VoidAuth;
}());
exports.VoidAuth = VoidAuth;
var AccountsApiApiKeys;
(function (AccountsApiApiKeys) {
})(AccountsApiApiKeys = exports.AccountsApiApiKeys || (exports.AccountsApiApiKeys = {}));
var AccountsApi = (function () {
    function AccountsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AccountsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AccountsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AccountsApi.prototype.setApiKey = function (key, value) {
        this.authentications[AccountsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(AccountsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    AccountsApi.prototype.answerSignUpQuestion = function (signupStepAction, body) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/signupstep/{signupStepAction}/answer'
            .replace('{' + 'signupStepAction' + '}', encodeURIComponent(String(signupStepAction)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (signupStepAction === null || signupStepAction === undefined) {
            throw new Error('Required parameter signupStepAction was null or undefined when calling answerSignUpQuestion.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling answerSignUpQuestion.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "number")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.changePassword = function (ChangePasswordModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/password';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (ChangePasswordModel === null || ChangePasswordModel === undefined) {
            throw new Error('Required parameter ChangePasswordModel was null or undefined when calling changePassword.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ChangePasswordModel, "ChangePasswordModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.changePasswordWithPin = function (SetPasswordWithPinModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/password/pin';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (SetPasswordWithPinModel === null || SetPasswordWithPinModel === undefined) {
            throw new Error('Required parameter SetPasswordWithPinModel was null or undefined when calling changePasswordWithPin.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(SetPasswordWithPinModel, "SetPasswordWithPinModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.createAccount = function (CreateAccountModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (CreateAccountModel === null || CreateAccountModel === undefined) {
            throw new Error('Required parameter CreateAccountModel was null or undefined when calling createAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateAccountModel, "CreateAccountModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.createBasicAccount = function (CreateBasicAccountModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/basic-account';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (CreateBasicAccountModel === null || CreateBasicAccountModel === undefined) {
            throw new Error('Required parameter CreateBasicAccountModel was null or undefined when calling createBasicAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateBasicAccountModel, "CreateBasicAccountModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "string");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.getAccountDetails = function () {
        var localVarPath = this.basePath + '/api/v1.0/accounts';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAccountDetail");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.getLocalisedTimeZones = function () {
        var localVarPath = this.basePath + '/api/v1.0/accounts/timezones';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultLocalisedTimeZone");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.login = function (LoginModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/login';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (LoginModel === null || LoginModel === undefined) {
            throw new Error('Required parameter LoginModel was null or undefined when calling login.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(LoginModel, "LoginModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.loginSso = function () {
        var localVarPath = this.basePath + '/api/v1.0/accounts/login/sso';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.loginWithPin = function (LoginWithPinModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/login/pin';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (LoginWithPinModel === null || LoginWithPinModel === undefined) {
            throw new Error('Required parameter LoginWithPinModel was null or undefined when calling loginWithPin.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(LoginWithPinModel, "LoginWithPinModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.logout = function () {
        var localVarPath = this.basePath + '/api/v1.0/accounts/logout';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.passwordResetWithToken = function (PasswordResetModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/password';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (PasswordResetModel === null || PasswordResetModel === undefined) {
            throw new Error('Required parameter PasswordResetModel was null or undefined when calling passwordResetWithToken.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(PasswordResetModel, "PasswordResetModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.recaptchaValidate = function (token) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/recaptcha';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling recaptchaValidate.');
        }
        if (token !== undefined) {
            localVarQueryParameters['token'] = ObjectSerializer.serialize(token, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.requestLoginPin = function (RequestLoginPinModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/pin';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (RequestLoginPinModel === null || RequestLoginPinModel === undefined) {
            throw new Error('Required parameter RequestLoginPinModel was null or undefined when calling requestLoginPin.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(RequestLoginPinModel, "RequestLoginPinModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RequestLoginPinResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.requestPasswordReset = function (RequestPasswordResetModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/passwordreset';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (RequestPasswordResetModel === null || RequestPasswordResetModel === undefined) {
            throw new Error('Required parameter RequestPasswordResetModel was null or undefined when calling requestPasswordReset.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(RequestPasswordResetModel, "RequestPasswordResetModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.sendPinForPasswordReset = function (RequestPasswordResetModel) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/password/resetpin';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (RequestPasswordResetModel === null || RequestPasswordResetModel === undefined) {
            throw new Error('Required parameter RequestPasswordResetModel was null or undefined when calling sendPinForPasswordReset.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(RequestPasswordResetModel, "RequestPasswordResetModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RequestPasswordResetPinResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.skipSignupStep = function (signupStepAction) {
        var localVarPath = this.basePath + '/api/v1.0/accounts/signupstep/{signupStepAction}/skip'
            .replace('{' + 'signupStepAction' + '}', encodeURIComponent(String(signupStepAction)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (signupStepAction === null || signupStepAction === undefined) {
            throw new Error('Required parameter signupStepAction was null or undefined when calling skipSignupStep.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AccountsApi.prototype.updateAccount = function (AccountDetailBase) {
        var localVarPath = this.basePath + '/api/v1.0/accounts';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (AccountDetailBase === null || AccountDetailBase === undefined) {
            throw new Error('Required parameter AccountDetailBase was null or undefined when calling updateAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(AccountDetailBase, "AccountDetailBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AccountsApi;
}());
exports.AccountsApi = AccountsApi;
var AddressApiApiKeys;
(function (AddressApiApiKeys) {
})(AddressApiApiKeys = exports.AddressApiApiKeys || (exports.AddressApiApiKeys = {}));
var AddressApi = (function () {
    function AddressApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AddressApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddressApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AddressApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AddressApi.prototype.setApiKey = function (key, value) {
        this.authentications[AddressApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(AddressApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    AddressApi.prototype.formByApp = function (appId, language) {
        var localVarPath = this.basePath + '/api/v1.0/app/{appId}/address/form'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling formByApp.');
        }
        if (language !== undefined) {
            localVarQueryParameters['language'] = ObjectSerializer.serialize(language, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAddressFormResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AddressApi.prototype.formByCountry = function (countryCode, language) {
        var localVarPath = this.basePath + '/api/v1.0/address/country/{countryCode}/form'
            .replace('{' + 'countryCode' + '}', encodeURIComponent(String(countryCode)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (countryCode === null || countryCode === undefined) {
            throw new Error('Required parameter countryCode was null or undefined when calling formByCountry.');
        }
        if (language !== undefined) {
            localVarQueryParameters['language'] = ObjectSerializer.serialize(language, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAddressFormResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AddressApi.prototype.formatGoogleAddress = function (GoogleAddress, language) {
        var localVarPath = this.basePath + '/api/v1.0/address/google';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (GoogleAddress === null || GoogleAddress === undefined) {
            throw new Error('Required parameter GoogleAddress was null or undefined when calling formatGoogleAddress.');
        }
        if (language !== undefined) {
            localVarQueryParameters['language'] = ObjectSerializer.serialize(language, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(GoogleAddress, "GoogleAddress")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAddressFormResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AddressApi.prototype.getCountries = function (language) {
        var localVarPath = this.basePath + '/api/v1.0/address/countries';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (language !== undefined) {
            localVarQueryParameters['language'] = ObjectSerializer.serialize(language, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCountryFormResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AddressApi;
}());
exports.AddressApi = AddressApi;
var ApmApiApiKeys;
(function (ApmApiApiKeys) {
})(ApmApiApiKeys = exports.ApmApiApiKeys || (exports.ApmApiApiKeys = {}));
var ApmApi = (function () {
    function ApmApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(ApmApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApmApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    ApmApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    ApmApi.prototype.setApiKey = function (key, value) {
        this.authentications[ApmApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(ApmApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    ApmApi.prototype.getApmStatus = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/apm/status'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getApmStatus.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultApmStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ApmApi.prototype.getBasicStatistics = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/apm/statistics'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getBasicStatistics.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultApmStatistics");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ApmApi.prototype.getCalendarWeekStatistics = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/apm/statistics/calendar'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCalendarWeekStatistics.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultApmHourlyDataPoint");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ApmApi.prototype.getCallsStatistics = function (appId, aggregateDataBy, dataPointLimit, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/apm/statistics/calls/{aggregateDataBy}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'aggregateDataBy' + '}', encodeURIComponent(String(aggregateDataBy)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCallsStatistics.');
        }
        if (aggregateDataBy === null || aggregateDataBy === undefined) {
            throw new Error('Required parameter aggregateDataBy was null or undefined when calling getCallsStatistics.');
        }
        if (dataPointLimit !== undefined) {
            localVarQueryParameters['dataPointLimit'] = ObjectSerializer.serialize(dataPointLimit, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultApmDataPoint");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ApmApi.prototype.getOrderStatistics = function (appId, aggregateDataBy, dataPointLimit, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/apm/statistics/orders/{aggregateDataBy}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'aggregateDataBy' + '}', encodeURIComponent(String(aggregateDataBy)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOrderStatistics.');
        }
        if (aggregateDataBy === null || aggregateDataBy === undefined) {
            throw new Error('Required parameter aggregateDataBy was null or undefined when calling getOrderStatistics.');
        }
        if (dataPointLimit !== undefined) {
            localVarQueryParameters['dataPointLimit'] = ObjectSerializer.serialize(dataPointLimit, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultApmCurrencyDataPoint");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ApmApi.prototype.getPaginatedCallList = function (appId, page, limit, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/apm/calls'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPaginatedCallList.');
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultPhoneCall");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return ApmApi;
}());
exports.ApmApi = ApmApi;
var AppStoreApiApiKeys;
(function (AppStoreApiApiKeys) {
})(AppStoreApiApiKeys = exports.AppStoreApiApiKeys || (exports.AppStoreApiApiKeys = {}));
var AppStoreApi = (function () {
    function AppStoreApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AppStoreApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppStoreApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AppStoreApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AppStoreApi.prototype.setApiKey = function (key, value) {
        this.authentications[AppStoreApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(AppStoreApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    AppStoreApi.prototype.getAppStoreApp = function (appStoreAppId) {
        var localVarPath = this.basePath + '/api/v1.0/appstore/apps/{appStoreAppId}'
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling getAppStoreApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "AppStoreApp");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreApi.prototype.getAppStoreApps = function (search, page, limit, excludeNotOwned) {
        var localVarPath = this.basePath + '/api/v1.0/appstore/apps';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (search === null || search === undefined) {
            throw new Error('Required parameter search was null or undefined when calling getAppStoreApps.');
        }
        if (search !== undefined) {
            localVarQueryParameters['search'] = ObjectSerializer.serialize(search, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (excludeNotOwned !== undefined) {
            localVarQueryParameters['excludeNotOwned'] = ObjectSerializer.serialize(excludeNotOwned, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultAppStoreAppSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AppStoreApi;
}());
exports.AppStoreApi = AppStoreApi;
var AppStoreConfigurationsApiApiKeys;
(function (AppStoreConfigurationsApiApiKeys) {
})(AppStoreConfigurationsApiApiKeys = exports.AppStoreConfigurationsApiApiKeys || (exports.AppStoreConfigurationsApiApiKeys = {}));
var AppStoreConfigurationsApi = (function () {
    function AppStoreConfigurationsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AppStoreConfigurationsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppStoreConfigurationsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AppStoreConfigurationsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AppStoreConfigurationsApi.prototype.setApiKey = function (key, value) {
        this.authentications[AppStoreConfigurationsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(AppStoreConfigurationsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    AppStoreConfigurationsApi.prototype.appStoreConfigurationsAppStoreHandleOauthResponseCode = function (appStoreAppId) {
        var localVarPath = this.basePath + '/api/v1.0/appstore/oauthresponse/{appStoreAppId}/responsecode'
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling appStoreConfigurationsAppStoreHandleOauthResponseCode.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.createAppStoreConfig = function (appId, appStoreAppId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createAppStoreConfig.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling createAppStoreConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAppStoreAppConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.deleteAppStoreConfig = function (appId, appStoreAppId, configId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)))
            .replace('{' + 'configId' + '}', encodeURIComponent(String(configId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteAppStoreConfig.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling deleteAppStoreConfig.');
        }
        if (configId === null || configId === undefined) {
            throw new Error('Required parameter configId was null or undefined when calling deleteAppStoreConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.executeConfigurationAction = function (appId, appStoreAppId, configId, ExecuteConfigurationActionRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}/action'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)))
            .replace('{' + 'configId' + '}', encodeURIComponent(String(configId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling executeConfigurationAction.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling executeConfigurationAction.');
        }
        if (configId === null || configId === undefined) {
            throw new Error('Required parameter configId was null or undefined when calling executeConfigurationAction.');
        }
        if (ExecuteConfigurationActionRequest === null || ExecuteConfigurationActionRequest === undefined) {
            throw new Error('Required parameter ExecuteConfigurationActionRequest was null or undefined when calling executeConfigurationAction.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ExecuteConfigurationActionRequest, "ExecuteConfigurationActionRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "ExecuteConfigurationActionResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.getAppStoreConfig = function (appId, appStoreAppId, configId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)))
            .replace('{' + 'configId' + '}', encodeURIComponent(String(configId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAppStoreConfig.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling getAppStoreConfig.');
        }
        if (configId === null || configId === undefined) {
            throw new Error('Required parameter configId was null or undefined when calling getAppStoreConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "AppStoreAppConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.getConfiguredAppSingleApp = function (appId, appStoreAppId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps/{appStoreAppId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getConfiguredAppSingleApp.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling getConfiguredAppSingleApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultAppStoreAppConfigurationSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.getConfiguredAppWithSubscriptionsSingleApp = function (appId, appStoreAppId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps_subscriptions/{appStoreAppId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getConfiguredAppWithSubscriptionsSingleApp.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling getConfiguredAppWithSubscriptionsSingleApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAppStoreAppConfigurationsWithSubscriptions");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.getConfiguredApps = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getConfiguredApps.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultAppStoreAppConfigurationHeader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.updateAppStoreConfig = function (appId, appStoreAppId, configId, UpdateAppStoreAppConfiguration) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)))
            .replace('{' + 'configId' + '}', encodeURIComponent(String(configId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateAppStoreConfig.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling updateAppStoreConfig.');
        }
        if (configId === null || configId === undefined) {
            throw new Error('Required parameter configId was null or undefined when calling updateAppStoreConfig.');
        }
        if (UpdateAppStoreAppConfiguration === null || UpdateAppStoreAppConfiguration === undefined) {
            throw new Error('Required parameter UpdateAppStoreAppConfiguration was null or undefined when calling updateAppStoreConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateAppStoreAppConfiguration, "UpdateAppStoreAppConfiguration")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreConfigurationsApi.prototype.updateAppStoreConfigSettingValues = function (appId, appStoreAppId, configId, UpdateAppStoreAppConfigurationValuesBatch) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}/updatesettings'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)))
            .replace('{' + 'configId' + '}', encodeURIComponent(String(configId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateAppStoreConfigSettingValues.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling updateAppStoreConfigSettingValues.');
        }
        if (configId === null || configId === undefined) {
            throw new Error('Required parameter configId was null or undefined when calling updateAppStoreConfigSettingValues.');
        }
        if (UpdateAppStoreAppConfigurationValuesBatch === null || UpdateAppStoreAppConfigurationValuesBatch === undefined) {
            throw new Error('Required parameter UpdateAppStoreAppConfigurationValuesBatch was null or undefined when calling updateAppStoreConfigSettingValues.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateAppStoreAppConfigurationValuesBatch, "UpdateAppStoreAppConfigurationValuesBatch")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AppStoreConfigurationsApi;
}());
exports.AppStoreConfigurationsApi = AppStoreConfigurationsApi;
var AppStoreDeveloperApiApiKeys;
(function (AppStoreDeveloperApiApiKeys) {
})(AppStoreDeveloperApiApiKeys = exports.AppStoreDeveloperApiApiKeys || (exports.AppStoreDeveloperApiApiKeys = {}));
var AppStoreDeveloperApi = (function () {
    function AppStoreDeveloperApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AppStoreDeveloperApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppStoreDeveloperApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AppStoreDeveloperApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AppStoreDeveloperApi.prototype.setApiKey = function (key, value) {
        this.authentications[AppStoreDeveloperApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(AppStoreDeveloperApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    AppStoreDeveloperApi.prototype.appVerificationUpdate = function (oauthAppId, appStoreAppId, verificationStatus) {
        var localVarPath = this.basePath + '/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/verification'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling appVerificationUpdate.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling appVerificationUpdate.');
        }
        if (verificationStatus === null || verificationStatus === undefined) {
            throw new Error('Required parameter verificationStatus was null or undefined when calling appVerificationUpdate.');
        }
        if (verificationStatus !== undefined) {
            localVarQueryParameters['verificationStatus'] = ObjectSerializer.serialize(verificationStatus, "'Draft' | 'Submitted' | 'Verified'");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreDeveloperApi.prototype.createAppStoreApp = function (oauthAppId, CreateAppStoreApp) {
        var localVarPath = this.basePath + '/api/v1.0/oauthclients/{oauthAppId}/appstore/apps'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling createAppStoreApp.');
        }
        if (CreateAppStoreApp === null || CreateAppStoreApp === undefined) {
            throw new Error('Required parameter CreateAppStoreApp was null or undefined when calling createAppStoreApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateAppStoreApp, "CreateAppStoreApp")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAppStoreApp");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreDeveloperApi.prototype.deleteAppStoreApp = function (oauthAppId, appStoreAppId) {
        var localVarPath = this.basePath + '/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling deleteAppStoreApp.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling deleteAppStoreApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreDeveloperApi.prototype.getAppExternalProduct = function (oauthAppId, appStoreAppId) {
        var localVarPath = this.basePath + '/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/external_product'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getAppExternalProduct.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling getAppExternalProduct.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreDeveloperApi.prototype.getExternalFunctionSigningKey = function (oauthAppId, appStoreAppId) {
        var localVarPath = this.basePath + '/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/external_function_signing_key'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getExternalFunctionSigningKey.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling getExternalFunctionSigningKey.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreDeveloperApi.prototype.updateAppStoreApp = function (oauthAppId, appStoreAppId, UpdateAppStoreApp) {
        var localVarPath = this.basePath + '/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling updateAppStoreApp.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling updateAppStoreApp.');
        }
        if (UpdateAppStoreApp === null || UpdateAppStoreApp === undefined) {
            throw new Error('Required parameter UpdateAppStoreApp was null or undefined when calling updateAppStoreApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateAppStoreApp, "UpdateAppStoreApp")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreDeveloperApi.prototype.updateExternalProduct = function (oauthAppId, appStoreAppId, UpdateAppStoreAppExternalProduct) {
        var localVarPath = this.basePath + '/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/external_product'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling updateExternalProduct.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling updateExternalProduct.');
        }
        if (UpdateAppStoreAppExternalProduct === null || UpdateAppStoreAppExternalProduct === undefined) {
            throw new Error('Required parameter UpdateAppStoreAppExternalProduct was null or undefined when calling updateExternalProduct.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateAppStoreAppExternalProduct, "UpdateAppStoreAppExternalProduct")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppStoreDeveloperApi.prototype.uploadAppStoreAppLogo = function (oauthAppId, appStoreAppId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/logo'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appStoreAppId' + '}', encodeURIComponent(String(appStoreAppId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling uploadAppStoreAppLogo.');
        }
        if (appStoreAppId === null || appStoreAppId === undefined) {
            throw new Error('Required parameter appStoreAppId was null or undefined when calling uploadAppStoreAppLogo.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadAppStoreAppLogo.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AppStoreDeveloperApi;
}());
exports.AppStoreDeveloperApi = AppStoreDeveloperApi;
var AppsApiApiKeys;
(function (AppsApiApiKeys) {
})(AppsApiApiKeys = exports.AppsApiApiKeys || (exports.AppsApiApiKeys = {}));
var AppsApi = (function () {
    function AppsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AppsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AppsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AppsApi.prototype.setApiKey = function (key, value) {
        this.authentications[AppsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(AppsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    AppsApi.prototype.getApp = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultApp");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.getAppHostnameStatus = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/hostnamestatus'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAppHostnameStatus.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultDnsRecordInformation");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.getApps = function (nameFilter, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/apps';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (nameFilter !== undefined) {
            localVarQueryParameters['nameFilter'] = ObjectSerializer.serialize(nameFilter, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultApp");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.getCompliance = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/compliance'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCompliance.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAppCompliance");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.getPanaceaVanityUrl = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/panacea/url'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPanaceaVanityUrl.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.getSalesforceReferences = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/salesforcereferences'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getSalesforceReferences.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "AppSalesforceReferences");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.getSupportedCountries = function () {
        var localVarPath = this.basePath + '/api/v1.0/apps/supportedcountries';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultSupportedCountry");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.isPanaceaVanityUrlAvailable = function (vanityUrl, appId) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/panacea/url/available'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (vanityUrl === null || vanityUrl === undefined) {
            throw new Error('Required parameter vanityUrl was null or undefined when calling isPanaceaVanityUrlAvailable.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling isPanaceaVanityUrlAvailable.');
        }
        if (vanityUrl !== undefined) {
            localVarQueryParameters['vanityUrl'] = ObjectSerializer.serialize(vanityUrl, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.lookupByWhitelabelId = function (whitelabelId) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{whitelabelId}/lookup'
            .replace('{' + 'whitelabelId' + '}', encodeURIComponent(String(whitelabelId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (whitelabelId === null || whitelabelId === undefined) {
            throw new Error('Required parameter whitelabelId was null or undefined when calling lookupByWhitelabelId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "AppLookup");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.setAppConfig = function (appId, AppConfigUpdateModel) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/config'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setAppConfig.');
        }
        if (AppConfigUpdateModel === null || AppConfigUpdateModel === undefined) {
            throw new Error('Required parameter AppConfigUpdateModel was null or undefined when calling setAppConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(AppConfigUpdateModel, "AppConfigUpdateModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultApp");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.setAppHostname = function (appId, hostname, isEmbed) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/hostname'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setAppHostname.');
        }
        if (hostname === null || hostname === undefined) {
            throw new Error('Required parameter hostname was null or undefined when calling setAppHostname.');
        }
        if (hostname !== undefined) {
            localVarQueryParameters['hostname'] = ObjectSerializer.serialize(hostname, "string");
        }
        if (isEmbed !== undefined) {
            localVarQueryParameters['isEmbed'] = ObjectSerializer.serialize(isEmbed, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.setAppLanguages = function (appId, Language) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/config/languages'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setAppLanguages.');
        }
        if (Language === null || Language === undefined) {
            throw new Error('Required parameter Language was null or undefined when calling setAppLanguages.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(Language, "Array<Language>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultApp");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.setAppStoreName = function (appId, body) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/appstorename'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setAppStoreName.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setAppStoreName.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "string")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.setCompliance = function (appId, complianceType) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/compliance'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setCompliance.');
        }
        if (complianceType === null || complianceType === undefined) {
            throw new Error('Required parameter complianceType was null or undefined when calling setCompliance.');
        }
        if (complianceType !== undefined) {
            localVarQueryParameters['complianceType'] = ObjectSerializer.serialize(complianceType, "'Default' | 'GdprCompliance'");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAppCompliance");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.setPanaceaVanityUrl = function (appId, vanityUrl) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/panacea/url'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setPanaceaVanityUrl.');
        }
        if (vanityUrl === null || vanityUrl === undefined) {
            throw new Error('Required parameter vanityUrl was null or undefined when calling setPanaceaVanityUrl.');
        }
        if (vanityUrl !== undefined) {
            localVarQueryParameters['vanityUrl'] = ObjectSerializer.serialize(vanityUrl, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.setSalesforceReferences = function (appId, AppSalesforceReferences) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/salesforcereferences'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setSalesforceReferences.');
        }
        if (AppSalesforceReferences === null || AppSalesforceReferences === undefined) {
            throw new Error('Required parameter AppSalesforceReferences was null or undefined when calling setSalesforceReferences.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(AppSalesforceReferences, "AppSalesforceReferences")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.toggleNextGenWeb = function (appId, hostname, vanityUrl, isNextGenWeb) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/nextgenweb'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling toggleNextGenWeb.');
        }
        if (hostname === null || hostname === undefined) {
            throw new Error('Required parameter hostname was null or undefined when calling toggleNextGenWeb.');
        }
        if (vanityUrl === null || vanityUrl === undefined) {
            throw new Error('Required parameter vanityUrl was null or undefined when calling toggleNextGenWeb.');
        }
        if (isNextGenWeb === null || isNextGenWeb === undefined) {
            throw new Error('Required parameter isNextGenWeb was null or undefined when calling toggleNextGenWeb.');
        }
        if (hostname !== undefined) {
            localVarQueryParameters['hostname'] = ObjectSerializer.serialize(hostname, "string");
        }
        if (vanityUrl !== undefined) {
            localVarQueryParameters['vanityUrl'] = ObjectSerializer.serialize(vanityUrl, "string");
        }
        if (isNextGenWeb !== undefined) {
            localVarQueryParameters['isNextGenWeb'] = ObjectSerializer.serialize(isNextGenWeb, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AppsApi.prototype.uploadAppLogo = function (appId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/apps/{appId}/logo'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling uploadAppLogo.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadAppLogo.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AppsApi;
}());
exports.AppsApi = AppsApi;
var AuditLogsApiApiKeys;
(function (AuditLogsApiApiKeys) {
})(AuditLogsApiApiKeys = exports.AuditLogsApiApiKeys || (exports.AuditLogsApiApiKeys = {}));
var AuditLogsApi = (function () {
    function AuditLogsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AuditLogsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuditLogsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AuditLogsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AuditLogsApi.prototype.setApiKey = function (key, value) {
        this.authentications[AuditLogsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(AuditLogsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    AuditLogsApi.prototype.addOrderAuditLog = function (orderId, ExternalStoreAuditLog) {
        var localVarPath = this.basePath + '/api/v1.0/auditlogs/orders/{orderId}'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling addOrderAuditLog.');
        }
        if (ExternalStoreAuditLog === null || ExternalStoreAuditLog === undefined) {
            throw new Error('Required parameter ExternalStoreAuditLog was null or undefined when calling addOrderAuditLog.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ExternalStoreAuditLog, "Array<ExternalStoreAuditLog>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AuditLogsApi.prototype.addStoreAuditLogEvent = function (storeId, ExternalStoreAuditLog) {
        var localVarPath = this.basePath + '/api/v1.0/auditlogs/stores/{storeId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling addStoreAuditLogEvent.');
        }
        if (ExternalStoreAuditLog === null || ExternalStoreAuditLog === undefined) {
            throw new Error('Required parameter ExternalStoreAuditLog was null or undefined when calling addStoreAuditLogEvent.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ExternalStoreAuditLog, "Array<ExternalStoreAuditLog>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AuditLogsApi;
}());
exports.AuditLogsApi = AuditLogsApi;
var AuthorizationTokensApiApiKeys;
(function (AuthorizationTokensApiApiKeys) {
})(AuthorizationTokensApiApiKeys = exports.AuthorizationTokensApiApiKeys || (exports.AuthorizationTokensApiApiKeys = {}));
var AuthorizationTokensApi = (function () {
    function AuthorizationTokensApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AuthorizationTokensApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthorizationTokensApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AuthorizationTokensApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AuthorizationTokensApi.prototype.setApiKey = function (key, value) {
        this.authentications[AuthorizationTokensApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(AuthorizationTokensApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    AuthorizationTokensApi.prototype.getAuthorizationTokens = function (oauthAppId, appId, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/authorizationtokens/{oauthAppId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getAuthorizationTokens.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAuthorizationTokens.');
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultOAuthTokenModel");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    AuthorizationTokensApi.prototype.revokeToken = function (key, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/authorizationtokens/{key}'
            .replace('{' + 'key' + '}', encodeURIComponent(String(key)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling revokeToken.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling revokeToken.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AuthorizationTokensApi;
}());
exports.AuthorizationTokensApi = AuthorizationTokensApi;
var BankAccountApiApiKeys;
(function (BankAccountApiApiKeys) {
})(BankAccountApiApiKeys = exports.BankAccountApiApiKeys || (exports.BankAccountApiApiKeys = {}));
var BankAccountApi = (function () {
    function BankAccountApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(BankAccountApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BankAccountApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    BankAccountApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    BankAccountApi.prototype.setApiKey = function (key, value) {
        this.authentications[BankAccountApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(BankAccountApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    BankAccountApi.prototype.attachBankAccountToStore = function (appId, bankAccountId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/store/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling attachBankAccountToStore.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling attachBankAccountToStore.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling attachBankAccountToStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    BankAccountApi.prototype.createBankAccount = function (appId, BankAccountCreate) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createBankAccount.');
        }
        if (BankAccountCreate === null || BankAccountCreate === undefined) {
            throw new Error('Required parameter BankAccountCreate was null or undefined when calling createBankAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(BankAccountCreate, "BankAccountCreate")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultBankAccountDetail");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    BankAccountApi.prototype.deleteBankAccount = function (appId, bankAccountId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteBankAccount.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling deleteBankAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    BankAccountApi.prototype.getBankAccountById = function (bankAccountId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}'
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling getBankAccountById.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getBankAccountById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultBankAccountDetail");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    BankAccountApi.prototype.getBankAccounts = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getBankAccounts.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultBankAccountSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    BankAccountApi.prototype.getCountriesWithFieldDefinitions = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/countries-field-definitions'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCountriesWithFieldDefinitions.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultCountryWithAccountFieldsDefinitions");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    BankAccountApi.prototype.getFieldDefinitions = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/field-definitions'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getFieldDefinitions.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAccountFieldsDefinitions");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    BankAccountApi.prototype.updateBankAccount = function (appId, bankAccountId, BankAccountCreate) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateBankAccount.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling updateBankAccount.');
        }
        if (BankAccountCreate === null || BankAccountCreate === undefined) {
            throw new Error('Required parameter BankAccountCreate was null or undefined when calling updateBankAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(BankAccountCreate, "BankAccountCreate")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    BankAccountApi.prototype.updateBankAccountState = function (appId, bankAccountId, state, body) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/state/{state}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'state' + '}', encodeURIComponent(String(state)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateBankAccountState.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling updateBankAccountState.');
        }
        if (state === null || state === undefined) {
            throw new Error('Required parameter state was null or undefined when calling updateBankAccountState.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateBankAccountState.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "string")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return BankAccountApi;
}());
exports.BankAccountApi = BankAccountApi;
var CampaignsApiApiKeys;
(function (CampaignsApiApiKeys) {
})(CampaignsApiApiKeys = exports.CampaignsApiApiKeys || (exports.CampaignsApiApiKeys = {}));
var CampaignsApi = (function () {
    function CampaignsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CampaignsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CampaignsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CampaignsApi.prototype.setApiKey = function (key, value) {
        this.authentications[CampaignsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CampaignsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CampaignsApi.prototype.createLoyaltyCampaign = function (appId, LoyaltyCampaignBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/loyalty'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createLoyaltyCampaign.');
        }
        if (LoyaltyCampaignBase === null || LoyaltyCampaignBase === undefined) {
            throw new Error('Required parameter LoyaltyCampaignBase was null or undefined when calling createLoyaltyCampaign.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(LoyaltyCampaignBase, "LoyaltyCampaignBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultLoyaltyCampaign");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.createRetentionCampaign = function (appId, RetentionCampaignBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/retention'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createRetentionCampaign.');
        }
        if (RetentionCampaignBase === null || RetentionCampaignBase === undefined) {
            throw new Error('Required parameter RetentionCampaignBase was null or undefined when calling createRetentionCampaign.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(RetentionCampaignBase, "RetentionCampaignBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRetentionCampaign");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.getLoyaltyCampaignsForApp = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/loyalty'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getLoyaltyCampaignsForApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultLoyaltyCampaign");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.getLoyaltyCampaignsForStore = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/loyalty/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getLoyaltyCampaignsForStore.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getLoyaltyCampaignsForStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultLoyaltyCampaign");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.getRetentionCampaignsForApp = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/retention'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getRetentionCampaignsForApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRetentionCampaign");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.getRetentionCampaignsForStore = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/retention/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getRetentionCampaignsForStore.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getRetentionCampaignsForStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRetentionCampaign");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.getStoreList = function (appId, onlyPublished) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/stores'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoreList.');
        }
        if (onlyPublished !== undefined) {
            localVarQueryParameters['onlyPublished'] = ObjectSerializer.serialize(onlyPublished, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultStoreListItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.removeCampaign = function (appId, campaignId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/{campaignId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'campaignId' + '}', encodeURIComponent(String(campaignId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling removeCampaign.');
        }
        if (campaignId === null || campaignId === undefined) {
            throw new Error('Required parameter campaignId was null or undefined when calling removeCampaign.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.updateLoyaltyCampaign = function (appId, campaignId, LoyaltyCampaignBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/loyalty/{campaignId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'campaignId' + '}', encodeURIComponent(String(campaignId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateLoyaltyCampaign.');
        }
        if (campaignId === null || campaignId === undefined) {
            throw new Error('Required parameter campaignId was null or undefined when calling updateLoyaltyCampaign.');
        }
        if (LoyaltyCampaignBase === null || LoyaltyCampaignBase === undefined) {
            throw new Error('Required parameter LoyaltyCampaignBase was null or undefined when calling updateLoyaltyCampaign.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(LoyaltyCampaignBase, "LoyaltyCampaignBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultLoyaltyCampaign");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CampaignsApi.prototype.updateRetentionCampaign = function (appId, campaignId, RetentionCampaignBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/campaigns/retention/{campaignId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'campaignId' + '}', encodeURIComponent(String(campaignId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateRetentionCampaign.');
        }
        if (campaignId === null || campaignId === undefined) {
            throw new Error('Required parameter campaignId was null or undefined when calling updateRetentionCampaign.');
        }
        if (RetentionCampaignBase === null || RetentionCampaignBase === undefined) {
            throw new Error('Required parameter RetentionCampaignBase was null or undefined when calling updateRetentionCampaign.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(RetentionCampaignBase, "RetentionCampaignBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRetentionCampaign");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CampaignsApi;
}());
exports.CampaignsApi = CampaignsApi;
var CardReadersApiApiKeys;
(function (CardReadersApiApiKeys) {
})(CardReadersApiApiKeys = exports.CardReadersApiApiKeys || (exports.CardReadersApiApiKeys = {}));
var CardReadersApi = (function () {
    function CardReadersApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CardReadersApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardReadersApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CardReadersApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CardReadersApi.prototype.setApiKey = function (key, value) {
        this.authentications[CardReadersApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CardReadersApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CardReadersApi.prototype.cancelCurrentlyInitiatedBluetoothDeviceUpdate = function (appId, deviceId, terminalType) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/{terminalType}/cancelUpdate'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)))
            .replace('{' + 'terminalType' + '}', encodeURIComponent(String(terminalType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling cancelCurrentlyInitiatedBluetoothDeviceUpdate.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling cancelCurrentlyInitiatedBluetoothDeviceUpdate.');
        }
        if (terminalType === null || terminalType === undefined) {
            throw new Error('Required parameter terminalType was null or undefined when calling cancelCurrentlyInitiatedBluetoothDeviceUpdate.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.cancelReaderAction = function (readerId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/payments/terminals/stripe/{readerId}/cancel_action'
            .replace('{' + 'readerId' + '}', encodeURIComponent(String(readerId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (readerId === null || readerId === undefined) {
            throw new Error('Required parameter readerId was null or undefined when calling cancelReaderAction.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling cancelReaderAction.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCardReader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.cardReadersGetReader = function (readerId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/payments/terminals/stripe/{readerId}'
            .replace('{' + 'readerId' + '}', encodeURIComponent(String(readerId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (readerId === null || readerId === undefined) {
            throw new Error('Required parameter readerId was null or undefined when calling cardReadersGetReader.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling cardReadersGetReader.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCardReader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.generateStripeTerminalLocation = function (appId, GeoPointRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stripeterminal/location'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling generateStripeTerminalLocation.');
        }
        if (GeoPointRequest === null || GeoPointRequest === undefined) {
            throw new Error('Required parameter GeoPointRequest was null or undefined when calling generateStripeTerminalLocation.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(GeoPointRequest, "GeoPointRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStripeTerminalLocation");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.getBluetoothTerminalStatus = function (appId, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/status'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getBluetoothTerminalStatus.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling getBluetoothTerminalStatus.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultBluetoothTerminalStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.getStripeConnectionToken = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stripeterminal/connectiontoken'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStripeConnectionToken.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStripeTerminalConnectionToken");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.initiateBluetoothTerminalDeviceUpdateCheck = function (appId, deviceId, terminalType) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/{terminalType}/checkForUpdate'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)))
            .replace('{' + 'terminalType' + '}', encodeURIComponent(String(terminalType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling initiateBluetoothTerminalDeviceUpdateCheck.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling initiateBluetoothTerminalDeviceUpdateCheck.');
        }
        if (terminalType === null || terminalType === undefined) {
            throw new Error('Required parameter terminalType was null or undefined when calling initiateBluetoothTerminalDeviceUpdateCheck.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.initiateKioskBluetoothPairingMode = function (appId, deviceId, terminalType) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/{terminalType}/pair'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)))
            .replace('{' + 'terminalType' + '}', encodeURIComponent(String(terminalType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling initiateKioskBluetoothPairingMode.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling initiateKioskBluetoothPairingMode.');
        }
        if (terminalType === null || terminalType === undefined) {
            throw new Error('Required parameter terminalType was null or undefined when calling initiateKioskBluetoothPairingMode.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.initiateKioskBluetoothUpdateInstall = function (appId, deviceId, terminalType) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/{terminalType}/installUpdate'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)))
            .replace('{' + 'terminalType' + '}', encodeURIComponent(String(terminalType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling initiateKioskBluetoothUpdateInstall.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling initiateKioskBluetoothUpdateInstall.');
        }
        if (terminalType === null || terminalType === undefined) {
            throw new Error('Required parameter terminalType was null or undefined when calling initiateKioskBluetoothUpdateInstall.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.initiateReaderProcessPaymentIntent = function (readerId, appId, ProcessPaymentIntentRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/payments/terminals/stripe/{readerId}/processPaymentIntent'
            .replace('{' + 'readerId' + '}', encodeURIComponent(String(readerId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (readerId === null || readerId === undefined) {
            throw new Error('Required parameter readerId was null or undefined when calling initiateReaderProcessPaymentIntent.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling initiateReaderProcessPaymentIntent.');
        }
        if (ProcessPaymentIntentRequest === null || ProcessPaymentIntentRequest === undefined) {
            throw new Error('Required parameter ProcessPaymentIntentRequest was null or undefined when calling initiateReaderProcessPaymentIntent.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ProcessPaymentIntentRequest, "ProcessPaymentIntentRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCardReader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.registerStripeTerminal = function (appId, CardReaderRegistrationRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/payments/terminals/stripe/register'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling registerStripeTerminal.');
        }
        if (CardReaderRegistrationRequest === null || CardReaderRegistrationRequest === undefined) {
            throw new Error('Required parameter CardReaderRegistrationRequest was null or undefined when calling registerStripeTerminal.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CardReaderRegistrationRequest, "CardReaderRegistrationRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCardReader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.unRegisterTerminal = function (appId, UnRegisterCardReaderRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/payments/terminals/stripe/unregister'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling unRegisterTerminal.');
        }
        if (UnRegisterCardReaderRequest === null || UnRegisterCardReaderRequest === undefined) {
            throw new Error('Required parameter UnRegisterCardReaderRequest was null or undefined when calling unRegisterTerminal.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UnRegisterCardReaderRequest, "UnRegisterCardReaderRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCardReader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CardReadersApi.prototype.unpairCurrentlyPairedBluetoothDevice = function (appId, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/unpair'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling unpairCurrentlyPairedBluetoothDevice.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling unpairCurrentlyPairedBluetoothDevice.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CardReadersApi;
}());
exports.CardReadersApi = CardReadersApi;
var CatalogChangesApiApiKeys;
(function (CatalogChangesApiApiKeys) {
})(CatalogChangesApiApiKeys = exports.CatalogChangesApiApiKeys || (exports.CatalogChangesApiApiKeys = {}));
var CatalogChangesApi = (function () {
    function CatalogChangesApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CatalogChangesApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogChangesApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CatalogChangesApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CatalogChangesApi.prototype.setApiKey = function (key, value) {
        this.authentications[CatalogChangesApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CatalogChangesApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CatalogChangesApi.prototype.getPendingMenuChanges = function (appId, menuId, catalogItemId, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/menus/catalog-changes'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPendingMenuChanges.');
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (catalogItemId !== undefined) {
            localVarQueryParameters['catalogItemId'] = ObjectSerializer.serialize(catalogItemId, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultPendingMenuChanges");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogChangesApi.prototype.getPendingMenuChangesSummaries = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/menus/catalog-changes/summaries'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPendingMenuChangesSummaries.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultPendingMenuChangesSummaries");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogChangesApi.prototype.publishPendingMenuChanges = function (appId, PublishMenuChanges) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/menus/catalog-changes/publish'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling publishPendingMenuChanges.');
        }
        if (PublishMenuChanges === null || PublishMenuChanges === undefined) {
            throw new Error('Required parameter PublishMenuChanges was null or undefined when calling publishPendingMenuChanges.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(PublishMenuChanges, "PublishMenuChanges")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CatalogChangesApi;
}());
exports.CatalogChangesApi = CatalogChangesApi;
var CatalogGroupsApiApiKeys;
(function (CatalogGroupsApiApiKeys) {
})(CatalogGroupsApiApiKeys = exports.CatalogGroupsApiApiKeys || (exports.CatalogGroupsApiApiKeys = {}));
var CatalogGroupsApi = (function () {
    function CatalogGroupsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CatalogGroupsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogGroupsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CatalogGroupsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CatalogGroupsApi.prototype.setApiKey = function (key, value) {
        this.authentications[CatalogGroupsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CatalogGroupsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CatalogGroupsApi.prototype.archiveGroup = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/groups/{catalogItemId}/archive'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling archiveGroup.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling archiveGroup.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogGroupsApi.prototype.createGroup = function (appId, CreateGroup) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/groups'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createGroup.');
        }
        if (CreateGroup === null || CreateGroup === undefined) {
            throw new Error('Required parameter CreateGroup was null or undefined when calling createGroup.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateGroup, "CreateGroup")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultGroup");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogGroupsApi.prototype.duplicateGroup = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/groups/{catalogItemId}/duplicate'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling duplicateGroup.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling duplicateGroup.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogGroupsApi.prototype.getGroupById = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/groups/{catalogItemId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getGroupById.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling getGroupById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Group");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogGroupsApi.prototype.getGroups = function (appId, groupTypes, searchTerm, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/groups'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getGroups.');
        }
        if (groupTypes === null || groupTypes === undefined) {
            throw new Error('Required parameter groupTypes was null or undefined when calling getGroups.');
        }
        if (groupTypes !== undefined) {
            localVarQueryParameters['groupTypes'] = ObjectSerializer.serialize(groupTypes, "Array<'ModifierGroup'>");
        }
        if (searchTerm !== undefined) {
            localVarQueryParameters['searchTerm'] = ObjectSerializer.serialize(searchTerm, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultGroup");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogGroupsApi.prototype.updateGroup = function (appId, catalogItemId, UpdateGroup) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/groups/{catalogItemId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateGroup.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling updateGroup.');
        }
        if (UpdateGroup === null || UpdateGroup === undefined) {
            throw new Error('Required parameter UpdateGroup was null or undefined when calling updateGroup.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateGroup, "UpdateGroup")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CatalogGroupsApi;
}());
exports.CatalogGroupsApi = CatalogGroupsApi;
var CatalogImagesApiApiKeys;
(function (CatalogImagesApiApiKeys) {
})(CatalogImagesApiApiKeys = exports.CatalogImagesApiApiKeys || (exports.CatalogImagesApiApiKeys = {}));
var CatalogImagesApi = (function () {
    function CatalogImagesApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CatalogImagesApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogImagesApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CatalogImagesApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CatalogImagesApi.prototype.setApiKey = function (key, value) {
        this.authentications[CatalogImagesApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CatalogImagesApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CatalogImagesApi.prototype.uploadCatalogImage = function (appId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/images'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling uploadCatalogImage.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadCatalogImage.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "CatalogImage");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CatalogImagesApi;
}());
exports.CatalogImagesApi = CatalogImagesApi;
var CatalogItemsApiApiKeys;
(function (CatalogItemsApiApiKeys) {
})(CatalogItemsApiApiKeys = exports.CatalogItemsApiApiKeys || (exports.CatalogItemsApiApiKeys = {}));
var CatalogItemsApi = (function () {
    function CatalogItemsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CatalogItemsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogItemsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CatalogItemsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CatalogItemsApi.prototype.setApiKey = function (key, value) {
        this.authentications[CatalogItemsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CatalogItemsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CatalogItemsApi.prototype.archiveCatalogItem = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/items/{catalogItemId}/archive'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling archiveCatalogItem.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling archiveCatalogItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogItemsApi.prototype.createCatalogItem = function (appId, CreateCatalogItem) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/items'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createCatalogItem.');
        }
        if (CreateCatalogItem === null || CreateCatalogItem === undefined) {
            throw new Error('Required parameter CreateCatalogItem was null or undefined when calling createCatalogItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateCatalogItem, "CreateCatalogItem")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCatalogItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogItemsApi.prototype.duplicateCatalogItem = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/items/{catalogItemId}/duplicate'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling duplicateCatalogItem.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling duplicateCatalogItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogItemsApi.prototype.getCatalogItemById = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/items/{catalogItemId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCatalogItemById.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling getCatalogItemById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "CatalogItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogItemsApi.prototype.getItems = function (appId, itemTypes, searchTerm, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/items'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getItems.');
        }
        if (itemTypes === null || itemTypes === undefined) {
            throw new Error('Required parameter itemTypes was null or undefined when calling getItems.');
        }
        if (itemTypes !== undefined) {
            localVarQueryParameters['itemTypes'] = ObjectSerializer.serialize(itemTypes, "Array<'Product' | 'Modifier'>");
        }
        if (searchTerm !== undefined) {
            localVarQueryParameters['searchTerm'] = ObjectSerializer.serialize(searchTerm, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultCatalogItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogItemsApi.prototype.updateCatalogItem = function (appId, catalogItemId, UpdateCatalogItem) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/items/{catalogItemId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateCatalogItem.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling updateCatalogItem.');
        }
        if (UpdateCatalogItem === null || UpdateCatalogItem === undefined) {
            throw new Error('Required parameter UpdateCatalogItem was null or undefined when calling updateCatalogItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateCatalogItem, "UpdateCatalogItem")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CatalogItemsApi;
}());
exports.CatalogItemsApi = CatalogItemsApi;
var CatalogProductsApiApiKeys;
(function (CatalogProductsApiApiKeys) {
})(CatalogProductsApiApiKeys = exports.CatalogProductsApiApiKeys || (exports.CatalogProductsApiApiKeys = {}));
var CatalogProductsApi = (function () {
    function CatalogProductsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CatalogProductsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogProductsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CatalogProductsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CatalogProductsApi.prototype.setApiKey = function (key, value) {
        this.authentications[CatalogProductsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CatalogProductsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CatalogProductsApi.prototype.archiveProduct = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/products/{catalogItemId}/archive'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling archiveProduct.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling archiveProduct.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogProductsApi.prototype.createProduct = function (appId, CreateProduct) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/products'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createProduct.');
        }
        if (CreateProduct === null || CreateProduct === undefined) {
            throw new Error('Required parameter CreateProduct was null or undefined when calling createProduct.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateProduct, "CreateProduct")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultProduct");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogProductsApi.prototype.duplicateProduct = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/products/{catalogItemId}/duplicate'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling duplicateProduct.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling duplicateProduct.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogProductsApi.prototype.getProductById = function (appId, catalogItemId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/products/{catalogItemId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getProductById.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling getProductById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Product");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogProductsApi.prototype.getProducts = function (appId, productTypes, searchTerm, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/products'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getProducts.');
        }
        if (productTypes === null || productTypes === undefined) {
            throw new Error('Required parameter productTypes was null or undefined when calling getProducts.');
        }
        if (productTypes !== undefined) {
            localVarQueryParameters['productTypes'] = ObjectSerializer.serialize(productTypes, "Array<'Product' | 'Modifier'>");
        }
        if (searchTerm !== undefined) {
            localVarQueryParameters['searchTerm'] = ObjectSerializer.serialize(searchTerm, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultProduct");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CatalogProductsApi.prototype.updateProduct = function (appId, catalogItemId, UpdateProduct) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/catalog/products/{catalogItemId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'catalogItemId' + '}', encodeURIComponent(String(catalogItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateProduct.');
        }
        if (catalogItemId === null || catalogItemId === undefined) {
            throw new Error('Required parameter catalogItemId was null or undefined when calling updateProduct.');
        }
        if (UpdateProduct === null || UpdateProduct === undefined) {
            throw new Error('Required parameter UpdateProduct was null or undefined when calling updateProduct.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateProduct, "UpdateProduct")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CatalogProductsApi;
}());
exports.CatalogProductsApi = CatalogProductsApi;
var ChannelsApiApiKeys;
(function (ChannelsApiApiKeys) {
})(ChannelsApiApiKeys = exports.ChannelsApiApiKeys || (exports.ChannelsApiApiKeys = {}));
var ChannelsApi = (function () {
    function ChannelsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(ChannelsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChannelsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    ChannelsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    ChannelsApi.prototype.setApiKey = function (key, value) {
        this.authentications[ChannelsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(ChannelsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    ChannelsApi.prototype.assignAppIdToSalesChannel = function (appId, channelId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/{channelId}/assign-appId'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'channelId' + '}', encodeURIComponent(String(channelId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling assignAppIdToSalesChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling assignAppIdToSalesChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.assignStoreToChannel = function (storeId, appId, channelId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/assign-store'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling assignStoreToChannel.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling assignStoreToChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling assignStoreToChannel.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (channelId !== undefined) {
            localVarQueryParameters['channelId'] = ObjectSerializer.serialize(channelId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.attachStoreToSalesChannel = function (appId, channelId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/{channelId}/stores/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'channelId' + '}', encodeURIComponent(String(channelId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling attachStoreToSalesChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling attachStoreToSalesChannel.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling attachStoreToSalesChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.detachAllStoresFromSalesChannel = function (appId, channelId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/{channelId}/stores'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'channelId' + '}', encodeURIComponent(String(channelId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling detachAllStoresFromSalesChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling detachAllStoresFromSalesChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.detachStoreFromSalesChannel = function (appId, channelId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/{channelId}/stores/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'channelId' + '}', encodeURIComponent(String(channelId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling detachStoreFromSalesChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling detachStoreFromSalesChannel.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling detachStoreFromSalesChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.getAssignedChannels = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/assigned-channels'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAssignedChannels.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultChannel");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.getAvailableChannels = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/available-channels'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAvailableChannels.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultChannel");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.getChannel = function (id, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getChannel.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultChannel");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.getChannels = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getChannels.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultChannel");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.getStoresAssignedToChannel = function (appId, channelId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/{channelId}/assigned-stores'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'channelId' + '}', encodeURIComponent(String(channelId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoresAssignedToChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling getStoresAssignedToChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultStoreChannelAssignment");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.getStoresBySalesChannel = function (appId, channelId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/{channelId}/stores'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'channelId' + '}', encodeURIComponent(String(channelId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoresBySalesChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling getStoresBySalesChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Response");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsApi.prototype.unassignStoreFromChannel = function (storeId, appId, channelId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/unassign-store'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling unassignStoreFromChannel.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling unassignStoreFromChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling unassignStoreFromChannel.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (channelId !== undefined) {
            localVarQueryParameters['channelId'] = ObjectSerializer.serialize(channelId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return ChannelsApi;
}());
exports.ChannelsApi = ChannelsApi;
var ChannelsStoreMappingApiApiKeys;
(function (ChannelsStoreMappingApiApiKeys) {
})(ChannelsStoreMappingApiApiKeys = exports.ChannelsStoreMappingApiApiKeys || (exports.ChannelsStoreMappingApiApiKeys = {}));
var ChannelsStoreMappingApi = (function () {
    function ChannelsStoreMappingApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(ChannelsStoreMappingApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChannelsStoreMappingApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    ChannelsStoreMappingApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    ChannelsStoreMappingApi.prototype.setApiKey = function (key, value) {
        this.authentications[ChannelsStoreMappingApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(ChannelsStoreMappingApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    ChannelsStoreMappingApi.prototype.channelsGetStoreChannelStoreMapping = function (appId, channelId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/storemappings'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling channelsGetStoreChannelStoreMapping.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling channelsGetStoreChannelStoreMapping.');
        }
        if (channelId !== undefined) {
            localVarQueryParameters['channelId'] = ObjectSerializer.serialize(channelId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultStoreChannelStoreMapping");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ChannelsStoreMappingApi.prototype.channelsSetStoreChannelStoreMapping = function (appId, channelId, ChannelStoreMapping) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/channels/storemappings'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling channelsSetStoreChannelStoreMapping.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling channelsSetStoreChannelStoreMapping.');
        }
        if (ChannelStoreMapping === null || ChannelStoreMapping === undefined) {
            throw new Error('Required parameter ChannelStoreMapping was null or undefined when calling channelsSetStoreChannelStoreMapping.');
        }
        if (channelId !== undefined) {
            localVarQueryParameters['channelId'] = ObjectSerializer.serialize(channelId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ChannelStoreMapping, "Array<ChannelStoreMapping>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultStoreChannelStoreMapping");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return ChannelsStoreMappingApi;
}());
exports.ChannelsStoreMappingApi = ChannelsStoreMappingApi;
var ClientsApiApiKeys;
(function (ClientsApiApiKeys) {
})(ClientsApiApiKeys = exports.ClientsApiApiKeys || (exports.ClientsApiApiKeys = {}));
var ClientsApi = (function () {
    function ClientsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(ClientsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    ClientsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    ClientsApi.prototype.setApiKey = function (key, value) {
        this.authentications[ClientsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(ClientsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    ClientsApi.prototype.getClient = function (clientId) {
        var localVarPath = this.basePath + '/api/v1.0/clients/{clientId}'
            .replace('{' + 'clientId' + '}', encodeURIComponent(String(clientId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling getClient.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ClientsApi.prototype.setSalesForceContactId = function (clientId, body) {
        var localVarPath = this.basePath + '/api/v1.0/clients/{clientId}/salesforcecontactid'
            .replace('{' + 'clientId' + '}', encodeURIComponent(String(clientId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling setSalesForceContactId.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setSalesForceContactId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "string")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    ClientsApi.prototype.setStripeCustomerId = function (clientId, body) {
        var localVarPath = this.basePath + '/api/v1.0/clients/{clientId}/stripecustomerid'
            .replace('{' + 'clientId' + '}', encodeURIComponent(String(clientId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling setStripeCustomerId.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setStripeCustomerId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "string")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return ClientsApi;
}());
exports.ClientsApi = ClientsApi;
var ContentSecurityPolicyApiApiKeys;
(function (ContentSecurityPolicyApiApiKeys) {
})(ContentSecurityPolicyApiApiKeys = exports.ContentSecurityPolicyApiApiKeys || (exports.ContentSecurityPolicyApiApiKeys = {}));
var ContentSecurityPolicyApi = (function () {
    function ContentSecurityPolicyApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(ContentSecurityPolicyApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContentSecurityPolicyApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    ContentSecurityPolicyApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    ContentSecurityPolicyApi.prototype.setApiKey = function (key, value) {
        this.authentications[ContentSecurityPolicyApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(ContentSecurityPolicyApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    ContentSecurityPolicyApi.prototype.contentSecurityPolicyReport = function (CspReportRequest) {
        var localVarPath = this.basePath + '/api/v1.0/csp/report';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (CspReportRequest === null || CspReportRequest === undefined) {
            throw new Error('Required parameter CspReportRequest was null or undefined when calling contentSecurityPolicyReport.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CspReportRequest, "CspReportRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return ContentSecurityPolicyApi;
}());
exports.ContentSecurityPolicyApi = ContentSecurityPolicyApi;
var CrossSellApiApiKeys;
(function (CrossSellApiApiKeys) {
})(CrossSellApiApiKeys = exports.CrossSellApiApiKeys || (exports.CrossSellApiApiKeys = {}));
var CrossSellApi = (function () {
    function CrossSellApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CrossSellApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrossSellApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CrossSellApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CrossSellApi.prototype.setApiKey = function (key, value) {
        this.authentications[CrossSellApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CrossSellApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CrossSellApi.prototype.getCrossSellMenuItems = function (menuId, menuItemId, limit, totalValue, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/crossSell/menuItems'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getCrossSellMenuItems.');
        }
        if (menuItemId === null || menuItemId === undefined) {
            throw new Error('Required parameter menuItemId was null or undefined when calling getCrossSellMenuItems.');
        }
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling getCrossSellMenuItems.');
        }
        if (totalValue === null || totalValue === undefined) {
            throw new Error('Required parameter totalValue was null or undefined when calling getCrossSellMenuItems.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCrossSellMenuItems.');
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (menuItemId !== undefined) {
            localVarQueryParameters['menuItemId'] = ObjectSerializer.serialize(menuItemId, "Array<number>");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (totalValue !== undefined) {
            localVarQueryParameters['totalValue'] = ObjectSerializer.serialize(totalValue, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCrossSellMenuItems");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CrossSellApi;
}());
exports.CrossSellApi = CrossSellApi;
var CustomersApiApiKeys;
(function (CustomersApiApiKeys) {
})(CustomersApiApiKeys = exports.CustomersApiApiKeys || (exports.CustomersApiApiKeys = {}));
var CustomersApi = (function () {
    function CustomersApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(CustomersApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    CustomersApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    CustomersApi.prototype.setApiKey = function (key, value) {
        this.authentications[CustomersApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(CustomersApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    CustomersApi.prototype.getCustomerById = function (appId, customerId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customers/{customerId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'customerId' + '}', encodeURIComponent(String(customerId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCustomerById.');
        }
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getCustomerById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCustomer");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    CustomersApi.prototype.updateCustomerById = function (appId, customerId, CustomerUpdateModel) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customers/{customerId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'customerId' + '}', encodeURIComponent(String(customerId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateCustomerById.');
        }
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling updateCustomerById.');
        }
        if (CustomerUpdateModel === null || CustomerUpdateModel === undefined) {
            throw new Error('Required parameter CustomerUpdateModel was null or undefined when calling updateCustomerById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CustomerUpdateModel, "CustomerUpdateModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCustomer");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return CustomersApi;
}());
exports.CustomersApi = CustomersApi;
var DeliveryZoneApiApiKeys;
(function (DeliveryZoneApiApiKeys) {
})(DeliveryZoneApiApiKeys = exports.DeliveryZoneApiApiKeys || (exports.DeliveryZoneApiApiKeys = {}));
var DeliveryZoneApi = (function () {
    function DeliveryZoneApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(DeliveryZoneApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryZoneApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    DeliveryZoneApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    DeliveryZoneApi.prototype.setApiKey = function (key, value) {
        this.authentications[DeliveryZoneApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(DeliveryZoneApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    DeliveryZoneApi.prototype.addDeliveryZone = function (storeId, DeliveryZoneBase) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/deliveryzones'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling addDeliveryZone.');
        }
        if (DeliveryZoneBase === null || DeliveryZoneBase === undefined) {
            throw new Error('Required parameter DeliveryZoneBase was null or undefined when calling addDeliveryZone.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(DeliveryZoneBase, "DeliveryZoneBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultDeliveryZone");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DeliveryZoneApi.prototype.getDeliveryZones = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/deliveryzones'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getDeliveryZones.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultDeliveryZone");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DeliveryZoneApi.prototype.removeDeliveryZone = function (storeId, deliveryZoneId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/deliveryzones/{deliveryZoneId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryZoneId' + '}', encodeURIComponent(String(deliveryZoneId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling removeDeliveryZone.');
        }
        if (deliveryZoneId === null || deliveryZoneId === undefined) {
            throw new Error('Required parameter deliveryZoneId was null or undefined when calling removeDeliveryZone.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DeliveryZoneApi.prototype.updateDeliveryZone = function (storeId, deliveryZoneId, DeliveryZoneBase) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/deliveryzones/{deliveryZoneId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryZoneId' + '}', encodeURIComponent(String(deliveryZoneId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateDeliveryZone.');
        }
        if (deliveryZoneId === null || deliveryZoneId === undefined) {
            throw new Error('Required parameter deliveryZoneId was null or undefined when calling updateDeliveryZone.');
        }
        if (DeliveryZoneBase === null || DeliveryZoneBase === undefined) {
            throw new Error('Required parameter DeliveryZoneBase was null or undefined when calling updateDeliveryZone.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(DeliveryZoneBase, "DeliveryZoneBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultDeliveryZone");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return DeliveryZoneApi;
}());
exports.DeliveryZoneApi = DeliveryZoneApi;
var DeviceApiApiKeys;
(function (DeviceApiApiKeys) {
})(DeviceApiApiKeys = exports.DeviceApiApiKeys || (exports.DeviceApiApiKeys = {}));
var DeviceApi = (function () {
    function DeviceApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(DeviceApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    DeviceApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    DeviceApi.prototype.setApiKey = function (key, value) {
        this.authentications[DeviceApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(DeviceApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    DeviceApi.prototype.assignDevice = function (appId, ClientDeviceAssignEnrolledDevice) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/devices/assign'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling assignDevice.');
        }
        if (ClientDeviceAssignEnrolledDevice === null || ClientDeviceAssignEnrolledDevice === undefined) {
            throw new Error('Required parameter ClientDeviceAssignEnrolledDevice was null or undefined when calling assignDevice.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ClientDeviceAssignEnrolledDevice, "ClientDeviceAssignEnrolledDevice")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultClientDeviceEnrollmentResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DeviceApi.prototype.enrollDevice = function (appId, ClientDeviceEnroll) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/devices/enroll'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling enrollDevice.');
        }
        if (ClientDeviceEnroll === null || ClientDeviceEnroll === undefined) {
            throw new Error('Required parameter ClientDeviceEnroll was null or undefined when calling enrollDevice.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ClientDeviceEnroll, "ClientDeviceEnroll")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultClientDeviceEnrollmentResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DeviceApi.prototype.getDeviceDetails = function (appId, deviceModel, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/devices/device/{deviceModel}/{deviceId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceModel' + '}', encodeURIComponent(String(deviceModel)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getDeviceDetails.');
        }
        if (deviceModel === null || deviceModel === undefined) {
            throw new Error('Required parameter deviceModel was null or undefined when calling getDeviceDetails.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling getDeviceDetails.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultClientDevice");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DeviceApi.prototype.searchDevices = function (appId, storeId, deviceModel) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/devices/search'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling searchDevices.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (deviceModel !== undefined) {
            localVarQueryParameters['deviceModel'] = ObjectSerializer.serialize(deviceModel, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultClientDeviceSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return DeviceApi;
}());
exports.DeviceApi = DeviceApi;
var DriversApiApiKeys;
(function (DriversApiApiKeys) {
})(DriversApiApiKeys = exports.DriversApiApiKeys || (exports.DriversApiApiKeys = {}));
var DriversApi = (function () {
    function DriversApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(DriversApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DriversApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    DriversApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    DriversApi.prototype.setApiKey = function (key, value) {
        this.authentications[DriversApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(DriversApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    DriversApi.prototype.driversAddDriverNotificationToken = function (UpdateDriverNotificationToken) {
        var localVarPath = this.basePath + '/api/v1.0/drivers/token';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (UpdateDriverNotificationToken === null || UpdateDriverNotificationToken === undefined) {
            throw new Error('Required parameter UpdateDriverNotificationToken was null or undefined when calling driversAddDriverNotificationToken.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateDriverNotificationToken, "UpdateDriverNotificationToken")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversDeleteDriverProfileImage = function () {
        var localVarPath = this.basePath + '/api/v1.0/drivers/profile/image';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversDriverLogin = function (DriverLoginModel) {
        var localVarPath = this.basePath + '/api/v1.0/drivers/login';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (DriverLoginModel === null || DriverLoginModel === undefined) {
            throw new Error('Required parameter DriverLoginModel was null or undefined when calling driversDriverLogin.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(DriverLoginModel, "DriverLoginModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversDriverRequestLoginCodeSms = function (DriverRequestLoginPinModel) {
        var localVarPath = this.basePath + '/api/v1.0/drivers/pin';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (DriverRequestLoginPinModel === null || DriverRequestLoginPinModel === undefined) {
            throw new Error('Required parameter DriverRequestLoginPinModel was null or undefined when calling driversDriverRequestLoginCodeSms.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(DriverRequestLoginPinModel, "DriverRequestLoginPinModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversGetDriverProfile = function () {
        var localVarPath = this.basePath + '/api/v1.0/drivers/profile';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversGetStoresForDriver = function () {
        var localVarPath = this.basePath + '/api/v1.0/drivers/assignedstores';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversRemoveDriverNotificationToken = function (UpdateDriverNotificationToken) {
        var localVarPath = this.basePath + '/api/v1.0/drivers/token';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (UpdateDriverNotificationToken === null || UpdateDriverNotificationToken === undefined) {
            throw new Error('Required parameter UpdateDriverNotificationToken was null or undefined when calling driversRemoveDriverNotificationToken.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateDriverNotificationToken, "UpdateDriverNotificationToken")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversSetDriverPresenceForStore = function (storeId, presence) {
        var localVarPath = this.basePath + '/api/v1.0/drivers/stores/{storeId}/presence/{presence}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'presence' + '}', encodeURIComponent(String(presence)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling driversSetDriverPresenceForStore.');
        }
        if (presence === null || presence === undefined) {
            throw new Error('Required parameter presence was null or undefined when calling driversSetDriverPresenceForStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversSetDriverProfileImage = function () {
        var localVarPath = this.basePath + '/api/v1.0/drivers/profile/image';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversUpdateDeliveryTrackingStatus = function (orderId, deliveryTrackingStatus) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{orderId}/tracking/{deliveryTrackingStatus}'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)))
            .replace('{' + 'deliveryTrackingStatus' + '}', encodeURIComponent(String(deliveryTrackingStatus)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling driversUpdateDeliveryTrackingStatus.');
        }
        if (deliveryTrackingStatus === null || deliveryTrackingStatus === undefined) {
            throw new Error('Required parameter deliveryTrackingStatus was null or undefined when calling driversUpdateDeliveryTrackingStatus.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    DriversApi.prototype.driversUpdateDriverProfile = function (UpdateDriverProfileModel) {
        var localVarPath = this.basePath + '/api/v1.0/drivers/profile';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (UpdateDriverProfileModel === null || UpdateDriverProfileModel === undefined) {
            throw new Error('Required parameter UpdateDriverProfileModel was null or undefined when calling driversUpdateDriverProfile.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateDriverProfileModel, "UpdateDriverProfileModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return DriversApi;
}());
exports.DriversApi = DriversApi;
var EventsApiApiKeys;
(function (EventsApiApiKeys) {
})(EventsApiApiKeys = exports.EventsApiApiKeys || (exports.EventsApiApiKeys = {}));
var EventsApi = (function () {
    function EventsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(EventsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    EventsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    EventsApi.prototype.setApiKey = function (key, value) {
        this.authentications[EventsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(EventsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    EventsApi.prototype.getCustomerEvents = function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events/customer/{customerId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'customerId' + '}', encodeURIComponent(String(customerId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCustomerEvents.');
        }
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getCustomerEvents.');
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (orderId !== undefined) {
            localVarQueryParameters['orderId'] = ObjectSerializer.serialize(orderId, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (storeIdList !== undefined) {
            localVarQueryParameters['storeIdList'] = ObjectSerializer.serialize(storeIdList, "Array<number>");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "number");
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (campaignId !== undefined) {
            localVarQueryParameters['campaignId'] = ObjectSerializer.serialize(campaignId, "number");
        }
        if (userEmail !== undefined) {
            localVarQueryParameters['userEmail'] = ObjectSerializer.serialize(userEmail, "string");
        }
        if (userName !== undefined) {
            localVarQueryParameters['userName'] = ObjectSerializer.serialize(userName, "string");
        }
        if (voucherCode !== undefined) {
            localVarQueryParameters['voucherCode'] = ObjectSerializer.serialize(voucherCode, "string");
        }
        if (eventType !== undefined) {
            localVarQueryParameters['eventType'] = ObjectSerializer.serialize(eventType, "Array<string>");
        }
        if (flipdishEventId !== undefined) {
            localVarQueryParameters['flipdishEventId'] = ObjectSerializer.serialize(flipdishEventId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiEventSearchPaginationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    EventsApi.prototype.getEvents = function (appId, whiteLabelId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getEvents.');
        }
        if (whiteLabelId !== undefined) {
            localVarQueryParameters['whiteLabelId'] = ObjectSerializer.serialize(whiteLabelId, "number");
        }
        if (customerId !== undefined) {
            localVarQueryParameters['customerId'] = ObjectSerializer.serialize(customerId, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (orderId !== undefined) {
            localVarQueryParameters['orderId'] = ObjectSerializer.serialize(orderId, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (storeIdList !== undefined) {
            localVarQueryParameters['storeIdList'] = ObjectSerializer.serialize(storeIdList, "Array<number>");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "number");
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (campaignId !== undefined) {
            localVarQueryParameters['campaignId'] = ObjectSerializer.serialize(campaignId, "number");
        }
        if (userEmail !== undefined) {
            localVarQueryParameters['userEmail'] = ObjectSerializer.serialize(userEmail, "string");
        }
        if (userName !== undefined) {
            localVarQueryParameters['userName'] = ObjectSerializer.serialize(userName, "string");
        }
        if (voucherCode !== undefined) {
            localVarQueryParameters['voucherCode'] = ObjectSerializer.serialize(voucherCode, "string");
        }
        if (eventType !== undefined) {
            localVarQueryParameters['eventType'] = ObjectSerializer.serialize(eventType, "Array<string>");
        }
        if (flipdishEventId !== undefined) {
            localVarQueryParameters['flipdishEventId'] = ObjectSerializer.serialize(flipdishEventId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiEventSearchPaginationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    EventsApi.prototype.getEventsById = function (eventId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events/{eventId}'
            .replace('{' + 'eventId' + '}', encodeURIComponent(String(eventId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (eventId === null || eventId === undefined) {
            throw new Error('Required parameter eventId was null or undefined when calling getEventsById.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getEventsById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "EventSearchResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    EventsApi.prototype.getMenuEvents = function (appId, menuId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events/menu/{menuId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getMenuEvents.');
        }
        if (menuId2 === null || menuId2 === undefined) {
            throw new Error('Required parameter menuId2 was null or undefined when calling getMenuEvents.');
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (orderId !== undefined) {
            localVarQueryParameters['orderId'] = ObjectSerializer.serialize(orderId, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (storeIdList !== undefined) {
            localVarQueryParameters['storeIdList'] = ObjectSerializer.serialize(storeIdList, "Array<number>");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "number");
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (campaignId !== undefined) {
            localVarQueryParameters['campaignId'] = ObjectSerializer.serialize(campaignId, "number");
        }
        if (userEmail !== undefined) {
            localVarQueryParameters['userEmail'] = ObjectSerializer.serialize(userEmail, "string");
        }
        if (userName !== undefined) {
            localVarQueryParameters['userName'] = ObjectSerializer.serialize(userName, "string");
        }
        if (voucherCode !== undefined) {
            localVarQueryParameters['voucherCode'] = ObjectSerializer.serialize(voucherCode, "string");
        }
        if (eventType !== undefined) {
            localVarQueryParameters['eventType'] = ObjectSerializer.serialize(eventType, "Array<string>");
        }
        if (flipdishEventId !== undefined) {
            localVarQueryParameters['flipdishEventId'] = ObjectSerializer.serialize(flipdishEventId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiEventSearchPaginationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    EventsApi.prototype.getOrderEvents = function (appId, orderId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events/order/{orderId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOrderEvents.');
        }
        if (orderId2 === null || orderId2 === undefined) {
            throw new Error('Required parameter orderId2 was null or undefined when calling getOrderEvents.');
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (orderId !== undefined) {
            localVarQueryParameters['orderId'] = ObjectSerializer.serialize(orderId, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (storeIdList !== undefined) {
            localVarQueryParameters['storeIdList'] = ObjectSerializer.serialize(storeIdList, "Array<number>");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "number");
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (campaignId !== undefined) {
            localVarQueryParameters['campaignId'] = ObjectSerializer.serialize(campaignId, "number");
        }
        if (userEmail !== undefined) {
            localVarQueryParameters['userEmail'] = ObjectSerializer.serialize(userEmail, "string");
        }
        if (userName !== undefined) {
            localVarQueryParameters['userName'] = ObjectSerializer.serialize(userName, "string");
        }
        if (voucherCode !== undefined) {
            localVarQueryParameters['voucherCode'] = ObjectSerializer.serialize(voucherCode, "string");
        }
        if (eventType !== undefined) {
            localVarQueryParameters['eventType'] = ObjectSerializer.serialize(eventType, "Array<string>");
        }
        if (flipdishEventId !== undefined) {
            localVarQueryParameters['flipdishEventId'] = ObjectSerializer.serialize(flipdishEventId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiEventSearchPaginationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    EventsApi.prototype.getOrderEventsByCustomer = function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events/order'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOrderEventsByCustomer.');
        }
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getOrderEventsByCustomer.');
        }
        if (customerId !== undefined) {
            localVarQueryParameters['customerId'] = ObjectSerializer.serialize(customerId, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (orderId !== undefined) {
            localVarQueryParameters['orderId'] = ObjectSerializer.serialize(orderId, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (storeIdList !== undefined) {
            localVarQueryParameters['storeIdList'] = ObjectSerializer.serialize(storeIdList, "Array<number>");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "number");
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (campaignId !== undefined) {
            localVarQueryParameters['campaignId'] = ObjectSerializer.serialize(campaignId, "number");
        }
        if (userEmail !== undefined) {
            localVarQueryParameters['userEmail'] = ObjectSerializer.serialize(userEmail, "string");
        }
        if (userName !== undefined) {
            localVarQueryParameters['userName'] = ObjectSerializer.serialize(userName, "string");
        }
        if (voucherCode !== undefined) {
            localVarQueryParameters['voucherCode'] = ObjectSerializer.serialize(voucherCode, "string");
        }
        if (eventType !== undefined) {
            localVarQueryParameters['eventType'] = ObjectSerializer.serialize(eventType, "Array<string>");
        }
        if (flipdishEventId !== undefined) {
            localVarQueryParameters['flipdishEventId'] = ObjectSerializer.serialize(flipdishEventId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiEventSearchPaginationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    EventsApi.prototype.getStoreEvents = function (appId, storeId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events/store/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoreEvents.');
        }
        if (storeId2 === null || storeId2 === undefined) {
            throw new Error('Required parameter storeId2 was null or undefined when calling getStoreEvents.');
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (orderId !== undefined) {
            localVarQueryParameters['orderId'] = ObjectSerializer.serialize(orderId, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (storeIdList !== undefined) {
            localVarQueryParameters['storeIdList'] = ObjectSerializer.serialize(storeIdList, "Array<number>");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "number");
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (campaignId !== undefined) {
            localVarQueryParameters['campaignId'] = ObjectSerializer.serialize(campaignId, "number");
        }
        if (userEmail !== undefined) {
            localVarQueryParameters['userEmail'] = ObjectSerializer.serialize(userEmail, "string");
        }
        if (userName !== undefined) {
            localVarQueryParameters['userName'] = ObjectSerializer.serialize(userName, "string");
        }
        if (voucherCode !== undefined) {
            localVarQueryParameters['voucherCode'] = ObjectSerializer.serialize(voucherCode, "string");
        }
        if (eventType !== undefined) {
            localVarQueryParameters['eventType'] = ObjectSerializer.serialize(eventType, "Array<string>");
        }
        if (flipdishEventId !== undefined) {
            localVarQueryParameters['flipdishEventId'] = ObjectSerializer.serialize(flipdishEventId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiEventSearchPaginationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    EventsApi.prototype.getUserEvents = function (appId, userId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events/user/{userId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'userId' + '}', encodeURIComponent(String(userId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getUserEvents.');
        }
        if (userId2 === null || userId2 === undefined) {
            throw new Error('Required parameter userId2 was null or undefined when calling getUserEvents.');
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (orderId !== undefined) {
            localVarQueryParameters['orderId'] = ObjectSerializer.serialize(orderId, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (storeIdList !== undefined) {
            localVarQueryParameters['storeIdList'] = ObjectSerializer.serialize(storeIdList, "Array<number>");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "number");
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (campaignId !== undefined) {
            localVarQueryParameters['campaignId'] = ObjectSerializer.serialize(campaignId, "number");
        }
        if (userEmail !== undefined) {
            localVarQueryParameters['userEmail'] = ObjectSerializer.serialize(userEmail, "string");
        }
        if (userName !== undefined) {
            localVarQueryParameters['userName'] = ObjectSerializer.serialize(userName, "string");
        }
        if (voucherCode !== undefined) {
            localVarQueryParameters['voucherCode'] = ObjectSerializer.serialize(voucherCode, "string");
        }
        if (eventType !== undefined) {
            localVarQueryParameters['eventType'] = ObjectSerializer.serialize(eventType, "Array<string>");
        }
        if (flipdishEventId !== undefined) {
            localVarQueryParameters['flipdishEventId'] = ObjectSerializer.serialize(flipdishEventId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiEventSearchPaginationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    EventsApi.prototype.getWhiteLabelEvents = function (appId, whitelabelId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/events/whitelabel/{whitelabelId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'whitelabelId' + '}', encodeURIComponent(String(whitelabelId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getWhiteLabelEvents.');
        }
        if (whitelabelId === null || whitelabelId === undefined) {
            throw new Error('Required parameter whitelabelId was null or undefined when calling getWhiteLabelEvents.');
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (orderId !== undefined) {
            localVarQueryParameters['orderId'] = ObjectSerializer.serialize(orderId, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (storeIdList !== undefined) {
            localVarQueryParameters['storeIdList'] = ObjectSerializer.serialize(storeIdList, "Array<number>");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "number");
        }
        if (menuId !== undefined) {
            localVarQueryParameters['menuId'] = ObjectSerializer.serialize(menuId, "number");
        }
        if (campaignId !== undefined) {
            localVarQueryParameters['campaignId'] = ObjectSerializer.serialize(campaignId, "number");
        }
        if (userEmail !== undefined) {
            localVarQueryParameters['userEmail'] = ObjectSerializer.serialize(userEmail, "string");
        }
        if (userName !== undefined) {
            localVarQueryParameters['userName'] = ObjectSerializer.serialize(userName, "string");
        }
        if (voucherCode !== undefined) {
            localVarQueryParameters['voucherCode'] = ObjectSerializer.serialize(voucherCode, "string");
        }
        if (eventType !== undefined) {
            localVarQueryParameters['eventType'] = ObjectSerializer.serialize(eventType, "Array<string>");
        }
        if (flipdishEventId !== undefined) {
            localVarQueryParameters['flipdishEventId'] = ObjectSerializer.serialize(flipdishEventId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiEventSearchPaginationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return EventsApi;
}());
exports.EventsApi = EventsApi;
var FeaturesApiApiKeys;
(function (FeaturesApiApiKeys) {
})(FeaturesApiApiKeys = exports.FeaturesApiApiKeys || (exports.FeaturesApiApiKeys = {}));
var FeaturesApi = (function () {
    function FeaturesApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(FeaturesApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeaturesApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    FeaturesApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    FeaturesApi.prototype.setApiKey = function (key, value) {
        this.authentications[FeaturesApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(FeaturesApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    FeaturesApi.prototype.disableFeatures = function (appId, ERROR_UNKNOWN) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/features/disable'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling disableFeatures.');
        }
        if (ERROR_UNKNOWN === null || ERROR_UNKNOWN === undefined) {
            throw new Error('Required parameter ERROR_UNKNOWN was null or undefined when calling disableFeatures.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ERROR_UNKNOWN, "Array<string>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringArrayResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    FeaturesApi.prototype.enableFeatures = function (appId, ERROR_UNKNOWN) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/features/enable'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling enableFeatures.');
        }
        if (ERROR_UNKNOWN === null || ERROR_UNKNOWN === undefined) {
            throw new Error('Required parameter ERROR_UNKNOWN was null or undefined when calling enableFeatures.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ERROR_UNKNOWN, "Array<string>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringArrayResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return FeaturesApi;
}());
exports.FeaturesApi = FeaturesApi;
var FilesApiApiKeys;
(function (FilesApiApiKeys) {
})(FilesApiApiKeys = exports.FilesApiApiKeys || (exports.FilesApiApiKeys = {}));
var FilesApi = (function () {
    function FilesApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(FilesApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilesApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    FilesApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    FilesApi.prototype.setApiKey = function (key, value) {
        this.authentications[FilesApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(FilesApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    FilesApi.prototype.downloadFile = function (appId, fileId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/files/download/{fileId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'fileId' + '}', encodeURIComponent(String(fileId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling downloadFile.');
        }
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling downloadFile.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "string");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return FilesApi;
}());
exports.FilesApi = FilesApi;
var FirebaseAppsApiApiKeys;
(function (FirebaseAppsApiApiKeys) {
})(FirebaseAppsApiApiKeys = exports.FirebaseAppsApiApiKeys || (exports.FirebaseAppsApiApiKeys = {}));
var FirebaseAppsApi = (function () {
    function FirebaseAppsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(FirebaseAppsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    FirebaseAppsApi.prototype.setApiKey = function (key, value) {
        this.authentications[FirebaseAppsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(FirebaseAppsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppsApi.prototype.firebaseAppsAddFirebaseApp = function (FirebaseApp) {
        var localVarPath = this.basePath + '/api/v1.0/FirebaseApp';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (FirebaseApp === null || FirebaseApp === undefined) {
            throw new Error('Required parameter FirebaseApp was null or undefined when calling firebaseAppsAddFirebaseApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(FirebaseApp, "FirebaseApp")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    FirebaseAppsApi.prototype.firebaseAppsGetFirebaseApp = function (whitelabelId) {
        var localVarPath = this.basePath + '/api/v1.0/FirebaseApp/{whitelabelId}'
            .replace('{' + 'whitelabelId' + '}', encodeURIComponent(String(whitelabelId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (whitelabelId === null || whitelabelId === undefined) {
            throw new Error('Required parameter whitelabelId was null or undefined when calling firebaseAppsGetFirebaseApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return FirebaseAppsApi;
}());
exports.FirebaseAppsApi = FirebaseAppsApi;
var FulfillmentStateConfigurationApiApiKeys;
(function (FulfillmentStateConfigurationApiApiKeys) {
})(FulfillmentStateConfigurationApiApiKeys = exports.FulfillmentStateConfigurationApiApiKeys || (exports.FulfillmentStateConfigurationApiApiKeys = {}));
var FulfillmentStateConfigurationApi = (function () {
    function FulfillmentStateConfigurationApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(FulfillmentStateConfigurationApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FulfillmentStateConfigurationApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    FulfillmentStateConfigurationApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    FulfillmentStateConfigurationApi.prototype.setApiKey = function (key, value) {
        this.authentications[FulfillmentStateConfigurationApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(FulfillmentStateConfigurationApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    FulfillmentStateConfigurationApi.prototype.createFulfillmentStatesConfig = function (appId, CreateFulfillmentStatesConfiguration) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/fulfillment/configuration/states'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createFulfillmentStatesConfig.');
        }
        if (CreateFulfillmentStatesConfiguration === null || CreateFulfillmentStatesConfiguration === undefined) {
            throw new Error('Required parameter CreateFulfillmentStatesConfiguration was null or undefined when calling createFulfillmentStatesConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateFulfillmentStatesConfiguration, "CreateFulfillmentStatesConfiguration")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultFulfillmentStatesConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    FulfillmentStateConfigurationApi.prototype.deleteFulfillmentStatesConfig = function (appId, configId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/fulfillment/configuration/states/{configId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'configId' + '}', encodeURIComponent(String(configId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteFulfillmentStatesConfig.');
        }
        if (configId === null || configId === undefined) {
            throw new Error('Required parameter configId was null or undefined when calling deleteFulfillmentStatesConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    FulfillmentStateConfigurationApi.prototype.getFulfillmentStatesConfiguration = function (appId, configId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/fulfillment/configuration/states/{configId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'configId' + '}', encodeURIComponent(String(configId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getFulfillmentStatesConfiguration.');
        }
        if (configId === null || configId === undefined) {
            throw new Error('Required parameter configId was null or undefined when calling getFulfillmentStatesConfiguration.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "FulfillmentStatesConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    FulfillmentStateConfigurationApi.prototype.getFulfillmentStatesConfigurationTemplate = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/fulfillment/configuration/states_template'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getFulfillmentStatesConfigurationTemplate.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "FulfillmentStatesConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    FulfillmentStateConfigurationApi.prototype.searchFulfillmentStatesConfigurations = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/fulfillment/configuration/states'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling searchFulfillmentStatesConfigurations.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultFulfillmentStatesConfigurationSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    FulfillmentStateConfigurationApi.prototype.updateFulfillmentStatesConfig = function (appId, configId, UpdateFulfillmentStatesConfiguration) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/fulfillment/configuration/states/{configId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'configId' + '}', encodeURIComponent(String(configId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateFulfillmentStatesConfig.');
        }
        if (configId === null || configId === undefined) {
            throw new Error('Required parameter configId was null or undefined when calling updateFulfillmentStatesConfig.');
        }
        if (UpdateFulfillmentStatesConfiguration === null || UpdateFulfillmentStatesConfiguration === undefined) {
            throw new Error('Required parameter UpdateFulfillmentStatesConfiguration was null or undefined when calling updateFulfillmentStatesConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateFulfillmentStatesConfiguration, "UpdateFulfillmentStatesConfiguration")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return FulfillmentStateConfigurationApi;
}());
exports.FulfillmentStateConfigurationApi = FulfillmentStateConfigurationApi;
var GoogleFoodOrderPrototypeApiApiKeys;
(function (GoogleFoodOrderPrototypeApiApiKeys) {
})(GoogleFoodOrderPrototypeApiApiKeys = exports.GoogleFoodOrderPrototypeApiApiKeys || (exports.GoogleFoodOrderPrototypeApiApiKeys = {}));
var GoogleFoodOrderPrototypeApi = (function () {
    function GoogleFoodOrderPrototypeApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(GoogleFoodOrderPrototypeApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoogleFoodOrderPrototypeApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    GoogleFoodOrderPrototypeApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    GoogleFoodOrderPrototypeApi.prototype.setApiKey = function (key, value) {
        this.authentications[GoogleFoodOrderPrototypeApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(GoogleFoodOrderPrototypeApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    GoogleFoodOrderPrototypeApi.prototype.createOrder = function (appId, CreateOrderRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/googleorder'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createOrder.');
        }
        if (CreateOrderRequest === null || CreateOrderRequest === undefined) {
            throw new Error('Required parameter CreateOrderRequest was null or undefined when calling createOrder.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateOrderRequest, "CreateOrderRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultSubmitOrderResponseDm");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    GoogleFoodOrderPrototypeApi.prototype.submitOrder = function (appId, orderId, SubmitOrderRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/googleorder/{orderId}/submit'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling submitOrder.');
        }
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling submitOrder.');
        }
        if (SubmitOrderRequest === null || SubmitOrderRequest === undefined) {
            throw new Error('Required parameter SubmitOrderRequest was null or undefined when calling submitOrder.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(SubmitOrderRequest, "SubmitOrderRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultSubmitOrderResponseDm");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return GoogleFoodOrderPrototypeApi;
}());
exports.GoogleFoodOrderPrototypeApi = GoogleFoodOrderPrototypeApi;
var HeartbeatApiApiKeys;
(function (HeartbeatApiApiKeys) {
})(HeartbeatApiApiKeys = exports.HeartbeatApiApiKeys || (exports.HeartbeatApiApiKeys = {}));
var HeartbeatApi = (function () {
    function HeartbeatApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(HeartbeatApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HeartbeatApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    HeartbeatApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    HeartbeatApi.prototype.setApiKey = function (key, value) {
        this.authentications[HeartbeatApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(HeartbeatApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    HeartbeatApi.prototype.headHostname = function () {
        var localVarPath = this.basePath + '/api/v1.0/heartbeat/Hostname';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'HEAD',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HeartbeatApi.prototype.headPing = function () {
        var localVarPath = this.basePath + '/api/v1.0/heartbeat';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'HEAD',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HeartbeatApi.prototype.hostname = function () {
        var localVarPath = this.basePath + '/api/v1.0/heartbeat/Hostname';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HeartbeatApi.prototype.ping = function () {
        var localVarPath = this.basePath + '/api/v1.0/heartbeat';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return HeartbeatApi;
}());
exports.HeartbeatApi = HeartbeatApi;
var HomeApiApiKeys;
(function (HomeApiApiKeys) {
})(HomeApiApiKeys = exports.HomeApiApiKeys || (exports.HomeApiApiKeys = {}));
var HomeApi = (function () {
    function HomeApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(HomeApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    HomeApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    HomeApi.prototype.setApiKey = function (key, value) {
        this.authentications[HomeApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(HomeApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    HomeApi.prototype.completeHomeAction = function (appId, homeActionId, isDismissed) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/home/{homeActionId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'homeActionId' + '}', encodeURIComponent(String(homeActionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling completeHomeAction.');
        }
        if (homeActionId === null || homeActionId === undefined) {
            throw new Error('Required parameter homeActionId was null or undefined when calling completeHomeAction.');
        }
        if (isDismissed === null || isDismissed === undefined) {
            throw new Error('Required parameter isDismissed was null or undefined when calling completeHomeAction.');
        }
        if (isDismissed !== undefined) {
            localVarQueryParameters['isDismissed'] = ObjectSerializer.serialize(isDismissed, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HomeApi.prototype.dismissOldPortalAction = function () {
        var localVarPath = this.basePath + '/api/v1.0/home/dismissoldportalaction';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HomeApi.prototype.getHomeActions = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/home'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getHomeActions.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultHomeAction");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HomeApi.prototype.getHomeStatistics = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/home/stats'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getHomeStatistics.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHomeStatistics");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HomeApi.prototype.getOktaPortalFeatureFlag = function () {
        var localVarPath = this.basePath + '/api/v1.0/home/okta-portal';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOktaPortalFeatureFlag");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return HomeApi;
}());
exports.HomeApi = HomeApi;
var HttpRequestResponseLogsApiApiKeys;
(function (HttpRequestResponseLogsApiApiKeys) {
})(HttpRequestResponseLogsApiApiKeys = exports.HttpRequestResponseLogsApiApiKeys || (exports.HttpRequestResponseLogsApiApiKeys = {}));
var HttpRequestResponseLogsApi = (function () {
    function HttpRequestResponseLogsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(HttpRequestResponseLogsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpRequestResponseLogsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    HttpRequestResponseLogsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    HttpRequestResponseLogsApi.prototype.setApiKey = function (key, value) {
        this.authentications[HttpRequestResponseLogsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(HttpRequestResponseLogsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    HttpRequestResponseLogsApi.prototype.getLogs = function (start, end, appId, filterByUserId, guid, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/interactions/logs'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (start === null || start === undefined) {
            throw new Error('Required parameter start was null or undefined when calling getLogs.');
        }
        if (end === null || end === undefined) {
            throw new Error('Required parameter end was null or undefined when calling getLogs.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getLogs.');
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (filterByUserId !== undefined) {
            localVarQueryParameters['filterByUserId'] = ObjectSerializer.serialize(filterByUserId, "number");
        }
        if (guid !== undefined) {
            localVarQueryParameters['guid'] = ObjectSerializer.serialize(guid, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultHttpRequestAndResponseLog");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return HttpRequestResponseLogsApi;
}());
exports.HttpRequestResponseLogsApi = HttpRequestResponseLogsApi;
var HydraApiApiKeys;
(function (HydraApiApiKeys) {
})(HydraApiApiKeys = exports.HydraApiApiKeys || (exports.HydraApiApiKeys = {}));
var HydraApi = (function () {
    function HydraApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(HydraApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HydraApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    HydraApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    HydraApi.prototype.setApiKey = function (key, value) {
        this.authentications[HydraApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(HydraApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    HydraApi.prototype.assignEmv = function (appId, hydraConfigId, emvTerminalId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/emvterminal/assign/{hydraConfigId}/{emvTerminalId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'hydraConfigId' + '}', encodeURIComponent(String(hydraConfigId)))
            .replace('{' + 'emvTerminalId' + '}', encodeURIComponent(String(emvTerminalId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling assignEmv.');
        }
        if (hydraConfigId === null || hydraConfigId === undefined) {
            throw new Error('Required parameter hydraConfigId was null or undefined when calling assignEmv.');
        }
        if (emvTerminalId === null || emvTerminalId === undefined) {
            throw new Error('Required parameter emvTerminalId was null or undefined when calling assignEmv.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.attachStoreToKiosk = function (appId, storeId, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/AttachStoreToKiosk/{deviceId}/store/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling attachStoreToKiosk.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling attachStoreToKiosk.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling attachStoreToKiosk.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHydraStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.attachStoreToTerminal = function (appId, deviceId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/{deviceId}/attach/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling attachStoreToTerminal.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling attachStoreToTerminal.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling attachStoreToTerminal.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHydraStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.cancelEmvPayment = function (orderId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/cancelemvpayment/{orderId}'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling cancelEmvPayment.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling cancelEmvPayment.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.detachStoreFromTerminal = function (appId, deviceId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/{deviceId}/detach/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling detachStoreFromTerminal.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling detachStoreFromTerminal.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling detachStoreFromTerminal.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHydraStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getAblyToken = function () {
        var localVarPath = this.basePath + '/api/v1.0/hydra/ably_token';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getAttachedDevice = function (appId, deviceType, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/{deviceType}/{deviceId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceType' + '}', encodeURIComponent(String(deviceType)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAttachedDevice.');
        }
        if (deviceType === null || deviceType === undefined) {
            throw new Error('Required parameter deviceType was null or undefined when calling getAttachedDevice.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling getAttachedDevice.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHydraDeviceDetails");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getAttachedDevices = function (appId, deviceType, pageIndex, pageSize, storeId, deviceName, deviceSerial) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/{deviceType}/list'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceType' + '}', encodeURIComponent(String(deviceType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAttachedDevices.');
        }
        if (deviceType === null || deviceType === undefined) {
            throw new Error('Required parameter deviceType was null or undefined when calling getAttachedDevices.');
        }
        if (pageIndex !== undefined) {
            localVarQueryParameters['pageIndex'] = ObjectSerializer.serialize(pageIndex, "number");
        }
        if (pageSize !== undefined) {
            localVarQueryParameters['pageSize'] = ObjectSerializer.serialize(pageSize, "number");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        if (deviceName !== undefined) {
            localVarQueryParameters['deviceName'] = ObjectSerializer.serialize(deviceName, "string");
        }
        if (deviceSerial !== undefined) {
            localVarQueryParameters['deviceSerial'] = ObjectSerializer.serialize(deviceSerial, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultHydraDeviceDetails");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getEMVTerminalDetails = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/emvterminal'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getEMVTerminalDetails.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultPaymentTerminalDetails");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getEmvOrderState = function (orderId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/emvorderstate/{orderId}'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling getEmvOrderState.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getEmvOrderState.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultPaymentTerminalTransactionDetails");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getKioskCashPaymentSettings = function (appId, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/kioskcashsettings/{deviceId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getKioskCashPaymentSettings.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling getKioskCashPaymentSettings.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultKioskCashPaymentSettings");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getKioskSettings = function (appId, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/kiosksettings/{deviceId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getKioskSettings.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling getKioskSettings.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultKioskSettings");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getRegistration = function () {
        var localVarPath = this.basePath + '/api/v1.0/hydra/registration';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHydraStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.getSettings = function () {
        var localVarPath = this.basePath + '/api/v1.0/hydra/settings';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHydraConfig");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.hydraCreateEmv = function (appId, EmvTerminal) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/emvterminals'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling hydraCreateEmv.');
        }
        if (EmvTerminal === null || EmvTerminal === undefined) {
            throw new Error('Required parameter EmvTerminal was null or undefined when calling hydraCreateEmv.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(EmvTerminal, "EmvTerminal")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.hydraDeleteEmv = function (appId, id) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/emvterminals/{id}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling hydraDeleteEmv.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling hydraDeleteEmv.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.hydraDetachStoreFromKiosk = function (appId, storeId, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/DetachStoreFromKiosk/{deviceId}/store/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling hydraDetachStoreFromKiosk.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling hydraDetachStoreFromKiosk.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling hydraDetachStoreFromKiosk.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHydraStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.hydraGetEmvsForAppId = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/emvterminals'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling hydraGetEmvsForAppId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultEmvTerminalWithAssignments");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.loginWithDeviceId = function (deviceId, hydraUserType, serialNumber) {
        var localVarPath = this.basePath + '/api/v1.0/hydra/{deviceId}/login'
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling loginWithDeviceId.');
        }
        if (hydraUserType !== undefined) {
            localVarQueryParameters['hydraUserType'] = ObjectSerializer.serialize(hydraUserType, "'Kiosk' | 'Terminal' | 'LegacyPrinter'");
        }
        if (serialNumber !== undefined) {
            localVarQueryParameters['serialNumber'] = ObjectSerializer.serialize(serialNumber, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.register = function (appId, HydraRegistrationRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/registration'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling register.');
        }
        if (HydraRegistrationRequest === null || HydraRegistrationRequest === undefined) {
            throw new Error('Required parameter HydraRegistrationRequest was null or undefined when calling register.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(HydraRegistrationRequest, "HydraRegistrationRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultHydraStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.unAssign = function (appId, deviceId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/{deviceId}/registration'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling unAssign.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling unAssign.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.unassignEmv = function (appId, hydraConfigId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/hydra/emvterminal/unassign/{hydraConfigId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'hydraConfigId' + '}', encodeURIComponent(String(hydraConfigId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling unassignEmv.');
        }
        if (hydraConfigId === null || hydraConfigId === undefined) {
            throw new Error('Required parameter hydraConfigId was null or undefined when calling unassignEmv.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.updateKioskCashVisibilitySettings = function (appId, deviceId, isCashEnabled) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/kioskupdatecashsettings'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateKioskCashVisibilitySettings.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling updateKioskCashVisibilitySettings.');
        }
        if (isCashEnabled === null || isCashEnabled === undefined) {
            throw new Error('Required parameter isCashEnabled was null or undefined when calling updateKioskCashVisibilitySettings.');
        }
        if (deviceId !== undefined) {
            localVarQueryParameters['deviceId'] = ObjectSerializer.serialize(deviceId, "string");
        }
        if (isCashEnabled !== undefined) {
            localVarQueryParameters['isCashEnabled'] = ObjectSerializer.serialize(isCashEnabled, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    HydraApi.prototype.updateKioskSettings = function (appId, deviceId, KioskSettings) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/kiosksettings/{deviceId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'deviceId' + '}', encodeURIComponent(String(deviceId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateKioskSettings.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling updateKioskSettings.');
        }
        if (KioskSettings === null || KioskSettings === undefined) {
            throw new Error('Required parameter KioskSettings was null or undefined when calling updateKioskSettings.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(KioskSettings, "KioskSettings")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return HydraApi;
}());
exports.HydraApi = HydraApi;
var IntercomApiApiKeys;
(function (IntercomApiApiKeys) {
})(IntercomApiApiKeys = exports.IntercomApiApiKeys || (exports.IntercomApiApiKeys = {}));
var IntercomApi = (function () {
    function IntercomApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(IntercomApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntercomApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    IntercomApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    IntercomApi.prototype.setApiKey = function (key, value) {
        this.authentications[IntercomApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(IntercomApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    IntercomApi.prototype.userHash = function () {
        var localVarPath = this.basePath + '/api/v1.0/intercom/userHash';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultIntercomUserHash");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return IntercomApi;
}());
exports.IntercomApi = IntercomApi;
var InvoicesApiApiKeys;
(function (InvoicesApiApiKeys) {
})(InvoicesApiApiKeys = exports.InvoicesApiApiKeys || (exports.InvoicesApiApiKeys = {}));
var InvoicesApi = (function () {
    function InvoicesApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(InvoicesApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvoicesApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    InvoicesApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    InvoicesApi.prototype.setApiKey = function (key, value) {
        this.authentications[InvoicesApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(InvoicesApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    InvoicesApi.prototype.getInvoices = function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/invoices'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getInvoices.');
        }
        if (subscriptionId !== undefined) {
            localVarQueryParameters['subscriptionId'] = ObjectSerializer.serialize(subscriptionId, "string");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (pageId !== undefined) {
            localVarQueryParameters['pageId'] = ObjectSerializer.serialize(pageId, "string");
        }
        if (excludeNotOwnedInvoices !== undefined) {
            localVarQueryParameters['excludeNotOwnedInvoices'] = ObjectSerializer.serialize(excludeNotOwnedInvoices, "boolean");
        }
        if (dateFrom !== undefined) {
            localVarQueryParameters['dateFrom'] = ObjectSerializer.serialize(dateFrom, "Date");
        }
        if (dateTo !== undefined) {
            localVarQueryParameters['dateTo'] = ObjectSerializer.serialize(dateTo, "Date");
        }
        if (invoiceNumber !== undefined) {
            localVarQueryParameters['invoiceNumber'] = ObjectSerializer.serialize(invoiceNumber, "string");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiFinanceSearchPaginationResultInvoice");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return InvoicesApi;
}());
exports.InvoicesApi = InvoicesApi;
var KioskIotApiApiKeys;
(function (KioskIotApiApiKeys) {
})(KioskIotApiApiKeys = exports.KioskIotApiApiKeys || (exports.KioskIotApiApiKeys = {}));
var KioskIotApi = (function () {
    function KioskIotApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(KioskIotApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KioskIotApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    KioskIotApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    KioskIotApi.prototype.setApiKey = function (key, value) {
        this.authentications[KioskIotApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(KioskIotApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    KioskIotApi.prototype.getKioskIotConnection = function () {
        var localVarPath = this.basePath + '/api/v1.0/kioskiot/connect';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultKioskIotConnectionParameters");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    KioskIotApi.prototype.queryTelemetrySeries = function (appId, TelemetrySeriesQueryParameters) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/kioskiot/timeseries/query'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling queryTelemetrySeries.');
        }
        if (TelemetrySeriesQueryParameters === null || TelemetrySeriesQueryParameters === undefined) {
            throw new Error('Required parameter TelemetrySeriesQueryParameters was null or undefined when calling queryTelemetrySeries.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(TelemetrySeriesQueryParameters, "TelemetrySeriesQueryParameters")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultTelemetrySeriesResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return KioskIotApi;
}());
exports.KioskIotApi = KioskIotApi;
var LightspeedApiApiKeys;
(function (LightspeedApiApiKeys) {
})(LightspeedApiApiKeys = exports.LightspeedApiApiKeys || (exports.LightspeedApiApiKeys = {}));
var LightspeedApi = (function () {
    function LightspeedApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(LightspeedApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LightspeedApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    LightspeedApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    LightspeedApi.prototype.setApiKey = function (key, value) {
        this.authentications[LightspeedApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(LightspeedApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    LightspeedApi.prototype.lightspeedGenerateMenu = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/lightspeed/{storeId}/menu/generate'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling lightspeedGenerateMenu.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LightspeedApi.prototype.lightspeedGetStoreSettings = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/lightspeed/{storeId}/settings'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling lightspeedGetStoreSettings.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultLightspeedSettings");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LightspeedApi.prototype.lightspeedSaveStoreSettings = function (storeId, LightspeedSettings) {
        var localVarPath = this.basePath + '/api/v1.0/lightspeed/{storeId}/settings'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling lightspeedSaveStoreSettings.');
        }
        if (LightspeedSettings === null || LightspeedSettings === undefined) {
            throw new Error('Required parameter LightspeedSettings was null or undefined when calling lightspeedSaveStoreSettings.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(LightspeedSettings, "LightspeedSettings")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultLightspeedSettings");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return LightspeedApi;
}());
exports.LightspeedApi = LightspeedApi;
var LocationApiApiKeys;
(function (LocationApiApiKeys) {
})(LocationApiApiKeys = exports.LocationApiApiKeys || (exports.LocationApiApiKeys = {}));
var LocationApi = (function () {
    function LocationApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(LocationApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    LocationApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    LocationApi.prototype.setApiKey = function (key, value) {
        this.authentications[LocationApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(LocationApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    LocationApi.prototype.createLocation = function (locationAreaId, appId, storeId, CreateLocation) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location'
            .replace('{' + 'locationAreaId' + '}', encodeURIComponent(String(locationAreaId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (locationAreaId === null || locationAreaId === undefined) {
            throw new Error('Required parameter locationAreaId was null or undefined when calling createLocation.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createLocation.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling createLocation.');
        }
        if (CreateLocation === null || CreateLocation === undefined) {
            throw new Error('Required parameter CreateLocation was null or undefined when calling createLocation.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateLocation, "Array<CreateLocation>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LocationApi.prototype.deleteLocation = function (locationId, locationAreaId, appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location/{locationId}/delete'
            .replace('{' + 'locationId' + '}', encodeURIComponent(String(locationId)))
            .replace('{' + 'locationAreaId' + '}', encodeURIComponent(String(locationAreaId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (locationId === null || locationId === undefined) {
            throw new Error('Required parameter locationId was null or undefined when calling deleteLocation.');
        }
        if (locationAreaId === null || locationAreaId === undefined) {
            throw new Error('Required parameter locationAreaId was null or undefined when calling deleteLocation.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteLocation.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling deleteLocation.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LocationApi.prototype.mapLocationToExternalId = function (locationId, locationAreaId, appId, storeId, externalLocationId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location/{locationId}/map-external'
            .replace('{' + 'locationId' + '}', encodeURIComponent(String(locationId)))
            .replace('{' + 'locationAreaId' + '}', encodeURIComponent(String(locationAreaId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (locationId === null || locationId === undefined) {
            throw new Error('Required parameter locationId was null or undefined when calling mapLocationToExternalId.');
        }
        if (locationAreaId === null || locationAreaId === undefined) {
            throw new Error('Required parameter locationAreaId was null or undefined when calling mapLocationToExternalId.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling mapLocationToExternalId.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling mapLocationToExternalId.');
        }
        if (externalLocationId !== undefined) {
            localVarQueryParameters['externalLocationId'] = ObjectSerializer.serialize(externalLocationId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMappedLocation");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LocationApi.prototype.moveLocation = function (locationId, locationAreaId, newLocationAreaId, appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location/{locationId}/move'
            .replace('{' + 'locationId' + '}', encodeURIComponent(String(locationId)))
            .replace('{' + 'locationAreaId' + '}', encodeURIComponent(String(locationAreaId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (locationId === null || locationId === undefined) {
            throw new Error('Required parameter locationId was null or undefined when calling moveLocation.');
        }
        if (locationAreaId === null || locationAreaId === undefined) {
            throw new Error('Required parameter locationAreaId was null or undefined when calling moveLocation.');
        }
        if (newLocationAreaId === null || newLocationAreaId === undefined) {
            throw new Error('Required parameter newLocationAreaId was null or undefined when calling moveLocation.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling moveLocation.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling moveLocation.');
        }
        if (newLocationAreaId !== undefined) {
            localVarQueryParameters['newLocationAreaId'] = ObjectSerializer.serialize(newLocationAreaId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LocationApi.prototype.updateLocation = function (locationAreaId, locationId, appId, storeId, CreateLocation) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location/{locationId}/update'
            .replace('{' + 'locationAreaId' + '}', encodeURIComponent(String(locationAreaId)))
            .replace('{' + 'locationId' + '}', encodeURIComponent(String(locationId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (locationAreaId === null || locationAreaId === undefined) {
            throw new Error('Required parameter locationAreaId was null or undefined when calling updateLocation.');
        }
        if (locationId === null || locationId === undefined) {
            throw new Error('Required parameter locationId was null or undefined when calling updateLocation.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateLocation.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateLocation.');
        }
        if (CreateLocation === null || CreateLocation === undefined) {
            throw new Error('Required parameter CreateLocation was null or undefined when calling updateLocation.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateLocation, "CreateLocation")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultLocationAreaLocation");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return LocationApi;
}());
exports.LocationApi = LocationApi;
var LocationAreasApiApiKeys;
(function (LocationAreasApiApiKeys) {
})(LocationAreasApiApiKeys = exports.LocationAreasApiApiKeys || (exports.LocationAreasApiApiKeys = {}));
var LocationAreasApi = (function () {
    function LocationAreasApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(LocationAreasApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationAreasApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    LocationAreasApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    LocationAreasApi.prototype.setApiKey = function (key, value) {
        this.authentications[LocationAreasApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(LocationAreasApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    LocationAreasApi.prototype.createLocationArea = function (appId, storeId, CreateLocationArea) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createLocationArea.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling createLocationArea.');
        }
        if (CreateLocationArea === null || CreateLocationArea === undefined) {
            throw new Error('Required parameter CreateLocationArea was null or undefined when calling createLocationArea.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateLocationArea, "CreateLocationArea")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LocationAreasApi.prototype.getLocationArea = function (locationAreaId, appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}'
            .replace('{' + 'locationAreaId' + '}', encodeURIComponent(String(locationAreaId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (locationAreaId === null || locationAreaId === undefined) {
            throw new Error('Required parameter locationAreaId was null or undefined when calling getLocationArea.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getLocationArea.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getLocationArea.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultLocationAreaWithLocations");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LocationAreasApi.prototype.getLocationAreasForStore = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getLocationAreasForStore.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getLocationAreasForStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultLocationAreaWithLocations");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    LocationAreasApi.prototype.updateLocationArea = function (appId, storeId, locationAreaId, UpdateLocationArea) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/update'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'locationAreaId' + '}', encodeURIComponent(String(locationAreaId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateLocationArea.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateLocationArea.');
        }
        if (locationAreaId === null || locationAreaId === undefined) {
            throw new Error('Required parameter locationAreaId was null or undefined when calling updateLocationArea.');
        }
        if (UpdateLocationArea === null || UpdateLocationArea === undefined) {
            throw new Error('Required parameter UpdateLocationArea was null or undefined when calling updateLocationArea.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateLocationArea, "UpdateLocationArea")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultLocationArea");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return LocationAreasApi;
}());
exports.LocationAreasApi = LocationAreasApi;
var LookerDashboardApiApiKeys;
(function (LookerDashboardApiApiKeys) {
})(LookerDashboardApiApiKeys = exports.LookerDashboardApiApiKeys || (exports.LookerDashboardApiApiKeys = {}));
var LookerDashboardApi = (function () {
    function LookerDashboardApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(LookerDashboardApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookerDashboardApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    LookerDashboardApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    LookerDashboardApi.prototype.setApiKey = function (key, value) {
        this.authentications[LookerDashboardApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(LookerDashboardApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    LookerDashboardApi.prototype.lookerDashboardGetAll = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/looker/dashboards'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling lookerDashboardGetAll.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return LookerDashboardApi;
}());
exports.LookerDashboardApi = LookerDashboardApi;
var LookerSingleSignOnApiApiKeys;
(function (LookerSingleSignOnApiApiKeys) {
})(LookerSingleSignOnApiApiKeys = exports.LookerSingleSignOnApiApiKeys || (exports.LookerSingleSignOnApiApiKeys = {}));
var LookerSingleSignOnApi = (function () {
    function LookerSingleSignOnApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(LookerSingleSignOnApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookerSingleSignOnApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    LookerSingleSignOnApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    LookerSingleSignOnApi.prototype.setApiKey = function (key, value) {
        this.authentications[LookerSingleSignOnApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(LookerSingleSignOnApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    LookerSingleSignOnApi.prototype.getSSOEndpoint = function (appId, embedPath, filters) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/looker/sso'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getSSOEndpoint.');
        }
        if (embedPath === null || embedPath === undefined) {
            throw new Error('Required parameter embedPath was null or undefined when calling getSSOEndpoint.');
        }
        if (embedPath !== undefined) {
            localVarQueryParameters['embedPath'] = ObjectSerializer.serialize(embedPath, "string");
        }
        if (filters !== undefined) {
            localVarQueryParameters['filters'] = ObjectSerializer.serialize(filters, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "DashboardEmbed");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return LookerSingleSignOnApi;
}());
exports.LookerSingleSignOnApi = LookerSingleSignOnApi;
var MenuOptionSetItemsApiApiKeys;
(function (MenuOptionSetItemsApiApiKeys) {
})(MenuOptionSetItemsApiApiKeys = exports.MenuOptionSetItemsApiApiKeys || (exports.MenuOptionSetItemsApiApiKeys = {}));
var MenuOptionSetItemsApi = (function () {
    function MenuOptionSetItemsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(MenuOptionSetItemsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuOptionSetItemsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    MenuOptionSetItemsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    MenuOptionSetItemsApi.prototype.setApiKey = function (key, value) {
        this.authentications[MenuOptionSetItemsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(MenuOptionSetItemsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    MenuOptionSetItemsApi.prototype.addMenuItemOptionSetItem = function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetItemBase) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling addMenuItemOptionSetItem.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling addMenuItemOptionSetItem.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling addMenuItemOptionSetItem.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling addMenuItemOptionSetItem.');
        }
        if (MenuItemOptionSetItemBase === null || MenuItemOptionSetItemBase === undefined) {
            throw new Error('Required parameter MenuItemOptionSetItemBase was null or undefined when calling addMenuItemOptionSetItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuItemOptionSetItemBase, "MenuItemOptionSetItemBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetItemsApi.prototype.deleteOptionSetItemImage = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)))
            .replace('{' + 'menuItemOptionSetItemId' + '}', encodeURIComponent(String(menuItemOptionSetItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteOptionSetItemImage.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling deleteOptionSetItemImage.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling deleteOptionSetItemImage.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling deleteOptionSetItemImage.');
        }
        if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
            throw new Error('Required parameter menuItemOptionSetItemId was null or undefined when calling deleteOptionSetItemImage.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetItemsApi.prototype.getMenuItemOptionSetItemById = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)))
            .replace('{' + 'menuItemOptionSetItemId' + '}', encodeURIComponent(String(menuItemOptionSetItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItemOptionSetItemById.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling getMenuItemOptionSetItemById.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling getMenuItemOptionSetItemById.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling getMenuItemOptionSetItemById.');
        }
        if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
            throw new Error('Required parameter menuItemOptionSetItemId was null or undefined when calling getMenuItemOptionSetItemById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuItemOptionSetItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetItemsApi.prototype.getMenuItemOptionSetItems = function (menuId, menuSectionId, menuSectionItemId, optionSetId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItemOptionSetItems.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling getMenuItemOptionSetItems.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling getMenuItemOptionSetItems.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling getMenuItemOptionSetItems.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuItemOptionSetItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetItemsApi.prototype.removeMenuItemOptionSetItem = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)))
            .replace('{' + 'menuItemOptionSetItemId' + '}', encodeURIComponent(String(menuItemOptionSetItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling removeMenuItemOptionSetItem.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling removeMenuItemOptionSetItem.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling removeMenuItemOptionSetItem.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling removeMenuItemOptionSetItem.');
        }
        if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
            throw new Error('Required parameter menuItemOptionSetItemId was null or undefined when calling removeMenuItemOptionSetItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetItemsApi.prototype.setOptionSetItemTax = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, taxRateId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}/taxrate/{taxRateId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)))
            .replace('{' + 'menuItemOptionSetItemId' + '}', encodeURIComponent(String(menuItemOptionSetItemId)))
            .replace('{' + 'taxRateId' + '}', encodeURIComponent(String(taxRateId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling setOptionSetItemTax.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling setOptionSetItemTax.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling setOptionSetItemTax.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling setOptionSetItemTax.');
        }
        if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
            throw new Error('Required parameter menuItemOptionSetItemId was null or undefined when calling setOptionSetItemTax.');
        }
        if (taxRateId === null || taxRateId === undefined) {
            throw new Error('Required parameter taxRateId was null or undefined when calling setOptionSetItemTax.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetItemsApi.prototype.updateMenuItemOptionSetItem = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, MenuItemOptionSetItemBase, undoAfter) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)))
            .replace('{' + 'menuItemOptionSetItemId' + '}', encodeURIComponent(String(menuItemOptionSetItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling updateMenuItemOptionSetItem.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling updateMenuItemOptionSetItem.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling updateMenuItemOptionSetItem.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling updateMenuItemOptionSetItem.');
        }
        if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
            throw new Error('Required parameter menuItemOptionSetItemId was null or undefined when calling updateMenuItemOptionSetItem.');
        }
        if (MenuItemOptionSetItemBase === null || MenuItemOptionSetItemBase === undefined) {
            throw new Error('Required parameter MenuItemOptionSetItemBase was null or undefined when calling updateMenuItemOptionSetItem.');
        }
        if (undoAfter !== undefined) {
            localVarQueryParameters['undoAfter'] = ObjectSerializer.serialize(undoAfter, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuItemOptionSetItemBase, "MenuItemOptionSetItemBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetItemsApi.prototype.uploadOptionSetItemImage = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)))
            .replace('{' + 'menuItemOptionSetItemId' + '}', encodeURIComponent(String(menuItemOptionSetItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling uploadOptionSetItemImage.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling uploadOptionSetItemImage.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling uploadOptionSetItemImage.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling uploadOptionSetItemImage.');
        }
        if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
            throw new Error('Required parameter menuItemOptionSetItemId was null or undefined when calling uploadOptionSetItemImage.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadOptionSetItemImage.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return MenuOptionSetItemsApi;
}());
exports.MenuOptionSetItemsApi = MenuOptionSetItemsApi;
var MenuOptionSetsApiApiKeys;
(function (MenuOptionSetsApiApiKeys) {
})(MenuOptionSetsApiApiKeys = exports.MenuOptionSetsApiApiKeys || (exports.MenuOptionSetsApiApiKeys = {}));
var MenuOptionSetsApi = (function () {
    function MenuOptionSetsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(MenuOptionSetsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuOptionSetsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    MenuOptionSetsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    MenuOptionSetsApi.prototype.setApiKey = function (key, value) {
        this.authentications[MenuOptionSetsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(MenuOptionSetsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    MenuOptionSetsApi.prototype.createMenuItemOptionSet = function (menuId, menuSectionId, menuSectionItemId, MenuItemOptionSetBase) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling createMenuItemOptionSet.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling createMenuItemOptionSet.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling createMenuItemOptionSet.');
        }
        if (MenuItemOptionSetBase === null || MenuItemOptionSetBase === undefined) {
            throw new Error('Required parameter MenuItemOptionSetBase was null or undefined when calling createMenuItemOptionSet.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuItemOptionSetBase, "MenuItemOptionSetBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetsApi.prototype.deleteMenuItemOptionSet = function (menuId, menuSectionItemId, menuSectionId, optionSetId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenuItemOptionSet.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling deleteMenuItemOptionSet.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling deleteMenuItemOptionSet.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling deleteMenuItemOptionSet.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetsApi.prototype.deleteOptionSetImage = function (menuId, menuSectionId, menuSectionItemId, optionSetId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteOptionSetImage.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling deleteOptionSetImage.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling deleteOptionSetImage.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling deleteOptionSetImage.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetsApi.prototype.getMenuItemOptionSetById = function (menuId, menuSectionId, menuSectionItemId, optionSetId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItemOptionSetById.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling getMenuItemOptionSetById.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling getMenuItemOptionSetById.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling getMenuItemOptionSetById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuItemOptionSet");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetsApi.prototype.getMenuItemOptionSets = function (menuId, menuSectionId, menuSectionItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItemOptionSets.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling getMenuItemOptionSets.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling getMenuItemOptionSets.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuItemOptionSet");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetsApi.prototype.updateMenuItemOptionSet = function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetBase) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling updateMenuItemOptionSet.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling updateMenuItemOptionSet.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling updateMenuItemOptionSet.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling updateMenuItemOptionSet.');
        }
        if (MenuItemOptionSetBase === null || MenuItemOptionSetBase === undefined) {
            throw new Error('Required parameter MenuItemOptionSetBase was null or undefined when calling updateMenuItemOptionSet.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuItemOptionSetBase, "MenuItemOptionSetBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuOptionSetsApi.prototype.uploadOptionSetImage = function (menuId, menuSectionId, menuSectionItemId, optionSetId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'optionSetId' + '}', encodeURIComponent(String(optionSetId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling uploadOptionSetImage.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling uploadOptionSetImage.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling uploadOptionSetImage.');
        }
        if (optionSetId === null || optionSetId === undefined) {
            throw new Error('Required parameter optionSetId was null or undefined when calling uploadOptionSetImage.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadOptionSetImage.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return MenuOptionSetsApi;
}());
exports.MenuOptionSetsApi = MenuOptionSetsApi;
var MenuSectionItemsApiApiKeys;
(function (MenuSectionItemsApiApiKeys) {
})(MenuSectionItemsApiApiKeys = exports.MenuSectionItemsApiApiKeys || (exports.MenuSectionItemsApiApiKeys = {}));
var MenuSectionItemsApi = (function () {
    function MenuSectionItemsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(MenuSectionItemsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuSectionItemsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    MenuSectionItemsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    MenuSectionItemsApi.prototype.setApiKey = function (key, value) {
        this.authentications[MenuSectionItemsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(MenuSectionItemsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    MenuSectionItemsApi.prototype.cloneMenuSectionItem = function (menuId, menuSectionId, menuSectionItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/clone'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling cloneMenuSectionItem.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling cloneMenuSectionItem.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling cloneMenuSectionItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuSectionItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.createMenuSectionItem = function (menuId, menuSectionId, MenuSectionItemBase) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling createMenuSectionItem.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling createMenuSectionItem.');
        }
        if (MenuSectionItemBase === null || MenuSectionItemBase === undefined) {
            throw new Error('Required parameter MenuSectionItemBase was null or undefined when calling createMenuSectionItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuSectionItemBase, "MenuSectionItemBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.createMenuSectionItemFromCatalogItems = function (menuId, menuSectionId, CreateMenuSectionItemFromCatalogItems) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/add-catalogitems'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling createMenuSectionItemFromCatalogItems.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling createMenuSectionItemFromCatalogItems.');
        }
        if (CreateMenuSectionItemFromCatalogItems === null || CreateMenuSectionItemFromCatalogItems === undefined) {
            throw new Error('Required parameter CreateMenuSectionItemFromCatalogItems was null or undefined when calling createMenuSectionItemFromCatalogItems.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateMenuSectionItemFromCatalogItems, "CreateMenuSectionItemFromCatalogItems")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.deleteMenuSectionItem = function (menuId, menuSectionId, menuSectionItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenuSectionItem.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling deleteMenuSectionItem.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling deleteMenuSectionItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.deleteMenuSectionItemImage = function (menuId, menuSectionId, menuSectionItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenuSectionItemImage.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling deleteMenuSectionItemImage.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling deleteMenuSectionItemImage.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.getMenuItemById = function (menuId, menuSectionId, menuSectionItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItemById.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling getMenuItemById.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling getMenuItemById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuSectionItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.getMenuItems = function (menuId, menuSectionId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItems.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling getMenuItems.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuSectionItem");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.moveMenuItem = function (menuId, menuSectionId, menuSectionItemId, destinationDisplayOrder) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/setorder/{destinationDisplayOrder}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'destinationDisplayOrder' + '}', encodeURIComponent(String(destinationDisplayOrder)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling moveMenuItem.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling moveMenuItem.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling moveMenuItem.');
        }
        if (destinationDisplayOrder === null || destinationDisplayOrder === undefined) {
            throw new Error('Required parameter destinationDisplayOrder was null or undefined when calling moveMenuItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.setSectionItemTax = function (menuId, menuSectionId, menuSectionItemId, taxRateId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/taxrate/{taxRateId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)))
            .replace('{' + 'taxRateId' + '}', encodeURIComponent(String(taxRateId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling setSectionItemTax.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling setSectionItemTax.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling setSectionItemTax.');
        }
        if (taxRateId === null || taxRateId === undefined) {
            throw new Error('Required parameter taxRateId was null or undefined when calling setSectionItemTax.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.updateMenuSectionItem = function (menuId, menuSectionId, menuSectionItemId, MenuSectionItemBase, undoAfter) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling updateMenuSectionItem.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling updateMenuSectionItem.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling updateMenuSectionItem.');
        }
        if (MenuSectionItemBase === null || MenuSectionItemBase === undefined) {
            throw new Error('Required parameter MenuSectionItemBase was null or undefined when calling updateMenuSectionItem.');
        }
        if (undoAfter !== undefined) {
            localVarQueryParameters['undoAfter'] = ObjectSerializer.serialize(undoAfter, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuSectionItemBase, "MenuSectionItemBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionItemsApi.prototype.uploadMenuSectionItemImage = function (menuId, menuSectionId, menuSectionItemId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'menuSectionItemId' + '}', encodeURIComponent(String(menuSectionItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling uploadMenuSectionItemImage.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling uploadMenuSectionItemImage.');
        }
        if (menuSectionItemId === null || menuSectionItemId === undefined) {
            throw new Error('Required parameter menuSectionItemId was null or undefined when calling uploadMenuSectionItemImage.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadMenuSectionItemImage.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return MenuSectionItemsApi;
}());
exports.MenuSectionItemsApi = MenuSectionItemsApi;
var MenuSectionsApiApiKeys;
(function (MenuSectionsApiApiKeys) {
})(MenuSectionsApiApiKeys = exports.MenuSectionsApiApiKeys || (exports.MenuSectionsApiApiKeys = {}));
var MenuSectionsApi = (function () {
    function MenuSectionsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(MenuSectionsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuSectionsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    MenuSectionsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    MenuSectionsApi.prototype.setApiKey = function (key, value) {
        this.authentications[MenuSectionsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(MenuSectionsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    MenuSectionsApi.prototype.cloneMenuSection = function (menuId, menuSectionId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/clone'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling cloneMenuSection.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling cloneMenuSection.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuSection");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.createMenuAvailabilityForDay = function (menuId, menuSectionId, dayOfWeek, BusinessHoursPeriodBase) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/availability/times/{dayOfWeek}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)))
            .replace('{' + 'dayOfWeek' + '}', encodeURIComponent(String(dayOfWeek)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling createMenuAvailabilityForDay.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling createMenuAvailabilityForDay.');
        }
        if (dayOfWeek === null || dayOfWeek === undefined) {
            throw new Error('Required parameter dayOfWeek was null or undefined when calling createMenuAvailabilityForDay.');
        }
        if (BusinessHoursPeriodBase === null || BusinessHoursPeriodBase === undefined) {
            throw new Error('Required parameter BusinessHoursPeriodBase was null or undefined when calling createMenuAvailabilityForDay.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(BusinessHoursPeriodBase, "BusinessHoursPeriodBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.createMenuSection = function (menuId, MenuSectionBase) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling createMenuSection.');
        }
        if (MenuSectionBase === null || MenuSectionBase === undefined) {
            throw new Error('Required parameter MenuSectionBase was null or undefined when calling createMenuSection.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuSectionBase, "MenuSectionBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.createMenuSectionAvailability = function (menuId, menuSectionId, MenuSectionAvailabilityBase) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/availability'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling createMenuSectionAvailability.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling createMenuSectionAvailability.');
        }
        if (MenuSectionAvailabilityBase === null || MenuSectionAvailabilityBase === undefined) {
            throw new Error('Required parameter MenuSectionAvailabilityBase was null or undefined when calling createMenuSectionAvailability.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuSectionAvailabilityBase, "MenuSectionAvailabilityBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.deleteMenuSection = function (menuId, menuSectionId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenuSection.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling deleteMenuSection.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.deleteMenuSectionImage = function (menuId, menuSectionId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenuSectionImage.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling deleteMenuSectionImage.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.getMenuSectionById = function (menuId, menuSectionId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuSectionById.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling getMenuSectionById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuSection");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.getMenuSections = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuSections.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuSection");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.menuSectionsSetItemDisplayOrders = function (menuId, menuSectionId, MenuObjectDisplayOrders) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitemdisplayorders'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling menuSectionsSetItemDisplayOrders.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling menuSectionsSetItemDisplayOrders.');
        }
        if (MenuObjectDisplayOrders === null || MenuObjectDisplayOrders === undefined) {
            throw new Error('Required parameter MenuObjectDisplayOrders was null or undefined when calling menuSectionsSetItemDisplayOrders.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuObjectDisplayOrders, "MenuObjectDisplayOrders")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.updateMenuSection = function (menuId, menuSectionId, MenuSectionBase, undoAfter) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling updateMenuSection.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling updateMenuSection.');
        }
        if (MenuSectionBase === null || MenuSectionBase === undefined) {
            throw new Error('Required parameter MenuSectionBase was null or undefined when calling updateMenuSection.');
        }
        if (undoAfter !== undefined) {
            localVarQueryParameters['undoAfter'] = ObjectSerializer.serialize(undoAfter, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuSectionBase, "MenuSectionBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenuSectionsApi.prototype.uploadMenuSectionImage = function (menuId, menuSectionId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sections/{menuSectionId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'menuSectionId' + '}', encodeURIComponent(String(menuSectionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling uploadMenuSectionImage.');
        }
        if (menuSectionId === null || menuSectionId === undefined) {
            throw new Error('Required parameter menuSectionId was null or undefined when calling uploadMenuSectionImage.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadMenuSectionImage.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return MenuSectionsApi;
}());
exports.MenuSectionsApi = MenuSectionsApi;
var MenusApiApiKeys;
(function (MenusApiApiKeys) {
})(MenusApiApiKeys = exports.MenusApiApiKeys || (exports.MenusApiApiKeys = {}));
var MenusApi = (function () {
    function MenusApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(MenusApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenusApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    MenusApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    MenusApi.prototype.setApiKey = function (key, value) {
        this.authentications[MenusApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(MenusApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    MenusApi.prototype.createDraftMenuFromExistingMenu = function (menuId, newName) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/clone/{newName}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'newName' + '}', encodeURIComponent(String(newName)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling createDraftMenuFromExistingMenu.');
        }
        if (newName === null || newName === undefined) {
            throw new Error('Required parameter newName was null or undefined when calling createDraftMenuFromExistingMenu.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenu");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.createNewMenuForApp = function (appId, CreateFullMenu) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/menus'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createNewMenuForApp.');
        }
        if (CreateFullMenu === null || CreateFullMenu === undefined) {
            throw new Error('Required parameter CreateFullMenu was null or undefined when calling createNewMenuForApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateFullMenu, "CreateFullMenu")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "number");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.deleteMenu = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenu.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.deleteMenuImage = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenuImage.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.deleteMenuItemMetadata = function (menuId, storeId, menuItemId, key) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/menuitem/{menuItemId}/metadata/{key}/store/{storeId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'menuItemId' + '}', encodeURIComponent(String(menuItemId)))
            .replace('{' + 'key' + '}', encodeURIComponent(String(key)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenuItemMetadata.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling deleteMenuItemMetadata.');
        }
        if (menuItemId === null || menuItemId === undefined) {
            throw new Error('Required parameter menuItemId was null or undefined when calling deleteMenuItemMetadata.');
        }
        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling deleteMenuItemMetadata.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getAllMenuMetadataByMenuIdAndStoreId = function (menuId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/metadata/store/{storeId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getAllMenuMetadataByMenuIdAndStoreId.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getAllMenuMetadataByMenuIdAndStoreId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultAllMetadataResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenuById = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenu");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenuItemMetadata = function (menuId, storeId, menuItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/menuitem/{menuItemId}/metadata/store/{storeId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'menuItemId' + '}', encodeURIComponent(String(menuItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItemMetadata.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getMenuItemMetadata.');
        }
        if (menuItemId === null || menuItemId === undefined) {
            throw new Error('Required parameter menuItemId was null or undefined when calling getMenuItemMetadata.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMetadata");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenuItemMetadataByKey = function (menuId, storeId, menuItemId, key) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/menuitem/{menuItemId}/metadata/{key}/store/{storeId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'menuItemId' + '}', encodeURIComponent(String(menuItemId)))
            .replace('{' + 'key' + '}', encodeURIComponent(String(key)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItemMetadataByKey.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getMenuItemMetadataByKey.');
        }
        if (menuItemId === null || menuItemId === undefined) {
            throw new Error('Required parameter menuItemId was null or undefined when calling getMenuItemMetadataByKey.');
        }
        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getMenuItemMetadataByKey.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenuItemOptionSetItemMetadata = function (menuId, storeId, optionSetItemId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/optionsetitem/{optionSetItemId}/metadata/store/{storeId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'optionSetItemId' + '}', encodeURIComponent(String(optionSetItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuItemOptionSetItemMetadata.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getMenuItemOptionSetItemMetadata.');
        }
        if (optionSetItemId === null || optionSetItemId === undefined) {
            throw new Error('Required parameter optionSetItemId was null or undefined when calling getMenuItemOptionSetItemMetadata.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMetadata");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenuName = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/name'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuName.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenuStoreNames = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/stores'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuStoreNames.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuStoreNames");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenuTaxDetails = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/tax'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuTaxDetails.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuTaxDetails");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenusByAppId = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/menus'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getMenusByAppId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.getMenusCheckpoints = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/checkpoints'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenusCheckpoints.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuCheckpoint");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.menusDeleteTaxRate = function (menuId, taxId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/tax/{taxId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'taxId' + '}', encodeURIComponent(String(taxId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling menusDeleteTaxRate.');
        }
        if (taxId === null || taxId === undefined) {
            throw new Error('Required parameter taxId was null or undefined when calling menusDeleteTaxRate.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.menusGetMenuBulkShowHide = function (menuId, isAvailable) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/bulkshowhide/list'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling menusGetMenuBulkShowHide.');
        }
        if (isAvailable === null || isAvailable === undefined) {
            throw new Error('Required parameter isAvailable was null or undefined when calling menusGetMenuBulkShowHide.');
        }
        if (isAvailable !== undefined) {
            localVarQueryParameters['isAvailable'] = ObjectSerializer.serialize(isAvailable, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuElementListResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.menusSetDisplayOnMenuTax = function (menuId, show) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/tax/show/{show}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'show' + '}', encodeURIComponent(String(show)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling menusSetDisplayOnMenuTax.');
        }
        if (show === null || show === undefined) {
            throw new Error('Required parameter show was null or undefined when calling menusSetDisplayOnMenuTax.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.menusSetItemDisplayOrders = function (menuId, MenuObjectDisplayOrders) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/sectiondisplayorders'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling menusSetItemDisplayOrders.');
        }
        if (MenuObjectDisplayOrders === null || MenuObjectDisplayOrders === undefined) {
            throw new Error('Required parameter MenuObjectDisplayOrders was null or undefined when calling menusSetItemDisplayOrders.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuObjectDisplayOrders, "MenuObjectDisplayOrders")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.menusShowHideBulkItems = function (menuId, isAvailable, MenuElementHide) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/bulkshowhide'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling menusShowHideBulkItems.');
        }
        if (isAvailable === null || isAvailable === undefined) {
            throw new Error('Required parameter isAvailable was null or undefined when calling menusShowHideBulkItems.');
        }
        if (MenuElementHide === null || MenuElementHide === undefined) {
            throw new Error('Required parameter MenuElementHide was null or undefined when calling menusShowHideBulkItems.');
        }
        if (isAvailable !== undefined) {
            localVarQueryParameters['isAvailable'] = ObjectSerializer.serialize(isAvailable, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuElementHide, "Array<MenuElementHide>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMenuElementEditResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.menusUpdateTaxType = function (menuId, type) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/tax/type/{type}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'type' + '}', encodeURIComponent(String(type)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling menusUpdateTaxType.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling menusUpdateTaxType.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.menusUpsertTaxRate = function (menuId, MenuTaxRate) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/taxrate'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling menusUpsertTaxRate.');
        }
        if (MenuTaxRate === null || MenuTaxRate === undefined) {
            throw new Error('Required parameter MenuTaxRate was null or undefined when calling menusUpsertTaxRate.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuTaxRate, "MenuTaxRate")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "MenuTaxRate");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.restoreAMenuCheckpoint = function (menuId, checkpointId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/checkpoints/{checkpointId}/restore'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'checkpointId' + '}', encodeURIComponent(String(checkpointId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling restoreAMenuCheckpoint.');
        }
        if (checkpointId === null || checkpointId === undefined) {
            throw new Error('Required parameter checkpointId was null or undefined when calling restoreAMenuCheckpoint.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.setMenuItemMetadata = function (menuId, storeId, menuItemId, Metadata) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/menuitem/{menuItemId}/metadata/store/{storeId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'menuItemId' + '}', encodeURIComponent(String(menuItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling setMenuItemMetadata.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling setMenuItemMetadata.');
        }
        if (menuItemId === null || menuItemId === undefined) {
            throw new Error('Required parameter menuItemId was null or undefined when calling setMenuItemMetadata.');
        }
        if (Metadata === null || Metadata === undefined) {
            throw new Error('Required parameter Metadata was null or undefined when calling setMenuItemMetadata.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(Metadata, "Metadata")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.setMenuItemOptionSetItemMetadata = function (menuId, storeId, optionSetItemId, Metadata) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/optionsetitem/{optionSetItemId}/metadata/store/{storeId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'optionSetItemId' + '}', encodeURIComponent(String(optionSetItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling setMenuItemOptionSetItemMetadata.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling setMenuItemOptionSetItemMetadata.');
        }
        if (optionSetItemId === null || optionSetItemId === undefined) {
            throw new Error('Required parameter optionSetItemId was null or undefined when calling setMenuItemOptionSetItemMetadata.');
        }
        if (Metadata === null || Metadata === undefined) {
            throw new Error('Required parameter Metadata was null or undefined when calling setMenuItemOptionSetItemMetadata.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(Metadata, "Metadata")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.setMenuLock = function (menuId, body) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/lock'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling setMenuLock.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setMenuLock.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "boolean")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.setMenuName = function (menuId, body) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/name'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling setMenuName.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setMenuName.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "string")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.updateMenu = function (menuId, MenuBase) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling updateMenu.');
        }
        if (MenuBase === null || MenuBase === undefined) {
            throw new Error('Required parameter MenuBase was null or undefined when calling updateMenu.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MenuBase, "MenuBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.uploadMenuImage = function (menuId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/image'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling uploadMenuImage.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadMenuImage.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusApi.prototype.uploadNewMenuForApp = function (appId, Menu) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/menus/xlsx'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling uploadNewMenuForApp.');
        }
        if (Menu === null || Menu === undefined) {
            throw new Error('Required parameter Menu was null or undefined when calling uploadNewMenuForApp.');
        }
        var localVarUseFormData = false;
        if (Menu !== undefined) {
            localVarFormParams['Menu'] = Menu;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "number");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return MenusApi;
}());
exports.MenusApi = MenusApi;
var MenusNutritionInfoApiApiKeys;
(function (MenusNutritionInfoApiApiKeys) {
})(MenusNutritionInfoApiApiKeys = exports.MenusNutritionInfoApiApiKeys || (exports.MenusNutritionInfoApiApiKeys = {}));
var MenusNutritionInfoApi = (function () {
    function MenusNutritionInfoApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(MenusNutritionInfoApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenusNutritionInfoApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    MenusNutritionInfoApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    MenusNutritionInfoApi.prototype.setApiKey = function (key, value) {
        this.authentications[MenusNutritionInfoApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(MenusNutritionInfoApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    MenusNutritionInfoApi.prototype.addOrUpdateMenuItemNutritionInfo = function (menuId, publicId, ItemNutritionInfoAddUpdateModel) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/menuItem/{publicId}/nutrition'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'publicId' + '}', encodeURIComponent(String(publicId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling addOrUpdateMenuItemNutritionInfo.');
        }
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling addOrUpdateMenuItemNutritionInfo.');
        }
        if (ItemNutritionInfoAddUpdateModel === null || ItemNutritionInfoAddUpdateModel === undefined) {
            throw new Error('Required parameter ItemNutritionInfoAddUpdateModel was null or undefined when calling addOrUpdateMenuItemNutritionInfo.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ItemNutritionInfoAddUpdateModel, "ItemNutritionInfoAddUpdateModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuNutritionInfoHeader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusNutritionInfoApi.prototype.addOrUpdateMenuItemOptionSetItemNutritionInfo = function (menuId, publicId, ItemNutritionInfoAddUpdateModel) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/menuItemOption/{publicId}/nutrition'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)))
            .replace('{' + 'publicId' + '}', encodeURIComponent(String(publicId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfo.');
        }
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfo.');
        }
        if (ItemNutritionInfoAddUpdateModel === null || ItemNutritionInfoAddUpdateModel === undefined) {
            throw new Error('Required parameter ItemNutritionInfoAddUpdateModel was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfo.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ItemNutritionInfoAddUpdateModel, "ItemNutritionInfoAddUpdateModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuNutritionInfoHeader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusNutritionInfoApi.prototype.addOrUpdateMenuNutritionInfoByMenuId = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/nutrition'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling addOrUpdateMenuNutritionInfoByMenuId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMenuNutritionInfoHeader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusNutritionInfoApi.prototype.deleteMenuNutritionInfoByMenuId = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/nutrition'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling deleteMenuNutritionInfoByMenuId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusNutritionInfoApi.prototype.getAllergens = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/menus/nutrition/allergens'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAllergens.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultAllergen");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MenusNutritionInfoApi.prototype.getMenuNutritionInfoByMenuId = function (menuId) {
        var localVarPath = this.basePath + '/api/v1.0/menus/{menuId}/nutrition'
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getMenuNutritionInfoByMenuId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultNutritionInfo");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return MenusNutritionInfoApi;
}());
exports.MenusNutritionInfoApi = MenusNutritionInfoApi;
var MetafieldDefinitionsApiApiKeys;
(function (MetafieldDefinitionsApiApiKeys) {
})(MetafieldDefinitionsApiApiKeys = exports.MetafieldDefinitionsApiApiKeys || (exports.MetafieldDefinitionsApiApiKeys = {}));
var MetafieldDefinitionsApi = (function () {
    function MetafieldDefinitionsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(MetafieldDefinitionsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MetafieldDefinitionsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    MetafieldDefinitionsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    MetafieldDefinitionsApi.prototype.setApiKey = function (key, value) {
        this.authentications[MetafieldDefinitionsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(MetafieldDefinitionsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    MetafieldDefinitionsApi.prototype.createMetafieldDefinition = function (appId, ownerEntity, CreateMetafieldDefinition) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/metafields/definitions/{ownerEntity}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'ownerEntity' + '}', encodeURIComponent(String(ownerEntity)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createMetafieldDefinition.');
        }
        if (ownerEntity === null || ownerEntity === undefined) {
            throw new Error('Required parameter ownerEntity was null or undefined when calling createMetafieldDefinition.');
        }
        if (CreateMetafieldDefinition === null || CreateMetafieldDefinition === undefined) {
            throw new Error('Required parameter CreateMetafieldDefinition was null or undefined when calling createMetafieldDefinition.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateMetafieldDefinition, "CreateMetafieldDefinition")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMetafieldDefinition");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MetafieldDefinitionsApi.prototype.getMetafieldDefinitionByKey = function (appId, ownerEntity, key) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/metafields/definitions/{ownerEntity}/{key}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'ownerEntity' + '}', encodeURIComponent(String(ownerEntity)))
            .replace('{' + 'key' + '}', encodeURIComponent(String(key)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getMetafieldDefinitionByKey.');
        }
        if (ownerEntity === null || ownerEntity === undefined) {
            throw new Error('Required parameter ownerEntity was null or undefined when calling getMetafieldDefinitionByKey.');
        }
        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getMetafieldDefinitionByKey.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMetafieldDefinition");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MetafieldDefinitionsApi.prototype.getMetafieldDefinitions = function (appId, ownerEntity, searchTerm, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/metafields/definitions/{ownerEntity}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'ownerEntity' + '}', encodeURIComponent(String(ownerEntity)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getMetafieldDefinitions.');
        }
        if (ownerEntity === null || ownerEntity === undefined) {
            throw new Error('Required parameter ownerEntity was null or undefined when calling getMetafieldDefinitions.');
        }
        if (searchTerm !== undefined) {
            localVarQueryParameters['searchTerm'] = ObjectSerializer.serialize(searchTerm, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultMetafieldDefinition");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MetafieldDefinitionsApi.prototype.getOwnerEntityConfigurations = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/metafields/definitions'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOwnerEntityConfigurations.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "OwnerEntityConfigurations");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MetafieldDefinitionsApi.prototype.getOwnerEntityRecommendations = function (appId, ownerEntity, searchTerm, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/metafields/definitions/recommendations/{ownerEntity}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'ownerEntity' + '}', encodeURIComponent(String(ownerEntity)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOwnerEntityRecommendations.');
        }
        if (ownerEntity === null || ownerEntity === undefined) {
            throw new Error('Required parameter ownerEntity was null or undefined when calling getOwnerEntityRecommendations.');
        }
        if (searchTerm !== undefined) {
            localVarQueryParameters['searchTerm'] = ObjectSerializer.serialize(searchTerm, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultMetafieldDefinitionRecommendation");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MetafieldDefinitionsApi.prototype.updateMetafieldDefinition = function (appId, ownerEntity, key, UpdateMetafieldDefinition) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/metafields/definitions/{ownerEntity}/{key}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'ownerEntity' + '}', encodeURIComponent(String(ownerEntity)))
            .replace('{' + 'key' + '}', encodeURIComponent(String(key)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateMetafieldDefinition.');
        }
        if (ownerEntity === null || ownerEntity === undefined) {
            throw new Error('Required parameter ownerEntity was null or undefined when calling updateMetafieldDefinition.');
        }
        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling updateMetafieldDefinition.');
        }
        if (UpdateMetafieldDefinition === null || UpdateMetafieldDefinition === undefined) {
            throw new Error('Required parameter UpdateMetafieldDefinition was null or undefined when calling updateMetafieldDefinition.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateMetafieldDefinition, "UpdateMetafieldDefinition")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMetafieldDefinition");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return MetafieldDefinitionsApi;
}());
exports.MetafieldDefinitionsApi = MetafieldDefinitionsApi;
var MobileAppsApiApiKeys;
(function (MobileAppsApiApiKeys) {
})(MobileAppsApiApiKeys = exports.MobileAppsApiApiKeys || (exports.MobileAppsApiApiKeys = {}));
var MobileAppsApi = (function () {
    function MobileAppsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(MobileAppsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileAppsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    MobileAppsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    MobileAppsApi.prototype.setApiKey = function (key, value) {
        this.authentications[MobileAppsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(MobileAppsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    MobileAppsApi.prototype.getAppConfigSalesChannel = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/saleschannel/details'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAppConfigSalesChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAppConfigSalesChannel");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.getStatistics = function (appId, platformTypes) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/statistics'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStatistics.');
        }
        if (platformTypes === null || platformTypes === undefined) {
            throw new Error('Required parameter platformTypes was null or undefined when calling getStatistics.');
        }
        if (platformTypes !== undefined) {
            localVarQueryParameters['platformTypes'] = ObjectSerializer.serialize(platformTypes, "Array<'None' | 'Android' | 'IOS'>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultMobileAppsStatistics");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.getSubmissionDetails = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/submission/details'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getSubmissionDetails.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMobileAppsSubmissionDetails");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.getSubmissionStatus = function (appId, submissionId) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/submission/{submissionId}/status'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'submissionId' + '}', encodeURIComponent(String(submissionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getSubmissionStatus.');
        }
        if (submissionId === null || submissionId === undefined) {
            throw new Error('Required parameter submissionId was null or undefined when calling getSubmissionStatus.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMobileAppsSubmissionStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.publish = function (appId, submissionId, platformType) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/submission/{submissionId}/publish'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'submissionId' + '}', encodeURIComponent(String(submissionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling publish.');
        }
        if (submissionId === null || submissionId === undefined) {
            throw new Error('Required parameter submissionId was null or undefined when calling publish.');
        }
        if (platformType !== undefined) {
            localVarQueryParameters['platformType'] = ObjectSerializer.serialize(platformType, "'None' | 'Android' | 'IOS'");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRestApiIntegerResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.resubmission = function (appId, MobileAppsSubmission) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/resubmission'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling resubmission.');
        }
        if (MobileAppsSubmission === null || MobileAppsSubmission === undefined) {
            throw new Error('Required parameter MobileAppsSubmission was null or undefined when calling resubmission.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MobileAppsSubmission, "MobileAppsSubmission")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMobileAppsSubmission");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.submission = function (appId, MobileAppsSubmission) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/submission'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling submission.');
        }
        if (MobileAppsSubmission === null || MobileAppsSubmission === undefined) {
            throw new Error('Required parameter MobileAppsSubmission was null or undefined when calling submission.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(MobileAppsSubmission, "MobileAppsSubmission")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMobileAppsSubmission");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.unpublish = function (appId, submissionId, platformType) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/submission/{submissionId}/unpublish'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'submissionId' + '}', encodeURIComponent(String(submissionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling unpublish.');
        }
        if (submissionId === null || submissionId === undefined) {
            throw new Error('Required parameter submissionId was null or undefined when calling unpublish.');
        }
        if (platformType !== undefined) {
            localVarQueryParameters['platformType'] = ObjectSerializer.serialize(platformType, "'None' | 'Android' | 'IOS'");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiIntegerResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.updateAppConfigSalesChannel = function (appId, AppConfigSalesChannel) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/saleschannel'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateAppConfigSalesChannel.');
        }
        if (AppConfigSalesChannel === null || AppConfigSalesChannel === undefined) {
            throw new Error('Required parameter AppConfigSalesChannel was null or undefined when calling updateAppConfigSalesChannel.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(AppConfigSalesChannel, "AppConfigSalesChannel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAppConfigSalesChannel");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.updateSubmissionStatus = function (appId, submissionId, UpdateMobileAppsSubmissionStatus) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/submission/{submissionId}/status'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'submissionId' + '}', encodeURIComponent(String(submissionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateSubmissionStatus.');
        }
        if (submissionId === null || submissionId === undefined) {
            throw new Error('Required parameter submissionId was null or undefined when calling updateSubmissionStatus.');
        }
        if (UpdateMobileAppsSubmissionStatus === null || UpdateMobileAppsSubmissionStatus === undefined) {
            throw new Error('Required parameter UpdateMobileAppsSubmissionStatus was null or undefined when calling updateSubmissionStatus.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateMobileAppsSubmissionStatus, "UpdateMobileAppsSubmissionStatus")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultUpdateMobileAppsSubmissionStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    MobileAppsApi.prototype.uploadImage = function (appId, Image) {
        var localVarPath = this.basePath + '/api/v1.0/mobileapps/{appId}/submission/image'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling uploadImage.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadImage.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultMobileAppsImage");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return MobileAppsApi;
}());
exports.MobileAppsApi = MobileAppsApi;
var OAuthClientsApiApiKeys;
(function (OAuthClientsApiApiKeys) {
})(OAuthClientsApiApiKeys = exports.OAuthClientsApiApiKeys || (exports.OAuthClientsApiApiKeys = {}));
var OAuthClientsApi = (function () {
    function OAuthClientsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(OAuthClientsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OAuthClientsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    OAuthClientsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    OAuthClientsApi.prototype.setApiKey = function (key, value) {
        this.authentications[OAuthClientsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(OAuthClientsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    OAuthClientsApi.prototype.addRedirectUri = function (oauthAppId, appId, body) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/{oauthAppId}/redirecturis'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling addRedirectUri.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling addRedirectUri.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addRedirectUri.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "string")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOauthClientRedirectUri");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.createOAuthApp = function (appId, OAuthApp) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createOAuthApp.');
        }
        if (OAuthApp === null || OAuthApp === undefined) {
            throw new Error('Required parameter OAuthApp was null or undefined when calling createOAuthApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(OAuthApp, "OAuthApp")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.deleteOAuthApp = function (oauthAppId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/{oauthAppId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling deleteOAuthApp.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteOAuthApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.getOAuthApps = function (appId, oauthAppName) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOAuthApps.');
        }
        if (oauthAppName !== undefined) {
            localVarQueryParameters['oauthAppName'] = ObjectSerializer.serialize(oauthAppName, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultOAuthApp");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.getOAuthClientByClientId = function (oauthAppId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/{oauthAppId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getOAuthClientByClientId.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOAuthClientByClientId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOAuthApp");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.getOAuthClientSecret = function (oauthAppId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/{oauthAppId}/secret'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getOAuthClientSecret.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOAuthClientSecret.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.getOauthAccessToken = function (oauthAppId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/{oauthAppId}/accesstoken'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getOauthAccessToken.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOauthAccessToken.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.getRedirectUris = function (oauthAppId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/{oauthAppId}/redirecturis'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getRedirectUris.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getRedirectUris.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultOauthClientRedirectUri");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.oAuthClientsGetApplications = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/appnames'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling oAuthClientsGetApplications.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.removeRedirectUri = function (oauthAppId, uriId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/{oauthAppId}/redirecturis/{uriId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'uriId' + '}', encodeURIComponent(String(uriId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling removeRedirectUri.');
        }
        if (uriId === null || uriId === undefined) {
            throw new Error('Required parameter uriId was null or undefined when calling removeRedirectUri.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling removeRedirectUri.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OAuthClientsApi.prototype.updateOAuthApp = function (oauthAppId, appId, OAuthApp) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/oauthclients/{oauthAppId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling updateOAuthApp.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateOAuthApp.');
        }
        if (OAuthApp === null || OAuthApp === undefined) {
            throw new Error('Required parameter OAuthApp was null or undefined when calling updateOAuthApp.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(OAuthApp, "OAuthApp")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return OAuthClientsApi;
}());
exports.OAuthClientsApi = OAuthClientsApi;
var OnboardingApiApiKeys;
(function (OnboardingApiApiKeys) {
})(OnboardingApiApiKeys = exports.OnboardingApiApiKeys || (exports.OnboardingApiApiKeys = {}));
var OnboardingApi = (function () {
    function OnboardingApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(OnboardingApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OnboardingApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    OnboardingApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    OnboardingApi.prototype.setApiKey = function (key, value) {
        this.authentications[OnboardingApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(OnboardingApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    OnboardingApi.prototype.onboardingGetOnboardingConfig = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/clients/{appId}/onboarding/config'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling onboardingGetOnboardingConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OnboardingApi.prototype.onboardingGetOnboardingItems = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/clients/{appId}/onboarding/stores/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling onboardingGetOnboardingItems.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling onboardingGetOnboardingItems.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OnboardingApi.prototype.onboardingUpdateOnboardingConfig = function (appId, OnboardingConfigUpdate) {
        var localVarPath = this.basePath + '/api/v1.0/clients/{appId}/onboarding/config'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling onboardingUpdateOnboardingConfig.');
        }
        if (OnboardingConfigUpdate === null || OnboardingConfigUpdate === undefined) {
            throw new Error('Required parameter OnboardingConfigUpdate was null or undefined when calling onboardingUpdateOnboardingConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(OnboardingConfigUpdate, "OnboardingConfigUpdate")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OnboardingApi.prototype.onboardingUpdateOnboardingItem = function (appId, storeId, onboardingItemId, OnboardingItemUpdate) {
        var localVarPath = this.basePath + '/api/v1.0/clients/{appId}/onboarding/stores/{storeId}/items/{onboardingItemId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'onboardingItemId' + '}', encodeURIComponent(String(onboardingItemId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling onboardingUpdateOnboardingItem.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling onboardingUpdateOnboardingItem.');
        }
        if (onboardingItemId === null || onboardingItemId === undefined) {
            throw new Error('Required parameter onboardingItemId was null or undefined when calling onboardingUpdateOnboardingItem.');
        }
        if (OnboardingItemUpdate === null || OnboardingItemUpdate === undefined) {
            throw new Error('Required parameter OnboardingItemUpdate was null or undefined when calling onboardingUpdateOnboardingItem.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(OnboardingItemUpdate, "OnboardingItemUpdate")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return OnboardingApi;
}());
exports.OnboardingApi = OnboardingApi;
var OrderBatchesApiApiKeys;
(function (OrderBatchesApiApiKeys) {
})(OrderBatchesApiApiKeys = exports.OrderBatchesApiApiKeys || (exports.OrderBatchesApiApiKeys = {}));
var OrderBatchesApi = (function () {
    function OrderBatchesApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(OrderBatchesApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderBatchesApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    OrderBatchesApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    OrderBatchesApi.prototype.setApiKey = function (key, value) {
        this.authentications[OrderBatchesApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(OrderBatchesApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    OrderBatchesApi.prototype.getAllOrderBatches = function (appId, storeIds, createdFrom, createdTo) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/order-batches'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getAllOrderBatches.');
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        if (createdFrom !== undefined) {
            localVarQueryParameters['createdFrom'] = ObjectSerializer.serialize(createdFrom, "Date");
        }
        if (createdTo !== undefined) {
            localVarQueryParameters['createdTo'] = ObjectSerializer.serialize(createdTo, "Date");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultOrderBatch");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrderBatchesApi.prototype.getOrderBatch = function (appId, orderBatchId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/order-batches/{orderBatchId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'orderBatchId' + '}', encodeURIComponent(String(orderBatchId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOrderBatch.');
        }
        if (orderBatchId === null || orderBatchId === undefined) {
            throw new Error('Required parameter orderBatchId was null or undefined when calling getOrderBatch.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOrderBatch");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return OrderBatchesApi;
}());
exports.OrderBatchesApi = OrderBatchesApi;
var OrderBatchingConfigurationApiApiKeys;
(function (OrderBatchingConfigurationApiApiKeys) {
})(OrderBatchingConfigurationApiApiKeys = exports.OrderBatchingConfigurationApiApiKeys || (exports.OrderBatchingConfigurationApiApiKeys = {}));
var OrderBatchingConfigurationApi = (function () {
    function OrderBatchingConfigurationApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(OrderBatchingConfigurationApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderBatchingConfigurationApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    OrderBatchingConfigurationApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    OrderBatchingConfigurationApi.prototype.setApiKey = function (key, value) {
        this.authentications[OrderBatchingConfigurationApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(OrderBatchingConfigurationApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    OrderBatchingConfigurationApi.prototype.get = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/order-batching-configuration'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling get.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOrderBatchingConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrderBatchingConfigurationApi.prototype.post = function (storeId, SetOrderBatchingConfiguration) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/order-batching-configuration'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling post.');
        }
        if (SetOrderBatchingConfiguration === null || SetOrderBatchingConfiguration === undefined) {
            throw new Error('Required parameter SetOrderBatchingConfiguration was null or undefined when calling post.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(SetOrderBatchingConfiguration, "SetOrderBatchingConfiguration")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return OrderBatchingConfigurationApi;
}());
exports.OrderBatchingConfigurationApi = OrderBatchingConfigurationApi;
var OrderIngestApiApiKeys;
(function (OrderIngestApiApiKeys) {
})(OrderIngestApiApiKeys = exports.OrderIngestApiApiKeys || (exports.OrderIngestApiApiKeys = {}));
var OrderIngestApi = (function () {
    function OrderIngestApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(OrderIngestApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderIngestApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    OrderIngestApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    OrderIngestApi.prototype.setApiKey = function (key, value) {
        this.authentications[OrderIngestApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(OrderIngestApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    OrderIngestApi.prototype.orderIngestSubmitNewOrder = function (appNameId, OrderIngestSubmitOrderRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appNameId}/order-ingest/submit'
            .replace('{' + 'appNameId' + '}', encodeURIComponent(String(appNameId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appNameId === null || appNameId === undefined) {
            throw new Error('Required parameter appNameId was null or undefined when calling orderIngestSubmitNewOrder.');
        }
        if (OrderIngestSubmitOrderRequest === null || OrderIngestSubmitOrderRequest === undefined) {
            throw new Error('Required parameter OrderIngestSubmitOrderRequest was null or undefined when calling orderIngestSubmitNewOrder.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(OrderIngestSubmitOrderRequest, "OrderIngestSubmitOrderRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOrderIngestSubmitOrderResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return OrderIngestApi;
}());
exports.OrderIngestApi = OrderIngestApi;
var OrdersApiApiKeys;
(function (OrdersApiApiKeys) {
})(OrdersApiApiKeys = exports.OrdersApiApiKeys || (exports.OrdersApiApiKeys = {}));
var OrdersApi = (function () {
    function OrdersApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(OrdersApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrdersApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    OrdersApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    OrdersApi.prototype.setApiKey = function (key, value) {
        this.authentications[OrdersApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(OrdersApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    OrdersApi.prototype.acceptOrder = function (id, Accept) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{id}/accept'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling acceptOrder.');
        }
        if (Accept === null || Accept === undefined) {
            throw new Error('Required parameter Accept was null or undefined when calling acceptOrder.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(Accept, "Accept")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.dispatchOrder = function (id) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{id}/dispatch'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling dispatchOrder.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.getDeliveryInformation = function (orderId) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{orderId}/deliveryinfo'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling getDeliveryInformation.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOrderDeliveryInformation");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.getFulfillmentState = function (orderId) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{orderId}/fulfillment/state'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling getFulfillmentState.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOrderFulfillmentStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.getFulfillmentStatusWithDetailsAndActions = function (orderId) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{orderId}/fulfillment/state/details'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling getFulfillmentStatusWithDetailsAndActions.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOrderFulfillmentStatusWithConfigurationActions");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.getOrderById = function (id) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrderById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOrder");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.getOrders = function (physicalRestaurantId, state, from, to, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/orders';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (physicalRestaurantId !== undefined) {
            localVarQueryParameters['physicalRestaurantId'] = ObjectSerializer.serialize(physicalRestaurantId, "Array<number>");
        }
        if (state !== undefined) {
            localVarQueryParameters['state'] = ObjectSerializer.serialize(state, "Array<'Created' | 'PlacedCanBeCancelled' | 'ReadyToProcess' | 'AcceptedByRestaurant' | 'Dispatched' | 'Delivered' | 'Cancelled' | 'ManualReview' | 'RejectedByStore' | 'RejectedByFlipdish' | 'RejectedAutomatically' | 'RejectedAfterBeingAccepted' | 'AcceptedAndRefunded'>");
        }
        if (from !== undefined) {
            localVarQueryParameters['from'] = ObjectSerializer.serialize(from, "Date");
        }
        if (to !== undefined) {
            localVarQueryParameters['to'] = ObjectSerializer.serialize(to, "Date");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultOrder");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.getOrdersSummary = function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/orders/summaries'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOrdersSummary.');
        }
        if (searchQuery !== undefined) {
            localVarQueryParameters['searchQuery'] = ObjectSerializer.serialize(searchQuery, "string");
        }
        if (physicalRestaurantId !== undefined) {
            localVarQueryParameters['physicalRestaurantId'] = ObjectSerializer.serialize(physicalRestaurantId, "Array<number>");
        }
        if (state !== undefined) {
            localVarQueryParameters['state'] = ObjectSerializer.serialize(state, "Array<'Created' | 'PlacedCanBeCancelled' | 'ReadyToProcess' | 'AcceptedByRestaurant' | 'Dispatched' | 'Delivered' | 'Cancelled' | 'ManualReview' | 'RejectedByStore' | 'RejectedByFlipdish' | 'RejectedAutomatically' | 'RejectedAfterBeingAccepted' | 'AcceptedAndRefunded'>");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (orderByRequestedForTime !== undefined) {
            localVarQueryParameters['orderByRequestedForTime'] = ObjectSerializer.serialize(orderByRequestedForTime, "boolean");
        }
        if (channels !== undefined) {
            localVarQueryParameters['channels'] = ObjectSerializer.serialize(channels, "Array<'Unknown' | 'Ios' | 'Android' | 'Web' | 'Kiosk' | 'Pos' | 'TelephoneCall' | 'Sms' | 'PwaAndroid' | 'PwaIos' | 'Google'>");
        }
        if (orderIds !== undefined) {
            localVarQueryParameters['orderIds'] = ObjectSerializer.serialize(orderIds, "Array<number>");
        }
        if (from !== undefined) {
            localVarQueryParameters['from'] = ObjectSerializer.serialize(from, "Date");
        }
        if (to !== undefined) {
            localVarQueryParameters['to'] = ObjectSerializer.serialize(to, "Date");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultOrderSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.getReadyToProcess = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/orders/ready_to_process'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getReadyToProcess.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "OrderList");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.refundOrder = function (id, Refund) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{id}/refund'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling refundOrder.');
        }
        if (Refund === null || Refund === undefined) {
            throw new Error('Required parameter Refund was null or undefined when calling refundOrder.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(Refund, "Refund")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.rejectOrder = function (id, Reject) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{id}/reject'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling rejectOrder.');
        }
        if (Reject === null || Reject === undefined) {
            throw new Error('Required parameter Reject was null or undefined when calling rejectOrder.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(Reject, "Reject")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.searchFulfillmentStatuses = function (appId, orderIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/orders/fulfillmentstatuses'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling searchFulfillmentStatuses.');
        }
        if (orderIds === null || orderIds === undefined) {
            throw new Error('Required parameter orderIds was null or undefined when calling searchFulfillmentStatuses.');
        }
        if (orderIds !== undefined) {
            localVarQueryParameters['orderIds'] = ObjectSerializer.serialize(orderIds, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultOrderFulfillmentStatus");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.updateDeliveryInformation = function (orderId, OrderDeliveryInformationBase) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{orderId}/deliveryinfo'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling updateDeliveryInformation.');
        }
        if (OrderDeliveryInformationBase === null || OrderDeliveryInformationBase === undefined) {
            throw new Error('Required parameter OrderDeliveryInformationBase was null or undefined when calling updateDeliveryInformation.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(OrderDeliveryInformationBase, "OrderDeliveryInformationBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    OrdersApi.prototype.updateFulfillmentState = function (orderId, OrderFulfillmentStatusUpdate) {
        var localVarPath = this.basePath + '/api/v1.0/orders/{orderId}/fulfillment/state'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling updateFulfillmentState.');
        }
        if (OrderFulfillmentStatusUpdate === null || OrderFulfillmentStatusUpdate === undefined) {
            throw new Error('Required parameter OrderFulfillmentStatusUpdate was null or undefined when calling updateFulfillmentState.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(OrderFulfillmentStatusUpdate, "OrderFulfillmentStatusUpdate")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return OrdersApi;
}());
exports.OrdersApi = OrdersApi;
var PaymentIntentsApiApiKeys;
(function (PaymentIntentsApiApiKeys) {
})(PaymentIntentsApiApiKeys = exports.PaymentIntentsApiApiKeys || (exports.PaymentIntentsApiApiKeys = {}));
var PaymentIntentsApi = (function () {
    function PaymentIntentsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(PaymentIntentsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentIntentsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    PaymentIntentsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    PaymentIntentsApi.prototype.setApiKey = function (key, value) {
        this.authentications[PaymentIntentsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(PaymentIntentsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    PaymentIntentsApi.prototype.getPaymentIntent = function (paymentIntentId) {
        var localVarPath = this.basePath + '/api/v1.0/payment_intents/{paymentIntentId}'
            .replace('{' + 'paymentIntentId' + '}', encodeURIComponent(String(paymentIntentId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (paymentIntentId === null || paymentIntentId === undefined) {
            throw new Error('Required parameter paymentIntentId was null or undefined when calling getPaymentIntent.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultPaymentIntent");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return PaymentIntentsApi;
}());
exports.PaymentIntentsApi = PaymentIntentsApi;
var PaymentsApiApiKeys;
(function (PaymentsApiApiKeys) {
})(PaymentsApiApiKeys = exports.PaymentsApiApiKeys || (exports.PaymentsApiApiKeys = {}));
var PaymentsApi = (function () {
    function PaymentsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(PaymentsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    PaymentsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    PaymentsApi.prototype.setApiKey = function (key, value) {
        this.authentications[PaymentsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(PaymentsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    PaymentsApi.prototype.getOrderPaymentInformation = function (orderId) {
        var localVarPath = this.basePath + '/api/v1.0/payments/payment/{orderId}/refundable'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling getOrderPaymentInformation.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultOrderPaymentInformation");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return PaymentsApi;
}());
exports.PaymentsApi = PaymentsApi;
var PayoutsApiApiKeys;
(function (PayoutsApiApiKeys) {
})(PayoutsApiApiKeys = exports.PayoutsApiApiKeys || (exports.PayoutsApiApiKeys = {}));
var PayoutsApi = (function () {
    function PayoutsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(PayoutsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PayoutsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    PayoutsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    PayoutsApi.prototype.setApiKey = function (key, value) {
        this.authentications[PayoutsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(PayoutsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    PayoutsApi.prototype.getPayout = function (appId, bankAccountId, payoutId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPayout.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling getPayout.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling getPayout.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "PayoutDetail");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsApi.prototype.getPayoutChargebacks = function (appId, bankAccountId, payoutId, page, limit, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/chargebacks'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPayoutChargebacks.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling getPayoutChargebacks.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling getPayoutChargebacks.');
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultPayoutChargeback");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsApi.prototype.getPayoutOrders = function (appId, bankAccountId, payoutId, page, limit, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/orders'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPayoutOrders.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling getPayoutOrders.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling getPayoutOrders.');
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultPayoutOrder");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsApi.prototype.getPayoutOtherCharges = function (appId, bankAccountId, payoutId, page, limit, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/othercharges'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPayoutOtherCharges.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling getPayoutOtherCharges.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling getPayoutOtherCharges.');
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultPayoutOtherCharge");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsApi.prototype.getPayoutRefunds = function (appId, bankAccountId, payoutId, page, limit, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/refunds'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPayoutRefunds.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling getPayoutRefunds.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling getPayoutRefunds.');
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultPayoutRefund");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsApi.prototype.getPayoutSummaries = function (appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/payouts/summaries'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPayoutSummaries.');
        }
        if (startDate !== undefined) {
            localVarQueryParameters['startDate'] = ObjectSerializer.serialize(startDate, "Date");
        }
        if (endDate !== undefined) {
            localVarQueryParameters['endDate'] = ObjectSerializer.serialize(endDate, "Date");
        }
        if (payoutRequestIds_bankAccountIds !== undefined) {
            localVarQueryParameters['payoutRequestIds.bankAccountIds'] = ObjectSerializer.serialize(payoutRequestIds_bankAccountIds, "Array<number>");
        }
        if (payoutRequestIds_states !== undefined) {
            localVarQueryParameters['payoutRequestIds.states'] = ObjectSerializer.serialize(payoutRequestIds_states, "Array<'Pending' | 'InTransit' | 'Paid' | 'Failed' | 'Cancelled'>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultPayoutSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsApi.prototype.getPayouts = function (appId, startDate, endDate, page, limit, payoutRequestIds_bankAccountIds, payoutRequestIds_states) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/payouts'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPayouts.');
        }
        if (startDate !== undefined) {
            localVarQueryParameters['startDate'] = ObjectSerializer.serialize(startDate, "Date");
        }
        if (endDate !== undefined) {
            localVarQueryParameters['endDate'] = ObjectSerializer.serialize(endDate, "Date");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (payoutRequestIds_bankAccountIds !== undefined) {
            localVarQueryParameters['payoutRequestIds.bankAccountIds'] = ObjectSerializer.serialize(payoutRequestIds_bankAccountIds, "Array<number>");
        }
        if (payoutRequestIds_states !== undefined) {
            localVarQueryParameters['payoutRequestIds.states'] = ObjectSerializer.serialize(payoutRequestIds_states, "Array<'Pending' | 'InTransit' | 'Paid' | 'Failed' | 'Cancelled'>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultPayout");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return PayoutsApi;
}());
exports.PayoutsApi = PayoutsApi;
var PayoutsExportApiApiKeys;
(function (PayoutsExportApiApiKeys) {
})(PayoutsExportApiApiKeys = exports.PayoutsExportApiApiKeys || (exports.PayoutsExportApiApiKeys = {}));
var PayoutsExportApi = (function () {
    function PayoutsExportApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(PayoutsExportApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PayoutsExportApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    PayoutsExportApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    PayoutsExportApi.prototype.setApiKey = function (key, value) {
        this.authentications[PayoutsExportApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(PayoutsExportApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    PayoutsExportApi.prototype.exportPayoutChargebacks = function (appId, bankAccountId, payoutId, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/chargebacks/export'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling exportPayoutChargebacks.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling exportPayoutChargebacks.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling exportPayoutChargebacks.');
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "string");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsExportApi.prototype.exportPayoutOrders = function (appId, bankAccountId, payoutId, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/orders/export'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling exportPayoutOrders.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling exportPayoutOrders.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling exportPayoutOrders.');
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "string");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsExportApi.prototype.exportPayoutOtherCharges = function (appId, bankAccountId, payoutId, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/othercharges/export'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling exportPayoutOtherCharges.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling exportPayoutOtherCharges.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling exportPayoutOtherCharges.');
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "string");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsExportApi.prototype.exportPayoutRefunds = function (appId, bankAccountId, payoutId, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/refunds/export'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling exportPayoutRefunds.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling exportPayoutRefunds.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling exportPayoutRefunds.');
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "string");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsExportApi.prototype.exportPayoutStores = function (appId, bankAccountId, payoutId, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/export'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)))
            .replace('{' + 'payoutId' + '}', encodeURIComponent(String(payoutId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling exportPayoutStores.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling exportPayoutStores.');
        }
        if (payoutId === null || payoutId === undefined) {
            throw new Error('Required parameter payoutId was null or undefined when calling exportPayoutStores.');
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "string");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PayoutsExportApi.prototype.exportPayouts = function (appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/payouts/export'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling exportPayouts.');
        }
        if (startDate !== undefined) {
            localVarQueryParameters['startDate'] = ObjectSerializer.serialize(startDate, "Date");
        }
        if (endDate !== undefined) {
            localVarQueryParameters['endDate'] = ObjectSerializer.serialize(endDate, "Date");
        }
        if (payoutRequestIds_bankAccountIds !== undefined) {
            localVarQueryParameters['payoutRequestIds.bankAccountIds'] = ObjectSerializer.serialize(payoutRequestIds_bankAccountIds, "Array<number>");
        }
        if (payoutRequestIds_states !== undefined) {
            localVarQueryParameters['payoutRequestIds.states'] = ObjectSerializer.serialize(payoutRequestIds_states, "Array<'Pending' | 'InTransit' | 'Paid' | 'Failed' | 'Cancelled'>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "string");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return PayoutsExportApi;
}());
exports.PayoutsExportApi = PayoutsExportApi;
var ProcessingFeeConfigsApiApiKeys;
(function (ProcessingFeeConfigsApiApiKeys) {
})(ProcessingFeeConfigsApiApiKeys = exports.ProcessingFeeConfigsApiApiKeys || (exports.ProcessingFeeConfigsApiApiKeys = {}));
var ProcessingFeeConfigsApi = (function () {
    function ProcessingFeeConfigsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(ProcessingFeeConfigsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcessingFeeConfigsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    ProcessingFeeConfigsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    ProcessingFeeConfigsApi.prototype.setApiKey = function (key, value) {
        this.authentications[ProcessingFeeConfigsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(ProcessingFeeConfigsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    ProcessingFeeConfigsApi.prototype.getProcessingFeeConfigsByStoreIds = function (storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/processingfeeconfigs';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeIds === null || storeIds === undefined) {
            throw new Error('Required parameter storeIds was null or undefined when calling getProcessingFeeConfigsByStoreIds.');
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultProcessingFeeConfig");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return ProcessingFeeConfigsApi;
}());
exports.ProcessingFeeConfigsApi = ProcessingFeeConfigsApi;
var PushNotificationsApiApiKeys;
(function (PushNotificationsApiApiKeys) {
})(PushNotificationsApiApiKeys = exports.PushNotificationsApiApiKeys || (exports.PushNotificationsApiApiKeys = {}));
var PushNotificationsApi = (function () {
    function PushNotificationsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(PushNotificationsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PushNotificationsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    PushNotificationsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    PushNotificationsApi.prototype.setApiKey = function (key, value) {
        this.authentications[PushNotificationsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(PushNotificationsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    PushNotificationsApi.prototype.deletePushNotification = function (appId, scheduledPushNotificationId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/pushnotifications/{scheduledPushNotificationId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'scheduledPushNotificationId' + '}', encodeURIComponent(String(scheduledPushNotificationId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deletePushNotification.');
        }
        if (scheduledPushNotificationId === null || scheduledPushNotificationId === undefined) {
            throw new Error('Required parameter scheduledPushNotificationId was null or undefined when calling deletePushNotification.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PushNotificationsApi.prototype.getPushNotifications = function (appId, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/pushnotifications'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPushNotifications.');
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultPushNotificationResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PushNotificationsApi.prototype.schedulePushNotification = function (appId, PushNotificationRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/pushnotifications'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling schedulePushNotification.');
        }
        if (PushNotificationRequest === null || PushNotificationRequest === undefined) {
            throw new Error('Required parameter PushNotificationRequest was null or undefined when calling schedulePushNotification.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(PushNotificationRequest, "PushNotificationRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultPushNotificationResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    PushNotificationsApi.prototype.updatePushNotification = function (appId, scheduledPushNotificationId, PushNotificationRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/pushnotifications/{scheduledPushNotificationId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'scheduledPushNotificationId' + '}', encodeURIComponent(String(scheduledPushNotificationId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updatePushNotification.');
        }
        if (scheduledPushNotificationId === null || scheduledPushNotificationId === undefined) {
            throw new Error('Required parameter scheduledPushNotificationId was null or undefined when calling updatePushNotification.');
        }
        if (PushNotificationRequest === null || PushNotificationRequest === undefined) {
            throw new Error('Required parameter PushNotificationRequest was null or undefined when calling updatePushNotification.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(PushNotificationRequest, "PushNotificationRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultPushNotificationResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return PushNotificationsApi;
}());
exports.PushNotificationsApi = PushNotificationsApi;
var ReceiptsApiApiKeys;
(function (ReceiptsApiApiKeys) {
})(ReceiptsApiApiKeys = exports.ReceiptsApiApiKeys || (exports.ReceiptsApiApiKeys = {}));
var ReceiptsApi = (function () {
    function ReceiptsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(ReceiptsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReceiptsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    ReceiptsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    ReceiptsApi.prototype.setApiKey = function (key, value) {
        this.authentications[ReceiptsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(ReceiptsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    ReceiptsApi.prototype.getReceipt = function (orderId) {
        var localVarPath = this.basePath + '/api/v1.0/receipts/{orderId}'
            .replace('{' + 'orderId' + '}', encodeURIComponent(String(orderId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling getReceipt.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "GetReceiptByOrderIdQueryResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return ReceiptsApi;
}());
exports.ReceiptsApi = ReceiptsApi;
var RestaurantVouchersPayGreenApiApiKeys;
(function (RestaurantVouchersPayGreenApiApiKeys) {
})(RestaurantVouchersPayGreenApiApiKeys = exports.RestaurantVouchersPayGreenApiApiKeys || (exports.RestaurantVouchersPayGreenApiApiKeys = {}));
var RestaurantVouchersPayGreenApi = (function () {
    function RestaurantVouchersPayGreenApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(RestaurantVouchersPayGreenApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RestaurantVouchersPayGreenApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    RestaurantVouchersPayGreenApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    RestaurantVouchersPayGreenApi.prototype.setApiKey = function (key, value) {
        this.authentications[RestaurantVouchersPayGreenApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(RestaurantVouchersPayGreenApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    RestaurantVouchersPayGreenApi.prototype.createPayGreenConfiguration = function (appId, CreatePayGreenConfigurationRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createPayGreenConfiguration.');
        }
        if (CreatePayGreenConfigurationRequest === null || CreatePayGreenConfigurationRequest === undefined) {
            throw new Error('Required parameter CreatePayGreenConfigurationRequest was null or undefined when calling createPayGreenConfiguration.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreatePayGreenConfigurationRequest, "CreatePayGreenConfigurationRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRestaurantVoucherPayGreenConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    RestaurantVouchersPayGreenApi.prototype.deletePayGreenConfiguration = function (appId, paygreenConfigurationId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen/{paygreenConfigurationId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'paygreenConfigurationId' + '}', encodeURIComponent(String(paygreenConfigurationId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deletePayGreenConfiguration.');
        }
        if (paygreenConfigurationId === null || paygreenConfigurationId === undefined) {
            throw new Error('Required parameter paygreenConfigurationId was null or undefined when calling deletePayGreenConfiguration.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    RestaurantVouchersPayGreenApi.prototype.getElegibleStores = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen/stores'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getElegibleStores.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRestaurantVoucherEligibleStore");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    RestaurantVouchersPayGreenApi.prototype.getPayGreenConfigurations = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getPayGreenConfigurations.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRestaurantVoucherPayGreenConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    RestaurantVouchersPayGreenApi.prototype.getStoreAvailablePayGreenConfigurations = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen/stores/{storeId}/available-configurations'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoreAvailablePayGreenConfigurations.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getStoreAvailablePayGreenConfigurations.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRestaurantVoucherPayGreenConfigurationSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    RestaurantVouchersPayGreenApi.prototype.getStorePayGreenConfiguration = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen/stores/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStorePayGreenConfiguration.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getStorePayGreenConfiguration.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRestaurantVoucherPayGreenStoreConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    RestaurantVouchersPayGreenApi.prototype.listPayGreenConfigurations = function (appId, paygreenConfigurationId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen/{paygreenConfigurationId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'paygreenConfigurationId' + '}', encodeURIComponent(String(paygreenConfigurationId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling listPayGreenConfigurations.');
        }
        if (paygreenConfigurationId === null || paygreenConfigurationId === undefined) {
            throw new Error('Required parameter paygreenConfigurationId was null or undefined when calling listPayGreenConfigurations.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRestaurantVoucherPayGreenConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    RestaurantVouchersPayGreenApi.prototype.updatePayGreenConfiguration = function (appId, paygreenConfigurationId, UpdatePayGreenConfigurationRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen/{paygreenConfigurationId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'paygreenConfigurationId' + '}', encodeURIComponent(String(paygreenConfigurationId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updatePayGreenConfiguration.');
        }
        if (paygreenConfigurationId === null || paygreenConfigurationId === undefined) {
            throw new Error('Required parameter paygreenConfigurationId was null or undefined when calling updatePayGreenConfiguration.');
        }
        if (UpdatePayGreenConfigurationRequest === null || UpdatePayGreenConfigurationRequest === undefined) {
            throw new Error('Required parameter UpdatePayGreenConfigurationRequest was null or undefined when calling updatePayGreenConfiguration.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdatePayGreenConfigurationRequest, "UpdatePayGreenConfigurationRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRestaurantVoucherPayGreenConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    RestaurantVouchersPayGreenApi.prototype.updateStorePayGreenConfiguration = function (appId, storeId, UpdateStorePayGreenConfigurationRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/restaurant-vouchers/paygreen/stores/{storeId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateStorePayGreenConfiguration.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateStorePayGreenConfiguration.');
        }
        if (UpdateStorePayGreenConfigurationRequest === null || UpdateStorePayGreenConfigurationRequest === undefined) {
            throw new Error('Required parameter UpdateStorePayGreenConfigurationRequest was null or undefined when calling updateStorePayGreenConfiguration.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateStorePayGreenConfigurationRequest, "UpdateStorePayGreenConfigurationRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRestaurantVoucherPayGreenStoreConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return RestaurantVouchersPayGreenApi;
}());
exports.RestaurantVouchersPayGreenApi = RestaurantVouchersPayGreenApi;
var StoreGroupsApiApiKeys;
(function (StoreGroupsApiApiKeys) {
})(StoreGroupsApiApiKeys = exports.StoreGroupsApiApiKeys || (exports.StoreGroupsApiApiKeys = {}));
var StoreGroupsApi = (function () {
    function StoreGroupsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(StoreGroupsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreGroupsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    StoreGroupsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    StoreGroupsApi.prototype.setApiKey = function (key, value) {
        this.authentications[StoreGroupsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(StoreGroupsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    StoreGroupsApi.prototype.createStoreGroup = function (appNameId, StoreGroupBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appNameId}/storegroups'
            .replace('{' + 'appNameId' + '}', encodeURIComponent(String(appNameId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appNameId === null || appNameId === undefined) {
            throw new Error('Required parameter appNameId was null or undefined when calling createStoreGroup.');
        }
        if (StoreGroupBase === null || StoreGroupBase === undefined) {
            throw new Error('Required parameter StoreGroupBase was null or undefined when calling createStoreGroup.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StoreGroupBase, "StoreGroupBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStoreGroup");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoreGroupsApi.prototype.getStoreGroup = function (storeGroupId) {
        var localVarPath = this.basePath + '/api/v1.0/storegroups/{storeGroupId}'
            .replace('{' + 'storeGroupId' + '}', encodeURIComponent(String(storeGroupId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeGroupId === null || storeGroupId === undefined) {
            throw new Error('Required parameter storeGroupId was null or undefined when calling getStoreGroup.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStoreGroup");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoreGroupsApi.prototype.getStoreGroups = function (appNameId, searchQuery, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appNameId}/storegroups'
            .replace('{' + 'appNameId' + '}', encodeURIComponent(String(appNameId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appNameId === null || appNameId === undefined) {
            throw new Error('Required parameter appNameId was null or undefined when calling getStoreGroups.');
        }
        if (searchQuery !== undefined) {
            localVarQueryParameters['searchQuery'] = ObjectSerializer.serialize(searchQuery, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultStoreGroup");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoreGroupsApi.prototype.getStoreGroupsExtended = function (appNameId, searchQuery, page, limit, groupingRadius) {
        var localVarPath = this.basePath + '/api/v1.0/{appNameId}/storegroups/extended'
            .replace('{' + 'appNameId' + '}', encodeURIComponent(String(appNameId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appNameId === null || appNameId === undefined) {
            throw new Error('Required parameter appNameId was null or undefined when calling getStoreGroupsExtended.');
        }
        if (searchQuery !== undefined) {
            localVarQueryParameters['searchQuery'] = ObjectSerializer.serialize(searchQuery, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (groupingRadius !== undefined) {
            localVarQueryParameters['groupingRadius'] = ObjectSerializer.serialize(groupingRadius, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultStoreGroupExtended");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoreGroupsApi.prototype.removeStoreGroup = function (storeGroupId) {
        var localVarPath = this.basePath + '/api/v1.0/storegroups/{storeGroupId}'
            .replace('{' + 'storeGroupId' + '}', encodeURIComponent(String(storeGroupId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeGroupId === null || storeGroupId === undefined) {
            throw new Error('Required parameter storeGroupId was null or undefined when calling removeStoreGroup.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoreGroupsApi.prototype.setMenuMessagePerDeliveryType = function (storeGroupId, deliveryType, body) {
        var localVarPath = this.basePath + '/api/v1.0/storegroups/{storeGroupId}/{deliveryType}/MenuMessagePerDeliveryType'
            .replace('{' + 'storeGroupId' + '}', encodeURIComponent(String(storeGroupId)))
            .replace('{' + 'deliveryType' + '}', encodeURIComponent(String(deliveryType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeGroupId === null || storeGroupId === undefined) {
            throw new Error('Required parameter storeGroupId was null or undefined when calling setMenuMessagePerDeliveryType.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling setMenuMessagePerDeliveryType.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setMenuMessagePerDeliveryType.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "string")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoreGroupsApi.prototype.updateStoreGroup = function (storeGroupId, StoreGroupBase) {
        var localVarPath = this.basePath + '/api/v1.0/storegroups/{storeGroupId}'
            .replace('{' + 'storeGroupId' + '}', encodeURIComponent(String(storeGroupId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeGroupId === null || storeGroupId === undefined) {
            throw new Error('Required parameter storeGroupId was null or undefined when calling updateStoreGroup.');
        }
        if (StoreGroupBase === null || StoreGroupBase === undefined) {
            throw new Error('Required parameter StoreGroupBase was null or undefined when calling updateStoreGroup.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StoreGroupBase, "StoreGroupBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStoreGroupBase");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return StoreGroupsApi;
}());
exports.StoreGroupsApi = StoreGroupsApi;
var StoreOrderCapacityApiApiKeys;
(function (StoreOrderCapacityApiApiKeys) {
})(StoreOrderCapacityApiApiKeys = exports.StoreOrderCapacityApiApiKeys || (exports.StoreOrderCapacityApiApiKeys = {}));
var StoreOrderCapacityApi = (function () {
    function StoreOrderCapacityApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(StoreOrderCapacityApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreOrderCapacityApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    StoreOrderCapacityApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    StoreOrderCapacityApi.prototype.setApiKey = function (key, value) {
        this.authentications[StoreOrderCapacityApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(StoreOrderCapacityApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    StoreOrderCapacityApi.prototype.getStoreOrderCapacity = function (appId, storeId, deliveryType) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/storeordercapacity/{storeId}/{deliveryType}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryType' + '}', encodeURIComponent(String(deliveryType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoreOrderCapacity.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getStoreOrderCapacity.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling getStoreOrderCapacity.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStoreOrderCapacityConfig");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoreOrderCapacityApi.prototype.updateStoreOrderCapacityConfig = function (storeId, deliveryType, appId, StoreOrderCapacityConfigEditModel) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/storeordercapacity/{storeId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateStoreOrderCapacityConfig.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling updateStoreOrderCapacityConfig.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateStoreOrderCapacityConfig.');
        }
        if (StoreOrderCapacityConfigEditModel === null || StoreOrderCapacityConfigEditModel === undefined) {
            throw new Error('Required parameter StoreOrderCapacityConfigEditModel was null or undefined when calling updateStoreOrderCapacityConfig.');
        }
        if (deliveryType !== undefined) {
            localVarQueryParameters['deliveryType'] = ObjectSerializer.serialize(deliveryType, "'Delivery' | 'Pickup'");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StoreOrderCapacityConfigEditModel, "StoreOrderCapacityConfigEditModel")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return StoreOrderCapacityApi;
}());
exports.StoreOrderCapacityApi = StoreOrderCapacityApi;
var StoresApiApiKeys;
(function (StoresApiApiKeys) {
})(StoresApiApiKeys = exports.StoresApiApiKeys || (exports.StoresApiApiKeys = {}));
var StoresApi = (function () {
    function StoresApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(StoresApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoresApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    StoresApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    StoresApi.prototype.setApiKey = function (key, value) {
        this.authentications[StoresApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(StoresApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    StoresApi.prototype.archiveStore = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/archive'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling archiveStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.assignMenu = function (storeId, menuId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/menu/{menuId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'menuId' + '}', encodeURIComponent(String(menuId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling assignMenu.');
        }
        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling assignMenu.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRestApiDefaultResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.cloneStore = function (storeId, StoreCloneSettings) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/clone'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling cloneStore.');
        }
        if (StoreCloneSettings === null || StoreCloneSettings === undefined) {
            throw new Error('Required parameter StoreCloneSettings was null or undefined when calling cloneStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StoreCloneSettings, "StoreCloneSettings")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStore");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.configureStoreServiceCharge = function (storeId, ServiceCharge) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/servicecharge'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling configureStoreServiceCharge.');
        }
        if (ServiceCharge === null || ServiceCharge === undefined) {
            throw new Error('Required parameter ServiceCharge was null or undefined when calling configureStoreServiceCharge.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ServiceCharge, "ServiceCharge")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultServiceCharge");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.createBusinessHoursOverrideByStoreId = function (storeId, BusinessHoursOverrideBase) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/businesshoursoverrides'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling createBusinessHoursOverrideByStoreId.');
        }
        if (BusinessHoursOverrideBase === null || BusinessHoursOverrideBase === undefined) {
            throw new Error('Required parameter BusinessHoursOverrideBase was null or undefined when calling createBusinessHoursOverrideByStoreId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(BusinessHoursOverrideBase, "BusinessHoursOverrideBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultBusinessHoursOverride");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.createStore = function (storeGroupId, StoreCreateBase) {
        var localVarPath = this.basePath + '/api/v1.0/stores';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeGroupId === null || storeGroupId === undefined) {
            throw new Error('Required parameter storeGroupId was null or undefined when calling createStore.');
        }
        if (StoreCreateBase === null || StoreCreateBase === undefined) {
            throw new Error('Required parameter StoreCreateBase was null or undefined when calling createStore.');
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StoreCreateBase, "StoreCreateBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStore");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.deleteBusinessHoursOverride = function (storeId, businessHoursOverrideId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/businesshoursoverrides/{businessHoursOverrideId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'businessHoursOverrideId' + '}', encodeURIComponent(String(businessHoursOverrideId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling deleteBusinessHoursOverride.');
        }
        if (businessHoursOverrideId === null || businessHoursOverrideId === undefined) {
            throw new Error('Required parameter businessHoursOverrideId was null or undefined when calling deleteBusinessHoursOverride.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRestApiDefaultResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getBankAccountForStore = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/bankaccount'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getBankAccountForStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultAssignedBankAccount");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getBusinessHours = function (storeId, deliveryType) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/availability/{deliveryType}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryType' + '}', encodeURIComponent(String(deliveryType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getBusinessHours.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling getBusinessHours.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultBusinessHoursPeriod");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getBusinessHoursOverrideByStoreId = function (storeId, after, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/businesshoursoverrides'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getBusinessHoursOverrideByStoreId.');
        }
        if (after !== undefined) {
            localVarQueryParameters['after'] = ObjectSerializer.serialize(after, "Date");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultBusinessHoursOverride");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getEndOfDayReport = function (storeId, date) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/endofdayreport'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getEndOfDayReport.');
        }
        if (date !== undefined) {
            localVarQueryParameters['date'] = ObjectSerializer.serialize(date, "Date");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStoreEndOfDayReport");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getPreOrderConfig = function (storeId, deliveryType) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/preorderconfig/{deliveryType}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryType' + '}', encodeURIComponent(String(deliveryType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getPreOrderConfig.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling getPreOrderConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultPreOrderConfig");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getPreOrderPreview = function (storeId, deliveryType, preOrderConfig_leadTimeMinutes, preOrderConfig_intervalMinutes, preOrderConfig_maxOrderAheadDays, preOrderConfig_includeAsap, preOrderConfig_includeMoreGranularInitialTime, preOrderConfig_cutOffTimePreviousDayBasic, preOrderConfig_cutOffTimeCurrentDayBasic, preOrderConfig_preOrderTimeDisplayType, preOrderConfig_alwaysAppearOpen, preOrderConfig_requireExplicitSelectAlways) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/preorderconfig/{deliveryType}/preview'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryType' + '}', encodeURIComponent(String(deliveryType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getPreOrderPreview.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling getPreOrderPreview.');
        }
        if (preOrderConfig_leadTimeMinutes !== undefined) {
            localVarQueryParameters['preOrderConfig.leadTimeMinutes'] = ObjectSerializer.serialize(preOrderConfig_leadTimeMinutes, "number");
        }
        if (preOrderConfig_intervalMinutes !== undefined) {
            localVarQueryParameters['preOrderConfig.intervalMinutes'] = ObjectSerializer.serialize(preOrderConfig_intervalMinutes, "number");
        }
        if (preOrderConfig_maxOrderAheadDays !== undefined) {
            localVarQueryParameters['preOrderConfig.maxOrderAheadDays'] = ObjectSerializer.serialize(preOrderConfig_maxOrderAheadDays, "number");
        }
        if (preOrderConfig_includeAsap !== undefined) {
            localVarQueryParameters['preOrderConfig.includeAsap'] = ObjectSerializer.serialize(preOrderConfig_includeAsap, "boolean");
        }
        if (preOrderConfig_includeMoreGranularInitialTime !== undefined) {
            localVarQueryParameters['preOrderConfig.includeMoreGranularInitialTime'] = ObjectSerializer.serialize(preOrderConfig_includeMoreGranularInitialTime, "boolean");
        }
        if (preOrderConfig_cutOffTimePreviousDayBasic !== undefined) {
            localVarQueryParameters['preOrderConfig.cutOffTimePreviousDayBasic'] = ObjectSerializer.serialize(preOrderConfig_cutOffTimePreviousDayBasic, "string");
        }
        if (preOrderConfig_cutOffTimeCurrentDayBasic !== undefined) {
            localVarQueryParameters['preOrderConfig.cutOffTimeCurrentDayBasic'] = ObjectSerializer.serialize(preOrderConfig_cutOffTimeCurrentDayBasic, "string");
        }
        if (preOrderConfig_preOrderTimeDisplayType !== undefined) {
            localVarQueryParameters['preOrderConfig.preOrderTimeDisplayType'] = ObjectSerializer.serialize(preOrderConfig_preOrderTimeDisplayType, "'SingleTime' | 'StartAndEndTime' | 'DayOnly'");
        }
        if (preOrderConfig_alwaysAppearOpen !== undefined) {
            localVarQueryParameters['preOrderConfig.alwaysAppearOpen'] = ObjectSerializer.serialize(preOrderConfig_alwaysAppearOpen, "boolean");
        }
        if (preOrderConfig_requireExplicitSelectAlways !== undefined) {
            localVarQueryParameters['preOrderConfig.requireExplicitSelectAlways'] = ObjectSerializer.serialize(preOrderConfig_requireExplicitSelectAlways, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultPreOrderTime");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getProcessingFeeConfigsByStoreId = function (storeId, appNameId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/processingfeeconfigs'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getProcessingFeeConfigsByStoreId.');
        }
        if (appNameId !== undefined) {
            localVarQueryParameters['appNameId'] = ObjectSerializer.serialize(appNameId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultProcessingFeeConfig");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getProcessingFeeConfigsByStoreIdAndPaymentAccountType = function (storeId, paymentAccountType, appNameId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/processingfeeconfigs/{paymentAccountType}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'paymentAccountType' + '}', encodeURIComponent(String(paymentAccountType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getProcessingFeeConfigsByStoreIdAndPaymentAccountType.');
        }
        if (paymentAccountType === null || paymentAccountType === undefined) {
            throw new Error('Required parameter paymentAccountType was null or undefined when calling getProcessingFeeConfigsByStoreIdAndPaymentAccountType.');
        }
        if (appNameId !== undefined) {
            localVarQueryParameters['appNameId'] = ObjectSerializer.serialize(appNameId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultProcessingFeeConfig");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getStoreById = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getStoreById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStore");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getStoreFeeConfig = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/feeConfig'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getStoreFeeConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "StoreFeeConfig");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getStoreHeadersByAppId = function (appId, storeNameQuery, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/header'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoreHeadersByAppId.');
        }
        if (storeNameQuery !== undefined) {
            localVarQueryParameters['storeNameQuery'] = ObjectSerializer.serialize(storeNameQuery, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultStoreHeader");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getStoreNetSales = function (appId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores/stats'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoreNetSales.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getStoreNetSales.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultStoreStatistics");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getStoreServiceCharge = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/servicecharge'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getStoreServiceCharge.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "ServiceCharge");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getStores = function (searchQuery, page, limit, storeGroupId) {
        var localVarPath = this.basePath + '/api/v1.0/stores';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (searchQuery !== undefined) {
            localVarQueryParameters['searchQuery'] = ObjectSerializer.serialize(searchQuery, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        if (storeGroupId !== undefined) {
            localVarQueryParameters['storeGroupId'] = ObjectSerializer.serialize(storeGroupId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultStore");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getStoresByAppId = function (appId, searchQuery, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/stores'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoresByAppId.');
        }
        if (searchQuery !== undefined) {
            localVarQueryParameters['searchQuery'] = ObjectSerializer.serialize(searchQuery, "string");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultStore");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.getStoresByStoreIdWithValidations = function (storeId, appId, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/storevalidation/kiosk'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getStoresByStoreIdWithValidations.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getStoresByStoreIdWithValidations.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultStoreValidationConfig");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.publishStore = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/publish'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling publishStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.setBusinessHours = function (storeId, deliveryType, BusinessHoursPeriodBase) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/availability/{deliveryType}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryType' + '}', encodeURIComponent(String(deliveryType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling setBusinessHours.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling setBusinessHours.');
        }
        if (BusinessHoursPeriodBase === null || BusinessHoursPeriodBase === undefined) {
            throw new Error('Required parameter BusinessHoursPeriodBase was null or undefined when calling setBusinessHours.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(BusinessHoursPeriodBase, "BusinessHoursPeriodBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultBusinessHoursPeriod");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.setPreOrdeEnabled = function (storeId, deliveryType, enabled) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/preorderconfig/{deliveryType}/enabled'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryType' + '}', encodeURIComponent(String(deliveryType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling setPreOrdeEnabled.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling setPreOrdeEnabled.');
        }
        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setPreOrdeEnabled.');
        }
        if (enabled !== undefined) {
            localVarQueryParameters['enabled'] = ObjectSerializer.serialize(enabled, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRestApiDefaultResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.unpublishStore = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/unpublish'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling unpublishStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.updatePreOrderConfig = function (storeId, deliveryType, PreOrderConfig) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/preorderconfig/{deliveryType}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'deliveryType' + '}', encodeURIComponent(String(deliveryType)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updatePreOrderConfig.');
        }
        if (deliveryType === null || deliveryType === undefined) {
            throw new Error('Required parameter deliveryType was null or undefined when calling updatePreOrderConfig.');
        }
        if (PreOrderConfig === null || PreOrderConfig === undefined) {
            throw new Error('Required parameter PreOrderConfig was null or undefined when calling updatePreOrderConfig.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(PreOrderConfig, "PreOrderConfig")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultRestApiDefaultResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.updateStore = function (storeId, StoreBase) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateStore.');
        }
        if (StoreBase === null || StoreBase === undefined) {
            throw new Error('Required parameter StoreBase was null or undefined when calling updateStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StoreBase, "StoreBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStore");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.updateStoreAddress = function (storeId, StoreAddressBase) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/address'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateStoreAddress.');
        }
        if (StoreAddressBase === null || StoreAddressBase === undefined) {
            throw new Error('Required parameter StoreAddressBase was null or undefined when calling updateStoreAddress.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StoreAddressBase, "StoreAddressBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStoreAddress");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.updateStoreAddressCoordinates = function (storeId, Coordinates, appNameId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/address/coordinates'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateStoreAddressCoordinates.');
        }
        if (Coordinates === null || Coordinates === undefined) {
            throw new Error('Required parameter Coordinates was null or undefined when calling updateStoreAddressCoordinates.');
        }
        if (appNameId !== undefined) {
            localVarQueryParameters['appNameId'] = ObjectSerializer.serialize(appNameId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(Coordinates, "Coordinates")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultCoordinates");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StoresApi.prototype.updateStoreAddressForm = function (storeId, StoreAddressForm) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/addressform'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling updateStoreAddressForm.');
        }
        if (StoreAddressForm === null || StoreAddressForm === undefined) {
            throw new Error('Required parameter StoreAddressForm was null or undefined when calling updateStoreAddressForm.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StoreAddressForm, "StoreAddressForm")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return StoresApi;
}());
exports.StoresApi = StoresApi;
var StripeCustomConnectApiApiKeys;
(function (StripeCustomConnectApiApiKeys) {
})(StripeCustomConnectApiApiKeys = exports.StripeCustomConnectApiApiKeys || (exports.StripeCustomConnectApiApiKeys = {}));
var StripeCustomConnectApi = (function () {
    function StripeCustomConnectApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(StripeCustomConnectApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StripeCustomConnectApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    StripeCustomConnectApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    StripeCustomConnectApi.prototype.setApiKey = function (key, value) {
        this.authentications[StripeCustomConnectApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(StripeCustomConnectApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    StripeCustomConnectApi.prototype.createBankAccountAndConnectedAccount = function (appId, BankAccountCreate) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/bank-account'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createBankAccountAndConnectedAccount.');
        }
        if (BankAccountCreate === null || BankAccountCreate === undefined) {
            throw new Error('Required parameter BankAccountCreate was null or undefined when calling createBankAccountAndConnectedAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(BankAccountCreate, "BankAccountCreate")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultBankAccountDetail");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StripeCustomConnectApi.prototype.createStripeConnectedAccount = function (appId, bankAccountId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/{bankAccountId}/create-update-account'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createStripeConnectedAccount.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling createStripeConnectedAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStripeConnectedAccount");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StripeCustomConnectApi.prototype.createStripeConnectedAccountLink = function (appId, stripeConnectedAccountId, StripeAccountLinkRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/{stripeConnectedAccountId}/create-account-link'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'stripeConnectedAccountId' + '}', encodeURIComponent(String(stripeConnectedAccountId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createStripeConnectedAccountLink.');
        }
        if (stripeConnectedAccountId === null || stripeConnectedAccountId === undefined) {
            throw new Error('Required parameter stripeConnectedAccountId was null or undefined when calling createStripeConnectedAccountLink.');
        }
        if (StripeAccountLinkRequest === null || StripeAccountLinkRequest === undefined) {
            throw new Error('Required parameter StripeAccountLinkRequest was null or undefined when calling createStripeConnectedAccountLink.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StripeAccountLinkRequest, "StripeAccountLinkRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStripeConnectedAccount");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StripeCustomConnectApi.prototype.getCustomConnect = function (storeId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/{storeId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getCustomConnect.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getCustomConnect.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultStripeCustomConnectedAccount");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StripeCustomConnectApi.prototype.getVerificationStatus = function (appId, stripeConnectedAccountId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/verification-status'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getVerificationStatus.');
        }
        if (stripeConnectedAccountId === null || stripeConnectedAccountId === undefined) {
            throw new Error('Required parameter stripeConnectedAccountId was null or undefined when calling getVerificationStatus.');
        }
        if (stripeConnectedAccountId !== undefined) {
            localVarQueryParameters['stripeConnectedAccountId'] = ObjectSerializer.serialize(stripeConnectedAccountId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStripeConnectedAccount");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StripeCustomConnectApi.prototype.setBankAccountBusinessType = function (appId, bankAccountId, body) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/bank-account/{bankAccountId}/businesstype'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setBankAccountBusinessType.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling setBankAccountBusinessType.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setBankAccountBusinessType.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "string")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultBankAccountDetail");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StripeCustomConnectApi.prototype.stripeCustomConnectRefresh = function (linkRequestId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/refresh-link'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (linkRequestId === null || linkRequestId === undefined) {
            throw new Error('Required parameter linkRequestId was null or undefined when calling stripeCustomConnectRefresh.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling stripeCustomConnectRefresh.');
        }
        if (linkRequestId !== undefined) {
            localVarQueryParameters['linkRequestId'] = ObjectSerializer.serialize(linkRequestId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StripeCustomConnectApi.prototype.updateBankAccountDetails = function (appId, bankAccountId, BankAccountDetailsUpdateRequest) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/{bankAccountId}/update-bank-account-details'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'bankAccountId' + '}', encodeURIComponent(String(bankAccountId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateBankAccountDetails.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling updateBankAccountDetails.');
        }
        if (BankAccountDetailsUpdateRequest === null || BankAccountDetailsUpdateRequest === undefined) {
            throw new Error('Required parameter BankAccountDetailsUpdateRequest was null or undefined when calling updateBankAccountDetails.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(BankAccountDetailsUpdateRequest, "BankAccountDetailsUpdateRequest")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStripeConnectedAccount");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StripeCustomConnectApi.prototype.updatePayoutSchedule = function (appId, stripeConnectedAccountId, interval) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/customconnect/update-payout-schedule/{stripeConnectedAccountId}/{interval}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'stripeConnectedAccountId' + '}', encodeURIComponent(String(stripeConnectedAccountId)))
            .replace('{' + 'interval' + '}', encodeURIComponent(String(interval)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updatePayoutSchedule.');
        }
        if (stripeConnectedAccountId === null || stripeConnectedAccountId === undefined) {
            throw new Error('Required parameter stripeConnectedAccountId was null or undefined when calling updatePayoutSchedule.');
        }
        if (interval === null || interval === undefined) {
            throw new Error('Required parameter interval was null or undefined when calling updatePayoutSchedule.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultModelBase");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return StripeCustomConnectApi;
}());
exports.StripeCustomConnectApi = StripeCustomConnectApi;
var StripeCustomConnectAdminApiApiKeys;
(function (StripeCustomConnectAdminApiApiKeys) {
})(StripeCustomConnectAdminApiApiKeys = exports.StripeCustomConnectAdminApiApiKeys || (exports.StripeCustomConnectAdminApiApiKeys = {}));
var StripeCustomConnectAdminApi = (function () {
    function StripeCustomConnectAdminApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(StripeCustomConnectAdminApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StripeCustomConnectAdminApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    StripeCustomConnectAdminApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    StripeCustomConnectAdminApi.prototype.setApiKey = function (key, value) {
        this.authentications[StripeCustomConnectAdminApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(StripeCustomConnectAdminApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    StripeCustomConnectAdminApi.prototype.initializeBankAccountConnectedAccount = function (ERROR_UNKNOWN) {
        var localVarPath = this.basePath + '/api/v1.0/customconnect/initialize-bank-account';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (ERROR_UNKNOWN === null || ERROR_UNKNOWN === undefined) {
            throw new Error('Required parameter ERROR_UNKNOWN was null or undefined when calling initializeBankAccountConnectedAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(ERROR_UNKNOWN, "Array<number>")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultBankAccountDetail");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return StripeCustomConnectAdminApi;
}());
exports.StripeCustomConnectAdminApi = StripeCustomConnectAdminApi;
var StuartApiApiKeys;
(function (StuartApiApiKeys) {
})(StuartApiApiKeys = exports.StuartApiApiKeys || (exports.StuartApiApiKeys = {}));
var StuartApi = (function () {
    function StuartApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(StuartApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StuartApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    StuartApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    StuartApi.prototype.setApiKey = function (key, value) {
        this.authentications[StuartApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(StuartApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    StuartApi.prototype.stuartCancelJob = function (jobId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stuart/jobs/{jobId}'
            .replace('{' + 'jobId' + '}', encodeURIComponent(String(jobId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (jobId === null || jobId === undefined) {
            throw new Error('Required parameter jobId was null or undefined when calling stuartCancelJob.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling stuartCancelJob.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StuartApi.prototype.stuartGetJob = function (jobId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stuart/jobs/{jobId}'
            .replace('{' + 'jobId' + '}', encodeURIComponent(String(jobId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (jobId === null || jobId === undefined) {
            throw new Error('Required parameter jobId was null or undefined when calling stuartGetJob.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling stuartGetJob.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultJobResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StuartApi.prototype.stuartGetStuartSettings = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stuart/settings/{storeId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling stuartGetStuartSettings.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultStuartSettings");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    StuartApi.prototype.stuartPostStuartSettings = function (storeId, StuartSettings) {
        var localVarPath = this.basePath + '/api/v1.0/stuart/settings/{storeId}'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling stuartPostStuartSettings.');
        }
        if (StuartSettings === null || StuartSettings === undefined) {
            throw new Error('Required parameter StuartSettings was null or undefined when calling stuartPostStuartSettings.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(StuartSettings, "StuartSettings")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return StuartApi;
}());
exports.StuartApi = StuartApi;
var SubscriptionsApiApiKeys;
(function (SubscriptionsApiApiKeys) {
})(SubscriptionsApiApiKeys = exports.SubscriptionsApiApiKeys || (exports.SubscriptionsApiApiKeys = {}));
var SubscriptionsApi = (function () {
    function SubscriptionsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(SubscriptionsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubscriptionsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    SubscriptionsApi.prototype.setApiKey = function (key, value) {
        this.authentications[SubscriptionsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(SubscriptionsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionsApi.prototype.getSubscriptionById = function (appId, subscriptionId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/subscriptions/{subscriptionId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'subscriptionId' + '}', encodeURIComponent(String(subscriptionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getSubscriptionById.');
        }
        if (subscriptionId === null || subscriptionId === undefined) {
            throw new Error('Required parameter subscriptionId was null or undefined when calling getSubscriptionById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultSubscription");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    SubscriptionsApi.prototype.getSubscriptionsForApp = function (appId, excludeNotOwnedSubscriptions, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/subscriptions'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getSubscriptionsForApp.');
        }
        if (excludeNotOwnedSubscriptions !== undefined) {
            localVarQueryParameters['excludeNotOwnedSubscriptions'] = ObjectSerializer.serialize(excludeNotOwnedSubscriptions, "boolean");
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultSubscriptionSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return SubscriptionsApi;
}());
exports.SubscriptionsApi = SubscriptionsApi;
var TeammatesApiApiKeys;
(function (TeammatesApiApiKeys) {
})(TeammatesApiApiKeys = exports.TeammatesApiApiKeys || (exports.TeammatesApiApiKeys = {}));
var TeammatesApi = (function () {
    function TeammatesApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(TeammatesApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeammatesApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    TeammatesApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    TeammatesApi.prototype.setApiKey = function (key, value) {
        this.authentications[TeammatesApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(TeammatesApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    TeammatesApi.prototype.createTeammate = function (appId, CreateTeammate) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/teammates'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createTeammate.');
        }
        if (CreateTeammate === null || CreateTeammate === undefined) {
            throw new Error('Required parameter CreateTeammate was null or undefined when calling createTeammate.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateTeammate, "CreateTeammate")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultTeammate");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    TeammatesApi.prototype.deleteTeammate = function (appId, id) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/teammates/{id}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteTeammate.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTeammate.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    TeammatesApi.prototype.getTeammateByAppIdAndTeammateId = function (appId, id) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/teammates/{id}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getTeammateByAppIdAndTeammateId.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTeammateByAppIdAndTeammateId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultTeammate");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    TeammatesApi.prototype.getTeammatesByAppId = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/teammates'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getTeammatesByAppId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultTeammate");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    TeammatesApi.prototype.redeemInvitation = function (otc, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/teammates/redeem/{otc}'
            .replace('{' + 'otc' + '}', encodeURIComponent(String(otc)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (otc === null || otc === undefined) {
            throw new Error('Required parameter otc was null or undefined when calling redeemInvitation.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling redeemInvitation.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultRedeemInvitationResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    TeammatesApi.prototype.updateTeammate = function (appId, id, TeammateBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/teammates/{id}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateTeammate.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateTeammate.');
        }
        if (TeammateBase === null || TeammateBase === undefined) {
            throw new Error('Required parameter TeammateBase was null or undefined when calling updateTeammate.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(TeammateBase, "TeammateBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultTeammate");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return TeammatesApi;
}());
exports.TeammatesApi = TeammatesApi;
var TerminalIotApiApiKeys;
(function (TerminalIotApiApiKeys) {
})(TerminalIotApiApiKeys = exports.TerminalIotApiApiKeys || (exports.TerminalIotApiApiKeys = {}));
var TerminalIotApi = (function () {
    function TerminalIotApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(TerminalIotApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TerminalIotApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    TerminalIotApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    TerminalIotApi.prototype.setApiKey = function (key, value) {
        this.authentications[TerminalIotApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(TerminalIotApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    TerminalIotApi.prototype.getTerminalIotConnection = function () {
        var localVarPath = this.basePath + '/api/v1.0/terminaliot/connect';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultKioskIotConnectionParameters");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return TerminalIotApi;
}());
exports.TerminalIotApi = TerminalIotApi;
var TipsApiApiKeys;
(function (TipsApiApiKeys) {
})(TipsApiApiKeys = exports.TipsApiApiKeys || (exports.TipsApiApiKeys = {}));
var TipsApi = (function () {
    function TipsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(TipsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TipsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    TipsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    TipsApi.prototype.setApiKey = function (key, value) {
        this.authentications[TipsApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(TipsApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    TipsApi.prototype.tipConfigGet = function (storeId) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/tipconfig'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling tipConfigGet.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultTipConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    TipsApi.prototype.tipConfigUpsert = function (storeId, UpdateTipConfiguration) {
        var localVarPath = this.basePath + '/api/v1.0/stores/{storeId}/tipconfig'
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling tipConfigUpsert.');
        }
        if (UpdateTipConfiguration === null || UpdateTipConfiguration === undefined) {
            throw new Error('Required parameter UpdateTipConfiguration was null or undefined when calling tipConfigUpsert.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(UpdateTipConfiguration, "UpdateTipConfiguration")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultTipConfiguration");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return TipsApi;
}());
exports.TipsApi = TipsApi;
var UsersApiApiKeys;
(function (UsersApiApiKeys) {
})(UsersApiApiKeys = exports.UsersApiApiKeys || (exports.UsersApiApiKeys = {}));
var UsersApi = (function () {
    function UsersApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(UsersApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    UsersApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    UsersApi.prototype.setApiKey = function (key, value) {
        this.authentications[UsersApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(UsersApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    UsersApi.prototype.getPreviousOrderCountForStore = function (userId, storeId) {
        var localVarPath = this.basePath + '/api/v1.0/users/{userId}/previousordercount/{storeId}'
            .replace('{' + 'userId' + '}', encodeURIComponent(String(userId)))
            .replace('{' + 'storeId' + '}', encodeURIComponent(String(storeId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getPreviousOrderCountForStore.');
        }
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getPreviousOrderCountForStore.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    UsersApi.prototype.getRoles = function () {
        var localVarPath = this.basePath + '/api/v1.0/users/roles';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringArrayResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return UsersApi;
}());
exports.UsersApi = UsersApi;
var VouchersApiApiKeys;
(function (VouchersApiApiKeys) {
})(VouchersApiApiKeys = exports.VouchersApiApiKeys || (exports.VouchersApiApiKeys = {}));
var VouchersApi = (function () {
    function VouchersApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(VouchersApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VouchersApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    VouchersApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    VouchersApi.prototype.setApiKey = function (key, value) {
        this.authentications[VouchersApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(VouchersApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    VouchersApi.prototype.createVoucher = function (appId, CreateVoucher) {
        var localVarPath = this.basePath + '/api/v1.0/vouchers/{appId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createVoucher.');
        }
        if (CreateVoucher === null || CreateVoucher === undefined) {
            throw new Error('Required parameter CreateVoucher was null or undefined when calling createVoucher.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(CreateVoucher, "CreateVoucher")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultVoucherWithStats");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    VouchersApi.prototype.getVoucherById = function (voucherId) {
        var localVarPath = this.basePath + '/api/v1.0/vouchers/{voucherId}'
            .replace('{' + 'voucherId' + '}', encodeURIComponent(String(voucherId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (voucherId === null || voucherId === undefined) {
            throw new Error('Required parameter voucherId was null or undefined when calling getVoucherById.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultVoucherWithStats");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    VouchersApi.prototype.getVoucherStatsById = function (voucherId, aggregateDataBy, dataPointLimit) {
        var localVarPath = this.basePath + '/api/v1.0/vouchers/stats/{voucherId}'
            .replace('{' + 'voucherId' + '}', encodeURIComponent(String(voucherId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (voucherId === null || voucherId === undefined) {
            throw new Error('Required parameter voucherId was null or undefined when calling getVoucherStatsById.');
        }
        if (aggregateDataBy === null || aggregateDataBy === undefined) {
            throw new Error('Required parameter aggregateDataBy was null or undefined when calling getVoucherStatsById.');
        }
        if (aggregateDataBy !== undefined) {
            localVarQueryParameters['aggregateDataBy'] = ObjectSerializer.serialize(aggregateDataBy, "'Daily' | 'Weekly' | 'Monthly'");
        }
        if (dataPointLimit !== undefined) {
            localVarQueryParameters['dataPointLimit'] = ObjectSerializer.serialize(dataPointLimit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiArrayResultVoucherDataPoint");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    VouchersApi.prototype.getVouchers = function (appId, pageIndex, pageSize, searchCodes, statusSearch, typeSearch, subTypeSearch, storeIds) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/vouchers/summaries'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getVouchers.');
        }
        if (pageIndex !== undefined) {
            localVarQueryParameters['pageIndex'] = ObjectSerializer.serialize(pageIndex, "number");
        }
        if (pageSize !== undefined) {
            localVarQueryParameters['pageSize'] = ObjectSerializer.serialize(pageSize, "number");
        }
        if (searchCodes !== undefined) {
            localVarQueryParameters['searchCodes'] = ObjectSerializer.serialize(searchCodes, "Array<string>");
        }
        if (statusSearch !== undefined) {
            localVarQueryParameters['statusSearch'] = ObjectSerializer.serialize(statusSearch, "Array<'Valid' | 'NotYetValid' | 'Expired' | 'Used' | 'Disabled'>");
        }
        if (typeSearch !== undefined) {
            localVarQueryParameters['typeSearch'] = ObjectSerializer.serialize(typeSearch, "Array<'PercentageDiscount' | 'LumpDiscount' | 'AddItem' | 'CreditNote'>");
        }
        if (subTypeSearch !== undefined) {
            localVarQueryParameters['subTypeSearch'] = ObjectSerializer.serialize(subTypeSearch, "Array<'None' | 'SignUp' | 'Loyalty' | 'Loyalty25' | 'Retention' | 'SecondaryRetention' | 'Custom'>");
        }
        if (storeIds !== undefined) {
            localVarQueryParameters['storeIds'] = ObjectSerializer.serialize(storeIds, "Array<number>");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultVoucherSummary");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    VouchersApi.prototype.updateVoucher = function (voucherId, VoucherBase, storeId, percentValue, lumpValue, freeItemId) {
        var localVarPath = this.basePath + '/api/v1.0/vouchers/{voucherId}'
            .replace('{' + 'voucherId' + '}', encodeURIComponent(String(voucherId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (voucherId === null || voucherId === undefined) {
            throw new Error('Required parameter voucherId was null or undefined when calling updateVoucher.');
        }
        if (VoucherBase === null || VoucherBase === undefined) {
            throw new Error('Required parameter VoucherBase was null or undefined when calling updateVoucher.');
        }
        if (storeId !== undefined) {
            localVarQueryParameters['storeId'] = ObjectSerializer.serialize(storeId, "Array<number>");
        }
        if (percentValue !== undefined) {
            localVarQueryParameters['percentValue'] = ObjectSerializer.serialize(percentValue, "number");
        }
        if (lumpValue !== undefined) {
            localVarQueryParameters['lumpValue'] = ObjectSerializer.serialize(lumpValue, "number");
        }
        if (freeItemId !== undefined) {
            localVarQueryParameters['freeItemId'] = ObjectSerializer.serialize(freeItemId, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(VoucherBase, "VoucherBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultVoucherWithStats");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return VouchersApi;
}());
exports.VouchersApi = VouchersApi;
var WebhooksApiApiKeys;
(function (WebhooksApiApiKeys) {
})(WebhooksApiApiKeys = exports.WebhooksApiApiKeys || (exports.WebhooksApiApiKeys = {}));
var WebhooksApi = (function () {
    function WebhooksApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(WebhooksApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebhooksApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    WebhooksApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    WebhooksApi.prototype.setApiKey = function (key, value) {
        this.authentications[WebhooksApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(WebhooksApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    WebhooksApi.prototype.createWebhookSubscription = function (oauthAppId, appId, WebhookSubscription) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling createWebhookSubscription.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createWebhookSubscription.');
        }
        if (WebhookSubscription === null || WebhookSubscription === undefined) {
            throw new Error('Required parameter WebhookSubscription was null or undefined when calling createWebhookSubscription.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(WebhookSubscription, "WebhookSubscription")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiIntegerResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.createWebhookSubscriptionEventNames = function (oauthAppId, webhookSubscriptionId, eventName, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/events/{eventName}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'webhookSubscriptionId' + '}', encodeURIComponent(String(webhookSubscriptionId)))
            .replace('{' + 'eventName' + '}', encodeURIComponent(String(eventName)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling createWebhookSubscriptionEventNames.');
        }
        if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
            throw new Error('Required parameter webhookSubscriptionId was null or undefined when calling createWebhookSubscriptionEventNames.');
        }
        if (eventName === null || eventName === undefined) {
            throw new Error('Required parameter eventName was null or undefined when calling createWebhookSubscriptionEventNames.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling createWebhookSubscriptionEventNames.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.deleteWebhookSubscription = function (oauthAppId, webhookSubscriptionId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'webhookSubscriptionId' + '}', encodeURIComponent(String(webhookSubscriptionId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling deleteWebhookSubscription.');
        }
        if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
            throw new Error('Required parameter webhookSubscriptionId was null or undefined when calling deleteWebhookSubscription.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteWebhookSubscription.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.deleteWebhookSubscriptionEventName = function (oauthAppId, webhookSubscriptionId, eventName, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/events/{eventName}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'webhookSubscriptionId' + '}', encodeURIComponent(String(webhookSubscriptionId)))
            .replace('{' + 'eventName' + '}', encodeURIComponent(String(eventName)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling deleteWebhookSubscriptionEventName.');
        }
        if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
            throw new Error('Required parameter webhookSubscriptionId was null or undefined when calling deleteWebhookSubscriptionEventName.');
        }
        if (eventName === null || eventName === undefined) {
            throw new Error('Required parameter eventName was null or undefined when calling deleteWebhookSubscriptionEventName.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteWebhookSubscriptionEventName.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.getWebhookEventNames = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/events'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getWebhookEventNames.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringArrayResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.getWebhookEventNamesBySubscriptionId = function (oauthAppId, webhookSubscriptionId, appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/events'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'webhookSubscriptionId' + '}', encodeURIComponent(String(webhookSubscriptionId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getWebhookEventNamesBySubscriptionId.');
        }
        if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
            throw new Error('Required parameter webhookSubscriptionId was null or undefined when calling getWebhookEventNamesBySubscriptionId.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getWebhookEventNamesBySubscriptionId.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiStringArrayResult");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.getWebhookEventSample = function (eventName, appId, oauthAppId, webhookSubscriptionId, version) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/events/{eventName}/test'
            .replace('{' + 'eventName' + '}', encodeURIComponent(String(eventName)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'webhookSubscriptionId' + '}', encodeURIComponent(String(webhookSubscriptionId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (eventName === null || eventName === undefined) {
            throw new Error('Required parameter eventName was null or undefined when calling getWebhookEventSample.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getWebhookEventSample.');
        }
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getWebhookEventSample.');
        }
        if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
            throw new Error('Required parameter webhookSubscriptionId was null or undefined when calling getWebhookEventSample.');
        }
        if (version !== undefined) {
            localVarQueryParameters['version'] = ObjectSerializer.serialize(version, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "WebhookEventSample");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.getWebhookLogs = function (oauthAppId, webhookSubscriptionId, start, end, appId, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/logs'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'webhookSubscriptionId' + '}', encodeURIComponent(String(webhookSubscriptionId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getWebhookLogs.');
        }
        if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
            throw new Error('Required parameter webhookSubscriptionId was null or undefined when calling getWebhookLogs.');
        }
        if (start === null || start === undefined) {
            throw new Error('Required parameter start was null or undefined when calling getWebhookLogs.');
        }
        if (end === null || end === undefined) {
            throw new Error('Required parameter end was null or undefined when calling getWebhookLogs.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getWebhookLogs.');
        }
        if (start !== undefined) {
            localVarQueryParameters['start'] = ObjectSerializer.serialize(start, "Date");
        }
        if (end !== undefined) {
            localVarQueryParameters['end'] = ObjectSerializer.serialize(end, "Date");
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultWebhookLog");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.getWebhookSubscriptions = function (oauthAppId, appId, page, limit) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling getWebhookSubscriptions.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getWebhookSubscriptions.');
        }
        if (page !== undefined) {
            localVarQueryParameters['page'] = ObjectSerializer.serialize(page, "number");
        }
        if (limit !== undefined) {
            localVarQueryParameters['limit'] = ObjectSerializer.serialize(limit, "number");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiPaginationResultWebhookSubscription");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebhooksApi.prototype.updateWebhookSubscription = function (oauthAppId, webhookSubscriptionId, appId, WebhookSubscription) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}'
            .replace('{' + 'oauthAppId' + '}', encodeURIComponent(String(oauthAppId)))
            .replace('{' + 'webhookSubscriptionId' + '}', encodeURIComponent(String(webhookSubscriptionId)))
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (oauthAppId === null || oauthAppId === undefined) {
            throw new Error('Required parameter oauthAppId was null or undefined when calling updateWebhookSubscription.');
        }
        if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
            throw new Error('Required parameter webhookSubscriptionId was null or undefined when calling updateWebhookSubscription.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateWebhookSubscription.');
        }
        if (WebhookSubscription === null || WebhookSubscription === undefined) {
            throw new Error('Required parameter WebhookSubscription was null or undefined when calling updateWebhookSubscription.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(WebhookSubscription, "WebhookSubscription")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return WebhooksApi;
}());
exports.WebhooksApi = WebhooksApi;
var WebsiteApiApiKeys;
(function (WebsiteApiApiKeys) {
})(WebsiteApiApiKeys = exports.WebsiteApiApiKeys || (exports.WebsiteApiApiKeys = {}));
var WebsiteApi = (function () {
    function WebsiteApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'oauth2': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(WebsiteApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebsiteApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    WebsiteApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    WebsiteApi.prototype.setApiKey = function (key, value) {
        this.authentications[WebsiteApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(WebsiteApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.oauth2.accessToken = token;
        },
        enumerable: false,
        configurable: true
    });
    WebsiteApi.prototype.addTestimonial = function (appId, WebsiteTestimonialBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/website/testimonial'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling addTestimonial.');
        }
        if (WebsiteTestimonialBase === null || WebsiteTestimonialBase === undefined) {
            throw new Error('Required parameter WebsiteTestimonialBase was null or undefined when calling addTestimonial.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(WebsiteTestimonialBase, "WebsiteTestimonialBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultWebsiteTestimonial");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebsiteApi.prototype.deleteTestimonial = function (appId, testimonialId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/website/testimonial/{testimonialId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'testimonialId' + '}', encodeURIComponent(String(testimonialId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteTestimonial.');
        }
        if (testimonialId === null || testimonialId === undefined) {
            throw new Error('Required parameter testimonialId was null or undefined when calling deleteTestimonial.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebsiteApi.prototype.deleteWebsiteImage = function (appId, imageId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/website/image/{imageId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'imageId' + '}', encodeURIComponent(String(imageId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteWebsiteImage.');
        }
        if (imageId === null || imageId === undefined) {
            throw new Error('Required parameter imageId was null or undefined when calling deleteWebsiteImage.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebsiteApi.prototype.editTestimonial = function (appId, testimonialId, WebsiteTestimonialBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/website/testimonial/{testimonialId}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'testimonialId' + '}', encodeURIComponent(String(testimonialId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling editTestimonial.');
        }
        if (testimonialId === null || testimonialId === undefined) {
            throw new Error('Required parameter testimonialId was null or undefined when calling editTestimonial.');
        }
        if (WebsiteTestimonialBase === null || WebsiteTestimonialBase === undefined) {
            throw new Error('Required parameter WebsiteTestimonialBase was null or undefined when calling editTestimonial.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(WebsiteTestimonialBase, "WebsiteTestimonialBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultWebsiteTestimonial");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebsiteApi.prototype.getIndexConfiguration = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/website/index'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getIndexConfiguration.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultIndexPage");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebsiteApi.prototype.setIndexConfiguration = function (appId, IndexPageBase) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/website/index'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling setIndexConfiguration.');
        }
        if (IndexPageBase === null || IndexPageBase === undefined) {
            throw new Error('Required parameter IndexPageBase was null or undefined when calling setIndexConfiguration.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(IndexPageBase, "IndexPageBase")
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultIndexPageBase");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebsiteApi.prototype.uploadWebsiteImage = function (appId, imageLocation, Image) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/website/image/{imageLocation}'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)))
            .replace('{' + 'imageLocation' + '}', encodeURIComponent(String(imageLocation)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling uploadWebsiteImage.');
        }
        if (imageLocation === null || imageLocation === undefined) {
            throw new Error('Required parameter imageLocation was null or undefined when calling uploadWebsiteImage.');
        }
        if (Image === null || Image === undefined) {
            throw new Error('Required parameter Image was null or undefined when calling uploadWebsiteImage.');
        }
        var localVarUseFormData = false;
        if (Image !== undefined) {
            localVarFormParams['Image'] = Image;
        }
        localVarUseFormData = true;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "RestApiResultWebsiteImage");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    WebsiteApi.prototype.websiteCheckNow = function (appId) {
        var localVarPath = this.basePath + '/api/v1.0/{appId}/website/dnscheck'
            .replace('{' + 'appId' + '}', encodeURIComponent(String(appId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling websiteCheckNow.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.oauth2.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return WebsiteApi;
}());
exports.WebsiteApi = WebsiteApi;
//# sourceMappingURL=api.js.map